/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quotes\module.js
 */

"use strict";

angular
  .module('app.quote', [])
  .config(function ($stateProvider) {

    var stateDef = 'app.quote';

    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'Quotes',
          requiresLogin: true
        }
      })

      .state(stateDef + '.list', {
        url: '/quote',
        templateUrl: 'app/quote/views/index.html',
        controller: 'quoteCtrl',

        data: {
          title: 'Quotes List',
          htmlId: 'extr-page'
        },
        resolve: {
          data: function ($q, defaultApiService, $rootScope) {
            var quoteSource = defaultApiService.getListCall('Sources/ActiveSources');
            var quoteStatus = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.QuoteStatus');
            var activeUsers = defaultApiService.getListCall('Quotes/ActiveUsers');
            if (!$rootScope.user) {
              var currentUser = defaultApiService.getListCall('CurrentUser');
            }
            return $q.all([quoteSource, quoteStatus, activeUsers, currentUser]).then(function (results) {
              var quote = {};
              quote.quoteSource = results[0] ? results[0].data : {};
              quote.quoteStatus = results[1] ? results[1].data : {};
              quote.activeUsers = results[2] ? _.map(results[2].data, function (login) { return { login: login }; }) : {};
              quote.currentUser = results[3] ? results[3].data : {};
              return quote;
            });
          }
        }

      })

      .state(stateDef + '.createQuote', {
        url: '/quoteEdit',
        templateUrl: 'app/quote/views/edit.html',
        controller: 'quoteEditCtrl',
        data: {
          title: 'Edit Quote',
          htmlId: 'extr-page'
        },
        params: {
          id: '',
          itemId: null,
          createItem: false,
          editItem: false,
          toStep: 0,
          incomingFromCustomer: false,
          incomingFromQuote: false,
          versionId: '',
          viewQuote: '',
          restore: false,
          duplicateItem: false
        },
        resolve: {
          data: function ($location, $q, defaultApiService, $stateParams, genericQuotesService, $state) {
            if ($stateParams.incomingFromCustomer) {
              genericQuotesService.setIncomingFromCustomer($stateParams.incomingFromCustomer);
            }
            var quoteData = genericQuotesService.getQuoteDataCall($stateParams);
            var versionId = genericQuotesService.getVersionId();
            var viewQuote = genericQuotesService.getViewQuote();
            if (!$stateParams.createItem && !$stateParams.duplicateItem && !$stateParams.editItem && genericQuotesService.getLegitStateChange() && ($location.path().indexOf("index/quoteEdit/step_one") < 0 && $state.current.name != 'app.quote.list')) {
              $location.path('/index/quoteEdit/step_one/' + $stateParams.id + '/' + viewQuote + '/' + versionId);
            } else
              genericQuotesService.setLegitStateChange(true);

            var quoteTerms = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Terms');
            var quoteSource = defaultApiService.getListCall('Sources/ActiveSources');
            genericQuotesService.setLegitStateChange(true);

            var userNotes = '';
            if ($stateParams.id) {
              userNotes = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.id, '/NotesByQuoteId');
            }
            return $q.all([quoteTerms, quoteSource, quoteData, userNotes]).then(function (results) {
              var quote = {};
              quote.quoteTerms = results[0].data;
              quote.quoteSource = results[1].data;
              if (results[2].data && results[2].data.quoteDocument) {
                genericQuotesService.setVersionNumber(results[2].data.version);
                quote.quoteData = results[2].data.quoteDocument
              } else
                quote.quoteData = results[2].data;

              quote.userNotes = results[3].data ? results[3].data.data : [];
              return quote;
            });
          }
        }
      })
      .state(stateDef + '.createQuote.step_one', {
        url: '/step_one/{id}/{viewQuote}/{versionId}',
        templateUrl: 'app/quote/partials/stepOne/wizardStepOne.tpl.html',
        controller: 'stepOneCtrl',
        data: { title: 'Quote Step One' },
        params: {
          id: '',
          incomingFromCustomer: false,
          editItem: false,
          incomingFromQuote: false,
          versionId: null,
          viewQuote: null,
          restore: false
        }
      })
      .state(stateDef + '.createQuote.step_two', {
        url: '/step_two/{id}/{viewQuote}/{versionId}',
        controller: 'stepTwoCtrl',
        templateUrl: 'app/quote/partials/stepTwo/wizardStepTwo.tpl.html',
        data: { title: 'Quote Step Two' },
        params: {
          id: '',
          itemId: null,
          createItem: false,
          editItem: false,
          toStep: 0,
          incomingFromQuote: false,
          versionId: null,
          viewQuote: null,
          restore: false,
          duplicateItem: false
        },
        resolve: {
          data: function ($location, $q, defaultApiService, $rootScope, manageStatesService, $stateParams) {
            if ($stateParams.toStep) {
              manageStatesService.initializeStates();
              manageStatesService.setToState($stateParams.toStep)
            }
            if (manageStatesService.preventAdvancedStep() || manageStatesService.getLegitPreviousAction() || manageStatesService.legitStepTwoAction()) {
              manageStatesService.setLegitPreviousAction(false);
              var productTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes');
              var collateMethods = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.CollateMethods');
              var numberOfSides = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Sides');
              var productCategories = defaultApiService.getListCall('Products/GroupByProductType');
              var serviceLevels = defaultApiService.getListCall('ServiceLevels');
              var countries = defaultApiService.getListCall('Countries');
              var states = defaultApiService.getListCall('States/US');
              var stores = defaultApiService.getListCall('Facilities');
              var quantityCostingTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.QuantityCostingTypes');
              $rootScope.startSpinner();
              return $q.all([productTypes, collateMethods, numberOfSides, productCategories, countries, states, stores, serviceLevels, quantityCostingTypes]).then(function (results) {
                $rootScope.stopSpinner();
                var stepTwoData = {};
                stepTwoData.productTypes = results[0].data;
                stepTwoData.collateMethods = results[1].data;
                stepTwoData.numberOfSides = results[2].data;
                stepTwoData.productCategories = results[3].data;
                stepTwoData.countries = results[4].data;
                stepTwoData.states = results[5].data;
                stepTwoData.stores = results[6].data;
                stepTwoData.serviceLevels = results[7].data;
                stepTwoData.quantityCostingTypes = results[8].data;
                return stepTwoData
              });
            }
          }
        }
      })
      .state(stateDef + '.createQuote.step_three', {
        url: '/step_three/{id}/{viewQuote}/{versionId}',
        controller: 'stepThreeCtrl',
        templateUrl: 'app/quote/partials/stepThree/wizardStepThree.tpl.html',
        data: { title: 'Quote Step Three' },
        params: {
          id: '',
          editItem: false,
          versionId: null,
          viewQuote: null
        },
        resolve: {
          data: function ($q, defaultApiService, $rootScope, manageStatesService, $stateParams) {
            if (manageStatesService.preventAdvancedStep() || manageStatesService.getLegitPreviousAction()) {
              manageStatesService.setLegitPreviousAction(false);
              var deliveryMethods = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ShippingMethods');
              var operationTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.OperationTypes');

              $rootScope.startSpinner();
              return $q.all([deliveryMethods, operationTypes]).then(function (results) {
                $rootScope.stopSpinner();
                var stepThreeData = {};
                stepThreeData.deliveryMethods = results[0].data;
                stepThreeData.operationTypes = results[1].data;
                return stepThreeData;
              });
            }
          }
        }
      })
      .state(stateDef + '.convertQuote', {
        url: '/quote/{quoteId}/convertQuote/{viewOnly}',
        templateUrl: 'app/quote/views/convertQuote/convertQuote.html',
        controller: 'convertQuoteCtrl',
        params: {
          quoteId: null,
          variationIndex: null,
          viewOnly: ''
        },
        data: {
          title: 'Convert Quote'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {
            if ($stateParams.quoteId || $stateParams.viewOnly) {
              var convertQuoteResponse = '';
              if ($stateParams.quoteId && $stateParams.viewOnly) {
                convertQuoteResponse = defaultApiService.readObjectCall('Quotes/EditQuote', $stateParams.quoteId);
              } else if ($stateParams.quoteId) {
                convertQuoteResponse = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.quoteId, '/ConvertQuote');
              }
              var deliveryMethods = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ShippingMethods');
              var operationTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.OperationTypes');
              var serviceLevels = defaultApiService.getListCall('ServiceLevels');
              var stores = defaultApiService.getListCall('Facilities');
              var productTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes');
              var numberOfSides = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Sides');
              var quoteTerms = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Terms');
              var quoteSource = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Sources');
              var collateMethods = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.CollateMethods');
              var userNotes = '';

              if ($stateParams.quoteId) {
                userNotes = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.quoteId, '/NotesByQuoteId');
              }

              return $q.all([convertQuoteResponse, deliveryMethods, operationTypes, serviceLevels, stores, productTypes, numberOfSides, quoteTerms, quoteSource, collateMethods, userNotes]).then(function (results) {
                var convertQuoteData = {};
                convertQuoteData.convertQuoteResponse = results[0].data;
                convertQuoteData.deliveryMethods = results[1].data;
                convertQuoteData.operationTypes = results[2].data;
                convertQuoteData.serviceLevels = results[3].data;
                convertQuoteData.stores = results[4].data;
                convertQuoteData.productTypes = results[5].data;
                convertQuoteData.numberOfSides = results[6].data;
                convertQuoteData.quoteTerms = results[7].data;
                convertQuoteData.quoteSource = results[8].data;
                convertQuoteData.collateMethods = results[9].data;
                convertQuoteData.userNotes = results[10].data ? results[10].data.data : [];
                return convertQuoteData;
              })
            }
          }
        }
      })
      .state(stateDef + '.editDeliveryInfo', {
        url: '/quote/{quoteId}/convertQuote/editDeliveryInfo/{itemId}',
        templateUrl: 'app/quote/views/convertQuote/editDelivery.html',
        controller: 'editDeliveryInfoCtrl',
        params: {
          quoteId: null,
          itemId: null
        },
        data: {
          title: 'Edit Quote Delivery'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {

            if ($stateParams.quoteId && $stateParams.itemId) {
              var convertQuoteResponse = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.quoteId, '/ConvertQuote');
              var quoteTerms = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Terms');
              var quoteSource = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Sources');
              var deliveryMethods = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ShippingMethods');
              var serviceLevels = defaultApiService.getListCall('ServiceLevels');
              var countries = defaultApiService.getListCall('Countries');
              var states = defaultApiService.getListCall('States/US');
              var stores = defaultApiService.getListCall('Facilities');
              var productTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes');
              return $q.all([quoteTerms, quoteSource, convertQuoteResponse, deliveryMethods, serviceLevels, countries, states, stores, productTypes]).then(function (results) {
                var editDeliveryInfoData = {};
                editDeliveryInfoData.quoteTerms = results[0].data;
                editDeliveryInfoData.quoteSource = results[1].data;
                editDeliveryInfoData.convertQuoteResponse = results[2].data;
                editDeliveryInfoData.deliveryMethods = results[3].data;
                editDeliveryInfoData.serviceLevels = results[4].data;
                editDeliveryInfoData.countries = results[5].data;
                editDeliveryInfoData.states = results[6].data;
                editDeliveryInfoData.stores = results[7].data;
                editDeliveryInfoData.productTypes = results[8].data;
                return editDeliveryInfoData;
              })
            }
          },
          onExit: function (itemSummaryService) {
            itemSummaryService.initializeSummaryData();
          }
        }
      })
      .state(stateDef + '.reviewQuote', {
        url: '/quote/{quoteId}/convertQuoteReview/{viewOnly}',
        templateUrl: 'app/quote/views/convertQuote/reviewQuote.html',
        controller: 'reviewQuoteCtrl',
        params: {
          quoteId: null,
          viewOnly: ''
        },
        data: {
          title: 'Review Quote'
        },
        resolve: {
          data: function (convertQuoteService, $state, itemSummaryService, $stateParams, $location) {
            if (convertQuoteService.getReviewQuoteResponse().length <= 0) {
              if ($stateParams.viewOnly) {
                $location.path('/index/quote/' + $stateParams.quoteId + '/convertQuote/viewOnly');
              } else {
                $location.path('/index/quote/' + $stateParams.quoteId + '/convertQuote/');
              }
            }
          }
        },
        onExit: function (itemSummaryService) {
          itemSummaryService.initializeSummaryData();
        }
      })
      .state(stateDef + '.quoteHistory', {
        url: '/quote/{quoteId}/quoteHistory',
        templateUrl: 'app/quote/views/quoteHistory.html',
        controller: 'quoteHistoryCtrl',
        params: {
          quoteId: null
        },
        data: {
          title: 'Quote History'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {
            var quoteHistoryList = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.quoteId, '/QuoteHistory');
            return $q.all([quoteHistoryList]).then(function (results) {
              var quoteHistory = {};
              quoteHistory.quoteHistoryList = results[0].data ? results[0].data.data : [];
              return quoteHistory;
            });
          }
        }
      })
      .state(stateDef + '.editCustomer', {
        url: '/customerEdit/{id}/quote/{quoteState}/{quoteId}',
        templateUrl: 'app/customer/views/edit.html',
        controller: 'customerEditCtrl',
        params: {
          id: { value: null },
          quoteId: null,
          quoteState: null
        },
        data: {
          title: 'Edit Quote Customer'
        },
        resolve: {
          data: function ($q, $stateParams, defaultApiService, quoteModelService, quotesInfoService) {
            var customerObj = {};
            if ($stateParams.quoteId && $stateParams.id && $stateParams.quoteState) {
              customerObj.customerData = defaultApiService.readObjectCallWithQuery('Quotes', $stateParams.quoteId, '/GetCustomerFromQuote');
            } else if ($stateParams.id && $stateParams.quoteState) {
              customerObj.customerData = defaultApiService.readObjectCall('Customers', $stateParams.id);
            }
            var countries = defaultApiService.getListCall('Countries');
            var states = defaultApiService.getListCall('States/US');

            return $q.all([customerObj.customerData, countries, states]).then(function (results) {
              customerObj.customerData = results[0] ? results[0].data : {};
              if ($stateParams.quoteId && $stateParams.id && $stateParams.quoteState) {
                customerObj.customerData = quoteModelService.modifyCustomerData(customerObj.customerData);
              } else if (!$stateParams.quoteId && $stateParams.id && $stateParams.quoteState) {
                customerObj.customerData = quotesInfoService.getSelectedCustomerData() ? quotesInfoService.getSelectedCustomerData() : customerObj.customerData;
              }
              customerObj.countries = results[1] ? results[1].data : {};
              customerObj.states = results[2] ? results[2].data : {};
              return customerObj;
            });

          }
        }
      })
  });

/**
 * Created by sreddy on 3/1/2018.
 */

angular.module('app.quote').directive('shippingInputHandler', function (deliveryMethodService) {
  return {
    restrict: 'EA',
    replace: false,

    link: function (scope) {
      scope.newIndex = deliveryMethodService.getDropdownIndex()
    }
  }
});

/**
 * Created by sreddy on 2/24/2018.
 */


angular.module('app.quote').directive('recipientSearch', function ($log,
                                                                   quotesInfoService,
                                                                   $state,
                                                                   $rootScope,
                                                                   deliveryMethodService,
                                                                   recipientInfoService,
                                                                   itemConfigurationService,
                                                                   convertQuoteService
) {

  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/recipientSearch.tpl.html',

    link: function (scope, element, attributes) {
      scope.recipients = [];
      scope.hasRecipientObject = false;
      scope.customerDetails = ($state.current.url.indexOf('convertQuote') >= 0) ? convertQuoteService.getCustomerData() : quotesInfoService.getSelectedCustomerData();

      /**************************************************************
       * Manipulate the SelectedObj for Convert Quote
       **************************************************************/
      var convertQuoteSelectedObj = function (selectedObj) {
        deliveryMethodService.initializeRecipient();
        selectedObj.originalObject = {};
        selectedObj.originalObject = selectedObj;
        return selectedObj;
      };

      /**************************************************************
       * Looping in Recipients for current Item Recipient
       **************************************************************/
      var matchItemRecipient = function (allRecipients, result) {
        var itemRecipientObj = {};
        angular.forEach(allRecipients, function (recipientObj, idx) {
          if (recipientObj.itemId == $state.params.itemId) {
            itemRecipientObj = recipientObj;
            if (recipientObj.name) {
              scope.$broadcast('hasRecipientObject', true);
            }
          }

          if (idx == allRecipients.length - 1)
            result(itemRecipientObj);
        })
      };

      /**************************************************************
       * Make api call to get customer list on input change
       **************************************************************/
      scope.inputChanged = function (str) {
        var flag = false;
        if (deliveryMethodService.getRecipient().name) {
          scope.$broadcast('angucomplete-alt:clearInput');
          scope.$broadcast('hasRecipientObject', false);
          flag = true;
        }
        angular.element('#canAddLabel').addClass('ng-hide');
        deliveryMethodService.setRecipient({});
        // recipientInfoService.removeRecipientInfo(recipientInfoService.getRecipientInfo().length-1);
        scope.recipients = [];
        scope.disableEditBtn = true;
        recipientInfoService.removeRecipientInfo(deliveryMethodService.getShipToRecipients().length - 1, itemConfigurationService.getCurrentItem().id);
        if (!str) {
          scope.selectedRecipient();
          scope.$broadcast('hasRecipientObject', false);
        } else {
          if (!flag) scope.$broadcast('hasRecipientObject', true);
          quotesInfoService.enableSubmitButtons();
          quotesInfoService.getRecipientList('Customers', str, ((scope.customerDetails && (scope.customerDetails.id || scope.customerDetails.customerId)) || convertQuoteService.getCustomerData().customerId))
            .success(function (data) {
              scope.recipients = data.data;
              _.forEach(data.data, function (item) {
                item.name = ((item.fullName) ? item.fullName : "") + (((item.fullName) && (item.street1 || item.street2 || item.street3 || item.city || item.state || item.postalCode || item.country)) ? ' -' : "") +
                  ((item.street1) ? ' ' + item.street1 : "") + ((item.street2) ? ' ' + item.street2 : "") + ((item.street3) ? ' ' + item.street3 : "") + (((item.street1 || item.street2 || item.street3) && (item.city || item.state || item.postalCode || item.country)) ? ' -' : "") +
                  ((item.city) ? ' ' + item.city : "") + ((item.city && item.state) ? ',' : "") + ((item.state) ? ' ' + item.state : "") + (((item.city || item.state) && (item.postalCode || item.country)) ? ' -' : "") +
                  ((item.postalCode) ? ' ' + item.postalCode : "") + ((item.postalCode && item.country) ? ',' : "") + ((item.country) ? ' ' + item.country : "");
              });
            })
            .error(function (data) {
              $log.log(data)
            });
        }
      };

      /**************************************************************
       * On selecting a customer from the list
       **************************************************************/
      scope.$on('addRecipient', function (event, selectedObj) {
        scope.recipients = [];
        scope.recipients.push(selectedObj);
        selectedObj.street1 = selectedObj.street1 ? selectedObj.street1 : selectedObj.address1;
        selectedObj.street2 = selectedObj.street2 ? selectedObj.street2 : selectedObj.address2;
        selectedObj.name = ((selectedObj.fullName) ? selectedObj.fullName : "") + (((selectedObj.fullName) && (selectedObj.street1 || selectedObj.street2 || selectedObj.street3 || selectedObj.city || selectedObj.state || selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
          ((selectedObj.street1) ? ' ' + selectedObj.street1 : "") + ((selectedObj.street2) ? ' ' + selectedObj.street2 : "") + ((selectedObj.street3) ? ' ' + selectedObj.street3 : "") + (((selectedObj.street1 || selectedObj.street2 || selectedObj.street3) && (selectedObj.city || selectedObj.state || selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
          ((selectedObj.city) ? ' ' + selectedObj.city : "") + ((selectedObj.city && selectedObj.state) ? ',' : "") + ((selectedObj.state) ? ' ' + selectedObj.state : "") + (((selectedObj.city || selectedObj.state) && (selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
          ((selectedObj.postalCode) ? ' ' + selectedObj.postalCode : "") + ((selectedObj.postalCode && selectedObj.country) ? ',' : "") + ((selectedObj.country) ? ' ' + selectedObj.country : "");
        scope.selectedRecipient(selectedObj);
        var currentDropDownIndex = (deliveryMethodService.getCurrentDropdownIndex()) ? deliveryMethodService.getCurrentDropdownIndex() : 0;
        angular.element('#inputField' + currentDropDownIndex).val(selectedObj.name)
      });

      scope.selectedRecipient = function (selected) {
        var objectToBeReturn = {};
        if (selected) {
          if (selected.originalObject) {
            deliveryMethodService.setRecipient(selected.originalObject, selected.originalObject.customerId);
            objectToBeReturn = selected.originalObject;
            recipientInfoService.addRecipientInfo(objectToBeReturn, scope.item.id, scope.serviceLevel, scope.shipper, scope.responseCode);
          } else {
            deliveryMethodService.setRecipient(selected, selected.customerId);
            objectToBeReturn = selected
          }
          scope.$broadcast('hasRecipientObject', true);
          scope.disableEditBtn = false;
          quotesInfoService.enableSubmitButtons();
          return objectToBeReturn;
        } else {
          scope.$broadcast('hasRecipientObject', false);
          deliveryMethodService.setRecipient({});
        }
      };


      /***
       * calling this function for convert quote controller load only.
       * @param id
       */
      if ($state.current.url.indexOf('convertQuote') >= 0) {
        scope.recipients = [];
        var selectedObj = {};
        matchItemRecipient(scope.partialQuoteData.customerInfo.quoteShipTo, function (itemRecipientObj) {
          selectedObj = itemRecipientObj;
          if (selectedObj.postalCode) {
            selectedObj = convertQuoteSelectedObj(selectedObj);
            scope.recipients.push(selectedObj);
            selectedObj.name = ((selectedObj.fullName) ? selectedObj.fullName : "") + (((selectedObj.fullName) && (selectedObj.address1 || selectedObj.address2 || selectedObj.address3 || selectedObj.city || selectedObj.state || selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
              ((selectedObj.address1) ? ' ' + selectedObj.address1 : "") + ((selectedObj.address2) ? ' ' + selectedObj.address2 : "") + ((selectedObj.address3) ? ' ' + selectedObj.address3 : "") + (((selectedObj.address1 || selectedObj.address2 || selectedObj.address3) && (selectedObj.city || selectedObj.state || selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
              ((selectedObj.city) ? ' ' + selectedObj.city : "") + ((selectedObj.city && selectedObj.state) ? ',' : "") + ((selectedObj.state) ? ' ' + selectedObj.state : "") + (((selectedObj.city || selectedObj.state) && (selectedObj.postalCode || selectedObj.country)) ? ' -' : "") +
              ((selectedObj.postalCode) ? ' ' + selectedObj.postalCode : "") + ((selectedObj.postalCode && selectedObj.country) ? ',' : "") + ((selectedObj.country) ? ' ' + selectedObj.country : "");
            selectedObj.street1 = selectedObj.address1;
            selectedObj.street2 = selectedObj.address2;
            delete selectedObj.address1;
            delete selectedObj.address2;
            scope.selectedRecipient(selectedObj);
            setTimeout(function () {
              var bindDropdownIndex = deliveryMethodService.getCurrentDropdownIndex() || 0;
              angular.element('#inputField' + bindDropdownIndex).val(selectedObj.name);
              scope.$broadcast('hasRecipientObject', true);
              scope.$apply();
            }, 200)

          } else {
            scope.$broadcast('hasRecipientObject', false);
            scope.selectedRecipient({})
          }
        });
      }

      /***
       * Send a broadcast to the directive in order to change itself
       * if an id parameter is given only this ancucomplete is changed
       * @param id
       */
      scope.changeInput = function (id) {
        if (id) {
          var pos = Math.floor(Math.random() * (scope.recipients.length - 1));
          scope.$broadcast('angucomplete-alt:changeInput', id, scope.recipients[pos]);
        }
      };

      //Logic to clear the recipients
      scope.$on('clear-recipient', function (env, val) {
        scope.inputChanged();
      })
    }
  }
});

/**
 * Created by sreddy on 2/24/2018.
 */

angular.module('app.quote').directive('recipientDropdownHandler', function ($rootScope, quotesInfoService, deliveryMethodService, $timeout, convertQuoteService, $state) {

  return {
    restrict: 'EA',
    replace: false,

    link: function (scope, element, attributes) {
      scope.hasRecipientObject = false;
      scope.addNewRecipientLabel = $rootScope.getWord('AddNewRecipient');

      /****************************************************************
       * Clear Search Input
       ****************************************************************/
      scope.clearInput = function () {
        var currentDropDownIndex = (deliveryMethodService.getCurrentDropdownIndex()) ? deliveryMethodService.getCurrentDropdownIndex() : 0;
        angular.element('#inputField' + currentDropDownIndex).val('');
        scope.inputChanged();
      };

      /****************************************************************
       * Action performed when Add New Customer hyperlink is clicked **
       ****************************************************************/
      scope.performAddAction = function (index, e) {
        scope.hasRecipientObject = false;
        var currentId = e.currentTarget.id;
        var currentIndex = currentId[currentId.length - 1];
        var customerId = ($state.current.url.indexOf('convertQuote') >= 0) ? convertQuoteService.getCustomerData().customerId : quotesInfoService.getStepOneData().customerId || quotesInfoService.getCustomerInfoData().id;
        deliveryMethodService.currentDropdownIndex(currentIndex);
        scope.$emit('openRecipientModal');
        scope.clearInput();
        $rootScope.$broadcast('editButtonChange', 'disable');
        scope.showDropdown = false;
        scope.searchStr = null;
        deliveryMethodService.checkCustomerExists(customerId)
          .then(function (result) {
            $rootScope.$broadcast('isCustomerExists', result.data);
            angular.element('#recipientModal').modal('show');
            quotesInfoService.enableSubmitButtons();
            angular.element('#primaryDeliveryButton' + index).attr('disabled', 'disabled');
            angular.element('#toggleDeliveryAction' + index).attr('disabled', 'disabled');
          });
      };

      /****************************************************************
       * Check whether recipient Object is there or not
       ****************************************************************/
      scope.$on('hasRecipientObject', function (check, flag) {
        scope.hasRecipientObject = flag;
        $timeout(function () {
          scope.$apply()
        })
      })
    }
  }
});

/**
 * Created by sreddy on 2/14/2018.
 */

angular.module('app.quote').directive('editRecipientModal', function (quotesInfoService, $rootScope, deliveryMethodService, defaultApiService, notificationService, formValidationKeyService, $state, addressValidationService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/editRecipientModal.tpl.html',

    link: function (scope, form) {
      scope.runSatori = false;
      deliveryMethodService.setRecipient({});
      scope.recipient = deliveryMethodService.getRecipient();
      scope.recipient.street1 = '';
      scope.recipient.updateRecipient = false;
      scope.convertState = $state.current.url.indexOf('convertQuote') >= 0;

      scope.$on('openRecipientModal', function () {
        scope.recipientModalHeaderLabel = $rootScope.getWord('AddNewRecipient');
        scope.recipientModalSubmitBtnLabel = $rootScope.getWord('AddRecipient');
        deliveryMethodService.setRecipient({});
        scope.recipient = deliveryMethodService.getRecipient();
      });

      scope.disableAutoFill = function (id) {
        angular.element('#' + id).attr("autocomplete", "nope");
        return true;
      };

      var RequiredField = {
        en_US: $rootScope.getWord('RequiredField'),
        fr_CA: $rootScope.getWord('RequiredField'),
        en_CA: $rootScope.getWord('RequiredField')
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {
          // valid : 'glyphicon',
          // invalid : 'glyphicon glyphicon-remove',
          // validating : 'glyphicon glyphicon-refresh'
        },

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtFullName: {
            validators: {
              callback: {
                message: RequiredField,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.convertState && !value) {
                    isEmpty = false;
                  }
                  return isEmpty;
                }
              },
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          txtCompanyName: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          txtStreet1: {
            validators: {
              callback: {
                message: RequiredField,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.convertState && !value) {
                    isEmpty = false;
                  }
                  return isEmpty;
                }
              },
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          txtStreet2: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          txtCity: {
            group: '.col-lg-8',
            validators: {
              callback: {
                message: RequiredField,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.convertState && !value) {
                    isEmpty = false;
                  }
                  return isEmpty;
                }
              },
              stringLength: {
                trim: true,
                min: 1,
                max: 50
              }
            }
          },
          txtZipCode: {
            group: '.col-lg-4',
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 20
              }
            }
          },
          cboCountry: {
            validators: {}
          },
          cboState: {
            group: '.col-lg-4',
            validators: {
              callback: {
                message: RequiredField,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.convertState && !value) {
                    isEmpty = false;
                  }
                  return isEmpty;
                }
              }
            }
          },
          txtState: {
            excluded: function ($field, validator) {
              return scope.recipient ? scope.recipient.country == 'US' ? true : false : true;
            },
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          txtPhone: {
            group: '.col-lg-8',
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 20
              },
              callback: {
                message: {
                  en_US: 'Please enter a valid phone number',
                  fr_CA: '*(FR_CA)Please enter a valid phone number',
                  en_CA: '*(EN_CA)Please enter a valid phone number'
                },
                callback: function (value, validator, $field) {
                  if (value == '') {
                    return !scope.convertState;
                  } else {
                    angular.element('#txtPhone').intlTelInput("setCountry", scope.recipient.country);
                    if (addressValidationService.isExceptionalCountry(scope.recipient.country)) {
                      angular.element('#txtPhone').intlTelInput({});
                      return true
                    } else {
                      var isPhoneValid = angular.element('#txtPhone').intlTelInput('isValidNumber');
                      if (isPhoneValid)
                        addressValidationService.formatPhoneNumber('txtPhone');
                      return isPhoneValid
                    }
                  }
                }
              }
            }
          },
          txtExtension: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 10
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitRecipientObject();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        // $(e.target)    --> The field element
        // data.fv        --> The FormValidation instance
        // data.field     --> The field name
        // data.element   --> The field element
        // data.validator --> The current validator name

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

          // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      }).on('change', function (e, data) {
        if (_.includes(e.target.className, "satoriAddressField")) {
          scope.runSatori = true;
        }
      });
      // scope.recipient.street1 = scope.recipient.street1 ? deliveryMethodService.getStreet1(): '';
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }
  }
});

/**
 * Created by sreddy on 2/27/2018.
 */

angular.module('app.quote').directive('editRecipientAddress', function (autoPopulateService, deliveryMethodService, formattedPhoneService, toaster, $state, $stateParams, $rootScope, quotesInfoService, recipientInfoService) {

  return {
    restrict: 'A',
    link: function (scope, elements) {
      scope.customerData = quotesInfoService.getSelectedCustomerData();
      scope.countries = deliveryMethodService.getCountries();
      scope.states = deliveryMethodService.getStates();

      scope.resetRecipientAddress = function () {
        if (!scope.recipient.street1) {
          scope.recipient.street2 = '';
          scope.recipient.state = '';
          scope.recipient.city = '';
          scope.recipient.postalCode = '';
          angular.element('#recipientModal').formValidation('resetField', 'txtZipCode');
        }
      };

      scope.selectAutoCompleteAddress = function (results) {
        autoPopulateService.setFields(results);
        var addressDetail = autoPopulateService.getAddress();
        deliveryMethodService.setRecipientAddress(addressDetail);
        var recipientName = scope.recipient.fullName;
        var companyName = scope.recipient.companyName;
        scope.recipient = deliveryMethodService.getRecipient();
        scope.recipient.fullName = recipientName;
        scope.recipient.companyName = companyName;
        scope.$apply();
        deliveryMethodService.enableDisableAddressValidation(true);
      };

      // address validations
      scope.recommendedAddress = function () {
        deliveryMethodService.setRecipientAddress(scope.updatedModifiedAddress);
        scope.submitRecipient();
      };

      // original address Accept
      scope.originalAddress = function () {
        deliveryMethodService.setRecipientAddress(scope.unmodifiedAddress);
        scope.submitRecipient();
      };

      scope.submitRecipient = function () {
        scope.recipient = deliveryMethodService.getRecipient();
        scope.recipientId = scope.recipient ? scope.recipient.id || scope.recipient.recipientId : null;
        scope.customerId = ($state.current.url.indexOf('convertQuote') >= 0) ? scope.customerDetails.customerId : scope.customerData.id;
        if (scope.recipientId && scope.recipient.updateRecipient) {
          $rootScope.startSpinner();
          deliveryMethodService.updateRecipientObject(scope.recipientId, scope.customerId)
            .success(function (data) {
              angular.element('#recipientModal').data('formValidation').resetForm(true);
              angular.element('#recipientModal').removeClass('fade');
              angular.element('#recipientModal').modal('hide');
              $rootScope.stopSpinner();
              scope.recipient = {};
              scope.$broadcast('addRecipient', data);
              recipientInfoService.updateRecipientInfo(data, scope.item.id, scope.serviceLevel, scope.shipper, scope.responseCode);
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        } else if (scope.recipient.updateRecipient) {
          $rootScope.startSpinner();
          deliveryMethodService.createRecipientObject(scope.customerId)
            .success(function (data) {
              angular.element('#recipientModal').data('formValidation').resetForm(true);
              angular.element('#recipientModal').removeClass('fade');
              angular.element('#recipientModal').modal('hide');
              $rootScope.stopSpinner();
              scope.recipient = {};
              scope.$broadcast('addRecipient', data);
              recipientInfoService.addRecipientInfo(data, scope.item.id, scope.serviceLevel, scope.shipper, scope.responseCode);
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        } else {
          angular.element('#recipientModal').data('formValidation').resetForm(true);
          angular.element('#recipientModal').removeClass('fade');
          angular.element('#recipientModal').modal('hide');
          scope.recipient = {};
          var recipientObj = deliveryMethodService.getRecipient();
          scope.$broadcast('addRecipient', recipientObj);
          recipientInfoService.addRecipientInfo(recipientObj, scope.item.id, scope.serviceLevel, scope.shipper, scope.responseCode);
        }
        scope.invalidAddress = false;
        scope.modifiedAddress = false;
      };

      scope.showSuggestedAddress = function (data) {
        scope.invalidAddress = false;
        scope.modifiedAddress = false;
        switch (data.result) {
          case 0:
            var updatedAddress = data.modifiedAddress ? data.modifiedAddress : data.originalAddress;
            deliveryMethodService.setRecipientAddress(updatedAddress);
            scope.submitRecipient();
            break;
          case 1:
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress ? data.originalAddress : scope.submitRecipient();
            break;
          case 2:
            scope.modifiedAddress = true;
            scope.updatedModifiedAddress = data.modifiedAddress;
            scope.unmodifiedAddress = data.originalAddress;
            break;
          case 3:
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress;
            scope.unmodifiedAddress.isResidential = data.modifiedAddress ? data.modifiedAddress.isResidential : scope.unmodifiedAddress.isResidential;
            break;
        }
      };
      if (scope.id) {
        scope.recipient.fullName = scope.recipient.fullName ? scope.recipient.fullName : '';

      }
    }
  }
});

/**
 * Created by sreddy on 2/5/2018.
 */

'use strict';
angular
  .module('settings.system-users', [])
  .config(function ($stateProvider) {

    var stateDef = 'app.settings.system-users';

    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'System Users'
        }
      })

      .state(stateDef + '.list', {
        url: '/system-users',
        templateUrl: 'app/settings/system-users/views/index.html',
        controller: 'systemUsersCtrl',
        data: {
          title: 'System Users List'
        },
        resolve: {
          data: function ($q, defaultApiService) {
            var deferred = $q.defer();
            defaultApiService.getListCall('SystemUsers')
              .success(function (data) {
                deferred.resolve(data);
              });
            return deferred.promise;
          }
        }
      })

      //SYSTEM USERS - CHANGE PASSWORD
      .state(stateDef + '.password', {
        url: '/system-users/change-password/{id}',
        templateUrl: 'app/settings/system-users/views/change-password.html',
        controller: 'systemUsersPasswordCtrl',
        params: {
          id: {value: null}
        },
        data: {
          title: 'Change Password'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {
            if ($stateParams.id) {
              var systemUser = defaultApiService.readObjectCall('SystemUsers', $stateParams.id);
              return $q.all([systemUser]).then(function (results) {
                systemUser = results[0].data;
                return systemUser;
              });
            }
          }
        }
      })


      .state(stateDef + '.edit', {
        url: '/system-users/edit/{id}',
        templateUrl: 'app/settings/system-users/views/edit.html',
        controller: 'systemUsersEditCtrl',
        params: {
          id: {value: null}
        },
        data: {
          title: 'Edit System User'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {
            if ($stateParams.id) {
              var systemUser = defaultApiService.readObjectCall('SystemUsers', $stateParams.id);
              var availableRoles = [];
              var assignedRoles = [];


              availableRoles = defaultApiService.getListCall('SystemRoles');
              assignedRoles = defaultApiService.readObjectCall('SystemUserRoles', $stateParams.id);
              return $q.all([systemUser, availableRoles, assignedRoles]).then(function (results) {
                systemUser = results[0].data;
                if (results[1].data)
                  availableRoles = results[1].data;
                if (results[2].data)
                  assignedRoles = results[2].data;

                systemUser.availableRoles = availableRoles.data;
                systemUser.assignedRoles = assignedRoles.data;

                return systemUser;
              });
            }
          }
        }
      });
  });

/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\services\systemUsersService.js
 */
angular.module('settings.system-users').service('systemUsersService', function ($rootScope,
                                                                                $state,
                                                                                defaultApiService,
                                                                                notificationService,
                                                                                dtEncoder) {
  var systemUserModel = {
    apiCtrl: 'SystemUsers',
    siteSetupList: [],
    siteSetupObject: {},
    assignedSystemRoleIds: [],
    editScreen: 'app.settings.system-users.edit',
    viewScreen: 'app.settings.system-users',
    gridScreen: 'app.settings.system-users.list',
    passwordScreen: 'app.settings.system-users.password'
  };
  var disabledItems = [];
  var sysAdminItems = [];

  function iterateUpdateList(id, list, boolean, propertyName) {
    var oTable = $('#dtSystemUsers').DataTable();
    oTable.rows(function (idx, data) {
      if (data.id === id) {
        data[propertyName] = boolean;
      }
    });

    _.forEach(systemUserModel.siteSetupList, function (value, key) {
      if (value.id == id)
        value[propertyName] = boolean;
    });
  }

  return {
    setSiteSetupList: function (data) {

      var propertyNames = [
        "login",
        "firstName",
        "lastName",
        "title"
      ];

      systemUserModel.siteSetupList = dtEncoder.dtEncodeValues(data.data, propertyNames);

      _.forEach(systemUserModel.siteSetupList, function (item) {
        disabledItems[item.id] = item.isDisabled;
        sysAdminItems[item.id] = item.isSystemAdmin;
      });
    },

    initSiteSetupObject: function (data) {
      systemUserModel.assignedSystemRoleIds = [];

      if (data) {
        systemUserModel.siteSetupObject = data;
        if (data.assignedRoles) {
          _.forEach(data.assignedRoles, function (role) {
            systemUserModel.assignedSystemRoleIds.push(role.systemRoleId);
          });
        }
      }
      else
        systemUserModel.siteSetupObject = data;
    },

    createSiteSetupObject: function (createAnother) {
      return defaultApiService.createObjectCall(systemUserModel.apiCtrl, systemUserModel.siteSetupObject)
        .success(function () {
          notificationService.notifyCreateSuccess(systemUserModel.siteSetupObject.login);
          if (createAnother) {
            $('#system-users-form').bootstrapValidator('resetForm', true);
          }
          else
            $state.go(systemUserModel.gridScreen);
        });
    },

    updateSiteSetupObject: function () {
      $rootScope.startSpinner();
      return defaultApiService.updateObjectCall(systemUserModel.apiCtrl, systemUserModel.siteSetupObject)
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyEditSuccess(systemUserModel.siteSetupObject.login);
          $state.go(systemUserModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    updatePassword: function (id) {
      $rootScope.startSpinner();
      return defaultApiService.apiActionsCall(systemUserModel.apiCtrl, id, systemUserModel.siteSetupObject, 'ResetPassword')
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyEditSuccess($rootScope.getWord('Password'));
          $state.go(systemUserModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    deleteSiteSetupObject: function (id, itemName) {
      var table = $('#dtSystemUsers').DataTable();//Instantiate DataTables.

      var row = table.rows(function (idx, data) {
        return data.id === id;
      });

      defaultApiService.deleteObjectCall(systemUserModel.apiCtrl, id)
        .success(function () {
          table.row(row[0]).remove().draw();
          notificationService.notifyDeleteSuccess(itemName);
        });
    },

    getSiteSetupModel: function () {
      return systemUserModel;
    },

    getDisabledItems: function () {
      return disabledItems;
    },

    getSystemAdminItems: function () {
      return sysAdminItems;
    },

    disableSystemUser: function (id, itemName, isDisabled) {
      var oTable = $('#dtSystemUsers').dataTable();

      if (isDisabled) {
        defaultApiService.apiActionsCall(systemUserModel.apiCtrl, id, '', 'Enable')
          .success(function () {

            systemUserModel.siteSetupList = iterateUpdateList(id, systemUserModel.siteSetupList, false, 'isDisabled');

            if (disabledItems) {
              disabledItems[id] = !isDisabled;
            }
            notificationService.notifyEnableSuccess(itemName);
          })
          .error(function () {

            systemUserModel.siteSetupList = iterateUpdateList(id, systemUserModel.siteSetupList, true, 'isDisabled');


            if ($('#dis_' + id)[0]) {
              $('#dis_' + id).prop('checked', isDisabled);
            } else {
              $('#chkDisabled').prop('checked', isDisabled);
            }
          });
      }
      else {
        defaultApiService.apiActionsCall(systemUserModel.apiCtrl, id, '', 'Disable')
          .success(function () {

            systemUserModel.siteSetupList = iterateUpdateList(id, systemUserModel.siteSetupList, true, 'isDisabled');

            if (disabledItems) {
              disabledItems[id] = !isDisabled;
            }
            notificationService.notifyDisableSuccess(itemName);


          })
          .error(function () {

            systemUserModel.siteSetupList = iterateUpdateList(id, systemUserModel.siteSetupList, false, 'isDisabled');


            if ($('#dis_' + id)[0]) {
              $('#dis_' + id).prop('checked', isDisabled);
            }
            else {
              $('#chkDisabled').prop('checked', isDisabled);
            }
          });
      }
    },

    invokeSystemAdmin: function (id, itemName, isSystemAdmin) {

      var oTable = $('#dtSystemUsers').dataTable();

      if (!isSystemAdmin) {
        defaultApiService.apiActionsCall(systemUserModel.apiCtrl, id, '', 'SetAsSystemAdmin')
          .success(function () {

            iterateUpdateList(id, '', true, 'isSystemAdmin');
            sysAdminItems[id] = !isSystemAdmin;
            notificationService.notifyInvokeSystemAdminSuccess(itemName);
          })
          .error(function () {


            if ($('#sys_' + id)[0]) {
              $('#sys_' + id).prop('checked', isSystemAdmin);
            } else {
              $('#chkDisabled').prop('checked', isSystemAdmin);
            }

          });
      }
      else {
        defaultApiService.apiActionsCall(systemUserModel.apiCtrl, id, '', 'RemoveAsSystemAdmin')
          .success(function () {
            iterateUpdateList(id, '', false, 'isSystemAdmin');
            sysAdminItems[id] = !isSystemAdmin;
            notificationService.notifyRevokeSystemAdminSuccess(itemName);

          })
          .error(function () {
            if ($('#sys_' + id)[0]) {
              $('#sys_' + id).prop('checked', isSystemAdmin);
            } else {
              $('#chkDisabled').prop('checked', isSystemAdmin);
            }

          });
      }
    }
  };

});

/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\directives\systemUsersForm.js
 */
angular.module('settings.system-users').directive('systemUsersForm', function ($rootScope, formValidationKeyService) {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-users/partials/system-users-form.tpl.html',

    link: function (scope, form) {

      var PasswordRegexpMessage = {
        en_US: $rootScope.getWord('PasswordRegexp'),
        fr_CA: $rootScope.getWord('PasswordRegexp'),
        en_CA: $rootScope.getWord('PasswordRegexp')
      };
      var AlphaNumericMessage = {
        en_US: $rootScope.getWord('AlphaNumericCharactersOnly'),
        fr_CA: $rootScope.getWord('AlphaNumericCharactersOnly'),
        en_CA: $rootScope.getWord('AlphaNumericCharactersOnly')
      };


      var validatePasswordContent = function (password) {

        var validPassword = true;

        var hasUpperCase = /[A-Z]/.test(password);
        var hasLowerCase = /[a-z]/.test(password);
        var hasNumbers = /\d/.test(password);
        // var hasNonAlphas = /\W/.test(password);
        var hasNoSpace = (password.indexOf(' ') <= 0) ? true : false;
        var hasEmpPercent = (password.indexOf('&') <= 0) ? true : false;

        if (hasUpperCase + hasLowerCase + hasNumbers + hasNoSpace + hasEmpPercent < 5)
          validPassword = false;

        return validPassword;

      };

      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtLogin: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 2,
                max: 25
              },
              regexp: {
                regexp: /^[a-z0-9]+$/i,
                message: AlphaNumericMessage
              }
            }
          },

          txtPassword: {
            validators: {
              notEmpty: {},
              callback: {
                message: PasswordRegexpMessage,
                callback: function (value) {
                  return validatePasswordContent(value);
                }
              },

              stringLength: {
                trim: true,
                min: 10,
                max: 16
              }
            }
          },

          txtConfirmPassword: {
            validators: {
              notEmpty: {},
              identical: {
                field: 'txtPassword'
              }
            }
          },

          txtFirstName: {
            validators: {
              stringLength: {
                trim: true,
                min: 2,
                max: 100
              }
            }
          },

          txtLastName: {
            validators: {
              stringLength: {
                trim: true,
                min: 2,
                max: 100
              }
            }
          },

          txtTitle: {
            validators: {
              stringLength: {
                trim: true,
                min: 2,
                max: 100
              }
            }
          },

          txtEmailAddress: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 2,
                max: 254
              },
              regexp: {
                regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]{2,10}$',
                message: {
                  en_US: $rootScope.getWord('ValidEmailMessage'),
                  fr_CA: $rootScope.getWord('ValidEmailMessage'),
                  en_CA: $rootScope.getWord('ValidEmailMessage')
                }
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        }

      });//EO form.bootstrapValidator

      form.formValidation('setLocale', formValidationKeyService.getValidationKey());

    }//EO function

  };//EO return

});//EO registerDirective

/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\directives\systemUserPasswordChangeForm.js
 */
angular.module('settings.system-users').directive('systemUserPasswordChangeForm', function ($rootScope, formValidationKeyService) {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-users/partials/system-user-password-change-form.tpl.html',

    link: function (scope, form) {

      var PasswordRegexpMessage = {
        en_US: $rootScope.getWord('PasswordRegexp'),
        fr_CA: $rootScope.getWord('PasswordRegexp'),
        en_CA: $rootScope.getWord('PasswordRegexp')
      };

      var validatePasswordContent = function (password) {

        var validPassword = true;

        var hasUpperCase = /[A-Z]/.test(password);
        var hasLowerCase = /[a-z]/.test(password);
        var hasNumbers = /\d/.test(password);
        var hasNoSpace = (password.indexOf(' ') <= 0) ? true : false;

        if (hasUpperCase + hasLowerCase + hasNumbers + hasNoSpace < 4)
          validPassword = false;

        return validPassword;

      };

      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtNewPassword: {
            validators: {
              callback: {
                message: PasswordRegexpMessage,
                callback: function (value) {
                  return validatePasswordContent(value);
                }
              },
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 10,
                max: 16
              }
            }
          },

          txtNewPasswordConfirm: {
            validators: {
              notEmpty: {},
              identical: {
                field: 'txtNewPassword'
              }
            }
          }

        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        }

      });

      form.formValidation('setLocale', formValidationKeyService.getValidationKey());

    }

  };//EO return

});//EO registerDirective


/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\directives\systemUserAssignRolesForm.js
 */

angular.module('settings.system-users').directive('systemUserAssignRolesForm', function (formValidationKeyService) {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-users/partials/system-user-assign-roles-form.tpl.html',

    link: function (scope, form) {

      form.bootstrapValidator({

        framework: 'bootstrap',

        icon: {
          valid: 'glyphicon',
          invalid: 'glyphicon glyphicon-remove',
          validating: 'glyphicon glyphicon-refresh'
        },

        addOns: {
          i18n: {},
          mandatoryIcon: {
            icon: 'glyphicon glyphicon-asterisk'
          }
        },

        fields: {

          txtName: {
            validators: {
              notEmpty: {
                //Use message from validator config
              },
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          }

        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        }

      });

      form.formValidation('setLocale', formValidationKeyService.getValidationKey());

    }

  };//EO return

});//EO registerDirective


/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\controllers\systemUsersPasswordCtrl.js
 */

angular.module('settings.system-users').controller('systemUsersPasswordCtrl', function ($scope, $state, data, systemUsersService, $stateParams) {

  if ($stateParams.id) {
    $scope.id = $stateParams.id;
  }

  systemUsersService.initSiteSetupObject(data);

  var systemUser = systemUsersService.getSiteSetupModel();
  $scope.userPassword = {};
  $scope.systemUser = systemUser.siteSetupObject;
  $scope.systemUserObj = {};
  if (systemUser.siteSetupObject) {
    delete $scope.systemUser['availableRoles'];
    delete $scope.systemUser['assignedRoles'];
  }

  $scope.submitObject = function () {
    $scope.userPassword.login = $scope.systemUser.login;
    delete $scope.userPassword['PasswordConfirm'];

    systemUsersService.initSiteSetupObject($scope.userPassword);
    systemUsersService.updatePassword($scope.systemUser.id);
  };

  $scope.cancelForm = function () {
    $scope.systemUser = {};
    $state.go(systemUser.gridScreen);
  };
});

/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\controllers\systemUsersEditCtrl.js
 */
angular.module('settings.system-users').controller('systemUsersEditCtrl', function ($scope,
                                                                                    $state,
                                                                                    data,
                                                                                    systemUsersService,
                                                                                    $stateParams,
                                                                                    defaultApiService,
                                                                                    notificationService,
                                                                                    dualListService,
                                                                                    $rootScope) {

  if ($stateParams.id) {
    $scope.id = $stateParams.id;
  }

  // Tabs Handler functionality

  $scope.activeDetailsTab = true;
  $scope.changeTab = function (step) {
    switch (step) {
      case 1 :
        $scope.activeDetailsTab = true;
        $scope.activeRolesTab = false;
        break;
      case 2:
        $scope.activeDetailsTab = false;
        $scope.activeRolesTab = true;
        break;
    }
  };


  systemUsersService.initSiteSetupObject(data);

  var systemUser = systemUsersService.getSiteSetupModel();
  $scope.checkBreadCrumbs = $scope.id ? false : true;

  $scope.systemUser = systemUser.siteSetupObject;
  $scope.systemUserObj = {};
  if (systemUser.siteSetupObject) {
    $scope.systemUserObj.assignedSystemRoleIds = systemUser.assignedSystemRoleIds;
    $scope.availableRoles = systemUser.siteSetupObject.availableRoles;
    $scope.assignedRoles = systemUser.siteSetupObject.assignedRoles;
    delete $scope.systemUser['availableRoles'];
    delete $scope.systemUser['assignedRoles'];
  }

  $scope.enableDisableItem = function (id, itemName, isDisabled) {
    $scope.itemsDisabled = systemUsersService.getDisabledItems();
    if ($scope.itemsDisabled[id])
      isDisabled = $scope.itemsDisabled[id];
    systemUsersService.disableSystemUser(id, itemName, isDisabled);
  };

  $scope.invokeRevokeSystemAdminRights = function (id, itemName, isSystemAdmin) {
    $scope.itemsAdmin = systemUsersService.getSystemAdminItems();
    if ($scope.itemsAdmin[id])
      isSystemAdmin = $scope.itemsAdmin[id];

    systemUsersService.invokeSystemAdmin(id, itemName, isSystemAdmin);
  };

  $scope.submitObject = function () {
    systemUsersService.initSiteSetupObject($scope.systemUser);

    if ($stateParams.id) {
      systemUsersService.updateSiteSetupObject();
    }
    else {
      $rootScope.startSpinner();
      systemUsersService.createSiteSetupObject($scope.addAnother)
        .success(function () {
          $rootScope.stopSpinner();
          if ($scope.addAnother)
            $('#system-users-form').formValidation('resetForm', true);
        }).error(function () {
        $rootScope.stopSpinner();
      });
    }
  };

  $scope.cancelForm = function () {
    $scope.systemUser = {};
    $state.go(systemUser.gridScreen);
  };

  function initDualLists(admin, role) {
    $scope.initAssingRoles = role;
  }

  $scope.assignRemove = function () {
    $scope.saveRolesAssignment();
  };


  /*#####################################################################################################
   System Roles Assignment
   ######################################################################################################*/

  $scope.saveRolesAssignment = function () {
    $scope.assignRoles();
    $scope.removeRoles();
  };

  $scope.initiateSystemRoles = function () {
    //DualList -Assign 1. -Start Tracker
    initDualLists(false, true);
    dualListService.initTrackers($scope.systemUserObj.assignedSystemRoleIds, $scope.assignedRoles);
  };

  $scope.initiateSystemRoles();

  $scope.assignRoles = function () {

    var assignedRoles = {batchItems: dualListService.newAssignment($scope.systemUserObj.assignedSystemRoleIds)};

    //Dual List -Assign 2. -Find if items hasn't already been assigned.
    var idExist = dualListService.alreadyAssigned($scope.systemUserObj.assignedSystemRoleIds);

    if (!idExist) {
      $rootScope.startSpinner();
      $scope.assignRemoveButton = true;
      defaultApiService
        .batchAdd('SystemUserRoles', $stateParams.id, assignedRoles)
        .success(function (data) {
          $rootScope.stopSpinner();
          //Dual List -Assign 3. -Track items that are assigned.
          dualListService.trackAssignedItems($scope.systemUserObj.assignedSystemRoleIds, data);

          notificationService.notifyAssignationSuccess($rootScope.getWord('SystemRoles'), 'have');

          assignedRoles.batchItems = [];
          $scope.assignRemoveButton = false;

        }).error(function () {
        $scope.assignRemoveButton = false;
        $rootScope.stopSpinner();
      });
    }
  };

  $scope.removeRoles = function () {
    var itemType = 'SystemUserRole';
    var removeRoles = {
      batchItems: dualListService.removeUnselectedItems($scope.systemUserObj.assignedSystemRoleIds, itemType)
    };

    if (removeRoles.batchItems.length > 0) {
      $scope.assignRemoveButton = true;
      $rootScope.startSpinner();
      defaultApiService
        .batchRemove('SystemUserRoles', $stateParams.id, removeRoles)
        .success(function () {
          $rootScope.stopSpinner();
          //Dual List -Remove 2. -Stop tracking items that have been removed.
          dualListService.removeAssignedItems(removeRoles.batchItems, itemType);

          notificationService.notifyRemoveSuccess($rootScope.getWord('SystemRoles'), 'have');

          removeRoles.batchItems = [];
          $scope.assignRemoveButton = false;

        }).error(function () {
        $scope.assignRemoveButton = false;
        $rootScope.stopSpinner();
      });
    }
  };

});


/**
 *Created by Srikanth 02/5/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-users\controllers\systemUsersCtrl.js
 */

angular.module('settings.system-users').controller('systemUsersCtrl', function ($scope, $state, $compile, data, systemUsersService, notificationService, $rootScope) {

  systemUsersService.setSiteSetupList(data);
  var systemUsers = systemUsersService.getSiteSetupModel();

  $scope.options = {
    data: data.data,
    stateSave: true,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    buttons: [
      {
        text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="btnSystemUserCreate">' +
        '                <i class="fa fa-plus p-r-sm"></i>' +
        '                <span>' + $rootScope.getWord("AddSystemUser") + '</span>' +
        '              </button>',
        className: 'btn btn-success no-padding',
        action: function (e, dt, node, config) {
          $scope.createNewItem();
        }
      }
    ],
    columns: [
      {
        "mDataProp": "login"
      },
      {
        "mDataProp": "firstName"
      },
      {
        "mDataProp": "lastName"
      },
      {
        "mDataProp": "title"
      },
      {
        mData: "UserIs",
        className: "smart-form col-checkbox",
        mRender: function (data, type, full) {
          return $scope.showCheckBox(full, 'isSystemUsers');
        },
        visible: $scope.systemAdminVisible,
        bSearchable: false,
        bSortable: false
      },
      {
        "className": "col-action",
        "bSearchable": false,
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = [3, 5];
          var labels = {
            deleteLabel: $rootScope.getWord('Delete')
          };
          var btnName = $rootScope.getWord('Edit');
          return $scope.tableDropdownActions(full.id, full.login, full.readOnly, commandTypes, labels, btnName);
        }
        // "mRender": function (data, type, full) {
        //   var commandTypes = [1, 2, 3, 4];
        //   return $scope.tableActions(full.id, full.login, full.readOnly, commandTypes);
        // }
      }
    ], fnRowCallback: function (row, data) {
      angular.element('#dis_' + data.id, row).prop('checked', data.isDisabled == 1);
      angular.element('#sys_' + data.id, row).prop('checked', data.isSystemAdmin == 1);
    }
  };

  $scope.defaultButtonAction = function (id) {
    $state.transitionTo(systemUsers.editScreen, {id: id});
  };

  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    systemUsersService.deleteSiteSetupObject(id, itemName);
  };

  $scope.createNewItem = function () {
    $state.go(systemUsers.editScreen);
  };

  $scope.updatePassword = function (id) {
    $state.transitionTo(systemUsers.passwordScreen, {id: id});
  };
  $scope.enableDisableItem = function (id, itemName, isDisabled) {
    $scope.itemsDisabled = systemUsersService.getDisabledItems();
    isDisabled = $scope.itemsDisabled[id];
    systemUsersService.disableSystemUser(id, itemName, isDisabled);
  };

  $scope.invokeRevokeSystemAdminRights = function (id, itemName, isSystemAdmin) {
    $scope.itemsAdmin = systemUsersService.getSystemAdminItems();
    isSystemAdmin = $scope.itemsAdmin[id];
    systemUsersService.invokeSystemAdmin(id, itemName, isSystemAdmin);
  };
});

/**
 * Created by Srikanth Reddy Anugu on 05/16/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-settings\module.js
 */

"use strict";

angular
    .module('settings.system-settings', [])
    .config(function ($stateProvider) {


        var stateDef = 'app.settings.system-settings';


        $stateProvider
            .state(stateDef, {
                abstract: true,
                template: '<ui-view/>',
                data: {
                    title: 'System Settings'
                }
            })

            .state(stateDef + '.list', {
                url: '/system-settings',
                templateUrl: 'app/settings/system-settings/views/index.html',
                controller: 'systemSettingsCtrl',
                data: {
                    title: 'System Settings List'
                },
                resolve: {
                    data: function ($q, defaultApiService) {
                        var systemSettingsList = defaultApiService.getListCall('Settings');
                        return $q.all([systemSettingsList]).then(function (results) {
                            var systemSettings = {};
                            systemSettings.systemSettingsList = results[0].data ? results[0].data.data : [];
                            return systemSettings;
                        });
                    }
                }
            })
            .state(stateDef + '.edit', {
                url: '/system-settings/edit/{id}',
                templateUrl: 'app/settings/system-settings/views/edit.html',
                controller: 'systemSettingsEditCtrl',
                params: {
                    id: {value: null}
                },
                data: {
                    title: 'Edit System Setting'
                },
                resolve: {
                    deps: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'scripts/ckeditor/ckeditor.js'
                        ]);
                    },
                    data: function ($q, defaultApiService, $stateParams, $state) {
                        var deferred = $q.defer();
                        var systemSettings = {
                            data: {}
                        };
                        if ($stateParams.id) {
                            $state.params = $stateParams.id;

                            defaultApiService.readObjectCall('Settings', $stateParams.id)
                                .success(function (data) {
                                    systemSettings.data = data;
                                    deferred.resolve(systemSettings);
                                });
                            return deferred.promise;
                        } else
                            deferred.resolve(systemSettings);

                        return deferred.promise;
                    }
                }

            })
    });

/**
 * Created by Srikanth Reddy Anugu on 05/16/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-settings\services\systemSettingsService.js
 */

angular.module('settings.system-settings').service('systemSettingsService', function ($state, defaultApiService, notificationService, $rootScope, dtEncoder) {
  var SiteSetupModel = {
    apiCtrl: 'Settings',
    siteSetupList: [],
    siteSetupObject: {},
    editScreen: 'app.settings.system-settings.edit',
    gridScreen: 'app.settings.system-settings.list',
    createAnother: false
  };

  return {
    setSiteSetupList: function (data) {
      SiteSetupModel.siteSetupList = dtEncoder.dtEncodeValues(data.systemSettingsList, ['name']);
    },

    initSiteSetupObject: function (data) {
      if (!data.data)
        SiteSetupModel.siteSetupObject = data;
      else if (!data.data.dto)
        SiteSetupModel.siteSetupObject = data.data;
      else
        SiteSetupModel.siteSetupObject = data.data;
    },

    createSiteSetupObject: function (createAnother) {
      $rootScope.startSpinner();
      var data = {};
      data = SiteSetupModel.siteSetupObject;
      return defaultApiService.createObjectCall(SiteSetupModel.apiCtrl, data)
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyCreateSuccess(SiteSetupModel.siteSetupObject.name);
          if (createAnother) {
            angular.element('#systems-settings-form').bootstrapValidator('resetForm', true);
          }
          else
            $state.go(SiteSetupModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    updateSiteSetupObject: function () {
      $rootScope.startSpinner();
      var data = {};
      data = SiteSetupModel.siteSetupObject;
      return defaultApiService.createObjectCall(SiteSetupModel.apiCtrl, data)
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyEditSuccess(SiteSetupModel.siteSetupObject.name);
          $state.go(SiteSetupModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    deleteSiteSetupObject: function (id, itemName) {
      $rootScope.startSpinner();
      var table = angular.element('#dtSystemSettings').DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, data, node) {
        return data.id === id;
      });

      defaultApiService.deleteObjectCall(SiteSetupModel.apiCtrl, id)
        .success(function () {
          $rootScope.stopSpinner();
          table.row(row[0]).remove().draw();
          notificationService.notifyDeleteSuccess(itemName);
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },

    getSiteSetupModel: function () {
      return SiteSetupModel;
    }
  };


});

/**
 * Created by Srikanth Reddy Anugu on 05/16/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-settings\directives\systemSettingsForm.js
 */
angular.module('settings.system-settings').directive('systemSettingsForm', function (formValidationKeyService) {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-settings/partials/system-settings-form.tpl.html',

    link: function (scope, form) {

      var integerMin = 0;
      var integerMax = 2147483647;
      var decimalsRegex = /^(?:\d*\.\d{1,2}|\d+)$/;
      var decimalMin = 0;
      var decimalMax = 9999999;

      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {
          cboCulture: {
            validators: {
              notEmpty: {}
            }
          },

          txtName: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },

          txtVariableTypeString: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 1000
              }
            }
          },

          txtVariableTypeInt: {
            validators: {
              notEmpty: {},
              digits: {},
              between: {
                min: integerMin,
                max: integerMax
              }
            }
          },

          txtVariableTypeDecimal: {
            validators: {
              numeric: {
                regexp: decimalsRegex
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtNotes: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 1000
              }
            }
          },

          cboVariableType: {
            validators: {
              notEmpty: {}
            }
          }

        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }

  }

});

/**
 * Created by Srikanth Reddy Anugu on 05/16/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-settings\controllers\systemSettingsEditCtrl.js
 */

angular.module('settings.system-settings').controller('systemSettingsEditCtrl', function ($scope, $state, data, systemSettingsService, $stateParams, $rootScope) {

  if ($stateParams.id) {
    $scope.id = $stateParams.id;
  }

  $scope.settingBreadcrumb = $scope.id ? $rootScope.getWord('EditSystemSetting') : $rootScope.getWord('AddNewSystemSetting');

  systemSettingsService.initSiteSetupObject(data);

  var systemSetting = systemSettingsService.getSiteSetupModel();

  $scope.systemSettings = systemSetting.siteSetupObject;
  if ($scope.systemSettings.variableType == 5)
    $scope.htmlValue = $scope.systemSettings.value;
  $scope.valueType = 'valueSimpleText';

  $scope.isShown = function (valueType) {
    return valueType === $scope.valueType;
  };

  $scope.submitObject = function () {

    systemSettingsService.initSiteSetupObject($scope.systemSettings);
    if ($scope.systemSettings.variableType == 5)
      $scope.systemSettings.value = $scope.htmlValue;

    if ($stateParams.id) {
      systemSettingsService.updateSiteSetupObject();
    }
    else {
      systemSettingsService.createSiteSetupObject($scope.addAnother)
        .success(function () {
          if ($scope.addAnother) {
            $scope.systemSettings = {};
            $scope.htmlValue = "";
          }
        });
    }
  };

  $scope.cancelForm = function () {
    $scope.systemSetting = {};
    $state.go(systemSetting.gridScreen);
  };

});

/**
 * Created by Srikanth Reddy Anugu on 05/16/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-settings\controllers\systemSettingsCtrl.js
 */

angular.module('settings.system-settings').controller('systemSettingsCtrl', function ($scope, $state, $compile, data, systemSettingsService, notificationService, $rootScope) {

  systemSettingsService.setSiteSetupList(data);

  var systemSettings = systemSettingsService.getSiteSetupModel();

  $scope.options = {
    data: systemSettings.siteSetupList,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    // This is added so that we maintain the default ordering.
    order: [[0, 'asc']],
    buttons: [
      {
        text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="createSystemSetting">' +
        '                <i class="fa fa-plus p-r-sm"></i>' +
        '                <span>' + $rootScope.getWord("AddSystemSetting") + '</span>' +
        '              </button>',
        className: 'btn btn-success no-padding',
        action: function () {
          $scope.createNewItem();
        }
      }
    ],
    columns: [
      {
        "mDataProp": "name"
      },
      {
        "className": "col-action",
        "bSearchable": false,
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = [3];
          var labels = {
            deleteLabel: $rootScope.getWord('Delete')
          };
          var btnName = $rootScope.getWord('Edit');
          return $scope.tableDropdownActions(full.id, full.name, full.readOnly, commandTypes, labels, btnName);
        }
      }
    ]
  };

  $scope.defaultButtonAction = function (id) {
    $state.transitionTo(systemSettings.editScreen, {id: id});
  };

  $scope.viewItem = function (id) {
    $state.transitionTo(systemSettings.viewScreen, {id: id});
  };

  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    systemSettingsService.deleteSiteSetupObject(id, itemName);
  };

  $scope.createNewItem = function () {
    $state.go(systemSettings.editScreen);
  };

});

/**
 * Created by Srikanth Reddy Anugu on 2/1/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\systemRoles\module.js
 */

"use strict";
angular
  .module('settings.system-roles', [])
  .config(function ($stateProvider) {


    var stateDef = 'app.settings.system-roles';


    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'System Roles'
        }
      })

      .state(stateDef + '.list', {
        url: '/system-roles',
        templateUrl: 'app/settings/system-roles/views/index.html',
        controller: 'systemRolesCtrl',
        data: {
          title: 'System Roles List'
        },
        resolve: {

          data: function ($q, defaultApiService) {
            var deferred = $q.defer();
            defaultApiService.getListCall('SystemRoles')
              .success(function (data) {
                deferred.resolve(data);
              });
            return deferred.promise;
          }
        }

      })
      .state(stateDef + '.edit', {
        url: '/system-roles/edit/{id}',
        templateUrl: 'app/settings/system-roles/views/edit.html',
        controller: 'systemRolesEditCtrl',
        params: {
          id: {value: null}
        },
        data: {
          title: 'Edit System Role'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams) {
            if ($stateParams.id) {
              var systemRole = defaultApiService.readObjectCall('SystemRoles', $stateParams.id);
              var availableCommands = [];
              var assignedCommands = [];
              availableCommands = defaultApiService.getListCall('Commands');
              assignedCommands = defaultApiService.readObjectCall('SystemRoleCommands', $stateParams.id);

              return $q.all([systemRole, availableCommands, assignedCommands]).then(function (results) {
                systemRole = results[0].data;

                if (results[1].data)
                  availableCommands = results[1].data;
                if (results[2].data)
                  assignedCommands = results[2].data;

                systemRole.availableCommands = availableCommands;
                systemRole.assignedCommands = assignedCommands;

                return systemRole;
              });
            }
          }
        }

      })
  });

/**
 * Created by Srikanth Reddy on 02/1/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-roles\services\systemRolesService.js
 */

angular.module('settings.system-roles').service('systemRolesService', function ($state,
                                                                                defaultApiService,
                                                                                notificationService,
                                                                                dtEncoder,
                                                                                $rootScope) {

  var systemRoleModel = {
    apiCtrl: 'SystemRoles',
    siteSetupList: [],
    siteSetupObject: {},
    assignedCommandIds: [],
    editScreen: 'app.settings.system-roles.edit',
    gridScreen: 'app.settings.system-roles.list'
  };

  return {
    setSiteSetupList: function (data) {

      var propertyNames = [
        'name'
      ];

      systemRoleModel.siteSetupList = dtEncoder.dtEncodeValues(data.data, propertyNames);
    },

    initSiteSetupObject: function (data) {
      systemRoleModel.assignedCommandIds = [];

      if (data) {
        systemRoleModel.siteSetupObject = data;

        if (data.assignedCommands) {
          _.forEach(data.assignedCommands, function (command) {
            systemRoleModel.assignedCommandIds.push(command.name);
          });
        }
        if (data.availableCommands) {
          _.forEach(data.availableCommands, function (command, key) {
            data.availableCommands[key].formattedName = humps.separateWords(command.name, ' ');
          });
        }
      }
      else
        systemRoleModel.siteSetupObject = {};
    },

    createSiteSetupObject: function (createAnother) {
      return defaultApiService.createObjectCall(systemRoleModel.apiCtrl, systemRoleModel.siteSetupObject)
        .success(function () {
          notificationService.notifyCreateSuccess(systemRoleModel.siteSetupObject.name);
          if (createAnother) {
            // $('#system-roles-form').bootstrapValidator('resetForm', true);
          }
          else
            $state.go(systemRoleModel.gridScreen);
        });
    },

    updateSiteSetupObject: function () {
      $rootScope.startSpinner();
      return defaultApiService.updateObjectCall(systemRoleModel.apiCtrl, systemRoleModel.siteSetupObject)
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyEditSuccess(systemRoleModel.siteSetupObject.name);
          $state.go(systemRoleModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    deleteSiteSetupObject: function (id, itemName) {
      $rootScope.startSpinner();
      var table = angular.element('#dtSystemRoles').DataTable();
      var row = table.rows(function (idx, data) {
        return data.id === id;
      });
      defaultApiService.deleteObjectCall(systemRoleModel.apiCtrl, id)
        .success(function () {
          table.row(row[0]).remove().draw();
          $rootScope.stopSpinner();
          notificationService.notifyDeleteSuccess(itemName);
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },
    gridScreen: function () {
      $state.go(systemRoleModel.gridScreen);
    },

    getSiteSetupModel: function () {
      return systemRoleModel;
    }
  };

});

/**
 * Created by Srikanth Reddy on 2/1/2018.
 * Filename: public/app/modules/site/directives/system-roles/systemRolesForm.js
 */

angular.module('settings.system-roles').directive('systemRolesForm', function (formValidationKeyService) {


  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-roles/partials/system-roles-form.tpl.html',

    link: function (scope, form) {

      form.formValidation({

        framework: 'bootstrap',

        icon: {
          // valid : 'glyphicon',
          // invalid : 'glyphicon glyphicon-remove',
          // validating : 'glyphicon glyphicon-refresh'
        },

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtName: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        }

      }).on('error.validator.bv', function (e, data) {

        data.element
          .data('bv.messages')

          // Hide all the messages
          .find('.help-block[data-bv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-bv-validator="' + data.validator + '"]').show();

      });

      form.formValidation('setLocale', formValidationKeyService.getValidationKey());

    }

  }
});

/**
 * Created by Srikanth on 2/1/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\systemRoles\directives\systemRolesAssignCommands.js
 */

angular.module('settings.system-roles').directive('systemRolesAssignCommands', function () {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/system-roles/partials/system-roles-assign-commands.tpl.html',

    link: function (scope, form) {
    }//EO function

  };//EO return

});//EO registerDirective

/**
 * Created by Srikanth on 02/01/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-roles\controllers\systemRolesEditCtrl.js
 */

angular.module('settings.system-roles').controller('systemRolesEditCtrl', function ($scope,
                                                                                    $state,
                                                                                    data,
                                                                                    systemRolesService,
                                                                                    $stateParams,
                                                                                    defaultApiService,
                                                                                    notificationService,
                                                                                    $rootScope) {

  if ($stateParams.id) {
    $scope.id = $stateParams.id;
  }

  systemRolesService.initSiteSetupObject(data);

  // Tabs Handler functionality

  $scope.activeDetailsTab = true;
  $scope.changeTab = function (step) {
    switch (step) {
      case 1 :
        $scope.activeDetailsTab = true;
        $scope.activeCommandTab = false;
        break;
      case 2:
        $scope.activeDetailsTab = false;
        $scope.activeCommandTab = true;
        break;
    }
  };

  var systemRole = systemRolesService.getSiteSetupModel();
  var startTrackerVar = [];
  $scope.systemRole = systemRole.siteSetupObject;
  var systemRoleCommandTracker = {};
  $scope.checkBreadCrumbs = $scope.id ? false : true;

  $scope.systemRoleObj = {};
  if (systemRole.siteSetupObject) {
    $scope.systemRoleObj.assignedCommandIds = systemRole.assignedCommandIds;
    $scope.availableCommands = systemRole.siteSetupObject.availableCommands;
    $scope.assignedCommands = systemRole.siteSetupObject.assignedCommands;
    systemRoleCommandTracker = new Utilities.DualListTracker(systemRole.assignedCommandIds, $scope.assignedCommands, _);

    delete systemRole['assignedCommandIds'];
    delete $scope.systemRole['availableCommands'];
    delete $scope.systemRole['assignedCommands'];
    $scope.availableCommandsFiltered = $scope.availableCommands;
  }

  $scope.systemRoleCategories = [];
  $scope.systemRoleCategory = "";
  _.forEach($scope.availableCommands, function (command) {
    var itemIdx = _.findIndex($scope.systemRoleCategories, function (category) {
      return category == command.category;
    });

    if (itemIdx < 0) {
      $scope.systemRoleCategories.push(command.category);
    }
  });


  $scope.submitObject = function () {
    systemRolesService.initSiteSetupObject($scope.systemRole);

    if ($stateParams.id) {
      systemRolesService.updateSiteSetupObject();
    }
    else {
      $rootScope.startSpinner();
      systemRolesService
        .createSiteSetupObject($scope.addAnother)
        .success(function () {
          $scope.stopSpinner();
          if ($scope.addAnother) {
            $scope.systemRole = {};
            $('#system-roles-form').formValidation('resetForm', true);
          }
        }).error(function () {
        $rootScope.stopSpinner();
      });
    }
  };


  $scope.removeUnselectedItems = function (removeItemsArray, completeList) {
    var tempItem = '';
    var tempArray = [];

    for (var i = 0; i < removeItemsArray.length; i++) {
      _.pull(storeArray['All'], removeItemsArray[i]);

      if (completeList) {
        _.forEach(completeList, function (item) {
          if (item.fullName == removeItemsArray[i]) {
            _.pull(storeArray[item.category], removeItemsArray[i])
          }
        });
      }
    }
  };
  $scope.getAllItemsGathered = function () {

    var newArray = [];
    for (var category in storeArray) {
      var tempArray = _.uniq(storeArray['All']);
      if (category != 'All') {
        if (storeArray[category].length > 0) {
          if (newArray.length <= 0) {
            newArray = storeArray[category];
          }
          else {
            newArray = newArray.concat(_.uniq(storeArray[category]));//set the difference.
          }
        }
      }
    }
    storeArray['All'] = _.uniq(newArray);
    //console.log(storeArray);
  };


  $scope.categorizeItems = function (completeList) {

    var tempItem = '';
    var tempArray = [];

    for (var i = 0; i < storeArray['All'].length; i++) {

      //Iterate through completeList, compare retrieve category and create new category or add to the existing category.
      _.forEach(completeList, function (item) {
        tempItem = storeArray['All'][i];
        tempArray = [];
        if (item.fullName == tempItem) {
          if (storeArray[item.category]) {
            if (!_.includes(storeArray[item.category], tempItem)) {
              storeArray[item.category].push(tempItem);
            }
          }
          else {
            storeArray[item.category] = [tempItem];
          }
        }
      });
    }
  };

  var storeArray = [];
  $scope.storeSelectedItems = function (category, array) {
    var itemsToRemove = [];
    if (!storeArray[category]) {
      if (category == null || category == "" || !storeArray['All']) {

        itemsToRemove = _.xor(array, storeArray['All']);

        if (itemsToRemove.length > 0) {
          $scope.removeUnselectedItems(itemsToRemove, $scope.availableCommands);
        }

        storeArray['All'] = array;//TODO: Create a function to add all the items from other categories.
      }
      else {
        storeArray[category] = array;//TODO: Create a function to append and remove items.
      }
    }
    else {
      if (storeArray[category]) {
        var temp = _.uniq(storeArray[category]);
        itemsToRemove = _.xor(array, temp);

        if (itemsToRemove.length > 0) {
          $scope.removeUnselectedItems(itemsToRemove);
        }

        storeArray[category] = array;//TODO: Create a function to append and remove items.
      }
      else
        storeArray[category].push(_.difference(storeArray[category], array));
    }
  };
  $scope.getCategorySelection = function (category) {
    var selectedItems = [];
    if (category == null || category == "") {
      selectedItems = storeArray['All'];
    }
    else if (storeArray[category]) {
      selectedItems = storeArray[category];
    }

    return selectedItems
  };

  var prevSelectedCat = ''; //Tracks previously selected category.
  $scope.filterCategory = function (category) {
    $scope.storeSelectedItems(prevSelectedCat, $scope.systemRoleObj.assignedCommandIds);
    $scope.categorizeItems($scope.availableCommands);

    if (category == null || category == "") {
      $scope.getAllItemsGathered();
      $scope.availableCommandsFiltered = $scope.availableCommands;
    }
    else {
      $scope.availableCommandsFiltered = _.filter($scope.availableCommands, function (item) {
        return item.category == category;
      });
    }

    $scope.systemRoleObj.assignedCommandIds = $scope.getCategorySelection(category);
    prevSelectedCat = category;
    this.listenToModel();
  };

  $scope.cancelForm = function () {
    $scope.systemRole = {};
    $state.go(systemRole.gridScreen);
  };

  $scope.assignRemove = function () {
    $scope.saveCommandsAssignment();
  };

  $scope.saveCommandsAssignment = function () {
    $scope.storeSelectedItems(prevSelectedCat, $scope.systemRoleObj.assignedCommandIds);
    $scope.categorizeItems($scope.availableCommands);
    $scope.getAllItemsGathered();
    $scope.systemRoleObj.assignedCommandIds = $scope.getCategorySelection('');

    $scope.assignCommands();
  };

  //DualList -Assign 1. -Start Tracker
  //dualListFactory.initTrackers(startTrackerVar, $scope.assignedCommands);
  //systemRoleCommandTracker.initTrackers(startTrackerVar, $scope.assignedCommands);

  $scope.assignCommands = function () {
    var assignedCommands = {batchItems: systemRoleCommandTracker.newAssignment($scope.systemRoleObj.assignedCommandIds, true)};

    //Dual List -Assign 2. -Find if items hasn't already been assigned.
    var idExist = systemRoleCommandTracker.alreadyAssigned($scope.systemRoleObj.assignedCommandIds, true);

    if (!idExist) {
      $rootScope.startSpinner();
      $scope.assignRemoveButton = true;
      defaultApiService
        .batchAdd('SystemRoleCommands', $stateParams.id, assignedCommands)
        .success(function (data) {
          $rootScope.stopSpinner();

          // Initiating remove commands
          $scope.removeCommands();

          //Dual List -Assign 3. -Track items that are assigned.
          systemRoleCommandTracker.trackAssignedItems($scope.systemRoleObj.assignedCommandIds, data);

          if (assignedCommands.batchItems.length > 1)
            notificationService.notifyAssignationSuccess('Commands', 'have');
          else
            notificationService.notifyAssignationSuccess('Command', 'has');

          assignedCommands.batchItems = [];
          storeArray = [];
          $scope.assignRemoveButton = false;
        }).error(function () {
        $rootScope.stopSpinner();
        $scope.assignRemoveButton = false;
      });
    } else {
      // Initiating remove commands
      $scope.removeCommands();
    }
  };

  $scope.removeCommands = function () {

    var itemType = 'SystemRoleCommand';
    var removeCommands = {
      batchItems: systemRoleCommandTracker.removeUnselectedItems($scope.systemRoleObj.assignedCommandIds, itemType)
    };

    if (removeCommands.batchItems.length > 0) {
      $scope.assignRemoveButton = true;
      $rootScope.startSpinner();
      defaultApiService
        .batchRemove('SystemRoleCommands', $stateParams.id, removeCommands)
        .success(function () {
          $rootScope.stopSpinner();
          //Dual List -Remove 2. -Stop tracking items that have been removed.
          systemRoleCommandTracker.removeAssignedItems(removeCommands.batchItems, itemType);

          if (removeCommands.batchItems.length > 1)
            notificationService.notifyRemoveSuccess('Commands', 'have');
          else
            notificationService.notifyRemoveSuccess('Command', 'has');

          removeCommands.batchItems = [];
          storeArray = [];
          $scope.assignRemoveButton = false;
        }).error(function () {
        $scope.assignRemoveButton = false;
        $rootScope.stopSpinner();
      });
    }
  };
});

/**
 * Created by Srikanth Reddy on 02/01/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\system-roles\controllers\systemRolesCtrl.js
 */

angular.module('settings.system-roles').controller('systemRolesCtrl', function ($scope,
                                                                                $state,
                                                                                data,
                                                                                $compile,
                                                                                systemRolesService,
                                                                                notificationService,
                                                                                dtEncoder,
                                                                                $rootScope) {


  var systemRoles = systemRolesService.getSiteSetupModel();

  //Encoding the data
  var propertyNames = [
    'name'
  ];

  var systemRoleData = data.data ? data.data : [];

  systemRoleData = dtEncoder.dtEncodeValues(systemRoleData, propertyNames);

  $scope.options = {
    data: systemRoleData,
    stateSave: true,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    buttons: [
      {
        text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="btnSystemRoleCreate">' +
        '                <i class="fa fa-plus p-r-sm"></i>' +
        '                <span>' + $rootScope.getWord("AddSystemRole") + '</span>' +
        '              </button>',
        className: 'btn btn-success no-padding',
        action: function (e, dt, node, config) {
          $scope.createNewItem();
        }
      }
    ],
    columns: [
      {
        "mDataProp": "name"
      },
      {
        //SSM 11/02 Updated Class Name
        "className": "col-action",
        //SSM - Removed - "sDefaultContent" : "actions",
        "bSearchable": false,
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = [3];
          var labels = {
            deleteLabel: $rootScope.getWord('Delete')
          };
          var btnName = $rootScope.getWord('Edit');
          return $scope.tableDropdownActions(full.id, full.name, full.readOnly, commandTypes, labels, btnName);
        }
      }
    ]
  };

  $scope.defaultButtonAction = function (id) {
    $state.transitionTo(systemRoles.editScreen, {id: id});
  };

  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    systemRolesService.deleteSiteSetupObject(id, itemName);
  };

  $scope.createNewItem = function () {
    $state.go(systemRoles.editScreen);
  };

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\module.js
 */

"use strict";

angular
    .module('settings.sources', [])
    .config(function ($stateProvider) {


        var stateDef = 'app.settings.sources';


        $stateProvider
            .state(stateDef, {
                abstract: true,
                template: '<ui-view/>',
                data: {
                    title: 'Sources'
                }
            })

            .state(stateDef + '.list', {
                url: '/sources',
                templateUrl: 'app/settings/sources/views/index.html',
                controller: 'sourcesCtrl',
                data: {
                    title: 'Sources List'
                },
                resolve: {
                    data: function ($q, defaultApiService) {
                        var sourceList = defaultApiService.getListCall('Sources');
                        return $q.all([sourceList]).then(function (results) {
                            var sources = {};
                            sources.sourceList = results[0].data ? results[0].data.data : [];
                            return sources;
                        });
                    }
                }

            })
            .state(stateDef + '.edit', {
                url: '/sourcesEdit/{id}',
                templateUrl: 'app/settings/sources/views/edit.html',
                controller: 'sourcesEditCtrl',
                params: {
                    id: {value: null}
                },
                data: {
                    title: 'Edit Source'
                },
                resolve: {
                    data: function ($q, defaultApiService, $stateParams, $state) {
                        var sources = { data: {}, setting: {} };

                        if ($stateParams.id) {
                            $state.params = $stateParams.id;

                            return $q.all([
                                defaultApiService.readObjectCall('Sources', $stateParams.id),
                                defaultApiService.getListCall('Settings')
                            ])
                            .then(function (response) {
                                sources.data = response[0].data;
                                sources.setting = _.find(response[1].data.data, function(setting) {
                                    return setting.name === 'VictorPricing_OrderTypes';
                                }) || {};
                                sources.victor = [
                                    { id: 'Estimator', value: 'Estimator' },
                                    { id: 'Victor', value: 'Victor' }
                                ];
                                if (!_.isEmpty(sources.setting) && !_.isEmpty(sources.setting.value)) {
                                    var orderTypes = sources.setting.value.split(', ');
                                    sources.setting.value = _.map(orderTypes, function(item) {
                                        return { id: item, value: item };
                                    });
                                }
                                return sources;
                            });
                        } else {
                            return $q.all([defaultApiService.getListCall('Settings')])
                            .then(function (response) {
                                sources.setting = _.find(response[0].data.data, function(setting) {
                                    return setting.name === 'VictorPricing_OrderTypes';
                                }) || {};
                                sources.victor = [
                                    { id: 'Estimator', value: 'Estimator' },
                                    { id: 'Victor', value: 'Victor' }
                                ];
                                if (!_.isEmpty(sources.setting) && !_.isEmpty(sources.setting.value)) {
                                    var orderTypes = sources.setting.value.split(', ');
                                    sources.setting.value = _.map(orderTypes, function(item) {
                                        return { id: item, value: item };
                                    });
                                }
                                return sources;
                            });
                        }
                    }
                }

            })
    });

/**
 * Created by Srikanth Reddy Anugu on 11/7/2019.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\sources\services\sourceService.js
 */

angular.module('settings.sources').service('sourceService', function ($state, defaultApiService, notificationService, dtEncoder, $rootScope) {
    var SourceSetupModel = {
        apiCtrl: 'Sources',
        sourceSetupList: [],
        sourceSetupObject: {},
        editScreen: 'app.settings.sources.edit',
        gridScreen: 'app.settings.sources.list',
        createAnother: false
    };

    return {
        setSourceSetupList: function (data) {
            SourceSetupModel.sourceSetupList = dtEncoder.dtEncodeValues(data.sourceList, ['name']);
        },

        initSourceSetupObject: function (data) {
            if (!data.data)
                SourceSetupModel.sourceSetupObject = data;
            else if (!data.data.dto)
                SourceSetupModel.sourceSetupObject = data.data;
            else
                SourceSetupModel.sourceSetupObject = data.data;
        },

        createSourceSetupObject: function (createAnother) {
            return defaultApiService.createObjectCall(SourceSetupModel.apiCtrl, SourceSetupModel.sourceSetupObject)
            .success(function () {
                notificationService.notifyCreateSuccess(SourceSetupModel.sourceSetupObject.name);
                if (createAnother) {
                    SourceSetupModel.createAnother = true;
                    angular.element('#source-type-form').bootstrapValidator('resetForm', true);
                } else
                    $state.go(SourceSetupModel.gridScreen);
            });
        },

        updateSourceSetupObject: function () {
            $rootScope.startSpinner();
            return defaultApiService.updateObjectCall(SourceSetupModel.apiCtrl, SourceSetupModel.sourceSetupObject)
            .success(function () {
                $rootScope.stopSpinner();
                notificationService.notifyEditSuccess(SourceSetupModel.sourceSetupObject.name);
                $state.go(SourceSetupModel.gridScreen);
            }).error(function () {
                $rootScope.stopSpinner();
            });
        },

        deleteSourceSetupObject: function (id, itemName) {
            $rootScope.startSpinner();
            var table = angular.element('#sourceDatatable').DataTable();//Instantiate DataTables.
            var row = table.rows(function (idx, data, node) {
                return data.id === id;
            });
            defaultApiService.deleteObjectCall(SourceSetupModel.apiCtrl, id)
            .success(function () {
                table.row(row[0]).remove().draw();
                $rootScope.stopSpinner();
                notificationService.notifyDeleteSuccess(itemName);
            }).error(function () {
            $rootScope.stopSpinner();
            });
        },

        getSourceSetupModel: function () {
            return SourceSetupModel;
        }
    };

});

/**
 * Created by Srikanth Reddy Anugu on 10/28/2019.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\sources\directives\sourceForm.js
 */
angular.module('settings.sources').directive('sourceForm', function (formValidationKeyService, $rootScope) {

    return {

        restrict: 'E',
        replace: true,
        templateUrl: 'app/settings/sources/partials/sourceForm.tpl.html',

        link: function (scope, form) {
            form.formValidation({

                framework: 'bootstrap',

                icon: {},

                addOns: {
                    i18n: {},
                    mandatoryIcon: {}
                },

                fields: {

                    txtName: {
                        validators: {
                            notEmpty: {},
                            stringLength: {
                                min: 1,
                                max: 50
                            }
                        }
                    },

                    priceType: {
                        validators: {
                            notEmpty: {}
                        }
                    },

                    victorPriceType: {
                        validators: {
                            notEmpty: {}
                        }
                    }
                },

                onSuccess: function (e, data) {
                    e.preventDefault();
                    scope.submitObject();
                },

                live: 'enabled'

            }).on('error.validator.fv', function (e, data) {

                // $(e.target)    --> The field element
                // data.fv        --> The FormValidation instance
                // data.field     --> The field name
                // data.element   --> The field element
                // data.validator --> The current validator name

                data.element
                    .data('fv.messages')

                    // Hide all the messages
                    .find('.help-block[data-fv-for="' + data.field + '"]').hide()

                    // Show only message associated with current validator
                    .filter('[data-fv-validator="' + data.validator + '"]').show();

            });
            form.formValidation('setLocale', formValidationKeyService.getValidationKey());
        }

    }

});

/**
 * Created by Srikanth Reddy Anugu on 10/28/2019.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\sources\controllers\sourcesEditCtrl.js
 */

angular.module('settings.sources').controller('sourcesEditCtrl', function ($scope, $rootScope, $state, data, sourceService, $stateParams, $interval) {


    if ($stateParams.id) {
        $scope.id = $stateParams.id;
    }
    $scope.sourceBreadcrumb = $scope.id ? $rootScope.getWord('EditSource') : $rootScope.getWord('AddNewSource');

    sourceService.initSourceSetupObject(data);
    var initData = sourceService.getSourceSetupModel();
    $scope.source = initData.sourceSetupObject;
    $scope.setting = data.setting;
    $scope.victorPriceTypes = data.victor;

    $scope.$watch('source.priceType', function (newValue) {
        angular.element('#source-type-form').formValidation('enableFieldValidators', 'victorPriceType', newValue === 'Victor');
    }, true);

    var interval = $interval(function() {
        if (!$('#priceType').length && !$('#victorPriceType').length) { return; }
        $('#priceType').val($scope.source.priceType);
        $('#victorPriceType').val($scope.source.victorPriceType);
        $interval.cancel(interval);
    }, 100);

    if ($scope.id) {
        $scope.source.markup = $scope.source.markup ? $scope.source.markup : '0';
    }

    $scope.submitObject = function () {

        if ($stateParams.id) {
            if ($scope.source.priceType !== 'Victor') { $scope.source.victorPriceType = ''; }
            sourceService.updateSourceSetupObject();
        } else {
            $rootScope.startSpinner();
            if ($scope.source.priceType !== 'Victor') { $scope.source.victorPriceType = ''; }
            sourceService.initSourceSetupObject($scope.source);
            sourceService.createSourceSetupObject($scope.addAnother)
                .success(function () {
                    $scope.stopSpinner();
                    if ($scope.addAnother) {
                        $scope.source = {};
                    }
                });
        }
    };

    $scope.cancelForm = function () {
        $scope.source = {};
        $state.go(initData.gridScreen);
    };

});

/**
 * Created by Srikanth Reddy Anugu on 10/28/2019.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\sources\controllers\sourcesCtrl.js
 */
angular.module('settings.sources').controller('sourcesCtrl', function ($scope, $state, $compile, data, sourceService, notificationService, $rootScope) {

    sourceService.setSourceSetupList(data);

    var source = sourceService.getSourceSetupModel();

    $scope.options = {
        data: source.sourceSetupList,
        fnCreatedRow: function (nRow) {
            $compile(angular.element(nRow))($scope);
        },
        // This is added so that we maintain the default ordering.
        order: [[0, 'asc']],
        buttons: [
            {
                text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="createSource">' +
                    '<i class="fa fa-plus p-r-sm"></i>' +
                    '<span>' + $rootScope.getWord("AddSource") + '</span>' +
                '</button>',
                className: 'btn btn-success no-padding',
                action: function () {
                    $scope.createNewItem();
                }
            }
        ],
        columns: [
            {
                "mDataProp": "name"
            },
            {
                "mData": "isActive",
                "mRender": function (data, type, full) {
                    var sourceStatus = "Inactive";

                    if (full.isActive) {
                        sourceStatus = "Active";
                    }

                    return "<span>{{getWord('" + sourceStatus + "')}}</span>";
                }
            },
            {
                "mData": "priceType",
                "mRender": function (data, type, full) {
                    var sourceStatus = full.priceType ? full.priceType : 'N/A';
                    return "<span>" + sourceStatus + "</span>";
                }
            },
            {
                "mData": "victorPriceType",
                "mRender": function (data, type, full) {
                    var sourceStatus = full.victorPriceType ? full.victorPriceType : 'N/A';
                    return "<span>" + sourceStatus + "</span>";
                }
            },
            {
                "className": "col-action",
                "bSearchable": false,
                "bSortable": false,
                "mRender": function (data, type, full) {
                    var commandTypes = [3];
                    var labels = {
                        deleteLabel: $rootScope.getWord('Delete')
                    };
                    var btnName = $rootScope.getWord('Edit');
                    return $scope.tableDropdownActions(full.id, full.name, full.readOnly, commandTypes, labels, btnName);
                }
            }

        ]
    };

    $scope.defaultButtonAction = function (id) {
        $state.transitionTo(source.editScreen, {id: id});
    };

    $scope.viewItem = function (id) {
        $state.transitionTo(source.viewScreen, {id: id});
    };

    $scope.deleteItem = function (id, itemName) {
        $scope.confirmDelete(id, itemName, $scope);
    };

    $scope.deleteOnConfirm = function (id, itemName) {
        sourceService.deleteSourceSetupObject(id, itemName);
    };

    $scope.createNewItem = function () {
        $state.go(source.editScreen);
    };

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\module.js
 */

"use strict";

angular
  .module('settings.products', [])
  .config(function ($stateProvider) {


    var stateDef = 'app.settings.products';


    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'Products'
        }
      })

      .state(stateDef + '.list', {
        url: '/products',
        templateUrl: 'app/settings/products/views/index.html',
        controller: 'productsCtrl',
        data: {
          title: 'Products List'
        },
        resolve: {
          data: function ($q, defaultApiService) {
            var ProductTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes');
            var product = defaultApiService.getListCall('Products');

            return $q.all([product, ProductTypes]).then(function (results) {
              var products = {};
              products.product = results[0].data ? results[0].data.data : [];
              products.productTypes = results[1].data;
              return products;
            });
          }
        }

      })
      .state(stateDef + '.edit', {
        url: '/productsEdit/{id}',
        templateUrl: 'app/settings/products/views/edit.html',
        controller: 'productsEditCtrl',
        params: {
          id: {value: null}
        },
        data: {
          title: 'Edit Product'
        },
        resolve: {
          data: function ($q, defaultApiService, $stateParams, $state) {
            var deferred = $q.defer();
            var products = {
              data: {}
            };
            if ($stateParams.id) {
              $state.params = $stateParams.id;

              defaultApiService.readObjectCall('Products', $stateParams.id)
                .success(function (data) {
                  products.data = data;
                  deferred.resolve(products);
                });
              return deferred.promise;
            } else
              deferred.resolve(products);

            return deferred.promise;
          }
        }

      })
  });

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\services\productTypeService.js
 */

angular.module('settings.products').service('productTypeService', function ($state, defaultApiService, notificationService, dtEncoder, $rootScope) {
  var ProductSetupModel = {
    apiCtrl: 'Products',
    productSetupList: [],
    productSetupObject: {},
    editScreen: 'app.settings.products.edit',
    gridScreen: 'app.settings.products.list',
    createAnother: false
  };

  return {
    setProductSetupList: function (data) {
      ProductSetupModel.productSetupList = dtEncoder.dtEncodeValues(data.product, ['name']);
    },

    initProductSetupObject: function (data) {
      if (!data.data)
        ProductSetupModel.productSetupObject = data;
      else if (!data.data.dto)
        ProductSetupModel.productSetupObject = data.data;
      else
        ProductSetupModel.productSetupObject = data.data;
    },

    createProductSetupObject: function (createAnother) {
      return defaultApiService.createObjectCall(ProductSetupModel.apiCtrl, ProductSetupModel.productSetupObject)
        .success(function () {
          notificationService.notifyCreateSuccess(ProductSetupModel.productSetupObject.name);
          if (createAnother) {
            ProductSetupModel.createAnother = true;
            angular.element('#product-type-form').bootstrapValidator('resetForm', true);
          }
          else
            $state.go(ProductSetupModel.gridScreen);
        });
    },

    updateProductSetupObject: function () {
      $rootScope.startSpinner();
      return defaultApiService.updateObjectCall(ProductSetupModel.apiCtrl, ProductSetupModel.productSetupObject)
        .success(function () {
          $rootScope.stopSpinner();
          notificationService.notifyEditSuccess(ProductSetupModel.productSetupObject.name);
          $state.go(ProductSetupModel.gridScreen);
        }).error(function () {
          $rootScope.stopSpinner();
        });
    },

    deleteProductSetupObject: function (id, itemName) {
      $rootScope.startSpinner();
      var table = angular.element('#productDatatable').DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, data, node) {
        return data.id === id;
      });
      defaultApiService.deleteObjectCall(ProductSetupModel.apiCtrl, id)
        .success(function () {
          table.row(row[0]).remove().draw();
          $rootScope.stopSpinner();
          notificationService.notifyDeleteSuccess(itemName);
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },

    getProductSetupModel: function () {
      return ProductSetupModel;
    }
  };

});

/**
 * Created by Srikanth Reddy Anugu on 1/12/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\directives\productTypeEnum.js
 */
angular.module('settings.products').directive('productTypeCategories', function ($rootScope, defaultApiService) {
  return {
    restrict: 'EA',
    replace: true,
    link: function (scope, elements, attributes) {

      var apiCallType = 'JsTypes';
      var archive = attributes.archive == 'true' || false;
      var selectedValue = -1;
      var populateEnums = function (enums) {

        scope.productTypes = [];//Only change this scope variable to populate dropdown menu.
        scope.enumOrders = {};
        var enumIndex = 0;
        _.forEach(enums, function (enumKey, enumValue) {
          scope.productTypes.push({
            name: $rootScope.getWord(enumKey),
            statEnum: enumValue,
            value: enumValue

          });
          if (scope.ctrlProductTypeValue == enumValue)
            selectedValue = enumIndex;
          enumIndex++;
        });

      };

      /*
       * Initialize call for Orders Statuses...
       * TODO: Avoid another call if the statuses have already being loaded.
       *
       **/

      defaultApiService.getListCall(apiCallType + '/' + 'FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes')
        .success(function (data) {
          populateEnums(data);
          scope.productTypeValue = scope.productTypes[selectedValue];
        });
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\directives\product-types.js
 */
angular.module('settings.products').directive('productForm', function (formValidationKeyService, $rootScope) {

  return {

    restrict: 'E',
    replace: true,
    templateUrl: 'app/settings/products/partials/productForm.tpl.html',

    link: function (scope, form) {

      var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
      var TwoDecimalRegexMessage = {
        en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
        en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
      };

      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtName: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 1,
                max: 50
              }
            }
          },

          productTypeValue: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 1,
                max: 100
              }
            }
          },

          txtMarkup: {
            validators: {
              numeric: {},
              between: {
                min: 0,
                max: 100
              },
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitObject();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        // $(e.target)    --> The field element
        // data.fv        --> The FormValidation instance
        // data.field     --> The field name
        // data.element   --> The field element
        // data.validator --> The current validator name

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }

  }

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsEditCtrl.js
 */

angular.module('settings.products').controller('productsEditCtrl', function ($scope, $rootScope, $state, data, productTypeService, $stateParams) {


  if ($stateParams.id) {
    $scope.id = $stateParams.id;
  }
  $scope.productBreadcrumb = $scope.id ? $rootScope.getWord('EditProduct') : $rootScope.getWord('AddNewProduct');

  productTypeService.initProductSetupObject(data);
  var initData = productTypeService.getProductSetupModel();
  $scope.productType = initData.productSetupObject;

  if ($scope.id) {
    $scope.productType.markup = $scope.productType.markup ? $scope.productType.markup : '0';
  }

  $scope.ctrlProductTypeValue = $scope.productType.productType;

  $scope.submitObject = function () {

    if ($stateParams.id) {
      if ($scope.productTypeValue)
        $scope.productType.productType = $scope.productTypeValue.statEnum;
      else
        $scope.productType.productType = null;
      productTypeService.updateProductSetupObject();
    } else {
      if ($scope.productTypeValue)
        $scope.productType.productType = $scope.productTypeValue.statEnum;
      $rootScope.startSpinner();
      productTypeService.initProductSetupObject($scope.productType);
      productTypeService.createProductSetupObject($scope.addAnother)
        .success(function () {
          $scope.stopSpinner();
          if ($scope.addAnother) {
            $scope.productType = {};
            $scope.productTypeValue = -null;
          }
        });
    }
  };

  $scope.cancelForm = function () {
    $scope.productType = {};
    $state.go(initData.gridScreen);
  };

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsCtrl.js
 */
angular.module('settings.products').controller('productsCtrl', function ($scope, $state, $compile, data, productTypeService, notificationService, $rootScope) {

  productTypeService.setProductSetupList(data);

  var productType = productTypeService.getProductSetupModel();

  $scope.productTypeCategoriesEnum = data.productTypes;

  $scope.productList = productType.productSetupList;

  $scope.options = {
    data: productType.productSetupList,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    // This is added so that we maintain the default ordering.
    order: [[0, 'asc']],
    buttons: [
      {
        text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="createProduct">' +
          '                <i class="fa fa-plus p-r-sm"></i>' +
          '                <span>' + $rootScope.getWord("AddProductNames") + '</span>' +
          '              </button>',
        className: 'btn btn-success no-padding',
        action: function () {
          $scope.createNewItem();
        }
      }
    ],
    columns: [
      {
        "mDataProp": "name"
      },
      {
        "sDefaultContent": "",
        "mRender": function (data, type, full) {
          try {
            return $rootScope.getWord($scope.productTypeCategoriesEnum[full.productType]);
          } catch (ex) {
            return $scope.productTypeCategoriesEnum[full.productType];
          }
        }
      },
      {
        "sDefaultContent": "",
        "mRender": function (data, type, full) {
          return full.markup ? full.markup : '0';
        }
      },
      {
        "className": "col-action",
        "bSearchable": false,
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = [3];
          var labels = {
            deleteLabel: $rootScope.getWord('Delete')
          };
          var btnName = $rootScope.getWord('Edit');
          return $scope.tableDropdownActions(full.id, full.name, full.readOnly, commandTypes, labels, btnName);
        }
      }

    ]
  };

  $scope.defaultButtonAction = function (id) {
    $state.transitionTo(productType.editScreen, {id: id});
  };

  $scope.viewItem = function (id) {
    $state.transitionTo(productType.viewScreen, {id: id});
  };

  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    productTypeService.deleteProductSetupObject(id, itemName);
  };

  $scope.createNewItem = function () {
    $state.go(productType.editScreen);
  };

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\services\productTypeService.js
 */

angular.module('settings.products').service('productTypeCodesService', function ($state, defaultApiService, notificationService, dtEncoder, $rootScope) {
    var ProductSetupModel = {
        apiCtrl: 'ProductTypeCode',
        productSetupList: [],
        productSetupObject: {},
        editScreen: 'app.settings.product-codes.edit',
        gridScreen: 'app.settings.product-codes.list',
        createAnother: false
    };

    return {
        setProductSetupList: function (data) {
            ProductSetupModel.productSetupList = dtEncoder.dtEncodeValues(data.product, ['name']);
        },

        initProductSetupObject: function (data) {
            if (!data.data)
                ProductSetupModel.productSetupObject = data;
            else if (!data.data.dto)
                ProductSetupModel.productSetupObject = data.data;
            else
                ProductSetupModel.productSetupObject = data.data;
        },

        createProductSetupObject: function (createAnother) {
            return defaultApiService.createObjectCall(ProductSetupModel.apiCtrl, ProductSetupModel.productSetupObject)
            .success(function () {
                notificationService.notifyCreateSuccess(ProductSetupModel.productSetupObject.name);
                if (createAnother) {
                    ProductSetupModel.createAnother = true;
                    angular.element('#product-codes-type-form').bootstrapValidator('resetForm', true);
                } else
                    $state.go(ProductSetupModel.gridScreen);
            });
        },

        updateProductSetupObject: function () {
            $rootScope.startSpinner();
            return defaultApiService.updateObjectCall(ProductSetupModel.apiCtrl, ProductSetupModel.productSetupObject)
            .success(function () {
                $rootScope.stopSpinner();
                notificationService.notifyEditSuccess(ProductSetupModel.productSetupObject.name);
                $state.go(ProductSetupModel.gridScreen);
            }).error(function () {
                $rootScope.stopSpinner();
            });
        },

        deleteProductSetupObject: function (id, itemName) {
            $rootScope.startSpinner();
            var table = angular.element('#productCodesDatatable').DataTable();//Instantiate DataTables.
            var row = table.rows(function (idx, data, node) {
                return data.id === id;
            });
            defaultApiService.deleteObjectCall(ProductSetupModel.apiCtrl, id)
                .success(function () {
                    table.row(row[0]).remove().draw();
                    $rootScope.stopSpinner();
                    notificationService.notifyDeleteSuccess(itemName);
                }).error(function () {
                $rootScope.stopSpinner();
            });
        },

        getProductSetupModel: function () {
            return ProductSetupModel;
        }
    };

});

/**
 * Created by Srikanth Reddy Anugu on 1/12/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\directives\productTypeEnum.js
 */
angular.module('settings.products').directive('productCodesType', function ($rootScope, defaultApiService) {
    return {
        restrict: 'EA',
        replace: true,
        link: function (scope, elements, attributes) {

            var apiCallType = 'JsTypes';
            var archive = attributes.archive == 'true' || false;
            var selectedValue = -1;
            var populateEnums = function (enums) {

                scope.productTypes = [];//Only change this scope variable to populate dropdown menu.
                scope.enumOrders = {};
                var enumIndex = 0;
                _.forEach(enums, function (enumKey, enumValue) {
                    scope.productTypes.push({
                        name: $rootScope.getWord(enumKey),
                        statEnum: enumValue,
                        value: enumValue

                    });
                    if (scope.ctrlProductTypeValue == enumValue)
                        selectedValue = enumIndex;
                    enumIndex++;
                });

            };

            /*
             * Initialize call for Orders Statuses...
             * TODO: Avoid another call if the statuses have already being loaded.
             *
             **/

            defaultApiService.getListCall(apiCallType + '/' + 'FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes')
                .success(function (data) {
                    populateEnums(data);
                    scope.productTypeValue = scope.productTypes[selectedValue];
                });
        }
    }
});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\directives\product-types.js
 */
angular.module('settings.products').directive('productCodesForm', function (formValidationKeyService, $rootScope) {

    return {

        restrict: 'E',
        replace: true,
        templateUrl: 'app/settings/product-codes/partials/productCodesForm.tpl.html',

        link: function (scope, form) {

            var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
            var TwoDecimalRegexMessage = {
                en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
                fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
                en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
            };

            form.formValidation({

                framework: 'bootstrap',

                icon: {},

                addOns: {
                    i18n: {},
                    mandatoryIcon: {}
                },

                fields: {

                    txtName: {
                        validators: {
                            notEmpty: {},
                            stringLength: {
                                min: 1,
                                max: 50
                            }
                        }
                    },

                    productTypeValue: {
                        validators: {
                            notEmpty: {},
                            stringLength: {
                                min: 1,
                                max: 100
                            }
                        }
                    },
                },

                onSuccess: function (e, data) {
                    e.preventDefault();
                    scope.submitObject();
                },

                live: 'enabled'

            }).on('error.validator.fv', function (e, data) {

                // $(e.target)    --> The field element
                // data.fv        --> The FormValidation instance
                // data.field     --> The field name
                // data.element   --> The field element
                // data.validator --> The current validator name

                data.element
                    .data('fv.messages')

                    // Hide all the messages
                    .find('.help-block[data-fv-for="' + data.field + '"]').hide()

                    // Show only message associated with current validator
                    .filter('[data-fv-validator="' + data.validator + '"]').show();

            });
            form.formValidation('setLocale', formValidationKeyService.getValidationKey());
        }

    }

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\module.js
 */

"use strict";

angular
    .module('settings.product-codes', [])
    .config(function ($stateProvider) {


        var stateDef = 'app.settings.product-codes';


        $stateProvider
            .state(stateDef, {
                abstract: true,
                template: '<ui-view/>',
                data: {
                    title: 'Products'
                }
            })

            .state(stateDef + '.list', {
                url: '/products-codes',
                templateUrl: 'app/settings/product-codes/views/index.html',
                controller: 'productCodesCtrl',
                data: {
                    title: 'Product Code List'
                },
                resolve: {
                    data: function ($q, defaultApiService) {
                        var ProductTypes = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.ProductTypes');
                        var product = defaultApiService.getListCall('ProductTypeCode');

                        return $q.all([product, ProductTypes]).then(function (results) {
                            var products = {};
                            products.product = results[0].data ? results[0].data.data : [];
                            products.productTypes = results[1].data;
                            return products;
                        });
                    }
                }

            })
            .state(stateDef + '.edit', {
                url: '/product-codes/{id}',
                templateUrl: 'app/settings/product-codes/views/edit.html',
                controller: 'productCodesEditCtrl',
                params: {
                    id: {value: null}
                },
                data: {
                    title: 'Edit Product'
                },
                resolve: {
                    data: function ($q, defaultApiService, $stateParams, $state) {
                        var deferred = $q.defer();
                        var products = {
                            data: {}
                        };
                        if ($stateParams.id) {
                            $state.params = $stateParams.id;

                            defaultApiService.getListCall('ProductTypeCode')
                            .success(function (results) {
                                products.data = !_.isEmpty(results.data) ? results.data : [];
                                products.data = _.find(products.data, function(item) {
                                    return item.id === $stateParams.id;
                                });
                                deferred.resolve(products);
                            });
                            return deferred.promise;
                        } else
                            deferred.resolve(products);

                        return deferred.promise;
                    }
                }

            })
    });

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsEditCtrl.js
 */

angular.module('settings.product-codes').controller('productCodesEditCtrl', function ($scope, $rootScope, $state, data, productTypeCodesService, $stateParams) {


    if ($stateParams.id) {
        $scope.id = $stateParams.id;
    }
    $scope.productBreadcrumb = $scope.id ? $rootScope.getWord('EditProductCode') : $rootScope.getWord('AddNewProductCode');

    productTypeCodesService.initProductSetupObject(data);
    var initData = productTypeCodesService.getProductSetupModel();
    $scope.productType = initData.productSetupObject;

    if ($scope.id) {
        $scope.productType.markup = $scope.productType.markup ? $scope.productType.markup : '0';
    }

    $scope.ctrlProductTypeValue = $scope.productType.productType;

    $scope.submitObject = function () {

        if ($stateParams.id) {
            if ($scope.productTypeValue)
                $scope.productType.productType = $scope.productTypeValue.statEnum;
            else
                $scope.productType.productType = null;
            productTypeCodesService.updateProductSetupObject();
        } else {
            if ($scope.productTypeValue)
                $scope.productType.productType = $scope.productTypeValue.statEnum;
            $rootScope.startSpinner();
            productTypeCodesService.initProductSetupObject($scope.productType);
            productTypeCodesService.createProductSetupObject($scope.addAnother)
                .success(function () {
                    $scope.stopSpinner();
                    if ($scope.addAnother) {
                        $scope.productType = {};
                        $scope.productTypeValue = -null;
                    }
                });
        }
    };

    $scope.cancelForm = function () {
        $scope.productType = {};
        $state.go(initData.gridScreen);
    };

});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsCtrl.js
 */
angular.module('settings.product-codes').controller('productCodesCtrl', function ($scope, $state, $compile, data, productTypeCodesService, notificationService, $rootScope) {

    productTypeCodesService.setProductSetupList(data);

    var productType = productTypeCodesService.getProductSetupModel();

    $scope.productTypeCategoriesEnum = data.productTypes;

    $scope.productList = productType.productSetupList;

    $scope.options = {
        data: productType.productSetupList,
        fnCreatedRow: function (nRow) {
            $compile(angular.element(nRow))($scope);
        },
        // This is added so that we maintain the default ordering.
        order: [[0, 'asc']],
        buttons: [
            {
                text: '<button class="btn btn-success m-sm m-t-xs no-padding " id="createProduct">' +
                    '                <i class="fa fa-plus p-r-sm"></i>' +
                    '                <span>' + $rootScope.getWord("AddProductNames") + '</span>' +
                    '              </button>',
                className: 'btn btn-success no-padding',
                action: function () {
                    $scope.createNewItem();
                }
            }
        ],
        columns: [
            {
                "sDefaultContent": "",
                "mRender": function (data, type, full) {
                    try {
                        return $rootScope.getWord($scope.productTypeCategoriesEnum[full.productType]);
                    } catch (ex) {
                        return $scope.productTypeCategoriesEnum[full.productType];
                    }
                }
            },
            {
                "mDataProp": "code"
            },
            {
                "className": "col-action",
                "bSearchable": false,
                "bSortable": false,
                "mRender": function (data, type, full) {
                    var commandTypes = [3];
                    var labels = {
                        deleteLabel: $rootScope.getWord('Delete')
                    };
                    var btnName = $rootScope.getWord('Edit');
                    return $scope.tableDropdownActions(full.id, full.name, full.readOnly, commandTypes, labels, btnName);
                }
            }

        ]
    };

    $scope.defaultButtonAction = function (id) {
        $state.transitionTo(productType.editScreen, {id: id});
    };

    $scope.viewItem = function (id) {
        $state.transitionTo(productType.viewScreen, {id: id});
    };

    $scope.deleteItem = function (id, itemName) {
        $scope.confirmDelete(id, itemName, $scope);
    };

    $scope.deleteOnConfirm = function (id, itemName) {
        productTypeCodesService.deleteProductSetupObject(id, itemName);
    };

    $scope.createNewItem = function () {
        $state.go(productType.editScreen);
    };

});

/**
 * Created by $ingh on 4/6/2017.
 */

angular.module('app.quote').service('variationService', function (multiComponentService, guidService, $timeout) {

  var numberOfSidesVariation = [];
  var colorVariation = [];
  var bleedVariation = [];
  var materialVariation = [];
  var primaryBindVariation = [];
  var finishingOptionsVariation = [];
  var variationAdHocProperties = {};
  var variationAskProperties = {};
  var addHocTags = [];
  var legitVariationAddAction = true;
  var variationRows = [];
  var descriptionTags = [];
  var color = {
    c: true,
    m: true,
    y: true,
    k: true,
    spotColors: []
  };
  var black = {
    c: false,
    m: false,
    y: false,
    k: true,
    spotColors: []
  };


  function clearVariation(id, variationArray) {
    _.forEach(variationArray, function (variation) {
      if (variation.id == id) {
        _.remove(variationArray, variation);
        return false;
      }
    });
    return variationArray
  }

  function getAllVariations() {
    materialVariation = multiComponentService.getCurrentComponent().materialVariations;
    numberOfSidesVariation = multiComponentService.getCurrentComponent().sidesVariations;
    bleedVariation = multiComponentService.getCurrentComponent().bleedVariations;
    colorVariation = multiComponentService.getCurrentComponent().colorVariations;
    finishingOptionsVariation = multiComponentService.getCurrentComponent().finishingOptionsVariations;
    primaryBindVariation = multiComponentService.getCurrentComponent().bindVariations;
  }

  function setBleed(id, bleedObject) {
    if (bleedVariation.length < 1) {
      bleedVariation.push({
        "bleed": {
          "hasBleeds": bleedObject.hasBleeds,
          "bleedBottom": bleedObject.bleedBottom,
          "bleedLeft": bleedObject.bleedLeft,
          "bleedRight": bleedObject.bleedRight,
          "bleedTop": bleedObject.bleedTop
        },
        "id": id
      });
    } else {
      var match = false;
      _.forEach(bleedVariation, function (variation, index) {
        if (variation.id == id) {
          match = true;
          bleedVariation[index] = {
            "bleed": {
              "hasBleeds": bleedObject.hasBleeds ? true : false,
              "bleedBottom": bleedObject.bleedBottom ? bleedObject.bleedBottom : variation.bleedBottom,
              "bleedLeft": bleedObject.bleedLeft ? bleedObject.bleedLeft : variation.bleedLeft,
              "bleedRight": bleedObject.bleedRight ? bleedObject.bleedRight : variation.bleedRight,
              "bleedTop": bleedObject.bleedTop ? bleedObject.bleedTop : variation.bleedTop
            },
            "id": id
          }
        }
      });
      if (!match) {
        bleedVariation.push({
          "bleed": {
            "hasBleeds": bleedObject.hasBleeds,
            "bleedBottom": bleedObject.bleedBottom,
            "bleedLeft": bleedObject.bleedLeft,
            "bleedRight": bleedObject.bleedRight,
            "bleedTop": bleedObject.bleedTop
          },
          "id": id
        });
      }
    }
  }

  function adHocOption(finishingId, adHocObject) {
    var obj = {};
    if (finishingId == '00000000-0000-0000-0000-000000000000') {
      obj = {
        "finishingId": finishingId,
        "finishingOptionName": '',
        "adHocOperation": {
          "customServiceName": adHocObject.customServiceName,
          "adHocMachineCost": adHocObject.costType == "adHocMachineCost" ? {
            "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
            "quantityBy": adHocObject.quantityBy,
            "quantity": adHocObject.quantity,
            "speed": adHocObject.speed,
            "hourlyCost": adHocObject.hourlyCost
          } : null,
          "adHocMaterialCost": adHocObject.costType == "adHocMaterialCost" ? {
            "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
            "quantityBy": adHocObject.quantityBy,
            "quantity": adHocObject.quantity,
            "unitCost": adHocObject.unitCost
          } : null,
          "adHocLaborCost": adHocObject.costType == "adHocLaborCost" ? {
            "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
            "quantityBy": adHocObject.quantityBy,
            "quantity": adHocObject.quantity,
            "speed": adHocObject.speed,
            "hourlyCost": adHocObject.hourlyCost
          } : null
        }
      }
    } else if (adHocObject && adHocObject.inputQuantity) {
      obj = {
        "finishingId": finishingId,
        "inputQuantity": adHocObject.inputQuantity
      }
    } else {
      obj = {
        "finishingId": finishingId
      }
    }
    return obj
  }

  return {
    initializeVariation: function () {
      variationRows = [
        {
          value: '',
          id: guidService.newGuid()
        }
      ];
    },
    setVariationRows: function (rows) {
      variationRows = rows;
    },
    getVariationRows: function () {
      return variationRows;
    },
    setMaterialVariation: function (id, matId) {
      var existingMaterial = false;
      _.filter(materialVariation, function (mat) {
        if (mat.id == id) {
          existingMaterial = true;
          mat.material.materialId = matId
        }
      });
      if (!existingMaterial) {
        materialVariation.push({
          material: { "materialId": matId },
          "id": id
        });
      }
    },
    setSidesVariation: function (id, side) {
      numberOfSidesVariation.push({
        "side": side,
        "id": id
      });
    },
    setBleedVariation: function (id, bleedObject) {
      if (bleedObject.hasBleeds || bleedObject.bleedOffset) {
        if (bleedObject.bleedOffset !== 'custom') {
          bleedObject.bleedBottom = bleedObject.bleedOffset;
          bleedObject.bleedLeft = bleedObject.bleedOffset;
          bleedObject.bleedRight = bleedObject.bleedOffset;
          bleedObject.bleedTop = bleedObject.bleedOffset;
          setBleed(id, bleedObject);
        } else {
          setBleed(id, bleedObject);
        }
        // multiComponentService.enableDisableValidation(false);
      } else {
        setBleed(id, {});
        // multiComponentService.enableDisableValidation(true);
      }
    },

    clearAllVariations: function (id, type) {
      getAllVariations();
      clearVariation(id, materialVariation);
      clearVariation(id, numberOfSidesVariation);
      clearVariation(id, colorVariation);
      clearVariation(id, bleedVariation);
      clearVariation(id, primaryBindVariation);
      clearVariation(id, finishingOptionsVariation);
    },
    clearVariation: function (id, type) {
      switch (type) {
        case 'NumberOfSides':
          numberOfSidesVariation = clearVariation(id, numberOfSidesVariation);
          break;
        case 'Color':
          colorVariation = clearVariation(id, colorVariation);
          break;
        case 'Bleed':
          bleedVariation = clearVariation(id, bleedVariation);
          break;
        case 'Material':
          materialVariation = clearVariation(id, materialVariation);
          break;
        case 'Binding':
          primaryBindVariation = clearVariation(id, primaryBindVariation);
          break;
        case 'Finishing':
          finishingOptionsVariation = clearVariation(id, finishingOptionsVariation);
          break;
        default:
      }
    },
    initializeVariationColor: function (id) {
      colorVariation.push({
        "frontColor": black,
        "backColor": black,
        "id": id
      });
    },
    setVariationColor: function (id, currentColor) {
      switch (currentColor) {
        case 'frontColor':
          colorVariation[colorVariation.length - 1].frontColor = color;
          break;
        case 'frontBlack':
          colorVariation[colorVariation.length - 1].frontColor = black;
          break;
        case 'backColor':
          colorVariation[colorVariation.length - 1].backColor = color;
          break;
        case 'backBlack':
          colorVariation[colorVariation.length - 1].backColor = black;
          break;
      }
      colorVariation[colorVariation.length - 1].id = id;
    },

    setFinishingOptionVariation: function (id, finishingId, adHocObject) {
      var variationExists = false;
      _.forEach(finishingOptionsVariation, function (variation) {
        if (id == variation.id) {
          variationExists = true;
          variation.finishingOptions.push(adHocOption(finishingId, adHocObject))
        }
      });
      if (finishingId == '00000000-0000-0000-0000-000000000000' && !variationExists) {
        finishingOptionsVariation.push({
          "finishingOptions": [
            {
              "finishingId": finishingId,
              "finishingOptionName": '',
              "adHocOperation": {
                "customServiceName": adHocObject.customServiceName,
                "adHocMachineCost": adHocObject.costType == "adHocMachineCost" ? {
                  "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
                  "quantityBy": adHocObject.quantityBy,
                  "quantity": adHocObject.quantity,
                  "speed": adHocObject.speed,
                  "hourlyCost": adHocObject.hourlyCost
                } : null,
                "adHocMaterialCost": adHocObject.costType == "adHocMaterialCost" ? {
                  "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
                  "quantityBy": adHocObject.quantityBy,
                  "quantity": adHocObject.quantity,
                  "unitCost": adHocObject.unitCost
                } : null,
                "adHocLaborCost": adHocObject.costType == "adHocLaborCost" ? {
                  "markAsBuyOut": adHocObject.markAsBuyOut ? adHocObject.markAsBuyOut : false,
                  "quantityBy": adHocObject.quantityBy,
                  "quantity": adHocObject.quantity,
                  "speed": adHocObject.speed,
                  "hourlyCost": adHocObject.hourlyCost
                } : null
              }
            }
          ],
          "id": id
        })
      } else if (!variationExists && adHocObject && adHocObject.inputQuantity) {
        finishingOptionsVariation.push({
          "finishingOptions": [
            {
              "finishingId": finishingId,
              "inputQuantity": adHocObject.inputQuantity
            }
          ],
          "id": id
        })
      } else if (!variationExists) {
        finishingOptionsVariation.push({
          "finishingOptions": [
            {
              "finishingId": finishingId
            }
          ],
          "id": id
        })
      }
    },

    setPrimaryBindVariation: function (rowId, value) {
      var existingBindingOption = false;
      _.filter(primaryBindVariation, function (bind) {
        if (bind.id == rowId) {
          existingBindingOption = true;
          bind.bindId = value
        }
      });
      if (!existingBindingOption) {
        primaryBindVariation.push(
          {
            "bindId": value,
            "id": rowId
          }
        )
      }
    },

    setVariationAdHocProperties: function (rowId, flag, index) {
      variationAdHocProperties = {
        rowId: rowId,
        isVariationAdHoc: flag,
        index: index
      }

    },
    getVariationAdHocProperties: function () {
      return variationAdHocProperties
    },
    setAdHockTags: function (rowId, allFinishingOptions) {
      var filterAdHoc = [];
      _.forEach(addHocTags, function (adHoc) {
        if (rowId == adHoc.value) {
          filterAdHoc.push(adHoc)
        }
      });

      if (descriptionTags.length > 0) {
        _.forEach(descriptionTags, function (description) {
          if (rowId === description.rowId) {
              if(description.finishingOptionName == null) {
                  _.forEach(allFinishingOptions, function (option) {
                      _.forEach(option.operations, function (operation) {
                          if (description.finishingId === operation.id) {
                              if (operation.jdfNodeType === 5 || operation.jdfNodeType === 6) {
                                  description.finishingOptionName = operation.name;
                              }
                          }
                      })
                  });
              }
            filterAdHoc.push(description)
          }
        });
      }
      return filterAdHoc;
    },
    getAdHocTags: function (rowId, adHocName) {
      addHocTags.push({
        name: adHocName,
        value: rowId
      });
    },
    closeVariationTags: function (tagName, rowId, index, finishingId) {
      var filterAdHoc = [];
      if (tagName) {
        _.remove(addHocTags, function (o) {
          return o.name == tagName && o.value == rowId
        });

        _.forEach(addHocTags, function (adHoc) {
          if (rowId == adHoc.value) {
            filterAdHoc.push(adHoc)
          }
        });
      } else if (finishingId) {
        _.remove(descriptionTags, function (o) {
          return o.finishingId == finishingId && o.rowId == rowId
        });

        _.forEach(descriptionTags, function (description) {
          if (rowId == description.rowId) {
            filterAdHoc.push(description)
          }
        });
      }

      _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
        _.remove(variation.finishingOptions, function (o) {
          if (tagName) {
            return variation.id == rowId && o.finishingId == '00000000-0000-0000-0000-000000000000' && o.adHocOperation.customServiceName == tagName;
          } else if (finishingId) {
            return variation.id == rowId && o.finishingId == finishingId;
          }
        });
      });

      if (filterAdHoc.length <= 0) {
        var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
        legitVariationAddAction = false;
        variationFinishingOption[0].selectize.removeItem("00000000-0000-0000-0000-000000000000", true);
        legitVariationAddAction = true;
      }

      if (finishingId) {
        var selectizeInstance = angular.element('#cboVariationFinishingOptions' + index)[0].selectize;
        legitVariationAddAction = false;
        selectizeInstance.items.forEach(function (selectedKey) {
          var option = selectizeInstance.options[selectedKey];
          if (option && option.value === finishingId) {
            // Remove the selected item
            selectizeInstance.removeItem(selectedKey, true);
          }
        });
        legitVariationAddAction = true;
      }

    },
    removeAdHocVariation: function (rowId) {
      _.remove(addHocTags, function (o) {
        return o.value == rowId
      });
      _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
        _.remove(variation.finishingOptions, function (o) {
          return variation.id == rowId && o.finishingId == '00000000-0000-0000-0000-000000000000'
        });
      });
    },
    setLegitVariationAddAction: function (flag) {
      legitVariationAddAction = flag
    },
    getLegitVariationAddAction: function () {
      return legitVariationAddAction
    },
    removeVariationFinishingOption: function (rowId, finishingId) {
      _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
        _.remove(variation.finishingOptions, function (o) {
          return variation.id == rowId && o.finishingId == finishingId
        });
        if (variation.finishingOptions.length == 0) {
          _.remove(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (o) {
            return o.id == rowId;
          });
        }
      });
        _.remove(descriptionTags, function (tag) {
            return tag.finishingId == finishingId;
        });

    },
    getAllVariations: function () {
      return getAllVariations();
    },
    isCustomBleed: function (bleed, index) {
      if (bleed && bleed.hasBleeds) {
        if (!angular.element('#example' + index).is(":checked")) {
          angular.element('#example' + index).click()
        }
        // angular.element('#example'+index).prop('checked', true);
        angular.element('#bleedOffsetRow' + index).removeClass('ng-hide');
        if (bleed.bleedBottom == bleed.bleedLeft && (bleed.bleedBottom == bleed.bleedRight) && (bleed.bleedBottom == bleed.bleedTop)) {
          if (bleed.bleedBottom == "0.0625" || bleed.bleedBottom == "0.125" || bleed.bleedBottom == "0.25") {
            bleed.bleedOffset = bleed.bleedBottom.toString();
            angular.element('#cboVariationBleedOffset' + index).val(bleed.bleedOffset);
          } else {
            bleed.bleedOffset = "custom";
            angular.element('#cboVariationBleedOffset' + index).val(bleed.bleedOffset);
            angular.element('.customFields' + index).removeClass('ng-hide');
            angular.element('#cboVariationBleedTop' + index).val(bleed.bleedTop);
            angular.element('#cboVariationBleedRight' + index).val(bleed.bleedRight);
            angular.element('#cboVariationBleedBottom' + index).val(bleed.bleedBottom);
            angular.element('#cboVariationBleedLeft' + index).val(bleed.bleedLeft);
          }
        } else {
          bleed.bleedOffset = "custom";
          angular.element('#cboVariationBleedOffset' + index).val(bleed.bleedOffset);
          angular.element('.customFields' + index).removeClass('ng-hide');
          angular.element('#cboVariationBleedTop' + index).val(bleed.bleedTop);
          angular.element('#cboVariationBleedRight' + index).val(bleed.bleedRight);
          angular.element('#cboVariationBleedBottom' + index).val(bleed.bleedBottom);
          angular.element('#cboVariationBleedLeft' + index).val(bleed.bleedLeft);
        }
      } else {
        bleed.bleedOffset = "";
        angular.element('#example' + index).prop('checked', false);
      }
    },
    renderFinishingVariations: function (index, finishVariation, rowId) {
      var finishingId = [];
      _.forEach(finishVariation.finishingOptions, function (variation) {
        finishingId.push(variation.finishingId);
        if (variation.adHocOperation) {
          addHocTags.push({
            name: variation.adHocOperation.customServiceName,
            value: rowId
          });
        }
        else {
          variation.rowId = rowId;
          descriptionTags.push(variation);
        }
        addHocTags = _.uniqBy(addHocTags, function (elem) {
          return [elem.value, elem.name].join();
        });

        descriptionTags = _.uniqBy(descriptionTags, function (elem) {
          return [elem.finishingId, elem.finishingOptionName, elem.adHocOperation, elem.description, elem.rowId].join();
        });
      });
      var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
      legitVariationAddAction = false;
      finishingId = _.uniq(finishingId);
      variationFinishingOption[0].selectize.setValue(finishingId, true);
      legitVariationAddAction = true;
    },
    renderBindingVariations: function (index, bindVariation) {
      var variationPrimaryBind = angular.element('#cboVariationPrimaryBind' + index).selectize();
      variationPrimaryBind[0].selectize.setValue(bindVariation.bindId, true);
    },
    renderMaterialVariations: function (index, materialVariation) {
      var variationMaterial = angular.element('#cboVariationMaterial' + index).selectize();
      variationMaterial[0].selectize.setValue(materialVariation.materialId, true);
    },
    setVariationAskProperties: function (rowId, flag, index) {
      variationAskProperties = {
        rowId: rowId,
        isVariationAsk: flag,
        index: index
      }

    },
    getVariationAskProperties: function () {
      return variationAskProperties
    },
    clearAdhocTags: function () {
      addHocTags = [];
    },
    clearDescriptionTags: function () {
      descriptionTags = [];
    },
    setAdhocTags: function (updatedTags) {
      addHocTags = updatedTags
    },
    setDescriptionForFinishingOptionVariations: function (finishingId, description, name, index, row) {
      _.some(finishingOptionsVariation, function (variation) {
        return _.some(variation.finishingOptions, function (finishing) {
          if ((finishing.finishingId === finishingId || finishing === finishingId) && variation.id === row) {
            finishing.description = description;
            if (name !== "") {
              finishing.finishingOptionName = name;
            }
            if(name === '') {
                name = finishing.finishingOptionName;
            }
            return true; // Stop inner loop
          }
          return false;
        });
      });

      var existingTag = null;
      _.forEach(descriptionTags, function (tag) {
        if (tag.finishingId === finishingId) {
          existingTag = tag;
          return false; // break loop
        }
      });
      if (existingTag) {
        existingTag.description = description; // only update description
      } else {
        descriptionTags.push({
          finishingId: finishingId,
          description: description,
          finishingOptionName: name,
          adHocOperation: {},
          rowId: row
        });
      }
        $timeout();
    }
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('recipientInfoService', function (quoteModelService, deliveryMethodService, itemConfigurationService) {

  var recipientInfo = [];

  function getRecipientModel(recipientData, itemId, serviceLevel, shipper, responseCode) {
    return {

      recipientId: recipientData.id || recipientData.recipientId,
      itemId: itemId,
      serviceLevel: serviceLevel ? serviceLevel : '',
      carrier: shipper ? shipper : '',
      responseCode: responseCode ? responseCode : '',
      shippingNotes: "",
      name: recipientData.fullName,
      code: "",
      companyName: recipientData.companyName,
      fullName: recipientData.fullName,
      address1: recipientData.street1,
      address2: recipientData.street2,
      address3: "",
      city: recipientData.city,
      state: recipientData.state,
      postalCode: recipientData.postalCode,
      country: recipientData.country,
      phone: {
        countryCode: recipientData.countryCode,
        number: recipientData.phoneNumber,
        ext: recipientData.phoneExt,
        type: 0
      },
      email: recipientData.email,
      requestedShipDate: "",
      requiredDeliveryDate: "",
      customerWaiting: true
    }
  }

  return {
    initializeRecipientInfo: function () {
      recipientInfo = [];
    },
    addRecipientInfo: function (recipientData, itemId, serviceLevel, shipper, responseCode) {
      if (deliveryMethodService.getShipToRecipients().length == recipientInfo.length) {
        recipientInfo.splice(recipientInfo.length - 1, 1);
        recipientInfo.push(getRecipientModel(recipientData, itemId, serviceLevel, shipper, responseCode));
        quoteModelService.setRecipientInfo(recipientInfo, itemId);
      } else {
        recipientInfo.push(getRecipientModel(recipientData, itemId, serviceLevel, shipper, responseCode));
        quoteModelService.setRecipientInfo(recipientInfo, itemId)
      }
      var index = recipientInfo.length - 1;
      itemConfigurationService.setShipToQuantityId(recipientData.id, index);
      angular.element('#primaryDeliveryButton' + index).removeAttr('disabled', 'disabled');
      angular.element('#primaryDeliveryButton' + index).removeClass('disabled');
      angular.element('#toggleDeliveryAction' + index).removeAttr('disabled', 'disabled');
      angular.element('#toggleDeliveryAction' + index).removeClass('disabled');
    },
    updateRecipientInfo: function (recipientData, itemId, serviceLevel, shipper, responseCode) {
      _.map(recipientInfo, function (recipient, index) {
        //Check if the recipient belongs to the current item
        //Different item can have same recipient
        if (recipient.recipientId == recipientData.id && recipient.itemId == itemId) {
          recipientInfo[index] = getRecipientModel(recipientData, itemId, serviceLevel, shipper, responseCode)
        }
      });
      quoteModelService.setRecipientInfo(recipientInfo, itemId)
    },
    getRecipientInfo: function () {
      return recipientInfo
    },
    setRecipientInfo: function (itemId) {
      var quoteShipTo = quoteModelService.getRecipientInfo();
      _.forEach(quoteShipTo, function (info) {
        if (info.itemId == itemId) {
          recipientInfo.push(info)
        }
      })
    },
    duplicateRecipientInfo: function (oldItemId, newItemId) {
      var quoteShipTo = quoteModelService.getRecipientInfo();
      _.forEach(quoteShipTo, function (info) {
        if (info.itemId == oldItemId) {
          var duplicateRecipientInfo = Object.assign({}, info, {itemId: newItemId});
          quoteModelService.setRecipientInfo([duplicateRecipientInfo], newItemId)
        }
      })
    },
    setDeliveryTable: function (currentItem) {
      _.forEach(quoteModelService.getRecipientInfo(), function (recipient) {
        if (currentItem.id == recipient.recipientId) {
          recipientInfo.push(recipient)
        }
      });
    },
    removeRecipientInfo: function (index, itemId) {
      recipientInfo.splice(index, 1);
      quoteModelService.setRecipientInfo(recipientInfo, itemId)
    },
    setServiceLevel: function (itemId, serviceLevel) {
      var quoteShipTo = quoteModelService.getRecipientInfo();
      _.filter(recipientInfo, function (recipient) {
        if (recipient.itemId == itemId) {
          recipient.serviceLevel = serviceLevel.code;
          recipient.carrier = serviceLevel.shipper;
          recipient.responseCode = serviceLevel.responseCode;
        }
      });
      _.map(quoteShipTo, function (info) {
        if (info.itemId == itemId) {
          info.serviceLevel = serviceLevel.code;
          info.carrier = serviceLevel.shipper;
          info.responseCode = serviceLevel.responseCode
        }
      })
    }

  }


});

/* eslint-disable no-undef */
/**
 * Created by Srikanth Reddy on 03/19/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\services\stepTwo\quoteFileUploadService.js
 */

angular.module('app.quote').service('quoteFileUploadService', function (fileUploadService, $http, defaultApiService, $rootScope, notificationService, itemConfigurationService) {

  var inputValueChanged = false;
  var uploadedFiles = [];

  function setUploadedFile(fileId, fileName) {
    var currentItem = itemConfigurationService.getCurrentItem();
    angular.forEach(fileId, function (fn, val) {
      notificationService.notifyFileUploadSuccess(fileName[val]);
      currentItem.files.push({fileName: fileName[val], itemFileId: fileId[val]})
    })
  }

  return {

    pdfFilesApiCall: function (fileValue, fileName) {
      var fileFormData = fileUploadService.createFileFormData(fileValue);
      return $http({
        method: "POST",
        url: appConfig.apiURL + '/api/' + 'Files',
        headers: {'Content-Type': fileValue ? undefined : "application/x-www-form-urlencoded"},
        transformRequest: function (data) {
          return data.files;
        },
        //Create an object that contains the model and files which will be transformed
        // in the above transformRequest method

        data: {files: fileFormData}
      }).success(function (response) {
        return setUploadedFile(response, fileName);
      }).error(function () {
      });
    },

    removeFileApiCall: function (file) {
      $rootScope.startSpinner();
      var currentItem = itemConfigurationService.getCurrentItem();
      defaultApiService.createObjectCall('Quotes/RemoveFile', file)
        .success(function () {
          angular.forEach(currentItem.files, function (val, index) {
            if (val.itemFileId === file.fileId) {
              currentItem.files.splice(index, 1);
              notificationService.notifyRemoveUploadedFile(val.fileName);
            }
          });
          $rootScope.stopSpinner();
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },

    setDataChanged: function (bool) {
      inputValueChanged = bool
    },

    getDataChanged: function () {
      return inputValueChanged;
    },

    setUploadedFile: function (fileId, fileName) {
      return setUploadedFile(fileId, fileName)
    },

    getUploadFile: function () {
      return uploadedFiles
    }
  };
});

/**
 * Created by Srikanth Reddy Anugu on 8/21/2018.
 * Path : D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\services\stepTwo\pageNumberValidator.js
 */

angular.module('app.quote').service('pageNumberValidator', function ($rootScope) {
  var validTabPageNumberMessage = $rootScope.getWord('ValidTabPageNumberMessage');
  var validTabPageRangeMessage = $rootScope.getWord('ValidTabPageRangeMessage');
  var validTabCountMatchMessage = $rootScope.getWord('ValidTabCountMatchMessage');
  var validNumberOfPageCountMatchMessage = 'Page numbers must match the number of Pages';
  var validTabPageNumberCharacterLimitMessage = $rootScope.getWord('ValidTabPageNumberCharacterLimitMessage');

  var isPageNumbersValid = function (arr, val, flag) {
    var tilt_val = val.split(flag);
    if (tilt_val.length > 2) {
      return false;
    }
    var check_flag = true;
    var without_spec = arr.filter(function (el) {
      if (el.indexOf('~') == -1 && el.indexOf('-') == -1) {
        return el;
      }
    });
    _.forEach(without_spec, function (range_val) {
      if (parseInt(range_val) >= parseInt(tilt_val[0]) && parseInt(range_val) <= parseInt(tilt_val[1])) {
        check_flag = false;
        return false
      }
    });

    if (check_flag) {
      if (tilt_val[0] == "" || tilt_val[1] == "") {
        return false;
      } else if (parseInt(tilt_val[0]) > parseInt(tilt_val[1])) {
        return false;
      } else if (tilt_val[0] == 0) {
        return false;
      }
      else {
        counting_tab += ((parseInt(tilt_val[1]) - parseInt(tilt_val[0])) + 1);
        return true;
      }
    } else {
      return false
    }
  };

  var isRangeValidWithSpec = function (arr) {
    var count = 0;
    var value_flag = false;
    var startValue = [];
    var endValue = [];
    var regex_chk = /\b^\d{1,7}\b\-?\~?\b\d{1,7}$/;

    if (count == arr.length || arr.length == 0) {
      return false
    }

    _.forEach(arr, function (val, idx) {
      if (count == 0) {
        var comp = (arr[count].indexOf('-') != -1) ? arr[count].split('-') : arr[count].split('~');
        if (!comp[0] || !comp[1]) {
          return true
        } else if (comp[0] == comp[1]) {
          value_flag = true;
          return true
        }
        else if ((comp[0].substr(0, 1) == '0') || (comp[1].substr(0, 1) == '0')) {
          value_flag = true;
          return true;
        }
        else if (!regex_chk.test(arr[count])) {
          value_flag = true;
          return true;
        }
        else {
          startValue.push(comp[0]);
          endValue.push(comp[1]);
          count++;
        }
      } else if (count <= arr.length - 1) {
        var comp = (arr[count].indexOf('-') != -1) ? arr[count].split('-') : arr[count].split('~');
        if (!comp[0] || !comp[1]) {
          return true
        } else if (!regex_chk.test(arr[count])) {
          value_flag = true;
          return true;
        }
        count++;
        for (var i = 0; i < startValue.length; i++) {
          if (parseInt(comp[0]) >= parseInt(startValue[i]) && parseInt(comp[0]) <= parseInt(endValue[i])) {
            value_flag = true;
            break;
          }
          else if (parseInt(comp[1]) >= parseInt(startValue[i]) && parseInt(comp[1]) <= parseInt(endValue[i])) {
            value_flag = true;
            break;
          }
          else if (parseInt(startValue[i]) >= parseInt(comp[0]) && parseInt(startValue[i]) <= parseInt(comp[1])) {
            value_flag = true;
            break
          }
          else if (parseInt(endValue[i]) >= parseInt(comp[0]) && parseInt(endValue[i]) <= parseInt(comp[1])) {
            value_flag = true;
            break;
          } else {
            startValue.push(comp[0]);
            endValue.push(comp[1]);
            break;
          }
        }
        if (value_flag) {
          return true
        }
      } else {
        return false
      }
    });
    return value_flag;
  };

  // Check whether page numbers are in ascending order or not
  function checkAscendingOrder(pageNumbers) {
    var asc = false;
    if (pageNumbers.length > 1) {
      for (var i = 0; i < pageNumbers.length; i++) {
        for (var j = i; j < pageNumbers.length; j++) {
          var first_value = pageNumbers[i],
            last_value = pageNumbers[j];
          if (pageNumbers[i].indexOf('~') != -1) {
            first_value = first_value.split('~')[0];
          } else if (pageNumbers[i].indexOf('-') != -1) {
            first_value = first_value.split('-')[0];
          } else if (pageNumbers[j].indexOf('~') != -1) {
            last_value = last_value.split('~')[0];
          } else if (pageNumbers[j].indexOf('-') != -1) {
            last_value = last_value.split('-')[0];
          }
          if (parseInt(first_value) > parseInt(last_value)) {
            asc = true;
            break;
          }
        }
        if (asc) {
          break;
        }
      }
      return asc;
    }
  }

  var counting_tab;
  var pageCount_val;
  var checkTabCountFlag = false;
  var hasError = false;

  return {
    isValid: function (value) {
      // Check whether page Count matches with Page Numbers Count
      hasError = false;
      // if (checkTabCountFlag) {
      //   if (counting_tab != pageCount_val) {
      //     hasError = true;
      //     return {
      //       valid: false,
      //       message: validTabCountMatchMessage
      //     }
      //   }
      // }
      if(value.length > 500) {
        return {
          valid: false,
          message: validTabPageNumberCharacterLimitMessage
        };
      }
      var isValid = true;
      counting_tab = 0;
      if (!value) {
        return false;
      } else {
        var pageNumbers = value.split(',');
        var isDuplicate = pageNumbers.filter(function (current_val, idx, arr) {
          if (arr.indexOf(current_val) != idx) {
            return current_val;
          }
        });
      }

      var isEmpty = pageNumbers.filter(function (current_val, idx) {
        if (!current_val) {
          return idx;
        }
      });
      var without_spec = pageNumbers.filter(function (range) {
        if (range.indexOf('~') == -1 && range.indexOf('-') == -1) {
          return range;
        }
      });
      var with_spec = pageNumbers.filter(function (range) {
        if (range.indexOf('~') != -1 || range.indexOf('-') != -1) {
          return range;
        }
      });

      var char_regex = /\b^\d{1,7}\b$/;
      _.forEach(without_spec, function (count) {
        if (char_regex.test(count) && (count.substr(0, 1) != '0'))
          counting_tab++;
        else {
          isValid = false;
          return false
        }
      });
      if (!isValid) {
        return {
          valid: false,
          message: validTabPageRangeMessage
        }
      }
      if (isRangeValidWithSpec(with_spec)) {
        return {
          valid: false,
          message: validTabPageRangeMessage
        }
      }
      if (isEmpty.length > 0) {
        return {
          valid: false,
          message: validTabPageNumberMessage
        };
      }
      if (isDuplicate.length > 0) {
        return {
          valid: false,
          message: validTabPageNumberMessage
        };
      } else if (checkAscendingOrder(pageNumbers)) {
        return {
          valid: false,
          message: validTabPageRangeMessage
        };
      } else {
        var errorMessage = '';
        angular.forEach(pageNumbers, function (val, idx) {
          if (val.indexOf('~') >= 0) {
            if (!isPageNumbersValid(pageNumbers, val, '~')) {
              isValid = false;
              errorMessage = validTabPageRangeMessage;
              return false;
            }
          } else if (val.indexOf('-') >= 0) {
            if (!isPageNumbersValid(pageNumbers, val, '-')) {
              isValid = false;
              errorMessage = validTabPageRangeMessage;
              return false;
            }
          } else if (val.indexOf('.') >= 0) {
            isValid = false;
            errorMessage = validTabPageNumberMessage;
            return false;
          } else if (val > 10000000) {
            isValid = false;
            errorMessage = validTabPageNumberMessage;
            return false;
          }
        });

          if (checkTabCountFlag) {
              if (counting_tab != pageCount_val) {
                  hasError = true;
                  return {
                      valid: false,
                      message: validNumberOfPageCountMatchMessage
                  }
              }
          }
        return (isValid) ? isValid : {valid: isValid, message: errorMessage};
      }
    },
    getCountFromPageNumbers: function () {
      return counting_tab
    },
    setTabCount: function (val) {
      pageCount_val = val;
    },
    setPageCountCheckFlag: function (flag) {
      checkTabCountFlag = flag;
    },
    checkError: function () {
      return hasError
    },
    initializeAll: function () {
      counting_tab = 0;
      pageCount_val = 0;
      checkTabCountFlag = false;
      hasError = false;
    }
  }
});

/* eslint-disable no-undef */
/**
 * Created by j$ingh on 03/30/2018.
 *
 */

angular.module('app.quote').service('operationsService', function (genericQuotesService, $rootScope) {

  var staticVariations = [];
  var askFinishingId = null;
  var isAskOperationValid = true;
  var currentAskName = '';
  var askLabel = $rootScope.getWord('Quantity');

  return {
    setStaticVariationTypes: function (options) {
      staticVariations = options
    },
    getStaticVariationTypes: function () {
      return staticVariations
    },
    askOperation: function (finishingId, finishingOptions) {
      var isAsk = false;
      _.forEach(finishingOptions, function (option) {
        _.forEach(option.operations, function (operation) {
          if (finishingId == operation.id && operation.estimatingAskType) {
            switch (operation.estimatingAskType) {
              case 1:
                askLabel = $rootScope.getWord('AskQuantity');
                break;
              case 2:
                askLabel = $rootScope.getWord('AskTimesItemQuantity');
                break;
              default:
                askLabel = $rootScope.getWord('AskQuantity');

            }
            isAsk = true;
            currentAskName = operation.name;
          }
        })
      });
      return isAsk;
    },
    setAskFinishingOptions: function (finishingOptions, inputQuantity) {
      finishingOptions.push({
        "finishingId": askFinishingId,
        "inputQuantity": inputQuantity
      })
    },
    setAskFinishingId: function (askId) {
      askFinishingId = askId;
    },
    getAskFinishingId: function () {
      return askFinishingId;
    },
    setValidAskOperation: function (flag) {
      isAskOperationValid = flag
    },
    getValidAskOperation: function () {
      return isAskOperationValid
    },
    getCurrentAskName: function () {
      return currentAskName;
    },
    getAskLabel: function () {
      return askLabel;
    }
  }

});

/**
 * Created by $ingh on 2/5/2017.
 */

angular.module('app.quote').service('multiComponentService', function (itemConfigurationService, defaultApiService, $rootScope, operationsService, customIntentService, $timeout) {

  var multiComponent = [];
  var currentComponent = {};
  var tempFinishingOptions = [];
  var color = {
    c: true,
    m: true,
    y: true,
    k: true,
    spotColors: []
  };
  var black = {
    c: false,
    m: false,
    y: false,
    k: true,
    spotColors: []
  };
  var initialValidAskFlag = false;
  var primaryBind, finishingOption, material;
  var previousValue = [];
  var currentFinishingIds = [];
  var adHockTags = [];
  var legitAddOperation = true;
  var addHocModel = {};
  var descriptionTags = [];
  var descriptionModel = {};
  var isRemoveFunction2 = false;
  function toggleColorButton(color1, color2, color3) {
    angular.element('#' + color3).removeClass('active');
    angular.element('#' + color3).addClass('btn-default');
    angular.element('#' + color3).removeClass('btn-success');

    angular.element('#' + color2).removeClass('active');
    angular.element('#' + color2).addClass('btn-default');
    angular.element('#' + color2).removeClass('btn-success');
    angular.element('#' + color1).addClass('active');
    angular.element('#' + color1).removeClass('btn-default');
    angular.element('#' + color1).addClass('btn-success');
  }

  function getDefaultComponent(componentType) {
    var defaultComponent = {
      itemComponentName: "Component 1",
      isComponentInfoValidated: true,
      "size": {
        "finalWidth": '',
        "finalHeight": '',
        "bleedWidth": 0,
        "bleedHeight": 0
      },
      "pages": '',
      "side": 0,
      "colorFront": {
        "c": false,
        "m": false,
        "y": false,
        "k": true,
        "spotColors": []
      },
      "colorBack": {
        "c": false,
        "m": false,
        "y": false,
        "k": true,
        "spotColors": []
      },
      "itemComponentType": componentType || 1,
      material: {
        "materialId": "",
        "pageCount": '',
        "pageNumbers": ''
      },
      "overridePressCode": null,
      "bindId": null,
      "itemComponentBleed": {
        "hasBleeds": false,
        "bleedBottom": 0,
        "bleedLeft": 0,
        "bleedRight": 0,
        "bleedTop": 0
      },
      "finishingOptions": [],
      "sidesVariations": [],
      "colorVariations": [],
      "bleedVariations": [],
      "materialVariations": [],
      "bindVariations": [],
      "finishingOptionsVariations": []
    };

    var newComponent = JSON.parse(JSON.stringify(defaultComponent));
    return defaultComponent;
  }

  function setOperations(id) {
    var select = angular.element('#' + id).selectize();
    var selectize = select[0].selectize;
    var selectizeValue = '';
    switch (id) {
      case 'cboPrimaryBind':
        selectizeValue = currentComponent.bindId ? currentComponent.bindId : '';
        break;
      case 'cboFinishingOptions':
        var selectedIds = [];
        angular.forEach(currentComponent.finishingOptions, function (option) {
          selectedIds.push(option.finishingId)
        });
        selectizeValue = selectedIds.length > 0 ? selectedIds : '';
        break;
      case 'cboMaterial':
        selectizeValue = currentComponent.material ? currentComponent.material.materialId : '';
        break;
    }
    selectize.setValue(selectizeValue, true)
  }

  function setPrimaryBind(value) {
    currentComponent.bindId = value
  }

  function setMaterial(value) {
    currentComponent.material.materialId = value
  }

  //Build addHock tag array
  function setAdHocTags(adHocName) {
    adHockTags.push({
      name: adHocName,
      value: adHocName
    })
  }
  //Build addHock tag array
  function setFinishingAdHocTag(tag) {
    // adHockTags.push(tag);
      var index = adHockTags.findIndex(function(t) {
          return t.finishingId === tag.finishingId;
      });

      if (index > -1) {
          // Update existing tag
          adHockTags[index] = tag;
      } else {
          // Add new tag
          adHockTags.push(tag);
      }
  }

  function setFinishingOption(value, adHocObj) {
    var finishingIds = [];
    _.forEach(currentComponent.finishingOptions, function (option) {
      finishingIds.push(option.finishingId)
    });

    var removedValues = _.difference(finishingIds, value);
    _.forEach(removedValues, function (value) {
      _.remove(currentComponent.finishingOptions, function (n) {
        return n.finishingId == value;
      });
    });
    //Identify the newly added finishing options and push to array
    var currentIds = value;
    var newValues = [];
    _.forEach(currentIds, function (id) {
      var newArray = [];
      newArray.push(id);
      var common = _.intersection(newArray, finishingIds);
      if (common.length >= 1) {
        _.remove(finishingIds, function (n) {
          return n == id;
        });
      } else {
        newValues.push(id);
      }
    });
    if (newValues.length >= 1)
      _.forEach(newValues, function (val) {
        //if customAdHoc
        if (val == '00000000-0000-0000-0000-000000000000' && adHocObj) {
          currentComponent.finishingOptions.push({
            finishingId: val,
            finishingOptionName: '',
            "adHocOperation": {
              "customServiceName": adHocObj.customServiceName,
              "adHocMachineCost": adHocObj.costType == "adHocMachineCost" ? {
                "markAsBuyOut": adHocObj.markAsBuyOut ? adHocObj.markAsBuyOut : false,
                "quantityBy": adHocObj.quantityBy,
                "quantity": adHocObj.quantity,
                "speed": adHocObj.speed,
                "hourlyCost": adHocObj.hourlyCost
              } : null,
              "adHocMaterialCost": adHocObj.costType == "adHocMaterialCost" ? {
                "markAsBuyOut": adHocObj.markAsBuyOut ? adHocObj.markAsBuyOut : false,
                "quantityBy": adHocObj.quantityBy,
                "quantity": adHocObj.quantity,
                "unitCost": adHocObj.unitCost
              } : null,
              "adHocLaborCost": adHocObj.costType == "adHocLaborCost" ? {
                "markAsBuyOut": adHocObj.markAsBuyOut ? adHocObj.markAsBuyOut : false,
                "quantityBy": adHocObj.quantityBy,
                "quantity": adHocObj.quantity,
                "speed": adHocObj.speed,
                "hourlyCost": adHocObj.hourlyCost
              } : null
            },
            description: ''
          });
          setAdHocTags(adHocObj.customServiceName)
        } else if (adHocObj && adHocObj.inputQuantity) {
          currentComponent.finishingOptions.push({
            finishingId: val,
            "inputQuantity": adHocObj.inputQuantity
          });

        } else {
          currentComponent.finishingOptions.push({
            finishingId: val
          });
        }
      });
  }

  function setOperationsData(operations) {
    var operationObj = {
      allOperation: [],
      optGroupArray: []
    };
    _.forEach(operations, function (bind) {
      _.forEach(bind.operations, function (opt) {
        opt.value = opt.id ? opt.id : '';
        opt.class = bind.formattedHeader;
        operationObj.allOperation.push(opt)
      });
      operationObj.optGroupArray.push(
        {
          value: bind.formattedHeader,
          label: bind.formattedHeader
        }
      );
    });
    return operationObj
  }

  function setEmptyDescriptionForFinishingOption(finishingId, description) {
        if (!currentComponent || !currentComponent.finishingOptions) return;
        var found = _.some(currentComponent.finishingOptions, function (option) {
            if (option.finishingId === finishingId) {
                option.description = description;
                option.finishingOptionName = customIntentService.getFinishingOptionName() || option.finishingOptionName;
                setFinishingAdHocTag(option);
                return true; // break loop, item found and updated
            }
        });

        if (!found) {
            // Add new option if not found
            var newOption = {
                finishingId: finishingId,
                description: description,
                finishingOptionName: customIntentService.getFinishingOptionName()
            };
            setFinishingAdHocTag(newOption);
            currentComponent.finishingOptions.push(newOption);
        }
      $timeout();
    }

  return {
    initializeMultiComponent: function () {
      multiComponent = [];
      currentComponent = {};
    },
    iniatializeComponent: function () {
      currentComponent = {}
    },
    getInitializedComponent: function (tab, idx, stc) {
      var newComp = getDefaultComponent(tab);
      newComp.componentNumber = idx;
      newComp.itemComponentName = stc ? stc.itemComponentName : ('Component ' + idx);
      currentComponent = newComp;
      return newComp
    },
    addComponent: function () {
      var componentNumber = multiComponent.length + 1;
      var newComp = getDefaultComponent();
      newComp.componentNumber = componentNumber;
      newComp.itemComponentName = 'Component ' + componentNumber;
      multiComponent.push(newComp);
      // Pushing a component to multiComponent array is updating the item already.
      // Still adding this condition if it is not updating the item by comparing array lengths.
      var curItem = itemConfigurationService.getCurrentItem();
      if (curItem.itemComponents.length != multiComponent.length)
        itemConfigurationService.pushNewComponent(newComp)
    },
    getAllComponents: function () {
      return multiComponent
    },
    setAllComponents: function (components) {
      multiComponent = components
    },
    removeComponent: function (index) {
      _.remove(multiComponent, function (n) {
        return n.componentNumber == parseInt(index) + 1;
      });
    },
    saveCurrentComponent: function (currentComp, currentTabIndex) {
      multiComponent[currentTabIndex] = currentComp;
    },
    setCurrentComponent: function (index) {
      index = index < 0 ? 0 : index;
      currentComponent = multiComponent[index];
      currentComponent.isComponentInfoValidated = true;
    },
    getCurrentComponent: function () {
      return currentComponent
    },
    getCurrentComponentNumber: function () {
      return currentComponent.componentNumber
    },
    setDescriptionForFinishingOption: function (finishingId, description) {
      if (!currentComponent || !currentComponent.finishingOptions) return;
      var found = _.some(currentComponent.finishingOptions, function (option) {
        if (option.finishingId === finishingId) {
          option.description = description;
          option.finishingOptionName = customIntentService.getFinishingOptionName() || option.finishingOptionName;
          setFinishingAdHocTag(option);
          return true; // break loop, item found and updated
        }
      });

      if (!found) {
        // Add new option if not found
        var newOption = {
          finishingId: finishingId,
          description: description,
          finishingOptionName: customIntentService.getFinishingOptionName()
        };
        setFinishingAdHocTag(newOption);
        currentComponent.finishingOptions.push(newOption);
      }
    },
    updateComponentNumber: function (componentIndex) {
      _.forEach(multiComponent, function (comp) {
        if (comp.componentNumber > componentIndex + 1) {
          comp.componentNumber = comp.componentNumber - 1;
          // comp.itemComponentName = 'componentNumber' + comp.componentNumber;
        }
      })
    },
    setFirstComponent: function () {
      var componentNumber = multiComponent.length + 1;
      var currentItem = itemConfigurationService.getCurrentItem();
      var comp = currentItem.itemComponents[0];
      comp.componentNumber = componentNumber;
      // comp.itemComponentName = 'componentNumber' + componentNumber;
      multiComponent.push(comp);
    },
    setBleed: function (bleed) {
      if (currentComponent.itemComponentBleed) {
        currentComponent.itemComponentBleed.bleedBottom = bleed;
        currentComponent.itemComponentBleed.bleedLeft = bleed;
        currentComponent.itemComponentBleed.bleedRight = bleed;
        currentComponent.itemComponentBleed.bleedTop = bleed;
      }
    },
    setColorButton: function (color1, color2, color3) {
      toggleColorButton(color1, color2, color3);
    },
    setComponentType: function (componentType) {
      // currentComponent.itemComponentType = (componentType && componentType == 'tab') ? 2 : 1;
      if (componentType && componentType == 'standard') {
        currentComponent.itemComponentType = 1;
      } else if (componentType && componentType == 'tab') {
        currentComponent.itemComponentType = 2;
      } else if (componentType && componentType == 'exception') {
        currentComponent.itemComponentType = 3;
      }
    },
    getPageCount: function () {
      return currentComponent.material.pageCount;
    },
    setPageCount: function (value) {
      currentComponent.material.pageCount = value;
    },
    getPageNumber: function () {
      return currentComponent.material.pageNumbers
    },
    setPageNumbers: function (value) {
      currentComponent.material.pageNumbers = value;
    },
    tabComponentCall: function (productType) {
      $rootScope.startSpinner();
      var productTypeObj = {
        productType: productType
      };
      return defaultApiService.createObjectCall('GetTabsMaterial', productTypeObj)
        .success(function (result) {
          $rootScope.stopSpinner();
          return result;
        }).error(function (err) {
          $rootScope.stopSpinner();
          return err;
        });
    },
    setColor: function (color1) {
      switch (color1) {
        case 'frontColor':
          currentComponent.colorFront = color;
          break;
        case 'frontBlack':
          currentComponent.colorFront = black;
          break;
        case 'backColor':
          currentComponent.colorBack = color;
          break;
        case 'backBlack':
          currentComponent.colorBack = black;
          break;
      }
    },
    getColorButton: function () {
      if (JSON.stringify(currentComponent.colorFront) === JSON.stringify(color)) {
        toggleColorButton('frontColor', 'frontBlack');
      } else {
        toggleColorButton('frontBlack', 'frontColor');
      }
      if (JSON.stringify(currentComponent.colorBack) === JSON.stringify(color)) {
        toggleColorButton('backColor', 'backBlack');
      } else {
        toggleColorButton('backBlack', 'backColor');
      }
    },
    enableDisableValidation: function (flag, formId) {
      angular.element('#' + formId).formValidation('enableFieldValidators', 'cboBleedTop', flag);
      angular.element('#' + formId).formValidation('enableFieldValidators', 'cboBleedRight', flag);
      angular.element('#' + formId).formValidation('enableFieldValidators', 'cboBleedBottom', flag);
      angular.element('#' + formId).formValidation('enableFieldValidators', 'cboBleedLeft', flag);
    },
    validateCurrentTab: function () {
      currentComponent.isComponentInfoValidated = true;
    },
    setOperationsData: function (operations) {
      return setOperationsData(operations)
    },
    initializePrimaryBind: function (id) {
      currentComponent.bindId = id
    },
    setPrimaryBind: function (value) {
      setPrimaryBind(value)
    },
    setMaterial: function (value) {
      setMaterial(value)
    },
    initializeFinishingOptions: function (options) {
      currentComponent.finishingOptions = options
    },
    setFinishingOption: function (value, adHocService) {
      setFinishingOption(value, adHocService)
    },
    setOperations: function () {
      setOperations('cboPrimaryBind');
      setOperations('cboFinishingOptions');
      setOperations('cboMaterial');
    },
    reConfigureComponents: function (value, productEnums) {
      var redraw = false;
      switch (parseInt(value[0].productType)) {
        case productEnums.flatSheet:
          multiComponent = _.pullAt(multiComponent, [0]);
          currentComponent = multiComponent[0];
          redraw = true;
          break;
        case productEnums.wideFormat:
          multiComponent = _.pullAt(multiComponent, [0]);
          currentComponent = multiComponent[0];
          redraw = true;
          break;
        case productEnums.finishingOnly:
          multiComponent = _.pullAt(multiComponent, [0]);
          currentComponent = multiComponent[0];
          redraw = true;
          break;
        case productEnums.scans:
          multiComponent = _.pullAt(multiComponent, [0]);
          currentComponent = multiComponent[0];
          redraw = true;
          break;
      }
      return redraw
    },
    setPrimaryBindSelectize: function (select) {
      if (select[0]) {
        var selectize = select[0].selectize;
        var bindingId = currentComponent.bindId ? currentComponent.bindId : "";
        selectize.setValue(bindingId, true)
      }
    },
    setMaterialSelectize: function (select) {
      if (select[0]) {
        var selectize = select[0].selectize;
        var materialId = currentComponent.material ? currentComponent.material.materialId : "";
        selectize.setValue(materialId, true)
      }
    },
    setFinishingSelectize: function (select) {
      if (select[0]) {
        var selectize = select[0].selectize;
        var finishingIds = [];
        _.forEach(currentComponent.finishingOptions, function (option) {
          option.finishingId = option.finishingId ? option.finishingId : '';
          finishingIds.push(option.finishingId)
        });
        var selectizeValue = _.uniq(finishingIds);
        selectize.setValue(selectizeValue, true)
      }
    },
    primaryBindSelectize: function (primaryBinds) {
      var bindingObject = setOperationsData(primaryBinds);
      if (primaryBind && primaryBind[0])
        primaryBind[0].selectize.destroy();
      primaryBind = angular.element('#cboPrimaryBind').selectize({
        options: bindingObject.allOperation,
        optgroups: bindingObject.optGroupArray,
        optgroupField: 'class',
        labelField: 'name',
        searchField: ['name'],
        placeholder: $rootScope.getWord('NoBind'),
        onChange: function (value) {
          setPrimaryBind(value)
        }
      });
    },
    getPrimaryBindSelectize: function () {
      return primaryBind
    },
    getMaterialSelectize: function () {
      return material
    },
    materialSelectize: function (materialOptions) {
      if (material && material[0])
        material[0].selectize.destroy();
      material = angular.element('#cboMaterial').selectize({
        options: materialOptions,
        valueField: 'id',
        labelField: 'name',
        searchField: ['name'],
        placeholder: $rootScope.getWord('SelectOption'),
        sortField: [{ field: 'name', direction: 'asc' }],
        onChange: function (value) {
          setMaterial(value)
        }
      });
    },
    initializePreviousValue: function () {
      previousValue = [];
    },
    finishingOptionSelectize: function (finishingOptions) {
      var invalidRemove = true;
      var isRemoveFunction = false;
      // var isRemoveFunction2 = false;
      var finishingObject = setOperationsData(finishingOptions);
      if (finishingOption && finishingOption[0])
        finishingOption[0].selectize.destroy();
      finishingOption = angular.element('#cboFinishingOptions').selectize({
        options: finishingObject.allOperation,
        optgroups: finishingObject.optGroupArray,
        optgroupField: 'class',
        labelField: 'name',
        searchField: ['name'],
        plugins: ['remove_button'],
        hideSelected: false,
        persist: false,
        duplicates: true,
        placeholder: $rootScope.getWord('NoFinish'),
        onChange: function (value) {
          currentFinishingIds = invalidRemove ? value : currentFinishingIds;
          var recentChange = value[value.length - 1];
          //count will be 2 for duplicate selection
          var count = 0;
          var count_adhoc = 0;
          var adhoc_default = "00000000-0000-0000-0000-000000000000";
          _.forEach(value, function (option) {
            if (option == recentChange) {
              count += 1;
            }

            if (option == adhoc_default) {
              count_adhoc += 1;
            }
          });
          var cusomIntentAlreadyOpen = false;
          var isCusomIntent = customIntentService.customInentOperation(recentChange, finishingOptions, 'finishingOptions');
            tempFinishingOptions = finishingOptions;
          // Logic to Set valid Ask Operation and to fix modal issue
          if (previousValue.length == 0) {
            previousValue = value;
            (initialValidAskFlag) ? operationsService.setValidAskOperation(true) : '';
          } else if (previousValue.length > value.length) {
            previousValue = value;
            operationsService.setValidAskOperation(false);
          } else if (previousValue.length == value.length) {
            previousValue = value;
            operationsService.setValidAskOperation(false);
            legitAddOperation = false
          } else {
            previousValue = value;
            operationsService.setValidAskOperation(true);
          }
          // End

          if (recentChange === adhoc_default && !isRemoveFunction) {
            isRemoveFunction = false;

            /**if there are two customAdHoc tags we need to manually remove it
             Count is number of custom adHoc tags
             **/
            if (count > 1) {
              invalidRemove = false;
              finishingOption[0].selectize.removeItem(recentChange, true);
            }
            /** If we removed a finishing option and now the most recent tag is customAdHoc
             Then to prevent showing Modal this legit flag is used so that modal shows
             Only when user clicks on custom ad hoc to add new not on remove
             This flag is set on submit click of adHoc Modal directive
             **/
            if (legitAddOperation) {
              legitAddOperation = true;
              addHocModel = {};
              angular.element('#adHocCustomServiceModal').modal('show');
            }
            invalidRemove = true;
          } else if (count_adhoc > 1 && recentChange != adhoc_default && !isRemoveFunction) {
            isRemoveFunction = false;
            finishingOption[0].selectize.removeItem(adhoc_default, true);
          } else if (operationsService.askOperation(recentChange, finishingOptions) && !isRemoveFunction) {
            if (count > 1) {
              operationsService.setValidAskOperation(false);
              isRemoveFunction = false;
              finishingOption[0].selectize.removeItem(recentChange, true);
            } else if (operationsService.getValidAskOperation()) {
              isRemoveFunction = false;
              operationsService.setAskFinishingId(recentChange);
              angular.element('#askOperationModal').modal('show');
              cusomIntentAlreadyOpen = true;
              // After the first modal is hidden, show the second modal if needed
              angular.element('#askOperationModal').one('hidden.bs.modal', function () {
                if (isCusomIntent && !isRemoveFunction2 && legitAddOperation) {
                  // angular.element('#customIntentModal').modal('show');
                    setEmptyDescriptionForFinishingOption(recentChange, '');
                }
              });
            } else {
              operationsService.setValidAskOperation(true);
            }
          } else if (count > 1 && recentChange != "00000000-0000-0000-0000-000000000000" && !isRemoveFunction) {
            isRemoveFunction = false;
            finishingOption[0].selectize.removeItem(recentChange, true);
          } else {
            setFinishingOption(value);
            isRemoveFunction = false;
          }

          if (isCusomIntent && !isRemoveFunction2 && legitAddOperation && !cusomIntentAlreadyOpen) {
            //angular.element('#customIntentModal').modal('show');

              setEmptyDescriptionForFinishingOption(recentChange, '');
          }
          isRemoveFunction2 = false;
          cusomIntentAlreadyOpen = false;
        },
        onDelete: function (value) {
          isRemoveFunction = true;
          isRemoveFunction2 = true;
          /**
           * If user remove the adHoc tag then we are removing all the tags on the right and
           * removing all custom adHocs
           **/
          if (value == '00000000-0000-0000-0000-000000000000') {
            // adHockTags = [];
            _.remove(currentComponent.finishingOptions, function (n) {
              return n.finishingId == '00000000-0000-0000-0000-000000000000';
            });
          } else {
            _.remove(currentComponent.finishingOptions, function (n) {
              return _.includes(value, n.finishingId);
            });

            _.remove(adHockTags, function (tag) {
              return _.includes(value, tag.finishingId);
            });

          }
          $rootScope.$apply();
        }
      });
    },
    setDefaultValidAsk: function (flag) {
      initialValidAskFlag = flag;
    },
    getFinishingOptionSelectize: function () {
      return finishingOption
    },
    callPressesForProductType: function (selectedProduct) {
      var presses = [];
      if (selectedProduct) {
        return defaultApiService.getListCall('Presses/GetEstimatorFacilityPresses')
          .success(function (data) {
            presses = data;
            return presses
          })
          .error(function (data) {
            $rootScope.stopSpinner();
          })
      }
    },
    getCurrentFinishingIds: function () {
      return currentFinishingIds;
    },
    getAdHockTags: function () {
      return adHockTags;
    },
    setAdHockTags: function (tags) {
      adHockTags = tags;
    },
    getDescriptionTags: function () {
      return descriptionTags;
    },
    setDescriptionTags: function (tags) {
      descriptionTags = tags;
    },
    setDescriptionModel: function (model) {
      descriptionModel = model;
    },
    setActionLegit: function (flag) {
      legitAddOperation = flag
    },
    buildAdHockTags: function () {
      adHockTags = [];
      _.forEach(currentComponent.finishingOptions, function (option) {
        if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
          setAdHocTags(option.adHocOperation.customServiceName);
        } else { // if(option.description)
            if(tempFinishingOptions) {
                _.forEach(tempFinishingOptions, function (tempOption) {
                    _.forEach(tempOption.operations, function (op) {
                        if (option.finishingId === op.id) {
                            if (op.jdfNodeType === 5 || op.jdfNodeType === 6 && option.description != null) {
                                setFinishingAdHocTag(option);
                            }
                        }
                    })
                });
            }
        }
      })
    },
    getAdHocModel: function () {
      return addHocModel;
    },
    getDescriptionModel: function () {
      return descriptionModel;
    },
    removeAdHoc: function (adHocName, tag) {
      isRemoveFunction2 = true;
      _.forEach(currentComponent.finishingOptions, function (option) {
        if (option.adHocOperation && option.adHocOperation.customServiceName == adHocName) {
          _.remove(currentComponent.finishingOptions, option);
          return false;
        } else if (!adHocName && option.finishingId == tag.finishingId) {
          _.remove(currentComponent.finishingOptions, function (o) {
            return o.finishingId === tag.finishingId;
          });
          finishingOption[0].selectize.removeItem(tag.finishingId, true);
          // return true;
        }
      });
      if (adHockTags.length <= 0) {
        finishingOption[0].selectize.removeItem("00000000-0000-0000-0000-000000000000", true);
      }
    },
    showFinishingTags: function () {
      return adHockTags.length > 0 || descriptionTags.length > 0;
    },
    resetComponent: function () {
      var componentNumber = 1;
      var newComp = getDefaultComponent();
      newComp.componentNumber = componentNumber;
      // newComp.itemComponentName = 'componentNumber' + componentNumber;
      currentComponent = newComp;
      multiComponent = _.pullAt(multiComponent, [0]);
      multiComponent[componentNumber - 1] = currentComponent;

    }
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('itemTabService', function ($rootScope, genericQuotesService) {

  var tabs = [];
  var currentTabIndex = 0;

  return {
    initializeTabs: function () {
      tabs = [];
      currentTabIndex = 0;
    },
    getItemTabs: function () {
      return tabs
    },
    setItemTabs: function (updatedTabs) {
      tabs = updatedTabs
    },
    updateItemTabs: function (tabIndex) {
      tabs[currentTabIndex].active = false;
      tabs[tabIndex].active = true;
      currentTabIndex = parseInt(tabIndex);
    },
    addItemTab: function (index,item) {
      tabs.push(
        {
          id: index,
          name: item && item.itemName ? item.itemName : '',
          disabled: false,
          active: false,
          tabIcon: 'fa fa-ellipsis-h',
          tabClassName: '',
          isItemCosting: false
        }
      )
    },
    setItemName: function (itemName) {
      tabs[currentTabIndex].name = itemName ? itemName : '';
    },
    removeItemTab: function (index) {
      _.remove(tabs, function (n) {
        return n.id == currentTabIndex;
      });
    },
    removeAllTabs: function () {
      tabs = [];
    },
    getCurrentTabIndex: function () {
      return parseInt(currentTabIndex);
    },
    setCurrentTabIndex: function (index) {
      currentTabIndex = index
    },
    validItem: function (index) {
      if (index != currentTabIndex) {
        if (genericQuotesService.validateForm('stepTwoForm')) {
          return true;
        }
      }
      return false;
    },
    enableDeliveryTab: function (i) {
      angular.element('#configTab' + i).removeClass('active');
      angular.element('#deliveryTab' + i).addClass('active')
    },
    enableConfigTab: function (i) {
      angular.element('#deliveryTab' + i).removeClass('active');
      angular.element('#configTab' + i).addClass('active')
    },
    validateDeliveryTabs: function (items) {
      _.forEach(items, function (item, index) {
        if (!item.isDeliveryInfoValid) {
          tabs[index].tabClassName = 'text-danger';
          tabs[index].tabDeliveryClassName = 'text-danger';
        }
      })
    },
    removeItemValidationAlert: function () {
      tabs[currentTabIndex].tabClassName = '';
    },
    removeValidationAlert: function () {
      tabs[currentTabIndex].tabDeliveryClassName = '';
    },
    validateItemTabs: function (index) {
      tabs[index].tabClassName = 'text-danger'
    },
    setCurrentItemCosting: function (index, flag) {
      tabs[index].isItemCosting = flag;
  }
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('itemConfigurationService', function (guidService) {

  var multiItems = [];
  var currentItem = {};
  var currentItemIndex = 0;
  var byPassValidation = false;
  var setOperations = false;

  function getDefaultItem() {
    var defaultItem = {
      "id": guidService.newGuid(),
      "customerSelectedStoreId": currentItem.customerSelectedStoreId ? currentItem.customerSelectedStoreId : null,
      "shippingMethodName": '',
      "productType": null,
      "productId": null,
      "itemName": "",
      "itemTemplateGuid": null,
      "quantity": "",
      "margin": 0,
      "markup": 0,
      "shippingCost": 0,
      "files": [],
      "itemNotes": "",
      "collateMethod": 0,
      "itemComponents": [
        {
          itemComponentName: "Component 1",
          isComponentInfoValidated: true,
          "componentNumber": 1,
          "size": {
            "finalWidth": '',
            "finalHeight": '',
            "bleedWidth": 0,
            "bleedHeight": 0
          },
          "pages": '',
          "side": 0,
          "colorFront": {
            "c": false,
            "m": false,
            "y": false,
            "k": true,
            "spotColors": []
          },
          "colorBack": {
            "c": false,
            "m": false,
            "y": false,
            "k": true,
            "spotColors": []
          },
          "itemComponentType": 1,
          material: {
            "materialId": "",
            "pageCount": '',
            "pageNumbers": ''
          },
          "overridePressCode": null,
          "bindId": null,
          "itemComponentBleed": {
            "hasBleeds": false,
            "bleedBottom": 0,
            "bleedLeft": 0,
            "bleedRight": 0,
            "bleedTop": 0
          },
          "finishingOptions": [],
          "sidesVariations": [],
          "colorVariations": [],
          "bleedVariations": [],
          "materialVariations": [],
          "bindVariations": [],
          "finishingOptionsVariations": []
        }
      ],
      "shipToQuantity": [
        {
          "quoteShipToId": null,
          "quantity": ''
        }
      ],
      "quantityVariations": [],
      isDeliveryInfoValid: false,
      "isItemInfoValidated": false
    };

    var newItem = JSON.parse(JSON.stringify(defaultItem));
    return newItem;
  }

  return {
    initializeItems: function () {
      multiItems = [];
      currentItem = {};
    },
    setCurrentItem: function (item) {
      currentItem = item;
      currentItem.isItemInfoValidated = true;
    },
    getCurrentItem: function () {
      return currentItem
    },
    addItem: function () {
      var itemNumber = multiItems.length + 1;
      var newItem = getDefaultItem();
      newItem.itemNumber = itemNumber;
      if (itemNumber == '1')
        newItem.isItemInfoValidated = true;
      multiItems.push(newItem)
    },
    setAllItems: function (items) {
      multiItems = items;
    },
    getAllItems: function () {
      return multiItems;
    },
    deleteItem: function () {
      _.remove(multiItems, function (n) {
        return n.id == currentItem.id;
      });
    },
    saveCurrentItem: function (allMultiComponents) {
      multiItems[currentItemIndex].itemComponents = allMultiComponents;
    },
    setCurrentItemIndex: function (index) {
      currentItemIndex = index
    },
    getCurrentItemIndex: function () {
      return currentItemIndex
    },
    pushNewComponent: function (comp) {
      multiItems[currentItemIndex].itemComponents.push(comp)
    },
    setProductType: function (value) {
      multiItems[currentItemIndex].productType = value[0].productType;
      multiItems[currentItemIndex].productId = value[0].noId ? null : value[0].value;
      multiItems[currentItemIndex].itemName = (value[0].noId || multiItems[currentItemIndex].itemName) ? multiItems[currentItemIndex].itemName : value[0].name;
      multiItems[currentItemIndex].itemNumber = (multiItems[currentItemIndex].itemNumber) ? (multiItems[currentItemIndex].itemNumber) : '1';
    },
    clearItemLevelFields: function () {
      multiItems[currentItemIndex].itemName = '';
      multiItems[currentItemIndex].collateMethod = 0;
      multiItems[currentItemIndex].itemNotes = '';
      multiItems[currentItemIndex].quantity = '';
    },
    resetSelectize: function (id, selectize) {
      selectize.setValue(null, true)
    },
    setSelectizeValue: function (id) {
      var select = angular.element('#' + id).selectize();
      var selectize = select[0].selectize;
      var selectizeValue = currentItem.productId ? currentItem.productId : currentItem.productType;
      selectize.setValue(selectizeValue, true)
    },
    removeQuantityVariations: function () {
      angular.element('.variationQuantity').remove();
    },
    removeItemQuantityVariations: function () {
      currentItem.quantityVariations = [];
    },
    removeQuantity: function (quantityId) {
      _.remove(currentItem.quantityVariations, function (o) {
        return o.id == quantityId;
      })
    },
    setByPassValidation: function (flag) {
      byPassValidation = flag
    },
    getByPassValidation: function () {
      return byPassValidation
    },
    setShipToQuantity: function (quan, index) {
      if (currentItem.shipToQuantity && currentItem.shipToQuantity.length >= 1 && index >= 0)
        currentItem.shipToQuantity[index].quantity = quan
    },
    addShipToQuantity: function () {
      currentItem.shipToQuantity.push(
        {
          "quoteShipToId": null,
          "quantity": ''
        }
      )
    },
    removeShipToQuantity: function (index) {
      currentItem.shipToQuantity.splice(index, 1);
    },
    setShipToQuantityId: function (id, index) {
      if (currentItem.shipToQuantity && currentItem.shipToQuantity.length >= 1 && index >= 0)
        currentItem.shipToQuantity[index].quoteShipToId = id;
    },
    isDeliveryValidated: function () {
      var isValidated = true;
      _.forEach(multiItems, function (item) {
        if (!item.isDeliveryInfoValid) {
          isValidated = false
        }
      });
      return isValidated;
    },
    setBoolOperations: function (bool) {
      setOperations = bool
    },
    getBoolOperations: function () {
      return {setOperations: setOperations}
    },
    updateMultiItem: function (itemIndex, newItem) {
      multiItems[itemIndex] = newItem;
    },
    setItemValidated: function (index) {
      multiItems[index].isItemInfoValidated = true;
    },
    clearItemFields: function (itemName, collateMethod, notes, quantity) {
      angular.element('#txtItemName').val(itemName);
      angular.element('#cboCollateMethod').val(collateMethod);
      angular.element('#txtItemNotes').val(notes);
      angular.element('#staticQuantity').val(quantity);
    }
  }
});

/**
 * Created by sreddy on 2/12/2018.
 */
angular.module('app.quote').service('deliveryMethodService', function ($rootScope, defaultApiService, notificationService, $state, $stateParams) {
  var deliveryMethodData = {};
  var recipientObj = {};
  var countries = [];
  var states = [];
  var stores = [];
  var street1 = '';
  var setPickupObjectValue = {};
  var shipToRecipients = [];
  var multiSelectIndex = 0;
  var currentDropdownIndex = 0;

  function getAddressData() {
    return {
      companyName: recipientObj.companyName,
      street1: recipientObj.street1,
      street2: recipientObj.street2,
      city: recipientObj.city,
      state: recipientObj.state,
      postalCode: recipientObj.postalCode,
      country: recipientObj.country,
      isResidential: recipientObj.isResidential == false ? recipientObj.isResidential : true
    }
  }

  return {
    initializeDeliveryMethodData: function () {
      deliveryMethodData = {};
    },
    setDeliveryMethodData: function (data) {
      deliveryMethodData = data
    },
    getDeliveryMethodData: function () {
      return deliveryMethodData
    },

    /** ///////////////////////////////////// **/
    /**   Delivery Pickup Stores              **/
    /** ///////////////////////////////////// **/
    setStores: function (data) {
      stores = data.stores;
    },

    getStores: function () {
      return stores
    },

    /** //////////////////////////////////////////////////////////////**/
    /**   Get Delivery Method Enum Values      ///////////////////////**/
    /**  This was a enum before then changed   ///////////////////////**/
    /** to regular Api that is why the function names still say enum  **/
    /** ///////////////////////////////////////////////////////////// **/
    getServiceLevelEnum: function () {
      return deliveryMethodData.serviceLevels;
    },

    //Ends

    /** ///////////////////////////////////// **/
    /**   Get Delivery Method Enum Values     **/
    /** ///////////////////////////////////// **/
    initializeRecipient: function () {
      recipientObj = {}
    },
    setRecipient: function (recipientData, customerId) {
      recipientObj = recipientData;
      recipientObj.country = 'US';
      recipientObj.countryCode = '+1';
      recipientObj.customerId = customerId;
      recipientObj.phoneNumber = recipientData.phoneNumber ? recipientData.phoneNumber : (recipientData && recipientData.phone) ? recipientData.phone.number : '';
      recipientObj.phoneExt = recipientObj.phoneExt ? recipientObj.phoneExt : (recipientData && recipientData.phone) ? recipientData.phone.ext : '';
    },
    getRecipient: function () {
      return recipientObj
    },

    setCountryStates: function (data) {
      countries = data.countries;
      states = data.states;
    },
    getCountries: function () {
      return countries
    },
    getStates: function () {
      return states
    },

    enableDisableAddressValidation: function (flag) {
      angular.element('#recipientModal')
        .formValidation('enableFieldValidators', 'txtStreet1', flag)
        .formValidation('enableFieldValidators', 'txtStreet2', flag)
        .formValidation('enableFieldValidators', 'txtCity', flag)
        .formValidation('enableFieldValidators', 'txtZipCode', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },
    enableDisableContactValidation: function (flag) {
      angular.element('#recipientModal')
        .formValidation('enableFieldValidators', 'txtPhone', flag)
        .formValidation('enableFieldValidators', 'txtExtension', flag)
        .formValidation('enableFieldValidators', 'txtEmail', flag)
        .formValidation('enableFieldValidators', 'txtWebsite', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },
    callAddressValidation: function (id) {
      var addressData = getAddressData();
      return defaultApiService.createObjectCall('AddressValidation', addressData)
        .success(function (data) {
        })
        .error(function (data) {
        })
    },
    haveAddressDetails: function () {
      if (recipientObj.street1 && recipientObj.city && recipientObj.state && recipientObj.postalCode && recipientObj.country && recipientObj.country.toLowerCase() == 'us') {
        return true
      }
      else {
        return false
      }
    },

    enableSubmitButtons: function () {
      angular.element('#btn1').attr('disabled', false);
      angular.element('#btn2').attr('disabled', false);
      angular.element('#btnSave').attr('disabled', false);
      angular.element('#btn1').removeClass('disabled');
      angular.element('#btn2').removeClass('disabled');
      angular.element('#btnSave').removeClass('disabled');
    },
    setRecipientAddress: function (addressDetail) {
      recipientObj.street1 = addressDetail.street1;
      recipientObj.street2 = addressDetail.street2;
      recipientObj.city = addressDetail.city;
      recipientObj.postalCode = addressDetail.postalCode;
      recipientObj.state = addressDetail.state;
      recipientObj.country = addressDetail.country;
      recipientObj.isResidential = addressDetail.isResidential == false ? false : true;
    },
    createRecipientObject: function () {
      delete recipientObj.originalObject;
      return defaultApiService.createObjectCall('Recipients', recipientObj)
        .success(function (data) {
          var successName = recipientObj.fullName ? recipientObj.fullName : $rootScope.getWord('Recipient');
          notificationService.notifyCreateSuccess(successName);
        });
    },
    updateRecipientObject: function (id) {
      recipientObj.quoteId = $stateParams.quoteId ? $stateParams.quoteId : '';
      if ($state.current.url.indexOf('convertQuote') >= 0) {
        if (!recipientObj.id) {
          delete recipientObj.originalObject;
          recipientObj.id = recipientObj.recipientId;
          delete recipientObj.recipientId;
          delete recipientObj.phone;
          delete recipientObj.address3;
          delete recipientObj.customerWaiting;
          delete recipientObj.requestedShipDate;
          delete recipientObj.requiredDeliveryDate;
          delete recipientObj.serviceLevel;
          delete recipientObj.shippingNotes;
        }
      }
      else {
        recipientObj.id = id
      }
      return defaultApiService.updateObjectCallWithQuery('Recipients', recipientObj, 'ConversionRecipientUpdate')
        .success(function (obj_response) {
          var successName = recipientObj.fullName ? recipientObj.fullName : $rootScope.getWord('Recipient');
          notificationService.notifyEditSuccess(successName);
        });
    },
    setStreet1: function () {
      street1 = recipientObj.street1
    },
    getStreet1: function () {
      return street1;
    },
    setPickupObject: function (obj) {
      setPickupObjectValue = obj
    },
    getPickupObject: function () {
      return setPickupObjectValue
    },
    getAvailableStores: function (availableStores, searchString) {
      var searchedData = [];
      if (searchString) {
        _.forEach(availableStores, function (store) {
          if ((store.externalCode && ((store.externalCode.substr(0, searchString.length) === searchString.toLowerCase()) || store.externalCode.indexOf(searchString) >= 0))) {
            searchedData.push(store)
          }
          if (store.externalId && (store.externalId.toLowerCase().substr(0, searchString.length) === searchString.toLowerCase() || store.externalId.indexOf(searchString) >= 0)) {
            searchedData.push(store)
          }
          if (store.city && (store.city.toLowerCase().substr(0, searchString.length) === searchString.toLowerCase() || store.city.toLowerCase().indexOf(searchString.toLowerCase()) >= 0)) {
            searchedData.push(store);
          }
        });
        searchedData = _.uniqWith(searchedData, _.isEqual);
      }
      return searchedData;
    },
    enableSelectedStore: function (index) {
      angular.element('#selectButton' + index).find('.btn').toggleClass('btn-default');
      angular.element('#selectButton' + index).find('.btn').toggleClass('btn-success');
      angular.element('#selectButton' + index).find('.btn-success').html('Selected');
      angular.element('#selectButton' + index).find('.btn-default').html('Select');
      angular.element('#selectButton' + index).find('.btn-success').closest('.ibox').css('border', '1px solid #0288d1');
      angular.element('#selectButton' + index).find('.btn-default').closest('.ibox').css('border', '1px solid #e5e6e7');
    },
    initializeShipToRecipients: function () {
      shipToRecipients = [{
        quantity: ''
      }];
    },
    setShipToRecipients: function (recipients) {
      shipToRecipients = recipients;
    },
    getShipToRecipients: function () {
      return shipToRecipients;
    },
    setAllocatedQuantity: function () {
      var allocatedQuantity = 0;
      _.forEach(shipToRecipients, function (recipient) {
        allocatedQuantity += isNaN(recipient.quantity) ? 0 : recipient.quantity ? parseInt(recipient.quantity) : 0;
      });
      return allocatedQuantity;
    },
    getDropdownIndex: function () {
      return multiSelectIndex
    },
    incrementDropdownIndex: function () {
      multiSelectIndex += 1
    },
    setDropdownIndex: function (index) {
      multiSelectIndex = index
    },
    decrementDropdownIndex: function () {
      multiSelectIndex -= 1
    },
    currentDropdownIndex: function (index) {
      currentDropdownIndex = index
    },
    getCurrentDropdownIndex: function () {
      return currentDropdownIndex
    },
    resetRecipients: function () {
      multiSelectIndex = 0;
      currentDropdownIndex = 0;
    },
    //This is working opposite
    // This function returns whether IsQuantity Not A Number
    isQuantityNumber: function () {
      var flag = false;
      var numberOfRecipients = shipToRecipients.length;
      _.forEach(shipToRecipients, function (recipient) {
        if (numberOfRecipients > 1) {
          if (recipient.quantity && (isNaN(recipient.quantity) || (typeof  recipient.quantity == 'string' && recipient.quantity.indexOf(".") != -1) || recipient.quantity <= 0)) {
            flag = true;
          }
        }
      });
      return flag;
    },
    isQuantityEmpty: function () {
      var flag = false;
      var numberOfRecipients = shipToRecipients.length;
      _.forEach(shipToRecipients, function (recipient) {
        if (numberOfRecipients > 1) {
          if (!recipient.quantity) {
            flag = true;
          }
        }
      });
      return flag;
    },
    checkCustomerExists: function (id) {
      $rootScope.startSpinner();
      return defaultApiService.readObjectCallWithQuery('Customers', id, '/CheckCustomerExists')
        .success(function (data) {
          $rootScope.stopSpinner();
          return data;
        }).error(function () {
          $rootScope.stopSpinner();
        });
    }
  }
});

/* eslint-disable no-undef */
/**
 * Created by j$ingh on 03/30/2018.
 *
 */

angular.module('app.quote').service('customIntentService', function () {
    var currentFinishingId = '';
    var type = '';
    var name = '';
    var description = '';
    var _rowId = '';
    var _index = '';
    return {
        customInentOperation: function (finishingId, finishingOptions, t, index, rowId, des) {
            this.resetAllData();
            if(t === 'variant') {
                _rowId = rowId;
                _index = index;
            } else {
                _rowId = '';
                _index = '';
            }
            type = t;
            description = des;
            currentFinishingId = finishingId;
            var isCusomIntent = false;
            _.forEach(finishingOptions, function (option) {
                _.forEach(option.operations, function (operation) {
                    if (finishingId === operation.id) {
                        if (operation.jdfNodeType === 5 || operation.jdfNodeType === 6) {
                            isCusomIntent = true;
                            name = operation.name;
                            return isCusomIntent;
                        } else {
                            return isCusomIntent;
                        }
                    }
                })
            });
            return isCusomIntent;
        },
        setFinishingId: function (id) {
            currentFinishingId = id
        },
        getFinishingId: function () {
            return currentFinishingId;
        },
        getfinishingOptionsType: function (t) {
            return type;
        },
         getFinishingOptionName: function () {
            return name;
        },
        getRowId: function () {
            return _rowId;
        },
        getIndex: function () {
            return _index;
        },
        setDescription: function (des) {
            description = des;
        },
        getDescription: function () {
            return description;
        },
        resetAllData: function () {
            currentFinishingId = '';
            type = '';
            name = '';
            description = '';
            _rowId = '';
            _index = '';
        }
    }

});

/**
 * Created by $ingh on 2/5/2017.
 */

angular.module('app.quote').service('componentTabService', function ($rootScope) {

  var componentTabs = [];
  var componentTabIndex = 0;
  var currentComponentTabIndex = 0;

  return {
    initializeComponentTabs: function () {
      componentTabs = [];
      componentTabIndex = 0;
      currentComponentTabIndex = 0;
    },
    getComponentTabs: function () {
      return componentTabs
    },
    setComponentTabs: function (updatedTabs) {
      componentTabs = updatedTabs
    },
    updateComponentTabs: function (tabIndex) {
      componentTabs[currentComponentTabIndex].active = false;
      componentTabs[tabIndex].active = true;
      currentComponentTabIndex = parseInt(tabIndex);
    },
    addComponentTab: function (compTabName) {
      componentTabIndex = componentTabs.length;
      componentTabs.push(
        {
          id: componentTabIndex,
          name: compTabName ? compTabName : $rootScope.getWord('Component') + (parseInt(componentTabIndex) + 1),
          disabled: false,
          active: false,
          tabIcon: 'fa fa-ellipsis-h',
          tabClassName: ''
        }
      )
    },
    removeComponentTab: function (index) {
      _.remove(componentTabs, function (n) {
        return n.id == index;
      });
    },
    removeAllComponentTabs: function () {
      componentTabs = [];
    },
    getCurrentComponentTabIndex: function () {
      return parseInt(currentComponentTabIndex);
    },
    setCurrentComponentTabIndex: function (index) {
      index = index < 0 ? 0 : index;
      currentComponentTabIndex = index
    },
    validateComponentTabs: function (components) {
      var componentValid = true;
      _.forEach(components, function (item, index) {
        if (!item.isComponentInfoValidated) {
          componentValid = false;
          componentTabs[index].tabClassName = 'text-danger'
        }
      });
      return componentValid;
    },
    removeComponentValidationAlert: function () {
      componentTabs[currentComponentTabIndex].tabClassName = '';
    },
    updateComponentTabName: function (name) {
      componentTabs[currentComponentTabIndex].name = name ? name : $rootScope.getWord('Component ') + (parseInt(currentComponentTabIndex) + 1)
    }
  }
});

/**
 * Created by Srikanth Reddy on 04/4/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\services\stepThree\itemSummaryService.js
 */

angular.module('app.quote').service('itemSummaryService', function ($rootScope, defaultApiService, $cookies, downloadFileService) {

  var deliveryMethodEnums = {};
  var operationTypeEnums = {};
  var summaryData = {};
  var quoteNumber = '';
  var currentItem = '';
  var currentItemIndex = '';
  var nextEnable = false;
  var reviewEnable = false;
  return {
    initializeSummaryData: function () {
      summaryData = {};
      quoteNumber = '';
    },
    setSummaryData: function (data) {
      summaryData = data;
      quoteNumber = data.quoteHeader ? data.quoteHeader.quoteNumber : quoteNumber;
    },

    getQuoteId: function () {
      return summaryData.quoteId;
    },
    getItemSummaryData: function () {
      return summaryData.items
    },
    setItemSummaryData: function (updatedItems) {
      summaryData.items[currentItemIndex] = updatedItems
    },
    getQuoteHeaderData: function () {
      return summaryData.quoteHeader || summaryData.header;
    },

    setDeliveryMethodEnums: function (data) {
      deliveryMethodEnums = data
    },

    getDeliveryMethodEnums: function () {
      return deliveryMethodEnums
    },

    setOperationTypeEnums: function (data) {
      operationTypeEnums = data
    },

    getOperationTypeEnums: function () {
      return operationTypeEnums
    },

    /***********************************************************************************************
     * File Download Api Call
     **********************************************************************************************/
    downloadFileApiCall: function (file) {
      $rootScope.startSpinner();
      var url = appConfig.apiURL + '/api/Files/' + file.itemFileId;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader('Authorization', "Bearer " + $cookies.get('_Token'));
      xhr.onload = function (e) {
        if (xhr.status == 200) {
          $rootScope.stopSpinner();
          downloadFileService.saveFile(xhr, file.fileName);
        }
        else {
          $rootScope.stopSpinner();
        }
      };
      xhr.send(null);
    },

    /***********************************************************************************************
     * Update Markup Api Call
     **********************************************************************************************/
    updateMarkUp: function (markupObject) {
      $rootScope.startSpinner();
      return defaultApiService.createObjectCall('Quotes/VariationMarkup', markupObject)
        .success(function (result) {
          $rootScope.stopSpinner();
          return result;
        }).error(function (err) {
          $rootScope.stopSpinner();
          return err;
        });
    },

    /***********************************************************************************************
     * Update Shipping Cost Api Call
     **********************************************************************************************/
    updateOverrideShippingCost: function (shippingCostObject) {
      $rootScope.startSpinner();
      return defaultApiService.createObjectCall('Quotes/VariationOverrideShipmentCost', shippingCostObject)
        .success(function (result) {
          $rootScope.stopSpinner();
          return result;
        }).error(function (err) {
          $rootScope.stopSpinner();
          return err;
        });
    },

    setQuoteNumber: function (qNumber) {
      quoteNumber = qNumber ? qNumber : '';
    },
    getQuoteNumber: function () {
      return quoteNumber
    },
    getSummaryData: function () {
      return summaryData;
    },
    setCurrentItemId: function (id) {
      currentItem = id;
    },
    getCurrentItemId: function () {
      return currentItem;
    },
    setCurrentItemIndex: function (index) {
      currentItemIndex = index;
    },
    initItemIndex: function () {
      currentItemIndex = 0;
    },
    getCurrentItemIndex: function () {
      return currentItemIndex;
    },
    itemChangeUpdate: function (value, check) {
      nextEnable = value;
      reviewEnable = check || false;
    },
    getReviewEnableFlag: function () {
      return reviewEnable
    },
    getNextEnableFlag: function () {
      return nextEnable;
    }
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('quotesInfoService', function ($rootScope, $http, $log) {

    var showCustomerCard = false;
    var stepOne = {};
    var selectedCustomerData = null;
    var files = [];
    var customerInfoData = {};
    var detailsParam = {};

    function clearCustomerFields() {
        angular.element('#stepOneForm').formValidation('resetField', 'txtFullName', true);
        angular.element('#stepOneForm').formValidation('resetField', 'txtAccountNumber', true);
        angular.element('#stepOneForm').formValidation('resetField', 'txtCompanyName', true);
    }

    return {

        initializeStepOne: function () {
            showCustomerCard = false;
            stepOne = {};
            selectedCustomerData = null;
        },

        getCustomerList: function (api, string) {

            return $http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                url: appConfig.apiURL + '/api/' + api + '/Filter?' + 'filterValue=' + string
            });
        },

        getRecipientList: function (api, string, id) {
            return $http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                url: appConfig.apiURL + '/api/' + api + '/' + id + '/Recipients' + '/Filter?' + 'filterValue=' + string
            });
        },

        setShowCustomerCard: function (bool) {
            showCustomerCard = bool;
        },
        getShowCustomerCard: function () {
            return showCustomerCard;
        },
        enableSubmitButtons: function () {
            angular.element('#createBtn').removeClass('disabled');
            angular.element('#createBtn').removeAttr('disabled');
            angular.element('#btn3').removeClass('disabled');
            angular.element('#btn3').removeAttr('disabled');
        },
        saveStepOneData: function (data) {
            data.customerId = null;
            if (!showCustomerCard) {
                data.customerId = selectedCustomerData.id;
            }
            stepOne = data;
            $log.log(data);
        },
        getStepOneData: function () {
            return stepOne;
        },
        setupStepOne: function (quoteHeaderData) {
            var customerInfo = quoteHeaderData.customerInfo;
            stepOne = {
                id: customerInfo.customerId,
                accountNumber: customerInfo.accountNumber,
                fullName: customerInfo.quoteBillTo.fullName,
                code: customerInfo.quoteBillTo.code,
                companyName: customerInfo.quoteBillTo.companyName,
                firstName: customerInfo.quoteBillTo.firstName,
                lastName: customerInfo.quoteBillTo.lastName,
                street1: customerInfo.quoteBillTo.address1,
                street2: customerInfo.quoteBillTo.address2,
                street3: customerInfo.quoteBillTo.address3,
                city: customerInfo.quoteBillTo.city,
                state: customerInfo.quoteBillTo.state,
                postalCode: customerInfo.quoteBillTo.postalCode,
                country: customerInfo.quoteBillTo.country,
                hasAddressDetails: !!(customerInfo.quoteBillTo.address1 || customerInfo.quoteBillTo.address2 || customerInfo.quoteBillTo.address3 || customerInfo.quoteBillTo.city || customerInfo.quoteBillTo.state || customerInfo.quoteBillTo.postalCode || customerInfo.quoteBillTo.country),
                countryCode: customerInfo.quoteBillTo.phone.countryCode,
                phoneNumber: customerInfo.quoteBillTo.phone.number,
                phoneExt: customerInfo.quoteBillTo.phone.ext,
                email: customerInfo.email || customerInfo.quoteBillTo.email,
                website: customerInfo.quoteBillTo.website,
                saveAsCustomer: customerInfo.saveAsCustomer ? customerInfo.saveAsCustomer : false,
                projectDescription: quoteHeaderData.projectDescription,
                requesterFullName: quoteHeaderData.requester.name,
                requesterCountryCode: quoteHeaderData.requester.phone.countryCode ? quoteHeaderData.requester.phone.countryCode : '+1',
                requesterPhoneNumber: quoteHeaderData.requester.phone.number,
                requesterPhExtension: quoteHeaderData.requester.phone.ext,
                requesterEmail: quoteHeaderData.requester.email,
                referenceNumber: quoteHeaderData.source.referenceNumber,
                sourceName: quoteHeaderData.source.sourceName,
                priceType: quoteHeaderData.source.priceType,
                versionNumber: quoteHeaderData.versionNumber || '',
                quoteSubTotal: quoteHeaderData.hasOwnProperty('quoteSubTotal') && _.isNumber(quoteHeaderData.quoteSubTotal)
                    ? Number(quoteHeaderData.quoteSubTotal.toFixed(2)) : $rootScope.getWord('SubtotalNotCalculated'),
                vendorTotal: quoteHeaderData.hasOwnProperty('vendorTotal') && _.isNumber(quoteHeaderData.vendorTotal)
                    ? Number(quoteHeaderData.vendorTotal.toFixed(2)) : $rootScope.getWord('VendorTotalNotCalculated')
            }
        },
        removeCustomerInfo: function () {
            stepOne.id = "";
            stepOne.accountNumber = "";
            stepOne.fullName = "";
            stepOne.code = "";
            stepOne.companyName = "";
            stepOne.firstName = "";
            stepOne.lastName = "";
            stepOne.street1 = "";
            stepOne.street2 = "";
            stepOne.street3 = "";
            stepOne.city = "";
            stepOne.state = "";
            stepOne.postalCode = "";
            stepOne.country = "";
            stepOne.countryCode = "";
            stepOne.phoneExt = "";
            stepOne.phoneNumber = "";
            stepOne.email = "";
            stepOne.website = "";
        },
        updateQuoteModel: function (quote, customerInfo) {
            quote.id = customerInfo.id | customerInfo.customerId;
            quote.accountNumber = customerInfo.accountNumber;
            quote.fullName = customerInfo.fullName;
            quote.code = customerInfo.code;
            quote.companyName = customerInfo.companyName;
            quote.firstName = customerInfo.firstName;
            quote.lastName = customerInfo.lastName;
            quote.street1 = customerInfo.street1;
            quote.street2 = customerInfo.street2;
            quote.street3 = customerInfo.street3;
            quote.city = customerInfo.city;
            quote.state = customerInfo.state;
            quote.postalCode = customerInfo.postalCode;
            quote.country = customerInfo.country;
            quote.countryCode = customerInfo.countryCode;
            quote.phoneExt = customerInfo.phoneExt;
            quote.phoneNumber = customerInfo.phoneNumber;
            quote.email = customerInfo.email;
            quote.website = customerInfo.website;
            return quote;
        },
        setSelectedCustomerData: function (data) {
            if (data) {
                clearCustomerFields()
            }
            selectedCustomerData = data
        },
        clearCustomerFields: function () {
            clearCustomerFields()
        },
        getSelectedCustomerData: function () {
            return selectedCustomerData;
        },
        setSaveFiles: function (savedFile) {
            savedFile.isSaved = true;
            files.push(savedFile);
        },
        getSaveFiles: function () {
            return files
        },
        removeFile: function (currentFile) {
            _.pull(files, currentFile);
        },
        setCustomerInfoData: function (data) {
            customerInfoData = data
        },
        getCustomerInfoData: function () {
            return customerInfoData
        },
        setDetailsForParams: function (value) {
            detailsParam = value;
        },
        getDetailsForParams: function () {
            return detailsParam;
        }
    }

});

/**
 * Created by sreddy on 1/30/2018.
 */

angular.module('app.quote').service('quoteListService', function ($rootScope, userRolesService, defaultApiService, notificationService, $state) {

  var listData = {};
  var statusEnumsLocalised = [];
  var sourceNamesArray = [];
  var quoteStatusEnums = {
    inProgress: 10,
    created: 20,
    converted: 30,
    closed: 40
  };
  var defaultButtonLabel = 'Edit';

  return {
    setListData: function (data) {
      listData = data
    },
    getListData: function () {
      return listData
    },
    getStatusEnums: function () {
      statusEnumsLocalised = [];
      _.forEach(listData.quoteStatus, function (statusValue, statusEnum) {
        statusEnumsLocalised[statusEnum] = $rootScope.getWord(statusValue);
      });
      return statusEnumsLocalised
    },

    getSourceEnums: function () {
      sourceNamesArray = [];
      _.forEach(listData.quoteSource, function (source) {
        sourceNamesArray.push({
          check: false,
          value: source.name,
          val: source.name
        });
      });
      return _.sortBy(sourceNamesArray, ['value'], ['asc'])
    },
    getEnumValue: function (enumData, localizedEnum) {
      var enumArray = [];
      _.forEach(enumData, function (value, index) {
        enumArray.push({
          check: false,
          value: localizedEnum[index],
          val: index
        })
      });
      return enumArray
    },
    getDateModifiedOptions: function () {
      return [
        {
          check: false,
          value: $rootScope.getWord('Today'),
          val: 'today'
        }, {
          check: false,
          value: $rootScope.getWord('Yesterday'),
          val: 'yesterday'
        }, {
          check: false,
          value: $rootScope.getWord('LastWeek'),
          val: 'lastweek'
        }, {
          check: false,
          value: $rootScope.getWord('LastTwoWeeks'),
          val: 'lasttwoweeks'
        }, {
          check: false,
          value: $rootScope.getWord('LastMonth'),
          val: 'lastmonth'
        }
      ];
    },
    getQuoteStatusByEnums: function () {
      return quoteStatusEnums;
    },
    getCommands: function (quoteStatus) {
      var commands = [];
      switch (userRolesService.getSystemUserRoles()) {
        //for sysAdmin
        case null && userRolesService.isSysAdmin():
          switch (quoteStatus) {
            case quoteStatusEnums.inProgress:
              defaultButtonLabel = 'Edit';
              commands.push(1);
              commands.push(3);
              break;
            case quoteStatusEnums.created:
              defaultButtonLabel = 'Edit';
              commands.push(6);
              commands.push(7);
              commands.push(8);
              break;
            case quoteStatusEnums.converted:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(9);
              break;
            case quoteStatusEnums.closed:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(3);
              break;
          }
          break;
        case userRolesService.isCoa():
          switch (quoteStatus) {
            case quoteStatusEnums.inProgress:
              defaultButtonLabel = 'View';
              break;
            case quoteStatusEnums.created:
              defaultButtonLabel = 'Convert';
              break;
            case quoteStatusEnums.converted:
              defaultButtonLabel = 'View';
              commands.push(10);
              break;
            case quoteStatusEnums.closed:
              defaultButtonLabel = 'View';
              break;
          }
          break;
        case userRolesService.isCoaManager():
          switch (quoteStatus) {
            case quoteStatusEnums.inProgress:
              defaultButtonLabel = 'Edit';
              commands.push(3);
              break;
            case quoteStatusEnums.created:
              defaultButtonLabel = 'Edit';
              commands.push(6);
              commands.push(7);
              commands.push(8);
              break;
            case quoteStatusEnums.converted:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(9);
              break;
            case quoteStatusEnums.closed:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(3);
              break;
          }
          break;
        case userRolesService.isEstimator():
          switch (quoteStatus) {
            case quoteStatusEnums.inProgress:
              defaultButtonLabel = 'Edit';
              commands.push(3);
              break;
            case quoteStatusEnums.created:
              defaultButtonLabel = 'Edit';
              commands.push(6);
              commands.push(8);
              break;
            case quoteStatusEnums.converted:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(9);
              break;
            case quoteStatusEnums.closed:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(3);
              break;
          }
          break;
        case userRolesService.isEstimatorManager():
          switch (quoteStatus) {
            case quoteStatusEnums.inProgress:
              defaultButtonLabel = 'Edit';
              commands.push(3);
              break;
            case quoteStatusEnums.created:
              defaultButtonLabel = 'Edit';
              commands.push(6);
              commands.push(8);
              break;
            case quoteStatusEnums.converted:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(9);
              break;
            case quoteStatusEnums.closed:
              defaultButtonLabel = 'View';
              commands.push(6);
              commands.push(3);
              break;
          }
          break;
      }

      // if(userRolesService.isSysAdmin() && quoteStatus==quoteStatusEnums.inProgress)
      //   return [1,2,3]
      return commands;
    },
    getDefaultButtonLabel: function () {
      return defaultButtonLabel
    },
    deleteQuote: function (id, itemName, goToList, tableId) {
      $rootScope.startSpinner();

      var table = angular.element('#quoteListDatatable').DataTable();//Instantiate DataTables.
      if (tableId)
        table = angular.element('#' + tableId).DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, data, node) {
        return data.id === id;
      });
      defaultApiService.deleteObjectCall('Quotes', id)
        .success(function () {
          table.row(row[0]).remove().draw();
          $rootScope.stopSpinner();
          notificationService.notifyDeleteSuccess(itemName);
          if (goToList)
            $state.go('app.quote.list');
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },
    reQuote: function (quoteId, versionId) {
      $rootScope.startSpinner();
      var reQuoteObj = {
        "quoteId": quoteId,
        "versionId": versionId
      };
      defaultApiService.createObjectCall('Quotes/ReQuote', reQuoteObj)
        .success(function (data) {
          $rootScope.stopSpinner();
          $state.go('app.quote.createQuote.step_one', {id: data.quoteId});
        }).error(function () {
        $rootScope.stopSpinner();
      });
    }
  }
});

/**
 * Created by sreddy on 10/3/2017.
 */
angular.module('app.quote').service('chipService', function ($rootScope) {

  return {
    //================================================================
    // CREATE TAGS
    //================================================================
    createTags: function (source, status, modifiedBy, date) {
      $rootScope.taging = [];
      if (source != undefined || source != null) {
        _.forEach(source, function (value) {
          $rootScope.taging.push(value)
        })
      }
      if (status != undefined || status != null) {
        _.forEach(status, function (value) {
          $rootScope.taging.push(value)
        })
      }
      if (modifiedBy != undefined || modifiedBy != null) {
        _.forEach(modifiedBy, function (value) {
          $rootScope.taging.push(value)
        })
      }
      if (date != undefined || date != null) {
        _.forEach(date, function (value) {
          $rootScope.taging.push(value)
        })
      }
    },

    //================================================================
    // REMOVE TAG
    //================================================================

    removeTag: function (tag, sourceArray, source, statusArray, status, modifiedArray, modifiedBy, dateArray, date, custom) {

      var valueIndx = '';
      if (source != undefined || source != null) {
        if (source.indexOf(tag) != -1) {
          valueIndx = _.findIndex(sourceArray, function (obj) {
            return obj.value == tag.value
          });
          sourceArray[valueIndx].check = false
          _.pull(source, tag);
          _.pull($rootScope.taging, tag)

        }
      }
      if (status != undefined || status != null) {
        if (status.indexOf(tag) != -1) {
          valueIndx = _.findIndex(statusArray, function (obj) {
            return obj.value == tag.value
          });
          statusArray[valueIndx].check = false
          _.pull(status, tag);
          _.pull($rootScope.taging, tag)
        }
      }
      if (modifiedBy != undefined || modifiedBy != null) {
        if (modifiedBy.indexOf(tag) != -1) {
          valueIndx = _.findIndex(modifiedArray, function (obj) {
            return obj.value == tag.value
          });
          modifiedArray[valueIndx].check = false
          _.pull(modifiedBy, tag);
          _.pull($rootScope.taging, tag)
        }
      }
      if (date != undefined || date != null) {
        if (date.indexOf(tag) != -1) {
          if (custom.value == tag.value) {
            custom.check = false
          } else {
            valueIndx = _.findIndex(dateArray, function (obj) {
              return obj.value == tag.value
            });
            dateArray[valueIndx].check = false
          }

          _.pull(date, tag);
          _.pull($rootScope.taging, tag)
        }


      }
    }

  }

});

/**
 * Created by Srikanth Reddy on 5/2/2018.
 */

angular.module('app.quote').service('convertQuoteService', function (defaultApiService, $rootScope, fileUploadService, $http, notificationService, itemSummaryService, $state, $filter, dtEncoder) {

    /***********************************************************************************************
     * Initialisation
     **********************************************************************************************/
    var convertSource;
    var convertDate;
    var convertTerm;
    var modifiedQuote = {};
    var customerInfo = {};
    var auditInfo = {};
    var source = {};
    var requester = {};
    var sourceTypeEnums = {};
    var termTypeEnums = {};
    var getUpdatedItems = [];
    var customerData = {};
    var selectedVariationsArray = [];
    var variationResponseArray = [];
    var userNoteList = [];
    /***********************************************************************************************
     * Converting Source Enum to Value
     **********************************************************************************************/
    convertSource = function (sourceValue) {
        for (var sourceType in sourceTypeEnums) {
            if (sourceType == sourceValue) {
                return {
                    name: $rootScope.getWord(sourceTypeEnums[sourceType]),
                    value: sourceValue
                };
            }
        }
    };

    /***********************************************************************************************
     * Converting Term Enum to Value
     **********************************************************************************************/
    convertTerm = function (termValue) {
        for (var termType in termTypeEnums) {
            if (termType == termValue) {
                return {
                    name: $rootScope.getWord(termTypeEnums[termType]),
                    value: termValue
                };
            }
        }
    };

    /***********************************************************************************************
     * File Upload for Convert Quote
     **********************************************************************************************/
    var convertQuoteFileUpdate = function (convertFilesObj) {
        $rootScope.startSpinner();
        return defaultApiService.createObjectCall('QuoteReview/UpdateFileInfo', convertFilesObj)
            .success(function (result) {
                $rootScope.stopSpinner();
                getUpdatedItems = result.fileInfo;
                var allItems = itemSummaryService.getItemSummaryData();
                var currentItem = allItems[itemSummaryService.getCurrentItemIndex()];
                angular.forEach(result.fileInfo, function (val) {
                    currentItem.files.push(val);
                });
                return result;
            }).error(function () {
                $rootScope.stopSpinner();
            });
    };

    return {
        setManipulateQuoteData: function (quoteData) {
            customerData = quoteData.customerInfo;
            customerInfo = quoteData.customerInfo.quoteBillTo;
            auditInfo = quoteData.auditInfo;
            source = quoteData.source;
            requester = quoteData.requester;
            modifiedQuote.versionNumber = quoteData.versionNumber || '';
            modifiedQuote.accountNumber = quoteData.customerInfo.accountNumber;
            modifiedQuote.projectDescription = quoteData.projectDescription;
            modifiedQuote.term = convertTerm(quoteData.term) ? convertTerm(quoteData.term) : '';
            modifiedQuote.quoteSubTotal = quoteData.hasOwnProperty('quoteSubTotal') && _.isNumber(quoteData.quoteSubTotal)
                ? Number(quoteData.quoteSubTotal.toFixed(2)) : $rootScope.getWord('SubtotalNotCalculated');
            modifiedQuote.vendorTotal = quoteData.hasOwnProperty('vendorTotal') && _.isNumber(quoteData.vendorTotal)
                ? Number(quoteData.vendorTotal.toFixed(2)) : $rootScope.getWord('VendorTotalNotCalculated');
            modifiedQuote.fullName = customerInfo.fullName;
            modifiedQuote.companyName = customerInfo.companyName;
            modifiedQuote.hasAddressDetails = !!(customerInfo.address1 || customerInfo.address2 || customerInfo.address3 || customerInfo.city || customerInfo.state || customerInfo.postalCode || customerInfo.country);
            modifiedQuote.street1 = customerInfo.address1;
            modifiedQuote.street2 = customerInfo.address2;
            modifiedQuote.street3 = customerInfo.address3;
            modifiedQuote.city = customerInfo.city;
            modifiedQuote.state = customerInfo.state;
            modifiedQuote.postalCode = customerInfo.postalCode;
            modifiedQuote.country = customerInfo.country;
            modifiedQuote.email = customerInfo.email;
            modifiedQuote.phoneNumber = customerInfo.phone.number;
            modifiedQuote.countryCode = customerInfo.phone.countryCode;
            modifiedQuote.phoneExt = customerInfo.phone.ext;
            modifiedQuote.sourceName = source.sourceName;
            modifiedQuote.priceType = source.priceType;
            modifiedQuote.victorPriceType = source.victorPriceType;
            modifiedQuote.referenceNumber = source.referenceNumber;
            modifiedQuote.requesterFullName = requester.name;
            modifiedQuote.requesterCountryCode = requester.phone.countryCode ? requester.phone.countryCode : '+1';
            modifiedQuote.requesterPhoneNumber = requester.phone.number;
            modifiedQuote.requesterPhExtension = requester.phone.ext;
            modifiedQuote.createDate = auditInfo.createdDate;
            modifiedQuote.modifiedDate = auditInfo.lastModifiedDate;
            modifiedQuote.lastModifiedByUserName = auditInfo.lastModifiedByUserName;
        },

        getManipulatedQuoteData: function () {
            return modifiedQuote;
        },

        setSourceTypeEnums: function (sourceEnums) {
            sourceTypeEnums = sourceEnums
        },

        setTermsTypeEnums: function (termEnums) {
            termTypeEnums = termEnums
        },

        setUserNotes: function (data) {
            userNoteList = dtEncoder.dtEncodeValues(data, ['userNote']);
        },

        fileUploadApiCallForConvert: function (fileValue, fileName) {
            var fileFormData = fileUploadService.createFileFormData(fileValue);
            return $http({
                method: "POST",
                url: appConfig.apiURL + '/api/' + 'Files',
                headers: { 'Content-Type': fileValue ? undefined : "application/x-www-form-urlencoded" },
                transformRequest: function (data) {
                    return data.files;
                },
                data: { files: fileFormData }
            }).success(function (response) {
                var filesToConvert = [];
                angular.forEach(response, function (fn, val) {
                    notificationService.notifyFileUploadSuccess(fileName[val]);
                    filesToConvert.push({ fileName: fileName[val], itemFileId: response[val] })
                });

                var convertFilesObj = {
                    "quoteId": itemSummaryService.getQuoteId(),
                    "itemId": itemSummaryService.getCurrentItemId(),
                    "fileInfo": filesToConvert
                };
                return convertQuoteFileUpdate(convertFilesObj);
            }).error(function () {
            });
        },

        removeFile: function (file, filename) {
            $rootScope.startSpinner();
            var currentItem = itemSummaryService.getItemSummaryData()[itemSummaryService.getCurrentItemIndex()];
            defaultApiService.createObjectCall('Quotes/RemoveFile', file)
                .success(function () {
                    angular.forEach(currentItem.files, function (val, index) {
                        if (val.itemFileId === file.fileId) {
                            currentItem.files.splice(index, 1);
                            notificationService.notifyRemoveUploadedFile(val.fileName);
                        }
                    });
                    itemSummaryService.setItemSummaryData(currentItem);
                    $rootScope.stopSpinner();
                }).error(function () {
                    $rootScope.stopSpinner();
                });
        },

        getCustomerData: function () {
            return customerData;
        },

        enableSelectedVariation: function (index, id) {
            angular.element('#' + id + index).find('.btn').toggleClass('btn-default');
            angular.element('#' + id + index).find('.btn').toggleClass('btn-success');
            angular.element('#' + id + index).find('.btn-success').html('Selected');
            angular.element('#' + id + index).find('.btn-default').html('Select');
        },

        updateDeliveryInfo: function (deliveryData, shippingMethod, itemId, storeId) {
            $rootScope.startSpinner();
            var quoteId = itemSummaryService.getQuoteId();
            var updateDeliveryObj = {
                "quoteId": quoteId,
                "itemId": itemId,
                "shippingMethod": shippingMethod,
                "customerSelectedStoreId": storeId,
                "quoteShipTo": deliveryData
            };

            defaultApiService.createObjectCall('QuoteReview/UpdateDeliveryInfo', updateDeliveryObj)
                .success(function () {
                    $rootScope.stopSpinner();
                    selectedVariationsArray = [];
                    notificationService.notifyEditSuccess('Delivery');
                    $state.go('app.quote.convertQuote', { quoteId: quoteId });
                }).error(function () {
                    $rootScope.stopSpinner();
                });
        },

        setSelectedVariations: function (currentItem, varIdx, itemIdx) {
            var hasVariationSelected;
            angular.forEach(itemSummaryService.getSummaryData().items, function (item, indx) {
                if (item.id == currentItem) {
                    var selectedVariation = item.itemVariationCosts[varIdx];
                    angular.forEach(selectedVariationsArray, function (value, index) {
                        if (value.itemId == currentItem) {
                            if (value.variationId == selectedVariation.variationId) {
                                hasVariationSelected = true;
                                selectedVariationsArray.splice(index, 1);
                            } else {
                                hasVariationSelected = false;
                                selectedVariationsArray.splice(index, 1);
                            }
                        } else {
                            hasVariationSelected = false;
                        }
                    });
                    if (!hasVariationSelected) {
                        selectedVariationsArray.push({
                            variationId: selectedVariation.variationId,
                            itemId: item.id,
                            index: varIdx,
                            itemIdx: itemIdx,
                            cost: selectedVariation.itemCost.totalPrice,
                            vendorCost: selectedVariation.itemCost.totalVendorCost
                        });
                    }
                }
            })
        },

        initSelectedVariationsArray: function () {
            selectedVariationsArray = [];
        },

        setReviewSelectedVariations: function (obj) {
            selectedVariationsArray = [];
            angular.forEach(obj, function (variation, indx) {
                if (!variation.variationId) {
                    obj.splice(indx, 1);
                }
            });
            selectedVariationsArray = obj;
        },

        getSelectedVariations: function () {
            return selectedVariationsArray;
        },

        reviewQuoteApiCall: function (quoteId) {
            $rootScope.startSpinner();
            var variationReviewObj = [];
            variationResponseArray = [];
            angular.forEach(selectedVariationsArray, function (item) {
                variationReviewObj.push({
                    "itemId": item.itemId,
                    "variationId": item.variationId
                })
            });

            var reviewRequestObj = {
                "quoteId": quoteId,
                "itemInfo": variationReviewObj
            };

            return defaultApiService.createObjectCall('QuoteReview/ReviewQuote', reviewRequestObj)
                .success(function (result) {
                    $rootScope.stopSpinner();
                    variationResponseArray = result;
                    $state.go('app.quote.reviewQuote', { quoteId: quoteId });
                }).error(function () {
                    $rootScope.stopSpinner();
                });
        },

        getReviewQuoteResponse: function () {
            return variationResponseArray;
        },

        convertToOrderApiCall: function (quoteId, orderNo, deliveryDueTime) {
            $rootScope.startSpinner();
            var variationFinalObj = [];
            var sortedData = $filter('orderBy')(selectedVariationsArray, 'itemIdx');
            angular.forEach(sortedData, function (item) {
                variationFinalObj.push({
                    "itemId": item.itemId,
                    "variationId": item.variationId,
                })
            });

            var convertRequestObj = {
                "quoteId": quoteId,
                "orderNumber": orderNo,
                "requestedDeliveryDate": deliveryDueTime,
                "itemRequests": variationFinalObj,
                "quoteSubtotal": _.reduce(selectedVariationsArray, function (memo, variation) {
                    return memo + variation.cost;
                }, 0),
                "vendorSubtotal": _.reduce(selectedVariationsArray, function (memo, variation) {
                    return memo + variation.vendorCost;
                }, 0)
            };

            return defaultApiService.createObjectCall('ConvertQuotes/ConvertQuoteToOrder', convertRequestObj)
                .success(function (result) {
                    $rootScope.stopSpinner();
                    return result;
                }).error(function () {
                    $rootScope.stopSpinner();
                });
        },

        convertTo24hours: function (time) {
            var hours = Number(time.match(/^(\d+)/)[1]);
            var minutes = Number(time.match(/:(\d+)/)[1]);
            var AMPM = time.match(/\s(.*)$/)[1];

            if (minutes < 10)
                minutes = "0" + minutes;
            if (hours < 10)
                hours = "0" + hours;

            var formattedTime = "1970-01-01T" + hours + ":" + minutes + ":00";

            var utcTime = 'Z';
            var dt = new Date(formattedTime + utcTime);

            if (AMPM == "PM") {
                if (hours != 12) {
                    hours = (dt.getUTCHours() + 12);
                }
            } else {
                if (hours == 12) {
                    hours = (dt.getUTCHours() + 12);
                }
            }
            return "1970-01-01T" + hours + ":" + minutes + ":00";
        },

        convertTo12hour: function (time) {
            // Check correct time format and split into components
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

            if (time.length > 1) { // If time format correct
                time = time.slice(1);  // Remove full string match value
                time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join(''); // return adjusted time or original string
        },

        manipulateViewJson: function (items, headerData, quoteId) {
            var endResponse = [];
            angular.forEach(items, function (val) {
                var item = {
                    "quoteId": quoteId,
                    "itemId": val.id,
                    "itemName": val.itemName,
                    "productType": val.productType,
                    "shippingMethod": val.shippingMethodName,
                    "customerSelectedStoreId": val.customerSelectedStoreId || '',
                    "files": val.files,
                    "itemNotes": val.itemNotes || '',
                    "quoteShipTo": [],
                    "variatonDetails": {}
                };
                endResponse.push(item);
            });

            // Looping to pull Recipient Info of that item
            angular.forEach(headerData.customerInfo.quoteShipTo, function (shipInfo, idx) {
                angular.forEach(endResponse, function (item, idx) {
                    if (item.itemId == shipInfo.itemId) {
                        item.quoteShipTo.push(shipInfo);
                    }
                })
            });

            // Looping to pull Variation Details of Selected Variation in that item
            angular.forEach(items, function (item) {
                angular.forEach(endResponse, function (partialItem) {
                    if (partialItem.itemId == item.id) {
                        var currentVar = item.selectedVariationId;
                        angular.forEach(item.itemVariationCosts, function (variation) {
                            if (variation.variationId == currentVar) {
                                partialItem.variatonDetails = variation;
                            }
                        })
                    }
                })
            });

            return endResponse
        }
    }
});

/**
 * Created by Singh on 11/1/2017.
 * Filename: src/app/quote/directives/wizardStepTwo.js
 */
angular.module('app.quote').directive('wizardStepTwo', function ($location,
                                                                 wizardNavigationService,
                                                                 manageStatesService,
                                                                 componentTabService,
                                                                 genericQuotesService,
                                                                 multiComponentService,
                                                                 itemTabService,
                                                                 itemConfigurationService,
                                                                 quoteFileUploadService,
                                                                 $q,
                                                                 $rootScope,
                                                                 deliveryMethodService,
                                                                 recipientInfoService,
                                                                 quoteModelService,
                                                                 defaultApiService,
                                                                 notificationService,
                                                                 itemSummaryService,
                                                                 $stateParams,
                                                                 pageNumberValidator) {

    return {
        restrict: 'EA',
        replace: false,

        link: function (scope, form) {

            if ($stateParams.id && manageStatesService.getFromState() != 3) {
                var items = itemConfigurationService.getAllItems();
                (items.length < 1) ? itemConfigurationService.addItem() : '';
                itemConfigurationService.setCurrentItemIndex(0);
                itemConfigurationService.setCurrentItem(items[0]);
                multiComponentService.setAllComponents(items[0].itemComponents);
                multiComponentService.setCurrentComponent(0);
                componentTabService.setCurrentComponentTabIndex(0);
                itemTabService.initializeTabs();
                _.forEach(items, function (item, index) {
                    itemTabService.addItemTab(index, item);
                });
                itemTabService.updateItemTabs(0);
                itemConfigurationService.setBoolOperations(true);
            }

            ///######################################///
            //////// Quantity logic start    ///////////
            //#######################################///
            scope.changeQuantity = function (quantityId, quantityValue) {
                _.forEach(scope.item.quantityVariations, function (quantity) {
                    if (quantity.id === quantityId) {
                        quantity.quantity = quantityValue
                    }
                })
            };

            scope.changeStaticQuantity = function () {
                scope.recipientQuantity();
            };

            scope.addQuantityVariations = function () {
                scope.quantityLabel = (scope.item.productType == scope.productEnums.pads) ? $rootScope.getWord('NumberOfPads') : $rootScope.getWord('Quantity');
                _.forEach(scope.item.quantityVariations, function (quantity) {
                    var $template = angular.element('#optionTemplate'),
                        $clone = $template
                            .clone()
                            .removeClass('hide')
                            .addClass('variationQuantity')
                            .removeAttr('id')
                            .insertBefore($template),
                        $option = $clone.find('[name="option[]"]');
                    var quanLabel = $clone.find('[id="quanLabel"]');
                    angular.element(quanLabel).text(scope.quantityLabel);

                    $option.attr('id', quantity.id);
                    $option.val(quantity.quantity);
                    $option.change(function () {
                        scope.changeQuantity(this.id, this.value)
                    });
                });
            };

            ///######################################///
            //////// Quantity logic End    ///////////
            //#######################################///

            var navigationSteps = wizardNavigationService.getNavigationStepEnums();
            scope.validateHighLightedComponents = false;

            scope.updateItemName = function () {
                itemTabService.setItemName(this.item.itemName);
            };

            // Validating Page Numbers against page count
            function validatePageCount() {
                pageNumberValidator.setPageCountCheckFlag(true);
                angular.element('#stepTwoForm').formValidation('revalidateField', 'txtPageNumbers', true);
                pageNumberValidator.setPageCountCheckFlag(false);
                if (!pageNumberValidator.checkError()) {
                    scope.submitConfig()
                }
            }

            // Checks whether item has at least one Bind for Books/Pads product type to continue
            function checkBindValidation(itemName) {
                if ((scope.isByPassEnabled && scope.isByPassEnabled === 'enable') || (scope.isStandardExist && scope.isStandardExist === 'enable')) {
                    scope.closeAlert();
                    validatePageCount();
                } else if ((scope.isByPassEnabled && scope.isByPassEnabled === 'disable') || (scope.isStandardExist && scope.isStandardExist === 'disable')) {
                    var errorMessage = (scope.isByPassEnabled === 'disable') ? $rootScope.getWord('AtLeastOneBindRequired') : $rootScope.getWord('AtLeastOneStandardRequired');
                    scope.errorBadgeFn([{
                        itemName: itemName,
                        message: errorMessage
                    }]);
                    window.scrollTo(0, 0);
                } else if (scope.checkTabCountFlag) {
                    validatePageCount();
                } else
                    scope.submitConfig();
            }

            scope.validateStepTwo = function () {
                angular.element('#stepTwoForm').formValidation('revalidateField', 'option[]', true);
                scope.validateHighLightedComponents = false;
                scope.item.itemName = angular.element('#txtItemName').val();
                if (!genericQuotesService.validateForm('stepTwoForm'))
                    genericQuotesService.autoScroll('stepTwoForm');
                else if (componentTabService.validateComponentTabs(multiComponentService.getAllComponents())) {
                    checkBindValidation(scope.item.itemName);
                } else {
                    scope.validateHighLightedComponents = true;
                }
            };

            // Populate Pick up card when Selected Store is there
            scope.populatePickUpCard = function (storeId) {
                if (storeId) {
                    scope.pickUpSearchText = storeId;
                    scope.searchByString(storeId);
                }
            };

            //Switching Tabs
            if (!manageStatesService.getGoToPrevious()) {
                scope.activeTabOne = true;
                scope.activeTabTwo = false;
            } else {
                scope.activeTabOne = false;
                scope.activeTabTwo = true;
                itemTabService.enableDeliveryTab(itemTabService.getCurrentTabIndex());
            }

            scope.submitConfig = function () {
                scope.activeTabOne = false;
                scope.activeTabTwo = true;
                itemTabService.removeValidationAlert(itemTabService.getCurrentTabIndex());
                itemTabService.enableDeliveryTab(itemTabService.getCurrentTabIndex());
                scope.populatePickUpCard(scope.selectedStore);
                scope.item.isDeliveryInfoValid = true;
                scope.canNotAddRecipient = false;
            };

            scope.goToDelivery = function (itemIndex) {
                angular.element('#stepTwoForm').formValidation('revalidateField', 'option[]', true);
                if (genericQuotesService.validateForm('stepTwoForm') && componentTabService.validateComponentTabs(multiComponentService.getAllComponents())) {
                    scope.validateHighLightedComponents = false;
                    angular.element('#stepTwoForm').data('formValidation').resetForm();
                    checkBindValidation(scope.item.itemName);
                    scope.item.isDeliveryInfoValid = true;
                    scope.canNotAddRecipient = false;
                    itemTabService.removeValidationAlert(itemIndex)
                } else {
                    genericQuotesService.autoScroll('stepTwoForm')
                }
            };

            scope.goToConfiguration = function (itemIndex) {
                if (!itemIndex && itemIndex !== 0) {
                    itemIndex = itemTabService.getCurrentTabIndex();
                }
                scope.closeAlert();
                scope.activeTabOne = true;
                scope.activeTabTwo = false;
                itemTabService.enableConfigTab(itemIndex);
            };

            function executeStepTwo() {
                manageStatesService.setLegitAction(true);
                // $state.go('app.quote.createQuote.step_three',{id : $stateParams.id,editItem : $stateParams.editItem});
                $location.path('/index/quoteEdit/step_three/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
                wizardNavigationService.setCurrentState(navigationSteps.quoteReview);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
                itemConfigurationService.setBoolOperations(true);
            }

            // Job Costing Error Messages
            var errorArray = [];

            function showVariationError(errorData, itemName, componentNo) {
                var errMessage = '';
                if (typeof errorData == 'string') {
                    errMessage = errorData || $rootScope.getWord('JobCostingError');
                    if (componentNo) {
                        errMessage = $rootScope.getWord('Component') + ' ' + componentNo + ' - ' + errMessage;
                    }
                } else {
                    errMessage = errorData.ExceptionMessage
                }
                errorArray.push({name: itemName, message: errMessage});
            }

            function bindCost(data, createQuote) {
                if (data.quoteHeader) {
                    itemSummaryService.setQuoteNumber(data.quoteHeader.quoteNumber);
                    scope.updateQuoteNumber();
                    quoteModelService.setAuditInfo(data.quoteHeader);
                }
                $rootScope.stopSpinner();
                angular.forEach(data.items, function (item, index) {
                    //Error Handling if costing fails for at least one item
                    if (item.itemVariationCosts && item.itemVariationCosts.length > 0) {
                        angular.forEach(item.itemVariationCosts, function (cost) {
                            if (!cost.success) {
                                createQuote = false;
                                try {
                                    showVariationError(JSON.parse(cost.errorMessage), 'Item ' + (+parseInt(index + 1)).toString() + ' - ' + item.itemName.toString());
                                } catch (e) {
                                    showVariationError('', 'Item ' + (+parseInt(index + 1)).toString() + ' - ' + item.itemName.toString());
                                }
                            }
                        })
                    }
                    //Error Handling if Item/component config fail
                    else {
                        createQuote = false;
                        if (!item.validationResponse.isValidated) {
                            angular.forEach(item.validationResponse.errorDetails, function (err) {
                                showVariationError(err, 'Item ' + (+parseInt(index + 1)).toString() + ' - ' + item.itemName.toString());
                            })
                        }
                        angular.forEach(item.validationResponse.componentValidationResponse, function (errResponse) {
                            if (!errResponse.isValidated) {
                                angular.forEach(errResponse.errorDetails, function (partErr) {
                                    showVariationError(partErr, 'Item ' + (+parseInt(index + 1)).toString() + ' - ' + item.itemName.toString(), errResponse.componentNumber);
                                })
                            }
                        })
                    }
                });

                if (createQuote) {
                    itemSummaryService.setSummaryData(data);
                    multiComponentService.setCurrentComponent(0);
                    componentTabService.updateComponentTabs(0);
                    itemSummaryService.initItemIndex();
                    scope.closeAlert();
                    executeStepTwo();
                    scope.canNotAddRecipient = false;
                    $rootScope.$broadcast('valueChanged', data);
                } else {
                    scope.errorBadgeFn(errorArray);
                    // window.scrollTo(0, 0);
                }

            }

            scope.calculateCost = function (createQuote, bindCostData) {
                //TODO: JSS : Temporary Fix for One recipient
                //Remove this logic for multi recipients
                var currentItemIndex = itemTabService.getCurrentTabIndex();
                _.forEach(itemConfigurationService.getAllItems(), function (item) {
                    item.shipToQuantity = [];
                });
                itemTabService.setCurrentItemCosting(currentItemIndex, true);
                quoteModelService.setItems();
                if (createQuote)
                    $rootScope.startSpinner();
                errorArray = [];
                var quoteData = JSON.parse(JSON.stringify(quoteModelService.getQuoteModel()));
                if (quoteData.items) {
                    _.filter(quoteData.items, function (item) {
                        if (item.itemVariationCosts)
                            delete item.itemVariationCosts;
                        if (item.validationResponse)
                            delete item.validationResponse;
                    });
                }
                defaultApiService.createObjectCall('Quotes/SaveQuote', quoteData)
                    .success(function (data) {

                        //if a user has not routed to another page after making this call then dump the response
                        if (!quoteModelService.getQuoteInterrupted()) {
                            quoteModelService.setQuoteId(data.quoteId);
                            itemSummaryService.setSummaryData(data);
                            $rootScope.$broadcast('valueChanged', data);
                            if (bindCostData)
                                bindCost(data, createQuote);
                            itemTabService.setCurrentItemCosting(currentItemIndex, false);
                        } else
                            quoteModelService.setQuoteInterrupted(false);
                    })
            };

            // Will make a api call to calculate cost
            scope.createQuote = function (createQuote, bindCostData) {
                if (scope.readOnly) {
                    var summaryViewResponse = quoteModelService.getQuoteModel();
                    itemSummaryService.setSummaryData(summaryViewResponse);
                    itemSummaryService.initItemIndex();
                    executeStepTwo();
                    $rootScope.$broadcast('valueChanged', summaryViewResponse);
                } else {
                    if (bindCostData && scope.getCostingStatus()) {
                        scope.costingInProgress = true;
                    } else {
                        scope.calculateCost(createQuote, bindCostData);
                    }
                }
            };

            function executePickupLogic(createQuote, cost, bindCostData) {
                var isDeliveryTabsValidated = itemConfigurationService.isDeliveryValidated();
                if (scope.item.customerSelectedStoreId) {
                    if (isDeliveryTabsValidated && validItemComponents()) {
                        scope.noPickupSelected = false;
                        scope.item.shipToQuantity = [];
                        scope.createQuote(createQuote, bindCostData)
                    } else {
                        if (cost)
                            scope.calculateCost(false, false);
                        itemTabService.validateDeliveryTabs(itemConfigurationService.getAllItems());
                        scope.invalidDeliveryInfo = isDeliveryTabsValidated ? false : true;
                    }
                } else {
                    scope.noPickupSelected = true;
                }
            }

            function executeShippingLogic(createQuote, cost, bindCostData) {
                var isDeliveryTabsValidated = itemConfigurationService.isDeliveryValidated();

                if (!deliveryMethodService.isQuantityNumber() && !deliveryMethodService.isQuantityEmpty() && (scope.shipToRecipients.length == recipientInfoService.getRecipientInfo().length)) {
                    if (isDeliveryTabsValidated && validItemComponents()) {
                        if (scope.shipToRecipients.length == 1)
                            scope.item.shipToQuantity = [];
                        scope.createQuote(createQuote, bindCostData);
                    } else {
                        if (cost)
                            scope.calculateCost(false, false);
                        itemTabService.validateDeliveryTabs(itemConfigurationService.getAllItems());
                        scope.invalidDeliveryInfo = isDeliveryTabsValidated ? false : true;
                    }
                } else {
                    if (cost)
                        scope.calculateCost(false, false);
                    if (deliveryMethodService.isQuantityNumber()) {
                        scope.notANumber = true;
                    } else if (deliveryMethodService.isQuantityEmpty()) {
                        scope.notANumber = true;
                    }
                    scope.canNotAddRecipient = true;
                }
            }

            function validItemComponents() {
                var itemValid = true;
                var componentValid = true;
                var allItems = itemConfigurationService.getAllItems();
                itemTabService.validateDeliveryTabs(allItems);
                _.forEach(allItems, function (item, index) {
                    if (!item.isItemInfoValidated) {
                        itemValid = false;
                        itemTabService.validateItemTabs(index);
                        // return false;
                    }

                    //Checks whether item has at least one Bind for Books/pads product type On Save and Continue
                    if ((item.productType == scope.productEnums.pads) || (item.productType == scope.productEnums.books) || (item.productType == scope.productEnums.multiFlatSheet)) {
                        var isItemBindValid = false;
                        _.forEach(item.itemComponents, function (comp, idx) {
                            if (item.productType == scope.productEnums.multiFlatSheet) {
                                if (comp.itemComponentType == scope.componentTypeEnums.standard) {
                                    isItemBindValid = true;
                                }
                            } else {
                                if (comp.bindId) {
                                    isItemBindValid = true;
                                }
                            }

                            if ((idx == item.itemComponents.length - 1) && (!isItemBindValid)) {
                                itemValid = false;
                                itemTabService.validateItemTabs(index);
                            }
                        })
                    }
                });

                _.forEach(allItems, function (item) {
                    _.forEach(item.itemComponents, function (component) {
                        if (!component.isComponentInfoValidated) {
                            componentValid = false;
                            return false;
                        }
                    });
                });
                if (itemValid && componentValid)
                    return true;
                else {
                    scope.invalidItemInfoInfo = true;
                    return false;
                }
            }

            scope.submitStepTwo = function (createQuote, cost, bindCostData) {
                scope.costingInProgress = false;
                scope.invalidItemInfoInfo = false;
                scope.canNotAddRecipient = false;
                quoteModelService.setMiscellaneousData({term: scope.quoteTerm});
                if (!scope.item.shippingMethodName) {
                    scope.makeSelection = true;
                } else {
                    var shippingMethodName = parseInt(scope.item.shippingMethodName);
                    switch (shippingMethodName) {
                        case 10:
                            executePickupLogic(createQuote, cost, bindCostData);
                            break;
                        case 20 :
                            executeShippingLogic(createQuote, cost, bindCostData);
                            break;
                    }
                }
            };

            scope.getCostingStatus = function () {
                scope.isStillCosting = false;
                _.forEach(itemTabService.getItemTabs(), function (tab) {
                    if (tab.isItemCosting) {
                        scope.isStillCosting = true;
                    }
                });
                return scope.isStillCosting
            };

            /**************************************
             *** Start of Component Code ***********
             **************************************/
            scope.changeBleed = function () {
                if (scope.component.bleedOffset !== 'custom') {
                    multiComponentService.setBleed(scope.component.bleedOffset);
                    multiComponentService.enableDisableValidation(false);
                } else {
                    multiComponentService.setBleed('');
                    multiComponentService.enableDisableValidation(true);
                }
            };

            scope.expandItem = function (index) {
                if (index === itemTabService.getCurrentTabIndex()) {
                    angular.element('#collapse' + index).toggleClass('in')
                }
            };

            scope.resetBleed = function () {
                scope.component.bleedOffset = '';
                scope.changeBleed();
            };

            scope.reConfigureComponents = function () {
                componentTabService.initializeComponentTabs();
                componentTabService.addComponentTab();
                componentTabService.updateComponentTabs(0);
                multiComponentService.setCurrentComponent(0);
                scope.component = multiComponentService.getCurrentComponent();
                scope.componentTabs = componentTabService.getComponentTabs();
                scope.multiComponents = multiComponentService.getAllComponents();
            };

            /** End of Component Code ***/
        }
    }
});

/**
 * Created by $ingh on 3/1/2018.
 */

angular.module('app.quote').directive('variationType', function (guidService, variationService, multiComponentService, $rootScope, genericQuotesService, operationsService, $timeout, customIntentService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/variationType.html',

    link: function (scope) {
      scope.addVariationType = function () {
        scope.variationRows.push(
          {
            value: '',
            id: guidService.newGuid(),
            i: scope.variationRows.length - 1
          }
        );
      };

      scope.removeVariationType = function (id, type) {
        variationService.clearVariation(id, type);
        _.remove(scope.variationRows, function (row) {
          return row.id == id;
        })
      };

      scope.changeVariationType = function (index, variationType) {
        variationService.clearAllVariations(scope.variationRows[index].id);
        var vType = variationType ? variationType : this.variationType;
        switch (vType) {
          case 'NumberOfSides':
            scope.variationRows[index].value = 'NumberOfSides';
            angular.element('#cboVariationNumberOfSides' + index).val('0');
            var validation = angular.element('[name="variationFields[]"]');
            angular.element('#stepTwoForm').formValidation('addField', validation);
            break;
          case 'Color':
            scope.variationRows[index].value = 'Color';
            scope.setColorVariation(index, scope.variationRows[index].id);
            break;
          case 'Bleed':
            var bleedValidation = angular.element('[name="variationFields[]"]');
            var customBleedValidation = angular.element('[name="cboVariationBleed[]"]');
            angular.element('#stepTwoForm').formValidation('addField', bleedValidation);
            angular.element('#stepTwoForm').formValidation('addField', customBleedValidation);
            scope.variationRows[index].value = 'Bleed';
            break;
          case 'Material':
          case 'Substrate':
            scope.setMaterialVariation(index, scope.variationRows[index].id);
            scope.variationRows[index].value = 'Material';
            // var materialValidation = angular.element('[name="cboVariationMaterial"]');
            // angular.element('#stepTwoForm').formValidation('addField', materialValidation);
            break;
          case 'Binding':
            scope.variationRows[index].value = 'Binding';
            scope.setPrimaryBindVariation(index, scope.variationRows[index].id);
            break;
          case 'Finishing':
            scope.variationRows[index].value = 'Finishing';
            scope.setFinishingVariation(index, scope.variationRows[index].id);
            break;
          default:
            scope.variationRows[index].value = '';
        }
      };

      // scope.changeMaterialVariation = function (id,matId) {
      //   variationService.clearVariation(id,'Material');
      //   var matId = matId?matId:this.materialId;
      //   variationService.setMaterialVariation(id,matId)
      // };

      scope.changeSidesVariation = function (id, sideId) {
        variationService.clearVariation(id, 'NumberOfSides');
        var side = sideId ? sideId : this.side;
        variationService.setSidesVariation(id, side)
      };

      scope.changeBleedVariation = function (id, index) {
        // variationService.clearVariation(id,'Bleed');
        if (!this.hasBleeds) {
          this.bleedOffset = '';
          this.bleedBottom = '';
          this.bleedLeft = '';
          this.bleedRight = '';
          this.bleedTop = '';
        }
        var newObj = Object.assign({}, this);
        newObj.bleedOffset = angular.element('#cboVariationBleedOffset' + index).val();
        newObj.bleedTop = angular.element('#cboVariationBleedTop' + index).val();
        newObj.bleedRight = angular.element('#cboVariationBleedRight' + index).val();
        newObj.bleedBottom = angular.element('#cboVariationBleedBottom' + index).val();
        newObj.bleedLeft = angular.element('#cboVariationBleedLeft' + index).val();
        variationService.setBleedVariation(id, newObj)
      };

      scope.changeBleedOffsetVariation = function (id, index) {
        angular.element('#stepTwoForm').formValidation('enableFieldValidators', 'cboVariationBleed[]', false);
        if (this.bleedOffset == 'custom') {
          angular.element('#stepTwoForm').formValidation('enableFieldValidators', 'cboVariationBleed[]', true);
        } else {
          angular.element('.customFields' + index).addClass('ng-hide')
        }
        this.bleedBottom = '';
        this.bleedLeft = '';
        this.bleedRight = '';
        this.bleedTop = '';
        variationService.setBleedVariation(id, this);
      };

      scope.setColorVariation = function (index, id) {
        variationService.clearVariation(id, 'Color');
        variationService.initializeVariationColor(id);
        multiComponentService.setColorButton('variationFrontBlack' + index, 'variationFrontColor' + index);
        multiComponentService.setColorButton('variationBackBlack' + index, 'variationBackColor' + index);
      };

      scope.changeVariationColor = function (color1, color2, id, currentColor) {
        multiComponentService.setColorButton(color1, color2);
        variationService.setVariationColor(id, currentColor)
      };

      scope.setPrimaryBindVariation = function (index, rowId) {
        variationService.clearVariation(rowId, 'Binding');
        var bindingObject = multiComponentService.setOperationsData(scope.primaryBinds);
        var variationPrimaryBind = angular.element('#cboVariationPrimaryBind' + index).selectize({
          options: bindingObject.allOperation,
          optgroups: bindingObject.optGroupArray,
          optgroupField: 'class',
          labelField: 'name',
          searchField: ['name'],
          placeholder: $rootScope.getWord('NoBind'),
          onChange: function (value) {
            variationService.setPrimaryBindVariation(rowId, value);
          }
        });
      };

      scope.setMaterialVariation = function (index, rowId) {
        variationService.clearVariation(rowId, 'Material');
        var variationMaterial = angular.element('#cboVariationMaterial' + index).selectize({
          options: scope.materials,
          valueField: 'id',
          labelField: 'name',
          searchField: ['name'],
          placeholder: $rootScope.getWord('Select'),
          onChange: function (value) {
            variationService.setMaterialVariation(rowId, value);
          }
        });
      };

      scope.setFinishingVariation = function (index, rowId, clearVariation) {
        var isRemoveFunction = false;
        if (!clearVariation)
          variationService.clearVariation(rowId, 'Finishing');
        var variationFinishingObject = multiComponentService.setOperationsData(scope.finishingOptions);
        var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize({
          options: variationFinishingObject.allOperation,
          optgroups: variationFinishingObject.optGroupArray,
          optgroupField: 'class',
          labelField: 'name',
          searchField: ['name'],
          plugins: ['remove_button'],
          hideSelected: false,
          persist: false,
          duplicates: true,
          placeholder: $rootScope.getWord('NoFinish'),
          onChange: function (value) {
            var tempRemoveFunction = isRemoveFunction;
            var recentChange = value[value.length - 1];
            var count = 0;
            _.forEach(value, function (option) {
              if (option == recentChange) {
                count += 1;
              }
            });
            if (!isRemoveFunction && variationService.getLegitVariationAddAction()) {

              if (recentChange === "00000000-0000-0000-0000-000000000000" && !isRemoveFunction) {
                isRemoveFunction = false;

                /**if there are two customAdHoc tags we need to manually remove it
                 Count is number of custom adHoc tags
                 **/
                if (count > 1) {
                  isRemoveFunction = true;
                  variationFinishingOption[0].selectize.removeItem(recentChange, true);
                }
                variationService.setVariationAdHocProperties(rowId, true, index);
                angular.element('#adHocCustomServiceModal').modal('show');
              } else if (operationsService.askOperation(recentChange, scope.finishingOptions) && !isRemoveFunction) {
                if (count > 1) {
                  operationsService.setValidAskOperation(false);
                  isRemoveFunction = false;
                  variationFinishingOption[0].selectize.removeItem(recentChange, true);
                } else if (operationsService.getValidAskOperation()) {
                  isRemoveFunction = false;
                  operationsService.setAskFinishingId(recentChange);
                  variationService.setVariationAskProperties(rowId, true, index);
                  angular.element('#askOperationModal').modal('show');
                } else {
                  operationsService.setValidAskOperation(true);
                }
              } else if (count > 1 && recentChange != "00000000-0000-0000-0000-000000000000" && !isRemoveFunction) {
                isRemoveFunction = true;
                variationFinishingOption[0].selectize.removeItem(recentChange, true);
              } else {
                variationService.setFinishingOptionVariation(rowId, recentChange);
                isRemoveFunction = false;
              }
            } else {
              isRemoveFunction = false;
            }
            var isCusomIntent = customIntentService.customInentOperation(recentChange, scope.finishingOptions, 'variant', index, rowId);
            if (isCusomIntent && !tempRemoveFunction && variationService.getLegitVariationAddAction()) {
              // angular.element('#customIntentModal').modal('show');
                variationService.setDescriptionForFinishingOptionVariations(recentChange, '', customIntentService.getFinishingOptionName(), index, rowId);
            }
          },
          onDelete: function (value) {
            isRemoveFunction = true;
            /**
             * If user remove the adHoc tag then we are removing all the tags on the right and
             * removing all custom adHocs
             **/
            if (value == '00000000-0000-0000-0000-000000000000') {
              variationService.removeAdHocVariation(rowId);
            } else {
              variationService.removeVariationFinishingOption(rowId, value)
            }
            $rootScope.$apply();
          }
        });
      };

      /**
       * return addHoc tags for particular row
       **/
      scope.setAdHockTags = function (index, rowId) {
        return variationService.setAdHockTags(rowId, scope.finishingOptions);
      };
      /**
       * SetUp all the adhoc tags for all finishing options
       **/
      scope.getAdHocTags = function (rowId, adHocName) {
        variationService.getAdHocTags(rowId, adHocName)
      };
      /**
       * Remove adHoc variation adHoc tags
       **/
      scope.closeVariationTags = function (tagName, rowId, index, finishingId) {
        variationService.closeVariationTags(tagName, rowId, index, finishingId)
      };

      /**
       * Edit adHoc variation adHoc tags
       **/
      scope.editVariationTags = function (tagName, rowId, index, finishingId, description) {
        scope.selectedCustomName = tagName;
        scope.variationSelectedRowId = rowId;
        if(tagName) {
            angular.element('#editVariationAdHocCustomServiceModal').on('shown.bs.modal', function (e) {
                scope.adHocService = {};
                $timeout(function () {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
                        if (variation.id == rowId) {
                            _.forEach(variation.finishingOptions, function (adhoc) {
                                if (adhoc.adHocOperation && (adhoc.finishingId == '00000000-0000-0000-0000-000000000000') && (adhoc.adHocOperation.customServiceName == scope.selectedCustomName)) {
                                    scope.adHocService.customServiceName = adhoc.adHocOperation.customServiceName;
                                    if (adhoc.adHocOperation.adHocMachineCost) {
                                        scope.adHocService.costType = 'adHocMachineCost';
                                        scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocMachineCost.markAsBuyOut;
                                        scope.adHocService.quantityBy = adhoc.adHocOperation.adHocMachineCost.quantityBy;
                                        scope.adHocService.quantity = adhoc.adHocOperation.adHocMachineCost.quantity ? adhoc.adHocOperation.adHocMachineCost.quantity : '';
                                        scope.adHocService.speed = adhoc.adHocOperation.adHocMachineCost.speed ? adhoc.adHocOperation.adHocMachineCost.speed : '';
                                        scope.adHocService.hourlyCost = adhoc.adHocOperation.adHocMachineCost.hourlyCost ? adhoc.adHocOperation.adHocMachineCost.hourlyCost : '';
                                    } else if (adhoc.adHocOperation.adHocMaterialCost) {
                                        scope.adHocService.costType = 'adHocMaterialCost';
                                        scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocMaterialCost.markAsBuyOut;
                                        scope.adHocService.quantityBy = adhoc.adHocOperation.adHocMaterialCost.quantityBy;
                                        scope.adHocService.quantity = adhoc.adHocOperation.adHocMaterialCost.quantity ? adhoc.adHocOperation.adHocMaterialCost.quantity : '';
                                        scope.adHocService.unitCost = adhoc.adHocOperation.adHocMaterialCost.unitCost ? adhoc.adHocOperation.adHocMaterialCost.unitCost : '';
                                    } else {
                                        scope.adHocService.costType = 'adHocLaborCost';
                                        scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocLaborCost.markAsBuyOut;
                                        scope.adHocService.quantityBy = adhoc.adHocOperation.adHocLaborCost.quantityBy;
                                        scope.adHocService.quantity = adhoc.adHocOperation.adHocLaborCost.quantity ? adhoc.adHocOperation.adHocLaborCost.quantity : '';
                                        scope.adHocService.speed = adhoc.adHocOperation.adHocLaborCost.speed ? adhoc.adHocOperation.adHocLaborCost.speed : '';
                                        scope.adHocService.hourlyCost = adhoc.adHocOperation.adHocLaborCost.hourlyCost ? adhoc.adHocOperation.adHocLaborCost.hourlyCost : '';
                                    }
                                    scope.$apply();
                                }
                            });
                        }
                    })
                });
            });
            angular.element("#editVariationAdHocCustomServiceModal").modal('show');
        } else if(finishingId) {
           _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
             if (variation.id == rowId) {
                _.forEach(variation.finishingOptions, function (adhoc) {
                   customIntentService.customInentOperation(adhoc.finishingId, variation.finishingOptions, 'variant', index, rowId, description);
                });
             }
           });
           angular.element("#customIntentModal").modal('show');
        }

      };


      /**
       * Logic used to render back the variations on switching items or step of wizard
       **/
      var color = {
        c: true,
        m: true,
        y: true,
        k: true,
        spotColors: []
      };
      scope.initializeVariation = function (flag) {
        variationService.getAllVariations();
        if (!genericQuotesService.getInitializeStuff() || flag) {
          genericQuotesService.initializeStuff(true);
          variationService.setVariationRows([]);
          scope.variationRows = variationService.getVariationRows();
          var count = 0;

          /**
           * Render Material Variations
           **/
          _.forEach(multiComponentService.getCurrentComponent().materialVariations, function (matVariation) {
            scope.variationRows.push({
              value: 'Material',
              id: matVariation.id
            });
            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.changeVariationType(count, 'Material');
              variationService.renderMaterialVariations(count, matVariation.material);
              angular.element('#variationOption' + count).val('Material');
              count++;
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
            }, 200)
          });

          /**
           * Render Sides Variations
           **/
          _.forEach(multiComponentService.getCurrentComponent().sidesVariations, function (sideVariation) {
            scope.variationRows.push({
              value: 'NumberOfSides',
              id: sideVariation.id
            });
            var sideId = sideVariation.side;
            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.changeVariationType(count, 'NumberOfSides');
              scope.changeSidesVariation(sideVariation.id, sideId);
              angular.element('#variationOption' + count).val('NumberOfSides');
              angular.element('#cboVariationNumberOfSides' + count).val(sideId);
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
              count++
            }, 200);
          });

          /**
           * Render Bleed Variations
           **/
          _.forEach(multiComponentService.getCurrentComponent().bleedVariations, function (bleedVariation) {
            scope.variationRows.push({
              value: 'Bleed',
              id: bleedVariation.id
            });
            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.changeVariationType(count, 'Bleed');
              variationService.isCustomBleed(bleedVariation.bleed, count);
              variationService.setBleedVariation(bleedVariation.id, bleedVariation.bleed);
              angular.element('#variationOption' + count).val('Bleed');
              count++;
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
            }, 200)
          });

          /**
           * Render Color Variations
           **/
          _.forEach(multiComponentService.getCurrentComponent().colorVariations, function (colorVariation) {
            scope.variationRows.push({
              value: 'Color',
              id: colorVariation.id
            });
            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.changeVariationType(count, 'Color');
              if (JSON.stringify(colorVariation.frontColor) === JSON.stringify(color)) {
                multiComponentService.setColorButton('variationFrontColor' + count, 'variationFrontBlack' + count);
                variationService.setVariationColor(colorVariation.id, 'frontColor')
              } else {
                multiComponentService.setColorButton('variationFrontBlack' + count, 'variationFrontColor' + count);
                variationService.setVariationColor(colorVariation.id, 'frontBlack')
              }
              if (JSON.stringify(colorVariation.backColor) === JSON.stringify(color)) {
                multiComponentService.setColorButton('variationBackColor' + count, 'variationBackBlack' + count);
                variationService.setVariationColor(colorVariation.id, 'backColor')
              } else {
                multiComponentService.setColorButton('variationBackBlack' + count, 'variationBackColor' + count);
                variationService.setVariationColor(colorVariation.id, 'backBlack')
              }

              angular.element('#variationOption' + count).val('Color');
              count++;
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
            }, 200)
          });

          /**
           * Render Finishing Variations
           **/
          variationService.clearAdhocTags();
          variationService.clearDescriptionTags();
          _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (finishVariation) {
            scope.variationRows.push({
              value: 'Finishing',
              id: finishVariation.id
            });
            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.variationRows[count].value = 'Finishing';
              scope.setFinishingVariation(count, scope.variationRows[count].id, true);
              angular.element('#variationOption' + count).val('Finishing');
              variationService.renderFinishingVariations(count, finishVariation, scope.variationRows[count].id);
              count++;
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
            }, 200);

          });

          /**
           * Render Binding Variations
           **/
          _.forEach(multiComponentService.getCurrentComponent().bindVariations, function (bindVariation) {
            scope.variationRows.push({
              value: 'Binding',
              id: bindVariation.id
            });

            $rootScope.startSpinner();
            setTimeout(function () {
              $rootScope.stopSpinner();
              scope.changeVariationType(count, 'Binding');
              variationService.renderBindingVariations(count, bindVariation);
              angular.element('#variationOption' + count).val('Binding');
              count++;
              scope.variationRows = variationService.getVariationRows();
              scope.$apply();
            }, 200)
          });


        }
        if (scope.variationRows.length <= 0)
          variationService.initializeVariation();
        scope.variationRows = variationService.getVariationRows();

      };

      variationService.initializeVariation();
      scope.variationRows = variationService.getVariationRows();

      scope.isCustomBleed = function (rowId, value) {
        var isCustom = false;
        if (value == 'Bleed') {
          _.forEach(multiComponentService.getCurrentComponent().bleedVariations, function (bleedVariation) {
            if (bleedVariation.id == rowId && bleedVariation.bleed.bleedBottom) {
              if (bleedVariation.bleed.bleedBottom == bleedVariation.bleed.bleedLeft && (bleedVariation.bleed.bleedBottom == bleedVariation.bleed.bleedRight) && (bleedVariation.bleed.bleedBottom == bleedVariation.bleed.bleedTop)) {
                if (bleedVariation.bleed.bleedBottom != "0.0625" && bleedVariation.bleed.bleedBottom != "0.125" && bleedVariation.bleed.bleedBottom != "0.25") {
                  bleedVariation.bleed.bleedOffset = "custom";
                }
              } else {
                bleedVariation.bleed.bleedOffset = "custom";
              }
              if (value == 'Bleed' && bleedVariation.bleed.hasBleeds && bleedVariation.bleed.bleedOffset == 'custom') {
                isCustom = true;
                return false;
              } else {
                isCustom = false;
                return false;
              }
            } else {
              isCustom = false;
            }
          })
        }
        return isCustom;
      };
    }
  }
});

/**
 * Created by sreddy on 3/1/2018.
 */

angular.module('app.quote').directive('shippingMethod', function (itemConfigurationService, deliveryMethodService, recipientInfoService, quotesInfoService, $rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/shippingMethod.tpl.html',

    link: function (scope) {
      scope.disableEditBtn = true;
      scope.isCustomerExists = false;
      scope.recipientModalHeaderLabel = $rootScope.getWord('EditRecipient');
      scope.editRecipient = function (index) {
        scope.recipientModalHeaderLabel = $rootScope.getWord('EditRecipient');
        scope.recipientModalSubmitBtnLabel = $rootScope.getWord('SaveRecipient');
        var customerId = quotesInfoService.getStepOneData().customerId || quotesInfoService.getCustomerInfoData().id;
        deliveryMethodService.checkCustomerExists(customerId)
          .then(function (result) {
            scope.isCustomerExists = result.data;
            deliveryMethodService.currentDropdownIndex(index);
            angular.element('#recipientModal').modal('show');
          })
      };

      scope.$on('isCustomerExists', function (data, flag) {
        scope.isCustomerExists = flag;
      });


      scope.resetModalValidations = function () {
        scope.recipient = {};
        angular.element('#recipientModal').removeClass('fade');
        angular.element('#recipientModal').formValidation('resetForm', true);
      };

      var enableApply = true;
      angular.element('#recipientModal').on('shown.bs.modal', function (e) {
        var temp = Object.assign({}, deliveryMethodService.getRecipient());
        scope.recipient = temp;
        if (enableApply) {
          scope.$apply();
          enableApply = false;
        }
      });

      deliveryMethodService.initializeShipToRecipients(itemConfigurationService.getCurrentItem().quantity);
      scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
      scope.addAnother = function () {
        if (!deliveryMethodService.isQuantityNumber() && (scope.shipToRecipients.length == recipientInfoService.getRecipientInfo().length)) {
          scope.canNotAddRecipient = false;
          deliveryMethodService.incrementDropdownIndex();
          if (scope.shipToRecipients.length == 1) {
            scope.shipToRecipients[0].quantity = ''
          }
          scope.shipToRecipients.push({
            quantity: ''
          });
          itemConfigurationService.addShipToQuantity();
          deliveryMethodService.setShipToRecipients(scope.shipToRecipients);
          var index = scope.shipToRecipients.length - 2;
          angular.element('#inputField' + index).attr('disabled', 'disabled');
        }
        else {
          if (deliveryMethodService.isQuantityNumber()) {
            scope.notANumber = true;
          }
          else if (deliveryMethodService.isQuantityEmpty()) {
            scope.invalidQuantity = false;
          }
          scope.canNotAddRecipient = true;
        }
        scope.allocatedQuantity = deliveryMethodService.setAllocatedQuantity();
      };

      scope.removeItem = function (index) {
        _.forEach(scope.shipToRecipients, function (recipient, i) {
          if (i > index) {
            var tempIndex = i - 1;
            angular.element('#inputField' + i).attr('id', 'inputField' + tempIndex);
            angular.element('#performAddActionId' + i).attr('id', 'performAddActionId' + tempIndex);
          }
        });
        scope.canNotAddRecipient = false;
        scope.shipToRecipients.splice(index, 1);
        itemConfigurationService.removeShipToQuantity(index);
        deliveryMethodService.setShipToRecipients(scope.shipToRecipients);
        scope.recipientQuantity();
        deliveryMethodService.decrementDropdownIndex();
        recipientInfoService.removeRecipientInfo(index, scope.item.id);
        var tempIndex = scope.shipToRecipients.length - 1;
        angular.element('#inputField' + tempIndex).removeAttr('disabled');
      };

      scope.allocatedQuantity = deliveryMethodService.setAllocatedQuantity();
      scope.recipientQuantity = function (quan, index) {
        scope.canNotAddRecipient = false;
        itemConfigurationService.setShipToQuantity(quan, index);
        if (deliveryMethodService.isQuantityNumber()) {
          scope.notANumber = true;
        }
        else {
          scope.notANumber = false;
        }
        scope.allocatedQuantity = deliveryMethodService.setAllocatedQuantity();
        if (scope.allocatedQuantity > scope.item.quantity) {
          scope.invalidQuantity = true;
        }
        else {
          scope.invalidQuantity = false;
        }
      };

      //To set the deliveryMethod dropdown to have values like
      // Standard, expedite etc
      scope.changeDeliveryMethod = function (serviceLevelCode) {
        var serviceLevelObj = {};
        _.forEach(scope.serviceLevels, function (serviceLevel, index) {
          if (serviceLevel.code === serviceLevelCode) {
            serviceLevelObj.code = serviceLevel.code;
            serviceLevelObj.responseCode = serviceLevel.responseCode;
            serviceLevelObj.shipper = serviceLevel.shipper;
            scope.serviceLevel = serviceLevel.code;
            scope.shipper = serviceLevel.shipper;
            scope.responseCode = serviceLevel.responseCode;
            recipientInfoService.setServiceLevel(scope.item.id, serviceLevelObj)
          }
        })
      };

      scope.handleRecipients = function () {
        scope.notANumber = false;
        scope.invalidQuantity = false;
        scope.canNotAddRecipient = false;
        recipientInfoService.initializeRecipientInfo();
        recipientInfoService.setRecipientInfo(scope.item.id);
        scope.serviceLevel = recipientInfoService.getRecipientInfo().length ? recipientInfoService.getRecipientInfo()[0].serviceLevel : scope.serviceLevels[0].code;
        scope.changeDeliveryMethod(scope.serviceLevel);
        scope.shipper = recipientInfoService.getRecipientInfo().length ? recipientInfoService.getRecipientInfo()[0].carrier : scope.serviceLevels[0].shipper;
        scope.responseCode = recipientInfoService.getRecipientInfo().length ? recipientInfoService.getRecipientInfo()[0].responseCode : scope.serviceLevels[0].responseCode;
        deliveryMethodService.setDropdownIndex(0);
        deliveryMethodService.setShipToRecipients([]);
        scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
        if (!scope.item.shipToQuantity)
          scope.item.shipToQuantity = [];
        _.forEach(scope.item.shipToQuantity, function (quan, index) {
          scope.shipToRecipients.push(
            {
              quantity: quan.quantity
            }
          )
        });
        if (scope.item.shipToQuantity && scope.item.shipToQuantity.length < 1) {
          deliveryMethodService.initializeShipToRecipients();
        }
        scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
        deliveryMethodService.setShipToRecipients(scope.shipToRecipients);

        setTimeout(function () {
          angular.element(".recipientInputField").each(function (i) {
            angular.element(this).attr('id', 'inputField' + i);
          });
          var recipientInfoLength = recipientInfoService.getRecipientInfo().length;
          var rowLength = deliveryMethodService.getShipToRecipients().length;
          _.forEach(recipientInfoService.getRecipientInfo(), function (recipient, index) {
            deliveryMethodService.currentDropdownIndex(index);
            scope.$broadcast('addRecipient', recipient);
            if (index != (rowLength - 1)) {
              // itemConfigurationService.setShipToQuantityId(recipient.id,index);
              angular.element('#inputField' + index).attr('disabled', 'disabled');
              angular.element('#primaryDeliveryButton' + index).removeAttr('disabled', 'disabled');
              angular.element('#primaryDeliveryButton' + index).removeClass('disabled');
            }
          });

          if (recipientInfoLength != rowLength) {
            angular.element('#primaryDeliveryButton' + (rowLength - 1)).addClass('disabled');
            angular.element('#toggleDeliveryAction' + (rowLength - 1)).addClass('disabled');
          }

        }, 200);
        scope.allocatedQuantity = deliveryMethodService.setAllocatedQuantity();

      };
      if (itemConfigurationService.getAllItems().length >= 1) {
        scope.handleRecipients();
      }
    }
  }
});

/**
 * Created by sreddy on 3/1/2018.
 */

angular.module('app.quote').directive('pickupMethod', function (formValidationKeyService, $rootScope, deliveryMethodService, formattedPhoneService) {
  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/quote/partials/stepTwo/pickupMethod.tpl.html',

    link: function (scope, form) {

      function getSelectedStore() {
        var selectedStore = '';
        _.forEach(scope.availableStores, function (store) {
          if (scope.item.customerSelectedStoreId == store.externalCode)
            selectedStore = store.name;
        });
        return selectedStore;
      }

      //Search By Store Number and City Functionality
      scope.availableStores = deliveryMethodService.getStores();
      scope.selectedStore = scope.item.customerSelectedStoreId ? getSelectedStore() : '';

      //Set the Selected Store to Service
      angular.forEach(scope.availableStores, function (selectedStore, idx) {
        if (selectedStore.externalCode === scope.item.customerSelectedStoreId) {
          deliveryMethodService.setPickupObject(selectedStore);
        }
      });

      var matchIndex = '';
      scope.searchByString = function (searchString) {
        scope.searchedData = deliveryMethodService.getAvailableStores(scope.availableStores, searchString);

        //Pickup Cards Align Logic
        setTimeout(function () {
          angular.element('#pickupPanel').find('.card-row-wrap').removeClass('row card-row-wrap');
          if (!angular.element('#pickupPanel').find('.card-row-wrap').hasClass('row')) {
            var pickupCards = angular.element('#pickupPanel').find('.pick-card-wrap');
            for (var i = 0; i < angular.element('#pickupPanel').find('.pick-card-wrap').length; i += 2) {
              pickupCards.slice(i, i + 2).wrapAll("<div class='row card-row-wrap'></div>");
            }
          }
        }, 100);


        _.filter(scope.searchedData, function (storeDetails) {
          if (storeDetails.phone1Number && storeDetails.countryCode) {
            var formattedPhoneNum = formattedPhoneService.formatPhoneNo(storeDetails.phone1Number, storeDetails.countryCode, 'txtPickupPhone');
            storeDetails.phone1Number = formattedPhoneNum.phoneNumber;
            storeDetails.phone1CountryCode = formattedPhoneNum.countryCode;
          }
        });

        //Retrieving Selected pickup Card CSS
        if (scope.searchedData && scope.item.customerSelectedStoreId) {
          matchIndex = _.findIndex(scope.searchedData, function (value) {
            return value.externalCode === scope.item.customerSelectedStoreId
          });

          if (matchIndex === 0 || matchIndex > 0) {
            scope.resetSelectBtn();
            setTimeout(function () {
              angular.element('#selectButton' + matchIndex).find('.btn').removeClass('btn-default').addClass('btn-success');
              angular.element('#selectButton' + matchIndex).find('.btn-success').html('Selected');
              angular.element('#selectButton' + matchIndex).find('.btn-success').closest('.ibox').css('border', '1px solid #0288d1');
            }, 200)
          }
          else {
            scope.resetSelectBtn();
          }
        }
      };

      //Toggle Functionality for Select Button
      scope.resetSelectBtn = function () {
        angular.element('.selectButton').removeClass('btn-success').addClass('btn-default');
        angular.element('.selectButton').html('Select');
        angular.element('.selectButton').closest('.ibox').css('border', '1px solid #e5e6e7');
      };

      function setDelivery(storeId) {
        _.forEach(scope.multiItems, function (item) {
          item.customerSelectedStoreId = storeId
        })
      }

      scope.selectStore = function (index) {
        selectToggleBtn(index);
        scope.noPickupSelected = false;
        //TODO: JSS Check this logic and bind the data as per quote model
        var getPickup = deliveryMethodService.getPickupObject();
        if (getPickup && (getPickup.id == scope.searchedData[index].id && getPickup.externalCode == scope.searchedData[index].externalCode) && scope.item.customerSelectedStoreId) {
          scope.selectedStore = '';
          scope.item.customerSelectedStoreId = '';
          setDelivery('');
          deliveryMethodService.setPickupObject({})
        } else {
          deliveryMethodService.setPickupObject(scope.searchedData[index]);
          scope.item.customerSelectedStoreId = scope.searchedData[index].externalCode;
          setDelivery(scope.searchedData[index].externalCode);
          scope.selectedStore = (scope.selectedStore && scope.selectedStore == scope.searchedData[index].name) ? '' : scope.searchedData[index].name;
        }
      };

      function selectToggleBtn(index) {
        if (angular.element('#selectButton' + index).find('.selectButton').hasClass('btn-success')) {
          scope.resetSelectBtn();
        }
        else {
          scope.resetSelectBtn();
          deliveryMethodService.enableSelectedStore(index);
        }
      }

      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          searchByStore: {
            validators: {
              notEmpty: {}
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitStepTwo(true, false, true);
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        // $(e.target)    --> The field element
        // data.fv        --> The FormValidation instance
        // data.field     --> The field name
        // data.element   --> The field element
        // data.validator --> The current validator name

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());

      // Populate Pick up Card when Selected Store is there
      scope.populatePickUpCard(scope.selectedStore);
    }
  }
});

/**
 * Created by Singh on 2/5/2017.
 * Filename: src/app/quote/directives/stepTwo/multiComponent.js
 */
angular.module('app.quote').directive('multiItems', function ($rootScope, itemTabService, itemConfigurationService, multiComponentService, componentTabService, deliveryMethodService, recipientInfoService, genericQuotesService, operationsService, quoteModelService) {
    return {
      restrict: 'EA',
      replace: false,
      link: function (scope) {

        scope.handleItemComponents = function (index) {
          multiComponentService.initializeMultiComponent();
          var itemComponents = scope.multiItems[index].itemComponents;
          itemComponents = _.map(itemComponents);
          multiComponentService.setAllComponents(itemComponents);
          scope.multiComponents = multiComponentService.getAllComponents();
          componentTabService.removeAllComponentTabs();
          scope.reDrawComponentTabs();
          componentTabService.setCurrentComponentTabIndex(0);
          componentTabService.updateComponentTabs(0);
          multiComponentService.setCurrentComponent(0);
          scope.component = scope.multiComponents[0];
          if (scope.component.itemComponentType == scope.componentTypeEnums.tab) {
            scope.changeColor('tabComponent', 'standardComponent', 'tab', true);
          } else {
            scope.changeColor('standardComponent', 'tabComponent', 'standard', true)
          }
        };

        scope.setCurrentStore = function () {
          scope.selectedStore = '';
          _.forEach(scope.multiItems, function (item) {
            if (item.customerSelectedStoreId) {
              _.forEach(deliveryMethodService.getStores(), function (store) {
                if (item.customerSelectedStoreId == store.externalCode)
                  scope.selectedStore = store.name;
              })
            }
          });
          if (scope.item.shippingMethodName == '10' && scope.item.customerSelectedStoreId) {
            _.forEach(deliveryMethodService.getStores(), function (store) {
              if (scope.item.customerSelectedStoreId == store.externalCode)
                scope.selectedStore = store.name;
            })
          }
        };

        function setItemFlags() {
          scope.showFields = false;
          scope.invalidDeliveryInfo = false;
          scope.invalidItemInfoInfo = false;
          scope.item.isDeliveryInfoValid = scope.validateDelivery();
          itemConfigurationService.setByPassValidation(false);
          itemConfigurationService.removeQuantityVariations();
        }

        /** ///////////////////////////////////// **/
        /** Action on switching Item tab          **/
        /** ///////////////////////////////////// **/
        scope.tabClick = function (index, cost) {
          scope.validateTabCount();
          angular.element('#stepTwoForm').formValidation('revalidateField', 'option[]', true);
          //When delete an Item we can byPAss the validation check
          if (itemTabService.validItem(index) || itemConfigurationService.getByPassValidation()) {
            //To check if current item is not validated including deliveryMethod
            //Then the costing call will not happen while moving to another item
            if (cost) {
              scope.submitStepTwo(false, true, false);
              scope.makeSelection = false;
            }
            // Checks whether previous item has at least one Bind for Books/Pads product type to continue
            multiComponentService.initializePreviousValue();
            if ((scope.isByPassEnabled && scope.isByPassEnabled === 'enable') || (scope.isStandardExist && scope.isStandardExist === 'enable')) {
              scope.closeAlert();
            } else if ((scope.isByPassEnabled && scope.isByPassEnabled === 'disable') || (scope.isStandardExist && scope.isStandardExist === 'disable')) {
              var errorMessage = (scope.isByPassEnabled === 'disable') ? $rootScope.getWord('AtLeastOneBindRequired') : $rootScope.getWord('AtLeastOneStandardRequired');
              scope.errorBadgeFn([{
                itemName: scope.item.itemName,
                message: errorMessage
              }]);
              window.scrollTo(0, 0);
              return;
            }
            setItemFlags();
            scope.goToConfiguration(index);
            multiComponentService.setDefaultValidAsk(false);
            var allMultiComponents = multiComponentService.getAllComponents();
            itemConfigurationService.saveCurrentItem(allMultiComponents);
            itemConfigurationService.setCurrentItemIndex(index);
            scope.item = scope.multiItems[index];
            itemConfigurationService.setCurrentItem(scope.item);
            itemTabService.updateItemTabs(index);
            scope.handleItemComponents(index);
            itemConfigurationService.resetSelectize('cboProductTypeName', scope.productselectize);
            itemConfigurationService.setBoolOperations(true);
            //To render variations per item
            genericQuotesService.initializeStuff(false);
            itemConfigurationService.setSelectizeValue('cboProductTypeName');
            scope.addQuantityVariations();
            multiComponentService.setCurrentComponent(0);
            angular.element('#stepTwoForm').data('formValidation').resetForm();
            multiComponentService.setActionLegit(false);
            operationsService.setValidAskOperation(false);
            //Clearing out the list of searched stores on pickup tab
            scope.searchedData = [];
            scope.pickUpSearchText = '';
            //to set the delivery shipping/pickup tab
            scope.handleRecipients();
            scope.serviceLevel = scope.serviceLevel ? scope.serviceLevel : scope.serviceLevels[0].code;
            scope.setCurrentStore();
            //To set the bleed of a component if the user is directly landing on an item
            _.forEach(scope.item.itemComponents, function (comp) {
              scope.setBleeds(comp);
            });

            //Validating Tabs
            scope.item.isItemInfoValidated = true;
            itemTabService.removeItemValidationAlert();
          }
        };

        function createItem() {
          scope.showFields = false;
          var newIndex = itemConfigurationService.getAllItems().length;
          itemTabService.addItemTab(newIndex);
          itemConfigurationService.addItem();
          scope.multiItems = itemConfigurationService.getAllItems();
          itemConfigurationService.setCurrentItem(scope.multiItems[newIndex]);
          scope.tabClick(newIndex, false);
          itemTabService.setItemName(itemConfigurationService.getCurrentItem().itemName);
          angular.element('#stepTwoForm').data('formValidation').resetForm();
          scope.makeSelection = false;
          genericQuotesService.initializeStuff(false);
        }

        function duplicateItem() {
          var cloneItemIndex = itemConfigurationService.getCurrentItemIndex();
          var newIndex = itemConfigurationService.getAllItems().length;
          itemTabService.addItemTab(newIndex);
          itemConfigurationService.addItem();
          var multiItems = itemConfigurationService.getAllItems();
          var prevItem = multiItems[cloneItemIndex];
          var currentItem = multiItems[newIndex];
          var tempObj = _.cloneDeep(prevItem);
          tempObj.id = currentItem.id;
          tempObj.itemNumber = currentItem.itemNumber;
          tempObj.files = [];
          multiItems[newIndex] = tempObj;
          itemConfigurationService.setAllItems(multiItems);
          itemConfigurationService.setCurrentItem(multiItems[newIndex]);
          recipientInfoService.duplicateRecipientInfo(prevItem.id, currentItem.id);
          scope.tabClick(newIndex, false);
          itemTabService.setItemName(itemConfigurationService.getCurrentItem().itemName);
          angular.element('#stepTwoForm').data('formValidation').resetForm();
          scope.makeSelection = false;
        }

        // User will have to wait for at least one item to cost
        // So that we can bind the quoteId and link it before second call
        // Rather thank creating two quotes
        function triggerNewItem(duplicate) {
          scope.calculateCost(false, false);
          if (duplicate)
            duplicateItem();
          else
            createItem();
        }

        scope.duplicateItem = function () {
          var shippingMethod = parseInt(scope.item.shippingMethodName);
          scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
          switch (shippingMethod) {
            //Pickup
            case 10:
              if (scope.item.customerSelectedStoreId) {
                triggerNewItem(true);
              } else {
                scope.noPickupSelected = true;
              }
              break;
            //Shipping
            case 20:
              if (!scope.notANumber && !scope.invalidQuantity && (scope.shipToRecipients.length == recipientInfoService.getRecipientInfo().length)) {
                triggerNewItem(true);
              } else {
                scope.canNotAddRecipient = true;
                scope.makeSelection = false;
              }
              break;
            default:
              scope.makeSelection = true;
          }
        };

        scope.createNewItem = function () {
          var shippingMethod = parseInt(scope.item.shippingMethodName);
          scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
          switch (shippingMethod) {
            //Pickup
            case 10:
              if (scope.item.customerSelectedStoreId) {
                triggerNewItem(false);
              } else {
                scope.noPickupSelected = true;
              }
              break;
            //Shipping
            case 20:
              if (!scope.notANumber && !scope.invalidQuantity && (scope.shipToRecipients.length == recipientInfoService.getRecipientInfo().length)) {
                triggerNewItem(false);
              } else {
                scope.canNotAddRecipient = true;
                scope.makeSelection = false;
              }
              break;
            default:
              scope.makeSelection = true;
          }
        };

        scope.reDrawTabs = function () {
          _.forEach(scope.multiItems, function (item, index) {
            itemTabService.addItemTab(index, item)
          });
          scope.itemTabs = itemTabService.getItemTabs();
        };

        scope.deleteItem = function () {
          scope.confirmText = $rootScope.getWord("DeleteItem");
          scope.deleteTitle = $rootScope.getWord("DeleteItem");
          scope.deleteMessage = $rootScope.getWord("DeleteItemMessage");
          scope.confirmDelete('', 'Item');
          angular.element('#deleteModal').modal('show');
        };
      }
    }
  }
);



/**
 * Created by Singh on 2/5/2017.
 * Filename: src/app/quote/directives/stepTwo/multiComponent.js
 */
angular.module('app.quote').directive('multiComponent', function (multiComponentService, componentTabService, itemConfigurationService, itemTabService, $rootScope, genericQuotesService, operationsService, recipientInfoService, deliveryMethodService, $timeout) {
  return {
    restrict: 'EA',
    replace: false,
    link: function (scope) {
      scope.editPress = false;
      scope.pressBtnName = 'Edit';
      scope.standardMaterials = [];
      scope.tabmaterials = [];
      scope.isTabEnabled = false;
      scope.isExceptionPageEnabled = false;
      multiComponentService.initializePreviousValue();
      if (multiComponentService.getAllComponents().length < 1) {
        multiComponentService.initializeMultiComponent();
      }
      scope.multiComponents = multiComponentService.getAllComponents();
      var sideTypeEnums = genericQuotesService.getSideTypeEnums();

      function setItem(index) {
        itemConfigurationService.setCurrentItemIndex(index);
        itemTabService.setCurrentTabIndex(index);
        itemTabService.removeAllTabs();
        scope.reDrawTabs();
        scope.item = scope.multiItems[index];
        multiComponentService.setAllComponents(scope.item.itemComponents);
        multiComponentService.setCurrentComponent(0);
        scope.tabClick(index);
        scope.component = multiComponentService.getCurrentComponent();
      }

      scope.deleteOnConfirm = function (index, type) {
        if (type == 'Component') {
          multiComponentService.setDefaultValidAsk(false);
          multiComponentService.removeComponent(index);
          componentTabService.removeAllComponentTabs();
          scope.reDrawComponentTabs();
          multiComponentService.updateComponentNumber(index);
          if (index === componentTabService.getCurrentComponentTabIndex()) {
            componentTabService.setCurrentComponentTabIndex(parseInt(index) - 1);
            multiComponentService.setCurrentComponent(parseInt(index) - 1);
          }
          else {
            componentTabService.setCurrentComponentTabIndex(multiComponentService.getCurrentComponentNumber() - 1);
            multiComponentService.setCurrentComponent(parseInt(multiComponentService.getCurrentComponentNumber()) - 1);
          }
          componentTabService.updateComponentTabs(multiComponentService.getCurrentComponentNumber() - 1);
          scope.component = multiComponentService.getCurrentComponent();
          genericQuotesService.initializeStuff(false);
          operationsService.setValidAskOperation(false);
          multiComponentService.setActionLegit(false);
          scope.initializeVariation();
          scope.setOperationFields();
          operationsService.setValidAskOperation(true);
          multiComponentService.setActionLegit(true);
          angular.element('#stepTwoForm').data('formValidation').resetForm();

          if (scope.component.itemComponentType === 1) {
            scope.changeColor('standardComponent', 'tabComponent', 'standard', true, 'exceptionComponent');
          } else if (scope.component.itemComponentType === 2) {
            scope.changeColor('tabComponent', 'standardComponent', 'tab', true, 'exceptionComponent');
          } else if (scope.component.itemComponentType === 3) {
            scope.changeColor('exceptionComponent', 'standardComponent', 'exception', true, 'tabComponent');
          }
          multiComponentService.setDefaultValidAsk(true);
        }
        //Delete Item
        else if (type == 'Item') {
          itemConfigurationService.setByPassValidation(true);
          itemConfigurationService.deleteItem();
          itemTabService.removeItemTab();
          recipientInfoService.removeRecipientInfo(deliveryMethodService.getShipToRecipients().length - 1, itemConfigurationService.getCurrentItem().id);
          var itemIndex = itemConfigurationService.getCurrentItemIndex();
          if (itemIndex == 0) {
            setItem(itemIndex)
          }
          else {
            setItem(itemIndex - 1)
          }
        }
      };

      scope.removeComponent = function (index) {
        scope.confirmText = $rootScope.getWord("DeleteComponent");
        scope.deleteTitle = $rootScope.getWord("DeleteComponent");
        scope.deleteMessage = $rootScope.getWord("DeleteCurrentComponent");
        scope.confirmDelete(index, 'Component');
      };

      // Disable the tab flag when standard component is selected
      scope.$on('isTabEnabled', function (val, flag) {
        scope.isTabEnabled = false;
      });

      // Set Tab Operation Fields
      scope.setTabOperationFields = function () {
        scope.setPrimaryBindDropdown();
        scope.setFinishingOptionDropdown();
        multiComponentService.setOperations();
        multiComponentService.buildAdHockTags();
        scope.finishingTags = multiComponentService.getAdHockTags();
        scope.descriptionTags = multiComponentService.getDescriptionTags();
      };


      var waitingInProgress = [];
      var inProgressFlag = false;
      // For color change(toggle buttons)
      scope.changeColor = function (color1, color2, componentType, setOperationsFlag, color3) {
        if (color1 === 'standardComponent' && (scope.isExceptionPageEnabled || scope.isTabEnabled)) {
          color2 = 'tabComponent';
          color3 = 'exceptionComponent';
        }

        if ((color1 === 'standardComponent' || color1 == 'tabComponent') && scope.tempComponentName) {
          scope.component.itemComponentName = scope.tempComponentName;
          scope.tempComponentName = undefined;
          scope.updateComponentTabName();
        }
        multiComponentService.setColorButton(color1, color2, color3);
        if (!componentType && !setOperationsFlag)
          multiComponentService.setColor(color1);
        else {
          if (inProgressFlag) {
            var obj = {
              color1: color1,
              color2: color2,
              componentType: componentType,
              setOperationsFlag: setOperationsFlag
            };
            waitingInProgress.push(obj);
          } else {
            changeComponentType(color1, color2, componentType, setOperationsFlag);
          }
        }
      };

      // Change Component Type Toggle Button
      var changeComponentType = function (color1, color2, componentType, setOperationsFlag) {
        inProgressFlag = true;
        angular.element('#stepTwoForm').data('formValidation').resetForm();
        multiComponentService.setActionLegit(false);
        operationsService.setValidAskOperation(false);
        multiComponentService.setDefaultValidAsk(false);
        multiComponentService.initializePreviousValue();
        multiComponentService.setComponentType(componentType);
        multiComponentService.setDescriptionTags([]);
        multiComponentService.setDescriptionModel({});
        scope.isExceptionPageEnabled = false;
        if (componentType === 'tab') {
          scope.isTabEnabled = true;
          scope.standardMaterials = scope.materials;
          multiComponentService.tabComponentCall(scope.item.productType)
            .then(function (result) {
              scope.tabmaterials = (result && result.data.materials) ? (result.data.materials) : (scope.tabmaterials);
              multiComponentService.materialSelectize(scope.tabmaterials);
              scope.component.side = sideTypeEnums.oneSided;
              if (setOperationsFlag) {
                scope.setTabOperationFields();
                setLegitFinishingOptionsAction();
              } else resetComponentForm(scope.componentTypeEnums.tab);
            }).catch(function (e) {
              return e;
            })
        } else if (componentType === 'standard') {
          if (scope.isTabEnabled)
            multiComponentService.materialSelectize(scope.standardMaterials);
          else multiComponentService.materialSelectize(scope.materials);
          scope.isTabEnabled = false;
          if (setOperationsFlag) {
            scope.setTabOperationFields();
            setLegitFinishingOptionsAction();
          } else resetComponentForm(scope.componentTypeEnums.standard);
        } else if (componentType === 'exception') {
          scope.isExceptionPageEnabled = true;
          if (scope.isTabEnabled)
            multiComponentService.materialSelectize(scope.standardMaterials);
          else multiComponentService.materialSelectize(scope.materials);
          scope.isTabEnabled = false;
          if (setOperationsFlag) {
            scope.setTabOperationFields();
            setLegitFinishingOptionsAction();
          } else resetComponentForm(scope.componentTypeEnums.exceptionPages);
          // resetComponentForm(scope.componentTypeEnums.exceptionPages);
        }
      };

      // Reset component form on tab change
      var resetComponentForm = function (componentType) {
        var tabIndex = multiComponentService.getCurrentComponentNumber();
        scope.component = multiComponentService.getInitializedComponent(componentType, tabIndex, scope.component);
        scope.changeColor('frontBlack', 'frontColor');
        multiComponentService.saveCurrentComponent(scope.component, tabIndex - 1);
        itemConfigurationService.saveCurrentItem(multiComponentService.getAllComponents());
        scope.setTabOperationFields();
        scope.initializeVariation(true);
        if (componentType == scope.componentTypeEnums.tab) scope.component.side = sideTypeEnums.oneSided;
        setLegitFinishingOptionsAction();
      };

      // Set Legit Finishing Options Action
      function setLegitFinishingOptionsAction() {
        setTimeout(function () {
          inProgressFlag = false;
          multiComponentService.setActionLegit(true);
          operationsService.setValidAskOperation(true);
          multiComponentService.setDefaultValidAsk(true);
          if (waitingInProgress.length > 0) {
            scope.changeColor(waitingInProgress[0].color1, waitingInProgress[0].color2, waitingInProgress[0].componentType, waitingInProgress[0].setOperationsFlag);
            waitingInProgress.shift();
          }
        }, 600);
        $timeout(function () {
          scope.$apply();
        })
      }

      //Press Override
      scope.changePress = function () {
        if (!scope.component.overridePressCode) {
          scope.component.overridePressCode = "";
          scope.pressLabel = "Default"
        }
        _.forEach(scope.presses, function (press) {
          if (scope.component.overridePressCode == press.code) {
            scope.pressLabel = press.name
          }
        });
      };

      scope.showPressDropDown = function () {
        scope.pressBtnName = (scope.pressBtnName === 'Edit') ? 'Save' : 'Edit';
        scope.editPress = !scope.editPress;
      };

      scope.updateComponentTabName = function () {
        componentTabService.updateComponentTabName(scope.component.itemComponentName)
      };

      scope.pageNumbersChange = function (numbers) {
        if (!scope.component.itemComponentName.includes('Exception Pages')) {
          scope.tempComponentName = scope.component.itemComponentName;
        }
        multiComponentService.setPageNumbers(numbers);
        if (scope.isExceptionPageEnabled) {
          var prefix = 'Exception Pages';
          var space = ' ';
          var maxLength = 50;
          var fullText = prefix + space + numbers;
          if (fullText.length <= maxLength) {
            scope.component.itemComponentName = fullText;
          } else {
            var overflow = fullText.length - maxLength;

            if (overflow <= prefix.length) {
              var trimmedPrefix = prefix.slice(0, prefix.length - overflow);
              scope.component.itemComponeantName = trimmedPrefix + space + numbers;
            } else {
              var trimmedPrefix2 = numbers.slice(0, 50);
              scope.component.itemComponentName = trimmedPrefix2;
            }
          }
          scope.updateComponentTabName();
        }

      };

      scope.tabCountChange = function (count) {
        if (multiComponentService.getPageNumber()) {
          angular.element('#stepTwoForm').formValidation('revalidateField', 'txtPageNumbers', true);
        }
        multiComponentService.setPageCount(count);
      }
    }
  }
}
);



/**
 * Created by $ingh on 3/1/2018.
 */

angular.module('app.quote').directive('itemTemplate', function ($rootScope, formValidationKeyService, genericQuotesService, defaultApiService, notificationService, itemConfigurationService, multiComponentService, itemTabService, operationsService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/itemTemplate.html',

    link: function (scope, form) {
      scope.template = {};
      scope.openTemplateModel = function () {
        scope.item.itemName = angular.element('#txtItemName').val();
        if (genericQuotesService.validateForm('stepTwoForm')) {
          window.scrollTo(0, 20);
          scope.template = {};
          angular.element('#saveAsTemplateModal').modal('show');
        }
        else {
          genericQuotesService.autoScroll('stepTwoForm');
        }
      };

      scope.saveAsTemplate = function () {
        var templateModel = {
          name: scope.template.templateName,
          productId: scope.item.productId,
          productType: scope.item.productType,
          item: scope.item
        };
        var tempShipToQuantity = templateModel.item.shipToQuantity;
        delete templateModel.item.bleedOffset;
        delete templateModel.item.shipToQuantity;
        delete templateModel.item.customerSelectedStoreId;
        scope.selectedStore = '';
        scope.resetSelectBtn();
        templateModel.item.shippingMethodName = '';
        $rootScope.startSpinner();
        defaultApiService.createObjectCall('ItemTemplates', templateModel)
          .success(function (data) {
            angular.element('#saveAsTemplateModal').removeClass('fade');
            angular.element('#saveAsTemplateModal').modal('hide');
            notificationService.notifyEditSuccess(data.name);
            $rootScope.stopSpinner();
            itemConfigurationService.setBoolOperations(true);
            scope.getTemplates(data.id);
            scope.item.shipToQuantity = tempShipToQuantity;
          })
          .error(function (data) {
            $rootScope.stopSpinner();
          });
      };

      scope.setBleeds = function (comp) {
        var bleed = comp.itemComponentBleed;
        if (bleed && bleed.hasBleeds) {
          if (bleed.bleedBottom == bleed.bleedLeft && (bleed.bleedBottom == bleed.bleedRight) && (bleed.bleedBottom == bleed.bleedTop))
            if (bleed.bleedBottom == "0.0625" || bleed.bleedBottom == "0.125" || bleed.bleedBottom == "0.25")
              comp.bleedOffset = bleed.bleedBottom.toString();
            else {
              comp.bleedOffset = "custom"
            }
          else {
            comp.bleedOffset = "custom"
          }
        }
        else {
          comp.bleedOffset = ""
        }
      };

      //To set the bleed of a component if the user is directly landing on an item
      _.forEach(scope.multiComponents, function (comp) {
        scope.setBleeds(comp);
      });

      scope.templateChange = function (templateId) {
        multiComponentService.setDefaultValidAsk(false);
        scope.item.itemTemplateGuid = templateId ? templateId : scope.item.itemTemplateGuid;
        scope.item.itemComponents = multiComponentService.getAllComponents();
        var itemGuid = scope.item.id;
        var productId = scope.item.productId;
        _.forEach(scope.itemTemplates, function (template) {
          if (template.itemTemplateId == scope.item.itemTemplateGuid) {
            template.item.itemTemplateGuid = template.itemTemplateId;
            var matchingItem = template.item;
            matchingItem.id = itemGuid;
            matchingItem.productId = productId;
            itemConfigurationService.setCurrentItem(matchingItem);
            itemConfigurationService.updateMultiItem(itemConfigurationService.getCurrentItemIndex(), matchingItem);
            itemConfigurationService.saveCurrentItem(matchingItem.itemComponents);
            itemConfigurationService.updateMultiItem(itemTabService.getCurrentTabIndex(), matchingItem);
            scope.item = itemConfigurationService.getCurrentItem();
            itemConfigurationService.removeQuantityVariations();
            scope.addQuantityVariations();
            scope.serviceLevel = scope.serviceLevel ? scope.serviceLevel : scope.serviceLevels[0].code;
            _.forEach(scope.item.itemComponents, function (comp) {
              scope.setBleeds(comp);
              angular.element('#stepTwoForm').data('formValidation').resetForm();
            });
            scope.handleItemComponents(itemConfigurationService.getCurrentItemIndex());
            multiComponentService.getColorButton();
            multiComponentService.setActionLegit(false);
            operationsService.setValidAskOperation(false);
            scope.setOperationFields();
            operationsService.setValidAskOperation(true);
            multiComponentService.setActionLegit(true);
            genericQuotesService.initializeStuff(false);
            scope.initializeVariation();
            itemConfigurationService.clearItemFields(scope.item.itemName, scope.item.collateMethod, scope.item.itemNotes, scope.item.quantity)
          }
        });
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtTemplateName: {
            validators: {
              notEmpty: {}
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.saveAsTemplate()
        },

        live: 'enabled'

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }
  }
});

/**
 * Created by sreddy on 2/12/2018.
 */

angular.module('app.quote').directive('initializeItemComponents', function ($rootScope, itemConfigurationService, itemTabService, multiComponentService, defaultApiService, $log, quoteFileUploadService, $q, operationsService, variationService, genericQuotesService, $stateParams, componentTabService, manageStatesService, quoteModelService) {
  return {
    restrict: 'EA',
    replace: false,

    link: function (scope) {

      function resetOperations() {
        scope.itemTemplates = [];
        scope.materials = [];
        scope.primaryBinds = [];
        scope.finishingOptions = [];
        scope.finishingTags = [];
        scope.enablePressOverride = false;
        if (!itemConfigurationService.getBoolOperations() && !itemConfigurationService.getBoolOperations().setOperations) {
          multiComponentService.initializeFinishingOptions([]);
          multiComponentService.initializePrimaryBind(null);
        }
        scope.setPrimaryBindDropdown();
        scope.setFinishingOptionDropdown();
        scope.setMaterialDropdown();
        multiComponentService.setAdHockTags([]);
      }

      var primaryBind, finishingOption, material;
      scope.setPrimaryBindDropdown = function () {
        multiComponentService.primaryBindSelectize(scope.primaryBinds);
        primaryBind = multiComponentService.getPrimaryBindSelectize();
      };

      scope.setFinishingOptionDropdown = function () {
        multiComponentService.finishingOptionSelectize(scope.finishingOptions);
        finishingOption = multiComponentService.getFinishingOptionSelectize();
        multiComponentService.buildAdHockTags();
        scope.finishingTags = multiComponentService.getAdHockTags();
      };

      scope.setMaterialDropdown = function () {
        multiComponentService.materialSelectize(scope.materials);
        material = multiComponentService.getMaterialSelectize();
      };

      /**
       * When coming from convert quote
       * Perform create or Edit Item actions
       **/
      function convertItemActions() {
        if ($stateParams.createItem && $stateParams.incomingFromQuote) {
          scope.createNewItem();
          $stateParams.incomingFromQuote = false;
          scope.$apply();
        } else if ($stateParams.editItem && $stateParams.incomingFromQuote) {
          var items = itemConfigurationService.getAllItems();
          _.forEach(items, function (item, index) {
            if (item.id == $stateParams.itemId) {
              itemConfigurationService.setByPassValidation(true);
              scope.tabClick(index);
              itemConfigurationService.setByPassValidation(false);
              _.forEach(scope.item.itemComponents, function (comp) {
                scope.setBleeds(comp);
              });
              return false;
            }
          });
          $stateParams.itemId = null;
          $stateParams.incomingFromQuote = false;
        } else if ($stateParams.duplicateItem && $stateParams.incomingFromQuote) {
          scope.duplicateItem();
          $stateParams.incomingFromQuote = false;
          scope.$apply();
        }
      }

      function setOperationValues() {
        scope.setPrimaryBindDropdown();
        scope.setFinishingOptionDropdown();
        scope.setMaterialDropdown();
        multiComponentService.setActionLegit(false);
        operationsService.setValidAskOperation(false);
        multiComponentService.setPrimaryBindSelectize(primaryBind);
        multiComponentService.setFinishingSelectize(finishingOption);
        multiComponentService.setMaterialSelectize(material);
        multiComponentService.setActionLegit(true);
        operationsService.setValidAskOperation(true);
      }

      scope.getTemplates = function (templateId) {
        var currentItem = itemConfigurationService.getCurrentItem();
        resetOperations();
        if (currentItem.productType) {
          var templateObj = {
            productType: currentItem.productType,
            productId: currentItem.productId
          };
          $rootScope.startSpinner();
          defaultApiService.createObjectCall('ItemTemplates/GetItemTemplates', templateObj)
            .success(function (data) {
              scope.itemTemplates = data ? data.itemTemplateResponse : [];
              scope.materials = data ? data.materials : [];
              scope.primaryBinds = data ? data.bindingOperations : [];
              scope.finishingOptions = data ? data.finishingOperations : [];
              operationsService.setStaticVariationTypes(data.variationTypes);
              scope.variationTypes = operationsService.getStaticVariationTypes();
              scope.enablePressOverride = data ? data.enablePressOverride : false;

              //Set the dropdown option values and set the existing values for those dropdowns
              setOperationValues();

              // getTemplate gets called multiTimes
              // It is called on product type change so on product change we dont want to set operation dropdowns
              // Hence there are boolean flags to by pass these
              if (itemConfigurationService.getBoolOperations() && itemConfigurationService.getBoolOperations().setOperations) {
                $rootScope.startSpinner();
                setTimeout(function () {
                  //Clicking on the component to set the right data for currently opened component
                  genericQuotesService.setByPassComponentValidation(true);
                  scope.componentTabClick(componentTabService.getCurrentComponentTabIndex());
                  genericQuotesService.setByPassComponentValidation(false);
                  itemConfigurationService.setBoolOperations(false);
                  angular.element('#txtItemTemplate').val(templateId);
                  convertItemActions();
                  scope.validComponent = false;
                  //When coming previous enable Delivery Tab
                  if (manageStatesService.getGoToPrevious()) {
                    itemTabService.enableDeliveryTab(itemTabService.getCurrentTabIndex());
                    manageStatesService.setGoToPrevious(false)
                  }
                  $rootScope.stopSpinner();
                }, 600);
              }
              scope.templateChange(templateId);
              angular.element('#stepTwoForm').data('formValidation').resetForm();
              genericQuotesService.initializeStuff(false);
              scope.initializeVariation();
              scope.changePress();
              if (!itemConfigurationService.getBoolOperations() || !itemConfigurationService.getBoolOperations().setOperations) {
                $rootScope.stopSpinner();
                // scope.initializeVariation();
              }
            })
            .error(function (data) {
              $log.log(data);
              $rootScope.stopSpinner();
            });
        } else
          $rootScope.stopSpinner();
      };

      scope.setPrimaryBind = function (value) {
        multiComponentService.setPrimaryBind(value);
      };
      scope.setFinishingOption = function (value) {
        multiComponentService.setFinishingOption(value);
      };
      scope.item = itemConfigurationService.getCurrentItem();
      if (itemConfigurationService.getAllItems().length < 1) {
        itemTabService.initializeTabs();
        itemConfigurationService.initializeItems();
        itemTabService.addItemTab(0);
        itemTabService.updateItemTabs(0);
        itemConfigurationService.addItem();
        scope.multiItems = itemConfigurationService.getAllItems();
        itemConfigurationService.setCurrentItem(scope.multiItems[0]);
        itemTabService.setItemName(scope.item.itemName);
        genericQuotesService.initializeStuff(true);
      } else {
        genericQuotesService.initializeStuff(false);
        itemConfigurationService.setSelectizeValue('cboProductTypeName');
        itemConfigurationService.setBoolOperations(true);
        scope.getTemplates();
      }

      scope.itemTabs = itemTabService.getItemTabs();
      scope.multiItems = itemConfigurationService.getAllItems();
      scope.item = itemConfigurationService.getCurrentItem();
      scope.addQuantityVariations();

      angular.element('#fileSelect').click(function () {
        angular.element('#txtItemFile').click();
      });

      // Remove File Functionality
      scope.removeFile = function (file) {
        var fileObj = {
          "quoteId": quoteModelService.getQuoteId() ? quoteModelService.getQuoteId() : null,
          "itemId": itemConfigurationService.getCurrentItem().id ? itemConfigurationService.getCurrentItem().id : null,
          "fileId": file.itemFileId
        };
        quoteFileUploadService.removeFileApiCall(fileObj);
        angular.element('#txtItemFile').val(null);
      };

      // Set PDF Files for API Call
      //TODO: JSS Check this logic and bind the data as per quote model
      scope.setPdfFiles = function (filevalue, fileName) {
        $rootScope.startSpinner();
        $q.all([quoteFileUploadService.pdfFilesApiCall(filevalue, fileName)]).then(function () {
          $rootScope.stopSpinner();
        }).catch(function () {
          $rootScope.stopSpinner();
        })
      };
    }
  }
});

/**
 * Created by sreddy on 3/8/2018.
 */

angular.module('app.quote').directive('editVariationAdhocCustomServiceModal', function ($rootScope, formValidationKeyService, multiComponentService, variationService, genericQuotesService, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/editVariationAdhocCustomServiceModal.tpl.html',

    link: function (scope, form) {
      scope.adHocService = multiComponentService.getAdHocModel();

      // Hard Coded Cost Types for Adhoc
      scope.adhocCostTypes = [{value: "adHocMachineCost"}, {value: "adHocMaterialCost"}, {value: "adHocLaborCost"}];
      scope.localisedCostTypes = [];
      scope.adhocCostTypes.map(function (costType) {
        scope.localisedCostTypes.push({
          name: $rootScope.getWord(costType.value),
          value: costType.value
        });
      });

      // clear Cost Type Fields on change
      scope.clearCostTypeFields = function () {
        scope.adHocService.quantityBy = '';
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'cboQuantityByForCostType', true);
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'txtSpeedForCostType', true);
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'txtRateForCostType', true);
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'txtUnitMeasureForMaterialCost', true);
      };

      // clear Quantity Field on change
      scope.clearQuantityField = function (selectedQuantityBy, costType) {
        angular.element('#editVariationAdHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
      };

      // cancel Adhoc
      scope.cancelAddHoc = function () {
        angular.element('#editVariationAdHocCustomServiceModal').removeClass('fade');
        angular.element('#editVariationAdHocCustomServiceModal').modal('hide');
      };

      // Triggers on modal close
      angular.element('#editVariationAdHocCustomServiceModal').on('hide.bs.modal', function (e) {
        scope.adHocService.customServiceName = angular.element('#txtCustomServicesName').val();
        //If AdHoc Modal was opened for variations
        if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
            variationService.setFinishingOptionVariation(variationService.getVariationAdHocProperties().rowId, '00000000-0000-0000-0000-000000000000', scope.adHocService);
            angular.element('#editVariationAdHocCustomServiceModal').removeClass('fade');
            scope.getAdHocTags(variationService.getVariationAdHocProperties().rowId, scope.adHocService.customServiceName);
            variationService.setVariationAdHocProperties(null, false, variationService.getVariationAdHocProperties().index);
            scope.$apply()
          } else {
            var variationAdHocIds = [];
            _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
              if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                _.forEach(variation.finishingOptions, function (option) {
                  if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                    variationAdHocIds.push(option.finishingId);
                  }
                });
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (variationAdHocIds && (variationAdHocIds.length == 0)) {
              var index = variationService.getVariationAdHocProperties().index;
              var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
              variationService.setLegitVariationAddAction(false);
              variationFinishingOption[0].selectize.removeItem("00000000-0000-0000-0000-000000000000", true);
              variationService.setLegitVariationAddAction(true);
            }
          }
        }
        //If AdHoc Modal was opened for base finishing options
        else {
          //If submit buttom is clicked then save it
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
          }
          //This triggers if user clicks outside of the modal or press esc
          else {
            var customAdHocIds = [];
            angular.forEach(scope.component.finishingOptions, function (option) {
              if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                customAdHocIds.push(option.finishingId);
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (customAdHocIds && (customAdHocIds.length == 0)) {
              var finishingDropdown = multiComponentService.getFinishingOptionSelectize();
              finishingDropdown[0].selectize.removeItem("00000000-0000-0000-0000-000000000000");
            }
          }
          angular.element('#editVariationAdHocCustomServiceModal').removeClass('fade');
          $timeout(function () {
            scope.$apply()
          })
        }
        angular.element('#editVariationAdHocCustomServiceModal').data('formValidation').resetForm(true);
        scope.adHocService = {};
        scope.selectedCustomName = '';
      });

      angular.element('#editVariationAdHocCustomServiceModal').on('shown.bs.modal', function (e) {
        scope.adHocService = {};
        angular.element('#editVariationAdHocCustomServiceModal').data('formValidation').resetForm(true);
        $timeout(function () {
          scope.$apply();
        })
      });

      // Save Variation Adhoc
      scope.saveVariationAdHoc = function () {
        // scope.addHocSelected = true;
        scope.updateVariationCustomValue(scope.adHocService, multiComponentService.getCurrentComponent().finishingOptionsVariations, scope.selectedCustomName, scope.variationSelectedRowId);
        angular.element('#editVariationAdHocCustomServiceModal').removeClass('fade');
        angular.element('#editVariationAdHocCustomServiceModal').modal('hide');
      };

      var decimalMin = 0;
      var decimalMax = 9999999;
      var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
      var decimalRegexFour = /^(?:-?\d*\.?\d{1,4}|\d+)$/;
      var TwoDecimalRegexMessage = {
        en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
        en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
      };
      var FourDecimalRegexMessage = {
        en_US: $rootScope.getWord('FourDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('FourDecimalPlacesNum'),
        en_CA: $rootScope.getWord('FourDecimalPlacesNum')
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtCustomServicesName: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 1,
                max: 100
              },
              callback: {
                message: {
                  en_US: $rootScope.getWord('DuplicateAdHoc'),
                  fr_CA: $rootScope.getWord('DuplicateAdHoc'),
                  en_CA: $rootScope.getWord('DuplicateAdHoc')
                },
                callback: function (value, validator) { //Validate date to be the current or after current date.
                  var flag = true;
                  if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
                      if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                        _.forEach(variation.finishingOptionsVariations, function (option) {
                          if (option.finishingId == "00000000-0000-0000-0000-000000000000" && option.adHocOperation.customServiceName == value && value != scope.selectedCustomName) {
                            flag = false
                          }
                        });
                      }
                    });
                  } else {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (option) {
                      if (option.finishingId == '00000000-0000-0000-0000-000000000000' && option.adHocOperation.customServiceName == value && value != scope.selectedCustomName) {
                        flag = false
                      }
                    });
                  }
                  return flag;
                }
              }
            }
          },

          chkMarkAsBuyOutForCostType: {
            validators: {}
          },

          costTypeForAhoc: {
            validators: {
              notEmpty: {}
            }
          },

          cboQuantityByForCostType: {
            validators: {
              notEmpty: {}
            }
          },

          txtQuantityForCostType: {
            group: '.col-lg-2',
            validators: {
              notEmpty: {},
              digits: {},
              between: {
                min: 1,
                max: 10000000
              }
            }
          },

          txtSpeedForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtRateForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtUnitMeasureForMaterialCost: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.saveVariationAdHoc()
        },

        live: 'enabled'

      });


      scope.updateVariationCustomValue = function (currentVal, valueTillNow, prevName, rowId) {
        var selectedIndexForVairation = valueTillNow.findIndex(function (val) {
          if (val.id == rowId) {
            return val;
          }
        });

        var selectObjIdx = valueTillNow[selectedIndexForVairation].finishingOptions.findIndex(function (selected) {
          if (selected.adHocOperation && selected.adHocOperation.customServiceName == prevName) {
            return selected;
          }
        });
        if (selectObjIdx >= 0) {
          var selectObj = valueTillNow[selectedIndexForVairation].finishingOptions[selectObjIdx];
          if (selectObj) {
            selectObj.adHocOperation.customServiceName = currentVal.customServiceName;
            if (currentVal.costType == 'adHocMachineCost') {
              selectObj.adHocOperation.adHocMaterialCost = null;
              selectObj.adHocOperation.adHocLaborCost = null;
              selectObj.adHocOperation.adHocMachineCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                speed: currentVal.speed,
                hourlyCost: currentVal.hourlyCost
              }
            } else if (currentVal.costType == 'adHocMaterialCost') {
              selectObj.adHocOperation.adHocMachineCost = null;
              selectObj.adHocOperation.adHocLaborCost = null;
              selectObj.adHocOperation.adHocMaterialCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                unitCost: currentVal.unitCost
              }
            } else if (currentVal.costType == 'adHocLaborCost') {
              selectObj.adHocOperation.adHocMachineCost = null;
              selectObj.adHocOperation.adHocMaterialCost = null;
              selectObj.adHocOperation.adHocLaborCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                speed: currentVal.speed,
                hourlyCost: currentVal.hourlyCost
              }
            }
            valueTillNow[selectedIndexForVairation].finishingOptions.splice(selectObjIdx, 1, selectObj);
            var currentComponentVal = multiComponentService.getCurrentComponent();
            currentComponentVal.finishingOptionsVariations = valueTillNow; //will be depends upon current action
            multiComponentService.saveCurrentComponent(currentComponentVal, multiComponentService.getCurrentComponentNumber() - 1);
            var allAdhoc = variationService.setAdHockTags(rowId);
            allAdhoc.map(function (valToBeupdated) {
              if (valToBeupdated.name == prevName) {
                valToBeupdated.name = currentVal.customServiceName
              }
              return valToBeupdated
            });
            variationService.setAdhocTags(allAdhoc)
          }
        }
      }
    }
  }
});


/**
 * Created by sreddy on 3/8/2018.
 */

angular.module('app.quote').directive('editAdhocCustomServiceModal', function ($rootScope, formValidationKeyService, multiComponentService, variationService, genericQuotesService, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/editAdhocCustomServiceModal.tpl.html',

    link: function (scope, form) {
      scope.adHocService = multiComponentService.getAdHocModel();
      // scope.showQuantityField = true;

      // Hard Coded Cost Types for Adhoc
      scope.adhocCostTypes = [{value: "adHocMachineCost"}, {value: "adHocMaterialCost"}, {value: "adHocLaborCost"}];
      scope.localisedCostTypes = [];
      scope.adhocCostTypes.map(function (costType) {
        scope.localisedCostTypes.push({
          name: $rootScope.getWord(costType.value),
          value: costType.value
        });
      });

      // clear Cost Type Fields on change
      scope.clearCostTypeFields = function () {
        scope.adHocService.quantityBy = '';
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'cboQuantityByForCostType', true);
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'txtSpeedForCostType', true);
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'txtRateForCostType', true);
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'txtUnitMeasureForMaterialCost', true);
      };

      // clear Quantity Field on change
      scope.clearQuantityField = function (selectedQuantityBy, costType) {
        // scope.showQuantityField = (selectedQuantityBy == scope.quanityByEnums.Ask);
        angular.element('#editAdHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
      };

      // cancel Adhoc
      scope.cancelAddHoc = function () {
        angular.element('#editAdHocCustomServiceModal').removeClass('fade');
        angular.element('#editAdHocCustomServiceModal').modal('hide');
      };

      // Triggers on modal close
      angular.element('#editAdHocCustomServiceModal').on('hide.bs.modal', function (e) {
        scope.adHocService.customServiceName = angular.element('#txtCustomServicesName').val();
        //If AdHoc Modal was opened for variations
        if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
            variationService.setFinishingOptionVariation(variationService.getVariationAdHocProperties().rowId, '00000000-0000-0000-0000-000000000000', scope.adHocService);
            angular.element('#editAdHocCustomServiceModal').removeClass('fade');
            scope.getAdHocTags(variationService.getVariationAdHocProperties().rowId, scope.adHocService.customServiceName);
            variationService.setVariationAdHocProperties(null, false, variationService.getVariationAdHocProperties().index);
            scope.$apply()
          } else {
            var variationAdHocIds = [];
            _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
              if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                _.forEach(variation.finishingOptions, function (option) {
                  if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                    variationAdHocIds.push(option.finishingId);
                  }
                });
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (variationAdHocIds && (variationAdHocIds.length == 0)) {
              var index = variationService.getVariationAdHocProperties().index;
              var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
              variationService.setLegitVariationAddAction(false);
              variationFinishingOption[0].selectize.removeItem("00000000-0000-0000-0000-000000000000", true);
              variationService.setLegitVariationAddAction(true);
            }
          }
        }
        //If AdHoc Modal was opened for base finishing options
        else {
          //If submit buttom is clicked then save it
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
          }
          //This triggers if user clicks outside of the modal or press esc
          else {
            var customAdHocIds = [];
            angular.forEach(scope.component.finishingOptions, function (option) {
              if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                customAdHocIds.push(option.finishingId);
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (customAdHocIds && (customAdHocIds.length == 0)) {
              var finishingDropdown = multiComponentService.getFinishingOptionSelectize();
              finishingDropdown[0].selectize.removeItem("00000000-0000-0000-0000-000000000000");
            }
          }
          angular.element('#editAdHocCustomServiceModal').removeClass('fade');
          $timeout(function () {
            scope.$apply()
          })
        }
        angular.element('#editAdHocCustomServiceModal').data('formValidation').resetForm(true);
        scope.adHocService = {};
        scope.selectedCustomName = '';
      });

      angular.element('#editAdHocCustomServiceModal').on('shown.bs.modal', function (e) {
        scope.adHocService = {};
        angular.element('#editAdHocCustomServiceModal').data('formValidation').resetForm(true);
        $timeout(function () {
          scope.$apply();
        })
      });

      scope.saveAdHoc = function () {
        scope.addHocSelected = true;
        scope.updateCustomValue(scope.adHocService, multiComponentService.getCurrentComponent().finishingOptions, scope.selectedCustomName);
        angular.element('#editAdHocCustomServiceModal').removeClass('fade');
        angular.element('#editAdHocCustomServiceModal').modal('hide');
      };

      var decimalMin = 0;
      var decimalMax = 9999999;
      var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
      var decimalRegexFour = /^(?:-?\d*\.?\d{1,4}|\d+)$/;
      var TwoDecimalRegexMessage = {
        en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
        en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
      };
      var FourDecimalRegexMessage = {
        en_US: $rootScope.getWord('FourDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('FourDecimalPlacesNum'),
        en_CA: $rootScope.getWord('FourDecimalPlacesNum')
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtCustomServicesName: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 1,
                max: 100
              },
              callback: {
                message: {
                  en_US: $rootScope.getWord('DuplicateAdHoc'),
                  fr_CA: $rootScope.getWord('DuplicateAdHoc'),
                  en_CA: $rootScope.getWord('DuplicateAdHoc')
                },
                callback: function (value, validator) { //Validate date to be the current or after current date.
                  var flag = true;
                  if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
                      if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                        _.forEach(variation.finishingOptions, function (option) {
                          if (option.finishingId == "00000000-0000-0000-0000-000000000000" && option.adHocOperation.customServiceName == value && value != scope.selectedCustomName) {
                            flag = false
                          }
                        });
                      }
                    });
                  } else {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptions, function (option) {
                      if (option.finishingId == '00000000-0000-0000-0000-000000000000' && option.adHocOperation.customServiceName == value && value != scope.selectedCustomName) {
                        flag = false
                      }
                    });
                  }
                  return flag;
                }
              }
            }
          },

          chkMarkAsBuyOutForCostType: {
            validators: {}
          },

          costTypeForAhoc: {
            validators: {
              notEmpty: {}
            }
          },

          cboQuantityByForCostType: {
            validators: {
              notEmpty: {}
            }
          },

          txtQuantityForCostType: {
            group: '.col-lg-2',
            validators: {
              notEmpty: {},
              digits: {},
              between: {
                min: 1,
                max: 10000000
              }
            }
          },

          txtSpeedForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtRateForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtUnitMeasureForMaterialCost: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.saveAdHoc()
        },

        live: 'enabled'

      });


      scope.updateCustomValue = function (currentVal, valueTillNow, prevName) {
        var selectObjIdx = valueTillNow.findIndex(function (selected) {
          if (selected.adHocOperation && selected.adHocOperation.customServiceName == prevName) {
            return selected;
          }
        });
        if (selectObjIdx >= 0) {
          var selectObj = valueTillNow[selectObjIdx];
          if (selectObj) {
            selectObj.adHocOperation.customServiceName = currentVal.customServiceName;
            if (currentVal.costType == 'adHocMachineCost') {
              selectObj.adHocOperation.adHocMaterialCost = null;
              selectObj.adHocOperation.adHocLaborCost = null;
              selectObj.adHocOperation.adHocMachineCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                speed: currentVal.speed,
                hourlyCost: currentVal.hourlyCost
              }
            } else if (currentVal.costType == 'adHocMaterialCost') {
              selectObj.adHocOperation.adHocMachineCost = null;
              selectObj.adHocOperation.adHocLaborCost = null;
              selectObj.adHocOperation.adHocMaterialCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                unitCost: currentVal.unitCost
              }
            } else if (currentVal.costType == 'adHocLaborCost') {
              selectObj.adHocOperation.adHocMachineCost = null;
              selectObj.adHocOperation.adHocMaterialCost = null;
              selectObj.adHocOperation.adHocLaborCost = {
                markAsBuyOut: currentVal.markAsBuyOut,
                quantityBy: currentVal.quantityBy,
                quantity: currentVal.quantity,
                speed: currentVal.speed,
                hourlyCost: currentVal.hourlyCost
              }
            }
            valueTillNow.splice(selectObjIdx, 1, selectObj);
            var currentComponentVal = multiComponentService.getCurrentComponent();
            currentComponentVal.finshingOptions = valueTillNow;
            multiComponentService.saveCurrentComponent(currentComponentVal, multiComponentService.getCurrentComponentNumber() - 1);
            multiComponentService.buildAdHockTags();
            scope.finishingTags = multiComponentService.getAdHockTags();
          }
        }
      }
    }
  }
});


/**
 * Created by sreddy on 2/12/2018.
 */

angular.module('app.quote').directive('deliveryMethods', function (deliveryMethodService, $rootScope, recipientInfoService, itemConfigurationService, quotesInfoService) {
  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/quote/partials/stepTwo/deliveryMethods.tpl.html',

    link: function (scope) {

      scope.changeDeliveryType = function (step) {
        scope.makeSelection = false;
        switch (step) {
          case 1 :
            scope.item.shippingMethodName = '20';
            scope.noPickupSelected = false;
            scope.item.customerSelectedStoreId = '';
            scope.selectedStore = '';
            scope.searchedData = [];
            scope.pickUpSearchText = '';
            scope.resetSelectBtn();
            break;
          case 2 :
            scope.item.shippingMethodName = '10';
            scope.canNotAddRecipient = false;
            scope.$broadcast('clear-recipient', 'true');
            //If customerSelectedStoreId exists for any other item then it will
            // become the customerSelectedStoreId of this item as well by designed
            _.forEach(itemConfigurationService.getAllItems(), function (item) {
              if (item.customerSelectedStoreId) {
                scope.item.customerSelectedStoreId = item.customerSelectedStoreId;
                return false;
              }
            });
            scope.setCurrentStore();
            scope.populatePickUpCard(scope.selectedStore);
            break;
        }
      };

      //Recipient Form Submit Functionality
      scope.submitRecipientObject = function () {
        scope.recipient.street1 = angular.element('#txtStreet1').val();
        delete scope.recipient.firstName;
        delete scope.recipient.lastName;
        if (!scope.customerData)
          scope.customerData = quotesInfoService.getStepOneData();
        deliveryMethodService.setRecipient(scope.recipient, scope.customerData.id);
        if (deliveryMethodService.haveAddressDetails() && scope.runSatori) {
          $rootScope.startSpinner();
          deliveryMethodService.callAddressValidation()
            .success(function (data) {
              $rootScope.stopSpinner();
              scope.showSuggestedAddress(data);
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        }
        else {
          scope.submitRecipient();
        }
      };

      /** ///////////////////////////////////// **/
      /** Delivery Methods Enum values Data     **/
      /** ///////////////////////////////////// **/
      scope.serviceLevels = deliveryMethodService.getServiceLevelEnum();

      function isShippingMethodValid() {
        if (!deliveryMethodService.isQuantityNumber() && !deliveryMethodService.isQuantityEmpty()) {
          if (recipientInfoService.getRecipientInfo().length == scope.shipToRecipients.length) {
            return true
          }
          else {
            return false
          }
        }
        else
          return false;
      }

      function isPickupValid() {
        if (scope.item.customerSelectedStoreId)
          return true;
        return false;
      }

      //Check whether delivery for current Item is validated or not
      scope.validateDelivery = function () {
        if (scope.item.shippingMethodName == '10') {
          return isPickupValid();
        }
        else {
          return isShippingMethodValid()
        }

      }
    }
  }
});

/**
 * Created by anwar
 */

angular.module('app.quote').directive('customIntentModal', function (customIntentService, multiComponentService, variationService, $timeout) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/quote/partials/stepTwo/customIntentModal.tpl.html',

        link: function (scope, form) {
            var modal = angular.element('#customIntentModal');
            modal.on('shown.bs.modal', function () {
                scope.$applyAsync(function () {
                    scope.description = customIntentService.getDescription();
                });
            });
            // Clean up listener when scope is destroyed
            scope.$on('$destroy', function () {
                modal.off('shown.bs.modal');
            });
            scope.onModalClose = function () {};

            scope.submitDescription = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }
                var finishingId = customIntentService.getFinishingId();
                var description = angular.element('#txtDescription').val();
                var type = customIntentService.getfinishingOptionsType();
                if (type === 'finishingOptions') {
                    multiComponentService.setDescriptionForFinishingOption(finishingId, description);
                } else if(type === 'variant') {
                    variationService.setDescriptionForFinishingOptionVariations(finishingId, description, customIntentService.getFinishingOptionName(), customIntentService.getIndex(), customIntentService.getRowId());
                }
                angular.element('#customIntentModal').removeClass('fade');
                angular.element('#customIntentModal').modal('hide');
                $timeout(function () {
                    scope.$apply()
                })
            };
            form.formValidation({

                framework: 'bootstrap',
                icon: {},

                addOns: {
                    i18n: {},
                    mandatoryIcon: {}
                },

                fields: {
                    txtDescription: {
                        validators: {
                            notEmpty: {},
                            stringLength: {
                                trim: true,
                                min: 1,
                                max: 250
                            }
                        }
                    }
                },
                live: 'enabled'
            });

        }
    }
});


/**
 * Created by Singh on 29/1/2017.
 * Filename: src/app/quote/directives/stepTwo/componentTabs.js
 */
angular.module('app.quote').directive('componentTabs', function ($stateParams, $rootScope, $log, componentTabService, multiComponentService, genericQuotesService, itemConfigurationService, deliveryMethodService, defaultApiService, quoteFileUploadService, notificationService, recipientInfoService, quoteModelService, guidService, operationsService, customIntentService, pageNumberValidator, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/componentTabs.tpl.html',

    link: function (scope) {
      scope.validComponent = false;
      scope.isQuantityValid = false;
      multiComponentService.setDefaultValidAsk(false);
      scope.finishingTags = multiComponentService.getAdHockTags();
      // Close Ad-hoc Tags
      scope.closeTags = function (value, tag) {
        if (value) {
          var index = _.findLastIndex(scope.finishingTags, ['value', value]);
          scope.finishingTags.splice(index, 1);
          multiComponentService.setAdHockTags(scope.finishingTags);
          multiComponentService.removeAdHoc(value)
        } else {
          var index = _.findLastIndex(scope.finishingTags, ['finishingId', tag.finishingId]);
          scope.finishingTags.splice(index, 1);
          multiComponentService.setAdHockTags(scope.finishingTags);
          multiComponentService.removeAdHoc(value, tag);
        }
      };
      // Edit Ad-hoc Tags
      scope.editTags = function (value, tag) {
        if (value) {
          scope.selectedCustomName = value;
          angular.element('#editAdHocCustomServiceModal').on('shown.bs.modal', function (e) {
            scope.adHocService = {};
            $timeout(function () {
              _.forEach(multiComponentService.getCurrentComponent().finishingOptions, function (adhoc) {
                if (adhoc.adHocOperation && (adhoc.adHocOperation.customServiceName == scope.selectedCustomName)) {
                  scope.adHocService.customServiceName = adhoc.adHocOperation.customServiceName;
                  if (adhoc.adHocOperation.adHocMachineCost) {
                    scope.adHocService.costType = 'adHocMachineCost';
                    scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocMachineCost.markAsBuyOut;
                    scope.adHocService.quantityBy = adhoc.adHocOperation.adHocMachineCost.quantityBy;
                    scope.adHocService.quantity = adhoc.adHocOperation.adHocMachineCost.quantity ? adhoc.adHocOperation.adHocMachineCost.quantity : '';
                    scope.adHocService.speed = adhoc.adHocOperation.adHocMachineCost.speed ? adhoc.adHocOperation.adHocMachineCost.speed : '';
                    scope.adHocService.hourlyCost = adhoc.adHocOperation.adHocMachineCost.hourlyCost ? adhoc.adHocOperation.adHocMachineCost.hourlyCost : '';
                  } else if (adhoc.adHocOperation.adHocMaterialCost) {
                    scope.adHocService.costType = 'adHocMaterialCost';
                    scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocMaterialCost.markAsBuyOut;
                    scope.adHocService.quantityBy = adhoc.adHocOperation.adHocMaterialCost.quantityBy;
                    scope.adHocService.quantity = adhoc.adHocOperation.adHocMaterialCost.quantity ? adhoc.adHocOperation.adHocMaterialCost.quantity : '';
                    scope.adHocService.unitCost = adhoc.adHocOperation.adHocMaterialCost.unitCost ? adhoc.adHocOperation.adHocMaterialCost.unitCost : '';
                  } else {
                    scope.adHocService.costType = 'adHocLaborCost';
                    scope.adHocService.markAsBuyOut = !!adhoc.adHocOperation.adHocLaborCost.markAsBuyOut;
                    scope.adHocService.quantityBy = adhoc.adHocOperation.adHocLaborCost.quantityBy;
                    scope.adHocService.quantity = adhoc.adHocOperation.adHocLaborCost.quantity ? adhoc.adHocOperation.adHocLaborCost.quantity : '';
                    scope.adHocService.speed = adhoc.adHocOperation.adHocLaborCost.speed ? adhoc.adHocOperation.adHocLaborCost.speed : '';
                    scope.adHocService.hourlyCost = adhoc.adHocOperation.adHocLaborCost.hourlyCost ? adhoc.adHocOperation.adHocLaborCost.hourlyCost : '';
                  }
                  scope.$apply();
                }
              });
            })
          });
          angular.element("#editAdHocCustomServiceModal").modal('show');
        } else if (tag.finishingId) {
          var finishingOptions = multiComponentService.getCurrentComponent().finishingOptions;
          _.forEach(finishingOptions, function (option) {
            if (option.finishingId == tag.finishingId) {
              customIntentService.customInentOperation(tag.finishingId, finishingOptions, 'finishingOptions', undefined, undefined, tag.description);
            }
          });
          angular.element("#customIntentModal").modal('show');
        }
      };

      //Directly binded with ng-show of tags readonly field
      scope.showFinishingTags = function () {
        return multiComponentService.showFinishingTags();
      };

      if (multiComponentService.getAllComponents().length < 1) {
        componentTabService.initializeComponentTabs();
        componentTabService.addComponentTab();
        multiComponentService.setFirstComponent();
        componentTabService.updateComponentTabs(0);
        multiComponentService.setCurrentComponent(0);
      }
      scope.component = multiComponentService.getCurrentComponent();

      // Rounded finishing size to two decimals
      try {
        scope.component.size.finalHeight = scope.component.size.finalHeight.toFixed(2);
        scope.component.size.finalWidth = scope.component.size.finalWidth.toFixed(2);
      } catch (e) {
      }

      scope.addComponent = function () {
        scope.validateTabCount();
        if (genericQuotesService.validateContainer('stepTwoForm', 'componentSection')) {
          multiComponentService.addComponent();
          componentTabService.addComponentTab();
          scope.componentTabClick(scope.multiComponents.length - 1);
          angular.element('#stepTwoForm').data('formValidation').resetForm();
        } else {
          scope.validComponent = true;
        }
      };

      scope.removeComponentTab = function (index) {
        componentTabService.removeComponentTab(index)
      };

      scope.componentTabs = componentTabService.getComponentTabs();
      multiComponentService.getColorButton();

      /** ///////////////////////////////////// **/
      /** After removing all tabs redraw them   **/
      /** with updated Component Number         **/
      /** ///////////////////////////////////// **/
      scope.reDrawComponentTabs = function () {
        _.forEach(scope.multiComponents, function (comp, index) {
          componentTabService.addComponentTab(comp.itemComponentName)
        });
        scope.componentTabs = componentTabService.getComponentTabs();
      };

      if ($stateParams.id) {
        componentTabService.initializeComponentTabs();
        scope.reDrawComponentTabs();
        componentTabService.updateComponentTabs(0);
      }

      //Setting three operation fields
      scope.setOperationFields = function () {
        scope.setPrimaryBindDropdown();
        scope.setFinishingOptionDropdown();
        scope.setMaterialDropdown();
        multiComponentService.setOperations();
        multiComponentService.buildAdHockTags();
        scope.finishingTags = multiComponentService.getAdHockTags();
        //scope.descriptionTags = multiComponentService.getDescriptionTags();
      };

      // Validate Page Number count against tab count
      scope.validateTabCount = function () {
        pageNumberValidator.setTabCount(scope.component.material.pageCount);
        pageNumberValidator.isValid(angular.element('#txtPageNumbers').val());
        pageNumberValidator.setPageCountCheckFlag(true);
        angular.element('#stepTwoForm').formValidation('revalidateField', 'txtPageNumbers', true);
        pageNumberValidator.setPageCountCheckFlag(false);
      };

      scope.setPageCountCheckFlag = function (flag) {
        pageNumberValidator.setPageCountCheckFlag(flag);
      }

      /** ///////////////////////////////////// **/
      /** Action on switching Component tab          **/
      /** ///////////////////////////////////// **/
      scope.componentTabClick = function (componentTabNumber) {
        scope.validateTabCount();
        multiComponentService.setDefaultValidAsk(false);
        multiComponentService.initializePreviousValue();
        scope.validateHighLightedComponents = false;
        if (genericQuotesService.validateContainer('stepTwoForm', 'componentSection')) {
          scope.validComponent = false;
          multiComponentService.validateCurrentTab();
          var currentTabIndex = componentTabService.getCurrentComponentTabIndex();
          multiComponentService.saveCurrentComponent(scope.component, currentTabIndex);
          componentTabService.updateComponentTabs(componentTabNumber);
          componentTabService.setCurrentComponentTabIndex(componentTabNumber);
          multiComponentService.setCurrentComponent(componentTabNumber);
          scope.component = multiComponentService.getCurrentComponent();
          componentTabService.removeComponentValidationAlert();
          multiComponentService.getColorButton();
          //Setting three operation fields
          multiComponentService.setActionLegit(false);
          operationsService.setValidAskOperation(false);
          scope.setOperationFields({ legit: false });
          operationsService.setValidAskOperation(true);
          multiComponentService.setActionLegit(true);
          scope.changePress();

          if (!genericQuotesService.getByPassComponentValidation()) {
            genericQuotesService.initializeStuff(false);
            scope.initializeVariation();
          }
          angular.element('#stepTwoForm').data('formValidation').resetForm();
          var currentComponentTab = scope.multiComponents[componentTabNumber];
          // if (currentComponentTab.itemComponentType == scope.componentTypeEnums.tab) {
          //   scope.changeColor('tabComponent', 'standardComponent', 'tab', true);
          // } else {
          //   scope.changeColor('standardComponent', 'tabComponent', 'standard', true)
          // }
          //

          if (currentComponentTab.itemComponentType === 1) {
            scope.changeColor('standardComponent', 'tabComponent', 'standard', true, 'exceptionComponent');
          } else if (currentComponentTab.itemComponentType === 2) {
            scope.changeColor('tabComponent', 'standardComponent', 'tab', true, 'exceptionComponent');
          } else if (currentComponentTab.itemComponentType === 3) {
            scope.changeColor('exceptionComponent', 'standardComponent', 'exception', true, 'tabComponent');
          }
        } else {
          scope.validComponent = true;
        }
      };

      // File Upload Validations
      var excludeExtensions = ["ade", "adp", "app", "asa", "ashx", "asmx", "asp", "bas", "bat", "cdx", "cer", "chm", "class", "cmd", "cnt", "com", "config", "cpl", "crt", "csh", "der", "dll", "exe", "fxp", "gadget", "grp", "hlp", "hta", "htr", "htw", "ida", "idc", "idq", "ins", "isp", "its", "jse", "json", "ksh", "lnk", "mad", "maf", "mag", "mam", "maq", "mar", "mas", "mat", "mau", "mav", "maw", "mcf", "mda", "mdb", "mde", "mdt", "mdw", "mdz", "ms-one-stub", "msc", "msh", "msh1", "msh1xml", "msh2", "msh2xml", "mshxml", "msi", "msp", "mst", "ops", "pcd", "pif", "pl", "prf", "prg", "printer", "ps1", "ps1xml", "ps2", "ps2xml", "psc1", "psc2", "pst", "reg", "rem", "scf", "scr", "sct", "shb", "shs", "shtm", "shtml", "soap", "stm", "svc", "url", "vb", "vbe", "vbs", "vsix", "ws", "wsc", "wsf", "wsh", "xamlx", "ADE", "ADP", "APP", "ASA", "ASHX", "ASMX", "ASP", "BAS", "BAT", "CDX", "CER", "CHM", "CLASS", "CMD", "CNT", "COM", "CONFIG", "CPL", "CRT", "CSH", "DER", "DLL", "EXE", "FXP", "GADGET", "GRP", "HLP", "HTA", "HTR", "HTW", "IDA", "IDC", "IDQ", "INS", "ISP", "ITS", "JSE", "JSON", "KSH", "LNK", "MAD", "MAF", "MAG", "MAM", "MAQ", "MAR", "MAS", "MAT", "MAU", "MAV", "MAW", "MCF", "MDA", "MDB", "MDE", "MDT", "MDW", "MDZ", "MS-ONE-STUB", "MSC", "MSH", "MSH1", "MSH1XML", "MSH2", "MSH2XML", "MSHXML", "MSI", "MSP", "MST", "OPS", "PCD", "PIF", "PL", "PRF", "PRG", "PRINTER", "PS1", "PS1XML", "PS2", "PS2XML", "PSC1", "PSC2", "PST", "REG", "REM", "SCF", "SCR", "SCT", "SHB", "SHS", "SHTM", "SHTML", "SOAP", "STM", "SVC", "URL", "VB", "VBE", "VBS", "VSIX", "WS", "WSC", "WSF", "WSH", "XAMLX"];

      scope.form_validate = function (attr_id) {
        var result = true;
        angular.element('#' + attr_id + ' .form-group').each(function () {
          if (angular.element(this).hasClass('has-error')) {
            result = false;
            return false;
          }
        });
        return result;
      };

      function getFileNameExt(fName) {
        if (fName) {
          var validFile = false;
          var filename = fName.toLowerCase();
          var ext = filename.substr((filename.lastIndexOf('.') + 1));

          if (excludeExtensions.indexOf(ext) == -1) {
            validFile = true;
          }
          return validFile;
        }
      }

      scope.revalidateInputFields = function () {
        quoteFileUploadService.setDataChanged(true);
        scope.inputValueChanged = quoteFileUploadService.getDataChanged();
      };

      scope.checkFileSelect = function (multiFiles) {
        var fileValueArray = [];
        var fileNameArray = [];
        if (multiFiles.length > 0) {
          angular.forEach(multiFiles, function (singleFile, index) {
            if (getFileNameExt(singleFile.name) && singleFile.value.size <= 524288000) {
              scope.revalidateInputFields();
              fileValueArray.push(singleFile.value);
              fileNameArray.push(singleFile.name);
              var validateSheetForm = scope.form_validate('stepTwoForm');
              scope.validationFail = !validateSheetForm;
              if (index === multiFiles.length - 1) {
                scope.setPdfFiles(fileValueArray, fileNameArray);
                return true;
              }
            } else {
              notificationService.invalidFileError(singleFile.name);
              scope.$apply();
              return false;
            }
          })
        } else {
          return true;
        }
      };

      scope.pageNumbersTooltipText = $rootScope.getWord('PageNumbersInfo');
      var duplicateQuantityMessage = $rootScope.getWord('DuplicateQuantityMessage');

      var decimalRegexFour = /^(?:-?\d*\.?\d{1,4}|\d+)$/;
      var FourDecimalRegexMessage = {
        en_US: $rootScope.getWord('FourDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('FourDecimalPlacesNum'),
        en_CA: $rootScope.getWord('FourDecimalPlacesNum')
      };

      var RequiredField = {
        en_US: $rootScope.getWord('RequiredField'),
        fr_CA: $rootScope.getWord('RequiredField'),
        en_CA: $rootScope.getWord('RequiredField')
      };

      var eitherBindOrFinishingRequired = {
        en_US: $rootScope.getWord('EitherBindOrFinishingRequired'),
        fr_CA: $rootScope.getWord('EitherBindOrFinishingRequired'),
        en_CA: $rootScope.getWord('EitherBindOrFinishingRequired')
      };

      var finishingSizeInvalidMessage = $rootScope.getWord('ValueBetweenZeroAndHundred');

      var wideFormatInvalidMessage = $rootScope.getWord('ValueBetweenZeroAndThousand');

      var FourDecimalInvalidMessage = $rootScope.getWord('FourDecimalPlacesNum');

      var form = angular.element('#stepTwoForm');

      var validateFinishingSize = function (val) {
        if (scope.item.productType == scope.productEnums.wideFormat) {
          if (val > 0 && val <= 999 && decimalRegexFour.test(val)) {
            return true;
          } else {
            return {
              valid: false,
              message: !decimalRegexFour.test(val) && !isNaN(val) && val ? FourDecimalInvalidMessage : wideFormatInvalidMessage
            }
          }
        } else {
          if (val > 0 && val <= 100 && decimalRegexFour.test(val)) {
            return true;
          } else {
            return {
              valid: false,
              message: !decimalRegexFour.test(val) && !isNaN(val) && val ? FourDecimalInvalidMessage : finishingSizeInvalidMessage
            }
          }
        }
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {
          // valid: 'glyphicon',
          // invalid: 'glyphicon glyphicon-remove',
          // validating: 'glyphicon glyphicon-refresh'
        },

        addOns: {
          i18n: {},
          mandatoryIcon: {
            //     icon: !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          cboProductTypeName: {
            excluded: false,
            validators: {
              notEmpty: {}
            }
          },
          txtItemTemplate: {
            validators: {}
          },
          txtItemName: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 100
              }
            }
          },
          'option[]': {
            validators: {
              digits: {},
              between: {
                min: 1,
                max: 10000000
              },
              callback: {
                message: RequiredField,
                callback: function (value, validator, $field) {
                  var validation_array = [];
                  //TODO: Need to rework on this to enable live validation on change of Quantity - SR
                  validation_array.push(scope.item.quantity);
                  scope.item.quantityVariations
                    .map(function (quantityVariation) {
                      validation_array.push(quantityVariation.quantity);
                    });

                  var duplicateQuantities = validation_array.filter(function (val, index, arr) {
                    if (arr.indexOf(val) != index) {
                      return val;
                    }
                  });

                  if (value && duplicateQuantities.length == 0) {
                    scope.isQuantityValid = true;
                    return true;
                  } else {
                    scope.isQuantityValid = false;
                    if (!value) {
                      return false;
                    } else if (duplicateQuantities.length > 0 && value == duplicateQuantities[0]) {
                      return {
                        valid: false,
                        message: duplicateQuantityMessage
                      }
                    } else {
                      return true;
                    }
                  }
                }
              }
            }
          },
          'variationOption[]': {
            validators: {
              notEmpty: {}
            }
          },
          txtItemNotes: {
            validators: {
              stringLength: {
                trim: true,
                min: 1,
                max: 500
              }
            }
          },
          txtComponentName: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 50
              }
            }
          },
          txtTabCount: {
            validators: {
              digits: {},
              notEmpty: {},
              between: {
                min: 1,
                max: 999
              }
            }
          },
          txtWidth: {
            validators: {
              notEmpty: {},
              numeric: {},
              callback: {
                callback: function (val) {
                  return validateFinishingSize(val)
                }
              }
            }
          },
          txtHeight: {
            validators: {
              notEmpty: {},
              numeric: {},
              callback: {
                callback: function (val) {
                  return validateFinishingSize(val)
                }
              }
            }
          },
          cboNumberOfSides: {
            validators: {
              notEmpty: {},
              callback: {
                message: RequiredField,
                callback: function (value, validator) {
                  return value != '0';
                }
              }
            }
          },
          txtNumberOfPages: {
            excluded: function ($field, validator) {
              return scope.item.productType == scope.productEnums.flatSheet || scope.item.productType == scope.productEnums.envelope || scope.item.productType == scope.productEnums.wideFormat;
            },
            validators: {
              digits: {},
              between: {
                min: 1,
                max: 10000000
              },
              callback: {
                message: RequiredField,
                callback: function (value, validator) {
                  if (!value && (scope.item.productType == scope.productEnums.finishingOnly || scope.item.productType == scope.productEnums.copies))
                    return true;
                  else if ((scope.component.itemComponentType == scope.componentTypeEnums.standard) && !value)
                    return false;
                  else if (!scope.component.itemComponentType && !value)
                    return false;
                  return true;
                }
              }
            }
          },
          cboBleedOffset: {
            excluded: function ($field, validator) {
              return scope.component ? scope.component.itemComponentBleed.hasBleeds ? false : true : true;
            },
            validators: {
              notEmpty: {}
            }
          },
          cboBleedTop: {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 2
              },
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              }
            }
          },
          cboBleedRight: {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 2
              },
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              }
            }
          },
          cboBleedBottom: {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 2
              },
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              }
            }
          },
          cboBleedLeft: {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 2
              },
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              }
            }
          },
          cboMaterial: {
            excluded: function ($field, validator) {
              return scope.item ? scope.item.productType == scope.productEnums.finishingOnly ? true : false : false;
            },
            validators: {
              callback: {
                message: RequiredField,
                callback: function (value, validator) {
                  var materialPresent = false;
                  if (!value) {
                    materialPresent = false;
                  } else if (scope.component.itemComponentType == scope.componentTypeEnums.tab) {
                    _.forEach(scope.tabmaterials, function (mat) {
                      if (mat.id == value)
                        materialPresent = true
                    });
                  } else {
                    _.forEach(scope.materials, function (mat) {
                      if (mat.id == value)
                        materialPresent = true
                    });
                  }
                  return materialPresent;
                }
              }
            }
          },
          txtPageNumbers: {
            validators: {
              notEmpty: {},
              callback: {
                callback: function (value) {
                  if (scope.isExceptionPageEnabled) {
                    pageNumberValidator.setPageCountCheckFlag(true);
                    pageNumberValidator.setTabCount(document.getElementById('txtNumberOfPages').value);
                  } else {
                    pageNumberValidator.setPageCountCheckFlag(false);
                  }
                  var result = pageNumberValidator.isValid(value);
                  scope.tabCount = pageNumberValidator.getCountFromPageNumbers();
                  return result;
                }
              }
            }
          },
          cboPrimaryBind: {
            excluded: false,
            validators: {
              callback: {
                message: eitherBindOrFinishingRequired,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.item && (scope.item.productType == scope.productEnums.finishingOnly)) {
                    var field1 = document.getElementById('cboPrimaryBind').value;
                    var field2 = document.getElementById('cboFinishingOptions').value;
                    isEmpty = !!(field1 || field2);
                  }
                  return isEmpty
                }
              }
            }
          },
          cboFinishingOptions: {
            excluded: false,
            validators: {
              callback: {
                message: eitherBindOrFinishingRequired,
                callback: function (value, validator, $field) {
                  var isEmpty = true;
                  if (scope.item && (scope.item.productType == scope.productEnums.finishingOnly)) {
                    var field1 = document.getElementById('cboPrimaryBind').value;
                    var field2 = document.getElementById('cboFinishingOptions').value;
                    isEmpty = !!(field1 || field2);
                  }
                  return isEmpty;
                }
              }
            }
          },
          'variationFields[]': {
            validators: {
              notEmpty: {},
              callback: {
                callback: function (value, validator) {
                  if (value == '0') {
                    return false
                  }
                  return true;
                }

              }
            }
          },
          // 'cboVariationMaterial': {
          //   validators: {
          //    notEmpty : {}
          //   }
          // },
          'cboVariationBleed[]': {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 2
              },
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              }
            }
          }
        },

        onSuccess: function (e, data) {
          // Checking whether at least one component has Bind for Books/Pads product Type
          scope.isByPassEnabled = undefined;
          if (scope.item.productType == scope.productEnums.pads || scope.item.productType == scope.productEnums.books) {
            scope.isByPassEnabled = 'disable';
            scope.item.itemComponents.map(function (comp, idx) {
              if (comp.bindId) {
                scope.isByPassEnabled = 'enable';
              }
            })
          }

          // Checking whether at least one standard component is present for multiFlatSheet product Type
          scope.isStandardExist = undefined;
          if (scope.item.productType == scope.productEnums.multiFlatSheet) {
            scope.isStandardExist = 'disable';
            scope.item.itemComponents.map(function (comp, idx) {
              if (comp.itemComponentType == scope.componentTypeEnums.standard) {
                scope.isStandardExist = 'enable';
              }
            })
          }

          // Checking whether page numbers matches with tab count for tab component
          scope.checkTabCountFlag = false;
          if (scope.component.itemComponentType == scope.componentTypeEnums.tab) {
            pageNumberValidator.setTabCount(scope.component.material.pageCount);
            scope.checkTabCountFlag = true;
          }

          e.preventDefault();
          // scope.submitConfig();
        }
      }).on('err.field.fv', function (e, data) {
        scope.validComponent = false;
      }).on('click', function (e, data) {
        if (scope.validComponent)
          scope.validComponent = false;
      })

        // Add button click handler
        .on('click', '.addButton', function () {
          angular.element('#stepTwoForm').formValidation('revalidateField', 'option[]', true);
          if (scope.isQuantityValid) {
            var $template = angular.element('#optionTemplate'),
              $clone = $template
                .clone()
                .removeClass('hide')
                .removeAttr('id')
                .addClass('variationQuantity')
                .insertBefore($template),
              $option = $clone.find('[name="option[]"]');
            $option.change(function () {
              scope.changeQuantity(this.id, parseInt(this.value));
              angular.element('#stepTwoForm').formValidation('revalidateField', 'option[]', true);
            });

            var guid = guidService.newGuid();
            scope.item.quantityVariations.push(
              {
                id: guid,
                quantity: 0
              });
            $option.attr('id', guid);
            // Add new field
            form.formValidation('addField', $option);
          }
          // deliveryMethodService.initializeShipToRecipients(scope.item.quantity);
          // deliveryMethodService.resetRecipients();
          // scope.shipToRecipients = deliveryMethodService.getShipToRecipients();
          // recipientInfoService.initializeRecipientInfo();
          // quoteModelService.setRecipientInfo([], scope.item.id);
          // scope.item.shipToQuantity = [];
          // scope.invalidQuantity = false;
          // scope.notANumber = false;
        })

        // Remove button click handler
        .on('click', '.removeButton', function () {
          var $row = angular.element(this).parents('.form-group'),
            $option = $row.find('[name="option[]"]');

          // Remove element containing the option
          $row.remove();
          itemConfigurationService.removeQuantity($option[0].id);

          // Remove field
          form.formValidation('removeField', $option);
        })
        // File Upload
        .on('click', '#txtItemFile', function () {
          this.value = null;
        })

        .on('change', '#txtItemFile', function (e, data) {
          scope.multiFile = [];
          if (e.target.files.length > 0) {
            angular.element.each(e.target.files, function (key, value) {
              scope.multiFile.push({
                name: value.name,
                value: value
              })
            })
          } else {
            scope.multiFile = [];
          }
          form.formValidation('revalidateField', 'txtItemFile');
          var validateSheetForm = scope.form_validate('stepTwoForm');
          scope.validationFail = !validateSheetForm;
          scope.checkFileSelect(scope.multiFile);
        })
        // Re-validating Bind and Finishing Fields for Finishing Only Product Type onchange
        .on('change', '#cboFinishingOptions', function (e, data) {
          reValidateFields();
        })
        .on('change', '#cboPrimaryBind', function (e, data) {
          reValidateFields();
        })
        .on('click', '.selectize-input', function (e, data) {
          if (!e.target.textContent || e.target.parentNode.classList.contains('multi')) {
            angular.element('.selectize-dropdown-content').animate({ scrollTop: (0) });
          }
        });

      function reValidateFields() {
        form.formValidation('revalidateField', 'cboPrimaryBind');
        form.formValidation('revalidateField', 'cboFinishingOptions');
      }
    }
  }
}
);



/**
 * Created by $ingh on 5/4/2018.
 */

angular.module('app.quote').directive('askOperationModal', function (operationsService, multiComponentService, variationService, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/askOperationModal.tpl.html',

    link: function (scope, form) {
      angular.element('#askOperationModal').on('shown.bs.modal', function (e) {
        scope.askObj = {};
        form.formValidation('resetForm', true);
        scope.askObj.name = operationsService.getCurrentAskName();
        scope.askObj.askLabel = operationsService.getAskLabel();
        $timeout(function () {
          scope.$apply();
        })
      });

      angular.element('#askOperationModal').on('hide.bs.modal', function (e) {

        if (variationService.getVariationAskProperties().isVariationAsk) {
          if (scope.askSelected) {
            scope.askSelected = false;
            angular.element('#askOperationModal').removeClass('fade');
            variationService.setFinishingOptionVariation(variationService.getVariationAskProperties().rowId, operationsService.getAskFinishingId(), scope.askObj);
            variationService.setVariationAskProperties(null, false, variationService.getVariationAskProperties().index);
            scope.$apply()
          }
          else {
            var index = variationService.getVariationAskProperties().index;
            var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
            variationService.setLegitVariationAddAction(false);
            variationFinishingOption[0].selectize.removeItem(operationsService.getAskFinishingId(), true);
            variationService.setLegitVariationAddAction(true);
          }
        }
        else if (!variationService.getVariationAskProperties().isVariationAsk && scope.askSelected) {
          scope.askSelected = false;
          operationsService.setAskFinishingOptions(multiComponentService.getCurrentComponent().finishingOptions, scope.askObj.inputQuantity);
        }
        else {
          var finishingDropdown = multiComponentService.getFinishingOptionSelectize();
          finishingDropdown[0].selectize.removeItem(operationsService.getAskFinishingId());
        }
        angular.element('#askOperationModal').removeClass('fade');
      });

      scope.submitAskOperation = function () {
        scope.askSelected = true;
        angular.element('#askOperationModal').removeClass('fade');
        angular.element('#askOperationModal').modal('hide');
      };
      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {
          txtInputQuantity: {
            validators: {
              notEmpty: {},
              digits: {},
              between: {
                min: 1,
                max: 10000000
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitAskOperation()
        },
        live: 'enabled'
      });

    }
  }
});


/**
 * Created by sreddy on 3/8/2018.
 */

angular.module('app.quote').directive('adhocCustomServiceModal', function ($rootScope, formValidationKeyService, multiComponentService, variationService, genericQuotesService, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/quote/partials/stepTwo/adhocCustomServiceModal.tpl.html',

    link: function (scope, form) {
      scope.adHocService = multiComponentService.getAdHocModel();
      // Hard Coded Cost Types for Adhoc
      scope.adhocCostTypes = [{ value: "adHocMachineCost" }, { value: "adHocMaterialCost" }, { value: "adHocLaborCost" }];
      scope.localisedCostTypes = [];
      scope.adhocCostTypes.map(function (costType) {
        scope.localisedCostTypes.push({
          name: $rootScope.getWord(costType.value),
          value: costType.value
        });
      });

      scope.clearCostTypeFields = function () {
        scope.adHocService.quantityBy = '';
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'cboQuantityByForCostType', true);
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'txtSpeedForCostType', true);
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'txtRateForCostType', true);
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'txtUnitMeasureForMaterialCost', true);
      };

      scope.clearQuantityField = function (selectedQuantityBy, costType) {
        angular.element('#adHocCustomServiceModal').formValidation('resetField', 'txtQuantityForCostType', true);
      };

      scope.cancelAddHoc = function () {
        var customAdHocIds = [];
        angular.forEach(scope.component.finishingOptions, function (option) {
          if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
            customAdHocIds.push(option.finishingId);
          }
        });
      };

      angular.element('#adHocCustomServiceModal').on('hide.bs.modal', function (e) {
        scope.adHocService.customServiceName = angular.element('#txtCustomServicesName').val();
        //If AdHoc Modal was opened for variations
        if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
            variationService.setFinishingOptionVariation(variationService.getVariationAdHocProperties().rowId, '00000000-0000-0000-0000-000000000000', scope.adHocService);
            angular.element('#adHocCustomServiceModal').removeClass('fade');
            scope.getAdHocTags(variationService.getVariationAdHocProperties().rowId, scope.adHocService.customServiceName);
            variationService.setVariationAdHocProperties(null, false, variationService.getVariationAdHocProperties().index);
            scope.$apply()
          } else {
            var variationAdHocIds = [];
            _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
              if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                _.forEach(variation.finishingOptions, function (option) {
                  if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                    variationAdHocIds.push(option.finishingId);
                  }
                });
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (variationAdHocIds && (variationAdHocIds.length == 0)) {
              var index = variationService.getVariationAdHocProperties().index;
              var variationFinishingOption = angular.element('#cboVariationFinishingOptions' + index).selectize();
              variationService.setLegitVariationAddAction(false);
              variationFinishingOption[0].selectize.removeItem("00000000-0000-0000-0000-000000000000", true);
              variationService.setLegitVariationAddAction(true);
            }
          }
        }
        //If AdHoc Modal was opened for base finishing options
        else {
          //If submit buttom is clicked then save it
          if (scope.addHocSelected) {
            scope.addHocSelected = false;
            multiComponentService.setFinishingOption(multiComponentService.getCurrentFinishingIds(), scope.adHocService)
          }
          //This triggers if user clicks outside of the modal or press esc
          else {
            var customAdHocIds = [];
            angular.forEach(scope.component.finishingOptions, function (option) {
              if (option.finishingId == "00000000-0000-0000-0000-000000000000") {
                customAdHocIds.push(option.finishingId);
              }
            });
            //If current adHoc is the only adHoc and canceling the modal, then it should be removed
            if (customAdHocIds && (customAdHocIds.length == 0)) {
              var finishingDropdown = multiComponentService.getFinishingOptionSelectize();
              finishingDropdown[0].selectize.removeItem("00000000-0000-0000-0000-000000000000");
            }
          }
          angular.element('#adHocCustomServiceModal').removeClass('fade');
          scope.finishingTags = multiComponentService.getAdHockTags();
          $timeout(function () {
            scope.$apply()
          })
        }
      });

      angular.element('#adHocCustomServiceModal').on('shown.bs.modal', function (e) {
        scope.adHocService = {};
        angular.element('#adHocCustomServiceModal').data('formValidation').resetForm(true);
        $timeout(function () {
          scope.$apply();
        })
      });

      scope.submitAddHoc = function () {
        scope.addHocSelected = true;
        angular.element('#adHocCustomServiceModal').removeClass('fade');
        angular.element('#adHocCustomServiceModal').modal('hide');
      };

      var decimalMin = 0;
      var decimalMax = 9999999;
      var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
      var decimalRegexFour = /^(?:-?\d*\.?\d{1,4}|\d+)$/;
      var TwoDecimalRegexMessage = {
        en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
        en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
      };
      var FourDecimalRegexMessage = {
        en_US: $rootScope.getWord('FourDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('FourDecimalPlacesNum'),
        en_CA: $rootScope.getWord('FourDecimalPlacesNum')
      };

      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {
            // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtCustomServicesName: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 1,
                max: 100
              },
              callback: {
                message: {
                  en_US: $rootScope.getWord('DuplicateAdHoc'),
                  fr_CA: $rootScope.getWord('DuplicateAdHoc'),
                  en_CA: $rootScope.getWord('DuplicateAdHoc')
                },
                callback: function (value, validator) { //Validate date to be the current or after current date.
                  var flag = true;
                  if (variationService.getVariationAdHocProperties().isVariationAdHoc) {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptionsVariations, function (variation) {
                      if (variation.id == variationService.getVariationAdHocProperties().rowId) {
                        _.forEach(variation.finishingOptions, function (option) {
                          if (option.finishingId == "00000000-0000-0000-0000-000000000000" && option.adHocOperation.customServiceName == value) {
                            flag = false
                          }
                        });
                      }
                    });
                  } else {
                    _.forEach(multiComponentService.getCurrentComponent().finishingOptions, function (option) {
                      if (option.finishingId == '00000000-0000-0000-0000-000000000000' && option.adHocOperation.customServiceName == value) {
                        flag = false
                      }
                    });
                  }
                  return flag;
                }

              }
            }
          },

          chkMarkAsBuyOutForCostType: {
            validators: {}
          },

          costTypeForAhoc: {
            validators: {
              notEmpty: {}
            }
          },

          cboQuantityByForCostType: {
            validators: {
              notEmpty: {}
            }
          },

          txtQuantityForCostType: {
            group: '.col-lg-2',
            validators: {
              notEmpty: {},
              digits: {},
              between: {
                min: 1,
                max: 10000000
              }
            }
          },

          txtSpeedForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtRateForCostType: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          },

          txtUnitMeasureForMaterialCost: {
            group: '.col-lg-2',
            validators: {
              numeric: {},
              notEmpty: {},
              regexp: {
                regexp: decimalRegexFour,
                message: FourDecimalRegexMessage
              },
              between: {
                min: decimalMin,
                max: decimalMax
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.submitAddHoc()
        },

        live: 'enabled'

      });
      // form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }
  }
});


/**
 * Created by sreddy on 3/6/2018.
 */

angular.module('app.quote').directive('quoteSummaryView', function (itemTabService,
                                                                    $rootScope,
                                                                    formValidationKeyService,
                                                                    itemSummaryService,
                                                                    deliveryMethodService,
                                                                    genericQuotesService,
                                                                    $location,
                                                                    manageStatesService,
                                                                    wizardNavigationService,
                                                                    itemConfigurationService,
                                                                    convertQuoteService,
                                                                    multiComponentService,
                                                                    $state,
                                                                    $stateParams,
                                                                    componentTabService,
                                                                    userRolesService,
                                                                    recipientInfoService) {
  return {
    restrict: 'EA',
    replace: false,
    link: function (scope, form) {
      scope.rolesEnum = userRolesService.getUserNames();
      /***********************************************************************************************
       * Get Enum types from Service
       **********************************************************************************************/
      scope.deliveryMethodEnums = itemSummaryService.getDeliveryMethodEnums();
      scope.serviceLevelEnums = deliveryMethodService.getServiceLevelEnum();
      scope.importedEnums = genericQuotesService.getEnumValues();
      scope.operationTypeEnums = itemSummaryService.getOperationTypeEnums();
      scope.sidesEnums = scope.importedEnums.sides;
      scope.productTypeEnums = scope.importedEnums.productTypes;
      scope.collateTypeEnums = scope.importedEnums.collateMethods;
      scope.productEnums = genericQuotesService.getProductEnums();
      scope.componentTypeEnums = genericQuotesService.getComponentTypeEnums();

      /***********************************************************************************************
       * Initial Data
       **********************************************************************************************/
      scope.itemSummary = true;
      scope.quoteHeaderInfo = itemSummaryService.getQuoteHeaderData();
      scope.quoteShipToInfo = scope.quoteHeaderInfo.customerInfo.quoteShipTo;
      scope.availablePickupStores = deliveryMethodService.getStores();
      scope.quoteId = itemSummaryService.getQuoteId();
      scope.costingFacilityTooltipText = $rootScope.getWord('CostingFacilityInfo');

      /***********************************************************************************************
       * Edit Item Logic
       **********************************************************************************************/
      scope.summaryEditItem = function (itemId) {
        if ($stateParams.quoteId) {
          $state.go('app.quote.createQuote.step_two', {
            id: $stateParams.quoteId,
            editItem: true,
            toStep: 2,
            itemId: itemId,
            incomingFromQuote: true
          })
        } else {
          var items = itemConfigurationService.getAllItems();
          var itemIndex = 0;
          _.forEach(items, function (item, index) {
            if (item.id == itemId) {
              itemIndex = index;
            }
          });

          itemConfigurationService.setCurrentItem(itemConfigurationService.getAllItems()[itemIndex]);
          itemConfigurationService.setCurrentItemIndex(itemIndex);
          itemTabService.updateItemTabs(itemIndex);
          multiComponentService.initializeMultiComponent();
          var currentItem = itemConfigurationService.getCurrentItem();
          itemConfigurationService.saveCurrentItem(currentItem.itemComponents);
          multiComponentService.setAllComponents(currentItem.itemComponents);
          multiComponentService.setCurrentComponent(0);
          componentTabService.updateComponentTabs(0);
          manageStatesService.setLegitPreviousAction(true);
          wizardNavigationService.setCurrentState(2);
          wizardNavigationService.disableAllNavs();
          wizardNavigationService.setNav();
          $location.path('/index/quoteEdit/step_two/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
        }
      };

      /***********************************************************************************************
       * Create New Item Logic
       **********************************************************************************************/
      scope.summaryCreateNewItem = function () {
        if ($stateParams.quoteId) {
          $state.go('app.quote.createQuote.step_two', {
            id: $stateParams.quoteId,
            createItem: true,
            toStep: 2,
            incomingFromQuote: true
          })
        } else {
          var newIndex = itemConfigurationService.getAllItems().length;
          itemTabService.addItemTab(newIndex);
          itemConfigurationService.addItem();
          itemConfigurationService.setCurrentItem(itemConfigurationService.getAllItems()[newIndex]);
          itemConfigurationService.setCurrentItemIndex(newIndex);
          itemTabService.updateItemTabs(newIndex);
          itemTabService.setItemName(itemConfigurationService.getCurrentItem().itemName);
          itemConfigurationService.setItemValidated(newIndex);
          multiComponentService.initializeMultiComponent();
          manageStatesService.setLegitPreviousAction(true);
          wizardNavigationService.setCurrentState(2);
          wizardNavigationService.disableAllNavs();
          wizardNavigationService.setNav();
          $location.path('/index/quoteEdit/step_two/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
        }
      };

      /***********************************************************************************************
       * Duplicate Item Logic
       **********************************************************************************************/
      scope.summaryDuplicateItem = function () {
        if ($stateParams.quoteId) {
          $state.go('app.quote.createQuote.step_two', {
            id: $stateParams.quoteId,
            duplicateItem: true,
            toStep: 2,
            incomingFromQuote: true
          })
        } else {
          var cloneItemIndex = itemSummaryService.getCurrentItemIndex();
          var newIndex = itemConfigurationService.getAllItems().length;
          itemTabService.addItemTab(newIndex);
          itemConfigurationService.addItem();
          var multiItems = itemConfigurationService.getAllItems();
          var prevItem = multiItems[cloneItemIndex];
          var newItem = multiItems[newIndex];
          var tempObj = _.cloneDeep(prevItem);
          tempObj.id = newItem.id;
          tempObj.itemNumber = newItem.itemNumber;
          tempObj.files = [];
          multiItems[newIndex] = tempObj;
          itemConfigurationService.setAllItems(multiItems);
          itemConfigurationService.setCurrentItem(multiItems[newIndex]);
          recipientInfoService.duplicateRecipientInfo(prevItem.id, newItem.id);
          var allMultiComponents = multiComponentService.getAllComponents();
          itemConfigurationService.saveCurrentItem(allMultiComponents);
          itemConfigurationService.setCurrentItemIndex(newIndex);
          itemTabService.updateItemTabs(newIndex);
          multiComponentService.initializeMultiComponent();
          var itemComponents = multiItems[newIndex].itemComponents;
          itemComponents = _.map(itemComponents);
          multiComponentService.setAllComponents(itemComponents);
          componentTabService.setCurrentComponentTabIndex(0);
          componentTabService.updateComponentTabs(0);
          multiComponentService.setCurrentComponent(0);
          itemTabService.setItemName(itemConfigurationService.getCurrentItem().itemName);
          manageStatesService.setLegitPreviousAction(true);
          wizardNavigationService.setCurrentState(2);
          wizardNavigationService.disableAllNavs();
          wizardNavigationService.setNav();
          $location.path('/index/quoteEdit/step_two/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
        }
      };


      /***********************************************************************************************
       * Manipulating Json for Active tab
       **********************************************************************************************/
      scope.manipulateJson = function (items, selectedIndex) {
        return items.map(function (item, index) {

          // Making Active for Selected Item
          item.active = index === selectedIndex;

          // Checking selected variation
          if ($state.current.url.indexOf('convertQuote') >= 0) {
            angular.forEach(convertQuoteService.getSelectedVariations(), function (val) {
              if (val.itemId == items[selectedIndex].id) {
                scope.resetVarSelectBtn();
                setTimeout(function () {
                  angular.element('#variationSelectBtn' + val.index).find('.btn').removeClass('btn-default').addClass('btn-success');
                  angular.element('#variationSelectBtn' + val.index).find('.btn-success').html('Selected');
                }, 150)
              } else {
                scope.resetVarSelectBtn();
              }
            });

            // Logic to find Selected Variation in View Only Mode for Converted Status
            if ($state.params.viewOnly) {
              angular.forEach(item.itemVariationCosts, function (itemVariation, variationIndex) {
                if (itemVariation.variationId == item.selectedVariationId) {
                  item.selectedVariationViewIndex = variationIndex;
                }
                if (variationIndex == item.itemVariationCosts.length - 1) {
                  if (!item.selectedVariationViewIndex && item.selectedVariationViewIndex != 0) {
                    item.selectedVariationViewIndex = null;
                  }
                }
              })
            }
          }

          // Converting product Type Enum value to respective Enum name
          angular.forEach(scope.productTypeEnums, function (productType) {
            if (productType.value == item.productType) {
              item.productTypeEnum = productType;
            }
          });

          // Dynamic Quantity Label text for product type pads
          item.quantityLabelText = (item.productTypeEnum.productType != scope.productEnums.pads) ? $rootScope.getWord('Quantity') : $rootScope.getWord('NumberOfPads');

          // Converting delivery method Enum value to respective Enum name
          for (var deliveryMethodKey in scope.deliveryMethodEnums) {
            if (deliveryMethodKey == item.shippingMethodName) {
              item.deliveryMethodEnum = {
                name: $rootScope.getWord(scope.deliveryMethodEnums[deliveryMethodKey]),
                value: deliveryMethodKey
              };
            }
          }

          // Logic to pull to Quote Ship Info through id
          if (item.shippingMethodName === 20) {
            item.deliveryInfo = [];
            angular.forEach(scope.quoteShipToInfo, function (value) {
              if (value.itemId == item.id) {
                item.deliveryInfo
                  .push(((value.fullName) ? value.fullName : "") + (((value.fullName) && (value.address1 || value.address2 || value.address3 || value.city || value.state || value.postalCode || value.country)) ? ' -' : "") +
                    ((value.address1) ? ' ' + value.address1 : "") + ((value.address2) ? ' ' + value.address2 : "") + ((value.address3) ? ' ' + value.address3 : "") + (((value.address1 || value.address2 || value.address3) && (value.city || value.state || value.postalCode || value.country)) ? ' -' : "") +
                    ((value.city) ? ' ' + value.city : "") + ((value.city && value.state) ? ',' : "") + ((value.state) ? ' ' + value.state : "") + (((value.city || value.state) && (value.postalCode || value.country)) ? ' -' : "") +
                    ((value.postalCode) ? ' ' + value.postalCode : "") + ((value.postalCode && value.country) ? ',' : "") + ((value.country) ? ' ' + value.country : ""));
                angular.forEach(scope.serviceLevelEnums, function (shippingValue) {
                  if (value.serviceLevel == shippingValue.code) {
                    item.shippingServiceLevel = shippingValue.name
                  }
                })
              }
            })
          }
          // Logic to pull Pickup Info through external Code
          else if (item.shippingMethodName === 10) {
            item.deliveryInfo = [];
            angular.forEach(scope.availablePickupStores, function (pickupStore) {
              if (item.customerSelectedStoreId == pickupStore.externalCode) {
                item.deliveryInfo
                  .push(((pickupStore.externalId) ? pickupStore.externalId : "") + (((pickupStore.externalId) && (pickupStore.address1 || pickupStore.address2 || pickupStore.address3 || pickupStore.city || pickupStore.state || pickupStore.postalCode || pickupStore.countryCode)) ? ' -' : "") +
                    ((pickupStore.address1) ? ' ' + pickupStore.address1 : "") + ((pickupStore.address2) ? ' ' + pickupStore.address2 : "") + ((pickupStore.address3) ? ' ' + pickupStore.address3 : "") + (((pickupStore.address1 || pickupStore.address2 || pickupStore.address3) && (pickupStore.city || pickupStore.state || pickupStore.postalCode || pickupStore.countryCode)) ? ' -' : "") +
                    ((pickupStore.city) ? ' ' + pickupStore.city : "") + ((pickupStore.city && pickupStore.state) ? ',' : "") + ((pickupStore.state) ? ' ' + pickupStore.state : "") + (((pickupStore.city || pickupStore.state) && (pickupStore.postalCode || pickupStore.countryCode)) ? ' -' : "") +
                    ((pickupStore.postalCode) ? ' ' + pickupStore.postalCode : "") + ((pickupStore.postalCode && pickupStore.countryCode) ? ',' : "") + ((pickupStore.countryCode) ? ' ' + pickupStore.countryCode : ""));
              }
            })
          }

          // Costing Facility Logic
          var isFacilityExists = false;
          angular.forEach(item.itemVariationCosts, function (itemVariation) {
            if (itemVariation.itemCost && itemVariation.itemCost.jobCostingFacilityCode && !isFacilityExists) {
              item.CostingFacility = itemVariation.itemCost.jobCostingFacilityName;
              isFacilityExists = true;
            }
          });

          return item;
        });
      };

      /***********************************************************************************************
       * Initial Item Data Set up
       **********************************************************************************************/
      scope.tabIndex = (itemSummaryService.getCurrentItemIndex()) ? itemSummaryService.getCurrentItemIndex() : 0;
      scope.summaryItemData = scope.manipulateJson(itemSummaryService.getItemSummaryData(), scope.tabIndex);
      scope.summaryCurrentItem = scope.summaryItemData[scope.tabIndex];
      scope.itemFiles = scope.summaryCurrentItem.files;
      scope.itemDeliveryInfo = scope.summaryCurrentItem.deliveryInfo;
      itemSummaryService.setCurrentItemId(scope.summaryCurrentItem.id);
      itemSummaryService.setCurrentItemIndex(scope.tabIndex);
      getColSpan();

      /***********************************************************************************************
       * Get Col Span Logic
       **********************************************************************************************/
      function getColSpan() {
        var enterFlag = true;
        scope.variationColSpan = '2';
        scope.tokenColSpan = '';
        scope.tokenColumn = false;
        angular.forEach(scope.summaryCurrentItem.itemVariationCosts, function (variation) {
          if (variation.jdfShortId && enterFlag) {
            scope.variationColSpan = '';
            scope.tokenColSpan = '2';
            scope.tokenColumn = true;
            enterFlag = false;
          }
        })
      }

      /***********************************************************************************************
       * Download File Functionality
       **********************************************************************************************/
      scope.downloadFile = function (file) {
        itemSummaryService.downloadFileApiCall(file);
      };

      /***********************************************************************************************
       * Get Item Info on Click of Item Tab
       **********************************************************************************************/
      scope.expandItem = function (index) {
        scope.tabIndex = index;
        scope.summaryItemData = scope.manipulateJson(itemSummaryService.getItemSummaryData(), index);
        scope.summaryCurrentItem = scope.summaryItemData[index];
        scope.itemFiles = scope.summaryCurrentItem.files;
        scope.itemDeliveryInfo = scope.summaryCurrentItem.deliveryInfo;
        itemSummaryService.setCurrentItemId(scope.summaryCurrentItem.id);
        itemSummaryService.setCurrentItemIndex(index);
      };

      /***********************************************************************************************
       *View Mode for Totals(Convert Quote and Quote History)
       **********************************************************************************************/
      if (($state.current.url.indexOf('convertQuote') >= 0) || ($stateParams.viewQuote && $stateParams.versionId)) {
        angular.element('#detailTotals').find('.col-lg-5').removeClass('col-sm-5 col-md-5 col-lg-5').addClass('col-sm-6 col-md-6 col-lg-6').find('b').addClass('pull-right');
        angular.element('#detailTotals').find('.col-lg-6').removeClass('m-l').removeClass('m-l-n');
      }

      /***********************************************************************************************
       * For Covert Quote
       **********************************************************************************************/
      if ($state.current.url.indexOf('convertQuote') >= 0) {
        itemSummaryService.itemChangeUpdate(false, false);
        scope.serviceVariable = itemSummaryService;
        scope.$watch('serviceVariable.getNextEnableFlag()', function (newValue, oldValue) {
          scope.tabIndex = itemSummaryService.getCurrentItemIndex();
          if (itemSummaryService.getReviewEnableFlag()) {
            if (scope.tabIndex < scope.summaryItemData.length - 1 && itemSummaryService.getNextEnableFlag()) {
              scope.tabIndex++;
              scope.expandItem(scope.tabIndex);
              if (!scope.itemSummary) {
                scope.variationDetails(0)
              }
            }
          }
        });
      }

      /***********************************************************************************************
       * Route to respective variation detail on click
       **********************************************************************************************/
      scope.variationDetails = function (index) {
        if ($state.current.url.indexOf('convertQuote') == -1) scope.closeWarningAlert();
        scope.markupCheckBox = false;
        scope.shippingCheckBox = false;
        scope.selectedVariationIndex = index;
        scope.shippingCostTooltipText = $rootScope.getWord('ShippingCostInfo');
        scope.totalVariations = scope.summaryCurrentItem.itemVariationCosts.length;
        scope.selectedVariation = scope.summaryCurrentItem.itemVariationCosts[index];
        scope.selectedVariationSubTotal = scope.selectedVariation.itemCost.subtotal ? scope.selectedVariation.itemCost.subtotal : (scope.selectedVariation.itemCost.totalPrice - scope.selectedVariation.itemCost.shippingCost);
        scope.markup = scope.selectedVariation.itemCost.markup ? scope.selectedVariation.itemCost.markup : 0;
        scope.defaultShippingCost = (scope.selectedVariation.itemCost.overrideShippingCost != null) ? scope.selectedVariation.itemCost.overrideShippingCost : scope.selectedVariation.itemCost.shippingCost;
        scope.newShippingCost = angular.copy(scope.defaultShippingCost);
        scope.newMarkUp = angular.copy(scope.selectedVariation.itemCost.markup) || 0;
        scope.selectedVariationQuantity = scope.selectedVariation.itemCost ? (scope.selectedVariation.itemCost.quantity * scope.selectedVariation.itemCost.numberOfKinds) : null;
        scope.selectedVariationComponents = scope.selectedVariation.itemCost ? scope.selectedVariation.itemCost.components : [];

        // Logic to show Warning Banner for Shipping Cost failure
        if ($state.current.url.indexOf('convertQuote') == -1 && scope.selectedVariation.shippingRatesResponse && scope.selectedVariation.shippingRatesResponse.validSubmission == false) {
          if (scope.selectedVariation.shippingRatesResponse.friendlyErrorMessage) {
            scope.warningBannerFn([{message: scope.selectedVariation.shippingRatesResponse.friendlyErrorMessage}]);
          } else {
            scope.warningBannerFn([{message: $rootScope.getWord('ShippingCostWarningMessage')}]);
          }
        }

        // Initialise to get collapsed
        if (angular.element('#editMarkUp').hasClass('in')) angular.element('#editMarkUp').removeClass('in');
        if (angular.element('#editShippingCost').hasClass('in')) angular.element('#editShippingCost').removeClass('in');
        if (!angular.element('#editMarkUp').hasClass('in')) angular.element('#editMarkUpBtn').addClass('collapsed');
        if (!angular.element('#editShippingCost').hasClass('in')) angular.element('#editShippingBtn').addClass('collapsed');

        // Looping in Components for Color
        angular.forEach(scope.selectedVariationComponents, function (component) {
          // Logic for Dynamic Label for Tab Count
          if (component.jobComponentType == scope.componentTypeEnums.tab) {
            component.tabCountLabelText = $rootScope.getWord('TabCount');
          } else if (scope.summaryCurrentItem.productTypeEnum.value == scope.productEnums.pads) {
            component.tabCountLabelText = $rootScope.getWord('PagesPerPad');
            component.sheetsPerPad = component.setsPerPad ? component.setsPerPad : '';
          } else {
            component.tabCountLabelText = $rootScope.getWord('NoOfPages');
          }

          // Logic for Orientation
          if (component.size && (component.size.finalWidth > component.size.finalHeight)) {
            component.orientation = $rootScope.getWord('Landscape');
          } else if (component.size && (component.size.finalWidth < component.size.finalHeight)) {
            component.orientation = $rootScope.getWord('Portrait');
          } else if (component.size && (component.size.finalWidth === component.size.finalHeight)) {
            component.orientation = $rootScope.getWord('Square');
          }

          // Logic for Front Color
          component.frontColor = component.colorFront.c && component.colorFront.m && component.colorFront.y && component.colorFront.k;
          component.frontBlack = (!component.colorFront.c || !component.colorFront.m || !component.colorFront.y) && component.colorFront.k;

          // Logic for Back Color depending on Sides
          if (component.sides == 1 || component.sides == 2) {
            component.selectedColor = $rootScope.getWord('Color');
          } else if (component.sides == 3 || component.sides == 4) {
            component.selectedColor = $rootScope.getWord('FrontColor');
            component.backColor = component.colorBack.c && component.colorBack.m && component.colorBack.y && component.colorBack.k;
            component.backBlack = (!component.colorBack.c || !component.colorBack.m || !component.colorBack.y) && component.colorBack.k;
          }

          // Logic for Printed Sides
          angular.forEach(scope.sidesEnums, function (sideEnum) {
            if (component.sides == sideEnum.value) {
              component.sideEnumName = sideEnum.name;
            }
          });

          // Logic for Collation
          angular.forEach(scope.collateTypeEnums, function (collateEnum) {
            if (component.collateMethod == collateEnum.value) {
              component.collateEnumName = collateEnum.name;
            }
          });

          // Logic for Dynamic Label text for Print Sheet Size
          switch (scope.selectedVariation.itemCost.productType) {
            case 1 :
              component.componentPrintSheetWidth = component.runSheetWidth;
              component.componentPrintSheetHeight = component.runSheetHeight;
              break;
            case 3 :
              component.componentPrintSheetWidth = component.stockRollWidth;
              component.componentPrintSheetHeight = component.stockRollLength;
              break;
            default:
              component.componentPrintSheetWidth = component.runSheetWidth;
              component.componentPrintSheetHeight = component.runSheetHeight;
              break;
          }

          // Logic for Operation Standard Cost break down
          component.materialCost = [];
          component.pressCost = [];
          component.bindingCost = [];
          component.finishingCost = [];

          angular.forEach(component.operations, function (operation) {
            if (operation.isPrintMedia) {
              component.materialCost.push({
                name: operation.name,
                productionCost: operation.standardProductionCost,
                materialCost: operation.standardMaterialCost,
                laborCost: operation.laborCost,
                buyOutCost: operation.standardBuyOutCost,
                totalCost: operation.totalCost,
                vendorCost: operation.vendorCost
              })
            } else if (operation.operationType == 5 || operation.operationType == 6 || operation.operationType == 14) {
              component.pressCost.push({
                name: operation.name,
                productionCost: operation.standardProductionCost,
                materialCost: operation.standardMaterialCost,
                laborCost: operation.laborCost,
                buyOutCost: operation.standardBuyOutCost,
                totalCost: operation.totalCost,
                vendorCost: operation.vendorCost
              })
            } else if (operation.operationType == 13) {
              component.bindingCost.push({
                name: operation.name,
                productionCost: operation.standardProductionCost,
                materialCost: operation.standardMaterialCost,
                laborCost: operation.laborCost,
                buyOutCost: operation.standardBuyOutCost,
                totalCost: operation.totalCost,
                vendorCost: operation.vendorCost
              })
            } else {
              component.quantityLabel = '';
              if (operation.estimatingAskType) {
                switch (operation.estimatingAskType) {
                  case 1 :
                    component.quantityLabel = $rootScope.getWord('AskQuantity');
                    break;
                  case 2 :
                    component.quantityLabel = $rootScope.getWord('AskTimesItemQuantity');
                    break;
                }
              }

              component.finishingCost.push({
                name: operation.name,
                productionCost: operation.standardProductionCost,
                materialCost: operation.standardMaterialCost,
                laborCost: operation.laborCost,
                buyOutCost: operation.standardBuyOutCost,
                totalCost: operation.totalCost,
                vendorCost: operation.vendorCost,
                quantity: operation.inputQuantity,
                quantityLabel: component.quantityLabel
              });
            }
          })
        });

        /***********************************************************************************************
         * Pagination for Variations
         **********************************************************************************************/
        scope.currentVariation = index + 1;
        scope.disablePrev = (scope.currentVariation === 1);
        scope.disableNext = (scope.currentVariation === scope.totalVariations);
        scope.itemSummary = false;
        scope.variationPaginationInfo(scope.currentVariation, scope.totalVariations);
        angular.element("#summaryFooter").hide();

        /***********************************************************************************************
         * Convert Quote Variation Select Button Logic
         **********************************************************************************************/
        var isVariationIndexMatch = false;
        var selectedItemIndex = '';
        angular.forEach(convertQuoteService.getSelectedVariations(), function (val, idx) {
          if (scope.summaryCurrentItem.id == val.itemId && scope.selectedVariation.variationId == val.variationId) {
            selectedItemIndex = val.index;
            isVariationIndexMatch = true;
          } else {
            selectedItemIndex = scope.currentVariation - 1;
          }
          if (idx >= convertQuoteService.getSelectedVariations().length - 1) {
            if (isVariationIndexMatch && selectedItemIndex == scope.currentVariation - 1) {
              setTimeout(function () {
                angular.element('#variationDetailsSelectBtn' + selectedItemIndex).find('.btn').removeClass('btn-default').addClass('btn-success');
                angular.element('#variationDetailsSelectBtn' + selectedItemIndex).find('.btn-success').html('Selected');
              }, 150)
            } else {
              setTimeout(function () {
                angular.element('#variationDetailsSelectBtn' + selectedItemIndex).find('.btn').removeClass('btn-success').addClass('btn-default');
                angular.element('#variationDetailsSelectBtn' + selectedItemIndex).find('.btn-default').html('Select');
              }, 150)
            }
          }
        });
      };

      scope.previous = function () {
        var variationIndex = angular.copy(scope.currentVariation);
        if (variationIndex > 1) {
          scope.variationDetails(variationIndex - 2);
        } else {
          scope.disablePrev = true;
        }
      };

      scope.next = function () {
        var variationIndex = angular.copy(scope.currentVariation);
        if (variationIndex < scope.totalVariations) {
          scope.variationDetails(variationIndex);
        } else {
          scope.disableNext = true;
        }
      };

      /***********************************************************************************************
       * Route Back to Summary Page from Details
       **********************************************************************************************/
      scope.backToSummary = function () {
        scope.itemSummary = true;
        angular.element("#summaryFooter").show();
        if ($state.current.url.indexOf('convertQuote') == -1) scope.closeWarningAlert();
        scope.manipulateJson(itemSummaryService.getItemSummaryData(), scope.tabIndex);
      };

      /***********************************************************************************************
       * Reset Function for Shipping Cost
       **********************************************************************************************/
      scope.resetShippingCost = function () {
        scope.newShippingCost = scope.selectedVariation.itemCost.shippingCost;
      };

      /***********************************************************************************************
       * Pagination for Variations
       **********************************************************************************************/
      scope.variationPaginationInfo = function (number, Total) {
        if (Total > 0)
          return $rootScope.getWord('VariationPaginationLabel').replace('{1}', number).replace('{2}', Total)
      };


      /***********************************************************************************************
       * Markup Update
       **********************************************************************************************/
      scope.updateMarkup = function () {
        var markupObj = {};
        markupObj.quoteId = scope.quoteId;
        markupObj.itemId = scope.summaryCurrentItem.id;
        markupObj.variationId = scope.selectedVariation.variationId;
        markupObj.markup = scope.newMarkUp ? scope.newMarkUp : 0;
        markupObj.applyToAllVariations = scope.markupCheckBox;

        itemSummaryService.updateMarkUp(markupObj)
          .then(function (result) {
            itemSummaryService.setSummaryData(result.data);
            scope.expandItem(scope.tabIndex);
            scope.variationDetails(scope.selectedVariationIndex);
            markupForm.data('formValidation').resetForm();
            return result;
          });
      };

      /***********************************************************************************************
       *Shipping Cost Update
       **********************************************************************************************/
      scope.resetTooltipText = $rootScope.getWord('resetInfo');
      scope.updateShippingCost = function () {
        var shippingCostObj = {};
        shippingCostObj.quoteId = scope.quoteId;
        shippingCostObj.itemId = scope.summaryCurrentItem.id;
        shippingCostObj.variationId = scope.selectedVariation.variationId;
        shippingCostObj.shippingCost = (scope.newShippingCost && scope.newShippingCost != scope.selectedVariation.itemCost.shippingCost) ? scope.newShippingCost : null;
        shippingCostObj.applyShippingCost = true;
        shippingCostObj.applyToAllVariations = scope.shippingCheckBox;

        itemSummaryService.updateOverrideShippingCost(shippingCostObj)
          .then(function (result) {
            itemSummaryService.setSummaryData(result.data);
            scope.expandItem(scope.tabIndex);
            scope.variationDetails(scope.selectedVariationIndex);
            shippingCostForm.data('formValidation').resetForm();
            return result;
          })
      };

      scope.showActionButtons = function () {
        if (scope.readOnly)
          return false;
        if (userRolesService.isSysAdmin())
          return true;
        if (userRolesService.isCoaManager() && scope.quoteId)
          return true;
        return false;
      };

      /***********************************************************************************************
       * Validations for Markup and Shipping Cost
       **********************************************************************************************/
      var decimalRegexTwo = /^(?:-?\d*\.?\d{1,2}|\d+)$/;
      var TwoDecimalRegexMessage = {
        en_US: $rootScope.getWord('TwoDecimalPlacesNum'),
        fr_CA: $rootScope.getWord('TwoDecimalPlacesNum'),
        en_CA: $rootScope.getWord('TwoDecimalPlacesNum')
      };

      var shippingCostInvalidMessage = {
        en_US: $rootScope.getWord('ValueCannotBeNegative'),
        fr_CA: $rootScope.getWord('ValueCannotBeNegative'),
        en_CA: $rootScope.getWord('ValueCannotBeNegative')
      };

      var markupForm = angular.element('#markupForm');
      markupForm.formValidation({

        framework: 'bootstrap',
        icon: {},
        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtMarkUp: {
            validators: {
              notEmpty: {},
              numeric: {},
              between: {
                min: 0,
                max: 100
              },
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.updateMarkup();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        // $(e.target)    --> The field element
        // data.fv        --> The FormValidation instance
        // data.field     --> The field name
        // data.element   --> The field element
        // data.validator --> The current validator name

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

          // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      var shippingCostForm = angular.element('#shippingCostForm');
      shippingCostForm.formValidation({

        framework: 'bootstrap',
        icon: {},
        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtShippingCost: {
            validators: {
              notEmpty: {},
              numeric: {},
              regexp: {
                regexp: decimalRegexTwo,
                message: TwoDecimalRegexMessage
              },
              callback: {
                message: shippingCostInvalidMessage,
                callback: function (val) {
                  return val >= 0;
                }
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.updateShippingCost();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {

        // $(e.target)    --> The field element
        // data.fv        --> The FormValidation instance
        // data.field     --> The field name
        // data.element   --> The field element
        // data.validator --> The current validator name

        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

          // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      markupForm.formValidation('setLocale', formValidationKeyService.getValidationKey());
      shippingCostForm.formValidation('setLocale', formValidationKeyService.getValidationKey());

      /***********************************************************************************************
       * Route From Review Convert Quote to Variation Details Logic
       **********************************************************************************************/
      if ($stateParams.variationIndex || $stateParams.variationIndex == '0') {
        scope.variationDetails($stateParams.variationIndex);
      }
    }
  }
});

/**
 * Created by Singh on 11/1/2017.
 * Filename: src/app/quote/directives/wizardStepOne.js
 */
angular.module('app.quote').directive('wizardStepOne', function ($location,
                                                                 wizardNavigationService,
                                                                 manageStatesService,
                                                                 $log,
                                                                 quotesInfoService,
                                                                 $state,
                                                                 addressValidationService,
                                                                 $rootScope,
                                                                 quoteHeaderService,
                                                                 formValidationKeyService,
                                                                 quoteModelService,
                                                                 defaultApiService,
                                                                 $stateParams) {
        return {
            restrict: 'EA',
            replace: false,

            link: function (scope, form) {

                var navigationSteps = wizardNavigationService.getNavigationStepEnums();
                scope.quote = quotesInfoService.getStepOneData();
                scope.quote.saveAsCustomer = true;

                quoteHeaderService.setQuotesData(scope.quote);
                scope.quoteData = quoteHeaderService.getQuoteData();
                scope.changeHeaderData = function () {
                    quoteHeaderService.setQuotesData(scope.quote);
                    quoteHeaderService.quoteChanged(scope.quoteData)
                };

                function goToStepTwo() {
                    scope.quote.victorPriceType = scope.quoteData.victorPriceType;
                    scope.quote.priceType = scope.quoteData.priceType;

                    scope.customerInfoData = quotesInfoService.getCustomerInfoData();
                    if (scope.customerInfoData && scope.customerInfoData.id) {
                        quoteModelService.setCustomerInfo(scope.customerInfoData, scope.quote);
                        quotesInfoService.setSelectedCustomerData(scope.customerInfoData);
                    } else {
                        quoteModelService.setCustomerInfo(scope.quote, scope.quote);
                        quotesInfoService.setSelectedCustomerData(null);
                    }

                    manageStatesService.setLegitAction(true);
                    $location.path('/index/quoteEdit/step_two/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
                    wizardNavigationService.setCurrentState(navigationSteps.addItems);
                    wizardNavigationService.disableAllNavs();
                    wizardNavigationService.setNav();
                }

                function stepOneSaveCall() {
                    var quoteData = quoteModelService.getQuoteModel();
                    if (!quoteData.items)
                        quoteData.items = [];
                    defaultApiService.createObjectCall('Quotes/SaveProgress', quoteData)
                        .success(function (data) {
                            quoteModelService.setQuoteId(data.quoteId);
                        })
                }

                scope.submitStepOne = function () {
                    quotesInfoService.saveStepOneData(scope.quote);
                    scope.customerInfoData = quotesInfoService.getCustomerInfoData();
                    var customerId = scope.customerInfoData ? scope.customerInfoData.id : null;
                    if (customerId) {
                        goToStepTwo();
                        if (!quoteModelService.getQuoteId()) {
                            stepOneSaveCall();
                        }
                    } else {
                        $rootScope.startSpinner();
                        defaultApiService.createObjectCall('Customers', scope.quote)
                            .success(function (data) {
                                quotesInfoService.setCustomerInfoData(data);
                                goToStepTwo();
                                $rootScope.stopSpinner();
                            })
                            .then(function () {
                                stepOneSaveCall();
                            })
                    }
                    scope.$apply();
                };

                scope.requesterTooltipText = $rootScope.getWord('RequesterInfo');

                form.formValidation({

                    framework: 'bootstrap',

                    icon: {
                        // valid: 'glyphicon',
                        // invalid: 'glyphicon glyphicon-remove',
                        // validating: 'glyphicon glyphicon-refresh'
                    },

                    addOns: {
                        i18n: {},
                        mandatoryIcon: {
                            //     icon: !scope.id ? 'glyphicon glyphicon-asterisk' : ''
                        }
                    },

                    fields: {
                        txtAccountNumber: {
                            excluded: function ($field, validator) {
                                return !quotesInfoService.getShowCustomerCard();
                            },
                            selector: '.commonField',
                            validators: {
                                callback: {
                                    message: {
                                        en_US: 'You must enter at least Full Name, Account Number or Company Name',
                                        fr_CA: 'You must enter at least Full Name, Account Number or Company Name',
                                        en_CA: 'You must enter at least Full Name, Account Number or Company Name'
                                    },
                                    callback: function (value, validator, $field) {
                                        var isEmpty = true,
                                            // Get the list of fields
                                            $fields = validator.getFieldElements('txtAccountNumber');
                                        for (var i = 0; i < $fields.length; i++) {
                                            if ($fields.eq(i).val().trim() !== '') {
                                                isEmpty = false;
                                                break;
                                            }
                                        }

                                        if (!isEmpty) {
                                            // Update the status of callback validator for all fields
                                            validator.updateStatus('txtAccountNumber', validator.STATUS_VALID, 'callback');
                                            return true;
                                        }

                                        return false;
                                    }
                                },
                                stringLength: {
                                    trim: true,
                                    min: 1,
                                    max: 100
                                }
                            }
                        },
                        cboSourceName: {
                            validators: {
                                notEmpty: {}
                            }
                        },

                        txtReferenceNumber: {
                            validators: {
                                stringLength: {
                                    min: 2,
                                    max: 100
                                }
                            }
                        },

                        txtRequesterFullName: {
                            validators: {
                                stringLength: {
                                    min: 2,
                                    max: 100
                                }
                            }
                        },

                        txtProjectDescription: {
                            validators: {
                                stringLength: {
                                    min: 1,
                                    max: 100
                                }
                            }
                        },

                        txtPhone: {
                            validators: {
                                stringLength: {
                                    trim: true,
                                    min: 1,
                                    max: 20
                                },
                                callback: {
                                    message: {
                                        en_US: 'Please enter a valid phone number',
                                        fr_CA: 'Please enter a valid phone number',
                                        en_CA: 'Please enter a valid phone number'
                                    },
                                    callback: function (value, validator, $field) {
                                        if (value === '')
                                            return true;
                                        else {
                                            angular.element('#txtPhone').intlTelInput("setCountry", 'us');
                                            var isPhoneValid = angular.element('#txtPhone').intlTelInput('isValidNumber');
                                            if (isPhoneValid)
                                                addressValidationService.formatPhoneNumber('txtPhone');
                                            return isPhoneValid
                                        }
                                    }
                                }
                            }
                        },

                        txtExtension: {
                            validators: {
                                stringLength: {
                                    trim: true,
                                    min: 1,
                                    max: 10
                                }
                            }
                        },

                        txtEmail: {
                            validators: {
                                regexp: {
                                    regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]{2,10}$',
                                    message: {
                                        en_US: $rootScope.getWord('ValidEmailMessage'),
                                        fr_CA: $rootScope.getWord('ValidEmailMessage'),
                                        en_CA: $rootScope.getWord('ValidEmailMessage')
                                    }
                                },
                                stringLength: {
                                    trim: true,
                                    min: 2,
                                    max: 200
                                }
                            }
                        }
                    },

                    onSuccess: function (e, data) {
                        if (quotesInfoService.getShowCustomerCard() || quotesInfoService.getSelectedCustomerData()) {
                            e.preventDefault();
                            scope.submitStepOne();
                        } else {
                            e.preventDefault();
                            angular.element('#requiredCustomer').removeClass('hide');
                            angular.element('#customerSearchDrpDwn').find('#inputField').addClass('required-field-error');
                            window.scrollTo(0, 20);
                        }
                    }
                });
                form.formValidation('setLocale', formValidationKeyService.getValidationKey());
            }
        }
    }
);

/**
 * Created by Singh on 1/4/2018.
 * Filename: src/app/quote/directives/dropdownHandler.js
 */
angular.module('app.quote').directive('dropdownHandler', function ($rootScope, quotesInfoService, $state, quoteHeaderService) {

  return {
    restrict: 'EA',
    replace: false,

    link: function (scope, element, attributes) {

      scope.addNewCustomerLabel = $rootScope.getWord('AddNewCustomer');
      scope.selectCustomer = $rootScope.getWord('SelectOrAddNewCustomer');
      if (quotesInfoService.getShowCustomerCard()) {
        angular.element('#customerBlock').removeClass('hide');
      }

      /***
       * Send a broadcast to the directive in order to clear itself
       * if an id parameter is given only this angucomplete is cleared
       * @param id
       */
      scope.clearInput = function (id) {
        if (id) {
          scope.$broadcast('angucomplete-alt:clearInput', id);
        }
        else {
          scope.$broadcast('angucomplete-alt:clearInput');
        }
      };

      /****************************************************************
       * Action performed when Add New Customer hyperlink is clicked **
       ****************************************************************/
      scope.performAddAction = function () {
        quotesInfoService.setCustomerInfoData({});
        quotesInfoService.removeCustomerInfo();
        quotesInfoService.clearCustomerFields();
        angular.element('#customerBlock').removeClass('hide');
        scope.showDropdown = false;
        scope.searchStr = null;
        quotesInfoService.setShowCustomerCard(true);
        angular.element('#requiredCustomer').addClass('hide');
        angular.element('#customerSearchDrpDwn').find('#inputField').removeClass('required-field-error');
        quotesInfoService.enableSubmitButtons();
        angular.element('#customerDetailsBlock').addClass('hide');
        quoteHeaderService.resetCustomerInfo();
        quoteHeaderService.quoteChanged(scope.quoteData);
      };

      scope.viewCustomerList = function () {
        $state.go('app.customer.list', {incomingCustomerFilter: scope.searchStr})
      };
    }
  }
});

/**
 * Created by Singh on 1/9/2018.
 * Filename: src/app/quote/directives/customerSearch.js
 */
angular.module('app.quote').directive('customerSearch', function ($log,
                                                                  quotesInfoService,
                                                                  $state,
                                                                  quoteHeaderService,
                                                                  $stateParams,
                                                                  genericQuotesService) {

  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/quote/partials/stepOne/customerSearch.tpl.html',

    link: function (scope, element, attributes) {
      scope.customers = [];
      scope.searchStr = '';
      scope.initialCustomer = quotesInfoService.getSelectedCustomerData();

      scope.goToCustomerEdit = function () {
        $state.go('app.customer.edit', {incomingCustomerData: scope.quote})
      };

      scope.editCustomer = function (customerId) {
        if ($stateParams.id) {
          quotesInfoService.setDetailsForParams({id: customerId, quoteId: $stateParams.id, quoteState: 'quoteInfo'});
          $state.go('app.quote.editCustomer', {id: customerId, quoteId: $stateParams.id, quoteState: 'quoteInfo'})
        } else {
          quotesInfoService.setDetailsForParams({id: customerId, quoteState: 'quoteInfo'});
          $state.go('app.quote.editCustomer', {id: customerId, quoteState: 'quoteInfo'})
        }
      };

      scope.disableCustomerSearch = function (id) {
        angular.element('#' + id).attr("autocomplete", "nope");
        return true;
      };

      /**************************************************************
       * Make api call to get customer list on input change
       **************************************************************/
      scope.inputChanged = function (str) {
        scope.customers = [];
        quotesInfoService.removeCustomerInfo();
        quoteHeaderService.resetCustomerInfo();
        angular.element('#requiredCustomer').addClass('hide');
        angular.element('#customerDetailsBlock').addClass('hide');
        quotesInfoService.setSelectedCustomerData(null);
        angular.element('#customerSearchDrpDwn').find('#inputField').removeClass('required-field-error');
        quotesInfoService.enableSubmitButtons();
        quotesInfoService.getCustomerList('Customers', str)
          .success(function (data) {
            scope.customers = data.data;
            _.forEach(data.data, function (item) {
              item.name = item.firstName + ' ' + item.lastName
            });
          })
          .error(function (data) {
            $log.log(data)
          });
      };

      /**************************************************************
       * On selecting a customer from the list
       **************************************************************/
      scope.selectedCustomer = function (selected) {
        if (selected) {
          quotesInfoService.setSelectedCustomerData(selected.originalObject);
          angular.element('#requiredCustomer').addClass('hide');
          angular.element('#customerSearchDrpDwn').find('#inputField').removeClass('required-field-error');
          angular.element('#customerBlock').addClass('hide');
          angular.element('#customerDetailsBlock').removeClass('hide');
          quotesInfoService.enableSubmitButtons();
          quotesInfoService.setShowCustomerCard(false);
          var customerData = selected.originalObject ? selected.originalObject : {};
          quotesInfoService.setCustomerInfoData(customerData);
          scope.quote = quotesInfoService.updateQuoteModel(scope.quote, customerData);
          scope.customerInfoData = quotesInfoService.getCustomerInfoData();
          quoteHeaderService.setQuotesData(selected.originalObject);
          quoteHeaderService.quoteChanged(scope.quoteData);
          return selected.originalObject;
        } else {
          angular.element('#customerDetailsBlock').addClass('hide');
          quotesInfoService.setCustomerInfoData({});
          scope.customerInfoData = {};
          quotesInfoService.setSelectedCustomerData(null);
          quoteHeaderService.setQuotesData({});
          quoteHeaderService.quoteChanged(scope.quoteData);
        }
      };

      /***
       * Send a broadcast to the directive in order to change itself
       * if an id parameter is given only this ancucomplete is changed
       * @param id
       */
      scope.changeInput = function (id) {
        if (id) {
          var pos = Math.floor(Math.random() * (scope.customers.length - 1));
          scope.$broadcast('angucomplete-alt:changeInput', id, scope.customers[pos]);
        }
      };
      //To set the existing customer and header
      if ($stateParams.id || genericQuotesService.getIncomingFromCustomer()) {
        angular.element('#customerBlock').addClass('hide');
        var data = genericQuotesService.getIncomingFromCustomer() ? genericQuotesService.getIncomingFromCustomer() : scope.quote;
        genericQuotesService.setIncomingFromCustomer(false);
        angular.element('#customerDetailsBlock').removeClass('hide');
        quotesInfoService.setSelectedCustomerData(data);
        quotesInfoService.setCustomerInfoData(data);
        scope.customerInfoData = quotesInfoService.getCustomerInfoData();
        quoteHeaderService.setQuotesData(scope.customerInfoData);
        quoteHeaderService.quoteChanged(scope.quoteData);
      }
    }
  }
});

/**
 * Created by Srikanth on 1/29/2018.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\tagBuilder.js
 */
angular.module('app.quote').directive('tagBuilder', function ($compile) {
  return {
    restrict: "EA",
    link: function (scope, element, attrs) {

      //============================================================
      // Switch statement to get the right status
      //============================================================
      scope.buildTags = function (tag) {
        return '<div class="filter-heading-align" ng-hide="tag.length == 0">' +
          '<span class="soft-default">{{getWord("filteredBy")}}</span>' +
          '<div class="custom-tags m-t-n-sm">' +
          '<span ng-hide="tag.length == 0" class="custom-badge-style" ng-repeat="tag in taging track by $index">' +
          '<span ng-hide="tag.length == 0 " ng-if="!tag.modifiedValue">{{tag.value}}<i class="fa fa-close custom-clear-badge-style" ng-click="removeTag(tag);checkCustom(tag)"></i></span>' +
          '<span ng-hide="tag.length == 0 " ng-if="tag.modifiedValue">{{tag.modifiedValue}}<i class="fa fa-close custom-clear-badge-style" ng-click="removeTag(tag);checkCustom(tag)"></i></span>' +
          '</span>' +
          '</div>' +
          '<span ng-hide="taging.length == 0" class="custom-clear-all"><span ng-click="clearAllFilters()">{{getWord("ClearAllFilters")}}</span>' +
          '</span>' +
          '</div>';
      };

      //============================================================
      // Compile the HTML
      //============================================================
      element.html(scope.buildTags());
      return $compile(element.contents())(scope);
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\quotesServerSideTable.js
 */
"use strict";

angular.module('app.quote').directive('quoteServerSideTable', function ($compile, $rootScope, $cookies, chipService, $timeout) {

  var noResultsMessage = "<strong>" + $rootScope.getWord('NoResultsFound') + "</strong>";

  //Get Cookie for use with DataTable Internationalisation plug-in.
  //See options.oLanguage below where returned variable is used.
  // if ($cookies.get('_locale') != null) {
  //   var locale = "plugin/datatables-plugins/i18n/" + $cookies.get('_locale') + ".json";
  // }
  var locale = '';
  return {
    restrict: 'A',
    scope: {
      tableOptions: '='
    },

    link: function (scope, element, attributes) {
      /* // DOM Position key index //

       l - Length changing (dropdown)
       f - Filtering input (search)
       t - The Table! (datatable)
       i - Information (records)
       p - Pagination (paging)
       r - Processing
       < and > - div elements
       <"#id" and > - div with an id
       <"class" and > - div with a class
       <"#id.class" and > - div with an id and class

       Also see: http://legacy.datatables.net/usage/features
       */

      var options = {
        autoWidth: false,
        serverSide: true,
        stateSave: true,
        filter: false,

        "smartResponsiveHelper": null,
        "sDom": "<'dt-toolbar'<'#filteredContainer.col-xs-12 col-sm-6'><'col-sm-6 col-xs-12 hidden-xs no-padding'>r>" +
          't' +
          '<"dt-toolbar-footer"<"col-sm-6 col-xs-12 hidden-xs m-t-xs"i><"col-xs-12 col-sm-6 m-t-xs"p>>',

        "fnInitComplete": function (oSettings, json) {
          //alert( 'DataTables has finished its initialisation.' );
        },

        oLanguage: {
          "sSearch": "<span class='input-group-addon input-sm'><i class='glyphicon glyphicon-search'></i></span>",
          "sLengthMenu": "_MENU_",
          "sEmptyTable": noResultsMessage,
          "sUrl": locale,
          "oPaginate": {
            "sFirst": false,
            "sLast": false,
            "sPrevious": "<strong>Previous</strong>",
            "sNext": "<strong>Next</strong>"
          }
        },
        "pagingType": "full_numbers",

        "fnHeaderCallback": function (nHead) {

          var searchedHtml = '';
          $compile(angular.element(nHead))(scope.$parent);

          if (scope.$parent.searchPerformed) {
            searchedHtml += '<div><strong class="k k-top-left">' + $rootScope.getWord('Searchedby') + ': </strong><span>' + unescape(scope.$parent.searchPerformed) + '</span></div>';
          }
        },

        "fnPreDrawCallback": function () {
          // Initialize the responsive datatables helper once.
          if (!this.smartResponsiveHelper) {
            this.smartResponsiveHelper = new ResponsiveDatatablesHelper(element, {
              tablet: 1024,
              phone: 480
            });
          }
        },

        "fnRowCallback": function (nRow) {
          this.smartResponsiveHelper.createExpandIcon(nRow);
        },

        'stateSaveParams': function (oSettings, oData) {
          //// Save the filter parameters to local storage
          scope.saveFilterParamsToLocalStorage(oSettings, oData);
        },

        'stateLoadParams': function () {
          var data = localStorage.getItem('DataTables_' + scope.$parent.object + window.location.pathname);
          var stateObj = JSON.parse(data);
          if (stateObj) {
            scope.$parent.pageLength = stateObj.length;
            scope.$parent.dataTablePageLength = scope.$parent.pageLength.toString();
          }
          return stateObj;
        },

        "fnDrawCallback": function (oSettings) {
          this.smartResponsiveHelper.respond();
        },

        "footerCallback": function (row, data, start, end, display) {
          var createDivId = "#" + attributes.id + "_info";
          var footerSection = angular.element(createDivId);
          setTimeout(function () {

            //This is only a quick fix to release 8/19/2015
            var getText = footerSection[0] ? footerSection[0].textContent : '';
            var shortenText = getText.split('(');
            if (getText)
              footerSection[0].textContent = shortenText[0];

          }, 1);

        },

        "fnServerData": function (sSource, aoData, fnCallback, oSettings) {

          oSettings._iDisplayLength = scope.$parent.pageLength;

          /*#################################################################################################
           Support for saving state of the user from edit view to list view
           #################################################################################################*/
          if (scope.$parent.searchedObj && scope.$parent.searchedObj.length > 0) {
            //$('#filterCollapse').addClass('in');
            for (var j = 0; j < scope.$parent.searchedObj.length; j++) {
              switch (scope.$parent.searchedObj[j].name) {
                case 'Filter':
                  scope.$parent.searchText = unescape(scope.$parent.searchedObj[j].value);
                  break;
                case 'SearchApplied':
                  scope.$parent.searchApplied = scope.$parent.searchedObj[j].value;
                  break;
                case 'FilterApplied':
                  scope.$parent.filterApplied = scope.$parent.searchedObj[j].value;
                  break;
                case 'SourceName':
                  scope.$parent.source_array = scope.$parent.searchedObj[j].value;
                  $timeout(function () {
                    scope.$parent.retrieveSelectCheckMark(scope.$parent.source_array, 'source');
                    chipService.createTags(scope.$parent.source_array, scope.$parent.status_array, scope.$parent.lastModify_array, scope.$parent.dateModified_array);
                  }, 300);
                  break;
                case 'QuoteStatus':
                  scope.$parent.status_array = scope.$parent.searchedObj[j].value;
                  $timeout(function () {
                    scope.$parent.retrieveSelectCheckMark(scope.$parent.status_array, 'status');
                    chipService.createTags(scope.$parent.source_array, scope.$parent.status_array, scope.$parent.lastModify_array, scope.$parent.dateModified_array);
                  }, 300);
                  break;
                case 'LastModifiedBy':
                  scope.$parent.lastModify_array = scope.$parent.searchedObj[j].value;
                  $timeout(function () {
                    scope.$parent.retrieveSelectCheckMark(scope.$parent.lastModify_array, 'modifiedBy');
                    chipService.createTags(scope.$parent.source_array, scope.$parent.status_array, scope.$parent.lastModify_array, scope.$parent.dateModified_array);
                  }, 300);
                  break;
                case 'DateModified':
                  scope.$parent.dateModified_array = scope.$parent.searchedObj[j].value;
                  scope.$parent.customEnable = scope.$parent.searchedObj[j].isCustomEnable;
                  scope.$parent.fromDate = scope.$parent.searchedObj[j].fromDate;
                  scope.$parent.toDate = scope.$parent.searchedObj[j].toDate;
                  $timeout(function () {
                    scope.$parent.retrieveCheckMarkForDateModified(scope.$parent.dateModified_array[0], scope.$parent.customEnable, scope.$parent.fromDate, scope.$parent.toDate);
                  }, 300);
                  break;
              }
            }
          }

          scope.$parent.searchedObj = null;
          sessionStorage.setItem('DataTables_Filtered_' + scope.$parent.object + window.location.pathname, scope.$parent.searchedObj);

          ///#################################################################################################

          var sortedColumn = {};
          for (var i = 0; i < aoData.length; i++) {
            if (aoData[i].name == 'order')
              sortedColumn = aoData[i].value[0];
          }

          aoData = []; //Clear out all extra DataTables Parameters.
          aoData.push({"name": "orderBy", "value": scope.$parent.tableColumns[sortedColumn.column]});


          if (sortedColumn.dir == 'asc')
            aoData.push({"name": "descending", "value": "false"});
          else
            aoData.push({"name": "descending", "value": "true"});

          aoData.push({
            "name": "pageSize",
            "value": oSettings._iDisplayLength
          });

          /*###############################################################################################
           For displaying the correct page number
           #################################################################################################*/
          var pgIndex = Math.round(oSettings._iDisplayStart / oSettings._iDisplayLength);
          scope.$parent.pageNum = pgIndex;
          if (scope.$parent.pageLength == oSettings._iDisplayLength) {
            pgIndex += 1;
          } else {
            var pages = Math.ceil(oSettings._iRecordsDisplay / oSettings._iDisplayLength);
            if (oSettings._iDisplayLength < oSettings._iDisplayStart) {
              for (var i = 1; i <= pages; i++) {
                if (((i * oSettings._iDisplayLength) <= oSettings._iDisplayStart) &&
                  (((i + 1) * oSettings._iDisplayLength) > oSettings._iDisplayStart)) {
                  oSettings._iDisplayStart = (i * oSettings._iDisplayLength);
                  break;
                }
              }
            }
          }

          aoData.push({
            "name": "pageIndex",
            "value": pgIndex
          });

          scope.$parent.filterApplied = true;

          scope.$parent.pageLength = oSettings._iDisplayLength;

          scope.$parent.searchPerformed = "";
          if (scope.$parent.searchApplied) {
            if (scope.$parent.searchText && scope.$parent.searchText.length > 0) {
              aoData.push({
                "name": "FilterValue",
                "value": unescape(scope.$parent.searchText)
              });
              scope.$parent.searchPerformed = unescape(scope.$parent.searchText);
            }

          }

          // Multiselect dropdown

          if (scope.$parent.source_array.length > 0) {
            var source = [];
            scope.$parent.source_array.map(function (val, index) {
              source.push(val.val)
            });

            aoData.push({
              "name": "sourceName",
              "value": source
            })
          }

          if (scope.$parent.status_array.length > 0) {
            var status = [];
            scope.$parent.status_array.map(function (val, index) {
              status.push(val.val)
            });

            aoData.push({
              "name": "quoteStatus",
              "value": status
            })
          }

          if (scope.$parent.lastModify_array.length > 0) {
            var lastModifyBy = [];
            scope.$parent.lastModify_array.map(function (val, index) {
              lastModifyBy.push(val.value)
            });

            aoData.push({
              "name": "lastModifiedBy",
              "value": lastModifyBy
            })
          }

          if (scope.$parent.dateModified_array.length > 0) {
            var modifiedDate = [];
            var array_value = scope.$parent.dateModified_array[0];

            if (array_value.value == 'Custom') {
              if (scope.$parent.customEnable) {
                var startDate = moment(new Date(scope.$parent.fromDate)).format("YYYY-MM-DD HH:mm:ss");
                var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
                if ((date_regex.test(scope.$parent.toDate))) {
                  var endDate = moment(new Date(scope.$parent.toDate));
                  endDate = moment(endDate).add(1, "days");
                  endDate = moment(endDate).subtract(1, 'seconds');
                  endDate = moment(endDate).format("YYYY-MM-DD HH:mm:ss");
                  aoData.push({
                    "name": "TimeInterval",
                    "value": array_value.val
                  });

                  aoData.push({
                    "name": "StartDate",
                    "value": moment(startDate).utc().unix()
                  });

                  aoData.push({
                    "name": "EndDate",
                    "value": moment(endDate).utc().unix()
                  })
                } else {
                  return false;
                }


              } else {
                scope.$parent.fromDate = '';
                scope.$parent.toDate = ''
              }

            } else {
              modifiedDate.push(array_value.val);
              aoData.push({
                "name": "TimeInterval",
                "value": modifiedDate
              })
            }
          }

          //// This export url is used to export

          scope.$parent.exportUrl = appConfig.apiURL + "/api/" + scope.$parent.object + "?";
          for (var j = 0; j < aoData.length; j++) {

            if (j != 0)
              scope.$parent.exportUrl += '&';

            if (aoData[j].name == 'pageSize') {
              scope.$parent.exportUrl += aoData[j].name + "=100000";
            } else {
              scope.$parent.exportUrl += aoData[j].name + "=" + aoData[j].value;
            }
          }

          $rootScope.startSpinner();
          // if (scope.$parent.searchText) {
          oSettings.jqXHR = $.ajax({
            "type": "GET",
            "cache": false,
            "url": appConfig.apiURL + "/api/" + scope.$parent.object + '/Filter',
            "data": aoData,
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Content-Type', 'application/json'),
                xhr.setRequestHeader('Authorization', 'Bearer ' + $cookies.get('_Token'))
            },
            success: function (json) {
              // if (scope.$parent.searchText) {
              $rootScope.stopSpinner();
              json.iTotalRecords = json.pagedData.records;
              json.iTotalDisplayRecords = json.pagedData.total;
              oSettings.json = json;
              scope.$parent[scope.$parent.object] = json.data;
              if (scope.$parent.previousSelectedJobs) {
                scope.$parent.previousSelectedJobs(json.data);
              }
              fnCallback(json);
            },
            error: function () {
              $rootScope.stopSpinner();
            }
          });
        }
      };

      if (attributes.tableOptions) {
        options = angular.extend(options, scope.tableOptions)
      }
      var _dataTable = element.DataTable(options);
    },

    controller: function ($scope) {

      $scope.resetTableData = function () {
        var json = {};
        json.iTotalRecords = 0;
        json.iTotalDisplayRecords = 0;
        json.data = [];
        return json
      };

      //// Save filter and search params to local storage

      $scope.saveFilterParamsToLocalStorage = function (oSettings, oData) {
        localStorage.setItem('DataTables_' + $scope.$parent.object + window.location.pathname, JSON.stringify(oData));

        var saveSearchedObj = [];

        if ($scope.$parent.searchApplied) {
          saveSearchedObj.push({"name": "SearchApplied", "value": $scope.$parent.searchApplied});
          if ($scope.$parent.searchText && $scope.$parent.searchText.length > 0) {
            $scope.$parent.searchText = unescape($scope.$parent.searchText);
            saveSearchedObj.push({"name": "Filter", "value": escape($scope.$parent.searchText)});
            $scope.$parent.searchText = unescape($scope.$parent.searchText);
          }
        }

        if ($scope.$parent.filterApplied) {
          saveSearchedObj.push({"name": "FilterApplied", "value": $scope.$parent.filterApplied});

          if ($scope.$parent.source_array.length > 0) {
            saveSearchedObj.push({"name": "SourceName", "value": $scope.$parent.source_array});
          }

          if ($scope.$parent.status_array.length > 0) {
            saveSearchedObj.push({"name": "QuoteStatus", "value": $scope.$parent.status_array});
          }

          if ($scope.$parent.lastModify_array.length > 0) {
            saveSearchedObj.push({"name": "LastModifiedBy", "value": $scope.$parent.lastModify_array});
          }

          if ($scope.$parent.dateModified_array.length > 0) {
            saveSearchedObj.push({
              "name": "DateModified",
              "value": $scope.$parent.dateModified_array,
              "fromDate": $scope.$parent.fromDate,
              "toDate": $scope.$parent.toDate,
              "isCustomEnable": $scope.$parent.customEnable
            });
          }
        }

        sessionStorage.setItem('DataTables_Filtered_' + $scope.$parent.object + window.location.pathname, JSON.stringify(saveSearchedObj));
      };
    }
  };
});


angular.module('app.quote').directive('quoteFilters', function ($rootScope, quoteListService, chipService, userRolesService) {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: 'app/quote/partials/quotesList/quoteFilters.tpl.html',
    link: function (scope, element, attrs) {

      scope.users = userRolesService.getUserNames();
      var quoteListData = quoteListService.getListData();
      $rootScope.taging = [];
      /***********************************************************************************************
       * Source and Status Enum Values
       **********************************************************************************************/
      scope.sourceEnumsLocalised = quoteListService.getSourceEnums();
      scope.statusEnumsLocalised = quoteListService.getStatusEnums();

      /***********************************************************************************************
       * Active System Users Data
       **********************************************************************************************/
      scope.systemUsers = quoteListData.activeUsers;

      scope.multiSelectOptions = [];
      /***********************************************************************************************
       * MultiSelect Dropdown Data
       **********************************************************************************************/
      scope.source_select = [];
      scope.status_select = [];
      scope.lastBySelect = [];
      scope.dateSelect = [];
      scope.lastModify_select = [];

      scope.source_select = quoteListService.getSourceEnums();
      scope.status_select = quoteListService.getEnumValue(scope.statusEnumValues, scope.statusEnumsLocalised);

      scope.systemUsers.map(function (value) {
        scope.lastModify_select.push({
          check: false,
          value: value.login
        })
      });

      /***********************************************************************************************
       * Hard Coded the Data Modified Options
       **********************************************************************************************/
      scope.dateModified_select = quoteListService.getDateModifiedOptions();

      scope.custom = {
        check: false,
        value: $rootScope.getWord('custom'),
        val: 'custom',
        modifiedValue: null
      };

      /***********************************************************************************************
       *Toggle DropDown of Filters
       **********************************************************************************************/
      scope.source_var = false;
      scope.status_var = false;
      scope.lastBy_var = false;
      scope.date_var = false;

      scope.toggleDropdown = function (value) {
        switch (value) {
          case 'source_var' :
            angular.element('#sourceDrpDwn').toggleClass('ng-hide');
            break;
          case 'status_var':
            angular.element('#statusDrpDwn').toggleClass('ng-hide');
            break;
          case 'lastBy_var' :
            angular.element('#lastByDrpDwn').toggleClass('ng-hide');
            break;
          case 'date_var' :
            angular.element('#dateDrpDwn').toggleClass('ng-hide');
            break;
        }
      };

      window.onclick = function (e) {
        if (!angular.element(e.target).hasClass("ng-hide")
          && angular.element(e.target).parents("#sourceBtn").length === 0) {
          angular.element('#sourceDrpDwn').addClass('ng-hide')
        }
        if (!angular.element(e.target).hasClass("ng-hide")
          && angular.element(e.target).parents("#statusBtn").length === 0) {
          angular.element('#statusDrpDwn').addClass('ng-hide')
        }
        if (!angular.element(e.target).hasClass("ng-hide")
          && angular.element(e.target).parents("#lastByBtn").length === 0) {
          angular.element('#lastByDrpDwn').addClass('ng-hide')
        }
        if (!angular.element(e.target).hasClass("ng-hide")
          && angular.element(e.target).parents("#dateBtn").length === 0) {
          angular.element('#dateDrpDwn').addClass('ng-hide')
        }
      };

      /***********************************************************************************************
       * Single Select Check mark Functionality
       **********************************************************************************************/
      scope.singleSelectFn = function (mod, index) {
        scope.dateModified_select.map(function (val, ind) {
          if (ind === index) {
            val.check = !val.check
          } else
            val.check = false
        });
        scope.dateModified_array = [];
        scope.custom.check = false;
        scope.dateModified_select.map(function (val) {
          if (val.check) {
            scope.dateModified_array.push(val)
          }
        });
        scope.customCalenderValue = false;
        scope.toDate = '';
        scope.fromDate = '';
        angular.element('#fromDate,#toDate').datepicker('setDate', null);
        chipService.createTags(scope.source_array, scope.status_array, scope.lastModify_array, scope.dateModified_array);
        var jobsTable = angular.element('#quoteListDatatable').dataTable();
        jobsTable.fnDraw();
      };


      scope.removeCustom = function () {
        scope.customEnable = false;
        scope.customCalenderValue = false
      };

      scope.checkCustom = function (tag) {
        if (tag.value === 'Custom') {
          scope.dateModified_array = [];
          scope.toDate = '';
          scope.fromDate = '';
          angular.element('#fromDate,#toDate').datepicker('setDate', null);
          scope.customCalenderValue = false
        }

      };

      /***********************************************************************************************
       * Clear All tags Button Functionality
       **********************************************************************************************/
      scope.clearAllFilters = function () {
        scope.source_select.map(function (val) {
          val.check = false
        });
        scope.status_select.map(function (val) {
          val.check = false
        });
        scope.lastModify_select.map(function (val) {
          val.check = false
        });
        scope.dateModified_select.map(function (val) {
          val.check = false
        });
        scope.source_array = [];
        scope.status_array = [];
        scope.lastModify_array = [];
        scope.dateModified_array = [];
        $rootScope.taging = [];
        scope.toDate = '';
        scope.fromDate = '';
        angular.element('#fromDate,#toDate').datepicker('setDate', null);
        scope.custom.check = false;
        scope.customCalenderValue = false;
        var jobsTable = angular.element('#quoteListDatatable').dataTable();
        jobsTable.fnDraw();
      };

      /***********************************************************************************************
       * Custom Date Range Picker Functionality
       **********************************************************************************************/
      scope.customCalenderValue = false;
      scope.customCalenderValid = function () {
        scope.dateModified_array = [];
        scope.dateModified_select.map(function (ev) {
          ev.check = false;
        });
        scope.toDate = '';
        scope.fromDate = '';
        angular.element('#fromDate,#toDate').datepicker('setDate', null);
        scope.customCalenderValue = !scope.customCalenderValue;
        scope.custom.check = !scope.custom.check;
        chipService.createTags(scope.source_array, scope.status_array, scope.lastModify_array, scope.dateModified_array);
        var jobsTable = angular.element('#quoteListDatatable').dataTable();
        jobsTable.fnDraw();
      };

      scope.customCalender = function () {
        if (!scope.fromDate || !scope.toDate) {
          scope.customEnable = false;
        } else {
          scope.dateModified_array = [];
          scope.dateModified_select.map(function (val) {
            val.check = false
          });
          if (scope.custom.check) {
            scope.custom.modifiedValue = scope.fromDate + ' - ' + scope.toDate;
            scope.dateModified_array.push(scope.custom);
            scope.customEnable = true
          }
          chipService.createTags(scope.source_array, scope.status_array, scope.lastModify_array, scope.dateModified_array);
          var jobsTable = angular.element('#quoteListDatatable').dataTable();
          jobsTable.fnDraw();
        }
      };

      /***********************************************************************************************
       * Remove tag Functionality
       **********************************************************************************************/
      scope.removeTag = function (tag) {
        chipService.removeTag(tag, scope.source_select, scope.source_array, scope.status_select, scope.status_array, scope.lastModify_select, scope.lastModify_array, scope.dateModified_select, scope.dateModified_array, scope.custom);
        var jobsTable = angular.element('#quoteListDatatable').dataTable();
        jobsTable.fnDraw();
      };

      /***********************************************************************************************
       * Multi Select Check mark Functionality
       **********************************************************************************************/
      scope.multiSelectFn = function (raw_data, key) {
        var selected_item_array = [];
        var parent_array = [];
        switch (key) {
          case 'source':
            selected_item_array = scope.source_array;
            parent_array = scope.source_select;
            break;
          case 'status':
            selected_item_array = scope.status_array;
            parent_array = scope.status_select;
            break;
          case 'modifiedBy':
            selected_item_array = scope.lastModify_array;
            parent_array = scope.lastModify_select;
            break;
        }

        if (selected_item_array.length == 0) {
          selected_item_array.push(raw_data);
        } else {
          var indexing = '';
          selected_item_array.map(function (val, index) {
            if (val.value == raw_data.value) {
              indexing = index + 1;
            }
          });

          if (indexing == '') {
            selected_item_array.push(raw_data)
          } else {
            selected_item_array.splice(indexing - 1, 1)
          }
        }

        var indexed = [];
        selected_item_array.map(function (val) {
          indexed.push(parent_array.findIndex(function (value) {
            return val.value == value.value
          }))

        });

        parent_array.map(function (val) {
          val.check = false
        });
        indexed.map(function (value) {
          parent_array[value].check = true
        });

        switch (key) {
          case 'source':
            scope.source_array = selected_item_array;
            scope.source_select = parent_array;
            break;
          case 'status':
            scope.status_array = selected_item_array;
            scope.status_select = parent_array;
            break;
          case 'modifiedBy':
            scope.lastModify_select = parent_array;
            scope.lastModify_array = selected_item_array;
            break
        }
        chipService.createTags(scope.source_array, scope.status_array, scope.lastModify_array, scope.dateModified_array);
        var jobsTable = angular.element('#quoteListDatatable').dataTable();
        jobsTable.fnDraw();
      };


      /***********************************************************************************************
       * Retrieve Select Check mark for Stored Filters (Source, Status, Last Modified By)
       **********************************************************************************************/
      scope.retrieveSelectCheckMark = function (selectedOptions, key) {
        var parent_array = [];
        switch (key) {
          case 'source':
            parent_array = scope.source_select;
            break;
          case 'status':
            parent_array = scope.status_select;
            break;
          case 'modifiedBy':
            parent_array = scope.lastModify_select;
            break;
        }

        var indexed = [];
        selectedOptions.map(function (val) {
          indexed.push(parent_array.findIndex(function (value) {
            return val.value == value.value
          }))

        });

        parent_array.map(function (val) {
          val.check = false
        });
        indexed.map(function (value) {
          parent_array[value].check = true
        });

        switch (key) {
          case 'source':
            scope.source_select = parent_array;
            break;
          case 'status':
            scope.status_select = parent_array;
            break;
          case 'modifiedBy':
            scope.lastModify_select = parent_array;
            break
        }
      };

      /***********************************************************************************************
       * Retrieve Select Check mark for Stored Filters (Date Modified)
       **********************************************************************************************/
      scope.retrieveCheckMarkForDateModified = function (selectedOption, isCustomEnable, fromDate, toDate) {
        if (!isCustomEnable) {
          scope.dateModified_select.map(function (val) {
            if (val.value == selectedOption.value) {
              val.check = !val.check
            } else
              val.check = false
          });
        } else {
          scope.customCalenderValue = true;
          scope.custom.check = true;
          scope.fromDate = fromDate;
          scope.toDate = toDate;
        }
      }
    }
  }
});

/**
 * Created by Md Anwar Hossain on 04/04/2025.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\viewUserNotesModal.js
 */

angular.module('app.quote').directive('viewUserNotesModal', function ($rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/quote/partials/convertQuote/viewUserNotesModal.tpl.html',

        link: function (scope) {
            scope.$watch(function () {
                return $rootScope.selectedNote;
            }, function (newVal) {
                if (newVal) {
                    scope.noteData = newVal;
                }
            });
        }
    }
});

angular.module('app.quote').directive('quoteActionButtons', function (userRolesService, itemSummaryService, $state, quoteListService, genericQuotesService) {
  return {
    restrict: 'A',
    replace: false,

    link: function (scope) {

      var quoteStatusEnums = {
        inProgress: 10,
        created: 20,
        converted: 30,
        closed: 40
      };

      function getCommands(quoteStatus) {
        var commands = [];
        switch (userRolesService.getSystemUserRoles()) {
          //for sysAdmin
          case null && userRolesService.isSysAdmin():
            switch (quoteStatus) {
              case quoteStatusEnums.inProgress:
                scope.defaultButtonLabel = 'Edit';
                commands.push(3);
                break;
              case quoteStatusEnums.created:
                scope.defaultButtonLabel = 'Edit';
                commands.push(6);
                commands.push(7);
                commands.push(8);
                break;
              case quoteStatusEnums.converted:
                scope.defaultButtonLabel = 'Requote';
                commands.push(9);
                break;
              case quoteStatusEnums.closed:
                scope.defaultButtonLabel = 'Requote';
                commands.push(3);
                break;
            }
            break;
          case userRolesService.isCoa():
            switch (quoteStatus) {
              case quoteStatusEnums.inProgress:
                scope.defaultButtonLabel = '';
                break;
              case quoteStatusEnums.created:
                scope.defaultButtonLabel = 'Convert';
                break;
              case quoteStatusEnums.converted:
                scope.defaultButtonLabel = 'DownloadConvertedSummaryReport';
                break;
              case quoteStatusEnums.closed:
                scope.defaultButtonLabel = '';
                break;
            }
            break;
          case userRolesService.isCoaManager():
            switch (quoteStatus) {
              case quoteStatusEnums.inProgress:
                scope.defaultButtonLabel = 'Edit';
                commands.push(3);
                break;
              case quoteStatusEnums.created:
                scope.defaultButtonLabel = 'Edit';
                commands.push(6);
                commands.push(7);
                commands.push(8);
                break;
              case quoteStatusEnums.converted:
                scope.defaultButtonLabel = 'Requote';
                commands.push(9);
                break;
              case quoteStatusEnums.closed:
                scope.defaultButtonLabel = 'Requote';
                commands.push(3);
                break;
            }
            break;
          case userRolesService.isEstimator():
            switch (quoteStatus) {
              case quoteStatusEnums.inProgress:
                scope.defaultButtonLabel = 'Edit';
                commands.push(3);
                break;
              case quoteStatusEnums.created:
                scope.defaultButtonLabel = 'Edit';
                commands.push(6);
                commands.push(8);
                break;
              case quoteStatusEnums.converted:
                scope.defaultButtonLabel = 'Requote';
                commands.push(9);
                break;
              case quoteStatusEnums.closed:
                scope.defaultButtonLabel = 'Requote';
                commands.push(3);
                break;
            }
            break;
          case userRolesService.isEstimatorManager():
            switch (quoteStatus) {
              case quoteStatusEnums.inProgress:
                scope.defaultButtonLabel = 'Edit';
                commands.push(3);
                break;
              case quoteStatusEnums.created:
                scope.defaultButtonLabel = 'Edit';
                commands.push(6);
                commands.push(8);
                break;
              case quoteStatusEnums.converted:
                scope.defaultButtonLabel = 'Requote';
                commands.push(9);
                break;
              case quoteStatusEnums.closed:
                scope.defaultButtonLabel = 'Requote';
                commands.push(3);
                break;
            }
            break;
        }
        return commands;
      }

      var summaryData = itemSummaryService.getSummaryData();

      var commands = getCommands(summaryData.quoteHeader.status);

      scope.defaultButtonAction = function (action) {
        switch (action) {
          case 'Edit':
            $state.go('app.quote.createQuote.step_one', {id: itemSummaryService.getQuoteId()});
            break;
          case 'Convert':
            scope.convertQuote();
            break;
          case 'Requote':
            scope.requote();
            break;
          case 'DownloadConvertedSummaryReport':
            scope.downloadConvertedSummaryReport();
            break;
        }
      };

      scope.requote = function () {
        quoteListService.reQuote(itemSummaryService.getQuoteId());
      };

      scope.convertQuote = function () {
        $state.go('app.quote.convertQuote', {quoteId: itemSummaryService.getQuoteId(), viewOnly: ''});
      };

      scope.deleteItem = function () {
        scope.confirmDelete(itemSummaryService.getQuoteId(), itemSummaryService.getQuoteNumber(), scope);
      };

      scope.deleteOnConfirm = function (id, itemName) {
        quoteListService.deleteQuote(id, itemName, true)
      };

      /***********************************************************************************************
       * Download Reports
       **********************************************************************************************/
      scope.downloadCostedSummaryReport = function () {
        genericQuotesService.downloadPdfAsset('Report/CostedQuoteSummaryReport', itemSummaryService.getQuoteId())
      };

      scope.downloadCostedDetailedReport = function () {
        genericQuotesService.downloadPdfAsset('Report/CostedQuoteDetailedReport', itemSummaryService.getQuoteId())
      };

      scope.downloadConvertedSummaryReport = function () {
        genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteSummaryReport', itemSummaryService.getQuoteId())
      };

      scope.downloadConvertedDetailedReport = function () {
        genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteDetailedReport', itemSummaryService.getQuoteId())
      };

      scope.showActionButton = function (actionName) {
        var index;
        switch (actionName) {
          case 'Convert':
            index = _.indexOf(commands, 7);
            if (index != '-1')
              return true;
            break;
          case 'Requote':
            index = _.indexOf(commands, 6);
            if (index != '-1')
              return true;
            break;
          case 'Delete':
            index = _.indexOf(commands, 3);
            if (index != '-1')
              return true;
            break;
          case 'CostedReportOnly':
            index = _.indexOf(commands, 8);
            if (index != '-1')
              return true;
            break;
          case 'ConvertedReportOnly':
            index = _.indexOf(commands, 9);
            if (index != '-1')
              return true;
            break
        }
      }
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 04/30/2018.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\editShippingMethod.js
 */

angular.module('app.quote').directive('editShippingMethod', function (itemConfigurationService, deliveryMethodService, recipientInfoService, $rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/convertQuote/editShippingMethod.tpl.html',

    link: function (scope) {
      scope.disableEditBtn = true;
      scope.isCustomerExists = false;
      scope.recipientModalHeaderLabel = $rootScope.getWord('EditRecipient');
      scope.editRecipient = function (index) {
        scope.recipientModalHeaderLabel = $rootScope.getWord('EditRecipient');
        scope.recipientModalSubmitBtnLabel = $rootScope.getWord('SaveRecipient');
        deliveryMethodService.checkCustomerExists(scope.customerDetails.customerId)
          .then(function (result) {
            scope.isCustomerExists = result.data;
            scope.recipient = deliveryMethodService.getRecipient();
            deliveryMethodService.currentDropdownIndex(index);
            angular.element('#recipientModal').modal('show');
          })
      };

      // Returns whether customer exists or not with flag
      scope.$on('isCustomerExists', function (data, flag) {
        scope.isCustomerExists = flag;
      });

      scope.resetModalValidations = function () {
        scope.recipient = {};
        angular.element('#recipientModal').removeClass('fade');
        angular.element('#recipientModal').formValidation('resetForm', true);
      };

      angular.element('#recipientModal').on('shown.bs.modal', function (e) {
        scope.recipient = Object.assign({}, deliveryMethodService.getRecipient());
      });


      deliveryMethodService.initializeShipToRecipients(itemConfigurationService.getCurrentItem().quantity);

      //To set the deliveryMethod dropdown to have values like
      // Standard, expedite etc
      scope.changeDeliveryMethod = function (serviceLevelCode) {
        var serviceLevelObj = {};
        _.forEach(scope.serviceLevels, function (serviceLevel, index) {
          if (serviceLevel.code === serviceLevelCode) {
            serviceLevelObj.code = serviceLevel.code;
            serviceLevelObj.responseCode = serviceLevel.responseCode;
            serviceLevelObj.shipper = serviceLevel.shipper;
            scope.serviceLevel = serviceLevel.code;
            scope.shipper = serviceLevel.shipper;
            scope.responseCode = serviceLevel.responseCode;
            recipientInfoService.setServiceLevel(scope.item.id, serviceLevelObj)
          }
        })
      };

      scope.$on('editButtonChange', function (env, value) {
        scope.disableEditBtn = true;
      })
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 04/26/2018.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\editDeliveryInfoModal.js
 */

angular.module('app.quote').directive('editDeliveryInfo', function (deliveryMethodService, $rootScope, recipientInfoService, genericQuotesService, convertQuoteService, $state) {
  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/quote/partials/convertQuote/editDeliveryInfo.tpl.html',

    link: function (scope) {

      scope.customerDetails = convertQuoteService.getCustomerData();

      /***********************************************************************************************
       * Localising the Enum Value
       **********************************************************************************************/
      scope.productTypeEnums = genericQuotesService.getEnumValues().productTypes;
      angular.forEach(scope.productTypeEnums, function (productType) {
        if (productType.value == scope.item.productType) {
          scope.item.productTypeEnum = productType;
        }
      });

      // Populate Pick up card when Selected Store is there
      scope.populatePickUpCard = function (storeId) {
        if (storeId) {
          scope.pickUpSearchText = storeId;
          scope.searchByString(storeId);
        }
      };

      /***********************************************************************************************
       * Change Delivery Type Functionality
       **********************************************************************************************/
      scope.changeConvertDeliveryType = function (step) {
        scope.closeAlert();
        switch (step) {
          case 1 :
            scope.item.shippingMethodName = '20';
            scope.noPickupSelected = false;
            scope.item.customerSelectedStoreId = '';
            scope.selectedStore = '';
            scope.searchedData = [];
            scope.pickUpSearchText = '';
            scope.resetSelectBtn();
            break;
          case 2 :
            scope.item.shippingMethodName = '10';
            scope.$broadcast('clear-recipient', 'true');
            //If customerSelectedStoreId exists for any other item then it will
            // become the customerSelectedStoreId of this item as well by designed
            _.forEach(scope.allItems, function (item) {
              if (item.customerSelectedStoreId) {
                scope.item.customerSelectedStoreId = item.customerSelectedStoreId;
                return false;
              }
            });
            scope.setCurrentStore();
            scope.populatePickUpCard(scope.selectedStore);
            break;
        }
      };

      /***********************************************************************************************
       * Recipient Form Submit Functionality
       **********************************************************************************************/
      scope.submitRecipientObject = function () {
        scope.recipient.street1 = angular.element('#txtStreet1').val();
        delete scope.recipient.firstName;
        delete scope.recipient.lastName;
        deliveryMethodService.setRecipient(scope.recipient, scope.customerDetails.customerId);
        if (deliveryMethodService.haveAddressDetails() && scope.runSatori) {
          $rootScope.startSpinner();
          deliveryMethodService.callAddressValidation()
            .success(function (data) {
              $rootScope.stopSpinner();
              scope.showSuggestedAddress(data);
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        }
        else {
          scope.submitRecipient();
        }
      };

      /***********************************************************************************************
       * Delivery Methods Enum values Data
       **********************************************************************************************/
      scope.serviceLevels = deliveryMethodService.getServiceLevelEnum();
      if (scope.customerDetails.quoteShipTo && scope.customerDetails.quoteShipTo.length) {
        angular.forEach(scope.customerDetails.quoteShipTo, function (currentShipTo) {
          if (currentShipTo.itemId == $state.params.itemId) {
            scope.serviceLevel = currentShipTo.serviceLevel;
            scope.shipper = currentShipTo.carrier;
            scope.responseCode = currentShipTo.responseCode;
          }
        })
      } else {
        scope.serviceLevel = scope.serviceLevels[0].code;
        scope.shipper = scope.serviceLevels[0].shipper;
        scope.responseCode = scope.serviceLevels[0].responseCode;
      }
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 04/30/2018.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\convertQuoteReview.js
 */

angular.module('app.quote').directive('convertQuoteReview', function ($rootScope, formValidationKeyService, convertQuoteService, deliveryMethodService, itemSummaryService, genericQuotesService, $state, $filter, notificationService, $stateParams) {
  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/quote/partials/convertQuote/convertQuoteReview.tpl.html',

    link: function (scope) {

      /***********************************************************************************************
       * Manipulating Response for Review Quote(View Only)
       **********************************************************************************************/
      var manipulateViewResponse = function (itemsData) {
        return convertQuoteService.manipulateViewJson(itemsData, scope.partialQuoteData, $stateParams.quoteId);
      };

      /***********************************************************************************************
       * Initialise Data
       **********************************************************************************************/
      scope.dueDateTooltipText = $rootScope.getWord('DueDateInfo');
      scope.reviewQuoteResponse = scope.readOnly ? manipulateViewResponse(itemSummaryService.getItemSummaryData()) : convertQuoteService.getReviewQuoteResponse();
      scope.selectedVariationData = convertQuoteService.getSelectedVariations();
      $('#quoteSubtotalSummary').text(_.reduce(scope.selectedVariationData,function(memo, variation) {
        return memo + variation.cost;
      },0));
      $('#quoteVendorTotalSummary').text(_.reduce(scope.selectedVariationData,function(memo, variation) {
        return memo + variation.vendorCost;
      },0));
      var pickupStores = deliveryMethodService.getStores();
      var importedEnums = genericQuotesService.getEnumValues();
      var productTypeEnums = importedEnums.productTypes;
      var deliveryMethodEnums = itemSummaryService.getDeliveryMethodEnums();
      var serviceLevelEnums = deliveryMethodService.getServiceLevelEnum();

      /***********************************************************************************************
       * Binding Back the Converted Quote Info
       **********************************************************************************************/
      if (scope.readOnly) {
        var convertedQuoteInfo = itemSummaryService.getSummaryData().convertQuoteInfo;
        scope.orderNumber = convertedQuoteInfo ? convertedQuoteInfo.orderNumber : '';
        scope.dueDate = convertedQuoteInfo ? $filter('date')(new Date(convertedQuoteInfo.dueDateTime), 'MM/dd/yyyy') : '';
        scope.dueTime = convertedQuoteInfo ? convertQuoteService.convertTo12hour($filter('date')(new Date(convertedQuoteInfo.dueDateTime), 'hh:mm a')) : '';
      }

      /***********************************************************************************************
       * Item Panel Data
       **********************************************************************************************/
      angular.forEach(scope.reviewQuoteResponse, function (item, idx) {
        angular.forEach(scope.selectedVariationData, function (value, indx) {
          if (item.itemId == value.itemId) {
            item.selectedIndex = value.index;
            item.itemIdx = value.itemIdx;
            // Converting product Type Enum value to respective Enum name
            angular.forEach(productTypeEnums, function (productType) {
              if (productType.value == item.productType) {
                item.productTypeEnum = productType;
              }
            });

            // Converting delivery method Enum value to respective Enum name
            for (var deliveryMethodKey in deliveryMethodEnums) {
              if (deliveryMethodKey == item.shippingMethod) {
                item.deliveryMethodEnum = {
                  name: $rootScope.getWord(deliveryMethodEnums[deliveryMethodKey]),
                  value: deliveryMethodKey
                };
              }
            }

            // Logic to pull to Quote Ship Info through id
            if (item.shippingMethod === 20) {
              item.deliveryInfo = [];
              angular.forEach(item.quoteShipTo, function (shipTo) {
                if (shipTo.itemId == item.itemId) {
                  item.deliveryInfo
                    .push(((shipTo.fullName) ? shipTo.fullName : "") + (((shipTo.fullName) && (shipTo.address1 || shipTo.address2 || shipTo.address3 || shipTo.city || shipTo.state || shipTo.postalCode || shipTo.country)) ? ' -' : "") +
                      ((shipTo.address1) ? ' ' + shipTo.address1 : "") + ((shipTo.address2) ? ' ' + shipTo.address2 : "") + ((shipTo.address3) ? ' ' + shipTo.address3 : "") + (((shipTo.address1 || shipTo.address2 || shipTo.address3) && (shipTo.city || shipTo.state || shipTo.postalCode || shipTo.country)) ? ' -' : "") +
                      ((shipTo.city) ? ' ' + shipTo.city : "") + ((shipTo.city && shipTo.state) ? ',' : "") + ((shipTo.state) ? ' ' + shipTo.state : "") + (((shipTo.city || shipTo.state) && (shipTo.postalCode || shipTo.country)) ? ' -' : "") +
                      ((shipTo.postalCode) ? ' ' + shipTo.postalCode : "") + ((shipTo.postalCode && shipTo.country) ? ',' : "") + ((shipTo.country) ? ' ' + shipTo.country : ""));
                  angular.forEach(serviceLevelEnums, function (shippingValue) {
                    if (shipTo.serviceLevel == shippingValue.code) {
                      item.shippingServiceLevel = shippingValue.name
                    }
                  })
                }
              })
            }
            // Logic to pull Pickup Info through external Code
            else if (item.shippingMethod === 10) {
              item.deliveryInfo = [];
              angular.forEach(pickupStores, function (pickupStore) {
                if (item.customerSelectedStoreId == pickupStore.externalCode) {
                  item.deliveryInfo
                    .push(((pickupStore.externalId) ? pickupStore.externalId : "") + (((pickupStore.externalId) && (pickupStore.address1 || pickupStore.address2 || pickupStore.address3 || pickupStore.city || pickupStore.state || pickupStore.postalCode || pickupStore.country)) ? ' -' : "") +
                      ((pickupStore.address1) ? ' ' + pickupStore.address1 : "") + ((pickupStore.address2) ? ' ' + pickupStore.address2 : "") + ((pickupStore.address3) ? ' ' + pickupStore.address3 : "") + (((pickupStore.address1 || pickupStore.address2 || pickupStore.address3) && (pickupStore.city || pickupStore.state || pickupStore.postalCode || pickupStore.country)) ? ' -' : "") +
                      ((pickupStore.city) ? ' ' + pickupStore.city : "") + ((pickupStore.city && pickupStore.state) ? ',' : "") + ((pickupStore.state) ? ' ' + pickupStore.state : "") + (((pickupStore.city || pickupStore.state) && (pickupStore.postalCode || pickupStore.country)) ? ' -' : "") +
                      ((pickupStore.postalCode) ? ' ' + pickupStore.postalCode : "") + ((pickupStore.postalCode && pickupStore.country) ? ',' : "") + ((pickupStore.country) ? ' ' + pickupStore.country : ""));
                }
              })
            }
          }
        })
      });

      /***********************************************************************************************
       * Convert To Order Api Call Logic
       **********************************************************************************************/
      scope.convertToOrder = function () {
        var parsedDate = '';
        if ((scope.dueDate) && scope.dueTime) {
          var getTime = convertQuoteService.convertTo24hours(scope.dueTime);
          var parsedTime = $filter('date')(getTime, 'HH:mm');
          var getEpoch = new Date(scope.dueDate).getTime();
          parsedDate = $filter('date')(new Date(getEpoch), 'yyyy-MM-dd');
          var parsedDeliveryDueTime = parsedDate + "T" + parsedTime + ":00";
          var deliveryDueTime = moment(parsedDeliveryDueTime).utc();
          convertQuoteService.convertToOrderApiCall(scope.reviewQuoteResponse[0].quoteId, scope.orderNumber, deliveryDueTime)
            .then(function (result) {
              if (result.data.success) {
                scope.closeAlert();
                notificationService.notifyQuoteConvertSuccess(result.data.srcOrderId);
                $state.go('app.quote.list');
              }
              else {
                var errorArray = [];
                errorArray.push({
                  name: '',
                  message: result.data.exceptionMessage || result.data.message || $rootScope.getWord('QuoteConvertingError')
                });
                scope.errorBadgeFn(errorArray);
                window.scrollTo(0, 0);
              }
            })
        }
      };

      /***********************************************************************************************
       * Remove Item from Review Quote
       **********************************************************************************************/
      scope.removeReviewItem = function (selectedItem) {
        angular.forEach(scope.reviewQuoteResponse, function (data, idx) {
          if (data.variatonDetails.variationId == selectedItem.variatonDetails.variationId) {
            scope.reviewQuoteResponse.splice(idx, 1);
          }
        });
        angular.forEach(scope.selectedVariationData, function (item, index) {
          if (selectedItem.variatonDetails.variationId == item.variationId) {
            scope.selectedVariationData.splice(index, 1);
          }
          if (index == scope.selectedVariationData.length - 1) {
            convertQuoteService.setReviewSelectedVariations(scope.selectedVariationData)
          }
        });

        $('#quoteSubtotalSummary').text(_.reduce(scope.selectedVariationData,function(memo, variation) {
          return memo + variation.cost;
        },0));
      };

      /***********************************************************************************************
       * Route to Convert Item on click of Item Name Hyperlink
       **********************************************************************************************/
      scope.routeToItem = function (item) {
        itemSummaryService.setCurrentItemIndex(item.itemIdx);
        if (scope.readOnly) {
          $state.go('app.quote.convertQuote', {quoteId: item.quoteId, viewOnly: 'viewOnly'});
        } else {
          $state.go('app.quote.convertQuote', {quoteId: item.quoteId});
        }
      };

      /***********************************************************************************************
       * Route to Variation Details on click of Variation Name Hyperlink
       **********************************************************************************************/
      scope.routeToVariationDetails = function (item) {
        itemSummaryService.setCurrentItemIndex(item.itemIdx);
        if (scope.readOnly) {
          $state.go('app.quote.convertQuote', {
            quoteId: item.quoteId,
            variationIndex: item.selectedIndex,
            viewOnly: 'viewOnly'
          });
        } else {
          $state.go('app.quote.convertQuote', {quoteId: item.quoteId, variationIndex: item.selectedIndex});
        }
      };

      /***********************************************************************************************
       * Validations for Order Number, Due Date and Due Time
       **********************************************************************************************/
      var systemCurrentDate = new Date();
      var AlphaNumericMessage = {
        en_US: $rootScope.getWord('AlphaNumericCharactersOnly'),
        fr_CA: $rootScope.getWord('AlphaNumericCharactersOnly'),
        en_CA: $rootScope.getWord('AlphaNumericCharactersOnly')
      };

      var ValidTimeMessage = {
        en_US: $rootScope.getWord('ValidTime'),
        fr_CA: $rootScope.getWord('ValidTime'),
        en_CA: $rootScope.getWord('ValidTime')
      };

      var form = angular.element('#reviewQuoteForm');
      form.formValidation({

        framework: 'bootstrap',
        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtOrderNumber: {
            validators: {
              notEmpty: {},
              stringLength: {
                trim: true,
                min: 1,
                max: 10
              },
              regexp: {
                regexp: /^[a-z0-9]+$/i,
                message: AlphaNumericMessage
              }
            }
          },

          dpDueDate: {
            validators: {
              notEmpty: {},
              date: {
                format: 'MM/DD/YYYY'
              },
              callback: {
                message: {
                  en_US: $rootScope.getWord('DateTodayOrAfter'),
                  fr_CA: $rootScope.getWord('DateTodayOrAfter'),
                  en_CA: $rootScope.getWord('DateTodayOrAfter')
                },
                callback: function (value, validator) {
                  var dateSelected = new Date(value);
                  var convertCurrentDate = (systemCurrentDate.getMonth() + 1) + '/' + (systemCurrentDate.getDate()) + '/' + (systemCurrentDate.getFullYear());
                  var currentDate = new Date(convertCurrentDate);

                  if (dateSelected < currentDate) {
                    return {
                      valid: false
                    };
                  }

                  else
                    return {valid: true};

                }
              }
            }
          },

          tpDueTime: {
            validators: {
              notEmpty: {},
              regexp: {
                regexp: /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/,
                message: ValidTimeMessage
              },
              callback: {
                message: {
                  en_US: $rootScope.getWord('TimeFifteenMinutesAhead'),
                  fr_CA: $rootScope.getWord('TimeFifteenMinutesAhead'),
                  en_CA: $rootScope.getWord('TimeFifteenMinutesAhead')
                },

                callback: function (value, validator) {
                  if (!scope.dueDate)
                    return {
                      valid: false
                    };

                  var selectedDueDate = moment(scope.dueDate);//+' 00:00:00');
                  var currentDate = moment((moment().get('month') + 1) + '/' + moment().get('date') + '/' + moment().get('year'));//+' 00:00:00');

                  //Checks for the selected Due Date time is equals to the current Date.
                  if (moment(currentDate).isSame(selectedDueDate)) {
                    //Instantiate selected time.
                    var selectedTime = moment(value, 'hh:mm A');
                    //Checks if the selected time is greater or equal to 15 minutes head of current time.
                    if (selectedTime > (moment(moment().get('hour') + ':' + moment().get('minutes'), 'hh:mm'))) {
                      return {valid: true};
                    }
                    else {
                      return {
                        valid: false
                      };
                    }
                  } else {
                    {
                      return {valid: true};
                    }
                  }
                }
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.convertToOrder();
        },

        live: 'enabled'

      }).on('change', '#dpDueDate', function () {
        form.formValidation('revalidateField', 'dpDueDate');
        form.formValidation('revalidateField', 'tpDueTime');

      }).on('change', '#tpDueTime', function () {
        form.formValidation('revalidateField', 'dpDueDate');
        form.formValidation('revalidateField', 'tpDueTime');

      }).on('error.validator.fv', function (e, data) {
        data.element
          .data('fv.messages')

          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }
  }

});

/**
 * Created by Md Anwar Hossain on 04/04/2025.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\addUserNotesModal.js
 */

angular.module('app.quote').directive('addUserNotesModal', function (formValidationKeyService, itemSummaryService, defaultApiService, $rootScope, userRolesService, notificationService, $timeout, $filter) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/quote/partials/convertQuote/addUserNotesModal.tpl.html',

        link: function (scope, form) {

            /***********************************************************************************************
             * Open Modal for Adding Notes
             **********************************************************************************************/
            scope.openUserNotesModal = function () {
                scope.newNotes = '';
                angular.element('#addUserNotesModal').modal('show');
                angular.element('#addUserNotesModal').on('shown.bs.modal', function (e) {
                    angular.element('#txtNotes').focus();
                    angular.element('#txtNotes').select();
                });
            };

            /***********************************************************************************************
             * Save user Notes
             **********************************************************************************************/
            scope.saveUserNotes = function () {
                var userNotesObj = {};
                userNotesObj.userNote = scope.newNotes;
                userNotesObj.quoteId = itemSummaryService.getQuoteId();
                // userNotesObj.createdDate = new Date().toLocaleString();
                var now = new Date();
                userNotesObj.createdDate = $filter('date')(now, 'yyyy-MM-dd hh:mm:ss a');
                userNotesObj.createdByUserName = userRolesService.getSystemUser().username;
                $rootScope.startSpinner();
                defaultApiService.createObjectCall('Quotes/SaveNote', userNotesObj)
                    .success(function (result) {
                        // for update data table
                        scope.userNoteList.push(result);
                        scope.userNoteCount = scope.userNoteList.length;
                        $timeout(function () {
                            const table = $('#userNotesTable').DataTable();
                            table.clear();
                            table.rows.add(scope.userNoteList);
                            table.draw();
                        });
                        $rootScope.stopSpinner();
                        angular.element('#addUserNotesModal').removeClass('fade');
                        angular.element('#addUserNotesModal').modal('hide');
                        scope.newNotes = '';
                        notificationService.notifyCreateSuccess('Note');
                    }).error(function () {
                        $rootScope.stopSpinner();
                        notificationService.notifyQuoteCreateError('Note');
                    });
            };

            /***********************************************************************************************
             * Validations
             **********************************************************************************************/
            form.formValidation({

                framework: 'bootstrap',

                icon: {},

                addOns: {
                    i18n: {},
                    mandatoryIcon: {}
                },

                fields: {
                    txtNotes: {
                        validators: {
                            notEmpty: {},
                            stringLength: {
                                trim: false,
                                min: 1,
                                max: 300
                            }
                        }
                    }
                },

                onSuccess: function (e, data) {
                    console.log('Form validated!');
                    e.preventDefault();
                    scope.saveUserNotes();
                },

                live: 'enabled'

            }).on('error.validator.fv', function (e, data) {
                data.element
                    .data('fv.messages')
                    // Hide all the messages
                    .find('.help-block[data-fv-for="' + data.field + '"]').hide()

                    // Show only message associated with current validator
                    .filter('[data-fv-validator="' + data.validator + '"]').show();

            });
            form.formValidation('setLocale', formValidationKeyService.getValidationKey());
        }
    }
});

/**
 * Created by Srikanth Reddy Anugu on 04/26/2018.
 * Filename: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\directives\convertQuote\addNotesModal.js
 */

angular.module('app.quote').directive('addNotesModal', function (formValidationKeyService, itemSummaryService, defaultApiService, $rootScope) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/quote/partials/convertQuote/addNotesModal.tpl.html',

    link: function (scope, form) {

      /***********************************************************************************************
       * Open Modal for Adding Notes
       **********************************************************************************************/
      scope.openModalForAddNotes = function () {
        angular.element('#addNotesModal').modal('show');
        scope.newNotes = scope.summaryCurrentItem.itemNotes || '';
        angular.element('#addNotesModal').on('shown.bs.modal', function (e) {
          angular.element('#txtItemNotes').focus();
          angular.element('#txtItemNotes').select();
        });
      };

      /***********************************************************************************************
       * Updating Notes for Item
       **********************************************************************************************/
      scope.saveNotesForConvert = function () {
        var updateNotesObj = {};
        updateNotesObj.quoteId = itemSummaryService.getQuoteId();
        updateNotesObj.itemId = itemSummaryService.getCurrentItemId();
        updateNotesObj.notes = scope.newNotes;
        $rootScope.startSpinner();
        defaultApiService.createObjectCall('QuoteReview/AddNote', updateNotesObj)
          .success(function (result) {
            $rootScope.stopSpinner();
            angular.element('#addNotesModal').removeClass('fade');
            angular.element('#addNotesModal').modal('hide');
            scope.summaryCurrentItem.itemNotes = result.notes;
          }).error(function () {
          $rootScope.stopSpinner();
        });
      };

      /***********************************************************************************************
       * Validations
       **********************************************************************************************/
      form.formValidation({

        framework: 'bootstrap',

        icon: {},

        addOns: {
          i18n: {},
          mandatoryIcon: {}
        },

        fields: {

          txtItemNotes: {
            validators: {
              stringLength: {
                trim: false,
                min: 1,
                max: 250
              }
            }
          }
        },

        onSuccess: function (e, data) {
          e.preventDefault();
          scope.saveNotesForConvert();
        },

        live: 'enabled'

      }).on('error.validator.fv', function (e, data) {
        data.element
          .data('fv.messages')
          // Hide all the messages
          .find('.help-block[data-fv-for="' + data.field + '"]').hide()

        // Show only message associated with current validator
          .filter('[data-fv-validator="' + data.validator + '"]').show();

      });
      form.formValidation('setLocale', formValidationKeyService.getValidationKey());
    }
  }
});

/**
 * Created by $ingh on 2/2/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsCtrl.js
 */
angular.module('app.quote').controller('stepTwoCtrl', function ($scope, data, genericQuotesService, deliveryMethodService, itemConfigurationService, $log, $rootScope, defaultApiService, multiComponentService, wizardNavigationService, itemTabService) {

  // Initialise data
  genericQuotesService.populateEnums(data);
  $scope.collateMethods = genericQuotesService.getEnumValues().collateMethods;
  $scope.productTypes = genericQuotesService.getEnumValues().productTypes;
  $scope.sides = genericQuotesService.getEnumValues().sides;
  deliveryMethodService.setCountryStates(data);
  deliveryMethodService.setStores(data);
  $scope.componentTypeEnums = genericQuotesService.getComponentTypeEnums();
  var navigationSteps = wizardNavigationService.getNavigationStepEnums();
  $scope.quanityByEnums = genericQuotesService.getQuantityByEnums();
  //Force Setting the step to be third
  wizardNavigationService.setCurrentState(navigationSteps.addItems);
  wizardNavigationService.disableAllNavs();
  wizardNavigationService.setNav();
  $scope.navProperties = wizardNavigationService.getNavProperties();

  /** ///////////////////////////////////// **/
  /**     Deliver Methods DropDown Data     **/
  /** ///////////////////////////////////// **/
  deliveryMethodService.initializeDeliveryMethodData();
  deliveryMethodService.setDeliveryMethodData(data);
  $scope.deliveryData = deliveryMethodService.getDeliveryMethodData();

  $scope.productCategories = data.productCategories;
  var optgroup = [
    {value: 'type', label: 'Type'}
  ];

  _.forEach($scope.productTypes, function (prod, index) {
    prod.productType = prod.value;
    prod.noId = true;
  });

  _.forEach($scope.productCategories, function (prod, index) {
    var productTypeValue = _.find($scope.productTypes, function (o) {
      return o.productType == prod.productType;
    });
    optgroup.push(
      {
        value: productTypeValue.unlocalisedName,
        label: productTypeValue.name
      }
    );

    _.forEach(prod.products, function (name) {
      $scope.productTypes.push(
        {
          productType: prod.productType,
          class: productTypeValue.unlocalisedName,
          value: name.id,
          name: name.name,
          id: name.id
        }
      )
    });

  });

  var productSelectize = angular.element('#cboProductTypeName').selectize({
    // plugins: ['remove_button'],
    options: $scope.productTypes,
    optgroups: optgroup,
    optgroupField: 'class',
    optgroupOrder: ["type", "Books", "Flatsheet", "Multiflatsheet", "Ncr", "Pads", "WideFormat"],
    labelField: 'name',
    searchField: ['name', 'class'],
    placeholder: $rootScope.getWord('SelectOption'),
    sortField: [
      {field: "name", direction: "asc"},
      {
        field: '$score', direction: "asc"
      }
    ],
    onChange: function (value) {
      // If user changes the product type then we are resetting the component
      // We may need to reset item in future as well
      // Condition is checking whether the change  has been triggered as result of manual change or item switch
      if (genericQuotesService.getInitializeStuff() && value) {
        $scope.item.files = [];
        multiComponentService.resetComponent();
        multiComponentService.setColorButton('frontBlack', 'frontColor');
        multiComponentService.setColorButton('backBlack', 'backColor');
        $scope.reConfigureComponents();
        $scope.component = multiComponentService.getCurrentComponent();
        genericQuotesService.initializeStuff(false);
        $scope.initializeVariation();
        itemConfigurationService.clearItemLevelFields();
        itemConfigurationService.clearItemFields('', 0, '', '');
        itemConfigurationService.removeQuantityVariations();
        itemConfigurationService.removeItemQuantityVariations();
        multiComponentService.initializePreviousValue();
        if ($scope.component && $scope.component.material)
          $scope.component.material.materialId = "";
      }
      $scope.setProductType(value);
    }
  });
  $scope.productselectize = productSelectize[0].selectize;
  $scope.productselectize.setValue(null);

  $scope.showFields = false;

  $scope.setProductType = function (value) {
    if (value) {
      $rootScope.startSpinner();
      $scope.closeAlert();
      multiComponentService.setColorButton('standardComponent', 'tabComponent');
      $scope.$emit('isTabEnabled', false);
      $scope.showFields = true;
      var selected_objects = angular.element.map($scope.productselectize.items, function (value) {
        return $scope.productselectize.options[value];
      });

      //Dynamic Labels for product type pads
      if (selected_objects[0].productType != $scope.productEnums.pads) {
        $scope.quantityLabelText = $rootScope.getWord('Quantity');
        $scope.numberOfPagesLabelText = $rootScope.getWord('NumberOfPages');
        $scope.addQuantityVariationLabelText = $rootScope.getWord('AddAnotherQuantity');
        $scope.quantityTooltipText = $rootScope.getWord('QuantityInfo');
      } else {
        $scope.quantityLabelText = $rootScope.getWord('NumberOfPads');
        $scope.numberOfPagesLabelText = $rootScope.getWord('SheetsPerPad');
        $scope.addQuantityVariationLabelText = $rootScope.getWord('AddAnotherNumberOfPads');
        $scope.quantityTooltipText = $rootScope.getWord('NumberOfPadsInfo');
      }

      //For Custom Adhoc,excluded Sheet Count, Total Area, Total Print Area QuantityBy's when Product Type is FinishingOnly
      $scope.availableQuantityBy = [];
      if (selected_objects[0].productType == $scope.productEnums.finishingOnly) {
        $scope.availableQuantityBy = genericQuotesService.getEnumValues().quantityCostingTypes.filter(function (quantityBy, index) {
          if ((quantityBy.value != $scope.quanityByEnums.RunSizeSheetsNoWaste) && (quantityBy.value != $scope.quanityByEnums.TotalArea) && (quantityBy.value != $scope.quanityByEnums.TotalPrintArea)) {
            return quantityBy.value;
          }
        });
      } else $scope.availableQuantityBy = genericQuotesService.getEnumValues().quantityCostingTypes;

      //call press api to get appropriate presses for this product type
      multiComponentService.callPressesForProductType(selected_objects[0].productType)
        .then(function (pressData) {
          $scope.presses = pressData.data;
        });

      itemConfigurationService.setProductType(selected_objects);
      //Logic for setting the itamTabName same as the name of product
      (!selected_objects[0].noId || !$scope.item.itemName) ? itemTabService.setItemName(selected_objects[0].name) : itemTabService.setItemName($scope.item.itemName);

      $scope.getTemplates();
      if (multiComponentService.reConfigureComponents(selected_objects, $scope.productEnums)) {
        $scope.reConfigureComponents();
      }
      if ($scope.item)
        $scope.item.itemTemplateGuid = null;
      //Remove all finishing option adHoc tags on product type change
      multiComponentService.setAdHockTags([]);
      $scope.finishingTags = multiComponentService.getAdHockTags();
    } else {
      if ($scope.showFields) {
        $scope.showFields = false;
        $scope.$apply();
      }
    }
  };

  // Disable Product Type DropDown in View Mode
  if ($scope.readOnly) {
    var productTypeDrpDwn = angular.element("#cboProductTypeName").selectize();
    var selectize = productTypeDrpDwn[0].selectize;
    selectize.disable();
  }
});


/**
 * Created by Srikanth on 3/28/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\controllers\stepThree\stepThreeCtrl.js
 */

angular.module('app.quote').controller('stepThreeCtrl', function ($scope, $compile, $window, genericQuotesService, itemSummaryService, data, wizardNavigationService) {

  //Initialise data
  itemSummaryService.setDeliveryMethodEnums(data.deliveryMethods);
  itemSummaryService.setOperationTypeEnums(data.operationTypes);
  var navigationSteps = wizardNavigationService.getNavigationStepEnums();

  //Force Setting the step to be third
  wizardNavigationService.setCurrentState(navigationSteps.quoteReview);
  wizardNavigationService.disableAllNavs();
  wizardNavigationService.setNav();
  $scope.navProperties = wizardNavigationService.getNavProperties();

});



angular.module('app.quote').controller('stepOneCtrl', function ($scope, wizardNavigationService) {

  var navigationSteps = wizardNavigationService.getNavigationStepEnums();
  //Force Setting the step to be third
  wizardNavigationService.setCurrentState(navigationSteps.quoteInformation);
  wizardNavigationService.disableAllNavs();
  wizardNavigationService.setNav();
  $scope.navProperties = wizardNavigationService.getNavProperties();

});


/**
 * Created by Srikanth Reddy Anugu on 04/27/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\controllers\convertQuote\reviewQuoteCtrl.js
 */

angular.module('app.quote').controller('reviewQuoteCtrl', function (itemSummaryService, $scope, $state, convertQuoteService, genericQuotesService, $stateParams) {

  /***********************************************************************************************
   * Initialise Data
   **********************************************************************************************/
  $scope.quoteId = itemSummaryService.getQuoteId();
  $scope.readOnly = ($stateParams.viewOnly);

  /***********************************************************************************************
   * Routing to Convert Quote
   **********************************************************************************************/
  $scope.goToConvertQuote = function (quoteId) {
    itemSummaryService.initItemIndex();
    if ($scope.readOnly) {
      $state.go('app.quote.convertQuote', {quoteId: quoteId, viewOnly: 'viewOnly'});
    } else {
      $state.go('app.quote.convertQuote', {quoteId: quoteId});
    }
  };

  /***********************************************************************************************
   * Routing to Quote List on click of cancel
   **********************************************************************************************/
  $scope.goToQuoteList = function () {
    $scope.confirmCancel();
    angular.element('#cancelModal').modal('show');
  };

  $scope.cancelOnConfirm = function () {
    $state.go('app.quote.list');
  };

  /***********************************************************************************************
   * Validate Review Quote Form
   **********************************************************************************************/
  $scope.validateReviewQuote = function () {
    genericQuotesService.validateForm('reviewQuoteForm');
  }
});

/**
 * Created by Srikanth Reddy Anugu on 04/23/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\controllers\convertQuote\editDeliveryInfoCtrl.js
 */

angular.module('app.quote').controller('editDeliveryInfoCtrl', function (convertQuoteService, data, itemSummaryService, $state, $scope, genericQuotesService, deliveryMethodService, recipientInfoService, quoteModelService, $rootScope) {

  /***********************************************************************************************
   * Initialise Data
   **********************************************************************************************/
  itemSummaryService.setSummaryData(data.convertQuoteResponse);
  convertQuoteService.setSourceTypeEnums(data.quoteSource);
  convertQuoteService.setTermsTypeEnums(data.quoteTerms);
  deliveryMethodService.setStores(data);
  deliveryMethodService.setDeliveryMethodData(data);
  genericQuotesService.populateEnums(data);
  deliveryMethodService.setCountryStates(data);
  $scope.quoteId = itemSummaryService.getQuoteId();

  /***********************************************************************************************
   * Ability to get Each Item
   **********************************************************************************************/
  $scope.allItems = data.convertQuoteResponse.items;
  angular.forEach($scope.allItems, function (item) {
    if (item.id == $state.params.itemId) {
      $scope.item = item;
    }
  });

  /***********************************************************************************************
   * Routing to Convert Quote on click of cancel
   **********************************************************************************************/
  $scope.goToConvertQuote = function (id) {
    $scope.confirmCancel(id);
    angular.element('#cancelModal').modal('show');
  };

  $scope.cancelOnConfirm = function (quoteId) {
    $state.go('app.quote.convertQuote', {quoteId: quoteId});
  };

  /***********************************************************************************************
   * Update Delivery for Item
   **********************************************************************************************/
  $scope.updateDelivery = function () {
    var shippingMethod = $scope.item.shippingMethodName;
    var recipientArray = recipientInfoService.getRecipientInfo();
    var selectedStore = $scope.item.customerSelectedStoreId;
    var itemId = $state.params.itemId;
    var errorArray = [];
    if (shippingMethod == '20') {
      selectedStore = '';
      if (recipientArray.length <= 0 || !recipientArray[0].fullName || !recipientArray[0].address1 || !recipientArray[0].state || !recipientArray[0].postalCode || !recipientArray[0].city || !recipientArray[0].country || !recipientArray[0].phone.number) {
        (recipientArray.length <= 0) ? errorArray.push({
          name: $rootScope.getWord('Shipping'),
          message: $rootScope.getWord('AddOrSelectRecipient')
        }) : errorArray.push({name: $rootScope.getWord('Shipping'), message: $rootScope.getWord('ValidateAllFields')});
        $scope.errorBadgeFn(errorArray);
        window.scrollTo(0, 0);
        return;
      }
    }
    if (shippingMethod == '10') {
      recipientArray = [];
      if (!selectedStore) {
        errorArray.push({name: $rootScope.getWord('PickUp'), message: $rootScope.getWord('SelectPickupLocation')});
        $scope.errorBadgeFn(errorArray);
        window.scrollTo(0, 0);
        return;
      }
    }
    $scope.closeAlert();
    convertQuoteService.updateDeliveryInfo(recipientArray, shippingMethod, itemId, selectedStore);
  };

  /***********************************************************************************************
   * Set Current Selected Store
   **********************************************************************************************/
  $scope.setCurrentStore = function () {
    $scope.selectedStore = '';
    _.forEach($scope.allItems, function (item) {
      if (item.customerSelectedStoreId) {
        _.forEach(deliveryMethodService.getStores(), function (store) {
          if (item.customerSelectedStoreId == store.externalCode)
            $scope.selectedStore = store.name;
        })
      }
    });
    if ($scope.item.shippingMethodName == '10' && $scope.item.customerSelectedStoreId) {
      _.forEach(deliveryMethodService.getStores(), function (store) {
        if ($scope.item.customerSelectedStoreId == store.externalCode)
          $scope.selectedStore = store.name;
      })
    }
  };
  $scope.$on('$stateChangeStart', function (ev, toState, toParams, from) {
    if (toState.name != 'app.quote.editDeliveryInfo' && from && (from.name == 'app.quote.editDeliveryInfo')) {
      recipientInfoService.initializeRecipientInfo();
      quoteModelService.initializeQuoteModel();
      quoteModelService.initializeHeader();
    }
  });

  /***********************************************************************************************
   * Set Current Selected Store when customer Selected Store Id is in response
   **********************************************************************************************/
  if ($scope.item.customerSelectedStoreId) {
    $scope.setCurrentStore()
  }

});

/**
 * Created by Srikanth Reddy Anugu on 04/23/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\controllers\convertQuoteCtrl.js
 */
angular.module('app.quote').controller('convertQuoteCtrl', function (genericQuotesService, data, itemSummaryService, deliveryMethodService, quoteHeaderService, $scope, convertQuoteService, $q, $rootScope, notificationService, $state, $stateParams, $interval, quoteModelService, userRolesService, $compile) {
    // , quoteModelService, userRolesService, $compile
    $scope.username = userRolesService.getSystemUser().username;
    /***********************************************************************************************
     * Initialise Data
     **********************************************************************************************/
    itemSummaryService.setDeliveryMethodEnums(data.deliveryMethods);
    itemSummaryService.setOperationTypeEnums(data.operationTypes);
    genericQuotesService.populateEnums(data);
    deliveryMethodService.setDeliveryMethodData(data);
    deliveryMethodService.setStores(data);
    itemSummaryService.setSummaryData(data.convertQuoteResponse);
    quoteModelService.setAuditInfo(data.convertQuoteResponse.quoteHeader);
    convertQuoteService.setSourceTypeEnums(data.quoteSource);
    convertQuoteService.setTermsTypeEnums(data.quoteTerms);
    $scope.quoteId = itemSummaryService.getQuoteId();
    $scope.summaryService = itemSummaryService;
    var updatedItems = itemSummaryService.getItemSummaryData();
    var currentItemIndex = itemSummaryService.getCurrentItemIndex() || 0;
    var readOnly = ($stateParams.viewOnly);
    var errorArr = [];

    //convertQuoteService.setUserNotes(data.userNotes);
    $scope.userNoteList = data.userNotes || [];
    $scope.userNoteCount = data.userNotes.length;


    var dtInstance;
    $scope.options = {
        data: $scope.userNoteList,
        fnCreatedRow: function (nRow) {
            $compile(angular.element(nRow))($scope);
        },
        // This is added so that we maintain the default ordering.
        order: [[0, 'desc']],
        columns: [
            {
                mDataProp: "createdDate",
                render: function (data) {
                    if (!data) return '';
                    const date = new Date(data);
                    const options = {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    };

                    const formatted = date.toLocaleString('en-US', options);
                    const splitParts = formatted.split(', ');
                    const datePart = splitParts[0];
                    const timePart = splitParts[1];
                    return '<div>' + datePart + '<br/><strong>' + timePart + '</strong></div>';
                }
            },
            {
                "mDataProp": "createdByUserName"
            },
            {
                mDataProp: "userNote",
                render: function (data, type, row, meta) {
                    if (!data) return '';

                    const index = meta.row;
                    const collapseId = 'viewUserNotesModal';
                    const shortText = data.substring(0, 200).replace(/"/g, '&quot;');
                    const fullText = data.replace(/"/g, '&quot;');
                    const isLong = data.length > 200;

                    if (!isLong) {
                        return "<div>" + fullText + "</div>";
                    }

                    return '<div>' +
                        '<div class="note-preview" id="preview_' + index + '">' +
                        shortText + '...' +
                        '</div>' +
                        '<div id="' + collapseId + '" class="collapse">' +
                        fullText +
                        '</div>' +
                        '<a href="" ng-click="openNoteInModal(userNoteList[' + index + '])">View More</a>' +
                        '</div>';

                }
            }

        ],
        dom: 'lrtip',
        language: {
            emptyTable: "There are no notes to show"
        },
        initComplete: function (settings, json) {
            dtInstance = $('#userNotesTable').DataTable(); // make sure to use your actual table ID
        }
    };

    $scope.resetNoteForm = function () {
        $scope.newNotes = '';
    };

    var isPartialQuoteSet = $interval(function () {
        if (!$scope.partialQuoteData || !Object.keys($scope.partialQuoteData).length) {
            return;
        }

        $scope.partialQuoteData['quoteDefaultSubtotal'] = $scope.partialQuoteData.quoteSubTotal.hasOwnProperty('quoteSubTotal') && _.isNumber($scope.partialQuoteData.quoteSubTotal)
            ? Number($scope.partialQuoteData.quoteSubTotal.toFixed(2)) : $scope.partialQuoteData.quoteSubTotal;

        $scope.partialQuoteData['quoteDefaultVendorTotal'] = $scope.partialQuoteData.vendorTotal.hasOwnProperty('vendorTotal') && _.isNumber($scope.partialQuoteData.vendorTotal)
            ? Number($scope.partialQuoteData.vendorTotal.toFixed(2)) : $scope.partialQuoteData.vendorTotal;
        $interval.cancel(isPartialQuoteSet);
    }, 1000);

    var haveSelectedItems = $interval(function () {
        if (!convertQuoteService.getSelectedVariations().length || !$('#quoteSubtotalSummary').length || !$('#quoteVendorTotalSummary').length) {
            return;
        }

        $('#quoteSubtotalSummary').text(_.reduce(convertQuoteService.getSelectedVariations(), function (memo, variation) {
            return Number((memo + variation.cost).toFixed(2));
        }, 0));

        $('#quoteVendorTotalSummary').text(_.reduce(convertQuoteService.getSelectedVariations(), function (memo, variation) {
            return Number((memo + variation.vendorCost).toFixed(2));
        }, 0));

        $interval.cancel(haveSelectedItems);
    }, 1000);

    /***********************************************************************************************
     * Checking that Job Costing is available for View Only
     **********************************************************************************************/
    $scope.showJobCost = true;
    if (readOnly) {
        angular.forEach(updatedItems, function (item) {
            var checkVariationCost = true;
            if (item.itemVariationCosts && item.itemVariationCosts.length > 0) {
                angular.forEach(item.itemVariationCosts, function (cost) {
                    if (checkVariationCost) {
                        if (!cost.success) {
                            $scope.showJobCost = false;
                            checkVariationCost = false;
                        }
                    }
                })
            } else {
                $scope.showJobCost = false;
            }
        });
    }

    /***********************************************************************************************
     * Quote Number Update for Convert Quote
     **********************************************************************************************/
    $scope.convertBreadcrumb = (readOnly) ? $rootScope.getWord('ViewQuote') : $rootScope.getWord('ConvertQuote');

    /***********************************************************************************************
     * Quote Number Update for Convert Quote
     **********************************************************************************************/
    setTimeout(function () {
        $scope.updateQuoteNumber();
        // Expand the Quote Header onLoad
        if (!angular.element('#quoteHeader').hasClass('in')) angular.element('#quoteHeader').addClass('in');
        if (angular.element('#quoteHeader').hasClass('in')) angular.element('#quoteHeaderLink').removeClass('collapsed');
    }, 150);

    /***********************************************************************************************
     * Routing to Quote List on click of cancel
     **********************************************************************************************/
    $scope.goToQuoteList = function () {
        if (!readOnly) {
            $scope.confirmCancel();
            angular.element('#cancelModal').modal('show');
        } else $state.go('app.quote.list');
    };

    $scope.cancelOnConfirm = function () {
        $state.go('app.quote.list');
    };

    /***********************************************************************************************
     * Routing to Edit Delivery Info
     **********************************************************************************************/
    $scope.editDeliveryInfo = function (quoteId, itemId) {
        $state.go('app.quote.editDeliveryInfo', { quoteId: quoteId, itemId: itemId });
    };

    /***********************************************************************************************
     * Routing to Review Quote
     **********************************************************************************************/
    $scope.reviewQuoteForConvert = function (quoteId) {

        //For View Only
        if (readOnly) {
            var selectedVariationsViewObject = [];
            angular.forEach(updatedItems, function (item, itemIndex) {
                selectedVariationsViewObject.push({
                    variationId: item.selectedVariationId,
                    itemId: item.id,
                    index: item.selectedVariationViewIndex,
                    itemIdx: itemIndex
                })
            });
            convertQuoteService.setReviewSelectedVariations(selectedVariationsViewObject);
            $state.go('app.quote.reviewQuote', { quoteId: $stateParams.quoteId, viewOnly: 'viewOnly' });
        } else {
            errorArr = [];
            var customerInfo = itemSummaryService.getQuoteHeaderData().customerInfo.quoteBillTo;
            var recipientArr = itemSummaryService.getQuoteHeaderData().customerInfo.quoteShipTo;
            var selectedVarItems = convertQuoteService.getSelectedVariations();

            // Checking whether variations Selected or not per Quote
            if (selectedVarItems.length <= 0) {
                errorArr.push({
                    name: '',
                    message: $rootScope.getWord('SelectItemMsg'),
                    check: 'noItem'
                })
            }

            // Checking whether Customer Info is Complete or not
            if (!customerInfo.fullName || !customerInfo.address1 || !customerInfo.state || !customerInfo.postalCode || !customerInfo.city || !customerInfo.country || !customerInfo.email || !customerInfo.phone.number) {
                errorArr.push({
                    name: $rootScope.getWord('InvalidCustomer'),
                    message: $rootScope.getWord('CustomerInfoErrorMsg')
                })
            }

            // Checking whether Selected Variation has at least one file
            angular.forEach(selectedVarItems, function (selectedItem) {
                angular.forEach(updatedItems, function (updatedItem) {
                    if (updatedItem.id == selectedItem.itemId) {
                        if (updatedItem.files.length <= 0) {
                            errorArr.push({
                                name: $rootScope.getWord('MissingFile'),
                                message: $rootScope.getWord('MissingFileMsg'),
                                itemName: updatedItem.itemName,
                                itemNumber: $rootScope.getWord('Item') + ' ' + (selectedItem.itemIdx + 1)
                            });
                        }
                    }
                })
            });

            // Checking whether Selected Variation has Complete Recipient
            angular.forEach(selectedVarItems, function (selectedItem) {
                angular.forEach(updatedItems, function (updatedItem) {
                    if (selectedItem.itemId == updatedItem.id) {
                        if (updatedItem.shippingMethodName == 20) {
                            angular.forEach(recipientArr, function (recipientInfo) {
                                if (recipientInfo.itemId == updatedItem.id) {
                                    if (!recipientInfo.fullName || !recipientInfo.address1 || !recipientInfo.state || !recipientInfo.postalCode || !recipientInfo.city || !recipientInfo.country || !recipientInfo.phone.number) {
                                        errorArr.push({
                                            name: $rootScope.getWord('InvalidRecipient'),
                                            message: $rootScope.getWord('RecipientInfoErrorMsg'),
                                            itemName: updatedItem.itemName,
                                            itemNumber: $rootScope.getWord('Item') + ' ' + (selectedItem.itemIdx + 1)
                                        })
                                    }
                                }
                            })
                        }
                    }
                })
            });

            // Checking Whether Error Array has at least one
            if (errorArr.length > 0) {
                $scope.errorBadgeFn(errorArr);
                window.scrollTo(0, 0);
            } else {
                $scope.closeAlert();
                convertQuoteService.reviewQuoteApiCall(quoteId);
            }
        }
    };

    /***********************************************************************************************
     * File Upload for Convert Quote
     **********************************************************************************************/
    var excludeExtensions = ["ade", "adp", "app", "asa", "ashx", "asmx", "asp", "bas", "bat", "cdx", "cer", "chm", "class", "cmd", "cnt", "com", "config", "cpl", "crt", "csh", "der", "dll", "exe", "fxp", "gadget", "grp", "hlp", "hta", "htr", "htw", "ida", "idc", "idq", "ins", "isp", "its", "jse", "json", "ksh", "lnk", "mad", "maf", "mag", "mam", "maq", "mar", "mas", "mat", "mau", "mav", "maw", "mcf", "mda", "mdb", "mde", "mdt", "mdw", "mdz", "ms-one-stub", "msc", "msh", "msh1", "msh1xml", "msh2", "msh2xml", "mshxml", "msi", "msp", "mst", "ops", "pcd", "pif", "pl", "prf", "prg", "printer", "ps1", "ps1xml", "ps2", "ps2xml", "psc1", "psc2", "pst", "reg", "rem", "scf", "scr", "sct", "shb", "shs", "shtm", "shtml", "soap", "stm", "svc", "url", "vb", "vbe", "vbs", "vsix", "ws", "wsc", "wsf", "wsh", "xamlx", "ADE", "ADP", "APP", "ASA", "ASHX", "ASMX", "ASP", "BAS", "BAT", "CDX", "CER", "CHM", "CLASS", "CMD", "CNT", "COM", "CONFIG", "CPL", "CRT", "CSH", "DER", "DLL", "EXE", "FXP", "GADGET", "GRP", "HLP", "HTA", "HTR", "HTW", "IDA", "IDC", "IDQ", "INS", "ISP", "ITS", "JSE", "JSON", "KSH", "LNK", "MAD", "MAF", "MAG", "MAM", "MAQ", "MAR", "MAS", "MAT", "MAU", "MAV", "MAW", "MCF", "MDA", "MDB", "MDE", "MDT", "MDW", "MDZ", "MS-ONE-STUB", "MSC", "MSH", "MSH1", "MSH1XML", "MSH2", "MSH2XML", "MSHXML", "MSI", "MSP", "MST", "OPS", "PCD", "PIF", "PL", "PRF", "PRG", "PRINTER", "PS1", "PS1XML", "PS2", "PS2XML", "PSC1", "PSC2", "PST", "REG", "REM", "SCF", "SCR", "SCT", "SHB", "SHS", "SHTM", "SHTML", "SOAP", "STM", "SVC", "URL", "VB", "VBE", "VBS", "VSIX", "WS", "WSC", "WSF", "WSH", "XAMLX"];
    $scope.setFilesForUpload = function (fileValue, fileName) {
        $rootScope.startSpinner();
        $q.all([convertQuoteService.fileUploadApiCallForConvert(fileValue, fileName)]).then(function () {
            $rootScope.stopSpinner();
        }).catch(function () {
            $rootScope.stopSpinner();
        })
    };

    function getFileNameExt(fName) {
        if (fName) {
            var validFile = false;
            var filename = fName.toLowerCase();
            var ext = filename.substr((filename.lastIndexOf('.') + 1));
            if (excludeExtensions.indexOf(ext) == -1) {
                validFile = true;
            }
            return validFile;
        }
    }

    $scope.checkFileSelectForConvert = function (multiFiles) {
        var covertFilesValueArray = [];
        var convertFilesNameArray = [];
        if (multiFiles.length > 0) {
            angular.forEach(multiFiles, function (singleFile, index) {
                if (getFileNameExt(singleFile.name) && singleFile.value.size <= 524288000) {
                    covertFilesValueArray.push(singleFile.value);
                    convertFilesNameArray.push(singleFile.name);
                    if (index === multiFiles.length - 1) {
                        $scope.setFilesForUpload(covertFilesValueArray, convertFilesNameArray);
                        return true;
                    }
                } else {
                    notificationService.invalidFileError(singleFile.name);
                    $scope.$apply();
                    return false;
                }
            }, function () {
            })
        } else {
            return true;
        }
    };


    $scope.browseFilesForConvert = function () {
        angular.element('#txtConvertItemFile').click();
        angular.element('#txtConvertItemFile').on('click', function () {
            this.value = null;
        });
    };

    $scope.fileChangeForConvert = function (e) {
        $scope.multiFilesForConvert = [];
        if (e.files.length > 0) {
            var currentItemName = updatedItems[currentItemIndex].itemName;
            angular.forEach(errorArr, function (error, idx) {
                if ((error.itemName == currentItemName) && (error.name == 'Missing file')) {
                    errorArr.splice(idx, 1);
                }
            });

            angular.element.each(e.files, function (key, value) {
                $scope.multiFilesForConvert.push({
                    name: value.name,
                    value: value
                })
            })
        } else {
            $scope.multiFilesForConvert = [];
        }
        $scope.checkFileSelectForConvert($scope.multiFilesForConvert);
    };

    /***********************************************************************************************
     * File Remove for Convert Quote
     **********************************************************************************************/
    $scope.fileRemoveForConvert = function (file) {
        var resultObj = {
            "quoteId": itemSummaryService.getQuoteId(),
            "itemId": itemSummaryService.getCurrentItemId(),
            "fileId": file.itemFileId
        };
        convertQuoteService.removeFile(resultObj, file.fileName);
    };

    /***********************************************************************************************
     *Trigger Error Badge on Variation Select
     **********************************************************************************************/
    function checkErrorBadge() {
        angular.forEach(errorArr, function (err, idx) {
            if (err.check == 'noItem') {
                errorArr.splice(idx, 1);
            }
        })
    }

    /***********************************************************************************************
     * Variation Select for Convert Quote
     **********************************************************************************************/
    $scope.selectVariation = function (varIndex, buttonId) {
        var currentItem = itemSummaryService.getCurrentItemId();
        convertQuoteService.setSelectedVariations(currentItem, varIndex, currentItemIndex);

        if (convertQuoteService.getSelectedVariations().length && convertQuoteService.getSelectedVariations().length > 0) {

            $scope.partialQuoteData.quoteSubtotal = _.reduce(convertQuoteService.getSelectedVariations(), function (memo, variation) {
                return Number((memo + variation.cost).toFixed(2));
            }, 0);

            $scope.partialQuoteData.vendorTotal = _.reduce(convertQuoteService.getSelectedVariations(), function (memo, variation) {
                return Number((memo + variation.vendorCost).toFixed(2));
            }, 0);

            $('#quoteSubtotalSummary').text($scope.partialQuoteData.quoteSubtotal.hasOwnProperty('quoteSubTotal') && _.isNumber($scope.partialQuoteData.quoteSubtotal)
                ? Number($scope.partialQuoteData.quoteSubtotal.toFixed(2)) : $scope.partialQuoteData.quoteSubtotal);

            $('#quoteVendorTotalSummary').text($scope.partialQuoteData.vendorTotal.hasOwnProperty('vendorTotal') && _.isNumber($scope.partialQuoteData.vendorTotal)
                ? Number($scope.partialQuoteData.vendorTotal.toFixed(2)) : $scope.partialQuoteData.vendorTotal);
        } else {
            $scope.partialQuoteData.quoteSubtotal = $scope.partialQuoteData.quoteDefaultSubtotal;
            $scope.partialQuoteData.vendorTotal = $scope.partialQuoteData.quoteDefaultVendorTotal;
            $('#quoteSubtotalSummary').text($scope.partialQuoteData.quoteSubtotal);
            $('#quoteVendorTotalSummary').text($scope.partialQuoteData.vendorTotal);
        }

        variationSelectToggleBtn(varIndex, buttonId);
        checkErrorBadge();
    };

    $scope.resetVarSelectBtn = function () {
        angular.element('.variationSelectBtn').removeClass('btn-success').addClass('btn-default');
        angular.element('.variationSelectBtn').html('Select');
    };

    function variationSelectToggleBtn(index, id) {
        if (angular.element('#' + id + index).find('.variationSelectBtn').hasClass('btn-success')) {
            $scope.resetVarSelectBtn();
        } else {
            $scope.resetVarSelectBtn();
            convertQuoteService.enableSelectedVariation(index, id);
        }
    }

    /***********************************************************************************************
     * Clear Variations Functionality
     **********************************************************************************************/
    function initialiseItems() {
        convertQuoteService.initSelectedVariationsArray();
        itemSummaryService.initItemIndex();
    }

    /***********************************************************************************************
     * onState Change Clear Variations
     **********************************************************************************************/
    $scope.$on('$stateChangeStart', function (ev, toState, toParams, from) {
        if (toState.name == 'app.quote.convertQuote' && from && (from.name != 'app.quote.convertQuote' && from.name != 'app.quote.editDeliveryInfo' && from.name != 'app.quote.reviewQuote' && from.name != 'app.quote.editCustomer')) {
            initialiseItems();
        }

        if (toState.name != 'app.quote.reviewQuote' && toState.name != 'app.quote.editDeliveryInfo' && toState.name != 'app.quote.editCustomer') {
            itemSummaryService.initializeSummaryData();
            itemSummaryService.initItemIndex();
            convertQuoteService.initSelectedVariationsArray();
            quoteModelService.setAuditInfo({});
        }
    });

    /***********************************************************************************************
     * Initialise Convert Quote Footer Action Buttons
     **********************************************************************************************/
    var initConvertActionBtns = function () {
        $scope.nextItemBtn = false;
        $scope.reviewQuoteBtn = true;
        if (currentItemIndex == updatedItems.length - 1) {
            $scope.nextItemBtn = false;
            $scope.reviewQuoteBtn = true;
        } else {
            $scope.nextItemBtn = true;
            $scope.reviewQuoteBtn = false;
        }
    };

    /***********************************************************************************************
     * Route to Next Item Function
     **********************************************************************************************/
    $scope.nextItemCall = function () {
        itemSummaryService.itemChangeUpdate((Math.floor(Math.random() * 10) + 1), true);
    };

    /***********************************************************************************************
     * Update Item Index on Change
     **********************************************************************************************/
    initConvertActionBtns();
    $scope.$watch('summaryService.getCurrentItemIndex()', function (newValue, oldValue) {
        currentItemIndex = itemSummaryService.getCurrentItemIndex();
        initConvertActionBtns();
    })

    $scope.openNoteInModal = function (noteData) {
        $rootScope.selectedNote = noteData;
        $('#viewUserNotesModal').modal('show');
    };

});

"use strict";

angular
  .module('app.customer', [])
  .config(function ($stateProvider) {

    var stateDef = 'app.customer';

    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'Customers',
          requiresLogin: true
        }
      })

      .state(stateDef + '.list', {
        url: '/customer',
        templateUrl: 'app/customer/views/index.html',
        controller: 'customerCtrl',
        params: {
          incomingCustomerFilter: null
        },

        data: {
          title: 'Customers List',
          htmlId: 'extr-page'
        },
        resolve: {}
      })

      .state(stateDef + '.edit', {
        url: '/customerEdit/{id}',
        templateUrl: 'app/customer/views/edit.html',
        controller: 'customerEditCtrl',
        params: {
          id: {value: null},
          incomingCustomerData: null
        },
        data: {
          title: 'Edit Customer'
        },
        resolve: {
          data: function ($q, $stateParams, defaultApiService) {
            var customerObj = {};
            if ($stateParams.id) {
              customerObj.customerData = defaultApiService.readObjectCall('Customers', $stateParams.id);
            }
            var countries = defaultApiService.getListCall('Countries');
            var states = defaultApiService.getListCall('States/US');

            return $q.all([customerObj.customerData, countries, states]).then(function (results) {
              customerObj.customerData = results[0] ? results[0].data : {};
              customerObj.countries = results[1] ? results[1].data : {};
              customerObj.states = results[2] ? results[2].data : {};
              return customerObj;
            });

          }
        }
      })

      .state(stateDef + '.details', {
        url: '/customerDetails/{id}',
        templateUrl: 'app/customer/views/details.html',
        controller: 'customerDetailsCtrl',
        params: {
          id: {value: null}
        },
        data: {
          title: 'Customer Details'
        },
        resolve: {
          data: function ($q, $stateParams, defaultApiService) {
            if ($stateParams.id) {
              var customerData = defaultApiService.readObjectCall('Customers', $stateParams.id);
              var quoteListData = defaultApiService.getListCall('Customers' + '/' + $stateParams.id + '/' + 'Quotes');
              var recipientData = defaultApiService.getListCall('Customers' + '/' + $stateParams.id + '/' + 'Recipients');
              var quoteSource = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.Sources');
              var quoteStatus = defaultApiService.getListCall('JsTypes/FlightDeck.Estimating.Interfaces.Enums.Estimating.QuoteStatus');
            }
            return $q.all([customerData, quoteListData, recipientData, quoteSource, quoteStatus]).then(function (results) {
              var customerObj = {};
              customerObj.customerData = results[0] ? results[0].data : {};
              customerObj.quoteListData = results[1] ? results[1].data : {};
              customerObj.recipientData = results[2] ? results[2].data : {};
              customerObj.quoteSource = results[3] ? results[3].data : {};
              customerObj.quoteStatus = results[4] ? results[4].data : {};
              return customerObj;
            });

          }
        }

      })

      .state(stateDef + '.recipientEdit', {
        url: '/customerDetails/{customerId}/recipientEdit/{recipientId}',
        templateUrl: 'app/customer/recipient/views/editRecipient.html',
        controller: 'recipientEditCtrl',
        params: {
          customerId: null,
          recipientId: null
        },
        data: {
          title: 'Edit Recipient'
        },
        resolve: {
          data: function ($q, $stateParams, defaultApiService) {
            var countries = defaultApiService.getListCall('Countries');
            var states = defaultApiService.getListCall('States/US');
            var recipientObj = {};
            if ($stateParams.recipientId) {
              recipientObj.recipientData = defaultApiService.readObjectCall('Recipients', $stateParams.recipientId);
            }
            return $q.all([recipientObj.recipientData, countries, states]).then(function (results) {
              recipientObj.recipientData = results[0] ? results[0].data : {};
              recipientObj.countries = results[1] ? results[1].data : {};
              recipientObj.states = results[2] ? results[2].data : {};
              return recipientObj;
            });

          }
        }
      })
  });

/**
 * Created by $ingh on 11/7/2017.
 */

angular.module('app.customer').service('recipientService', function (defaultApiService, notificationService, $rootScope) {

  var recipientObj = {};
  var street1 = '';
  var countries = [];
  var states = [];

  function getAddressData() {
    return {
      companyName: recipientObj.companyName,
      street1: recipientObj.street1,
      street2: recipientObj.street2,
      city: recipientObj.city,
      state: recipientObj.state,
      postalCode: recipientObj.postalCode,
      country: recipientObj.country,
      isResidential: recipientObj.isResidential == false ? recipientObj.isResidential : true
    }
  }

  return {

    initializeRecipient: function () {
      recipientObj = {}
    },
    setRecipient: function (recipientData, customerId) {
      recipientObj = recipientData;
      recipientObj.customerId = customerId;
    },
    getRecipient: function () {
      return recipientObj
    },
    setCountryStates: function (recipientData) {
      countries = recipientData.countries;
      states = recipientData.states;
    },
    getCountries: function () {
      return countries
    },
    getStates: function () {
      return states
    },
    enableDisableAddressValidation: function (flag) {
      angular.element('#recipientForm')
        .formValidation('enableFieldValidators', 'txtStreet1', flag)
        .formValidation('enableFieldValidators', 'txtStreet2', flag)
        .formValidation('enableFieldValidators', 'txtCity', flag)
        .formValidation('enableFieldValidators', 'txtZipCode', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },
    enableDisableContactValidation: function (flag) {
      angular.element('#recipientForm')
        .formValidation('enableFieldValidators', 'txtPhone', flag)
        .formValidation('enableFieldValidators', 'txtExtension', flag)
        .formValidation('enableFieldValidators', 'txtEmail', flag)
        .formValidation('enableFieldValidators', 'txtWebsite', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },
    callAddressValidation: function (id) {
      var addressData = getAddressData();
      return defaultApiService.createObjectCall('AddressValidation', addressData)
        .success(function (data) {
        })
        .error(function (data) {

        })
    },
    haveAddressDetails: function () {
      return !!(recipientObj.street1 && recipientObj.city && recipientObj.state && recipientObj.postalCode && recipientObj.country && recipientObj.country.toLowerCase() == 'us');
    },
    enableSubmitButtons: function () {
      angular.element('#btn1').attr('disabled', false);
      angular.element('#btn2').attr('disabled', false);
      angular.element('#btnSave').attr('disabled', false);
      angular.element('#btn1').removeClass('disabled');
      angular.element('#btn2').removeClass('disabled');
      angular.element('#btnSave').removeClass('disabled');
    },
    setRecipientAddress: function (addressDetail) {
      recipientObj.street1 = addressDetail.street1;
      recipientObj.street2 = addressDetail.street2;
      recipientObj.city = addressDetail.city;
      recipientObj.postalCode = addressDetail.postalCode;
      recipientObj.state = addressDetail.state;
      recipientObj.country = addressDetail.country;
      recipientObj.isResidential = addressDetail.isResidential == false ? false : true;
    },
    createRecipientObject: function () {
      return defaultApiService.createObjectCall('Recipients', recipientObj)
        .success(function (data) {
          var successName = recipientObj.fullName ? recipientObj.fullName : $rootScope.getWord('Recipient');
          notificationService.notifyCreateSuccess(successName);
        });
    },
    updateRecipientObject: function (id) {
      return defaultApiService.updateObjectCall('Recipients', recipientObj, id)
        .success(function () {
          var successName = recipientObj.fullName ? recipientObj.fullName : $rootScope.getWord('Recipient');
          notificationService.notifyEditSuccess(successName);
        });
    },
    deleteRecipientObject: function (id, itemName) {
      var table = $('#recipientDatatable').DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, recipientData, node) {
        return recipientData.id === id;
      });

      defaultApiService.deleteObjectCall('Recipients', id)
        .success(function () {
          table.row(row[0]).remove().draw();
          notificationService.notifyDeleteSuccess(itemName);
        });
    },
    setStreet1: function () {
      street1 = recipientObj.street1
    },
    getStreet1: function () {
      return street1;
    }
  }
});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('app.customer').controller('recipientEditCtrl', function ($scope, $state, defaultApiService, $rootScope, $stateParams, data, recipientService, $log) {

  // Initialise data
  recipientService.initializeRecipient();
  recipientService.setCountryStates(data);
  if ($stateParams.recipientId) {
    recipientService.setRecipient(data.recipientData, $stateParams.customerId);
  }
  $log.log($stateParams);
  $scope.recipientBreadcrumb = $stateParams.recipientId ? $rootScope.getWord('EditRecipient') : $rootScope.getWord('AddNewRecipient');
  recipientService.setStreet1();
  $scope.recipient = recipientService.getRecipient();
  $scope.id = $stateParams.recipientId ? $stateParams.recipientId : null;
  $scope.recipient.countryCode = $scope.id ? $scope.recipient.countryCode ? $scope.recipient.countryCode : '+1' : '+1';
  $scope.recipient.country = $scope.id ? $scope.recipient.country : 'US';

  // Submit Recipient Functionality
  $scope.submitObject = function () {
    $scope.recipient.customerId = $stateParams.customerId;
    $scope.recipient.street1 = angular.element('#txtStreet1').val();
    delete $scope.recipient.firstName;
    delete $scope.recipient.lastName;
    recipientService.setRecipient($scope.recipient, $stateParams.customerId);

    if (recipientService.haveAddressDetails() && $scope.runSatori) {
      $rootScope.startSpinner();
      recipientService.callAddressValidation()
        .success(function (data) {
          $rootScope.stopSpinner();
          $scope.showSuggestedAddress(data);
        })
        .error(function () {
          $rootScope.stopSpinner();
        });
    }
    else {
      $scope.submitRecipient();
    }

  };

  // Cancel Button Functionality
  $scope.cancelForm = function () {
    $scope.recipient = {};
    $state.go('app.customer.details', {id: $stateParams.customerId});
  };
});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('app.customer').controller('recipientCtrl', function ($scope, $compile, $rootScope, $state, $stateParams, notificationService, recipientService, dtEncoder, userRolesService) {

  // Initialise data
  var propertyNames = [
    'firstName', 'lastName', 'street1', 'street2', 'city', 'state', 'postalCode'
  ];

  /***********************************************************************************************
   * Encoding the Recipient Object and property Names
   **********************************************************************************************/
  $scope.recipientObject = dtEncoder.dtEncodeValues($scope.recipientObject, propertyNames);

  $scope.recipientOptions = {
    data: $scope.recipientObject,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    order: [[0, 'asc']],
    buttons: [
      {
        text: '<button class="btn btn-success m-n" id="btnCreate">' +
          '                <i class="fa fa-plus p-r-sm"></i>' +
          '                <span>' + $rootScope.getWord("AddNewRecipient") + '</span>' +
          '              </button>',
        className: 'btn btn-success no-padding',
        action: function (e, dt, node, config) {
          $scope.createNewRecipient();
        }
      }
    ],
    oLanguage: {
      "sSearch": '<span class="custom-input"><i class="fa fa-search"></i></span>',
      "sSearchPlaceholder": "Recipient, Company or Address",
      "sLengthMenu": "_MENU_",
      "oPaginate": {
        "sFirst": false,
        "sLast": false,
        "sPrevious": "<strong>Previous</strong>",
        "sNext": "<strong>Next</strong>"
      }
    },
    columns: [
      {
        "mData": "",
        "mRender": function (data, type, full) {
          var firstName = full.firstName ? full.firstName : '';
          var lastName = full.lastName ? full.lastName : '';
          var html = '';
          html += firstName ? firstName : '';
          html += lastName ? firstName ? ' ' + lastName : lastName : '';
          return html;
        }
      },
      {
        "mDataProp": "companyName"
      },
      {
        "mData": "",
        "mRender": function (data, type, full) {
          var html = '';
          html += full.street1 ? '<span>' + full.street1 + '</span><br/>' : '';
          html += full.street2 ? '<span>' + full.street2 + '</span><br/>' : '';
          html += full.city ? '<span>' + full.city + '</span>' + ', ' : '';
          html += full.state ? '<span>' + full.state + '</span><br/>' : '';
          html += full.postalCode ? '<span>' + full.postalCode + '</span>' : '';
          return html;
        }
      },
      {
        "className": "col-action",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = ($rootScope.user.userRole == userRolesService.getUserNames().Coa || $rootScope.user.userRole == userRolesService.getUserNames().Estimator) ? [] : [3];
          var name = full.fullName ? full.fullName : '';
          var labels = {
            deleteLabel: $rootScope.getWord('Delete')
          };
          var btnName = $rootScope.getWord('Edit');
          var objectType = 'recipient';
          return $scope.tableDropdownActions(full.id, name, full.readOnly, commandTypes, labels, btnName, objectType);
        }
      }
    ]
  };

  // Create Recipient Functionality
  $scope.createNewRecipient = function (id) {
    $state.go('app.customer.recipientEdit', {customerId: $stateParams.id, recipientId: id})
  };

  // Primary Action Button Functionality
  $scope.defaultButtonAction = function (id) {
    $state.go('app.customer.recipientEdit', {customerId: $scope.id, recipientId: id})
  };

});

/**
 * Created by Singh on 1/17/2018.
 * Filename: src/app/customer/directives/tabsHandler.js
 */
angular.module('app.customer').directive('recipientList', function () {

    return {
      restrict: 'EA',
      templateUrl: 'app/customer/recipient/partials/recipientList.tpl.html',
      replace: true,

      link: function (scope, element, attributes) {

      }
    }
  }
);





/**
 * Created by Singh on 1/18/2018.
 * Filename: src/app/customer/recipient/directives/recipientForm.js
 */
angular.module('app.customer').directive('recipientForm', function (recipientService, $rootScope, formValidationKeyService, addressValidationService) {


    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/customer/recipient/partials/recipientForm.tpl.html',

      link: function (scope, form) {
        scope.runSatori = false;
        scope.disableAutoFill = function (id) {
          angular.element('#' + id).attr("autocomplete", "nope");
          return true;
        };

        form.formValidation({

          framework: 'bootstrap',
          icon: {
            // valid : 'glyphicon',
            // invalid : 'glyphicon glyphicon-remove',
            // validating : 'glyphicon glyphicon-refresh'
          },

          addOns: {
            i18n: {},
            mandatoryIcon: {
              // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
            }
          },

          fields: {
            txtFullName: {
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtCompanyName: {
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtStreet1: {
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtStreet2: {
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtCity: {
              group: '.col-lg-4',
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 50
                }
              }
            },
            txtZipCode: {
              group: '.col-lg-2',
              validators: {
                notEmpty: {},
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 20
                }
              }
            },
            cboCountry: {
              validators: {}
            },
            cboState: {
              validators: {}
            },
            txtState: {
              excluded: function ($field, validator) {
                return scope.recipient ? scope.recipient.country == 'US' ? true : false : true;
              },
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtPhone: {
              group: '.col-lg-4',
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 20
                },
                callback: {
                  message: {
                    en_US: 'Please enter a valid phone number',
                    fr_CA: '*(FR_CA)Please enter a valid phone number',
                    en_CA: '*(EN_CA)Please enter a valid phone number'
                  },
                  callback: function (value, validator, $field) {
                    if (value == '') {
                      return true;
                    }
                    else {
                      angular.element('#txtPhone').intlTelInput("setCountry", scope.recipient.country);
                      if (addressValidationService.isExceptionalCountry(scope.recipient.country)) {
                        angular.element('#txtPhone').intlTelInput({});
                        return true
                      }
                      else {
                        var isPhoneValid = angular.element('#txtPhone').intlTelInput('isValidNumber');
                        if (isPhoneValid)
                          addressValidationService.formatPhoneNumber('txtPhone');
                        return isPhoneValid
                      }
                    }
                  }
                }
              }

            },
            txtExtension: {
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 10
                }
              }
            }

          },

          onSuccess: function (e, data) {
            e.preventDefault();
            scope.submitObject();
          },

          live: 'enabled'

        }).on('error.validator.fv', function (e, data) {

          data.element
            .data('fv.messages')

            // Hide all the messages
            .find('.help-block[data-fv-for="' + data.field + '"]').hide()

          // Show only message associated with current validator
            .filter('[data-fv-validator="' + data.validator + '"]').show();

        }).on('change', function (e, data) {
          if (_.includes(e.target.className, "satoriAddressField")) {
            scope.runSatori = true;
          }
        });
        scope.recipient.street1 = recipientService.getStreet1();
        form.formValidation('setLocale', formValidationKeyService.getValidationKey());
      }
    }
  }
);

/**
 * Created by Singh on 11/9/2017.
 * Filename: src/app/customer/directives/customerAddress.js
 * This directive includes logic for the google api address
 */
angular.module('app.customer').directive('recipientAddress', function (autoPopulateService, recipientService, formattedPhoneService, $state, $stateParams, $rootScope) {

  return {
    restrict: 'A',
    link: function (scope) {

      scope.countries = recipientService.getCountries();
      scope.states = recipientService.getStates();

      scope.resetRecipientAddress = function () {
        if (!scope.recipient.street1) {
          scope.recipient.street2 = '';
          scope.recipient.state = '';
          scope.recipient.city = '';
          scope.recipient.postalCode = '';
          angular.element('#recipientForm').formValidation('resetField', 'txtZipCode');
        }
      };

      scope.selectAutoCompleteAddress = function (results) {
        autoPopulateService.setFields(results);
        var addressDetail = autoPopulateService.getAddress();
        recipientService.setRecipientAddress(addressDetail);
        scope.$apply();
        recipientService.enableDisableAddressValidation(true);
      };

      // address validations
      scope.recommendedAddress = function () {
        recipientService.setRecipientAddress(scope.updatedModifiedAddress);
        scope.submitRecipient();
      };

      // original address Accept
      scope.originalAddress = function () {
        recipientService.setRecipientAddress(scope.unmodifiedAddress);
        scope.submitRecipient();
      };

      scope.submitRecipient = function () {
        if (scope.id) {
          $rootScope.startSpinner();
          recipientService.updateRecipientObject(scope.id, $stateParams.customerId)
            .success(function (data) {
              $rootScope.stopSpinner();
              $state.go('app.customer.details', {id: $stateParams.customerId});
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        }
        else {
          $rootScope.startSpinner();
          recipientService.createRecipientObject($stateParams.customerId)
            .success(function (data) {
              $rootScope.stopSpinner();
              if (scope.addAnother) {
                scope.recipient = {};
                scope.recipient.countryCode = "+1";
                scope.recipient.country = "US";
              }
              else
                $state.go('app.customer.details', {id: $stateParams.customerId});
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        }
        scope.invalidAddress = false;
        scope.modifiedAddress = false;
      };

      scope.showSuggestedAddress = function (data) {
        scope.invalidAddress = false;
        scope.modifiedAddress = false;
        switch (data.result) {
          case 0:
            var updatedAddress = data.modifiedAddress ? data.modifiedAddress : data.originalAddress;
            recipientService.setRecipientAddress(updatedAddress);
            scope.submitRecipient();
            break;
          case 1:
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress ? data.originalAddress : scope.submitRecipient();
            break;
          case 2:
            scope.modifiedAddress = true;
            scope.updatedModifiedAddress = data.modifiedAddress;
            scope.unmodifiedAddress = data.originalAddress;
            break;
          case 3:
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress;
            scope.unmodifiedAddress.isResidential = data.modifiedAddress ? data.modifiedAddress.isResidential : scope.unmodifiedAddress.isResidential;
            break;
        }
      };
      if (scope.id) {
        scope.recipient.firstName = scope.recipient.firstName ? scope.recipient.firstName : '';
        scope.recipient.lastName = scope.recipient.lastName ? scope.recipient.lastName : '';
        scope.recipient.fullName = scope.recipient.firstName ? scope.recipient.firstName + ' ' + scope.recipient.lastName : scope.recipient.lastName;

      }
    }
  }
});

(function(){
  "use strict";

  angular.module('Shared.Generic', []);
})();

/**
 * Created by $ingh on 11/7/2017.
 */

angular.module('Shared.Generic').service('userRolesService', function ($rootScope, $http, defaultApiService, User, userInfo, $log) {

  var systemUserRole = [];
  var userRoleEnum = {
    Estimator: 1,
    EstimatorManager: 2,
    Coa: 3,
    CoaManager: 4
  };

  var initSystemUser = function (response) {
    var user = User.initUserInfo(response);
    $rootScope.user = user;
    getSystemUserRoles();
    return user;
  };

  var getSystemUserRoles = function () {
    systemUserRole = $rootScope.user ? $rootScope.user.userRole : userRoleEnum.Estimator;
    return systemUserRole;
  };

  initSystemUser(userInfo);
  var getSystemUser = function () {
    if ($rootScope.user) {
      return $rootScope.user;
    }

    if (userInfo && userInfo.getCurrentUser()) {
      userInfo
        .getCurrentUser()
        .then(function successCallback(response) {
          return initSystemUser(response);
        }, function errorCallback(response) {
          $log.log(response);
        });
    }
  };

  return {
    initSystemUser: function (systemUser) {
      return initSystemUser(systemUser);
    },
    getSystemUser: function () {
      return getSystemUser();
    },
    getSystemUserRoles: function () {
      return getSystemUserRoles();
    },
    isSysAdmin: function () {
      return $rootScope.user ? $rootScope.user.isSysAdmin : false;
    },
    isGroupAdmin: function () {
      return $rootScope.user ? $rootScope.user.isFacGrpAdmin : false;
    },
    isFacilityAdmin: function () {
      return $rootScope.user ? $rootScope.user.isFacAdmin : false;
    },
    isAnyAdmin: function () {
      return (this.isSysAdmin() || this.isGroupAdmin() || this.isFacilityAdmin());
    },
    isEstimator: function () {
      return $rootScope.user ? $rootScope.user.userRole == userRoleEnum.Estimator ? userRoleEnum.Estimator : false : false;
    },
    isEstimatorManager: function () {
      return $rootScope.user ? $rootScope.user.userRole == userRoleEnum.EstimatorManager ? userRoleEnum.EstimatorManager : false : false;
    },
    isCoa: function () {
      return $rootScope.user ? $rootScope.user.userRole == userRoleEnum.Coa ? userRoleEnum.Coa : false : false;
    },
    isCoaManager: function () {
      return $rootScope.user ? $rootScope.user.userRole == userRoleEnum.CoaManager ? userRoleEnum.CoaManager : false : false;
    },
    getUserNames : function () {
      return userRoleEnum
    }
  }
});

'use strict';

angular.module('Shared.Generic').service('propertyValidationService', function(){
    return {
        isNull: function (value) {
            return !(value)
        },

        isNullOrEmpty: function(value){
            return !((value) && value.length > 0);
        }
    };
});

/**
 * Created by Srikanth on 1/12/2018
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\services\notificationService.js
 */


'use strict';

angular.module('Shared.Generic').factory('notificationService', function (notificationMessages, dtEncoder, toaster) {
  var notificationService = {
    // confirmDelete: function(id, itemName, scope){
    //   swal({
    //     title: notificationMessages.confirmTitle(),
    //     text: notificationMessages.confirmDeleteMessage() + " " + itemName,
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#DD6B55",
    //     confirmButtonText: "Yes",
    //     closeOnConfirm: true,
    //     closeOnCancel: true,
    //     closeOnClickOutside: false,
    //     allowOutsideClick: false
    //   }, function () {
    //     scope.deleteOnConfirm(id, itemName);
    //   });
    // },

    notifyCreateSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successCreateTitle(),
        body: notificationMessages.successCreateMessage().replace('{1}', itemName)
      });
    },

    notifyEditSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successEditTitle(),
        body: notificationMessages.successEditMessage().replace('{1}', itemName)
      });
    },

    notifyDeleteSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successDeleteTitle(),
        body: notificationMessages.successDeleteMessage() + " " + itemName
      });
    },

    notifyAssignationSuccess: function (itemType, itemPlural) {
      toaster.success({
        title: notificationMessages.successAssignTitle(),
        body: notificationMessages.successAssignMessage().replace('{1}', itemType).replace('{2}', itemPlural)
      });
    },

    notifyRemoveSuccess: function (itemType, itemPlural) {
      toaster.success({
        title: notificationMessages.successRemoveTitle(),
        body: notificationMessages.successRemoveMessage().replace('{1}', itemType).replace('{2}', itemPlural)
      });
    },

    notifyDisableSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successDisableTitle(),
        body: notificationMessages.successDisableMessage().replace('{1}', itemName)
      });
    },

    notifyRevokeSystemAdminSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successSystemAdminTitle(),
        body: notificationMessages.successRevokeSystemAdminMessage().replace('{1}', itemName)
      });
    },

    notifyInvokeSystemAdminSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successSystemAdminTitle(),
        body: notificationMessages.successInvokeSystemAdminMessage().replace('{1}', itemName)
      });
    },

    notifyEnableSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successEnableTitle(),
        body: notificationMessages.successEnableMessage().replace('{1}', itemName)
      });
    },

    invalidFileError: function (itemName) {
      toaster.error({
        title: notificationMessages.invalidFileErrorTitle(),
        body: notificationMessages.invalidFileErrorMessage().replace('{1}', itemName)
      });
    },

    notifyFileUploadSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successFileUploadTitle(),
        body: notificationMessages.successFileUploadMsg().replace('{1}', itemName)
      });
    },

    notifyRemoveUploadedFile: function (itemName) {
      toaster.success({
        title: notificationMessages.successRemoveTitle(),
        body: notificationMessages.successRemoveUploadedFileMsg().replace('{1}', itemName)
      });
    },

    notifyQuoteCreateSuccess: function (quoteNumber) {
      toaster.success({
        title: notificationMessages.successCreateTitle(),
        body: notificationMessages.successQuoteCreateMessage().replace('{1}', he.encode(dtEncoder.escapeQuotes(quoteNumber)))
      });
    },

    notifyQuoteCreateError: function (itemName) {
      toaster.error({
        title: notificationMessages.quoteCreateErrorTitle(),
        body: notificationMessages.quoteCreateErrorMessage().replace('{1}', he.encode(dtEncoder.escapeQuotes(itemName)))
      });
    },

    notifyQuoteConvertSuccess: function (orderNumber) {
      toaster.success({
        title: notificationMessages.successConvertTitle(),
        body: notificationMessages.successQuoteConvertMessage().replace('{1}', he.encode(dtEncoder.escapeQuotes(orderNumber)))
      });
    },

    notifySaveSuccess: function (itemName) {
      toaster.success({
        title: notificationMessages.successSaveTitle(),
        body: notificationMessages.successEditMessage().replace('{1}', itemName)
      });
    }
  };
  return notificationService;
});

/**
 * Created by Srikanth on 1/12/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\services\notificationMessages.js
 */

'use strict';

angular.module('Shared.Generic').factory('notificationMessages', function ($rootScope) {
  var notificationMessages = {
    confirmTitle: function () {
      return $rootScope.getWord('MsgPleaseConfirm');
    },
    confirmDeleteMessage: function () {
      return $rootScope.getWord('MsgDeleteMessage');
    },
    successCreateTitle: function () {
      return $rootScope.getWord('MsgSuccessCreateTitle');
    },
    successCreateMessage: function () {
      return $rootScope.getWord('MsgCreateConfirmation');
    },
    successEditTitle: function () {
      return $rootScope.getWord('MsgSuccessEditTitle');
    },
    successEditMessage: function () {
      return $rootScope.getWord('MsgEditConfirmation');
    },
    successDeleteTitle: function () {
      return $rootScope.getWord('MsgSuccessfullyDeleted');
    },
    successDeleteMessage: function () {
      return $rootScope.getWord('MsgDeleteConfirmation');
    },
    successAssignTitle: function () {
      return $rootScope.getWord('MsgAssignSuccessTitle');
    },
    successAssignMessage: function () {
      return $rootScope.getWord('MsgAssignSuccessConfirmation');
    },
    successRemoveTitle: function () {
      return $rootScope.getWord('MsgRemoveSuccessTitle');
    },
    successRemoveMessage: function () {
      return $rootScope.getWord('MsgRemoveSuccessConfirmation');
    },
    successDisableTitle: function () {
      return $rootScope.getWord('MsgDisableTitle');
    },
    successDisableMessage: function () {
      return $rootScope.getWord('MsgDisableConfirmation');
    },
    successSystemAdminTitle: function () {
      return $rootScope.getWord('MsgSuccessSystemAdminTitle');
    },
    successRevokeSystemAdminMessage: function () {
      return $rootScope.getWord('MsgRevokeSystemAdminConfirmation');
    },
    successInvokeSystemAdminMessage: function () {
      return $rootScope.getWord('MsgInvokeSystemAdminConfirmation');
    },
    successEnableTitle: function () {
      return $rootScope.getWord('MsgEnableTitle');
    },
    successEnableMessage: function () {
      return $rootScope.getWord('MsgEnableConfirmation');
    },
    logOutTitle: function () {
      return $rootScope.getWord('MsgLogoutPleaseConfirm');
    },
    logOutMessage: function () {
      return $rootScope.getWord('MsgLogOutMessage');
    },
    invalidFileErrorTitle: function () {
      return $rootScope.getWord('ErrorFileTitle');
    },
    invalidFileErrorMessage: function () {
      return $rootScope.getWord('ErrorFileMessage');
    },
    successFileUploadTitle: function () {
      return $rootScope.getWord('SuccessFileUploadTitle');
    },
    successFileUploadMsg: function () {
      return $rootScope.getWord('SuccessFileUploadMessage');
    },
    successRemoveUploadedFileMsg: function () {
      return $rootScope.getWord('SuccessRemoveUploadedFileMsg');
    },
    confirmCancelTitle: function () {
      return $rootScope.getWord('ConfirmCancelTitle');
    },
    confirmCancelMessage: function () {
      return $rootScope.getWord('ConfirmCancelMessage');
    },
    quoteCreateErrorTitle: function () {
      return $rootScope.getWord('QuoteCreateErrorTitle');
    },
    quoteCreateErrorMessage: function () {
      return $rootScope.getWord('QuoteCreateErrorMessage');
    },
    successQuoteCreateMessage: function () {
      return $rootScope.getWord('QuoteCreateSuccessMessage');
    },
    successConvertTitle: function () {
      return $rootScope.getWord('MsgSuccessConvertTitle');
    },
    successQuoteConvertMessage: function () {
      return $rootScope.getWord('QuoteConvertSuccessMessage');
    },
    successSaveTitle: function () {
      return $rootScope.getWord('MsgSuccessSaveTitle');
    },
    notAuthorizedErrorTitle: function () {
      return $rootScope.getWord('NotAuthorizedErrorTitle');
    },
    notAuthorizedErrorMessage: function () {
      return $rootScope.getWord('NotAuthorizedErrorMessage');
    }
  };
  return notificationMessages;
});

/**!
 * ngGuid v0.1.2
 * @copyright 2014 Rui Marques. All Rights Reserved.
 * @license see LICENCE.
 * [https://github.com:ruionwriting/ngUUID.git]
 *
 * Based on this SO discussion: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript.
 */
//Added By JSS.

angular.module('Shared.Generic').service('guidService', Guid);

  function Guid() {
    var EMPTY = '00000000-0000-0000-0000-000000000000';

    var service = {
      newGuid: create,
      empty: EMPTY
    };

    return service;

    //////////////

    function _padLeft(paddingString, width, replacementChar) {
      return paddingString.length >= width ? paddingString : _padLeft(replacementChar + paddingString, width, replacementChar || ' ');
    }

    function _s4(number) {
      var hexadecimalResult = number.toString(16);

      return _padLeft(hexadecimalResult, 4, '0');
    }

    function _cryptoGuid() {
      var buffer = new window.Uint16Array(8);
      var crypto = window.crypto || window.msCrypto
      crypto.getRandomValues(buffer);

      return [_s4(buffer[0]) + _s4(buffer[1]), _s4(buffer[2]), _s4(buffer[3]), _s4(buffer[4]), _s4(buffer[5]) + _s4(buffer[6]) + _s4(buffer[7])].join('-');
    }

    function _guid() {
      var currentDateMilliseconds = new Date().getTime();

      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (currentChar) {
        var randomChar = (currentDateMilliseconds + Math.random() * 16) % 16 | 0;
        currentDateMilliseconds = Math.floor(currentDateMilliseconds / 16);

        return (currentChar === 'x' ? randomChar : (randomChar & 0x7 | 0x8)).toString(16);
      });
    }

    function create() {
      var hasCrypto = typeof (window.crypto) != 'undefined',
        hasRandomValues;
      if(window.crypto) {
        hasRandomValues = typeof (window.crypto.getRandomValues) != 'undefined';
      }
      else if(window.msCrypto){
        hasRandomValues = typeof (window.msCrypto.getRandomValues) != 'undefined';
      }
      return (hasCrypto && hasRandomValues) ? _cryptoGuid() : _guid();
    }
  }

/**
 * Created by $ingh on 11/9/2017.
 * Path : src/app/common/generic/directives/formattedPhone.js
 */

"use strict";

angular.module('Shared.Generic').service('formattedPhoneService', function ($rootScope, addressValidationService) {

  var formattedData = {};

  return {

    formatPhoneNo: function (phoneNumber, country, id) {
      if (phoneNumber && !addressValidationService.isExceptionalCountry(country)) {
        angular.element('#' + id).intlTelInput();
        angular.element('#' + id).intlTelInput("setCountry", country);
        angular.element('#' + id).intlTelInput('setNumber', phoneNumber);
        angular.element('#' + id).intlTelInput();
        // $('#${id}').intlTelInput("selectCountry", country);
        var countryCode = angular.element('#' + id).intlTelInput("getSelectedCountryData");

        formattedData.countryCode = '+' + countryCode.dialCode;
        formattedData.phoneNumber = angular.element('#' + id).intlTelInput('getNumber', 2);
      }
      else {
        formattedData.countryCode = addressValidationService.getCountryCode(country, id);
        formattedData.phoneNumber = phoneNumber;
        angular.element('#' + id).intlTelInput({});
      }
      return formattedData;

    }
  }
});

/**
 * Created by Srikanth Reddy on  03/19/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\services\fileUploadService.js
 */

"use strict";

angular.module('Shared.Generic').service('fileUploadService', function ($rootScope) {

  return {
    createFileFormData: function (files, data) {

      var formData = new FormData();

      if (files == null || files == undefined || files.length == 0) {
        return 0;
      }

      for (var i = 0; i < files.length; i++)
        formData.append('files[]', files[i]);

      if (data) {
        _.forEach(data, function (n, key) {
          formData.append(key, n);
        });
      }
      return formData;
    }
  };
});

angular.module('Shared.Generic').service('errorNotificationService', function ($rootScope, $log, toaster) {

  function notifyError(rejection) {
    $log.log(rejection);

    var rejectionInfo = {};
    if (rejection) {
      rejectionInfo = rejection;
    }

    var errorMessage = rejectionInfo.data ? rejectionInfo.data.message : '';

    if (rejection.data && rejection.data.error && rejection.data.error == 'Login') {
      errorMessage = rejection.data.error_description;
    }


    try {
      toaster.error("Error", errorMessage);
    } catch (e) {
      $log.log(e);
    }
  }

  return {
    notifyError: function (rejection) {
      return notifyError(rejection);
    }
  }
});

/**
 * Created by sreddy on 2/2/2018.
 */
var Utilities;
(function (Utilities) {
  var DualListTracker = (function () {
    /**
     *
     * @param assginedItemValues - Assigned item values.
     * @param assignedItemObject - Available (Remaining) item complete object.
     * @param lodash
     */
    function DualListTracker(assginedItemValues, assignedItemObject, lodash) {
      var self = this;
      self.assignedItemsIdTracker = assginedItemValues;
      self.assignedItemsObject = assignedItemObject;
      self.unselectedItemIds = [];
      self.lodash = lodash;
    }
    DualListTracker.prototype.getUnselectedItemIds = function () {
      var self = this, _ = self.lodash;
      return self.unselectedItemIds;
    };
    DualListTracker.prototype.setUnselectedItemIds = function (data) {
      var self = this, _ = self.lodash;
      self.unselectedItemIds = data;
    };
    DualListTracker.prototype.initTrackers = function (tracker, fullObject) {
      var self = this, _ = self.lodash;
      self.assignedItemsIdTracker = tracker;
      self.assignedItemsObject = fullObject;
    };
    DualListTracker.prototype.trackAssignedItems = function (itemsTracker, assignedItemsResponse) {
      var self = this, _ = self.lodash;
      for (var i = 0; i < itemsTracker.length; i++)
        self.assignedItemsIdTracker.push(itemsTracker[i]);
      for (var j = 0; j < assignedItemsResponse.length; j++)
        self.assignedItemsObject.push(assignedItemsResponse[j]);
    };
    DualListTracker.prototype.removeAssignedItems = function (batchItems, itemType) {
      var self = this, _ = self.lodash;
      /*******************************************************
       * Removes item from being tracked.                  -DG
       *******************************************************/
      var unselectedItemsIds = self.unselectedItemIds;
      for (var i = 0; i < unselectedItemsIds.length; i++)
        _.remove(self.assignedItemsIdTracker, function (trackedItem) {
          return trackedItem == unselectedItemsIds[i];
        });
      /*******************************************************
       * Remove items from the Assigned Items stored in the server -DG
       *******************************************************/
      switch (itemType) {
        case 'pressCategory':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.pressClassInkId == batchItems[j];
            });
          }
          break;
        case 'supportFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'FacilityGroupFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'SystemUserFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'SystemUserFacilityAdmin':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'SystemUserRole':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'SystemMenuItemRole':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
        case 'SystemRoleCommand':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(self.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            });
          }
          break;
      }
    };
    DualListTracker.prototype.newAssignment = function (scopeAssignedItems) {
      var self = this, _ = self.lodash;
      return _.difference(scopeAssignedItems, self.assignedItemsIdTracker);
    };
    DualListTracker.prototype.alreadyAssigned = function (scopeAssignedItems) {
      var self = this, _ = self.lodash;
      var diff = _.difference(scopeAssignedItems, self.assignedItemsIdTracker);
      //return _.difference(scopeAssignedItems, assignedItemsIdTracker);
      if (diff.length > 0)
        return false;
      else
        return true;
    };
    DualListTracker.prototype.removeUnselectedItems = function (curSelected, itemType) {
      var self = this, _ = self.lodash;
      /**************************************************************
       * curSelected ...Current list scope model.                 -DG
       * itemType ...There will be several uses for this method.  -DG
       **************************************************************/
      var tempRemArray = self.assignedItemsObject; //Get a temporary array of assignedInks.
      //Get the difference between unselected inks and assigned inks..
      var unselectedItems = _.xor(self.assignedItemsIdTracker, curSelected);
      self.unselectedItemIds = unselectedItems;
      //Pull Assign items that match unselected items.
      var itemIds = [];
      for (var i = 0; i < unselectedItems.length; i++)
        switch (itemType) {
          case 'pressCategory':
            _.findIndex(tempRemArray, function (ink) {
              if (ink.id == unselectedItems[i]) {
                itemIds.push(ink.pressClassInkId);
              }
            });
            break;
          case 'supportFacility':
            _.findIndex(tempRemArray, function (suppFacility) {
              if (suppFacility.supportingFacilityId == unselectedItems[i]) {
                itemIds.push(suppFacility.id); //Push to the Id of the object where the Item is referenced.
              }
            });
            break;
          case 'FacilityGroupFacility':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.facilityId == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserFacility':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.facilityId == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserFacilityAdmin':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.id == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserRole':
            _.findIndex(tempRemArray, function (role) {
              if (role.systemRoleId == unselectedItems[i]) {
                itemIds.push(role.id);
              }
            });
            break;
          case 'SystemMenuItemRole':
            _.findIndex(tempRemArray, function (role) {
              if (role.systemRoleId == unselectedItems[i]) {
                itemIds.push(role.id);
              }
            });
            break;
          case 'SystemRoleCommand':
            _.findIndex(tempRemArray, function (command) {
              if ((command.name || command.commandName) == unselectedItems[i]) {
                itemIds.push(command.id);
              }
            });
            break;
        }
      //Create batch of Id's
      var batchRemoveItems = [];
      for (var i = 0; i < itemIds.length; i++)
        batchRemoveItems.push(itemIds[i]);
      return batchRemoveItems; //Batch of id's that will be sent for removal.
    };
    return DualListTracker;
  }());
  Utilities.DualListTracker = DualListTracker;
})(Utilities || (Utilities = {}));

/*****************************************************************************
 * Dual List Tracker Class                                                   *
 * Path: src\app\common\generic\services\dualListTrackerClass.js             *
 * Created by: Srikanth Reddy 02/1/2018                                       *
 *****************************************************************************/

var DualListTracker = function(scopeAvailableItemsIds, scopeAvailableObjectItems){

  this.unselectedItemIds = '';
  this.assignedItemsIdTracker = scopeAvailableItemsIds;
  this.assignedItemsObject = scopeAvailableObjectItems;

  this.getUnselectedItemIds = function () {
    return this.unselectedItemIds;
  };

  this.setUnselectedItemIds = function (data) {
    this.unselectedItemIds = data;
  };
  //Initialize items trackers. Will be used for removed and assigned items.
  this.initTrackers = function (tracker, fullObject) {
    this.assignedItemsIdTracker = tracker;
    this.assignedItemsObject = fullObject;
  };
  //Track every item that has been assigned.
  this.trackAssignedItems = function (itemsTracker, assignedItemsResponse) {
    //itemsTracker... This variable tracks the items.
    //assignedItemsIdTracker... Tracks items that havee been assign.
    for (var i = 0; i < itemsTracker.length; i++)
      this.assignedItemsIdTracker.push(itemsTracker[i]);

    for (var j = 0; j < assignedItemsResponse.length; j++)
      this.assignedItemsObject.push(assignedItemsResponse[j]);
  };
  //Removes items from tracker.
  this.removeAssignedItems = function (batchItems, itemType) {

    /*******************************************************
     * Removes item from being tracked.                  -DG
     *******************************************************/
    var unselectedItemsIds = this.unselectedItemIds;
    for (var i = 0; i < unselectedItemsIds.length; i++)
      _.remove(this.assignedItemsIdTracker, function (trackedItem) {
        return trackedItem == unselectedItemsIds[i]
      });

    /*******************************************************
     * Remove items from the Assigned Items stored in the server -DG
     *******************************************************/
    switch (itemType) {
      case 'pressCategory':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.pressClassInkId == batchItems[j];
            }
          );
        }
        break;
      case 'supportFacility':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'FacilityGroupFacility':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'SystemUserFacility':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'SystemUserFacilityAdmin':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'SystemUserRole':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'SystemMenuItemRole':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'SystemRoleCommand':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;
      case 'deliveryRouteFacility':
        for (var j = 0; j < batchItems.length; j++) {
          _.remove(this.assignedItemsObject, function (assignedItem) {
              return assignedItem.id == batchItems[j];
            }
          );
        }
        break;

    }
  };
  //Calculates if the item/s haven't already been assigned
  this.newAssignment = function(scopeAssignedItems){
    return  _.difference(scopeAssignedItems, this.assignedItemsIdTracker);
  };
  this.alreadyAssigned = function (scopeAssignedItems) {
    var diff = _.difference(scopeAssignedItems, this.assignedItemsIdTracker);
    //return _.difference(scopeAssignedItems, assignedItemsIdTracker);

    if (diff.length > 0)
      return false;
    else
      return true;
  };
  //Creates the remove batch to pass it to the call.
  this.removeUnselectedItems = function (curSelected, itemType) {

    /**************************************************************
     * curSelected ...Current list scope model.                 -DG
     * itemType ...There will be several uses for this method.  -DG
     **************************************************************/

    var tempRemArray = this.assignedItemsObject;//Get a temporary array of assignedInks.

    //Get the difference between unselected inks and assigned inks..
    var unselectedItems = _.xor(this.assignedItemsIdTracker, curSelected);
    this.unselectedItemIds = unselectedItems;

    //Pull Assign items that match unselected items.
    var itemIds = [];
    for (var i = 0; i < unselectedItems.length; i++)
      switch (itemType) {
        case 'pressCategory':
          _.findIndex(tempRemArray, function (ink) {
            if (ink.id == unselectedItems[i]) {
              itemIds.push(ink.pressClassInkId);
            }
          });
          break;
        case 'supportFacility':
          _.findIndex(tempRemArray, function (suppFacility) {
            if (suppFacility.supportingFacilityId == unselectedItems[i]) {//Match Item Id with Object Id
              itemIds.push(suppFacility.id);//Push to the Id of the object where the Item is referenced.
            }
          });
          break;
        case 'FacilityGroupFacility':
          _.findIndex(tempRemArray, function (facility) {
            if (facility.facilityId == unselectedItems[i]) {
              itemIds.push(facility.id);
            }
          });
          break;
        case 'SystemUserFacility':
          _.findIndex(tempRemArray, function (facility) {
            if (facility.facilityId == unselectedItems[i]) {
              itemIds.push(facility.id);
            }
          });
          break;
        case 'SystemUserFacilityAdmin':
          _.findIndex(tempRemArray, function (facility) {
            if (facility.id == unselectedItems[i]) {
              itemIds.push(facility.id);
            }
          });
          break;
        case 'SystemUserRole':
          _.findIndex(tempRemArray, function (role) {
            if (role.systemRoleId == unselectedItems[i]) {
              itemIds.push(role.id);
            }
          });
          break;
        case 'SystemMenuItemRole':
          _.findIndex(tempRemArray, function (role) {
            if (role.systemRoleId == unselectedItems[i]) {
              itemIds.push(role.id);
            }
          });
          break;
        case 'SystemRoleCommand':
          _.findIndex(tempRemArray, function (command) {
            if (command.name == unselectedItems[i]) {
              itemIds.push(command.id);
            }
          });
          break;
        case 'deliveryRouteFacility':
          _.findIndex(tempRemArray, function (command) {
            if (command.facilityId == unselectedItems[i]) {
              itemIds.push(command.id);
            }
          });
          break;
      }
    //Create batch of Id's
    var batchRemoveItems = [];
    for (var i = 0; i < itemIds.length; i++)
      batchRemoveItems.push(itemIds[i]);

    return batchRemoveItems;//Batch of id's that will be sent for removal.
  };
};

/**
 * Created by Srikanth Reddy on 2/1/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\services\dualListService.js
 */

angular.module('Shared.Generic').service('dualListService', function () {
  var unselectedItemIds = [];
  var assignedItemsIdTracker = [];
  var assignedItemsObject = [];
  return {
    removeUnselectedItemsObsolete: function (assigned, tracker, curSelected, itemType) {

      var tempRemArray = assigned;//Get a temporary array of assignedInks.

      //Get the difference between unselected inks and assigned inks..
      var unselectedItems = _.xor(tracker, curSelected);
      unselectedItemIds = unselectedItems;

      //Pull Assign inks that match unselected inks.
      var itemIds = [];
      for (var i = 0; i < unselectedItems.length; i++)
        switch (itemType) {
          case 'pressCategory':
            _.findIndex(tempRemArray, function (ink) {
              if (ink.id == unselectedItems[i]) {
                itemIds.push(ink.pressClassInkId);
              }
            });
            break;
        }
      //Create batch of Press Class Inks Id's
      var batchRemoveItems = [];
      for (var i = 0; i < itemIds.length; i++)
        batchRemoveItems.push(itemIds[i]);

      return batchRemoveItems;
    },
    getUnselectedItemIds: function () {
      return unselectedItemIds;
    },
    setUnselectedItemIds: function (data) {
      unselectedItemIds = data;
    },
    //Initialize items trackers. Will be used for removed and assigned items.
    initTrackers: function (tracker, fullObject) {
      assignedItemsIdTracker = tracker;
      assignedItemsObject = fullObject;
    },
    //Track every item that has been assigned.
    trackAssignedItems: function (itemsTracker, assignedItemsResponse) {
      //itemsTracker... This variable tracks the items.
      //assignedItemsIdTracker... Tracks items that havee been assign.
      for (var i = 0; i < itemsTracker.length; i++)
        assignedItemsIdTracker.push(itemsTracker[i]);

      for (var j = 0; j < assignedItemsResponse.length; j++)
        assignedItemsObject.push(assignedItemsResponse[j]);
    },
    //Removes items from tracker.
    removeAssignedItems: function (batchItems, itemType) {

      /*******************************************************
       * Removes item from being tracked.                  -DG
       *******************************************************/
      for (var i = 0; i < unselectedItemIds.length; i++)
        _.remove(assignedItemsIdTracker, function (trackedItem) {
          return trackedItem == unselectedItemIds[i]
        });

      /*******************************************************
       * Remove items from the Assigned Items stored in the server -DG
       *******************************************************/
      switch (itemType) {
        case 'pressCategory':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.pressClassInkId == batchItems[j];
              }
            );
          }
          break;
        case 'supportFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'FacilityGroupFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'SystemUserFacility':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'SystemUserFacilityAdmin':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'SystemUserRole':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'SystemMenuItemRole':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;
        case 'SystemRoleCommand':
          for (var j = 0; j < batchItems.length; j++) {
            _.remove(assignedItemsObject, function (assignedItem) {
                return assignedItem.id == batchItems[j];
              }
            );
          }
          break;

      }
    },
    //Calculates if the item/s haven't already been assigned
    newAssignment: function (scopeAssignedItems) {

      var diff = _.difference(scopeAssignedItems, assignedItemsIdTracker);
      return diff;
    },
    alreadyAssigned: function (scopeAssignedItems) {
      var diff = _.difference(scopeAssignedItems, assignedItemsIdTracker);
      //return _.difference(scopeAssignedItems, assignedItemsIdTracker);

      if (diff.length > 0)
        return false;
      else
        return true;
    },
    //Creates the remove batch to pass it to the call.
    removeUnselectedItems: function (curSelected, itemType) {

      /**************************************************************
       * curSelected ...Current list scope model.                 -DG
       * itemType ...There will be several uses for this method.  -DG
       **************************************************************/

      var tempRemArray = assignedItemsObject;//Get a temporary array of assignedInks.

      //Get the difference between unselected inks and assigned inks..
      var unselectedItems = _.xor(assignedItemsIdTracker, curSelected);
      unselectedItemIds = unselectedItems;

      //Pull Assign items that match unselected items.
      var itemIds = [];
      for (var i = 0; i < unselectedItems.length; i++)
        switch (itemType) {
          case 'pressCategory':
            _.findIndex(tempRemArray, function (ink) {
              if (ink.id == unselectedItems[i]) {
                itemIds.push(ink.pressClassInkId);
              }
            });
            break;
          case 'supportFacility':
            _.findIndex(tempRemArray, function (suppFacility) {
              if (suppFacility.supportingFacilityId == unselectedItems[i]) {//Match Item Id with Object Id
                itemIds.push(suppFacility.id);//Push to the Id of the object where the Item is referenced.
              }
            });
            break;
          case 'FacilityGroupFacility':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.facilityId == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserFacility':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.facilityId == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserFacilityAdmin':
            _.findIndex(tempRemArray, function (facility) {
              if (facility.id == unselectedItems[i]) {
                itemIds.push(facility.id);
              }
            });
            break;
          case 'SystemUserRole':
            _.findIndex(tempRemArray, function (role) {
              if (role.systemRoleId == unselectedItems[i]) {
                itemIds.push(role.id);
              }
            });
            break;
          case 'SystemMenuItemRole':
            _.findIndex(tempRemArray, function (role) {
              if (role.systemRoleId == unselectedItems[i]) {
                itemIds.push(role.id);
              }
            });
            break;
          case 'SystemRoleCommand':
            _.findIndex(tempRemArray, function (command) {
              if (command.name == unselectedItems[i] || command.commandName == unselectedItems[i]) {
                itemIds.push(command.id);
              }
            });
            break;
        }
      //Create batch of Id's
      var batchRemoveItems = [];
      for (var i = 0; i < itemIds.length; i++)
        batchRemoveItems.push(itemIds[i]);

      return batchRemoveItems;//Batch of id's that will be sent for removal.
    }
  };

});

/**
 * Created by Srikanth on 4/6/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\services\downloadFileService.js
 */

angular.module('Shared.Generic').service('downloadFileService', function () {

  /**
   * @return {string}
   */
  var RandomId = function () {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  };

  return {
    saveFile: function (xhr, name) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      var tempId = RandomId();
      link.setAttribute('id', tempId);
      var contentDisposition = xhr.getResponseHeader('Content-Disposition');
      var filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      if (xhr) {//Check if xhr is an object.
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(new Blob([xhr.response], {type: xhr.response.type}), name);
        } else {
          var file = new Blob([xhr.response], {type: xhr.response.type});
          link.href = URL.createObjectURL(file);
          link.download = filename ? filename : name;
          link.target = '_blank';
        }
        link.click();
      } else {
        link.href = xhr;
        link.download = filename ? filename : name;
        link.target = '_blank';
        link.click();
      }
      link.remove();
    }
  }
});

/**
 * Created by $ingh on 1011/2017.
 * Path: src/app/common/generic/services/defaultApiService.js
 */

'use strict';

angular.module('Shared.Generic').factory('defaultApiService', function ($http, $q, $cookies, $rootScope) {

  return {

    getListCall: function (api) {
      return $http({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api
      });
    },

    createObjectCall: function (api, payload) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api,
        data: payload
      });
    },
    createObjectCallWithId: function (api, id) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id
      });
    },
    readObjectCall: function (api, payloadId) {
      return $http({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId
      });
    },
    readObjectCallWithQuery: function (api, payloadId, query) {
      return $http({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId + query
      });
    },

    readObjectCallWithObject: function (api, payloadId, object) {
      return $http({
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId + '/' + object
      });
    },

    updateObjectCall: function (api, payload) {
      return $http({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payload.id,
        data: payload
      });
    },

    updateObjectCallWithQuery: function (api, payload, queryName) {
      return $http({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payload.id + '/' + queryName,
        data: payload
      });
    },

    batchAdd: function (api, id, payload) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id + '/BatchAdd',
        data: payload
      });
    },

    batchRemove: function (api, id, payload) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id + '/BatchRemove',
        data: payload
      });
    },

    apiActionsCall: function (api, id, payload, batchApi) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id + '/' + batchApi,
        data: payload
      });
    },

    batchRemoveWithApi: function (api, id, payload, batchApi) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id + '/' + batchApi,
        data: payload
      });
    },

    batchAddWithApi: function (api, id, payload, batchApi) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + id + '/' + batchApi,
        data: payload
      });
    },

    deleteObjectCall: function (api, payloadId) {
      return $http({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId
      });
    },

    deleteObjectWithContractCall: function (api, payload) {
      return $http({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        url: appConfig.apiURL + '/api/' + api,
        data: payload
      });
    },

    createObjectWithDomainModel: function (api, payloadId, payload, domainModel) {
      if (domainModel)
        domainModel = 'domain-model=' + domainModel;
      else
        domainModel = "";

      return $http({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;' + domainModel
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId,
        data: payload
      });
    },

    //SSM -- CURRENTLY USED ON HEADER.TPL.HTML
    changeFacility: function (facilityId) {
      return $http({
        method: 'PUT',
        url: appConfig.apiURL + '/api/CurrentFacility/' + facilityId
      });
    },

    lookupObjects: function (objectName) {
      return $http({
        method: 'GET',
        url: appConfig.apiURL + '/api/Lookup?LookupType=' + objectName
      });
    },

    booleanCall: function (api, payloadId, payload, activity) {
      return $http({
        method: 'POST',
        headers: {
          'Content-Type': "application/json"
        },
        url: appConfig.apiURL + '/api/' + api + '/' + payloadId + '/' + activity,
        data: payload
      });
    }

  };
});

/**
 * Created by $INGH on 3/1/2017.
 */

'use strict';

angular.module('Shared.Generic').service('addressValidationService', function () {

    var countryCode = '';
    var exceptionalCountries = ['AQ', 'BV', 'CX', 'CC', 'TP', 'TF', 'HM', 'YT', 'AN', 'PN', 'GS', 'SJ', 'UM', 'EH', 'ZR'];
    var isExceptionalCountry = false;
    var exceptionalCountriesData = [
        {
            areaCodes: null,
            dialCode: "672",
            iso2: "aq",
            name: "Antarctica",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "47",
            iso2: "bv",
            name: "Bouvet Island",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "61",
            iso2: "cx",
            name: "Christmas Island",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "891",
            iso2: "cc",
            name: "Cocos",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "670",
            iso2: "tp",
            name: "East Timor",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "262",
            iso2: "tf",
            name: "French Southern Territories",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "0",
            iso2: "hm",
            name: "Heard and McDonald Islands",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "262",
            iso2: "yt",
            name: "Mayotte",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "599",
            iso2: "an",
            name: "Netherlands Antilles",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "64",
            iso2: "pn",
            name: "Pitcairn",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "500",
            iso2: "gs",
            name: "S. Georgia and S. Sandwich Islands",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "47",
            iso2: "sj",
            name: "Svalbard and Jan Mayen Islands",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "1",
            iso2: "um",
            name: "US Minor Outlying Islands",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "212",
            iso2: "eh",
            name: "Western Sahara",
            priority: 0
        },
        {
            areaCodes: null,
            dialCode: "243",
            iso2: "zr",
            name: "Zaire",
            priority: 0
        }

    ];

    return {
        getCountryCode: function (value, elementId, countries) {
            countryCode = '';
            angular.element('#' + elementId).intlTelInput();

            var matchedCountry = _.find(exceptionalCountriesData, function (o, i) {
                return o.iso2.toUpperCase() == value;
            });

            if (matchedCountry) {
                isExceptionalCountry = true;
                var countryCode = '+' + matchedCountry.dialCode;
                return countryCode;
            }
            else {
                isExceptionalCountry = false;
              angular.element('#' + elementId).intlTelInput("setCountry", value);
                var countryCode = angular.element('#' + elementId).intlTelInput("getSelectedCountryData");
                countryCode = '+' + countryCode.dialCode;
                return countryCode;
            }
        },

        exceptionalCountries: function () {
            exceptionalCountries = []
        },
        isExceptionalCountry: function (value) {
            var matchedCountry = _.find(exceptionalCountriesData, function (o, i) {
                return o.iso2.toUpperCase() == value;
            });

            if (matchedCountry)
                isExceptionalCountry = true;
            else
                isExceptionalCountry = false;
            return isExceptionalCountry
        },
        formatPhoneNumber : function (id) {
          var formattedPhoneNumber = angular.element('#' +id).intlTelInput("getNumber");
          angular.element('#' +id).intlTelInput('setNumber', formattedPhoneNumber);
        }
    }
});

(function() {
  'use strict';

  angular
    .module('app',
      ['ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'ui.bootstrap',

        //Common Module
        'Shared',

        // App
        'app.auth',
        'app.admin',
        'app.dashboard',
        'app.quote',
        'app.customer',
        'app.settings',

        //Plugins
        'oc.lazyLoad',
        'toaster',
        'angucomplete-alt'
      ]);

})();



'use strict';

// Set as a contant at the app level.
angular.module('app').service('userInfo', function ($http, $q, defaultApiService) {
	return {
		cache: null,
		isNotRetrieved: true,
		getCurrentUser: function () {
			// Avoid scoping issues!
			var self = this;

			var deferred = $q.defer();
			// Check the cache first.
			if (self.cache) {
				deferred.resolve(self.cache);
			}
			else {
				defaultApiService
					.getListCall('CurrentUser')
					.success(function (response) {
						// Store the data in the cache.
						self.cache = response;
						deferred.resolve(self.cache);
					});
			}
			return deferred.promise;
		}
	};
});

'use strict';

angular.module('Shared.Generic').factory('User', function ($rootScope) {

  var UserModel;
  return {

    initUserInfo: function (response) {

      if (response && response.login) {
        UserModel = {};
        UserModel.username = response.login;
        UserModel.userId = response.id;
        UserModel.isSysAdmin = response.isSystemAdmin;
        UserModel.firstName = response.firstName;
        UserModel.lastName = response.lastName;
        UserModel.title = response.title;
        UserModel.email = response.email;
        UserModel.login = response.login;
        UserModel.userRole = response.userRole;
        UserModel.isDeleted = response.isDeleted;
        UserModel.isDisabled = response.isDisabled;
        UserModel.defaultCurrencyCode = response.defaultCurrency;
        UserModel.systemUserRoles = response.systemUserRoles;
        localStorage.setItem('login', response.login);
        localStorage.setItem('defaultCurrency', response.defaultCurrency);
      }
      return UserModel;
    },
    getUserInfo: function () {
      return UserModel;
    }
  };
});

/**
 * Created by Srikanth on 5/15/2018.
 */
angular.module('Shared.Generic').directive('warningBadge', function ($rootScope, $stateParams, quoteModelService, $state, genericQuotesService) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/common/generic/partials/warningBadge.tpl.html',

    link: function (scope, element, attributes) {

      var badgeFlags = {
        "quoteHistory" : 1,
        "viewOnly" : 2
      };
      var badgeFlag = badgeFlags.quoteHistory;
      scope.warningTitleText = attributes.warningTitleText ? $rootScope.getWord(attributes.warningTitleText) : scope.warningTitleText;
      scope.warningMsgText = attributes.warningMsgText ? $rootScope.getWord(attributes.warningMsgText) : scope.warningMsgText;
      scope.primaryLinkText = attributes.primaryLinkText ? $rootScope.getWord(attributes.primaryLinkText) : scope.primaryLinkText;
      scope.secondaryLinkText = attributes.secondaryLinkText ? $rootScope.getWord(attributes.secondaryLinkText) : scope.secondaryLinkText;

      scope.showBadge = function (number) {
        scope.versionNumber = number ? number : '';
        angular.element('#warning-badge').removeClass('hide');
      };

      scope.primaryLinkFn = function () {
        if (badgeFlag == badgeFlags.viewOnly) {
          $state.go('app.quote.list');
        } else {
          var id = $stateParams.versionId;
          scope.showModal(id, scope.versionNumber || genericQuotesService.getVersionNumber());
        }
      };

      //To restore a Quote to its current version
      scope.secondaryLinkFn = function () {
        var id = $stateParams.versionId;
        $state.go('app.quote.createQuote.step_one', {
          id: $stateParams.quoteId || $stateParams.id,
          versionId: '',
          viewQuote: ''
        });
      };

      //To restore a Quote
      scope.actionSubmitModal = function (id) {
        angular.element('#genericModal').removeClass('fade');
        angular.element('#genericModal').modal('hide');
        quoteModelService.setReadOnlyFlag(false);
        genericQuotesService.setLegitStateChange(false);
        $state.go('app.quote.createQuote.step_one', {
          id: $stateParams.quoteId || $stateParams.id,
          versionId: id,
          restore: true,
          viewQuote: ''
        })
      };

      //Set the warning head text
      if ($stateParams.viewQuote) {
        scope.warningTitleText = $rootScope.getWord('Version');
        scope.warningMsgText = $rootScope.getWord('ViewOldVersion');
        scope.primaryLinkText = $rootScope.getWord('RestoreVersion');
        scope.secondaryLinkText = $rootScope.getWord('CurrentVersion');
        badgeFlag = badgeFlags.quoteHistory;
        scope.showBadge(genericQuotesService.getVersionNumber());
      }
      else if ($stateParams.viewOnly) {
        scope.warningMsgText = $rootScope.getWord('ViewReadOnlyVersion');
        scope.primaryLinkText = $rootScope.getWord('BackToQuotesList');
        badgeFlag = badgeFlags.viewOnly;
        scope.showBadge();
      } else {
        angular.element('#warning-badge').addClass('hide');
      }

    }
  }
});

/**
 * Created by sreddy on 5/1/2018.
 */

angular.module('Shared.Generic').directive('timePicker', function () {
  return {
    restrict: 'A',
    link: function (scope, tElement, tAttributes) {
      tElement.removeAttr('time-picker');

      var setDefaultTime = 'current';
      moment.fn.roundNext15Min = function () {
        var intervals = Math.floor(this.minutes() / 15);
        if (this.minutes() % 15 != 0)
          intervals++;
        if (intervals == 4) {
          this.add('hours', 1);
          intervals = 0;
        }
        this.minutes(intervals * 15);
        this.seconds(0);
        return this;
      };

      if (tAttributes.redo)
        setDefaultTime = moment().roundNext15Min().add(15, 'minutes').format('hh:mm A');

      tElement.on('click', function () {//Initialize timePicker

        tElement.timepicker({
          showInputs: false, //Remove Text boxes.
          defaultTime: setDefaultTime
        });
        //this.click();//Initialize popup.
      });

      scope.initTimePicker = function () {//Initialize timePicker popup with label click.
        tElement.click();
      };
    }
  }
});

/**
 * Created by Srikanth Reddy on 5/17/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\generic\directives\smartCkEditor.js
 */
angular.module('Shared.Generic').directive('smartCkEditor', function () {

  return {
    require: '?ngModel',
    link: function (scope, elm, attr, ngModel) {
      var ck = CKEDITOR.replace(elm[0]);

      if (!ngModel) return;

      ck.on('pasteState', function () {
        scope.$apply(function () {
          ngModel.$setViewValue(ck.getData());
        });
      });

      ngModel.$render = function (value) {
        ck.setData(ngModel.$viewValue);
      };
    }
  }
});

/**
 * Created by sreddy on 8/1/2018.
 */

angular.module('Shared.Generic').directive('pageTitle', function ($rootScope, $timeout) {
  return {
    restrict: 'A',
    compile: function (element, attributes) {
      element.removeAttr('page-title data-page-title');
      var defaultTitle = attributes.pageTitle;
      var listener = function (event, toState, toParams, fromState, fromParams) {
        var title = defaultTitle;

        if (toState.data && toState.data.title) {
          title = $rootScope.getWord(toState.data.title) + ' | ' + title;
        }

        // Set asynchronously so page changes before title does
        $timeout(function () {
          angular.element('html head title').text(title);
        });
      };

      $rootScope.$on('$stateChangeStart', listener);

    }
  }
});

/**
 * Created by dgarcia on 3/10/2017.
 */

angular.module('Shared.Generic').directive('intlTel', function(){
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {

            //Remove attribute
            tElement.removeAttr('intl-tel data-intl-tel');

            //Set plugin options
            var options = {
                autoFormat : true,
                autoHideDialCode: false,
                preferredCountries : ['us', 'ca'],
              formatOnDisplay: true,


               allowDropdown: false,
              // autoPlaceholder: "off",
              //  dropdownContainer: "body"
              // excludeCountries: ["us"],
              // formatOnDisplay: false,
              // geoIpLookup: function(callback) {
              //   $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
              //     var countryCode = (resp && resp.country) ? resp.country : "";
              //     callback(countryCode);
              //   });
              // },
              //  hiddenInput: "full_number"
              // initialCountry: "auto",
              // nationalMode: false,
              // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
               placeholderNumberType: "MOBILE",
              // preferredCountries: ['cn', 'jp'],
              // separateDialCode: true,
            };

            //Initialise it on input element
            tElement.intlTelInput(options);
        }
    }
});

/**
 * Created by sreddy on 3/2/2018.
 */
angular.module('Shared.Generic').directive('inputEnter', function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.inputEnter);
        });
        event.preventDefault();
      }
    });
  };
});

/**
 * Created by $ingh on 1/5/2018.
 */

"use strict";

angular.module('Shared.Generic')
  .directive('gmPlacesAutocomplete', ['$rootScope', function ($rootScope) {
    var configOptions = {
      placeIdOnly: true,
      types: ['geocode']
    };

    return {
      restrict: 'AEC',
      require: ['gmPlacesAutocomplete', '?ngModel'],
      controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
        if (!appConfig.useGoogleAutoComplete) {
          return;
        }

        this._options = angular.extend({}, configOptions, $scope.$eval($attrs.gmOptions));
        this._element = $element[0];
        this._autoCompleteApi = undefined;
        this._placeApi = undefined;
        this._geocoderApi = undefined;

        // Define properties
        Object.defineProperties(this, {
          element: {
            get: function () {
              return this._element;
            },
            configurable: false
          },
          autoCompleteApi: {
            get: function () {
              return this._autoCompleteApi;
            },
            configurable: false
          },
          placeApi: {
            get: function () {
              return this._placeApi;
            },
            configurable: false
          },
          geocoderApi: {
            get: function () {
              return this._geocoderApi;
            },
            configurable: false
          }
        });

        // This is test to reduce google credits
        // this._options.placeIdOnly  = true;

        try {
          this._autoCompleteApi = new google.maps.places.Autocomplete(this._element, this._options);
          this._autoCompleteApi.setComponentRestrictions({'country': ['us']});
        }
        catch (err) {
          console.log(err)
        }

        try {
          this._placeApi = new google.maps.places.PlacesService(document.createElement('div'));
        }
        catch (err) {
          console.log(err)
        }

        try {
          this._geocoderApi = new google.maps.Geocoder;
        }
        catch (err) {
          console.log(err)
        }
      }],
      link: function (scope, iElement, iAttrs, controllers) {
        if (!appConfig.useGoogleAutoComplete) {
          return;
        }

        // Define controllers
        var gmPlacesAutocompleteController = controllers[0];
        var ngModelController = controllers[1];

        // Set initial model value if a model is defined
        if (ngModelController) {
          ngModelController.$setViewValue(gmPlacesAutocompleteController.autoCompleteApi);
        }

        // Listen to place_changed event
        google.maps.event.addListener(gmPlacesAutocompleteController.autoCompleteApi, 'place_changed',
          (function (scope, iElement, iAttrs, gmPlacesAutocompleteController, ngModelController, $rootScope) {
            return function () {

              // Broadcast event
              $rootScope.$broadcast('gmPlacesAutocomplete::placeChanged', gmPlacesAutocompleteController);
            };
          })(scope, iElement, iAttrs, gmPlacesAutocompleteController, ngModelController, $rootScope)
        );

        //Prevents to submit the form on 'enter key' while selecting the suggested addresses from google api
        var input = document.getElementById(iElement[0].id);
        google.maps.event.addDomListener(input, 'keydown', function (e) {
          if (e.keyCode == 13) {
            e.preventDefault();
          }
        });

        scope.$on('gmPlacesAutocomplete::placeChanged', function (currentScope, element) {
          var location = element._autoCompleteApi.getPlace();
          if (location == undefined) {
            return false;
          }

          if (location.address_components) {
            scope.selectedGoogleAddress(location);
            return;
          }

          if (!location.place_id) {
            return false;
          }

          gmPlacesAutocompleteController.geocoderApi.geocode({'placeId': location.place_id}, function (results, status) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
              scope.selectedGoogleAddress(results);
            } else {
              // TEMP: Added for QA to keep testing
              gmPlacesAutocompleteController._placeApi.getDetails({'placeId': location.place_id}, function (results, status) {
                scope.selectedGoogleAddress(results);
              });
            }
          });
        });

        // Fixed Issue with autofill
        document.getElementById("txtStreet1").addEventListener("focusout", function () {
          angular.element("#txtStreet1").blur()
        });

        scope.selectedGoogleAddress = function (results) {
          scope.selectAutoCompleteAddress(results)
        };
      }
    };

  }]);

/**
 * Created by $ingh on 5/14/2018.
 */

angular.module('Shared.Generic').directive('genericModal', function ($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/common/generic/partials/genericModal.tpl.html',

    link: function (scope, elements, attributes) {
      scope.modalId = null;
      scope.headerTittle = $rootScope.getWord('Action');
      scope.labelCancel = $rootScope.getWord('Cancel');
      scope.labelSubmit = $rootScope.getWord('Submit');
      scope.modalBody = $rootScope.getWord('AreYouSure');

      if (attributes.headerTittle) {
        scope.headerTittle = $rootScope.getWord(attributes.headerTittle);
      }
      if (attributes.labelCancel) {
        scope.labelCancel = $rootScope.getWord(attributes.labelCancel);
      }
      if (attributes.labelSubmit) {
        scope.labelSubmit = $rootScope.getWord(attributes.labelSubmit);
      }
      if (attributes.modalBody) {
        scope.modalBody = $rootScope.getWord(attributes.modalBody);
      }

      scope.showModal = function (id, name) {
        scope.modalId = id;
        scope.headerTittle = $rootScope.getWord(attributes.headerTittle) + name;
        angular.element('#genericModal').modal('show');
      };

      scope.submitModal = function () {
         scope.actionSubmitModal(scope.modalId);
      };

      scope.cancelModal = function () {

      };

    }
  }
});


/**
 * Created by Srikanth Reddy  on 2/1/2018.
 */
angular.module('Shared.Generic').directive('dualListBoxOnChange', function($rootScope){
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      //  element.removeAttr('dual-list-box data-dual-list-box');

      //Creates an object composed of the picked object properties

      var aOptions = _.pick(attrs, ['nonSelectedFilter']);

      scope.nonSelectedListLabel = $rootScope.getWord('Nonselected');
      scope.selectedListLabel = $rootScope.getWord('Selected');
      if (attrs.nonSelectedListLabel) {
        attrs.nonSelectedListLabel = attrs.nonSelectedListLabel;
        scope.nonSelectedListLabel = attrs.nonSelectedListLabel;
      }
      if (attrs.selectedListLabel) {
        attrs.nonSelectedListLabel = attrs.selectedListLabel;
        scope.selectedListLabel = attrs.selectedListLabel;
      }


      //Assigns own enumerable properties of source object(s) to the destination object
      var options = _.extend(aOptions, {
        bootstrap2Compatible: false,
        nonSelectedListLabel: scope.nonSelectedListLabel ,   //false: can be a string specifying the name of the non selected list.
        selectedListLabel: scope.selectedListLabel,          //false: can be a string specifying the name of the selected list.
        preserveSelectionOnMove: 'all',         //false: can be 'all' (for selecting both moved elements and
                                                //the already selected ones in the target list) or 'moved' (for selecting moved elements only)
        moveOnSelect: false ,                   //determines whether to move options upon selection. This option is forced to true on the Android browser.
        selectorMinimalHeight: 400,
        showFilterInputs: true                  //whether to show filter inputs.
      });

      scope.onClickLoadEvent = function () {
        init();
        refresh();
      };

      scope.onClickDestroyEvent = function () {
        destroy();
      };

      var refresh = function() {
        element.bootstrapDualListbox('refresh');
      };

      var init = function() {
        // Init the plugin
        element.bootstrapDualListbox(options);
      };

      scope.onClickLoadEvent();

    }
  }
});

/**
 * Created by Srikanth Reddy on 2/1/2018.
 */
angular.module('Shared.Generic').directive('dualListBox', function($rootScope){
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      //  element.removeAttr('dual-list-box data-dual-list-box');

      //Creates an object composed of the picked object properties


      var aOptions = _.pick(attrs, ['nonSelectedFilter']);

      scope.nonSelectedListLabel = $rootScope.getWord('Nonselected');
      scope.selectedListLabel = $rootScope.getWord('Selected');
      if (attrs.nonSelectedListLabel) {
        attrs.nonSelectedListLabel = attrs.nonSelectedListLabel;
        scope.nonSelectedListLabel = attrs.nonSelectedListLabel;
      }
      if (attrs.selectedListLabel) {
        attrs.nonSelectedListLabel = attrs.selectedListLabel;
        scope.selectedListLabel = attrs.selectedListLabel;
      }



      //Assigns own enumerable properties of source object(s) to the destination object
      var options = _.extend(aOptions, {
        bootstrap2Compatible: false,
        nonSelectedListLabel: scope.nonSelectedListLabel ,   //false: can be a string specifying the name of the non selected list.
        selectedListLabel: scope.selectedListLabel,          //false: can be a string specifying the name of the selected list.
        preserveSelectionOnMove: 'all',         //false: can be 'all' (for selecting both moved elements and
                                                //the already selected ones in the target list) or 'moved' (for selecting moved elements only)
        moveOnSelect: false ,                   //determines whether to move options upon selection. This option is forced to true on the Android browser.
        selectorMinimalHeight: 400,
        showFilterInputs: true                  //whether to show filter inputs.
      });

      scope.listenToModel = function () {
        // When ngModel changes, refresh the list
        // controller.$formatters.push(refresh);
        scope.$watch(attrs.ngModel, function () {
          init();
          refresh();
        });
      };

      var refresh = function() {
        element.bootstrapDualListbox('refresh');
      };

      var init = function() {
        // Init the plugin
        element.bootstrapDualListbox(options);
      };
      scope.listenToModel();

    }
  }
});

/**
 * Created by sreddy on 2/15/2018.
 */

angular.module('Shared.Generic').directive('deleteConfirmationModal', function ($rootScope, notificationMessages, dtEncoder) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/common/generic/partials/delete-confirmation-modal.tpl.html',
    link: function (scope, elements, attributes) {

      scope.confirmText = $rootScope.getWord('Delete');
      scope.cancelText = $rootScope.getWord('Cancel');
      if (attributes.confirmText) {
        scope.confirmText = $rootScope.getWord(attributes.confirmText);
      }
      if (attributes.cancelText) {
        scope.cancelText = $rootScope.getWord(attributes.cancelText);
      }

      scope.deleteConfirmation = function () {
        scope.deleteOnConfirm(scope.deleteId, scope.deleteName, scope.objectType);
      };

      scope.confirmDelete = function (id, itemName, flag, objectType) {
        scope.deleteId = id;
        var versionNumber;
        itemName = itemName ? itemName : '';
        versionNumber = flag ? itemName : '';
        scope.objectType = objectType ? objectType : '';
        scope.deleteName = itemName;
        scope.deleteNotificationTitle = attributes.deleteTitle ? $rootScope.getWord(attributes.deleteTitle) : scope.deleteTitle ? (scope.deleteTitle + ' ' + versionNumber) : notificationMessages.confirmTitle();
        scope.deleteNotificationMessage = attributes.deleteMessage ? $rootScope.getWord(attributes.deleteMessage) : scope.deleteMessage ? scope.deleteMessage : notificationMessages.confirmDeleteMessage() + " " + itemName + "?";
      };
    }
  }
});

/**
 * Created by sreddy on 2/3/2018.
 */

angular.module('Shared.Generic').directive('datePicker', function () {
  return {
    restrict: 'A',
    link: function (scope, tElement, tAttributes) {
      tElement.removeAttr('datePicker');

      var options = {
        clearBtn: true,
        orientation: "bottom auto",
        autoclose: true,
        todayHighlight: true
      };
      tElement.datepicker(options);
    }
  }
});

/**
 * Created by $ingh on 4/15/2017.
 * Path: src/app/_common/layout/directives/customSpinner.js
 * Notes: Directive for using the spin.js plugin
 */
angular.module('Shared.Generic').directive('customSpinner', function ($rootScope) {

			return {

				restrict: 'EA',
				// replace: true,

				link: function (scope, element, attributes) {

					var opts = {
						lines       : 13,           // The number of lines to draw
						length      : 28,           // The length of each line
						width       : 13,           // The line thickness
						radius      : 40,           // The radius of the inner circle
						scale       : 1,            // Scales overall size of the spinner
						corners     : 0.5,          // Corner roundness (0..1)
						color       : '#000',       // #rgb or #rrggbb or array of colors
						opacity     : 0.25,         // Opacity of the lines
						rotate      : 0,            // The rotation offset
						direction   : 1,            // 1: clockwise, -1: counterclockwise
						speed       : 1,            // Rounds per second
						trail       : 60,           // Afterglow percentage
						fps         : 20,           // Frames per second when using setTimeout() as a fallback for CSS
						zIndex      : 2000000000,   // The z-index (defaults to 2000000000)
						className   : 'spinner',    // The CSS class to assign to the spinner
						top         : '43%',        // Top position relative to parent
						left        : '50%',        // Left position relative to parent
						shadow      : false,        // Whether to render a shadow
						hwaccel     : false,        // Whether to use hardware acceleration
						position    : 'absolute'    // Element positioning
					};

					var spinner = new Spinner(opts).spin();

					$rootScope.startSpinner = function () {

						angular.element('#pageOverlay').removeClass("hidden");

						_.forEach(element[0].attributes, function (n, key) {
							if (opts[n.name]) {
								opts[n.name] = n.value;
							}
						});

						element[0].appendChild(spinner.el)
					};

					$rootScope.stopSpinner = function () {
						spinner.spin(false);
            angular.element('#pageOverlay').addClass("hidden");
					};
				}

			}

		});


/**
 * Created by $ingh on 5/11/2018.
 * Directive created to bind the enum numbers with regular drop-downs
 * Just inject this directive on select and it will work autoMagically
 */

angular.module('Shared.Generic').directive('convertToNumber', function () {
  return {
    restrict: 'EA',
    replace: true,
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {

      ngModel.$parsers.push(function(val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function (val) {
        return '' + val;
      });
    }
  }
});


/**
 * Created by sreddy on 4/13/2018.
 */

angular.module('Shared.Generic').directive('cancelConfirmationModal', function ($rootScope, notificationMessages) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/common/generic/partials/cancel-confirmation-modal.tpl.html',
    link: function (scope, elements, attributes) {

      scope.confirmCancelText = $rootScope.getWord('ConfirmCancel');
      scope.closeText = $rootScope.getWord('KeepEditing');
      if (attributes.confirmCancelText) {
        scope.confirmCancelText = $rootScope.getWord(attributes.confirmCancelText);
      }
      if (attributes.closeText) {
        scope.closeText = $rootScope.getWord(attributes.closeText);
      }

      scope.cancelConfirmation = function () {
        scope.cancelOnConfirm(scope.cancelId);
      };

      scope.confirmCancel = function (id) {
        scope.cancelId = id;
        scope.cancelNotificationTitle = notificationMessages.confirmCancelTitle();
        scope.cancelNotificationMessage = notificationMessages.confirmCancelMessage();
      };
    }
  }
});

/**
 * Created by Pragya Goel on 3/23/2017.
 */

'use strict';

angular.module('Shared.Generic').service('autoPopulateService', function () {

    var completeAddress = {
        country: '',
        state: '',
        stateLong: '',
        city: '',
        postalCode: '',
        street1: ''
    };

    return {
        setFields: function (results) {
            if(!results[0]){
                return false;
            }

            var locationAdr = results[0].address_components;
            var postalCode = "";
            var street1 = "";
            if (locationAdr) {
                var removeFromAddress = ['administrative_area_level_2', 'administrative_area_level_3', 'neighborhood', 'postal_town'];
                for (var i = 0; i < locationAdr.length; i++) {

                    switch (locationAdr[i].types[0]) {
                        case 'country':
                            completeAddress.country = locationAdr[i].short_name;
                            if (completeAddress.country != 'US') {
                                completeAddress.state = completeAddress.stateLong;
                            }
                            break;
                        case 'administrative_area_level_1':
                            completeAddress.state = locationAdr[i].short_name;
                            completeAddress.stateLong = locationAdr[i].long_name;
                            break;
                        case 'locality':
                            completeAddress.city = locationAdr[i].short_name;
                            break;
                        case 'postal_code_prefix':
                        case 'postal_code':
                            postalCode = postalCode + locationAdr[i].short_name;
                            break;
                        case 'postal_code_suffix':
                            postalCode = postalCode + '-' + locationAdr[i].short_name;
                            break;
                        default:
                            if (removeFromAddress.indexOf(locationAdr[i].types[0]) == -1) {
                                street1 = street1 + locationAdr[i].short_name + ' ';
                            }

                            //Following logic is for the case where there is only neighborhood and nothing else
                            if ((locationAdr[i].types[0]) == 'neighborhood' && street1 == '') {
                                street1 = street1 + locationAdr[i].short_name + ' ';
                            }
                            //Added this for addresses with neighborhood and no locality
                            // example: 37-1 31st St Queens, Long Island City, NY 11101
                            if ((locationAdr[i].types[0]) == 'neighborhood' && completeAddress.city == '') {
                                completeAddress.city = locationAdr[i].long_name;
                            }
                            break;
                    }
                }
                completeAddress.postalCode = postalCode;
                completeAddress.street1 = street1;
            }
        },
        getAddress: function () {
            return completeAddress;
        }
    }
});

/**
 * Created by $ingh on 2/7/2018.
 */
angular.module('Shared.Generic').directive('addressRecommendation', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/common/generic/partials/addressRecommendation.tpl.html',
    link: function (scope, element, attributes) {
      // Look for a simple way of doing this with just single value
      scope.showRecommendedAddress = function () {
        scope.showRecommended = true;
        scope.keepOriginal = false;
      };

      scope.showKeepOriginalAddress = function () {
        scope.showRecommended = false;
        scope.keepOriginal = true;
      };
    }
  }
});

/**
 * Created by hpanchal on 4/20/2017.
 */
angular.module('Shared.Generic').directive('addressErrorBadge', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/common/generic/partials/address-error-badge.tpl.html',
        link: function (scope, element, attributes) {}
    }
});

/**
 * Created by $ingh on 11/1/2017.
 * Path: src/app/common/generic/directives/aDisabled.js
 */
angular.module('Shared.Generic').directive('aDisabled', function () {

    return {
        compile: function (tElement, tAttrs) {

            //Use either attribute.
            var disableAttr = tAttrs["ngDisabled"] || tAttrs["aDisabled"];

            //Disable ngClick
            tAttrs["ngClick"] = "!(" + disableAttr + ") && (" + tAttrs["ngClick"] + ")";

            //Toggle "disabled" to class when aDisabled becomes true
            return function (scope, iElement, iAttrs) {
                scope.$watch(iAttrs["aDisabled"], function (newValue) {
                    if (newValue !== undefined) {
                        iElement.toggleClass("disabled", newValue);
                    }
                });

                //Disable href on click
                iElement.on("click", function (e) {
                    if (scope.$eval(iAttrs["aDisabled"])) {
                        e.preventDefault();
                    }
                });

            };
        }
    }
});

(function(){
  "use strict";

  angular.module('Shared.Forms', []);
})();

/**
 * Created by Srikanth on 1/12/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\forms\directives\tableActions.js
 */
"use strict";

angular.module('Shared.Forms').directive('misRowActions', function (dtEncoder) {
  return {
    restrict: 'A',
    replace: true,
    link: function (scope) {

      scope.tableActions = function (objectId, objectName, readOnly, commandTypes, objectType) {

        var stringifyIdVar = "'" + objectId + "'";
        var stringNameVar = "'" + he.encode(dtEncoder.escapeQuotes(objectName)) + "'";


        scope.stringifyIdVar = stringifyIdVar;
        scope.stringNameVar = stringNameVar;

        var actionItems = '';
        var buttonColor = "btn-success";

        var viewButton = '<a href-void tooltip-placement="bottom" data-tooltip-container="body" uib-tooltip="{{getWord(\'View\')}}"  class="btn ' + buttonColor + '" ng-click="viewItem(' + stringifyIdVar + ')" ><i class="fa fa-search fa-lg"></i></a>';
        var editButton = '<a href-void tooltip-placement="bottom" data-tooltip-container="body" uib-tooltip="{{getWord(\'Edit\')}}" class="btn ' + buttonColor + '" ng-click="editItem(' + stringifyIdVar + ')" ><i class="fa fa-pencil-square-o fa-lg"></i></a>';
        var deleteButton = '<a href-void tooltip-placement="bottom" data-tooltip-container="body" uib-tooltip="{{getWord(\'Delete\')}}" class="btn ' + buttonColor + '" ng-click="deleteItem(' + stringifyIdVar + ',' + stringNameVar + ')" data-toggle="modal" data-target="#deleteModal" ><i class="fa fa-trash-o fa-lg"></i></a>';
        var duplicateButton = '<a href-void tooltip-placement="bottom" uib-tooltip="{{getWord(\'Duplicate\')}}" class="btn ' + buttonColor + '" ng-click="duplicateItem(' + stringifyIdVar + ')" ><i class="fa fa-clone fa-lg"></i></a>';
        var passwordButton = '<a href-void tooltip-placement="bottom" data-tooltip-container="body" uib-tooltip="{{getWord(\'Password\')}}" class="btn ' + buttonColor + '" ng-click="updatePassword(' + stringifyIdVar + ')" ><i class="fa fa-key fa-lg"></i></a>';

        if (commandTypes) {
          _.forEach(commandTypes, function (item) {
            switch (item) {
              case 1:
                if (readOnly) {
                  actionItems += viewButton;

                }
                break;
              case 2:
                if (!readOnly) {
                  actionItems += editButton;

                }
                break;
              case 3:
                if (!readOnly) {

                  actionItems += deleteButton;

                }
                break;
              case 4:
                if (!readOnly) {
                  actionItems += passwordButton;

                }
                break;
            }
          });
        }
        else if (objectType) {

          switch (objectType.type) {
            case 'Imposition':
              if (readOnly)
                actionItems += viewButton;
              else {
                actionItems += editButton;
                actionItems += duplicateButton;
                actionItems += deleteButton;
              }
              break;
          }

        }
        else {
          if (readOnly) {
            actionItems += viewButton;

          }
          else {
            actionItems += editButton;
            actionItems += deleteButton;

          }
        }

        return '<div class="btn-group btn-group-sm" role="group">' + actionItems + '</div>'

      };

      scope.setObjectLevel = function (level) {

        switch (level) {
          case 1:
            return '<i tooltip-placement="bottom" uib-tooltip="{{getWord(\'Global\')}}" class="fa fa-globe fa-2x object-level"></i>';
          case 2:
            return '<i tooltip-placement="bottom" uib-tooltip="{{user.curFacilityGrpName}}" class="fa fa-group fa-2x object-level"></i>';
          default:
            return '';
        }
      };

      scope.setObjectLevelAllLabels = function (level) {

        switch (level) {
          case 1:
            return '<i tooltip-placement="bottom" uib-tooltip="{{getWord(\'Global\')}}" class="fa fa-globe fa-2x object-level"></i>';
          case 2:
            return '<i tooltip-placement="bottom" uib-tooltip="{{user.curFacilityGrpName}}" class="fa fa-group fa-2x object-level"></i>';
          case 3:
            return '<i tooltip-placement="bottom" uib-tooltip="{{user.curFacilityName}}" class="fa fa-building fa-2x object-level"></i>';
          default:
            return '';
        }
      };

      //// TODO: PB: Needs to be reworked to not use html to compare
      scope.isAccessible = function (data, html) {

        var editHtml = '<a title="{{getWord(Edit)}} + data.jobNumber" style="color: silver;" class="fa fa-search fa-2x"></a>';

        if (scope.object == 'OrdersArchive')
          return editHtml;

        return html;
      };

      scope.showCheckBox = function (data, command) {

        var html = '';
        var customSysAttributes = "";
        var customDisAttributes = "";
        var stringifyIdVar = "'" + data.id + "'";
        var stringNameVar = "'" + he.encode(dtEncoder.escapeQuotes(data.name)) + "'";
        var checked = '';

        if (!data.name) {
          stringNameVar = "'" + data.login + "'";
        }

        switch (command) {
          case 'isSystemUsers':
            customDisAttributes = 'id="dis_' + data.id + '" name="chkDis_' + data.id + '" ng-click="enableDisableItem(' + stringifyIdVar + ', ' + stringNameVar + ', ' + data.isDisabled + ')"';
            customSysAttributes = 'id="sys_' + data.id + '" name="chkSys_' + data.id + '" ng-click="invokeRevokeSystemAdminRights(' + stringifyIdVar + ', ' + stringNameVar + ', ' + data.isSystemAdmin + ')"';
            if (data.hasOwnProperty('isSystemAdmin')) { checked = data['isSystemAdmin'] ? 'checked' : ''; }
            html = '<label class="checkbox-wrap"><input class="checkBoxLabel" type="checkbox" ' + customSysAttributes + ' ' + checked + '><i></i><span class="checkbox-mark"></span>' + 'System Admin' + '</label>';
            if (data.hasOwnProperty('isDisabled')) { checked = data['isDisabled'] ? 'checked' : ''; }
            html += '<label class="checkbox-wrap"><input class="checkBoxLabel" type="checkbox" ' + customDisAttributes + ' ' + checked + '><i></i><span class="checkbox-mark"></span>' + 'Disabled' + '</label>';
            break;
          case "isConnected":
            if (data.isConnected) {
              checked = 'checked';
            }
            html = '<label class="checkbox-wrap"><input disabled class="checkBoxLabel" type="checkbox" ' + checked + '><i></i><span class="checkbox-mark"></span></label>';
            break;
        }

        return html;
      };
    }
  }
});




/**
 * Created by $ingh on 10/9/2017.
 * Path : src/app/common/forms/partials/form-actions.tpl.html
 */

"use strict";

angular.module('Shared.Forms').directive('formActions', function ($rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/common/forms/partials/form-actions.tpl.html',
    link: function (scope, elements, attributes) {

      scope.createText = $rootScope.getWord('Create');
      scope.createAnotherText = $rootScope.getWord('CreateAndAddAnother');
      scope.saveChangesText = $rootScope.getWord('SaveChanges');
      if (attributes.createText) {
        scope.createText = $rootScope.getWord(attributes.createText);
      }

      if (attributes.readOnly)
        scope.activeView = true;

      if (attributes.showcheck)
        attributes.vshowCheck = attributes.showcheck;

      if (attributes.createAnotherText) {
        scope.createAnotherText = $rootScope.getWord(attributes.createAnotherText);
      }
      if (attributes.saveChangesText) {
        scope.saveChangesText = $rootScope.getWord(attributes.saveChangesText);
      }

      scope.showCheck = attributes.vshowCheck;

      scope.showArrow = attributes.showarrow;

      angular.element('#submitAnother').on('click', function () {
        angular.element(this).submit();
      });

      var form = angular.element(elements[0]).closest("form").attr('id');

      angular.element('#' + form).on('submit', function () {
        angular.element('#createBtn').attr('disabled', 'disabled');
        angular.element('#btn2').attr('disabled', 'disabled');
        angular.element('#saveBtn').attr('disabled', 'disabled');
      });
    }
  }
});

(function(){
  "use strict";

  angular.module('Shared.Datatables', []);
})();

/**
 * Created by $ingh on 10/9/2017.
 * Path: src/app/common/datatables/services/dtEncoderFactory.js
 */

    angular.module('Shared.Datatables').service('dtEncoder', function ($log) {
        return {
            /*
                Encode all the string fields for DataTables.
                PropertyNames should only reference fields that contain string values.

                var propertyNames = [
                    'name',
                    'type',
                    'region',
                    'externalCode'
                ];
            */
            dtEncodeValues : function(data, propertyNames){

                if(data && data.length > 0) {
                    for (var pNames = 0; pNames < propertyNames.length; pNames++) {
                        for (var arrayIdx = 0; arrayIdx < data.length; arrayIdx++) {
                            try {
                                data[arrayIdx][propertyNames[pNames]] = (data[arrayIdx][propertyNames[pNames]]) ?
                                    he.encode(data[arrayIdx][propertyNames[pNames]]) :
                                    data[arrayIdx][propertyNames[pNames]];
                            } catch (e) {
                              $log.log(e);
                              $log.log('Please ensure that indexes reference Only string values.');
                            }
                        }
                    }
                }
                return data;
            },
            escapeQuotes : function(stringData){

                var newString = '';
                var stringLength = (stringData) ? stringData.length : 0;

                if(stringData){
                    if (((stringData[0] == '"') || (stringData[0] == "'"))) {
                        newString += "";
                    }

                    for (var i = 0; i < stringData.length; i++) {

                        if ((stringData[i] == '"') || (stringData[i] == "'")) {
                            newString += "\\";
                        }
                        newString += stringData[i];
                    }

                    if ((stringData[stringLength - 1] == '"') || (stringData[stringLength - 1] == "'"))
                        newString += "";

                }else
                    newString = '</>';

                    return newString;
            }

        };

    });

/**
 * Created by Pragya Goel on 1/27/2017.
 * Path: app/_common/layout/directives/widgetDataToolbar.js
 */
"use strict";

angular.module('Shared.Datatables').directive('widgetDataToolbar', function ($rootScope) {
    return {

        restrict: 'E',
        replace: true,
        templateUrl: 'app/common/datatables/partials/widget-data-toolbar.tpl.html',

        link: function (scope, elements, attributes) {

            if (attributes.label)
                attributes.buttonLabel = attributes.label;

            // scope.label = $rootScope.getWord(attributes.buttonLabel);
            scope.label = attributes.buttonLabel;
        }
    }
});

/**
 * Created by Pancham Bhagwat on 03/09/2017.
 * Path: app/_common/layout/directives/tableDropdownActions.js
 */

"use strict";

angular.module('Shared.Datatables').directive('tableDropdownActions', function (dtEncoder, $rootScope) {
  return {
    restrict: 'A',
    replace: true,
    link: function (scope) {

      scope.tableDropdownActions = function (objectId, objectName, readOnly, commandTypes, labels, btnName, itemType) {

        var stringifyIdVar = "'" + objectId + "'";
        var stringNameVar = isNaN(objectName) ? "'" + he.encode(dtEncoder.escapeQuotes(objectName)) + "'" : objectName;
        stringNameVar = stringNameVar ? stringNameVar : null;
        var actionName = "'" + btnName + "'";
        scope.stringifyIdVar = stringifyIdVar;
        scope.stringNameVar = stringNameVar;
        var objectType = "'" + itemType + "'";
        var passwordButtonText = $rootScope.getWord('ChangePassword');
        var actionItems = '';
        btnName = $rootScope.getWord(btnName);

        var viewHtml = '<li><a href-void ng-click="viewItem(' + stringifyIdVar + ')" ><b>' + labels.viewLabel + '</b></a></li>';
        var editHtml = '<li><a href-void ng-click="editItem(' + stringifyIdVar + ')"><b>' + labels.editLabel + '</b></a></li>';
        var deleteHtml = '<li><a ng-click="deleteItem(' + stringifyIdVar + ',' + stringNameVar + ',' + stringNameVar + ',' + objectType + ')" data-toggle="modal" data-target="#deleteModal"><b>' + labels.deleteLabel + '</b></a></li>';
        var deleteCustomerHtml = '<li ng-show="user.isSysAdmin"><a ng-click="deleteItem(' + stringifyIdVar + ',' + stringNameVar + ')" data-toggle="modal" data-target="#deleteModal">Delete</a></li>';
        var passwordButton = '<li><a href-void ng-click="updatePassword(' + stringifyIdVar + ')" ><b>' + passwordButtonText + '</b></a></li>';


        var reQuote = '<li><a href-void ng-click="reQuote(' + stringifyIdVar + ')"><b>' + labels.reQuoteLabel + '</b></a></li>';
        var convertQuote = '<li><a href-void ng-click="convertQuoteAction(' + stringifyIdVar + ')"><b>' + labels.convertQuoteLabel + '</b></a></li>';
        var btnId = "btn" + objectId;
        var costedSummaryReport = '<li><a href-void ng-click="downloadCostedSummaryReport(' + stringifyIdVar + ')"><b>' + labels.costedSummaryReportLabel + '</b></a></li>';
        var costedDetailedReport = '<li><a href-void ng-click="downloadCostedDetailedReport(' + stringifyIdVar + ')"><b>' + labels.costedDetailedReportLabel + '</b></a></li>';
        var convertedSummaryReport = '<li><a href-void ng-click="downloadConvertedSummaryReport(' + stringifyIdVar + ')"><b>' + labels.convertedSummaryReportLabel + '</b></a></li>';
        var convertedDetailedReport = '<li><a href-void ng-click="downloadConvertedDetailedReport(' + stringifyIdVar + ')"><b>' + labels.convertedDetailedReportLabel + '</b></a></li>';

        if (commandTypes) {
          _.forEach(commandTypes, function (item) {
            switch (item) {
              case 1:
                // Do not add view becuase view becomes the default option for users that cannot create shipments
                actionItems += viewHtml;
                break;
              case 2:
                actionItems += editHtml;
                break;
              case 3:
                if (!readOnly) {
                  actionItems += deleteHtml;
                }
                break;
              case 4:
                if (!readOnly) {
                  actionItems += deleteCustomerHtml;
                }
                break;
              case 5:
                if (!readOnly) {
                  actionItems += passwordButton;
                }
                break;
              case 6:
                if (!readOnly) {
                  actionItems += reQuote;
                }
                break;
              case 7:
                if (!readOnly) {
                  actionItems += convertQuote;
                }
                break;
              case 8:
                if (!readOnly) {
                  actionItems += costedSummaryReport;
                  actionItems += costedDetailedReport;
                }
                break;
              case 9:
                if (!readOnly) {
                  actionItems += costedSummaryReport;
                  actionItems += costedDetailedReport;
                  actionItems += convertedSummaryReport;
                  actionItems += convertedDetailedReport;
                }
                break;
              case 10:
                if (!readOnly) {
                  actionItems += convertedSummaryReport;
                }
                break;
            }
          });
        }
        else {
          if (readOnly) {
            actionItems += viewHtml;
          }
          else {
            actionItems += editHtml;
            actionItems += deleteHtml;
          }
        }

        var buttonContainer = '<button id="primaryButton" tabindex="-1" class="btn btn-white leftBorderRadius" ng-class="{\'rightBorderRadius\': ' + !actionItems + '}" ng-click="defaultButtonAction(' + stringifyIdVar + ',' + stringNameVar + ',' + actionName + ')"  type="button"><b>' + btnName + '</b></button>';
        if (actionItems) {
          buttonContainer += ' <button id="toggleAction" class="btn btn-white rightBorderRadius" uib-dropdown-toggle type="button"><span class="caret"></span></button>' +
            '<ul id="secondaryButton" uib-dropdown-menu >' + actionItems + '</ul>';
        }
        return "<div id=\"dropDownContainer\" class=\"input-group m-b \"><div class=\"input-group-btn\" uib-dropdown>" + buttonContainer + "</div></div>";
      };

      var previousOpenId = "";
      scope.openClose = function (id) {
        if (previousOpenId != id) {
          closePreviousOpenItems(previousOpenId);
        }

        var divElement = angular.element("#btn" + id).closest("div");
        if (divElement.hasClass("open")) {
          divElement.removeClass("open");
        } else {
          divElement.addClass("open");
        }

        previousOpenId = id;
      };

      // Close any previous open drop downs.
      var closePreviousOpenItems = function (previousOpenId) {
        var divElement = angular.element("#btn" + previousOpenId).closest("div");
        divElement.removeClass("open");
      }
    }
  }
});

/**
 * Created by $ingh on 10/11/2017.
 * Path: src/app/common/datatables/directives/responsive-angular-datatable.js
 */
"use strict";

angular.module('Shared.Datatables').directive('responsiveAngularDatatable', function ($compile) {
  return {

    restrict: 'A',
    replace: false,

    link: function (scope, element, attributes) {
      var options = {
        "fnCreatedRow" : function (nRow) {
          $compile(angular.element(nRow))(scope);
        },
        "fnInitComplete": function (oSettings, json) {

          // alert( 'DataTables has finished its initialisation.' );
        },
        "autoWidth": false,
        "smartResponsiveHelper": null,
        "procesing" : true,
        "fnPreDrawCallback": function () {
          //Initialize the responsive datatables helper once.
          if (!this.smartResponsiveHelper) {
            this.smartResponsiveHelper = new ResponsiveDatatablesHelper(element, {
              tablet: 1024,
              phone: 480
            });
          }
        },
        "fnRowCallback": function (nRow, data) {
          this.smartResponsiveHelper.createExpandIcon(nRow);
        },

        "fnDrawCallback": function (oSettings) {
          this.smartResponsiveHelper.respond();
        }
      };
      scope.dtOptions = angular.extend(scope.dtOptions,options)
    }
  }
});

/**
 * Created by $ingh on 12/15/2017.
 * Path: src/app/common/datatables/directives/pageDropdownLength.js
 */
"use strict";

angular.module('Shared.Datatables').directive('pageDropdownLength', function () {
    return {

        restrict: 'E',
        replace: true,
        templateUrl: 'app/common/datatables/partials/page-dropdown-length.tpl.html',
        link: function (scope, elements, attributes) {
        }
    }
});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('Shared.Datatables').directive('iboxTools', function($timeout) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'app/common/datatables/partials/ibox_tools.html',
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest('div.ibox');
        var icon = $element.find('i:first');
        var content = ibox.children('.ibox-content');
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        $timeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest('div.ibox');
        ibox.remove();
      }
    }
  };
});

/**
 * Created by $ingh on 11/2/2017.
 * Path: src/app/common/datatables/directives/datatableServerSide.js
 */

"use strict";

angular.module('Shared.Datatables').directive('datatableServerSide', function ($compile, $rootScope, $cookieStore) {

    var noResultsMessage = "<strong>" + $rootScope.getWord('NoResultsFound') + "</strong>";

    //Get Cookie for use with DataTable Internationalisation plug-in.
    //See options.oLanguage below where returned variable is used.
    if ($cookieStore.get('_locale') != null) {
        var locale = "plugin/datatables-plugins/i18n/" + $cookieStore.get('_locale') + ".json";
    }

    return {
        restrict: 'A',
        scope: {
            tableOptions: '='
        },

        link: function (scope, element, attributes) {
            /* // DOM Position key index //

             l - Length changing (dropdown)
             f - Filtering input (search)
             t - The Table! (datatable)
             i - Information (records)
             p - Pagination (paging)
             r - Processing
             < and > - div elements
             <"#id" and > - div with an id
             <"class" and > - div with a class
             <"#id.class" and > - div with an id and class

             Also see: http://legacy.datatables.net/usage/features
             */

            var options = {
                autoWidth: false,
                serverSide: true,
                stateSave: true,
                filter: false,

                "smartResponsiveHelper": null,
                "sDom":
                't' +
                '<"dt-toolbar-footer"<"col-sm-6 col-xs-12 hidden-xs"i><"col-xs-12 col-sm-6"p>>',

                "fnInitComplete": function (oSettings, json) {
                    //alert( 'DataTables has finished its initialisation.' );
                },

                oLanguage: {
                    "sSearch": "<span class='input-group-addon input-sm'><i class='glyphicon glyphicon-search'></i></span>",
                    "sLengthMenu": "_MENU_",
                    "sEmptyTable": noResultsMessage,
                    "sUrl": locale,
                    "oPaginate": {
                        "sFirst": "<strong><<</strong>",
                        "sLast": "<strong>>></strong>",
                        "sPrevious": "<strong><</strong>",
                        "sNext": "<strong>></strong>"
                    }
                },
                "pagingType": "full_numbers",

                "fnHeaderCallback": function (nHead) {

                    var searchedHtml = '';
                    $compile(angular.element(nHead))(scope.$parent);

                    // if ($('#filteredContainer')[0]) {
                    //     $('#filteredContainer')[0].innerHTML = '';
                    // }

                    if (scope.$parent.searchPerformed) {
                        searchedHtml += '<div><strong class="k k-top-left">' + $rootScope.getWord('Searchedby') + ': </strong><span>' + unescape(scope.$parent.searchPerformed) + '</span></div>';
                    }

                    // $('#filteredContainer').prepend($compile(searchedHtml)(scope.$parent));

                    // if ($('#dtCustomers')[0]) {
                    //     if(!$('#smart-search')[0]) {
                    //         $("#fooBar").append($compile(search)(scope.$parent));
                    //     }
                    // }
                },

                "fnPreDrawCallback": function () {
                    // Initialize the responsive datatables helper once.
                    if (!this.smartResponsiveHelper) {
                        this.smartResponsiveHelper = new ResponsiveDatatablesHelper(element, {
                            tablet: 1024,
                            phone: 480
                        });
                    }
                },

                "fnRowCallback": function (nRow) {
                    this.smartResponsiveHelper.createExpandIcon(nRow);
                },

                'stateSaveParams': function (oSettings, oData) {
                    //// Save the filter parameters to local storage
                    scope.saveFilterParamsToLocalStorage(oSettings, oData);
                },

                'stateLoadParams': function () {
                    var data = localStorage.getItem('DataTables_' + scope.$parent.object + window.location.pathname);
                    var stateObj = JSON.parse(data);
                    if (stateObj){
                        scope.$parent.pageLength = stateObj.length;
                        scope.$parent.dataTablePageLength = scope.$parent.pageLength.toString();
                    }
                    return stateObj;
                },

                "fnDrawCallback": function (oSettings) {
                    this.smartResponsiveHelper.respond();
                },

                "footerCallback": function (row, data, start, end, display) {
                    var createDivId = "#" + attributes.id + "_info";
                    var footerSection = angular.element(createDivId);
                    //footerSection[0].outerText;
                    setTimeout(function () {

                        //This is only a quick fix to release 8/19/2015
                        var getText = footerSection[0]?footerSection[0].textContent:'';
                        var shortenText = getText.split('(');
                        if(getText)
                        footerSection[0].textContent = shortenText[0];

                    }, 1);

                },

                "fnServerData": function (sSource, aoData, fnCallback, oSettings) {

                    oSettings._iDisplayLength = scope.$parent.pageLength;

                    /*#################################################################################################
                     Support for saving state of the user from edit view to list view
                     #################################################################################################*/
                    if (scope.$parent.searchedObj && scope.$parent.searchedObj.length > 0) {
                        //$('#filterCollapse').addClass('in');
                        for (var j = 0; j < scope.$parent.searchedObj.length; j++) {
                            switch (scope.$parent.searchedObj[j].name) {
                                case 'FilterCols':
                                    scope.$parent.searchBy = scope.$parent.searchedObj[j].value;
                                    break;
                                case 'Filter':
                                    scope.$parent.searchText = unescape(scope.$parent.searchedObj[j].value);
                                    break;
                                case 'SearchApplied':
                                    scope.$parent.searchApplied = scope.$parent.searchedObj[j].value;
                                    break;
                            }
                        }
                    }

                    scope.$parent.searchedObj = null;
                    localStorage.setItem('DataTables_Filtered_' + scope.$parent.object + window.location.pathname, scope.$parent.searchedObj);

                    ///#################################################################################################

                    var sortedColumn = {};
                    for (var i = 0; i < aoData.length; i++) {
                        if (aoData[i].name == 'order')
                            sortedColumn = aoData[i].value[0];
                    }

                    aoData = []; //Clear out all extra DataTables Parameters.
                    aoData.push({ "name": "OrderBy", "value": scope.$parent.tableColumns[sortedColumn.column] });


                    if (sortedColumn.dir == 'asc')
                        aoData.push({ "name": "Descending", "value": "false" });
                    else
                        aoData.push({ "name": "Descending", "value": "true" });

                    aoData.push({
                        "name": "PageSize",
                        "value": oSettings._iDisplayLength
                    });

                    /*###############################################################################################
                     For displaying the correct page number
                     #################################################################################################*/
                    var pgIndex = Math.round(oSettings._iDisplayStart / oSettings._iDisplayLength);
                    scope.$parent.pageNum = pgIndex;
                    if (scope.$parent.pageLength == oSettings._iDisplayLength) {
                        pgIndex += 1;
                    }
                    else {
                        var pages = Math.ceil(oSettings._iRecordsDisplay / oSettings._iDisplayLength);
                        if (oSettings._iDisplayLength < oSettings._iDisplayStart) {
                            for (var i = 1; i <= pages; i++) {
                                if (((i * oSettings._iDisplayLength) <= oSettings._iDisplayStart) &&
                                    (((i + 1) * oSettings._iDisplayLength) > oSettings._iDisplayStart)) {
                                    oSettings._iDisplayStart = (i * oSettings._iDisplayLength);
                                    break;
                                }
                            }
                        }
                    }

                    aoData.push({
                        "name": "PageIndex",
                        "value": pgIndex
                    });

                    scope.$parent.pageLength = oSettings._iDisplayLength;

                    scope.$parent.searchPerformed = "";
                    if (scope.$parent.searchApplied) {
                        aoData.push({ "name": "FilterColumn", "value": scope.$parent.searchBy.backendName });
                        if (scope.$parent.searchText && scope.$parent.searchText.length > 0) {
                            aoData.push({
                                "name": "FilterValue",
                                "value": unescape(scope.$parent.searchText)
                            });
                            // aoData.push({"name": "Filter", "value": unescape(scope.$parent.searchText)});
                            scope.$parent.searchPerformed = unescape(scope.$parent.searchText);
                        }
                    }

                    //// This export url is used to export
                    scope.$parent.exportUrl = appConfig.apiURL + "/api/" + scope.$parent.object + "?";
                    for (var j = 0; j < aoData.length; j++) {

                        if (j != 0)
                            scope.$parent.exportUrl += '&';

                        if (aoData[j].name == 'PageSize') {
                            scope.$parent.exportUrl += aoData[j].name + "=100000";
                        }
                        else {
                            scope.$parent.exportUrl += aoData[j].name + "=" + aoData[j].value;
                        }
                    }
                    if (scope.$parent.searchText) {
                        oSettings.jqXHR = $.ajax({
                            "type": "GET",
                            "cache": false,
                            "url": appConfig.apiURL + "/api/" + scope.$parent.object + '/Filter',
                            "data": aoData,
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('Content-Type', 'application/json'),
                                    xhr.setRequestHeader('Authorization', 'Bearer ' + $cookieStore.get('_Token'))
                            },
                            success: function (json) {
                                if (scope.$parent.searchText) {
                                    json.iTotalRecords = json.pagedData.records;
                                    json.iTotalDisplayRecords = json.pagedData.total;
                                    oSettings.json = json;
                                    // scope.$parent.stopSpinner();
                                    // $rootScope.stopSpinner();
                                    scope.$parent[scope.$parent.object] = json.data;
                                }
                                if (scope.$parent.previousSelectedJobs) {
                                    scope.$parent.previousSelectedJobs(json.data);
                                }
                                fnCallback(json);
                            },
                            error: function () {
                                // scope.$parent.stopSpinner();
                                // $rootScope.stopSpinner();
                            }
                        });
                    }
                    else {
                        var tableData = scope.resetTableData();
                        fnCallback(tableData);
                    }
                }
            };

            if (attributes.tableOptions) {
                options = angular.extend(options, scope.tableOptions)
            }
            var _dataTable = element.DataTable(options);
        },

        controller: function ($scope) {

            $scope.resetTableData = function () {
                var json = {};
              json.iTotalRecords = 0;
                json.iTotalDisplayRecords = 0;
                json.data = [];
                return json
            };

            //// Save filter and search params to local storage
            $scope.saveFilterParamsToLocalStorage = function (oSettings, oData) {
                localStorage.setItem('DataTables_' + $scope.$parent.object + window.location.pathname, JSON.stringify(oData));

                var saveSearchedObj = [];

                if ($scope.$parent.searchApplied) {
                    saveSearchedObj.push({ "name": "SearchApplied", "value": $scope.$parent.searchApplied });
                    if ($scope.$parent.searchText && $scope.$parent.searchText.length > 0) {
                        saveSearchedObj.push({ "name": "FilterCols", "value": $scope.$parent.searchBy });
                        $scope.$parent.searchText = unescape($scope.$parent.searchText);
                        saveSearchedObj.push({ "name": "Filter", "value": escape($scope.$parent.searchText) });
                        $scope.$parent.searchText = unescape($scope.$parent.searchText);
                    }
                }

                localStorage.setItem('DataTables_Filtered_' + $scope.$parent.object + window.location.pathname, JSON.stringify(saveSearchedObj));
            };
        }
    };
});

'use strict';

angular.module('Shared.Datatables').directive('datatableBasic', function ($compile) {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      tableOptions: '='
    },
    link: function (scope, element, attributes) {
      /* // DOM Position key index //

             l - Length changing (dropdown)
             f - Filtering input (search)
             t - The Table! (datatable)
             i - Information (records)
             p - Pagination (paging)
             r - Processing
             < and > - div elements
             <"#id" and > - div with an id
             <"class" and > - div with a class
             <"#id.class" and > - div with an id and class

             Also see: http://legacy.datatables.net/usage/features
             */

      var locale = '';
      var options = {
        "sDom": '<"dt-toolbar"<"col-xs-12 col-sm-12 col-md-6 col-lg-6 basicDatatableSearch no-padding"f><"col-sm-12 col-xs-12 col-md-4 col-lg-5 datatableBtn no-padding"B><"col-sm-12 col-xs-12 col-md-2 col-lg-1 hidden-xs"l>r>' +
        't' +
        '<"dt-toolbar-footer"<"col-sm-6 col-xs-12 hidden-xs"i><"col-xs-12 col-sm-6"p>>',
        "oTableTools": {
          "sSwfPath": "/plugins/datatables-tabletools/swf/copy_csv_xls_pdf.swf"
        },
        oLanguage: {
          "sSearch": "", //<span class='custom-input'><i class='fa fa-search'></i></span>
          "sSearchPlaceholder" : "Search",
          "sLengthMenu": "_MENU_",
          "sEmptyTable": "No Results Found",
          "sUrl": locale,
          "oPaginate": {
            "sFirst": false,
            "sLast": false,
            "sPrevious": "<strong>Previous</strong>",
            "sNext": "<strong>Next</strong>"
          }
        },
        "autoWidth": false,
        "smartResponsiveHelper": null,
        "pagingType": "full_numbers",
        "order": [[0, "asc"]],
        "fnHeaderCallback": function (nHead) {
          $compile(angular.element(nHead))(scope.$parent);
        },

        "preDrawCallback": function () {
          //Initialize the responsive datatables helper once.
          if (!this.smartResponsiveHelper) {
            this.smartResponsiveHelper = new ResponsiveDatatablesHelper(element, {
              tablet: 1024,
              phone: 480
            });
          }
        },

        "rowCallback": function (nRow, data) {
          this.smartResponsiveHelper.createExpandIcon(nRow);
        },

        "drawCallback": function (oSettings) {
          this.smartResponsiveHelper.respond();
        }
      };

      if (attributes.tableOptions) {
        options = angular.extend(options, scope.tableOptions)
      }

      var _dataTable;

      // var childFormat = element.find('.smart-datatable-child-format');
      // if (childFormat.length) {
      // 	var childFormatTemplate = childFormat.remove().html();
      // 	element.on('click', childFormat.data('childControl'), function () {
      // 		var tr = $(this).closest('tr');
      //
      // 		var row = _dataTable.row(tr);
      // 		if (row.child.isShown()) {
      // 			// This row is already open - close it
      // 			row.child.hide();
      // 			tr.removeClass('shown');
      // 		}
      // 		else {
      // 			// Open this row
      // 			var childScope = scope.$new();
      // 			childScope.d = row.data();
      // 			var html = $compile(childFormatTemplate)(childScope);
      // 			row.child(html).show();
      // 			tr.addClass('shown');
      // 		}
      // 	})
      // }

      _dataTable = element.DataTable(options);
    }
  };
});

'use strict';

angular.module('Shared.Datatables').directive('bigBreadcrumbs', function ($rootScope,$state) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/common/datatables/partials/bigBreadcrumbs.html',
    scope: {
      items: '=',
      icon: '@'
    },
    link: function (scope) {
      scope.breadItems = [];
      scope.header = '';

      scope.currentState = $state.current.name;
      scope.items = _.remove(scope.items, function (n) {
        scope.header = n.header ? $rootScope.getWord(n.label) : scope.header;
        return n.header != true;
      });

      _.forEach(scope.items, function (value) {
        value.label = $rootScope.getWord(value.label);
        scope.breadItems.push(value)
      })
    }
  }
});

/**
 * Created by Shawn Miller on 5/12/2015.
 * Path: public/app/layout/directives/assignActions.js
 */
'use strict';

  angular.module('Shared.Datatables').directive('assignActions', function ($compile) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/common/datatables/partials/assign-actions.tpl.html',
      link:function(scope, element, attributes) {

        /*attributes.$set('ngClick', attributes.function);
         $compile(element)(scope);*/
      }
    }
  });

/**
 * Created by Singh on 2/28//2017.
 */
'use strict';
angular
  .module('admin.pricing', [])
  .config(function ($stateProvider) {

    var stateDef = 'app.admin.pricing';

    // $ocLazyLoadProvider.config({
    //   // Set to true if you want to see what and when is dynamically loaded
    //   debug: false
    // });

    $stateProvider
      .state(stateDef, {
        abstract: true,
        template: '<ui-view/>',
        data: {
          title: 'Pricing'
        }
      })
      .state(stateDef+'.list', {
        url: '/pricing',
         templateUrl: 'app/admin/systemUser/views/index.html',
        controller: 'sysUserCtrl',
        resolve: {
          // loadPlugin: function ($ocLazyLoad) {
          //   return $ocLazyLoad.load([
          //     // {
          //     //   serie: true,
          //     //   files: ['plugins/datatables/media/js/dataTables.bootstrap.min.js','plugins/datatables/media/css/dataTables.bootstrap.min.css']
          //     // },
          //     // {
          //     //   serie: true,
          //     //
          //     //   files: ['plugins/angular-datatables/dist/angular-datatables.min.js']
          //     // },
          //     // {
          //     //   serie: true,
          //     //
          //     //   files: ['plugins/angular-datatables/dist/plugins/buttons/angular-datatables.buttons.min.js']
          //     // },
          //     {
          //       serie: true,
          //
          //       files: ['scripts/vendor-d67aa904cc.js']
          //     }
          //     // {
          //     //   serie: true,
          //     //   files: ['plugins/datatables-responsive/files/1.10/js/datatables.responsive.js']
          //     // }
          //   ]);
          // }
        },
        data: {
          title: 'Pricing'
        }
      })
      .state(stateDef + '.edit.step_one', {
        url: '/step_one',
        templateUrl: 'app/admin/systemUser/partials/step_one.html',
        data: { pageTitle: 'Wizard form' }
      })
      .state(stateDef + '.edit.step_two', {
        url: '/step_two',
        templateUrl: 'app/admin/systemUser/partials/step_two.html',
        data: { pageTitle: 'Wizard form' }
      })
      .state(stateDef + '.edit.step_three', {
        url: '/step_three',
        templateUrl: 'app/admin/systemUser/partials/step_three.html',
        data: { pageTitle: 'Wizard form' }
      })
      .state(stateDef+'.edit', {
        url: '/pricing-edit',
        templateUrl: 'app/admin/systemUser/views/edit.html',
        controller: 'sysUserEditCtrl',
        resolve: {
          // loadPlugin: function ($ocLazyLoad) {
          //   return $ocLazyLoad.load([
          //     // {
          //     //   serie: true,
          //     //   files: ['plugins/datatables/media/js/dataTables.bootstrap.min.js','plugins/datatables/media/css/dataTables.bootstrap.min.css']
          //     // },
          //     // {
          //     //   serie: true,
          //     //
          //     //   files: ['plugins/angular-datatables/dist/angular-datatables.min.js']
          //     // },
          //     // {
          //     //   serie: true,
          //     //
          //     //   files: ['plugins/angular-datatables/dist/plugins/buttons/angular-datatables.buttons.min.js']
          //     // },
          //     {
          //       serie: true,
          //
          //       files: ['scripts/vendor-d67aa904cc.js']
          //     }
          //     // {
          //     //   serie: true,
          //     //   files: ['plugins/datatables-responsive/files/1.10/js/datatables.responsive.js']
          //     // }
          //   ]);
          // }
        },
        data: {
          title: 'Pricing'
        }
      })
  });

/**
 * Created by Singh on 10/18/2017.
 * Filename: src/app/admin/systemUser/directives/quoteWizardForm.js
 */
angular.module('admin.pricing').directive('stepOne', function ($state,$log) {


  return {
    restrict: 'EA',

    link: function (scope, form) {

      scope.test = function () {
        $log.log("triggered")

        $state.go("app.admin.pricing.edit.step_two");

      };

      form.formValidation({

        framework: 'bootstrap',

        icon: {
          // valid: 'glyphicon',
          // invalid: 'glyphicon glyphicon-remove',
          // validating: 'glyphicon glyphicon-refresh'
        },

        addOns: {
          i18n: {},
          mandatoryIcon: {
            //     icon: !scope.id ? 'glyphicon glyphicon-asterisk' : ''
          }
        },

        fields: {
          txtName: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 2,
                max: 100
              }
            }
          }
        },

        // live: 'submitted',
        live: 'enabled',
        onSuccess: function (e, data) {
          e.preventDefault();
          scope.test();
          // scope.submitObject();
        }

      });

      // form.formValidation('setLocale', formValidationKeyService.getValidationKey());

    }

  }
});

/**
 * Created by Singh on 02/28/2017.
 * Filename: src/app/managing/pricing/directives/pricingRatesForm.js
 */
angular.module('admin.pricing').directive('pricingRatesForm', function ($log) {


    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/admin/systemUser/partials/pricing-rates-form.tpl.html',

      link: function (scope) {

        scope.remoteUrlRequestFn = function(str) {
          return {q: str};
        };

        scope.countrySelected = function(selected) {
          if (selected) {
            window.alert('You have selected ' + selected.title);
          } else {
            $log.log('cleared');
          }
        };

        scope.localSearch = function(str, people) {
          var matches = [];
          people.forEach(function(person) {
            var fullName = person.firstName + ' ' + person.surname;
            if ((person.firstName.toLowerCase().indexOf(str.toString().toLowerCase()) >= 0) ||
              (person.surname.toLowerCase().indexOf(str.toString().toLowerCase()) >= 0) ||
              (fullName.toLowerCase().indexOf(str.toString().toLowerCase()) >= 0)) {
              matches.push(person);
            }
          });
          return matches;
        };

        scope.people = [
          {firstName: "Daryl", surname: "Rowland", twitter: "@darylrowland", pic: "img/daryl.jpeg"},
          {firstName: "Alan", surname: "Partridge", twitter: "@alangpartridge", pic: "img/alanp.jpg"},
          {firstName: "Annie", surname: "Rowland", twitter: "@anklesannie", pic: "img/annie.jpg"}
        ];

        scope.countries = [
          {name: 'Afghanistan', code: 'AF'},
          {name: 'Aland Islands', code: 'AX'},
          {name: 'Albania', code: 'AL'},
          {name: 'Algeria', code: 'DZ'},
          {name: 'American Samoa', code: 'AS'},
          {name: 'AndorrA', code: 'AD'},
          {name: 'Angola', code: 'AO'},
          {name: 'Anguilla', code: 'AI'},
          {name: 'Antarctica', code: 'AQ'},
          {name: 'Antigua and Barbuda', code: 'AG'},
          {name: 'Argentina', code: 'AR'},
          {name: 'Armenia', code: 'AM'},
          {name: 'Aruba', code: 'AW'},
          {name: 'Australia', code: 'AU'},
          {name: 'Austria', code: 'AT'},
          {name: 'Azerbaijan', code: 'AZ'},
          {name: 'Bahamas', code: 'BS'},
          {name: 'Bahrain', code: 'BH'},
          {name: 'Bangladesh', code: 'BD'},
          {name: 'Barbados', code: 'BB'},
          {name: 'Belarus', code: 'BY'},
          {name: 'Belgium', code: 'BE'},
          {name: 'Belize', code: 'BZ'},
          {name: 'Benin', code: 'BJ'},
          {name: 'Bermuda', code: 'BM'},
          {name: 'Bhutan', code: 'BT'},
          {name: 'Bolivia', code: 'BO'},
          {name: 'Bosnia and Herzegovina', code: 'BA'},
          {name: 'Botswana', code: 'BW'},
          {name: 'Bouvet Island', code: 'BV'},
          {name: 'Brazil', code: 'BR'},
          {name: 'British Indian Ocean Territory', code: 'IO'},
          {name: 'Brunei Darussalam', code: 'BN'},
          {name: 'Bulgaria', code: 'BG'},
          {name: 'Burkina Faso', code: 'BF'},
          {name: 'Burundi', code: 'BI'},
          {name: 'Cambodia', code: 'KH'},
          {name: 'Cameroon', code: 'CM'},
          {name: 'Canada', code: 'CA'},
          {name: 'Cape Verde', code: 'CV'},
          {name: 'Cayman Islands', code: 'KY'},
          {name: 'Central African Republic', code: 'CF'},
          {name: 'Chad', code: 'TD'},
          {name: 'Chile', code: 'CL'},
          {name: 'China', code: 'CN'},
          {name: 'Christmas Island', code: 'CX'},
          {name: 'Cocos (Keeling) Islands', code: 'CC'},
          {name: 'Colombia', code: 'CO'},
          {name: 'Comoros', code: 'KM'},
          {name: 'Congo', code: 'CG'},
          {name: 'Congo, The Democratic Republic of the', code: 'CD'},
          {name: 'Cook Islands', code: 'CK'},
          {name: 'Costa Rica', code: 'CR'},
          {name: 'Cote D\'Ivoire', code: 'CI'},
          {name: 'Croatia', code: 'HR'},
          {name: 'Cuba', code: 'CU'},
          {name: 'Cyprus', code: 'CY'},
          {name: 'Czech Republic', code: 'CZ'},
          {name: 'Denmark', code: 'DK'},
          {name: 'Djibouti', code: 'DJ'},
          {name: 'Dominica', code: 'DM'},
          {name: 'Dominican Republic', code: 'DO'},
          {name: 'Ecuador', code: 'EC'},
          {name: 'Egypt', code: 'EG'},
          {name: 'El Salvador', code: 'SV'},
          {name: 'Equatorial Guinea', code: 'GQ'},
          {name: 'Eritrea', code: 'ER'},
          {name: 'Estonia', code: 'EE'},
          {name: 'Ethiopia', code: 'ET'},
          {name: 'Falkland Islands (Malvinas)', code: 'FK'},
          {name: 'Faroe Islands', code: 'FO'},
          {name: 'Fiji', code: 'FJ'},
          {name: 'Finland', code: 'FI'},
          {name: 'France', code: 'FR'},
          {name: 'French Guiana', code: 'GF'},
          {name: 'French Polynesia', code: 'PF'},
          {name: 'French Southern Territories', code: 'TF'},
          {name: 'Gabon', code: 'GA'},
          {name: 'Gambia', code: 'GM'},
          {name: 'Georgia', code: 'GE'},
          {name: 'Germany', code: 'DE'},
          {name: 'Ghana', code: 'GH'},
          {name: 'Gibraltar', code: 'GI'},
          {name: 'Greece', code: 'GR'},
          {name: 'Greenland', code: 'GL'},
          {name: 'Grenada', code: 'GD'},
          {name: 'Guadeloupe', code: 'GP'},
          {name: 'Guam', code: 'GU'},
          {name: 'Guatemala', code: 'GT'},
          {name: 'Guernsey', code: 'GG'},
          {name: 'Guinea', code: 'GN'},
          {name: 'Guinea-Bissau', code: 'GW'},
          {name: 'Guyana', code: 'GY'},
          {name: 'Haiti', code: 'HT'},
          {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
          {name: 'Holy See (Vatican City State)', code: 'VA'},
          {name: 'Honduras', code: 'HN'},
          {name: 'Hong Kong', code: 'HK'},
          {name: 'Hungary', code: 'HU'},
          {name: 'Iceland', code: 'IS'},
          {name: 'India', code: 'IN'},
          {name: 'Indonesia', code: 'ID'},
          {name: 'Iran, Islamic Republic Of', code: 'IR'},
          {name: 'Iraq', code: 'IQ'},
          {name: 'Ireland', code: 'IE'},
          {name: 'Isle of Man', code: 'IM'},
          {name: 'Israel', code: 'IL'},
          {name: 'Italy', code: 'IT'},
          {name: 'Jamaica', code: 'JM'},
          {name: 'Japan', code: 'JP'},
          {name: 'Jersey', code: 'JE'},
          {name: 'Jordan', code: 'JO'},
          {name: 'Kazakhstan', code: 'KZ'},
          {name: 'Kenya', code: 'KE'},
          {name: 'Kiribati', code: 'KI'},
          {name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
          {name: 'Korea, Republic of', code: 'KR'},
          {name: 'Kuwait', code: 'KW'},
          {name: 'Kyrgyzstan', code: 'KG'},
          {name: 'Lao People\'S Democratic Republic', code: 'LA'},
          {name: 'Latvia', code: 'LV'},
          {name: 'Lebanon', code: 'LB'},
          {name: 'Lesotho', code: 'LS'},
          {name: 'Liberia', code: 'LR'},
          {name: 'Libyan Arab Jamahiriya', code: 'LY'},
          {name: 'Liechtenstein', code: 'LI'},
          {name: 'Lithuania', code: 'LT'},
          {name: 'Luxembourg', code: 'LU'},
          {name: 'Macao', code: 'MO'},
          {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
          {name: 'Madagascar', code: 'MG'},
          {name: 'Malawi', code: 'MW'},
          {name: 'Malaysia', code: 'MY'},
          {name: 'Maldives', code: 'MV'},
          {name: 'Mali', code: 'ML'},
          {name: 'Malta', code: 'MT'},
          {name: 'Marshall Islands', code: 'MH'},
          {name: 'Martinique', code: 'MQ'},
          {name: 'Mauritania', code: 'MR'},
          {name: 'Mauritius', code: 'MU'},
          {name: 'Mayotte', code: 'YT'},
          {name: 'Mexico', code: 'MX'},
          {name: 'Micronesia, Federated States of', code: 'FM'},
          {name: 'Moldova, Republic of', code: 'MD'},
          {name: 'Monaco', code: 'MC'},
          {name: 'Mongolia', code: 'MN'},
          {name: 'Montserrat', code: 'MS'},
          {name: 'Morocco', code: 'MA'},
          {name: 'Mozambique', code: 'MZ'},
          {name: 'Myanmar', code: 'MM'},
          {name: 'Namibia', code: 'NA'},
          {name: 'Nauru', code: 'NR'},
          {name: 'Nepal', code: 'NP'},
          {name: 'Netherlands', code: 'NL'},
          {name: 'Netherlands Antilles', code: 'AN'},
          {name: 'New Caledonia', code: 'NC'},
          {name: 'New Zealand', code: 'NZ'},
          {name: 'Nicaragua', code: 'NI'},
          {name: 'Niger', code: 'NE'},
          {name: 'Nigeria', code: 'NG'},
          {name: 'Niue', code: 'NU'},
          {name: 'Norfolk Island', code: 'NF'},
          {name: 'Northern Mariana Islands', code: 'MP'},
          {name: 'Norway', code: 'NO'},
          {name: 'Oman', code: 'OM'},
          {name: 'Pakistan', code: 'PK'},
          {name: 'Palau', code: 'PW'},
          {name: 'Palestinian Territory, Occupied', code: 'PS'},
          {name: 'Panama', code: 'PA'},
          {name: 'Papua New Guinea', code: 'PG'},
          {name: 'Paraguay', code: 'PY'},
          {name: 'Peru', code: 'PE'},
          {name: 'Philippines', code: 'PH'},
          {name: 'Pitcairn', code: 'PN'},
          {name: 'Poland', code: 'PL'},
          {name: 'Portugal', code: 'PT'},
          {name: 'Puerto Rico', code: 'PR'},
          {name: 'Qatar', code: 'QA'},
          {name: 'Reunion', code: 'RE'},
          {name: 'Romania', code: 'RO'},
          {name: 'Russian Federation', code: 'RU'},
          {name: 'RWANDA', code: 'RW'},
          {name: 'Saint Helena', code: 'SH'},
          {name: 'Saint Kitts and Nevis', code: 'KN'},
          {name: 'Saint Lucia', code: 'LC'},
          {name: 'Saint Pierre and Miquelon', code: 'PM'},
          {name: 'Saint Vincent and the Grenadines', code: 'VC'},
          {name: 'Samoa', code: 'WS'},
          {name: 'San Marino', code: 'SM'},
          {name: 'Sao Tome and Principe', code: 'ST'},
          {name: 'Saudi Arabia', code: 'SA'},
          {name: 'Senegal', code: 'SN'},
          {name: 'Serbia and Montenegro', code: 'CS'},
          {name: 'Seychelles', code: 'SC'},
          {name: 'Sierra Leone', code: 'SL'},
          {name: 'Singapore', code: 'SG'},
          {name: 'Slovakia', code: 'SK'},
          {name: 'Slovenia', code: 'SI'},
          {name: 'Solomon Islands', code: 'SB'},
          {name: 'Somalia', code: 'SO'},
          {name: 'South Africa', code: 'ZA'},
          {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
          {name: 'Spain', code: 'ES'},
          {name: 'Sri Lanka', code: 'LK'},
          {name: 'Sudan', code: 'SD'},
          {name: 'Suriname', code: 'SR'},
          {name: 'Svalbard and Jan Mayen', code: 'SJ'},
          {name: 'Swaziland', code: 'SZ'},
          {name: 'Sweden', code: 'SE'},
          {name: 'Switzerland', code: 'CH'},
          {name: 'Syrian Arab Republic', code: 'SY'},
          {name: 'Taiwan, Province of China', code: 'TW'},
          {name: 'Tajikistan', code: 'TJ'},
          {name: 'Tanzania, United Republic of', code: 'TZ'},
          {name: 'Thailand', code: 'TH'},
          {name: 'Timor-Leste', code: 'TL'},
          {name: 'Togo', code: 'TG'},
          {name: 'Tokelau', code: 'TK'},
          {name: 'Tonga', code: 'TO'},
          {name: 'Trinidad and Tobago', code: 'TT'},
          {name: 'Tunisia', code: 'TN'},
          {name: 'Turkey', code: 'TR'},
          {name: 'Turkmenistan', code: 'TM'},
          {name: 'Turks and Caicos Islands', code: 'TC'},
          {name: 'Tuvalu', code: 'TV'},
          {name: 'Uganda', code: 'UG'},
          {name: 'Ukraine', code: 'UA'},
          {name: 'United Arab Emirates', code: 'AE'},
          {name: 'United Kingdom', code: 'GB'},
          {name: 'United States', code: 'US'},
          {name: 'United States Minor Outlying Islands', code: 'UM'},
          {name: 'Uruguay', code: 'UY'},
          {name: 'Uzbekistan', code: 'UZ'},
          {name: 'Vanuatu', code: 'VU'},
          {name: 'Venezuela', code: 'VE'},
          {name: 'Vietnam', code: 'VN'},
          {name: 'Virgin Islands, British', code: 'VG'},
          {name: 'Virgin Islands, U.S.', code: 'VI'},
          {name: 'Wallis and Futuna', code: 'WF'},
          {name: 'Western Sahara', code: 'EH'},
          {name: 'Yemen', code: 'YE'},
          {name: 'Zambia', code: 'ZM'},
          {name: 'Zimbabwe', code: 'ZW'}
        ];

        scope.countrySelected9 = {name: 'Zimbabwe', code: 'ZW'};
        scope.countrySelectedFn9 = function(selected) {
          if (selected) {
            scope.countrySelected9 = selected.originalObject;
          } else {
            scope.countrySelected9 = null;
          }
        };

        scope.selectedCountry16 = {name: 'Russia'};

        scope.inputChanged = function(str) {
          scope.console10 = str;
        };

        scope.focusState = 'None';
        scope.focusIn = function() {
          var focusInputElem = document.getElementById('ex12_value');
          scope.focusState = 'In';
          focusInputElem.classList.remove('small-input');
        };
        scope.focusOut = function() {
          var focusInputElem = document.getElementById('ex12_value');
          scope.focusState = 'Out';
          focusInputElem.classList.add('small-input');
        };

        /***
         * Send a broadcast to the directive in order to clear itself
         * if an id parameter is given only this ancucomplete is cleared
         * @param id
         */
        scope.clearInput = function (id) {
          if (id) {
            scope.$broadcast('angucomplete-alt:clearInput', id);
          }
          else{
            scope.$broadcast('angucomplete-alt:clearInput');
          }
        };

        /***
         * Send a broadcast to the directive in order to change itself
         * if an id parameter is given only this ancucomplete is changed
         * @param id
         */
        scope.changeInput = function (id) {
          if (id) {
            var pos = Math.floor(Math.random() * (scope.countries.length - 1));
            scope.$broadcast('angucomplete-alt:changeInput', id, scope.countries[pos]);
          }
        };

        scope.disableInput = true;

        scope.requireExample8a = true;
        scope.requireExample8b = true;
      }
    }
  }
);


// form.formValidation('setLocale', formValidationKeyService.getValidationKey());




/**
 * Created by Singh on 2/28/2017.
 */
angular.module('admin.pricing').controller('sysUserEditCtrl', function($scope,$state) {

  var stateModel = {
    listPage : "app.admin.pricing.list",
    editPage : "app.admin.pricing.edit.step_one"
  };

  $scope.cancelForm = function () {
    $state.go(stateModel.listPage);
  };

// All data will be store in this object
  $scope.formData = {};

  $scope.price={};

  $scope.clearText =  function () {
    $scope.price.test = ''
  };

});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('admin.pricing').controller('sysUserCtrl', function($scope, DTOptionsBuilder,$state,dtEncoder,DTColumnBuilder,$compile,$q,defaultApiService) {

  /**
   * persons - Data used in Tables view for Data Tables plugin
   */
  $scope.personsData = [
    {
      id: '1',
      firstName: 'Monica<b>hey</b>',
      lastName: 'Smith'
    },
    {
      id: '2',
      firstName: 'Sandra',
      lastName: 'Jackson'
    },
    {
      id: '3',
      firstName: 'John',
      lastName: 'Underwood'
    },
    {
      id: '4',
      firstName: 'Chris',
      lastName: 'Johnatan'
    },
    {
      id: '5',
      firstName: 'Kim',
      lastName: 'Rosowski'
    }
  ];

  //Encoding the data
  var propertyNames = [
    'firstName'
  ];

  $scope.persons = dtEncoder.dtEncodeValues($scope.personsData, propertyNames);

  $scope.options = {
    data : $scope.persons,
    stateSave : true,
    fnCreatedRow : function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    columns : [
      {
        "mDataProp" : "firstName"
      },
      {
        "mDataProp" : "lastName"
      }
    ]
  };


  var getTableData = function () {
    var deferred = $q.defer();
    deferred.resolve($scope.persons);
    return deferred.promise;
  };

  $scope.dtOptions = DTOptionsBuilder.fromFnPromise(getTableData)
    .withDOM('<"html5buttons"B>lTfgtp <"bottom"i>')
    .withButtons([
      {extend: 'copy'},
      {extend: 'csv'},
      {extend: 'excel', title: 'ExampleFile'},
      {extend: 'pdf', title: 'ExampleFile'},

      {
        extend: 'print',
        customize: function (win) {
          angular.element(win.document.body).addClass('white-bg');
          angular.element(win.document.body).css('font-size', '10px');

          angular.element(win.document.body).find('table')
            .addClass('compact')
            .css('font-size', 'inherit');
        }
      }
    ]);

  $scope.dtColumnDefs = [
    DTColumnBuilder.newColumn('id'),
    DTColumnBuilder.newColumn('firstName'),
    DTColumnBuilder.newColumn('lastName')
  ];

  $scope.createNewItem = function () {
    $state.go('app.admin.pricing.edit')
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */
angular.module('app.quote').service('wizardNavigationService', function () {

  var navProperties = {};
  var currentState = 1;

  var navigationStepEnums = {
    quoteInformation: 1,
    addItems: 2,
    quoteReview: 3
  };

  function setNavProperties() {
    navProperties.quoteInformation = {
      isQuoteInformationEnabled: true,
      isQuoteInformationCurrent: true
    };
    navProperties.addItems = {
      isItemShippingEnabled: false,
      isItemShippingCurrent: false
    };
    navProperties.quoteReview = {
      isQuoteReviewEnabled: false,
      isQuoteReviewCurrent: false
    };
  }

  setNavProperties();

  return {
    initializeNavProperties: function () {
      setNavProperties();
      currentState = 1;
    },
    getNavProperties: function () {
      return navProperties;
    },
    setCurrentState: function (curState) {
      currentState = parseInt(curState)
    },
    getCurrentState: function () {
      return currentState
    },
    getNavigationStepEnums: function () {
      return navigationStepEnums;
    },


    //Enable tabs
    setNav: function () {
      var tab = 1;
      while (currentState >= tab) {
        switch (tab) {
          case navigationStepEnums.quoteInformation :
            navProperties.quoteInformation.isQuoteInformationEnabled = true;
            navProperties.quoteInformation.isQuoteInformationCurrent = tab == currentState ? true : false;
            break;
          case navigationStepEnums.addItems :
            navProperties.addItems.isItemShippingEnabled = true;
            navProperties.addItems.isItemShippingCurrent = tab == currentState ? true : false;
            break;
          case navigationStepEnums.quoteReview :
            navProperties.quoteReview.isQuoteReviewEnabled = true;
            navProperties.quoteReview.isQuoteReviewCurrent = tab == currentState ? true : false;
            break;
        }
        tab++
      }
    },

    disableAllNavs: function () {
      var curState = currentState;
      while (curState <= navigationStepEnums.quoteReview) {
        switch (curState) {
          case navigationStepEnums.addItems :
            navProperties.addItems.isItemShippingCurrent = false;
            navProperties.addItems.isItemShippingEnabled = false;
            break;
          case navigationStepEnums.quoteReview :
            navProperties.quoteReview.isQuoteReviewCurrent = false;
            navProperties.quoteReview.isQuoteReviewEnabled = false;
            break;
        }
        curState++;
      }
    }

  }
});

angular.module('app.quote').service('quoteModelService', function (itemConfigurationService, $rootScope) {

    var readOnlyFlag = false;
    var version = '';
    var quoteInterrupted = false;
    var quoteModel = {
        quoteId: null,
        header: {
            customerInfo: {
                quoteShipTo: []
            }
        },
        items: []
    };
    var header = quoteModel.header;

    function setRequester(requesterInfo) {
        var requester = {};
        requester.name = requesterInfo.requesterFullName;
        requester.phone = {
            countryCode: requesterInfo.requesterCountryCode ? requesterInfo.requesterCountryCode : '+1',
            number: requesterInfo.requesterPhoneNumber,
            ext: requesterInfo.requesterPhExtension
        };
        requester.email = requesterInfo.requesterEmail;
        return requester
    }

    return {
        initializeQuoteModel: function () {
            quoteModel = {};
        },
        setQuoteModel: function (data) {
            quoteModel = data
        },
        getQuoteModel: function () {
            return quoteModel
        },
        initializeHeader: function () {
            header = {
                customerInfo: {
                    quoteShipTo: []
                }
            };
            quoteModel.header = header;
        },
        setCustomerInfo: function (customerInfo, quoteInfo) {
            header.customerInfo.customerId = customerInfo.id;
            header.customerInfo.accountNumber = customerInfo.accountNumber;
            header.customerInfo.quoteBillTo = {
                fullName: customerInfo.fullName,
                code: customerInfo.code,
                companyName: customerInfo.companyName,
                firstName: customerInfo.firstName,
                lastName: customerInfo.lastName,
                address1: customerInfo.street1,
                address2: customerInfo.street2,
                address3: customerInfo.street3,
                city: customerInfo.city,
                state: customerInfo.state,
                postalCode: customerInfo.postalCode,
                country: customerInfo.country,
                phone: {
                    countryCode: customerInfo.countryCode,
                    number: customerInfo.phoneNumber,
                    ext: customerInfo.phoneExt,
                    type: 0
                },
                email: customerInfo.email,
                website: customerInfo.website,
                saveAsCustomer: customerInfo.saveAsCustomer ? customerInfo.saveAsCustomer : false
            };
            header.requester = setRequester(quoteInfo);
            header.projectDescription = quoteInfo.projectDescription;
            header.source = {
                sourceName: quoteInfo.sourceName,
                priceType: quoteInfo.priceType,
                referenceNumber: quoteInfo.referenceNumber
            };
        },
        getCustomerInfo: function () {
            return quoteModel;
        },
        setRecipientInfo: function (recipientInfo, itemId) {
            if (header.customerInfo.quoteShipTo.length >= 1) {
                _.remove(header.customerInfo.quoteShipTo, function (n) {
                    return n.itemId == itemId;
                });
                header.customerInfo.quoteShipTo.push.apply(header.customerInfo.quoteShipTo, recipientInfo);
                // header.customerInfo.quoteShipTo.push(recipientInfo);
            } else {
                header.customerInfo.quoteShipTo = _.cloneDeep(recipientInfo);
            }
            // header.customerInfo.quoteShipTo = recipientInfo;
        },
        getRecipientInfo: function () {
            return header.customerInfo.quoteShipTo
        },
        deleteRecipientInfo: function (itemId) {
            _.forEach(header.customerInfo.quoteShipTo, function (recipient, index) {
                if (recipient.itemId == itemId) {
                    header.customerInfo.quoteShipTo.splice(index, 1);
                }
            });
        },
        setMiscellaneousData: function (data) {
            header.projectName = '';
            header.term = data.term
        },
        setItems: function () {
            quoteModel.items = itemConfigurationService.getAllItems();
        },
        setQuoteId: function (id) {
            quoteModel.quoteId = id
        },
        getQuoteId: function () {
            return quoteModel.quoteId;
        },
        setQuoteHeader: function (quoteHead) {
            quoteModel.header = quoteHead;
            header = quoteHead;
            if (quoteModel.quoteHeader)
                delete quoteModel.quoteHeader
        },
        setReadOnlyFlag: function (flag, versionNo) {
            readOnlyFlag = flag;
            if (flag) {
                version = versionNo
            } else {
                version = ''
            }
        },
        getReadOnlyFlag: function () {
            return readOnlyFlag;
        },
        getVersionNumber: function () {
            return version;
        },
        setAuditInfo: function (headerData) {
            if (quoteModel.header)
                quoteModel.header.auditInfo = headerData.auditInfo;
            header.auditInfo = headerData.auditInfo;
        },
        getHeaderAuditInfo: function () {
            if (header && header.auditInfo)
                return header.auditInfo;
            else
                return {
                    lastModifiedByUserName: $rootScope.user ? $rootScope.user.login : ''
                }
        },
        getHeader: function () {
            return quoteModel.header
        },
        modifyCustomerData: function (obj) {
            return {
                "id": obj.customerId,
                "code": obj.quoteBillTo.code,
                "firstName": obj.quoteBillTo.firstName,
                "lastName": obj.quoteBillTo.lastName,
                "fullName": obj.quoteBillTo.fullName,
                "companyName": obj.quoteBillTo.companyName,
                "street1": obj.quoteBillTo.address1,
                "street2": obj.quoteBillTo.address2,
                "city": obj.quoteBillTo.city,
                "state": obj.quoteBillTo.state,
                "postalCode": obj.quoteBillTo.postalCode,
                "country": obj.quoteBillTo.country,
                "countryCode": obj.quoteBillTo.phone.countryCode,
                "phoneNumber": obj.quoteBillTo.phone.number,
                "phoneExt": obj.quoteBillTo.phone.ext,
                "phoneType": obj.quoteBillTo.phone.type,
                "email": obj.quoteBillTo.email,
                "accountNumber": obj.accountNumber,
                "website": obj.quoteBillTo.website,
                "hasAddressDetails": !!(obj.quoteBillTo.address1 || obj.quoteBillTo.address2 || obj.quoteBillTo.address3 || obj.quoteBillTo.city || obj.quoteBillTo.state || obj.quoteBillTo.postalCode || obj.quoteBillTo.country),
                "hasContactDetails": !!(obj.quoteBillTo.phone.number || obj.quoteBillTo.phone.ext || obj.quoteBillTo.email || obj.quoteBillTo.website),
                "updateCustomer": false
            };
        },
        // If a user will make saveQuote call and will leave the page before success
        setQuoteInterrupted: function (flag) {
            quoteInterrupted = flag
        },
        getQuoteInterrupted: function (quoteInterrupted) {
            return quoteInterrupted
        }
    }
});

angular.module('app.quote').service('quoteHeaderService', function ($rootScope) {

    var headersData = {};
    var quoteSources = [];
    return {
        initializeQuotesData: function () {
            headersData = {};
        },
        setHeaderData: function (data) {
            headersData = data
        },

        getQuoteData: function () {
            return headersData
        },

        quoteChanged: function (newValue) {
            $rootScope.$broadcast('valueChanged', newValue);
        },

        // get QuoteTerm Enum Values

        populateEnums: function (enums) {
            var quoteTerms = [];
            _.forEach(headersData.quoteTerms, function (enumKey, enumValue) {
                quoteTerms.push({
                    name: $rootScope.getWord(enumKey),
                    statEnum: enumValue,
                    value: enumValue
                });
            });
            return quoteTerms;
        },

        getQuoteSourcesEnum: function () {
            quoteSources = [];
            _.forEach(headersData.quoteSource, function (source) {
                quoteSources.push({
                    name: source.name,
                    statEnum: source.name,
                    value: source.name,
                    priceType: source.priceType,
                    victorPriceType: source.victorPriceType
                });
            });

            return _.sortBy(quoteSources, ['name'], ['asc']);
        },
        setQuotesData: function (quotesData) {
            angular.element.each(quotesData, function (i, val) {
                if (i != 'sourceName' && i != 'priceType' && i != 'victorPriceType')
                    headersData[i] = val
            });
            _.filter(quoteSources, function (source, index) {
                if (source.statEnum === quotesData.sourceName) {
                    headersData.sourceName = source.name;
                    headersData.priceType = source.priceType;
                    headersData.victorPriceType = source.victorPriceType;
                }
            });
        },
        resetCustomerInfo: function () {
            var customerInfoArray = ['fullName', 'companyName', 'accountNumber', 'street1', 'street2', 'city', 'state', 'postalCode', 'country', 'hasAddressDetails', 'email', 'phoneNumber'];
            _.forEach(customerInfoArray, function (val) {
                headersData[val] = "";
            })
        },
        getQuoteStatus: function (status) {
            var quoteStatus = null;
            switch (status) {
                case 10:
                    quoteStatus = '<span class="label label-success status-label">' + $rootScope.getWord('InProgress').toUpperCase() + '</span>';
                    break;
                case 20:
                    quoteStatus = '<span class="label label-warning status-label">' + $rootScope.getWord('Created').toUpperCase() + '</span>';
                    break;
                case 30:
                    quoteStatus = '<span class="label label-primary status-label">' + $rootScope.getWord('Converted').toUpperCase() + '</span>';
                    break;
                case 40:
                    quoteStatus = '<span class="label label-danger status-label">' + $rootScope.getWord('Closed').toUpperCase() + '</span>';
                    break;
                default:
                    quoteStatus = '<span class="label label-success status-label">' + $rootScope.getWord('InProgress').toUpperCase() + '</span>';
                    break;
            }
            return quoteStatus;
        }
    }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('manageStatesService', function () {

  var from_state = 0;
  var to_state = 0;
  var isLegitAction = false;
  var legitPreviousAction = false;
  var goToPrevious = false;

  return {
    initializeStates: function () {
      from_state = 0;
      to_state = 0;
    },
    setLegitAction: function (value) {
      isLegitAction = value
    },
    getLegitAction: function () {
      return isLegitAction
    },
    executeRouting: function (event, toState, toParams, from) {
      switch (from.name) {
        case 'app.quote.createQuote.step_one':
          from_state = 1;
          break;
        case 'app.quote.createQuote.step_two':
          from_state = 2;
          break;
        case 'app.quote.createQuote.step_three':
          from_state = 3;
          break;
        default:
          from_state = 0;
      }
      switch (toState.name) {
        case 'app.quote.createQuote.step_one':
          to_state = 1;
          break;
        case 'app.quote.createQuote.step_two':
          to_state = 2;
          break;
        case 'app.quote.createQuote.step_three':
          to_state = 3;
          break;
        default:
          to_state = 0;
      }
    },

    // Check if action is legit and also
    // Check if attempt is to move to next step or previous step
    // If moving from lower to higher state with illegitimate action then state should not advance
    preventAdvancedStep: function () {
      if (!isLegitAction && from_state < to_state) {
        return true
      }
    },
    setLegitPreviousAction: function (value) {
      legitPreviousAction = value
    },
    getLegitPreviousAction: function () {
      if (legitPreviousAction && from_state > to_state) {
        return true
      }
      else {
        return false
      }
    },
    setToState: function (toState) {
      to_state = toState;
    },
    getFromState: function () {
      return from_state
    },
    legitStepTwoAction: function () {
      if (from_state > to_state) {
        return true
      }
      else {
        return false
      }
    },
    setGoToPrevious : function (bool) {
      goToPrevious = bool
    },
    getGoToPrevious : function () {
      return goToPrevious
    }
  }
});

/**
 * Created by $ingh on 11/1/2017.
 */

angular.module('app.quote').service('genericQuotesService', function ($rootScope, defaultApiService, notificationService, $stateParams, $location, $cookies, downloadFileService, errorNotificationService) {

  var enumValues = {
    collateMethods: [],
    productTypes: [],
    sides: [],
    quantityCostingTypes: []
  };

  var productEnums = {
    flatSheet: 1,
    books: 2,
    wideFormat: 3,
    copies: 4,
    scans: 5,
    pads: 6,
    finishingOnly: 7,
    ncr: 8,
    multiFlatSheet: 9,
    envelope: 10
  };

  var quantityCostingTypesEnums = {
    Ask: 1,
    ItemQuantity: 2,
    SetsPerPad: 3,
    RunSizeSheetsNoWaste: 7,
    Lot: 13,
    TotalArea: 22,
    TotalPrintArea: 35
  };

  var componentTypeEnums = {
    standard: 1,
    tab: 2,
    exceptionPages: 3,
    cover: 4
  };

  var sideTypeEnums = {
    none: 0,
    oneSided: 1,
    twoSidedHeadToHead: 2,
    twoSidedHeadToFoot: 3
  };

  var initializeFlag = true;
  var incomingFromCustomer = false;
  var versionId = '';
  var viewQuote = '';
  var legitStateChange = true;
  var versionNumber = '';
  var byPassComponentValidation = false;

  function populateEnums(enumData) {
    var populatedValues = [];
    _.forEach(enumData, function (value, enumNumber) {

      populatedValues.push({
        class: 'type',
        value: enumNumber,
        name: $rootScope.getWord(value),
        unlocalisedName: value
      })
    });
    return populatedValues;
  }

  // Logic to download Reports
  var downloadAsset = function (api, id) {
    $rootScope.startSpinner();
    var url = appConfig.apiURL + '/api/' + api + '/' + id;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = "blob";
    xhr.setRequestHeader('Authorization', 'Bearer ' + $cookies.get('_Token'));
    xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status == 200) {
          $rootScope.stopSpinner();
          downloadFileService.saveFile(xhr, id);
        }
        else if (xhr.status == 204) {
          // No Content
          $rootScope.stopSpinner();
        }
        else {
          $rootScope.stopSpinner();
          var rejectionInfo = {data: {message: xhr.statusText}};
          errorNotificationService.notifyError(rejectionInfo);
        }
      }
    };
    xhr.onerror = function (e) {
      $rootScope.stopSpinner();
      errorNotificationService.notifyError(xhr);
    };
    xhr.send(null);
  };

  return {
    populateEnums: function (data) {
      enumValues.collateMethods = populateEnums(data.collateMethods);
      enumValues.productTypes = populateEnums(data.productTypes);
      enumValues.quantityCostingTypes = populateEnums(data.quantityCostingTypes);
      //change the None Enum value to Select
      _.forEach(data.numberOfSides, function (side, index) {
        if (index == 0) {
          data.numberOfSides[index] = 'SelectOption';
        }
      });
      enumValues.sides = populateEnums(data.numberOfSides)
    },
    getEnumValues: function () {
      return enumValues;
    },
    validateForm: function (formId) {
      angular.element('#' + formId).data('formValidation').validate();
      var fv = angular.element('#' + formId).data('formValidation');
      var isFormValid = fv.isValid();
      return isFormValid
    },
    validateContainer: function (formId, containerId) {
      //By passsing the validation in getTemplate function to render finishing option
      if (!byPassComponentValidation) {
        var fv = angular.element('#' + formId).data('formValidation');
        var container = angular.element('#' + containerId);
        // Validate the container
        fv.validateContainer(container);
        var isValidStep = fv.isValidContainer(container);
        if (isValidStep === false || isValidStep === null) {
          return false;
        }
        return true;
      }
      else {
        return true;
      }
    },
    autoScroll: function (id) {
      var fv = angular.element('#' + id).data('formValidation');
      if (angular.element(fv.$invalidFields[0]).first().offset() != undefined) {

        angular.element('html, body').animate({
          scrollTop: (angular.element(fv.$invalidFields[0]).first().offset().top) + (-30)
        }, 700);
      }
    },
    getProductEnums: function () {
      return productEnums;
    },

    getQuantityByEnums: function () {
      return quantityCostingTypesEnums;
    },

    getComponentTypeEnums: function () {
      return componentTypeEnums;
    },

    getSideTypeEnums: function () {
      return sideTypeEnums;
    },

    initializeStuff: function (flag) {
      initializeFlag = flag
    },
    getInitializeStuff: function () {
      return initializeFlag
    },
    setIncomingFromCustomer: function (customerObj) {
      incomingFromCustomer = customerObj
    },
    getIncomingFromCustomer: function () {
      return incomingFromCustomer
    },
    deleteQuoteVersion: function (id, itemName) {
      $rootScope.startSpinner();
      var quoteId = $stateParams.quoteId;
      var table = angular.element('#quoteHistoryDatatable').DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, data, node) {
        return data.id === id;
      });
      var payload = {
        quoteId: quoteId,
        versionInfoId: id
      };
      defaultApiService.deleteObjectWithContractCall('Quotes/DeleteQuoteVersion', payload)
        .success(function () {
          table.row(row[0]).remove().draw();
          $rootScope.stopSpinner();
          var versionName = $rootScope.getWord('QuoteVersion') + ' ' + itemName;
          notificationService.notifyDeleteSuccess(versionName);
        }).error(function () {
        $rootScope.stopSpinner();
      });
    },
    getQuoteDataCall: function (param) {
      var quoteData = '';
      if (param.id && !param.versionId && param.viewQuote) {
        quoteData = defaultApiService.readObjectCall('Quotes/EditQuote', param.id);
        versionId = '';
        viewQuote = '';
      }
      else if (param.id && param.versionId && param.viewQuote) {
        quoteData = defaultApiService.readObjectCall('Quotes/VersionDetails', param.versionId);
        versionId = param.versionId;
        viewQuote = param.viewQuote;
      }
      else if (param.id && param.versionId && param.restore) {
        quoteData = defaultApiService.createObjectCall('Quotes/RestoreVersion', {
          quoteId: param.id,
          versionId: param.versionId
        });
        versionId = '';
        viewQuote = '';
      }
      else if (param.id && param.versionId) {
        versionId = '';
        viewQuote = '';
      }
      else if (param.versionId) {
        quoteData = defaultApiService.readObjectCall('Quotes/VersionDetails', param.versionId);
        versionId = param.versionId;
        viewQuote = '';
      }
      else if (param.id) {
        quoteData = defaultApiService.readObjectCall('Quotes/EditQuote', param.id);
        versionId = '';
        viewQuote = param.viewQuote;
      }
      return quoteData;
    },
    setVersionId: function (vId) {
      versionId = vId;
    },
    getVersionId: function () {
      return versionId;
    },
    setViewQuote: function (vQuote) {
      viewQuote = vQuote;
    },
    getViewQuote: function () {
      return viewQuote;
    },
    setVersionNumber: function (vNumber) {
      versionNumber = vNumber;
    },
    getVersionNumber: function () {
      return versionNumber;
    },
    setLegitStateChange: function (flag) {
      legitStateChange = flag
    },
    getLegitStateChange: function () {
      return legitStateChange
    },
    setByPassComponentValidation: function (flag) {
      byPassComponentValidation = flag
    },
    getByPassComponentValidation: function () {
      return byPassComponentValidation
    },
    downloadPdfAsset: function (api, id) {
      downloadAsset(api, id)
    }
  }
});

/**
 * Created by Singh on 4/26/2018.
 * Filename: src/app/quote/directives/saveProgress.js
 */
angular.module('app.quote').directive('saveProgress', function (defaultApiService,
                                                                quoteModelService,
                                                                $rootScope,
                                                                itemConfigurationService,
                                                                notificationService,
                                                                itemSummaryService,
                                                                deliveryMethodService,
                                                                recipientInfoService,
                                                                genericQuotesService,
                                                                convertQuoteService,
                                                                pageNumberValidator) {
    return {
      restrict: 'EA',
      replace: false,

      link: function (scope) {

        //Check whether delivery is validate then set the flag accordingly
        function deliveryValidation() {
          if (scope.item.shippingMethodName == 20 && !deliveryMethodService.isQuantityNumber() && !deliveryMethodService.isQuantityEmpty() && (scope.shipToRecipients.length == recipientInfoService.getRecipientInfo().length)) {
            scope.item.isDeliveryInfoValid = true;
          }
          else if (scope.item.shippingMethodName == 10 && scope.item.customerSelectedStoreId) {
            scope.item.isDeliveryInfoValid = true;
          }
          else {
            scope.item.isDeliveryInfoValid = false;
          }
        }

        //Check whether current component is valid then set the flag accordingly
        function componentValidation() {
          if (genericQuotesService.validateContainer('stepTwoForm', 'componentSection')) {
            if (scope.component.itemComponentType == 2) {
              pageNumberValidator.initializeAll();
              pageNumberValidator.isValid(scope.component.material.pageNumbers);
              if (scope.component.material.pageCount != pageNumberValidator.getCountFromPageNumbers()) {
                pageNumberValidator.initializeAll();
                scope.component.isComponentInfoValidated = false;
                scope.item.isItemInfoValidated = false;
              } else {
                scope.component.isComponentInfoValidated = true;
              }
            } else
              scope.component.isComponentInfoValidated = true;
          }
          else {
            scope.component.isComponentInfoValidated = false;
          }
        }

        //Check whether current item is valid then set the flag accordingly
        function itemValidation() {
          if (genericQuotesService.validateForm('stepTwoForm')) {
            (scope.component.isComponentInfoValidated) ? scope.item.isItemInfoValidated = true : scope.item.isItemInfoValidated = false;
          }
          else {
            scope.item.isItemInfoValidated = false;
          }
        }

        // saving quote
        scope.saveProgress = function () {
          scope.item.itemName = angular.element('#txtItemName').val();
          deliveryValidation();
          componentValidation();
          itemValidation();

          //TODO: JSS : Temporary Fix for One recipient
          //Remove this logic for multi recipients
          _.forEach(itemConfigurationService.getAllItems(), function (item) {
            item.shipToQuantity = [];
          });
          quoteModelService.setItems();
          angular.element('#stepTwoForm').data('formValidation').resetForm();
          var quoteData = quoteModelService.getQuoteModel();
          if (quoteData.items) {
            _.filter(quoteData.items, function (item) {
              if (item.itemVariationCosts)
                delete item.itemVariationCosts;
              if (item.validationResponse)
                delete item.validationResponse;
            });
          }
          $rootScope.startSpinner();
          defaultApiService.createObjectCall('Quotes/SaveProgress', quoteData)
            .success(function (data) {
              $rootScope.isWarningEnabled = false;
              scope.item.isItemInfoValidated = true;
              scope.component.isComponentInfoValidated = true;
              quoteModelService.setQuoteId(data.quoteId);
              itemSummaryService.setQuoteNumber(data.quoteHeader.quoteNumber);
              quoteModelService.setAuditInfo(data.quoteHeader);
              scope.updateQuoteNumber();
              $rootScope.stopSpinner();
              scope.partialQuoteData = data.quoteHeader;
              convertQuoteService.setManipulateQuoteData(scope.partialQuoteData);
              scope.quoteData = convertQuoteService.getManipulatedQuoteData();
              $rootScope.$broadcast('valueChanged', data);
              notificationService.notifySaveSuccess($rootScope.getWord('Quote') + ' #' + data.quoteHeader.quoteNumber);
              scope.setLastModifiedUser();
            })
        }
      }
    }
  }
);


/**
 * Created by Singh on 11/1/2017.
 * Filename: src/app/quote/directives/wizardStepOne.js
 */
angular.module('app.quote').directive('quotesHeader', function (quoteHeaderService, itemSummaryService, $rootScope, $state, convertQuoteService, $stateParams, genericQuotesService, quotesInfoService, quoteModelService, $filter, quoteListService, userRolesService) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/quote/partials/quotesHeader.tpl.html',

            link: function (scope) {

                /** ///////////////////////////////////// **/
                /** Initialise Data
                 /** ///////////////////////////////////// **/
                scope.quoteData = {};
                scope.termDisable = false;
                scope.convertQuoteFlag = false;
                scope.convertReviewFlag = true;
                scope.quoteStatusEnums = quoteListService.getQuoteStatusByEnums();
                scope.enableConvert = false;

                scope.users = userRolesService.getUserNames();

                if (!$stateParams.id)
                    itemSummaryService.setQuoteNumber();
                scope.partialQuoteData = {};
                scope.partialQuoteData = itemSummaryService.getQuoteHeaderData() || quoteModelService.getQuoteModel().header;
                scope.partialQuoteData.quoteSubTotal = scope.partialQuoteData.hasOwnProperty('quoteSubTotal') && _.isNumber(scope.partialQuoteData.quoteSubTotal)
                    ? Number(scope.partialQuoteData.quoteSubTotal.toFixed(2)) : $rootScope.getWord('SubtotalNotCalculated');
                scope.partialQuoteData.vendorTotal = scope.partialQuoteData.hasOwnProperty('vendorTotal') && _.isNumber(scope.partialQuoteData.vendorTotal)
                    ? Number(scope.partialQuoteData.vendorTotal.toFixed(2)) : $rootScope.getWord('VendorTotalNotCalculated');

                /** ///////////////////////////////////// **/
                /** Binding Quote Header for convert Quote
                 /** ///////////////////////////////////// **/
                scope.quoteHistoryId = itemSummaryService.getQuoteId() || quoteModelService.getQuoteId() || null;
                if ($state.current.url.indexOf('convertQuote') >= 0) {
                    //For View Only
                    if ($stateParams.viewOnly) {
                        scope.readOnly = true;
                        if (scope.partialQuoteData.status == scope.quoteStatusEnums.converted) {
                            scope.convertActionsFlag = true;
                        }
                    } else {
                        scope.readOnly = false;
                        scope.convertActionsFlag = false;
                        if (scope.partialQuoteData.status == scope.quoteStatusEnums.created) {
                            scope.enableConvert = true;
                            scope.convertActionsFlag = true;
                        }
                    }// View Only Ends
                    scope.convertQuoteFlag = true;
                    scope.summary = itemSummaryService.getSummaryData();
                    scope.orderNumber = scope.summary.convertQuoteInfo ? scope.summary.convertQuoteInfo.orderNumber : '';
                    scope.facilityName = (scope.summary.convertQuoteInfo && scope.summary.convertQuoteInfo.orderServiceResponse) ? scope.summary.convertQuoteInfo.orderServiceResponse.facilityName : '';
                    itemSummaryService.setSummaryData(scope.summary);
                    scope.partialQuoteData = itemSummaryService.getQuoteHeaderData();
                    if (scope.partialQuoteData)
                        convertQuoteService.setManipulateQuoteData(scope.partialQuoteData);
                    scope.quoteData = convertQuoteService.getManipulatedQuoteData();
                    scope.versionNumber = $rootScope.getWord('V.') + scope.quoteData.versionNumber;
                    // scope.quoteUser = {
                    //   "login": scope.quoteData.lastModifiedByUserName
                    // };
                    scope.customerId = convertQuoteService.getCustomerData().customerId;
                    scope.editCustomerForConvert = function (customerId, quoteId) {
                        $state.go('app.quote.editCustomer', {id: customerId, quoteId: quoteId, quoteState: 'convertQuote'})
                    };

                    // Hide the Edit Customer for Review Quote
                    if ($state.current.url.indexOf('convertQuoteReview') >= 0) {
                        scope.convertReviewFlag = false;
                    }
                }

                /** ///////////////////////////////////// **/
                /** Binding Quote Number **/
                /** ///////////////////////////////////// **/
                scope.quoteNumber = itemSummaryService.getQuoteNumber();
                scope.quoteNumberLabel = scope.quoteNumber ? $rootScope.getWord('Quote') + ' #' + scope.quoteNumber : $rootScope.getWord('NewQuote');

                scope.updateQuoteNumber = function () {
                    scope.quoteNumber = itemSummaryService.getQuoteNumber();
                    scope.quoteNumberLabel = scope.quoteNumber ? $rootScope.getWord('Quote') + ' #' + scope.quoteNumber : $rootScope.getWord('NewQuote');
                };


                if ($stateParams.id) {
                    scope.updateQuoteNumber();
                }

                if ($stateParams.id && $stateParams.toStep == '2') {
                    scope.quoteData = quotesInfoService.getStepOneData();
                    scope.versionNumber = $rootScope.getWord('V.') + scope.quoteData.versionNumber;
                }

                scope.setLastModifiedUser = function () {
                    scope.quoteUser = {
                        "login": quoteModelService.getHeaderAuditInfo() ? quoteModelService.getHeaderAuditInfo().lastModifiedByUserName : $rootScope.user ? $rootScope.user.login : ''
                    };
                };
                scope.setLastModifiedUser();

                /** ///////////////////////////////////// **/
                /** Binding Form Data with Quote Header Data **/
                /** ///////////////////////////////////// **/
                scope.$on('valueChanged', function (e, data) {
                    scope.quoteData = quoteHeaderService.getQuoteData();
                    scope.versionNumber = (scope.quoteData.quoteData && scope.quoteData.quoteData.header && scope.quoteData.quoteData.header.versionNumber) ? $rootScope.getWord('V.') + scope.quoteData.quoteData.header.versionNumber : '';
                    if (data && data.quoteHeader) {
                        scope.partialQuoteData = data.quoteHeader;
                        scope.partialQuoteData.quoteSubTotal = scope.partialQuoteData.hasOwnProperty('quoteSubTotal') && _.isNumber(scope.partialQuoteData.quoteSubTotal)
                            ? Number(scope.partialQuoteData.quoteSubTotal.toFixed(2)) : $rootScope.getWord('SubtotalNotCalculated');
                        scope.partialQuoteData.vendorTotal = scope.partialQuoteData.hasOwnProperty('vendorTotal') && _.isNumber(scope.partialQuoteData.vendorTotal)
                            ? Number(scope.partialQuoteData.vendorTotal.toFixed(2)) : $rootScope.getWord('VendorTotalNotCalculated');
                    }
                    scope.quoteStatus = quoteHeaderService.getQuoteStatus(scope.partialQuoteData.status);
                    setDates();
                    scope.setLastModifiedUser();
                });

                /** ///////////////////////////////////// **/
                /** Quote Terms Enum values Data          **/
                /** ///////////////////////////////////// **/
                try {
                    scope.quoteTerms = quoteHeaderService.populateEnums();
                    scope.quoteTerm = scope.quoteTerms[0].value;
                } catch (e) {
                }

                scope.disableAutoFill = function (id) {
                    angular.element('#' + id).attr("autocomplete", "nope");
                    return true;
                };

                /** ///////////////////////////////////// **/

                /**       Quote Header Dates              **/
                /** ///////////////////////////////////// **/
                function setDates() {
                    var auditInfo = quoteModelService.getHeaderAuditInfo();
                    scope.quoteData.createDate = auditInfo.createdDate || scope.quoteData.createDate;
                    scope.quoteData.modifiedDate = auditInfo.lastModifiedDate || scope.quoteData.modifiedDate;
                    scope.createdDate = (scope.quoteData.createDate) ? $filter('localDateTimeFilter')(scope.quoteData.createDate) : moment().format('L') + ' ' + moment().format('LT');
                    scope.modifiedDate = (scope.quoteData.modifiedDate) ? $filter('localDateTimeFilter')(scope.quoteData.modifiedDate) : moment().format('L') + ' ' + moment().format('LT');
                    scope.quoteTerm = quoteModelService.getHeader().term ? quoteModelService.getHeader().term.toString() : scope.quoteTerm;
                }

                setDates();

                scope.changeTerm = function () {
                    quoteModelService.setMiscellaneousData({term: scope.quoteTerm});
                };

                /** ///////////////////////////////////// **/
                /** Quote Source Enum values Data         **/
                /** ///////////////////////////////////// **/
                scope.quoteSources = quoteHeaderService.getQuoteSourcesEnum();

                /** ///////////////////////////////////// **/
                /** Quote History Logic                   **/
                /** ///////////////////////////////////// **/
                scope.quoteHistoryList = function (quoteId) {
                    scope.quoteSpecificId = quoteId;
                    $state.go('app.quote.quoteHistory', {quoteId: quoteId});
                };

                /** ///////////////////////////////////// **/
                /** Quote Status                          **/
                /** ///////////////////////////////////// **/
                scope.$watch('quoteData', function (newValue, oldValue) {
                    if (scope.partialQuoteData) {
                        scope.quoteStatus = quoteHeaderService.getQuoteStatus(scope.partialQuoteData.status)
                    } else {
                        scope.quoteStatus = '<span class="label label-success status-label">' + $rootScope.getWord('InProgress').toUpperCase() + '</span>';
                    }
                });
            }
        }
    }
);


/**
 * Created by Srikanth on 10/23/2018.
 * Filename: src\app\quote\directives\quoteWarningBanner.js
 */

angular.module('app.quote').directive('quoteWarningBanner', function () {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/quoteWarningBanner.html',

    link: function (scope) {
      scope.warningArray = [];
      scope.warningBannerFn = function (warningData) {
        scope.warningArray = warningData;
        if (scope.warningArray.length >= 1) {
          angular.element('#warning-banner').removeClass('hide')
        }
        else {
          angular.element('#warning-banner').removeClass('show')
        }
      };

      scope.closeWarningAlert = function () {
        angular.element('#warning-banner').removeClass('show');
        angular.element('#warning-banner').addClass('hide')
      }
    }
  }
});

/**
 * Created by Srikanth on 4/16/2018.
 * Filename: src\app\quote\directives\quoteCreateErrorBadge.js
 */

angular.module('app.quote').directive('quoteCreateErrorBadge', function () {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/quote/partials/quoteCreateErrorBadge.html',

    link: function (scope) {
      scope.errorArr = [];
      scope.errorBadgeFn = function (errorData) {
        scope.errorArr = errorData;
        if (scope.errorArr.length >= 1) {
          angular.element('#quantity-error-badge').removeClass('hide')
        }
        else {
          angular.element('#quantity-error-badge').removeClass('show')
        }
      };

      scope.closeAlert = function () {
        angular.element('#quantity-error-badge').removeClass('show');
        angular.element('#quantity-error-badge').addClass('hide')
      }
    }
  }
});

/**
 * Created by Srikanth Reddy Anugu on 5/10/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\quote\controllers\quoteHistoryCtrl.js
 */

angular.module('app.quote').controller('quoteHistoryCtrl', function ($scope, $rootScope, $compile, data, $filter, $state, $stateParams, genericQuotesService, quoteModelService, userRolesService) {

  var quoteHistoryList = data.quoteHistoryList;
  var currentVersion = _.maxBy(quoteHistoryList, function (o) {
    return o.version;
  });

  $scope.options = {
    data: quoteHistoryList,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    "sDom": '<"dt-toolbar"<"pageLengthDrpDwn"l>>' + 't' + '<"dt-toolbar-footer"<"col-sm-6 col-xs-12 hidden-xs"i><"col-xs-12 col-sm-6"p>>',
    order: [],
    columns: [
      {
        "mDataProp": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var stringifyIdVar = "'" + full.id + "'";
          var currentVersionHtml;
          currentVersionHtml = full.version == currentVersion.version ? $rootScope.getWord('Current-V.') + full.version : $rootScope.getWord('V.') + full.version;
          return full.version ? '<b><a ng-click="goToQuoteVersion(' + stringifyIdVar + ', ' + full.version + ')"><span>' + currentVersionHtml + '</span></a></b>' : '';
        }
      },
      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          return full.lastModifiedDate ? '<span>' + $filter('localDateTimeFilter')(full.lastModifiedDate) + '</span>' : '';
        }
      },
      {
        "mData": "",
        "bSortable": false,
        'sClass': 'text-center',
        "mRender": function (data, type, full) {
          return full.lastModifiedByUserName ? '<span>' + full.lastModifiedByUserName + '</span>' : '';
        }
      },
      {
        "className": "col-action",
        "bSearchable": false,
        "bSortable": false,
        "mRender": function (data, type, full) {
          if (full.version != currentVersion.version) {
            var commandTypes = [3];
            //TODO: Uncomment depending on the release scope
            !($rootScope.user.userRole == userRolesService.getUserNames().Coa) ? commandTypes.push(8) : '';
            var labels = {
              deleteLabel: $rootScope.getWord('Delete'),
              costedSummaryReportLabel: $rootScope.getWord('DownloadCostedSummaryReport'),
              costedDetailedReportLabel: $rootScope.getWord('DownloadCostedDetailedReport')
            };
            var btnName = $rootScope.getWord('Restore');
            return $scope.tableDropdownActions(full.id, full.version, full.readOnly, commandTypes, labels, btnName);
          } else {
            return '';
          }
        }
      }
    ]
  };

  $scope.goToQuoteVersion = function (versionId, versionNumber) {
    quoteModelService.setReadOnlyFlag(true, versionNumber);
    genericQuotesService.setLegitStateChange(false);
    var currentVersion = _.maxBy(quoteHistoryList, function (o) {
      return o.version;
    });
    if (versionNumber == currentVersion.version) {
      $state.go('app.quote.createQuote.step_one', {id: $stateParams.quoteId || $stateParams.id});
    }
    else
      $state.go('app.quote.createQuote.step_one', {
        id: $stateParams.quoteId,
        versionId: versionId,
        viewQuote: 'viewQuote'
      });
  };

  $scope.defaultButtonAction = function (id, name) {
    $scope.showModal(id, name);
  };

  $scope.deleteItem = function (id, itemName, version) {
    $scope.confirmText = $rootScope.getWord("DeleteVersion");
    $scope.deleteTitle = $rootScope.getWord("DeleteVersionTitle");
    $scope.deleteMessage = $rootScope.getWord("DeleteVersionMessage");
    $scope.confirmDelete(id, version, true);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    genericQuotesService.deleteQuoteVersion(id, itemName);
  };

  $scope.goToCurrentVersion = function () {
    $state.go('app.quote.createQuote.step_one', {id: $stateParams.quoteId || $stateParams.id});
  };

  /***********************************************************************************************
   * Download Reports
   **********************************************************************************************/
  $scope.downloadCostedSummaryReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteSummaryReportWithVersion', id)
  };

  $scope.downloadCostedDetailedReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteDetailedReportWithVersion', id)
  };
  // Reports Logic Ends

  $scope.actionSubmitModal = function (id) {
    angular.element('#genericModal').removeClass('fade');
    angular.element('#genericModal').modal('hide');
    genericQuotesService.setLegitStateChange(false);
    $state.go('app.quote.createQuote.step_one', {id: $stateParams.quoteId, versionId: id, restore: true})
  };

  $rootScope.$on('$stateChangeStart', function (ev, toState, toParams, from) {
    if (toState.name == 'app.quote.createQuote.step_one' && from && (from.name == 'app.quote.list')) {
      quoteModelService.setReadOnlyFlag(false, '');
    }
  });

});

/**
 * Created by Singh on 10/31/2017.
 */
angular.module('app.quote').controller('quoteEditCtrl', function (manageStatesService,
    wizardNavigationService,
    $scope,
    $location,
    quotesInfoService,
    $state,
    data,
    $rootScope,
    quoteHeaderService,
    genericQuotesService,
    componentTabService,
    multiComponentService,
    deliveryMethodService,
    itemConfigurationService,
    quoteModelService,
    itemSummaryService,
    defaultApiService,
    notificationService,
    $stateParams,
    recipientInfoService,
    userRolesService,
    $compile) {

    // Initialise data
    wizardNavigationService.initializeNavProperties();
    quotesInfoService.initializeStepOne();
    $scope.navProperties = wizardNavigationService.getNavProperties();
    manageStatesService.setLegitAction(false);
    var navigationStepEnums = wizardNavigationService.getNavigationStepEnums();
    quoteHeaderService.initializeQuotesData();
    quoteHeaderService.setHeaderData(data);

    // Read Only flag for View
    $scope.readOnly = !!($stateParams.viewQuote && $stateParams.versionId);
    $scope.quotehistoryFlag = $stateParams.id && $stateParams.viewQuote && $stateParams.versionId;
    $scope.createBreadcrumb = ($stateParams.viewQuote && $stateParams.versionId) ? $rootScope.getWord('ViewQuote') : $rootScope.getWord('CreateQuote');

    $scope.productEnums = genericQuotesService.getProductEnums();
    /** ///////////////////////////////////// **/
    /** Action Performed on Cancel Button Click **/
    /** ///////////////////////////////////// **/
    $scope.isCancelled = false;
    $scope.toRouteToParam = '';

    /** ///////////////////////////////////// **/
    /** User note section here start           **/
    /** ///////////////////////////////////// **/
    $scope.userNoteList = data.userNotes || [];
    $scope.userNoteCount = data.userNotes.length;
    $scope.username = userRolesService.getSystemUser().username;

    var dtInstance;
    $scope.options = {
        data: $scope.userNoteList,
        fnCreatedRow: function (nRow) {
            $compile(angular.element(nRow))($scope);
        },
        // This is added so that we maintain the default ordering.
        order: [[0, 'desc']],
        columns: [
            {
                mDataProp: "createdDate",
                render: function (data) {
                    if (!data) return '';
                    const date = new Date(data);
                    const options = {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    };

                    const formatted = date.toLocaleString('en-US', options);
                    const splitParts = formatted.split(', ');
                    const datePart = splitParts[0];
                    const timePart = splitParts[1];
                    return '<div>' + datePart + '<br/><strong>' + timePart + '</strong></div>';
                }
            },
            {
                "mDataProp": "createdByUserName"
            },
            {
                mDataProp: "userNote",
                render: function (data, type, row, meta) {
                    if (!data) return '';

                    const index = meta.row;
                    const collapseId = 'viewUserNotesModal';
                    const shortText = data.substring(0, 200).replace(/"/g, '&quot;');
                    const fullText = data.replace(/"/g, '&quot;');
                    const isLong = data.length > 200;

                    if (!isLong) {
                        return "<div>" + fullText + "</div>";
                    }

                    return '<div>' +
                        '<div class="note-preview" id="preview_' + index + '">' +
                        shortText + '...' +
                        '</div>' +
                        '<div id="' + collapseId + '" class="collapse">' +
                        fullText +
                        '</div>' +
                        '<a href="" ng-click="openNoteInModal(userNoteList[' + index + '])">View More</a>' +
                        '</div>';

                }
            },
        ],
        dom: 'lrtip',
        language: {
            emptyTable: "There are no notes to show"
        },
        initComplete: function (settings, json) {
            dtInstance = $('#userNotesTable').DataTable(); // make sure to use your actual table ID
        }
    };

    $scope.resetNoteForm = function () {
        $scope.newNotes = '';
    };

    /** ///////////////////////////////////// **/
    /** User note section here end            **/
    /** ///////////////////////////////////// **/



    $scope.cancelForm = function (quote) {
        $scope.quoteDetails = '';
        if (!$scope.readOnly) {
            $scope.isCancelled = false;
            $scope.confirmCancel();
            if (quote) $scope.quoteDetails = quote;
            angular.element('#cancelModal').modal('show');
        } else {
            $scope.isCancelled = true;
            $state.go('app.quote.list');
        }
    };

    $scope.cancelOnConfirm = function () {
        angular.element('#cancelModal').removeClass('fade');
        angular.element('#cancelModal').modal('hide');
        if (!$scope.isCancelled) {
            $scope.isCancelled = true;
            ($scope.toRouteToParam) ? ((!$scope.quoteDetails) ? $state.go($scope.toRouteToParam) : $state.go($scope.toRouteToParam, $scope.quoteDetails)) : $state.go('app.quote.list');
        } else {
            $state.go('app.quote.list');
        }
    };

    /** ///////////////////////////////////// **/
    /** Finish Quote Create Functionality     **/
    /** ///////////////////////////////////// **/
    $scope.finishQuoteCreate = function (goToCovertQuote) {
        $rootScope.startSpinner();
        var finishQuoteObj = {};
        finishQuoteObj.quoteId = itemSummaryService.getQuoteId();
        defaultApiService.createObjectCall('Quotes/CreateQuote', finishQuoteObj)
            .success(function (data) {
                $rootScope.stopSpinner();
                $scope.isCancelled = true;
                notificationService.notifyQuoteCreateSuccess(data.quoteHeader.quoteNumber);
                if (goToCovertQuote)
                    $state.go('app.quote.convertQuote', { quoteId: finishQuoteObj.quoteId });
                else {
                    $state.go('app.quote.list');
                }
            }).error(function () {
                $rootScope.stopSpinner();
                notificationService.notifyQuoteCreateError("Quote");
            });
    };

    /** ///////////////////////////////////// **/
    /** Check whether Coa Manager or not     **/
    /** ///////////////////////////////////// **/
    $scope.users = userRolesService.getUserNames();

    /** ///////////////////////////////////// **/
    /** Action Performed on Wizard step Click **/
    /** ///////////////////////////////////// **/
    $scope.clickDataStep = function (step) {
        $scope.closeAlert();
        $scope.closeWarningAlert();
        if (step != wizardNavigationService.getCurrentState()) {
            manageStatesService.setLegitPreviousAction(true);
            manageStatesService.setLegitAction(true);
            var currentSate = wizardNavigationService.getCurrentState();
            if (currentSate == navigationStepEnums.addItems) {
                if (genericQuotesService.validateContainer('stepTwoForm', 'componentSection')) {
                    multiComponentService.validateCurrentTab();
                }
            }
            // Logic to set data for the tab going to
            switch (step) {
                case navigationStepEnums.quoteInformation:
                    break;
                case navigationStepEnums.addItems:
                    break;
                case navigationStepEnums.quoteReview:
                    break
            }
            if (step < currentSate) {
                wizardNavigationService.setCurrentState(step);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
            }
        }
    };

    /** ///////////////////////////////////////// **/
    /** Action Performed on Previous button Click **/
    /** ///////////////////////////////////////// **/
    $scope.goPrevious = function (state) {
        $scope.closeAlert();
        manageStatesService.setLegitAction(true);
        manageStatesService.setLegitPreviousAction(true);
        var currentSate = wizardNavigationService.getCurrentState();
        if (currentSate == navigationStepEnums.addItems) {
            if (genericQuotesService.validateContainer('stepTwoForm', 'componentSection')) {
                multiComponentService.validateCurrentTab();
            }
        }
        switch (state) {
            case 1:
                $location.path('/index/quoteEdit/step_one/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
                wizardNavigationService.setCurrentState(1);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
                break;
            case 2:
                manageStatesService.setGoToPrevious(true);
                deliveryMethodService.initializeShipToRecipients();
                $location.path('/index/quoteEdit/step_two/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
                wizardNavigationService.setCurrentState(2);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
                break;
            case 3:
                $location.path('/index/quoteEdit/step_three/' + $stateParams.id + '/' + $stateParams.viewQuote + '/' + $stateParams.versionId);
                wizardNavigationService.setCurrentState(3);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
                break;
        }
    };

    if ($stateParams.id) {
        var quoteData = data.quoteData;
        quoteModelService.setQuoteModel(quoteData);
        quoteModelService.setQuoteHeader(quoteData.quoteHeader);
        var items = quoteData ? quoteData.items : [];
        itemConfigurationService.setAllItems(items);
        var quoteHeader = quoteData ? quoteData.header : {};
        quotesInfoService.setupStepOne(quoteHeader);
        itemSummaryService.setQuoteNumber(quoteData.header.quoteNumber);
    }

    function difference(object, base) {
        function changes(object, base) {
            return _.transform(object, function (result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }

        return changes(object, base);
    }

    /** ///////////////////////////////////////////////**/
    /** Enable leave quote warning after save progress **/
    /** ////////////////////////////////////////////// **/
    angular.element(document).on("click", function () {
        setTimeout(function () {
            $rootScope.isWarningEnabled = true;
        }, 600)
    });

    /** ///////////////////////////////**/
    /** Controls the routing of wizard **/
    /** ////////////////////////////// **/
    $scope.$on('$stateChangeStart', function (event, toState, toParams, from, previous) {
        // Logic to pop-up modal confirmation while leaving quote during configuration
        if ((from.name.indexOf('app.quote.createQuote.step_two') >= 0 || from.name.indexOf('app.quote.createQuote.step_one') >= 0 || from.name.indexOf('app.quote.createQuote.step_three') >= 0) && (toState.name.indexOf('app.quote.createQuote.step_one') == -1 && toState.name.indexOf('app.quote.createQuote.step_three') == -1 && toState.name.indexOf('app.quote.createQuote.step_two') == -1 && toState.name.indexOf('logout') == -1)) {
            if (!$scope.readOnly && !$scope.isCancelled) {
                $scope.toRouteToParam = toState.name;
                // Check route from step one with any changes
                if (from.name.indexOf('app.quote.createQuote.step_one') >= 0) {
                    var diffFound = difference(quoteHeaderService.getQuoteData(), $scope.watchObject);
                    var stepOneChangeCount = 0;
                    for (var i in diffFound) {
                        stepOneChangeCount++;
                    }
                    if (stepOneChangeCount > 0) {
                        if (toState.name.indexOf('app.quote.quoteHistory') >= 0) {
                            $scope.cancelForm({ quoteId: $scope.quoteSpecificId });
                        } else if (toState.name.indexOf('app.quote.editCustomer') >= 0) {
                            $scope.cancelForm(quotesInfoService.getDetailsForParams());
                        } else
                            $scope.cancelForm();
                    } else return;
                    // Check route from step two with any changes
                } else if (from.name.indexOf('app.quote.createQuote.step_two') >= 0) {
                    var realityCheck = difference(quoteModelService.getCustomerInfo(), $scope.watchStep2Object);
                    var stepTwoChangeCount = 0;
                    for (var i in realityCheck) {
                        stepTwoChangeCount++;
                    }
                    if (stepTwoChangeCount > 0 && ($rootScope.isWarningEnabled)) {
                        if (toState.name.indexOf('app.quote.quoteHistory') >= 0) {
                            $scope.cancelForm({ quoteId: $scope.quoteSpecificId });
                        } else $scope.cancelForm();
                    } else return;
                    // Check route from step three with any changes
                } else if (from.name.indexOf('app.quote.createQuote.step_three') >= 0) {
                    $scope.cancelForm();
                }
                event.preventDefault();
            }
        }

        //if parent state stays same
        // For IE do This
        if (from.name.indexOf('app.quote.createQuote') >= 0 && toState.name.indexOf('app.quote.createQuote') >= 0) {
            if (previous.id && !toParams.id) {
                location.reload();
            }
            // if (from.name.includes('app.quote.createQuote') && toState.name.includes('app.quote.createQuote')) {
            //Identify the from and to state
            manageStatesService.executeRouting(event, toState, toParams, from);
            //Check legit action
            if (manageStatesService.preventAdvancedStep()) {
                event.preventDefault();
            } else {
                var currentState = wizardNavigationService.getCurrentState();
                wizardNavigationService.setCurrentState(currentState);
                wizardNavigationService.disableAllNavs();
                wizardNavigationService.setNav();
            }
        }
        manageStatesService.setLegitAction(false);
    });

    $scope.restoreQuote = function (id, name) {
        $scope.showModal(id, name);
    };

    $scope.$on('$stateChangeSuccess', function (ev, toState, toParams, from) {
        if (from.name.indexOf('app.quote.createQuote') >= 0 && toState.name.indexOf('app.quote.createQuote') < 0) {
            itemConfigurationService.initializeItems();
            multiComponentService.initializeMultiComponent();
            itemConfigurationService.setCurrentItemIndex(0);
            componentTabService.initializeComponentTabs();
            quoteModelService.setQuoteId(null);
            quoteModelService.initializeQuoteModel();
            quoteModelService.setQuoteInterrupted(true);
            quoteModelService.initializeHeader();
            recipientInfoService.initializeRecipientInfo();
            if (toState.name.indexOf('app.quote.convertQuote') < 0)
                itemSummaryService.initializeSummaryData();
            genericQuotesService.setVersionId('');
            genericQuotesService.setViewQuote('');
        }

        // Disable terms on step three
        $scope.termDisable = toState.url.indexOf('step_three') >= 0;
    });
    // if(!$stateParams.createItem && !$stateParams.editItem)
    // $location.path('/index/quoteEdit/step_one/'+$stateParams.id);
    setTimeout(function () {
        $scope.watchObject = Object.assign({}, quoteHeaderService.getQuoteData());
        $scope.watchStep2Object = angular.copy(quoteModelService.getCustomerInfo());
    }, 600);

    $scope.openNoteInModal = function (noteData) {
        $rootScope.selectedNote = noteData;
        $('#viewUserNotesModal').modal('show');
    };
});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\products\controllers\productsCtrl.js
 */

angular.module('app.quote').controller('quoteCtrl', function ($scope, $state, dtEncoder, $compile, defaultApiService, propertyValidationService, $rootScope, toaster, data, chipService, quoteListService, $filter, itemSummaryService, convertQuoteService, userRolesService, genericQuotesService) {

  $scope.object = 'Quotes';
  var localStorageData = sessionStorage.getItem('DataTables_Filtered_' + $scope.object + window.location.pathname);
  $scope.searchedObj = JSON.parse(localStorageData);
  if (!_.isEmpty(data.currentUser)) {
    userRolesService.initSystemUser(data.currentUser);
  }

  /***********************************************************************************************
   * Initialisation of selected variations and item index
   **********************************************************************************************/
  convertQuoteService.initSelectedVariationsArray();
  itemSummaryService.initItemIndex();

  /***********************************************************************************************
   * Initialising table columns
   **********************************************************************************************/
  $scope.tableColumns = ["QuoteNumber", "source", "quoteStatus", "customer", "LastModifiedByUserName", "LastModifiedDate"];

  /***********************************************************************************************
   * Initialisation and Localisation of Enums
   **********************************************************************************************/
  $scope.pageLength = 10;
  $scope.customEnable = true;
  $scope.dataTablePageLength = $scope.pageLength.toString();
  $scope.sourceEnumValues = data.quoteSource;
  $scope.statusEnumValues = data.quoteStatus;
  $scope.multiSelectOptions = [];
  $scope.source_array = [];
  $scope.status_array = [];
  $scope.lastModify_array = [];
  $scope.dateModified_array = [];
  $scope.quoteStatusEnums = quoteListService.getQuoteStatusByEnums();
  $scope.searchTooltipText = $rootScope.getWord('searchInfo');

  /***********************************************************************************************
   * DropDown Options Bindings with Api Call Response
   **********************************************************************************************/
  quoteListService.setListData(data);
  $scope.quoteListData = data;

  /***********************************************************************************************
   * PAGE LENGTH FUNCTIONALITY
   **********************************************************************************************/
  $scope.changePageLength = function () {
    $scope.pageLength = parseInt($scope.dataTablePageLength);
    var customersTable = angular.element('#quoteListDatatable').dataTable();
    customersTable.fnDraw();
  };


  /***********************************************************************************************
   * Data table Bindings
   **********************************************************************************************/
  $scope.options = {

    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    order: [[$scope.tableColumns.indexOf("LastModifiedDate"), 'desc']],
    columns: [
      {

        "mData": "",
        "mRender": function (data, type, full) {
          var quoteId = "'" + full.id + "'";
          var html = '';
          html += full.quoteNumber ? '<b><a ng-click="viewItem(' + quoteId + ')"><span>' + full.quoteNumber + '</span></a></b><br/>' : '';
          html += full.projectDescription ? '<span>' + full.projectDescription + '</span>' : '';
          return html;
        }
      },

      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var html = '';
          html += full.referenceNumber ? '<span>' + full.referenceNumber + '</span><br/>' : '';
          html += full.sourceName ? '<span>' + full.sourceName + '</span>' : '';
          return html;
        }
      },
      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var statusEnum = $scope.statusEnumsLocalised[full.quoteStatus];
          var statusValue = full.quoteStatus;
          var btnValue = '';
          switch (statusValue) {
            case 10 :
              btnValue = '<span class="label label-success">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 20 :
              btnValue = '<span class="label label-warning">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 30 :
              btnValue = '<span class="label label-primary">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 40 :
              btnValue = '<span class="label label-danger">' + statusEnum.toUpperCase() + '</span>';
              break;
            case undefined:
              btnValue = "";
              break;
          }
          if (statusEnum === "" || statusValue === "") {
            return "";
          } else
            return btnValue
        }
      },
      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var fullName = full.billToName ? full.billToName : '';
          var accountNumber = full.accountNumber ? full.accountNumber : '';
          var companyName = full.billToCompanyName ? full.billToCompanyName : '';
          var stringifyIdVar = "'" + full.customerId + "'";
          var html = '';
          html += fullName ? '<b><a ng-click="goToCustomerDetails(' + stringifyIdVar + ')"><span>' + fullName + '</span></a></b> <br/>' : '';
          html += accountNumber ? '<a ng-click="goToCustomerDetails(' + stringifyIdVar + ')"><span>' + accountNumber + '</span></a><br/>' : '';
          html += companyName ? '<a ng-click="goToCustomerDetails(' + stringifyIdVar + ')"><span>' + companyName + '</span></a>' : '';
          return html;
        }
      },
      {
        "mData": "",
        'sClass': 'text-center',
        "mRender": function (data, type, full) {
          var html = '';
          html = full.lastModifiedByUserName ? '<span>' + full.lastModifiedByUserName + '</span>' : '';
          return html;
        }
      },
      {
        "mData": "",
        "mRender": function (data, type, full) {
          var html = '';
          html = full.lastModifiedDate ? '<span>' + $filter('localDateTimeFilter')(full.lastModifiedDate) + '</span>' : '';
          return html;
        }
      },
      {
        "className": "col-action",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = quoteListService.getCommands(full.quoteStatus);
          var btnName = quoteListService.getDefaultButtonLabel();
          var labels = {
            viewLabel: $rootScope.getWord('View'),
            editLabel: $rootScope.getWord('ReQuote'),
            deleteLabel: $rootScope.getWord('Delete'),
            reQuoteLabel: $rootScope.getWord('Requote'),
            convertQuoteLabel: $rootScope.getWord('Convert'),
            costedSummaryReportLabel: $rootScope.getWord('DownloadCostedSummaryReport'),
            costedDetailedReportLabel: $rootScope.getWord('DownloadCostedDetailedReport'),
            convertedSummaryReportLabel: $rootScope.getWord('DownloadConvertedSummaryReport'),
            convertedDetailedReportLabel: $rootScope.getWord('DownloadConvertedDetailedReport')
          };
          return $scope.tableDropdownActions(full.id, full.quoteNumber, full.readOnly, commandTypes, labels, btnName);
        }
      }
    ]
  };

  $scope.specialCharacters = function () {
    if ($scope.searchText) {
      $scope.searchText = escape($scope.searchText);
    } else {
      $scope.searchText = '';
    }
  };

  /***********************************************************************************************
   * Reset the search filter input
   **********************************************************************************************/
  $scope.resetSearch = function () {
    $scope.searchText = '';
    $scope.searchPerformed = '';
    if ($scope.searchApplied) {
      $scope.searchApplied = false;
      var shipmentsTable = angular.element('#quoteListDatatable').dataTable();
      shipmentsTable.fnDraw();
    }
  };

  /***********************************************************************************************
   * Search bar
   **********************************************************************************************/
  $scope.searchByString = function () {
    if (propertyValidationService.isNullOrEmpty($scope.searchText)) {
      $scope.searchText = angular.element('#search-by-string')[0].value;
    }

    if ($scope.searchText) {
      $scope.specialCharacters();
      $scope.searchApplied = true;
      $scope.filterApplied = true;
      $scope.searchText = unescape($scope.searchText);
      var shipmentsTable = angular.element('#quoteListDatatable').dataTable();
      shipmentsTable.fnDraw();
    } else {
      $scope.resetSearch();
    }
  };

  /***********************************************************************************************
   * Download Reports
   **********************************************************************************************/
  $scope.downloadCostedSummaryReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteSummaryReport', id)
  };

  $scope.downloadCostedDetailedReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteDetailedReport', id)
  };

  $scope.downloadConvertedSummaryReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteSummaryReport', id)
  };

  $scope.downloadConvertedDetailedReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteDetailedReport', id)
  };

  /***********************************************************************************************
   * All Actions Logic
   **********************************************************************************************/
  $scope.goToCustomerDetails = function (id) {
    $state.go('app.customer.details', {id: id})
  };

  $scope.createNewItem = function () {
    $state.go('app.quote.createQuote.step_one');
  };

  $scope.editQuoteAction = function (id) {
    $state.go('app.quote.createQuote.step_one', {id: id});
  };

  $scope.viewItem = function (id) {
    $state.go('app.quote.convertQuote', {quoteId: id, viewOnly: 'viewOnly'});
  };

  $scope.convertQuoteAction = function (quoteId) {
    $state.go('app.quote.convertQuote', {quoteId: quoteId});
  };

  $scope.reQuote = function (quoteId) {
    quoteListService.reQuote(quoteId);
  };

  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    quoteListService.deleteQuote(id, itemName);
  };

  $scope.defaultButtonAction = function (id, objName, actionName) {
    switch (actionName) {
      case 'Edit':
        $scope.editQuoteAction(id);
        break;
      case 'View':
        $scope.viewItem(id);
        break;
      case 'Convert':
        $scope.convertQuoteAction(id);
        break;
    }
  };

  function clearStateCache() {
    localStorage.removeItem('DataTables_Filtered_Quotes' + window.location.pathname);
    localStorage.removeItem('DataTables_Quotes' + window.location.pathname);
    var quotesTable = angular.element('#quoteListDatatable').DataTable();
    quotesTable.state.clear();
  }

  $rootScope.$on('$stateChangeSuccess', function (ev, toState, toParams, from, fromParams) {
    if (toState.name === 'app.quote.list' && from && (from.name !== 'app.quote.details' && from.name !== 'app.quote.createQuote.step_one' && from.name !== 'app.quote.details')) {
      clearStateCache();
    } else if (from && from.name === 'app.quote.list' && (toState.name !== 'app.quote.details' && toState.name !== 'app.quote.createQuote.step_one' && toState.name !== 'app.quote.details')) {
      clearStateCache();
    }
    if (toState.name.indexOf("app.quote.createQuote.step_one") >= 0 && from.name == 'app.quote.list') {
      itemSummaryService.initializeSummaryData()
    }
  });

});


"use strict";

angular
  .module('app.dashboard', [])
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
        abstract: true,
        url: "/index",

        templateUrl: "app/components/common/content.html",
        data: {
          requiresLogin: true
        },
        resolve: {
          deps: function ($ocLazyLoad) {
            return $ocLazyLoad.load({
              files: [
                {
                  path: 'scripts/vendor-datatables.js'
                },
                {
                  path: 'scripts/custom.plugins.js'
                },
                {
                  path: 'scripts/lazy-load.js'
                }
              ]
            });
          }
        }

      });
    // .state('app.main', {
    //   url: "/dashboard",
    //   controller: 'dashboardController',
    //   templateUrl: "app/dashboard/views/main.html",
    //   data: { pageTitle: 'Example view' }
    // });
    $urlRouterProvider.otherwise('/index/quote');
  });

'use strict';

angular.module('app.dashboard')
  .controller('dashboardController', function ($scope,$rootScope) {

    $scope.userName = '$ingh';
    $scope.helloText=$rootScope.getWord('welcomeMessage');
    $scope.descriptionText = 'It is an application skeleton for a typical AngularJS web app. You can use it to quickly bootstrap your angular webapp projects.';
  });

/**
 * Created by $ingh on 11/7/2017.
 */

angular.module('app.customer').service('customerService', function (defaultApiService, notificationService, $state, $rootScope, $stateParams, $q) {

  var customerObj = {};
  var street1 = '';
  var countries = [];
  var states = [];
  var tabStep = 1;

  function getAddressData() {
    return {
      companyName: customerObj.companyName,
      street1: customerObj.street1,
      street2: customerObj.street2,
      city: customerObj.city,
      state: customerObj.state,
      postalCode: customerObj.postalCode,
      country: customerObj.country,
      isResidential: customerObj.isResidential ? customerObj.isResidential : false
    }
  }

  return {

    initializeCustomer: function () {
      customerObj = {}
    },
    setCustomer: function (customerData) {
      customerObj = customerData;
    },
    getCustomer: function () {
      return customerObj
    },
    setCountryStates: function (customerData) {
      countries = customerData.countries;
      states = customerData.states;
    },
    getCountries: function () {
      return countries
    },
    getStates: function () {
      return states
    },

    enableDisableAddressValidation: function (flag) {
      angular.element('#customerForm')
        .formValidation('enableFieldValidators', 'txtStreet1', flag)
        .formValidation('enableFieldValidators', 'txtStreet2', flag)
        .formValidation('enableFieldValidators', 'txtCity', flag)
        .formValidation('enableFieldValidators', 'txtZipCode', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },
    enableDisableContactValidation: function (flag) {
      angular.element('#customerForm')
        .formValidation('enableFieldValidators', 'txtPhone', flag)
        .formValidation('enableFieldValidators', 'txtExtension', flag)
        .formValidation('enableFieldValidators', 'txtEmail', flag)
        .formValidation('enableFieldValidators', 'txtWebsite', flag)
        .formValidation('enableFieldValidators', 'cboCountry', flag)
        .formValidation('enableFieldValidators', 'cboState', flag)
    },

    enableSubmitButtons: function () {
      angular.element('#btn1').attr('disabled', false);
      angular.element('#btn2').attr('disabled', false);
      angular.element('#btnSave').attr('disabled', false);
      angular.element('#btn1').removeClass('disabled');
      angular.element('#btn2').removeClass('disabled');
      angular.element('#btnSave').removeClass('disabled');
    },
    setCustomerAddress: function (addressDetail) {
      customerObj.street1 = addressDetail.street1;
      customerObj.street2 = addressDetail.street2;
      customerObj.city = addressDetail.city;
      customerObj.postalCode = addressDetail.postalCode;
      customerObj.state = addressDetail.state;
      customerObj.country = addressDetail.country;
    },
    createCustomerObject: function (createAnother) {
      return defaultApiService.createObjectCall('Customers', customerObj)
        .success(function (data) {
          var successName = customerObj.fullName ? customerObj.fullName : $rootScope.getWord('Customer');
          notificationService.notifyCreateSuccess(successName);
          if (createAnother) {
            $state.go('app.customer.list');
          }
          else
            $state.go('app.quote.createQuote.step_one');
        });
    },
    updateCustomerObject: function (id) {
      var updatedCustomerObj = {};
      var customerData = '';
      if ($stateParams.quoteId) {
        customerObj.quoteId = $stateParams.quoteId;
        customerData = defaultApiService.updateObjectCallWithQuery('Customers', customerObj, 'ConversionCustomerUpdates');
      }
      else if ($stateParams.quoteState && !customerObj.updateCustomer) {
        customerData = '';
      }
      else if (customerObj.updateCustomer || id) {
        customerData = defaultApiService.updateObjectCall('Customers', customerObj, id);
      }
      return $q.all([customerData])
        .then(function (results) {
          updatedCustomerObj = results[0] ? results[0].data : {};
          var successName = customerObj.fullName ? customerObj.fullName : $rootScope.getWord('Customer');
          notificationService.notifyEditSuccess(successName);
          return updatedCustomerObj
        });
    },
    callAddressValidation: function (id) {
      var addressData = getAddressData();
      return defaultApiService.createObjectCall('AddressValidation', addressData)
        .success(function (data) {
        })
        .error(function (data) {
        })
    },
    haveAddressDetails: function () {
      return !!(customerObj.street1 && customerObj.city && customerObj.state && customerObj.postalCode && customerObj.country && customerObj.country.toLowerCase() == 'us');
    },
    setStreet1: function () {
      street1 = customerObj.street1
    },
    getStreet1: function () {
      return street1;
    },
    setIncomingCustomerData: function (data) {
      customerObj.fullName = data.fullName;
      customerObj.accountNumber = data.accountNumber;
      customerObj.companyName = data.companyName;
    },
    saveTabStep: function (step) {
      tabStep = step;
    },
    getTabStep: function () {
      return tabStep
    },
    getStatusEnums: function (statusEnumValues) {
      var statusEnumsLocalised = [];
      _.forEach(statusEnumValues, function (statusValue, statusEnum) {
        statusEnumsLocalised[statusEnum] = $rootScope.getWord(statusValue);
      });
      return statusEnumsLocalised
    },
    getSourceEnums: function (sourceEnumValues) {
      var sourceEnumsLocalised = [];
      _.forEach(sourceEnumValues, function (statusValue, statusEnum) {
        sourceEnumsLocalised[statusEnum] = $rootScope.getWord(statusValue);
      });
      return sourceEnumsLocalised
    }
  }
});

/**
 * Created by $ingh on 11/7/2017.
 */

angular.module('app.customer').service('customerListService', function (userRolesService, $rootScope, defaultApiService, notificationService, $state) {
  var defaultButtonLabel = $rootScope.getWord('Edit');

  return {
    getDynamicButtons: function () {
      var commandTypes = [];
      switch (userRolesService.getSystemUserRoles()) {
        case null && userRolesService.isSysAdmin():
          defaultButtonLabel = 'CreateQuote';
          commandTypes.push(2);
          commandTypes.push(3);
          break;
        case userRolesService.isCoa():
          defaultButtonLabel = 'Edit';
          break;
        case userRolesService.isCoaManager():
          defaultButtonLabel = 'CreateQuote';
          commandTypes.push(2);
          commandTypes.push(3);
          break;
        case userRolesService.isEstimator():
          defaultButtonLabel = 'CreateQuote';
          commandTypes.push(2);
          break;
        case userRolesService.isEstimatorManager():
          defaultButtonLabel = 'CreateQuote';
          commandTypes.push(2);
          commandTypes.push(3);
          break;
      }
      return commandTypes;
    },
    getDefaultButtonLabel: function () {
      return defaultButtonLabel
    },
    deleteCustomer: function (id, itemName) {
      $rootScope.startSpinner();
      var table = angular.element('#customerDatatable').DataTable();//Instantiate DataTables.
      var row = table.rows(function (idx, data, node) {
        return data.id === id;
      });
      defaultApiService.deleteObjectCall('Customers', id)
        .success(function () {
          table.row(row[0]).remove().draw();
          $rootScope.stopSpinner();
          notificationService.notifyDeleteSuccess(itemName);
          $state.go('app.customer.list');
        }).error(function () {
        $rootScope.stopSpinner();
      });
    }
  }
});

/**
 * Created by Singh on 1/17/2018.
 * Filename: src/app/customer/directives/tabsHandler.js
 */
angular.module('app.customer').directive('tabsHandler', function ($rootScope, customerService) {

    return {
      restrict: 'EA',
      templateUrl: 'app/customer/partials/tabsHandler.tpl.html',
      link: function (scope, element) {

        // Change tab Functionality between Quotes and Recipients
        scope.changeTab = function (step) {
          switch (step) {
            case 1 :
              scope.activeQuotesTab = true;
              scope.activeRecipientsTab = false;
              break;
            case 2:
              scope.activeQuotesTab = false;
              scope.activeRecipientsTab = true;
              break;
          }
        };

        // Saving Tab on State Change
        $rootScope.$on('$stateChangeSuccess', function (ev, toState, toParams, from, fromParams) {
          if (toState.name == 'app.customer.details' && from && from.name == 'app.customer.recipientEdit') {
            customerService.saveTabStep(2)
          }
          else if (toState.name == 'app.customer.details') {
            customerService.saveTabStep(1)
          }
        });

        // change tab on Condition
        if (customerService.getTabStep() == 2) {
          scope.changeTab(2)
        }
        else {
          scope.changeTab(1)
        }
      }
    }
  }
);





/**
 * Created by $ingh on 11/9/2017.
 * Path: src/app/customer/directives/customerServerSideTable.js
 */

"use strict";

angular.module('app.customer').directive('customerServerSideTable', function ($compile, $rootScope, $cookies, dtEncoder) {

  var noResultsMessage = "<strong>" + $rootScope.getWord('NoResultsFound') + "</strong>";

  //Get Cookie for use with DataTable Internationalisation plug-in.
  //See options.oLanguage below where returned variable is used.
  // if ($cookies.get('_locale') != null) {
  //   var locale = "plugin/datatables-plugins/i18n/" + $cookies.get('_locale') + ".json";
  // }
  var locale = ''
  return {
    restrict: 'A',
    scope: {
      tableOptions: '='
    },

    link: function (scope, element, attributes) {
      /* // DOM Position key index //

       l - Length changing (dropdown)
       f - Filtering input (search)
       t - The Table! (datatable)
       i - Information (records)
       p - Pagination (paging)
       r - Processing
       < and > - div elements
       <"#id" and > - div with an id
       <"class" and > - div with a class
       <"#id.class" and > - div with an id and class

       Also see: http://legacy.datatables.net/usage/features
       */

      var options = {
        autoWidth: false,
        serverSide: true,
        stateSave: true,
        filter: false,

        "smartResponsiveHelper": null,
        "sDom": "<'dt-toolbar'<'#filteredContainer.col-xs-12 col-sm-6'><'col-sm-6 col-xs-12 hidden-xs no-padding'l>r>" +
        't' +
        '<"dt-toolbar-footer"<"col-sm-6 col-xs-12 hidden-xs m-t-xs"i><"col-xs-12 col-sm-6 m-t-xs"p>>',

        "fnInitComplete": function (oSettings, json) {
          //alert( 'DataTables has finished its initialisation.' );
        },

        oLanguage: {
          "sSearch": "<span class='input-group-addon input-sm'><i class='glyphicon glyphicon-search'></i></span>",
          "sLengthMenu": "_MENU_",
          "sEmptyTable": noResultsMessage,
          "sUrl": locale,
          "oPaginate": {
            "sFirst": false,
            "sLast": false,
            "sPrevious": "<strong>Previous</strong>",
            "sNext": "<strong>Next</strong>"
          }
        },
        "pagingType": "full_numbers",

        "fnHeaderCallback": function (nHead) {
          $compile(angular.element(nHead))(scope.$parent);
        },

        "fnPreDrawCallback": function () {
          // Initialize the responsive datatables helper once.
          if (!this.smartResponsiveHelper) {
            this.smartResponsiveHelper = new ResponsiveDatatablesHelper(element, {
              tablet: 1024,
              phone: 480
            });
          }
        },

        "fnRowCallback": function (nRow) {
          this.smartResponsiveHelper.createExpandIcon(nRow);
        },

        'stateSaveParams': function (oSettings, oData) {
          //// Save the filter parameters to local storage
          scope.saveFilterParamsToLocalStorage(oSettings, oData);
        },

        'stateLoadParams': function () {
          var data = localStorage.getItem('DataTables_' + scope.$parent.object + window.location.pathname);
          var stateObj = JSON.parse(data);
          if (stateObj) {
            scope.$parent.pageLength = stateObj.length;
          }
          return stateObj;
        },

        "fnDrawCallback": function (oSettings) {
          this.smartResponsiveHelper.respond();
        },

        "footerCallback": function (row, data, start, end, display) {
          var createDivId = "#" + attributes.id + "_info";
          var footerSection = angular.element(createDivId);
          //footerSection[0].outerText;
          setTimeout(function () {

            //This is only a quick fix to release 8/19/2015
            var getText = footerSection[0] ? footerSection[0].textContent : '';
            var shortenText = getText.split('(');
            if (getText)
              footerSection[0].textContent = shortenText[0];

          }, 1);

        },

        "fnServerData": function (sSource, aoData, fnCallback, oSettings) {

          /*#################################################################################################
           Support for saving state of the user from edit view to list view
           #################################################################################################*/
          if (scope.$parent.searchedObj && scope.$parent.searchedObj.length > 0) {
            for (var j = 0; j < scope.$parent.searchedObj.length; j++) {
              switch (scope.$parent.searchedObj[j].name) {
                case 'Filter':
                  scope.$parent.searchText = unescape(scope.$parent.searchedObj[j].value);
                  break;
                case 'SearchApplied':
                  scope.$parent.searchApplied = scope.$parent.searchedObj[j].value;
                  break;
              }
            }
          }

          scope.$parent.searchedObj = null;
          localStorage.setItem('DataTables_Filtered_' + scope.$parent.object + window.location.pathname, scope.$parent.searchedObj);

          ///#################################################################################################

          var sortedColumn = {};
          for (var i = 0; i < aoData.length; i++) {
            if (aoData[i].name == 'order')
              sortedColumn = aoData[i].value[0];
          }

          aoData = []; //Clear out all extra DataTables Parameters.
          aoData.push({"name": "orderBy", "value": scope.$parent.tableColumns[sortedColumn.column]});


          if (sortedColumn.dir == 'asc')
            aoData.push({"name": "descending", "value": "false"});
          else
            aoData.push({"name": "descending", "value": "true"});

          aoData.push({
            "name": "pageSize",
            "value": oSettings._iDisplayLength
          });

          /*###############################################################################################
           For displaying the correct page number
           #################################################################################################*/
          var pgIndex = Math.round(oSettings._iDisplayStart / oSettings._iDisplayLength);
          scope.$parent.pageNum = pgIndex;
          if (scope.$parent.pageLength == oSettings._iDisplayLength) {
            pgIndex += 1;
          }
          else {
            var pages = Math.ceil(oSettings._iRecordsDisplay / oSettings._iDisplayLength);
            if (oSettings._iDisplayLength < oSettings._iDisplayStart) {
              for (var i = 1; i <= pages; i++) {
                if (((i * oSettings._iDisplayLength) <= oSettings._iDisplayStart) &&
                  (((i + 1) * oSettings._iDisplayLength) > oSettings._iDisplayStart)) {
                  oSettings._iDisplayStart = (i * oSettings._iDisplayLength);
                  break;
                }
              }
            }
          }

          aoData.push({
            "name": "pageIndex",
            "value": pgIndex
          });

          scope.$parent.pageLength = oSettings._iDisplayLength;

          scope.$parent.searchPerformed = "";
          if (scope.$parent.searchApplied) {
            if (scope.$parent.searchText && scope.$parent.searchText.length > 0) {
              aoData.push({
                "name": "FilterValue",
                "value": unescape(scope.$parent.searchText)
              });
              // aoData.push({"name": "Filter", "value": unescape(scope.$parent.searchText)});
              scope.$parent.searchPerformed = unescape(scope.$parent.searchText);
            }
          }

          //// This export url is used to export
          scope.$parent.exportUrl = appConfig.apiURL + "/api/" + scope.$parent.object + "?";
          for (var j = 0; j < aoData.length; j++) {

            if (j != 0)
              scope.$parent.exportUrl += '&';

            if (aoData[j].name == 'pageSize') {
              scope.$parent.exportUrl += aoData[j].name + "=100000";
            }
            else {
              scope.$parent.exportUrl += aoData[j].name + "=" + aoData[j].value;
            }
          }

          $rootScope.startSpinner();
          // if (scope.$parent.searchText) {
          oSettings.jqXHR = $.ajax({
            "type": "GET",
            "cache": false,
            "url": appConfig.apiURL + "/api/" + scope.$parent.object + '/Filter',
            "data": aoData,
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Content-Type', 'application/json'),
                xhr.setRequestHeader('Authorization', 'Bearer ' + $cookies.get('_Token'))
            },
            success: function (json) {
              // if (scope.$parent.searchText) {
              $rootScope.stopSpinner();
              json.iTotalRecords = json.pagedData.records;
              json.iTotalDisplayRecords = json.pagedData.total;
              oSettings.json = json;
              //Encoding the data
              var propertyNames = [
                'firstName', 'lastName', 'companyName', 'accountNumber', 'street1', 'street2', 'city', 'state', 'postalCode'
              ];
              json.data = dtEncoder.dtEncodeValues(json.data, propertyNames);
              scope.$parent[scope.$parent.object] = json.data;

              fnCallback(json);
            },
            error: function () {
              $rootScope.stopSpinner();
            }
          });
        }
      };

      if (attributes.tableOptions) {
        options = angular.extend(options, scope.tableOptions)
      }
      var _dataTable = element.DataTable(options);
    },

    controller: function ($scope) {

      $scope.resetTableData = function () {
        var json = {};
        json.iTotalRecords = 0;
        json.iTotalDisplayRecords = 0;
        json.data = [];
        return json
      };

      //// Save filter and search params to local storage
      $scope.saveFilterParamsToLocalStorage = function (oSettings, oData) {
        localStorage.setItem('DataTables_' + $scope.$parent.object + window.location.pathname, JSON.stringify(oData));

        var saveSearchedObj = [];

        if ($scope.$parent.searchApplied) {
          saveSearchedObj.push({"name": "SearchApplied", "value": $scope.$parent.searchApplied});
          if ($scope.$parent.searchText && $scope.$parent.searchText.length > 0) {
            $scope.$parent.searchText = unescape($scope.$parent.searchText);
            saveSearchedObj.push({"name": "Filter", "value": escape($scope.$parent.searchText)});
            $scope.$parent.searchText = unescape($scope.$parent.searchText);
          }
        }

        localStorage.setItem('DataTables_Filtered_' + $scope.$parent.object + window.location.pathname, JSON.stringify(saveSearchedObj));
      };
    }
  };
});

/**
 * Created by Singh on 11/1/2017.
 * Filename: src/app/quote/directives/wizardStepOne.js
 */
angular.module('app.customer').directive('customerForm', function (addressValidationService, customerService, $rootScope, formValidationKeyService) {


    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/customer/partials/customerForm.tpl.html',

      link: function (scope, form) {
        scope.runSatori = false;
        var RequiredField = {
          en_US: $rootScope.getWord('RequiredField'),
          fr_CA: $rootScope.getWord('RequiredField'),
          en_CA: $rootScope.getWord('RequiredField')
        };

        var requiredCustomerInfo = {
          en_US: $rootScope.getWord('RequiredCustomerInfo'),
          fr_CA: $rootScope.getWord('RequiredCustomerInfo'),
          en_CA: $rootScope.getWord('RequiredCustomerInfo')
        };

        scope.disableAutoFill = function (id) {
          angular.element('#' + id).attr("autocomplete", "nope");
          return true;
        };

        form.formValidation({

          framework: 'bootstrap',
          icon: {
            // valid : 'glyphicon',
            // invalid : 'glyphicon glyphicon-remove',
            // validating : 'glyphicon glyphicon-refresh'
          },

          addOns: {
            i18n: {},
            mandatoryIcon: {
              // icon : !scope.id ? 'glyphicon glyphicon-asterisk' : ''
            }
          },

          fields: {

            txtFullName: {
              enabled: !!(scope.convertState),
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                }
              }
            },

            txtAccountNumber: {
              selector: scope.convertState ? '' : '.commonField',
              excluded: function () {
                return !!scope.convertState;
              },
              validators: {
                callback: {
                  message: requiredCustomerInfo,
                  callback: function (value, validator, $field) {
                    var isEmpty = true,
                      // Get the list of fields
                      $fields = validator.getFieldElements('txtAccountNumber');
                    for (var i = 0; i < $fields.length; i++) {
                      if ($fields.eq(i).val().trim() !== '') {
                        isEmpty = false;
                        break;
                      }
                    }
                    if (!isEmpty) {
                      // Update the status of callback validator for all fields
                      validator.updateStatus('txtAccountNumber', validator.STATUS_VALID, 'callback');
                      return true;
                    }
                    return false;
                  }
                },
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtStreet1: {
              excluded: function () {
                return scope.customer ? !scope.customer.hasAddressDetails : false;
              },
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                },
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtStreet2: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasAddressDetails : false;
              },
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 100
                }
              }
            },
            txtCity: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasAddressDetails : false;
              },
              group: '.col-lg-4',
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                },
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 50
                }
              }
            },
            txtZipCode: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasAddressDetails : false;
              },
              group: '.col-lg-2',
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                },
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 20
                }
              }
            },
            cboCountry: {
              excluded: function ($field, validator) {
                return scope.customer ? scope.customer.hasAddressDetails ? false : true : false;
              },
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                }
              }
            },
            cboState: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasAddressDetails : false;
              },
              group: '.col-lg-2',
              validators: {
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                }
              }
            },
            txtPhone: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasContactDetails : false;
              },
              group: '.col-lg-3',
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 20
                },
                callback: {
                  message: {
                    en_US: 'Please enter a valid phone number',
                    fr_CA: '*(FR_CA)Please enter a valid phone number',
                    en_CA: '*(EN_CA)Please enter a valid phone number'
                  },
                  callback: function (value, validator, $field) {
                    if (value == '') {
                      return !scope.convertState;
                    }
                    else {
                      angular.element('#txtPhone').intlTelInput("setCountry", scope.customer.country);
                      if (addressValidationService.isExceptionalCountry(scope.customer.country)) {
                        angular.element('#txtPhone').intlTelInput({});
                        return true
                      }
                      else {
                        var isPhoneValid = angular.element('#txtPhone').intlTelInput('isValidNumber');
                        if (isPhoneValid)
                          addressValidationService.formatPhoneNumber('txtPhone');
                        return isPhoneValid
                      }
                    }
                  }
                }
              }

            },
            txtExtension: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasContactDetails : false;
              },
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 10
                }
              }
            },
            txtEmail: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasContactDetails : false;
              },
              validators: {
                regexp: {
                  regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]{2,10}$',
                  message: {
                    en_US: $rootScope.getWord('ValidEmailMessage'),
                    fr_CA: $rootScope.getWord('ValidEmailMessage'),
                    en_CA: $rootScope.getWord('ValidEmailMessage')
                  }
                },
                callback: {
                  message: RequiredField,
                  callback: function (value, validator, $field) {
                    var isEmpty = true;
                    if (scope.convertState && !value) {
                      isEmpty = false;
                    }
                    return isEmpty;
                  }
                },
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 200
                }
              }
            },
            txtWebsite: {
              excluded: function ($field, validator) {
                return scope.customer ? !scope.customer.hasContactDetails : false;
              },
              validators: {
                stringLength: {
                  trim: true,
                  min: 1,
                  max: 200
                }
              }
            }
          },

          onSuccess: function (e, data) {
            e.preventDefault();
            scope.submitObject();
          },

          live: 'enabled'

        }).on('change', function (e, data) {
          if (_.includes(e.target.className, "satoriAddressField")) {
            scope.runSatori = true;
          }
        });
        scope.customer.street1 = customerService.getStreet1();
        form.formValidation('setLocale', formValidationKeyService.getValidationKey());
      }
    }
  }
);

/**
 * Created by Singh on 11/16/2017.
 * Filename: src/app/customer/directives/customerDetailPanel.js
 */
angular.module('app.customer').directive('customerDetailPanel', function ($state, formattedPhoneService, customerListService, $rootScope, userRolesService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/customer/partials/customerDetailPanel.tpl.html',

    link: function (scope) {

      // Customer Edit Page Functionality
      scope.goToEditPage = function () {
        $state.go('app.customer.edit', {id: scope.id})
      };

      // Get the role of current user
      scope.users = userRolesService.getUserNames();

      // Delete Customer Functionality
      var itemName = (scope.customer.fullName) ? scope.customer.fullName : (scope.customer.accountNumber) ? scope.customer.accountNumber : scope.customer.companyName;
      scope.deleteCustomerInDetailsPage = function (objectType) {
        scope.confirmText = $rootScope.getWord("DeleteCustomer");
        scope.deleteTitle = $rootScope.getWord("Delete");
        scope.deleteMessage = $rootScope.getWord("DeleteCustomerMessage");
        scope.confirmDelete(scope.id, itemName, false, objectType);
        angular.element('#deleteModal').modal('show');
      };

      // Phone Number format Logic
      scope.customer.country = scope.customer.country ? scope.customer.country : 'US';
      if (scope.customer.country && scope.customer.phoneNumber) {
        var formattedData = formattedPhoneService.formatPhoneNo(scope.customer.phoneNumber, scope.customer.country, 'formattedPhone');
        scope.customer.countryCode = formattedData.countryCode ? formattedData.countryCode : '+1';
        scope.customer.phoneNumber = formattedData.phoneNumber;
      }
    }
  }
});

/**
 * Created by Singh on 11/9/2017.
 * Filename: src/app/customer/directives/customerAddress.js
 * This directive includes logic for the google api address
 */
angular.module('app.customer').directive('customerAddress', function (autoPopulateService, customerService, formattedPhoneService, $state, $rootScope, $log, $stateParams) {

  return {
    restrict: 'A',
    link: function (scope) {

      // Get States and Countries
      scope.countries = customerService.getCountries();
      scope.states = customerService.getStates();

      // Reset Customer Address Details fields
      scope.resetCustomerAddress = function () {
        if (!scope.customer.street1) {
          scope.customer.street2 = '';
          scope.customer.state = '';
          scope.customer.city = '';
          scope.customer.postalCode = '';
        }
      };

      // Setting Google Address to customer Address fields on Select
      scope.selectAutoCompleteAddress = function (results) {
        customerService.enableDisableAddressValidation(true);
        scope.customer.street2 = '';
        autoPopulateService.setFields(results);
        var addressDetail = autoPopulateService.getAddress();
        customerService.setCustomerAddress(addressDetail);
        scope.getStates();
        scope.$apply();
      };

      // Phone Number format Functionality
      scope.getStates = function () {
        scope.customer.country = scope.customer.country ? scope.customer.country : 'US';
        var formattedData = formattedPhoneService.formatPhoneNo(scope.customer.phoneNumber, scope.customer.country, 'txtPhone');
        scope.customer.countryCode = formattedData.countryCode;
        scope.customer.phoneNumber = formattedData.phoneNumber;
      };

      // address validations
      scope.recommendedAddress = function () {
        customerService.setCustomerAddress(scope.updatedModifiedAddress);
        scope.submitCustomer();
      };

      // original address Accept
      scope.originalAddress = function () {
        customerService.setCustomerAddress(scope.unmodifiedAddress);
        scope.submitCustomer();
      };

      // Submit Customer Functionality
      scope.submitCustomer = function () {
        if (scope.customer.id) {
          $rootScope.startSpinner();
          customerService.updateCustomerObject(scope.customer.id)
            .then(function (data) {
              var updatedCustomerResponse = _.isEmpty(data) ? scope.customer : data;
              updatedCustomerResponse.quoteId = $stateParams.quoteId || '';
              $rootScope.stopSpinner();
              if (scope.convertState) {
                $state.go('app.quote.convertQuote', {quoteId: $stateParams.quoteId});
              }
              else if (scope.quoteInfoWithQuoteId || scope.quoteInfoWithoutQuoteId) {
                $state.go('app.quote.createQuote', {
                  id: $stateParams.quoteId,
                  incomingFromCustomer: updatedCustomerResponse
                });
              }
              else
                $state.go('app.customer.list');
            })
            .catch(function (e) {
              $rootScope.stopSpinner();
            });
        }
        else {
          $rootScope.startSpinner();
          customerService.createCustomerObject(scope.addAnother)
            .success(function (data) {
              $rootScope.stopSpinner();
              if (!scope.addAnother) {
                $state.go('app.quote.createQuote.step_one', {incomingFromCustomer: data});
              }
            })
            .error(function () {
              $rootScope.stopSpinner();
            });
        }
      };

      // Show Suggested Address from Satori
      scope.showSuggestedAddress = function (data) {
        scope.invalidAddress = false;
        scope.modifiedAddress = false;
        switch (data.result) {
          case 0:
            var updatedAddress = data.modifiedAddress ? data.modifiedAddress : data.originalAddress;
            customerService.setCustomerAddress(updatedAddress);
            scope.submitCustomer();
            break;
          case 1:
            window.scrollTo(0, 50);
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress ? data.originalAddress : scope.submitCustomer();
            break;
          case 2:
            window.scrollTo(0, 50);
            scope.modifiedAddress = true;
            scope.updatedModifiedAddress = data.modifiedAddress;
            scope.unmodifiedAddress = data.originalAddress;
            break;
          case 3:
            window.scrollTo(0, 50);
            scope.invalidAddress = true;
            scope.unmodifiedAddress = data.originalAddress;
            scope.unmodifiedAddress.isResidential = scope.unmodifiedAddress.isResidential;
            break;
        }
      };

      if (scope.id) {
        scope.getStates();
        scope.customer.firstName = scope.customer.firstName ? scope.customer.firstName : '';
        scope.customer.lastName = scope.customer.lastName ? scope.customer.lastName : '';
      }
    }
  }
});

/**
 * Created by Singh on 11/7/2017.
 * Filename: src/app/customer/directives/customerAccordion.js
 * This directive takes care of expanding address and contact accordions
 * The validation is enabled for expanded accordion and vice versa
 */
angular.module('app.customer').directive('customerAccordion', function (customerService) {

  return {
    restrict: 'A',
    link: function (scope) {

      scope.expandAddress = function () {
        if (scope.customer.hasAddressDetails) {
          angular.element('#collapse1').collapse('hide');
          customerService.enableDisableAddressValidation(false);
          customerService.enableSubmitButtons()
        }
        else {
          angular.element('#collapse1').collapse('show');
          customerService.enableDisableAddressValidation(true);
        }
      };

      scope.expandContact = function () {
        if (scope.customer.hasContactDetails) {
          angular.element('#collapse2').collapse('hide');
          customerService.enableDisableContactValidation(false);
          customerService.enableSubmitButtons()
        }
        else {
          angular.element('#collapse2').collapse('show');
          customerService.enableDisableContactValidation(true);
        }
      };

      angular.element('#collapse1').on('hide.bs.collapse', function () {
        scope.customer.hasAddressDetails = false;
      });
      angular.element('#collapse1').on('show.bs.collapse', function () {
        scope.customer.hasAddressDetails = true;
      });

      angular.element('#collapse2').on('hide.bs.collapse', function () {
        scope.customer.hasContactDetails = false;
      });
      angular.element('#collapse2').on('show.bs.collapse', function () {
        scope.customer.hasContactDetails = true;
      });

      // if(scope.customer.hasAddressDetails) {
      //   angular.element('#collapse1').collapse('show');
      //   customerService.enableDisableAddressValidation(true);
      // }
      //  if(scope.customer.hasContactDetails) {
      //    angular.element('#collapse2').collapse('show');
      //    customerService.enableDisableContactValidation(true);
      // }

    }
  }
});

/**
 * Created by Srikanth on 9/28/2017.
 * Path: src\app\customer\directives\backToCustomerList.js
 */
angular.module('app.customer').directive('backToCustomerList', function () {

  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/customer/partials/backToCustomerList.html',

    link: function (scope, elements, attributes) {

      if (attributes.label) {
        attributes.buttonLabel = attributes.label;
      }
      scope.buttonLabel = attributes.buttonLabel;
    }
  }
});


/**
 * Created by Singh on 2/28/2017.
 */
angular.module('app.customer').controller('customerEditCtrl', function ($scope, $state, customerService, defaultApiService, $rootScope, data, $stateParams) {

  // Initialise data
  customerService.initializeCustomer();
  customerService.setCountryStates(data);
  if ($stateParams.id) {
    customerService.setCustomer(data.customerData);
  }
  if ($stateParams.incomingCustomerData) {
    customerService.setIncomingCustomerData($stateParams.incomingCustomerData);
  }
  customerService.setStreet1();
  $scope.id = $stateParams.id ? $stateParams.id : null;
  $scope.convertState = ($stateParams.quoteId && ($stateParams.quoteState == 'convertQuote')) ? ($stateParams.quoteId && ($stateParams.quoteState == 'convertQuote')) : null;
  $scope.quoteInfoWithQuoteId = ($stateParams.quoteId && ($stateParams.quoteState == 'quoteInfo')) ? ($stateParams.quoteId && ($stateParams.quoteState == 'quoteInfo')) : null;
  $scope.quoteInfoWithoutQuoteId = (!$stateParams.quoteId && ($stateParams.quoteState == 'quoteInfo')) ? (!$stateParams.quoteId && ($stateParams.quoteState == 'quoteInfo')) : null;
  $scope.customer = customerService.getCustomer();
  $scope.customer.validateCustomer = !!$scope.convertState;
  $scope.customer.countryCode = $scope.id ? $scope.customer.countryCode : '+1';
  $scope.customer.country = $scope.id ? $scope.customer.country : 'US';
  if ($scope.convertState) {
    $scope.customer.hasAddressDetails = true;
    $scope.customer.hasContactDetails = true;
  }

  // Breadcrumbs for Edit and Create
  $scope.customer.fullName = $scope.id ? $scope.customer.fullName : $stateParams.incomingCustomerData ? $stateParams.incomingCustomerData.fullName : '';
  var editHeader = '';
  editHeader += $scope.customer.fullName ? $scope.customer.fullName : '';
  editHeader += (!$scope.customer.fullName && !$scope.customer.companyName) ? $scope.customer.accountNumber : '';
  editHeader += ((!$scope.customer.fullName && !$scope.customer.accountNumber) || (!$scope.customer.fullName && $scope.customer.accountNumber && $scope.customer.companyName)) ? $scope.customer.companyName : '';
  $scope.customerBreadcrumb = $scope.id ? $rootScope.getWord('EditCustomerInfo') : $rootScope.getWord('AddNewCustomer');
  $scope.customerEditBreadcrumb = $scope.id ? $rootScope.getWord('Edit') + ' - ' + editHeader : $rootScope.getWord('AddNewCustomer');
  $scope.editCustomerLabel = $scope.convertState ? $rootScope.getWord('ConvertQuote') : $scope.editCustomerLabel = ($scope.quoteInfoWithQuoteId || $scope.quoteInfoWithoutQuoteId) ? $rootScope.getWord('QuoteInfo') : $rootScope.getWord('Customers');

  // Cancel Form Functionality
  $scope.cancelForm = function () {
    if ($scope.convertState) {
      $state.go('app.quote.convertQuote', {quoteId: $stateParams.quoteId});
    }
    else if ($scope.quoteInfoWithQuoteId || $scope.quoteInfoWithoutQuoteId) {
      $state.go('app.quote.createQuote', {
        id: $stateParams.quoteId,
        incomingFromCustomer: $scope.unchangedCustomerInfo
      });
    }
    else {
      $state.go('app.customer.list');
    }
  };

  // Dynamic Save Button Label
  $scope.saveText = ($scope.convertState || $scope.quoteInfoWithQuoteId || $scope.quoteInfoWithoutQuoteId) ? "SaveAndContinue" : "SaveChanges";

  // Submit Form Functionality
  $scope.submitObject = function () {
    $scope.customer.street1 = angular.element('#txtStreet1').val();
    delete $scope.customer.firstName;
    delete $scope.customer.lastName;
    customerService.setCustomer($scope.customer);

    if (customerService.haveAddressDetails() && $scope.runSatori) {
      $rootScope.startSpinner();
      customerService.callAddressValidation()
        .success(function (data) {
          $rootScope.stopSpinner();
          $scope.showSuggestedAddress(data);
        })
        .error(function () {
          $rootScope.stopSpinner();
        });
    }
    else {
      $scope.submitCustomer();
    }
  };

  $scope.unchangedCustomerInfo = angular.copy($scope.customer);
});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('app.customer').controller('customerDetailsCtrl', function ($scope, $state, $rootScope, dtEncoder, customerService, $stateParams, data, $compile, $filter, quoteListService, recipientService, userRolesService, genericQuotesService, customerListService) {

  /***********************************************************************************************
   * Initialise Data
   **********************************************************************************************/
  customerService.initializeCustomer();
  if ($stateParams.id) {
    customerService.setCustomer(data.customerData);
  }
  $scope.id = $stateParams.id ? $stateParams.id : null;
  $scope.customer = customerService.getCustomer();
  $scope.quoteListObject = data.quoteListData ? data.quoteListData.data : [];
  $scope.recipientObject = data.recipientData ? data.recipientData.data : [];

  /***********************************************************************************************
   * Source and Status Enum Values
   **********************************************************************************************/
  $scope.sourceEnumsLocalised = customerService.getSourceEnums(data.quoteSource);
  $scope.statusEnumsLocalised = customerService.getStatusEnums(data.quoteStatus);

  /***********************************************************************************************
   * Encoding the Project Description
   **********************************************************************************************/
  $scope.quotesObject = dtEncoder.dtEncodeValues($scope.quoteListObject, 'projectDescription');

  /***********************************************************************************************
   * Data table Bindings
   **********************************************************************************************/
  $scope.tableColumns = ["projectDescription", "source", "quoteStatus", "LastModifiedDate", "LastModifiedByUserName"];

  $scope.options = {
    data: $scope.quotesObject,
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    order: [[0, 'asc']],
    buttons: $rootScope.user.userRole != userRolesService.getUserNames().Coa ? [
      {
        text: '<button class="btn btn-success m-n" id="customerQuoteCreateBtn">' +
        '                <i class="fa fa-plus p-r-sm"></i>' +
        '                <span>' + $rootScope.getWord("CreateQuote") + '</span>' +
        '              </button>',
        className: 'btn btn-success no-padding',
        action: function (e, dt, node, config) {
          $scope.createNewQuote();
        }
      }
    ] : [],
    oLanguage: {
      "sSearch": '<span class="custom-input"><i class="fa fa-search"></i></span>',
      "sSearchPlaceholder": "Quote No. or Reference No.",
      "sLengthMenu": "_MENU_",
      "oPaginate": {
        "sFirst": false,
        "sLast": false,
        "sPrevious": "<strong>Previous</strong>",
        "sNext": "<strong>Next</strong>"
      }
    },
    columns: [
      {

        "mData": "",
        "mRender": function (data, type, full) {
          var quoteId = "'" + full.id + "'";
          var html = '';
          html += full.quoteNumber ? '<a ng-click="viewItem(' + quoteId + ')"><span>' + full.quoteNumber + '</span></a><br/>' : '';
          html += full.projectDescription ? '<span>' + full.projectDescription + '</span>' : '';
          return html;
        }
      },

      {
        "mData": "",
        "mRender": function (data, type, full) {
          var sourceEnum = $scope.sourceEnumsLocalised[full.source];
          var html = '';
          html += full.referenceNumber ? '<span>' + full.referenceNumber + '</span><br/>' : '';
          html += full.source ? '<span>' + sourceEnum + '</span>' : '';
          return html;
        }
      },
      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var statusEnum = $scope.statusEnumsLocalised[full.quoteStatus];
          var statusValue = full.quoteStatus;
          var btnValue = '';
          switch (statusValue) {
            case 10 :
              btnValue = '<span class="label label-success">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 20 :
              btnValue = '<span class="label label-warning">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 30 :
              btnValue = '<span class="label label-primary">' + statusEnum.toUpperCase() + '</span>';
              break;
            case 40 :
              btnValue = '<span class="label label-danger">' + statusEnum.toUpperCase() + '</span>';
              break;
            case undefined:
              btnValue = "";
              break;
          }
          if (statusEnum === "" || statusValue === "") {
            return "";
          } else
            return btnValue
        }
      },

      {
        "mData": "",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var html = '';
          html = full.lastModifiedDate ? '<span>' + $filter('localDateTimeFilter')(full.lastModifiedDate) + '</span>' : '';
          return html;
        }
      },
      {
        "mData": "",
        'sClass': 'text-center',
        "mRender": function (data, type, full) {
          var html = '';
          html = full.lastModifiedByUserName ? '<span>' + full.lastModifiedByUserName + '</span>' : '';
          return html;
        }
      },
      {
        "className": "col-action",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var commandTypes = quoteListService.getCommands(full.quoteStatus);
          var btnName = quoteListService.getDefaultButtonLabel();
          var objectType = 'quote';
          var labels = {
            viewLabel: $rootScope.getWord('View'),
            editLabel: $rootScope.getWord('ReQuote'),
            deleteLabel: $rootScope.getWord('Delete'),
            reQuoteLabel: $rootScope.getWord('Requote'),
            convertQuoteLabel: $rootScope.getWord('Convert'),
            costedSummaryReportLabel: $rootScope.getWord('DownloadCostedSummaryReport'),
            costedDetailedReportLabel: $rootScope.getWord('DownloadCostedDetailedReport'),
            convertedSummaryReportLabel: $rootScope.getWord('DownloadConvertedSummaryReport'),
            convertedDetailedReportLabel: $rootScope.getWord('DownloadConvertedDetailedReport')
          };
          return $scope.tableDropdownActions(full.id, full.quoteNumber, full.readOnly, commandTypes, labels, btnName, objectType);
        }
      }
    ]
  };

  /***********************************************************************************************
   * BACK TO LIST FUNCTIONALITY
   **********************************************************************************************/
  $scope.backToList = function () {
    $state.go('app.customer.list')
  };

  /***********************************************************************************************
   * EDIT QUOTE FUNCTIONALITY
   **********************************************************************************************/
  $scope.editQuoteAction = function (id) {
    $state.go('app.quote.createQuote.step_one', {id: id});
  };

  /***********************************************************************************************
   * VIEW QUOTE FUNCTIONALITY
   **********************************************************************************************/
  $scope.viewItem = function (id) {
    $state.go('app.quote.convertQuote', {quoteId: id, viewOnly: 'viewOnly'});
  };

  /***********************************************************************************************
   * Convert Quote Functionality
   **********************************************************************************************/
  $scope.convertQuoteAction = function (quoteId) {
    $state.go('app.quote.convertQuote', {quoteId: quoteId});
  };

  /***********************************************************************************************
   * ReQuote Functionality
   **********************************************************************************************/
  $scope.reQuote = function (quoteId) {
    quoteListService.reQuote(quoteId);
  };

  /***********************************************************************************************
   * Download Reports
   **********************************************************************************************/
  $scope.downloadCostedSummaryReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteSummaryReport', id)
  };

  $scope.downloadCostedDetailedReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/CostedQuoteDetailedReport', id)
  };

  $scope.downloadConvertedSummaryReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteSummaryReport', id)
  };

  $scope.downloadConvertedDetailedReport = function (id) {
    genericQuotesService.downloadPdfAsset('Report/ConvertedQuoteDetailedReport', id)
  };

  /***********************************************************************************************
   * Delete Functionality for Quote and Recipient
   **********************************************************************************************/
  $scope.deleteItem = function (id, itemName, version, objectType) {
    itemName = (objectType == 'recipient') ? (itemName && itemName.trim()) ? itemName : $rootScope.getWord('Recipient') : itemName;
    $scope.confirmDelete(id, itemName, false, objectType);
  };

  $scope.deleteOnConfirm = function (id, itemName, objectType) {
    switch (objectType) {
      case 'quote':
        quoteListService.deleteQuote(id, itemName, false, 'customerDetailsDatatable');
        break;
      case 'recipient':
        recipientService.deleteRecipientObject(id, itemName);
        break;
      case 'customer':
        customerListService.deleteCustomer(id, itemName);
        break;
    }
  };

  /***********************************************************************************************
   * Primary Action Button Functionality
   **********************************************************************************************/
  $scope.defaultButtonAction = function (id, objName, actionName) {
    switch (actionName) {
      case 'Edit':
        $scope.editQuoteAction(id);
        break;
      case 'View':
        $scope.viewItem(id);
        break;
      case 'Convert':
        $scope.convertQuoteAction(id);
        break;
    }
  };

  /***********************************************************************************************
   * Create Button Click Functionality
   **********************************************************************************************/
  $scope.createNewQuote = function () {
    $state.go('app.quote.createQuote.step_one', {incomingFromCustomer: $scope.customer});
  };

});

/**
 * Created by Singh on 2/28/2017.
 */
angular.module('app.customer').controller('customerCtrl', function ($scope, $state, dtEncoder, $compile, defaultApiService, propertyValidationService, $rootScope, $stateParams, customerListService, userRolesService, $filter) {

  // Initialise data
  $scope.object = 'Customers';
  var localStorageData = localStorage.getItem('DataTables_Filtered_' + $scope.object + window.location.pathname);
  $scope.searchedObj = JSON.parse(localStorageData);

  $scope.tableColumns = ["fullName", "companyName"];

  $scope.users = userRolesService.getUserNames();

  if ($stateParams.incomingCustomerFilter) {
    $scope.searchText = $stateParams.incomingCustomerFilter;
    $scope.searchApplied = true;
  }

  // Binding data to data table
  $scope.options = {
    fnCreatedRow: function (nRow) {
      $compile(angular.element(nRow))($scope);
    },
    order: [[$scope.tableColumns.indexOf("fullName"), 'asc']],
    columns: [
      {

        "mDataProp": "fullName",
        "mRender": function (data, type, full) {
          var fullName = full.fullName ? full.fullName : '';
          var accountNumber = full.accountNumber ? full.accountNumber : '';
          var stringifyIdVar = "'" + full.id + "'";
          var html = '';
          html += fullName ? '<b><a ng-click="goToDetailsPage(' + stringifyIdVar + ')"><span>' + fullName + '</span></a></b> <br/>' : '';
          html += accountNumber ? '<a ng-click="goToDetailsPage(' + stringifyIdVar + ')"><span>' + accountNumber + '</span></a>' : '';
          return html;
        }
      },

      {
        "mDataProp": "company",
        "mRender": function (data, type, full) {
          var stringifyIdVar = "'" + full.id + "'";
          var html = '';
          html = full.companyName ? '<b><a ng-click="goToDetailsPage(' + stringifyIdVar + ')"><span>' + full.companyName + '</span></a></b> <br/>' : '';
          return html;
        }
      },
      {
        "mDataProp": "address",
        'orderable': false,
        "mRender": function (data, type, full) {
          var html = '';
          html += full.street1 ? '<span>' + full.street1 + '</span><br/>' : '';
          html += full.street2 ? '<span>' + full.street2 + '</span><br/>' : '';
          html += full.city ? '<span>' + full.city + '</span>' : '';
          html += (full.city && full.state) ? ', ' : '';
          html += (full.city && !full.state) ? '<span></span><br/>' : '';
          html += full.state ? '<span>' + full.state + '</span><br/>' : '';
          html += full.postalCode ? '<span>' + full.postalCode + '</span>' + ', ' : '';
          html += full.country ? '<span>' + full.country + '</span>' : '';
          return html;
        }
      },
      {
        "mDataProp": "contact",
        "bSortable": false,
        "mRender": function (data, type, full) {
          var extText = $rootScope.getWord('Ext');
          var html = '';
          html += full.email ? '<span>' + full.email + '</span><br/>' : '';
          html += full.phoneNumber ? '<span>' + '+1' + ' ' + full.phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3") + '</span>' : '';
          html += full.phoneExt ? '<span>' + ' ' + extText + ' ' + full.phoneExt + '</span><br/>' : '';
          html += full.website ? '<a target="_blank" ng-href=" ' + $filter('urlFilter')(full.website) + '" class="block">' + full.website + '</a>' : '';
          return html
        }
      },
      {
        "className": "col-action",
        "bSortable": false,
        "mDataProp": "actions",
        "mRender": function (data, type, full) {
          var commandTypes = customerListService.getDynamicButtons();
          var btnName = customerListService.getDefaultButtonLabel();
          var name = (full.fullName) ? full.fullName : (full.accountNumber) ? full.accountNumber : full.companyName;
          var labels = {
            editLabel: $rootScope.getWord('EditCustomer'),
            deleteLabel: $rootScope.getWord('DeleteCustomer')
          };
          return $scope.tableDropdownActions(full.id, name, full.readOnly, commandTypes, labels, btnName);
        }
      }
    ]
  };

  $scope.specialCharacters = function () {
    if ($scope.searchText) {
      $scope.searchText = escape($scope.searchText);
    } else {
      $scope.searchText = '';
    }
  };

  /// Reset the search filter input
  $scope.resetSearch = function () {
    $scope.searchText = '';
    $scope.searchPerformed = '';
    if ($scope.searchApplied) {
      $scope.searchApplied = false;
      var shipmentsTable = angular.element('#customerDatatable').dataTable();
      shipmentsTable.fnDraw();
    }
  };

  //Search bar
  $scope.searchByString = function () {
    if (propertyValidationService.isNullOrEmpty($scope.searchText)) {
      $scope.searchText = angular.element('#search-by-string')[0].value;
    }

    if ($scope.searchText) {
      $scope.specialCharacters();
      $scope.searchApplied = true;
      $scope.filterApplied = true;
      $scope.searchText = unescape($scope.searchText);
      var shipmentsTable = angular.element('#customerDatatable').dataTable();
      shipmentsTable.fnDraw();
    } else {
      $scope.resetSearch();
    }
  };

  // Create Customer Functionality
  $scope.createNewItem = function () {
    $state.go('app.customer.edit');
  };

  // Delete Customer Functionality
  $scope.deleteItem = function (id, itemName) {
    $scope.confirmDelete(id, itemName, $scope);
  };

  $scope.deleteOnConfirm = function (id, itemName) {
    customerListService.deleteCustomer(id, itemName);
  };

  // Primary Action Button Label Functionality
  $scope.defaultButtonAction = function (id, itemName, actionName) {
    switch (actionName) {
      case 'Edit':
        $scope.editItem(id);
        break;
      case 'CreateQuote':
        $rootScope.startSpinner();
        defaultApiService.readObjectCall('Customers', id)
          .success(function (data) {
            $rootScope.stopSpinner();
            $state.go('app.quote.createQuote.step_one', {incomingFromCustomer: data});
          })
          .error(function () {
            $rootScope.stopSpinner();
          });
        break;
    }
  };

  // Clearing Cache and updating data table
  function clearShipmentFilters() {
    localStorage.removeItem('DataTables_Filtered_Customers' + window.location.pathname);
    localStorage.removeItem('DataTables_Customers' + window.location.pathname);
    var customerTable = angular.element('#customerDatatable').DataTable();
    customerTable.state.clear();
  }

  // Edit Customer Functionality
  $scope.editItem = function (id) {
    $state.go('app.customer.edit', {id: id})
  };

  // Customer Details Functionality
  $scope.goToDetailsPage = function (id) {
    $state.go('app.customer.details', {id: id})
  };

  // Clear Cache on State Change
  $rootScope.$on('$stateChangeStart', function (ev, toState, toParams, from) {
    if (toState.name == 'app.customer.list' && from && (from.name != 'app.customer.list' && from.name != 'app.customer.edit' && from.name != 'app.customer.details')) {
      clearShipmentFilters();
    }
    else if (from && from.name == 'app.customer.list' && (toState.name != 'app.customer.list' && toState.name != 'app.customer.edit' && toState.name != 'app.customer.details')) {
      clearShipmentFilters();
    }
  });
});

"use strict";

angular.module('app').directive('languageSelector', function(){
    return {
        restrict: "EA",
        replace: true,
        templateUrl: "app/layout/language/language-selector.tpl.html",
        scope: true
    }
});

"use strict";

angular.module('app').factory('languageService', function ($http, APP_CONFIG, $rootScope, $cookies) {

	function initializeLanguage() {
		/***********************************************************************************************/
		// Use cookie to get localization for set cookie using defaults if missing and get localizations
		/***********************************************************************************************/
		var loadLanguageKey = appConfig.default_language.key;

      if ($cookies.get('_locale'))
			loadLanguageKey = $cookies.get('_locale');
		else
        $cookies._locale = appConfig.default_language.key;

		/***********************************************************************************************/
		// Get localized list
		/***********************************************************************************************/
		getLanguage(loadLanguageKey, function (data) {
			$rootScope.lang = data;
		});

		/***********************************************************************************************/
		// Get localized word from the loc
		/***********************************************************************************************/
		$rootScope.getWord = function (key) {
			if ($rootScope.lang === undefined) {
				return key;
			}

			if ($rootScope.lang[key]) {
				return $rootScope.lang[key];
			}

			return key;
		};
	}

	function getLanguage(key, callback) {

		$http.get(APP_CONFIG.apiRootUrl + '/langs/' + key + '.json').success(function (data) {
			callback(data);
		}).error(function () {
			callback([]);
		});
	}

	function getLanguages(callback) {
		$http.get(APP_CONFIG.apiRootUrl + '/languages.json').success(function (data) {
			callback(data);
		}).error(function () {
			callback([]);
		});

	}

	return {
		initializeLanguage : function () {
			initializeLanguage();
		},
		getLang: function (type, callback) {
			getLanguage(type, callback);
		},
		getLanguages: function (callback) {
			getLanguages(callback);
		},
		getWord: function (key, rootScope) {
			if (angular.isDefined(rootScope.lang[key])) {
				return rootScope.lang[key];
			}
			else {
				return key;
			}
		}
	}

});

"use strict";

angular.module('app').controller("languageCtrl",  function languageCtrl($scope, $rootScope, $log, languageService,$cookies,$location){

    // $rootScope.lang = {};

    languageService.getLanguages(function(data){
      $rootScope.languages = data;
      /********************************************************************************************/
      //If cookie exist use the cookie to default the current language
      /********************************************************************************************/
      if ($cookies.get('_locale')) {
        $rootScope.currentLanguage = _(data)
          .filter(function (data) {
            return data.key == $cookies.get('_locale');
          })
          .value()[0];
      }

      /********************************************************************************************/
      //If no cookie is set or the cookie is deleted. We set it back to defaults from the app.config
      /********************************************************************************************/
      if (!$cookies.get('_locale')) {
        $cookies.put('_locale', appConfig.default_language.key) ;
        $rootScope.currentLanguage = appConfig.default_language;
        languageService.getLang($cookies.get('_locale'), function (data) {
          $rootScope.lang = data;
        });
      }

      /********************************************************************************************/
      // If current language is not set we use the app.config defaults
      /********************************************************************************************/
      if (!$rootScope.currentLanguage) {
        $rootScope.currentLanguage = appConfig.default_language;
      }
    });

    $scope.selectLanguage = function(language){
      $cookies.put('_locale', language.key);
      $cookies.put('formValidationKey',language.formValidationKey);

        $rootScope.currentLanguage = language;
        languageService.getLang(language.key,function(data){
            $rootScope.lang = data;
            appConfig.languages = data;
        });

      //TODO: This is not the final solution.
      //We must compile the Language directive to change the language on the fly
      //Refresh page with new language settings
      if ($location.path() == '/') {
        location.reload();
      } else {
        $location.path('/');
        location.reload();
      }
    };

    $rootScope.getWord = function(key){
        //return Language.getWord(key, $rootScope);
        if(angular.isDefined($rootScope.lang[key])){
            return $rootScope.lang[key];
        }
        else {
            return key;
        }
    };

});

/**
 * Created by DanGar on 2/17/2017.
 */

angular.module('app').factory('formValidationKeyService', function ($cookies) {

    var validationKey = 'en_US';
    function initializeKey() {
        if ($cookies.get('formValidationKey')) {
            validationKey = $cookies.get('formValidationKey');
            return 'form-validator-' + validationKey;
        } else {
          $cookies.put('formValidationKey', validationKey);
            return 'form-validator-' + validationKey;
        }
    }

    return {
        initializeKey: function(){
            initializeKey()
        },
        getValidationKey: function(){
            return validationKey;
        }
    };
});

/**
 * Created by $ingh on 10/9/2017.
 */
(function(){
  'use strict';
  angular.module('Shared.Filters', []);
})();

/**
 * Created by Srikanth Reddy on 6/20/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\filters\urlFilter.js
 * This filter adds http or https to url instead of running from local
 */

angular.module('Shared.Filters').filter('urlFilter', function () {

  return function (link) {
    var result;
    var startingUrl = "http://";
    var httpsStartingUrl = "https://";
    if (link.startWith(startingUrl) || link.startWith(httpsStartingUrl)) {
      result = link;
    }
    else {
      result = startingUrl + link;
    }
    return result;
  };
});

// function to check whether url has http or https
String.prototype.startWith = function (str) {
  return this.indexOf(str) == 0;
};

/**
 * Created by Srikanth Reddy on 2/1/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\filters\separateCamelWords.js
 */

angular.module('Shared.Filters').filter('separateCamelWords', function () {

    return function (input, uppercaseFirst) {

      if (typeof input !== "string") {
        return input;
      }

      var result = humps.separateWords(input, ' ');

      if (uppercaseFirst) {
        result = result.charAt(0).toUpperCase() + result.slice(1);
      }

      return result;

    };

  });

/**
 * Created by Srikanth Reddy on 9/17/2018.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\common\filters\phoneFilter.js
 */

angular.module('Shared.Filters').filter('phoneFilter', function () {

  return function (tel) {
    if (!tel) {
      return '';
    }

    var value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    var country, city, number;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;

      default:
        return tel;
    }

    if (country == 1) {
      country = "";
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + " (" + city + ") " + number).trim();
  };

});

/**
 * Created by sreddy on 1/30/2018.
 */


angular.module('Shared.Filters').filter('localDateTimeFilter', function ($filter) {

  var isUtcFormat = function (dateTimeString) {
    if (dateTimeString.indexOf("T") > -1)
      return true;
    return false;
  };

  return function (value, type, format) {
    if (!value)
      return;

    if (type == 'date') {
      if (!format)
        format = 'MM/dd/yy';
      return $filter('date')(moment.utc(value).toDate(), format);
    }
    if (type == 'time') {
      if (!format)
        format = 'hh:mm a';
      return $filter('date')(moment.utc(value).toDate(), format);
    }
    if (type == 'dateTime') {
      if (!format)
        format = 'MM/dd hh:mm:ss a';
      return $filter('date')(moment.utc(value).toDate(), format);
    }

    var dt = value;
    if (!isUtcFormat(value))
      dt = new Date(value + ' UTC').toISOString();
    var localTime = moment.utc(dt).toDate();

    if (!format)
      format = 'MM/dd/yy hh:mm a';

    return $filter('date')(localTime, format);
  };
});



angular.module('Shared.Filters').filter('filterHtmlChars', function () {
    return function (html) {

        if (!html || html.length == 0) {
            return html;
        }

        var RandomString = function () {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < 5; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }

            return text;
        };
        var firstRandomString = RandomString();
        var secondRandomString = RandomString();

        //
        html = html.replace(/<a/g, firstRandomString);
        html = html.replace(/<\/a>/g, secondRandomString);

        firstRandomString = new RegExp(firstRandomString, "g");
        secondRandomString = new RegExp(secondRandomString, "g");

        html = html.replace(/(<)/g, "&lt;");

        html = html.replace(firstRandomString, "<a");
        html = html.replace(secondRandomString, "</a>");

        if (!/\r|\n/.exec(html)) {
            return html;
        }

        html = '<p>' + html.replace(/(\r\n|\n|\r)/g, "&nbsp;</br>") + '</p>';
        return html;
    }
});

"use strict";

angular
  .module('app.auth', [])
  .config(function ($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/auth/views/login.html',
        controller: 'LoginCtrl',

        data: {
          pageTitle: 'Login',
          htmlId: 'extr-page',
          requiresLogin: false
        },
        resolve: {
          deps: function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'scripts/on-init-plugins.js'
            ]);
          }
        }
        // resolve: {
        //   srcipts: function (lazyScript, buildNumberService) {
        //     return lazyScript.register([
        //       buildNumberService.getBuildNumber() + 'vendor.ui.js'
        //     ])
        //
        //   }
        // }
      })
      .state('logout', {
        url: '/logout',

        templateUrl: '',
        controller: function ($rootScope, $cookies,$log) {
          //Delete cookies.
          $cookies.remove("_Token");
          $cookies.remove("expDate");
          $rootScope.userIsAuthorized = false;
          //Clear out DataTables states.
          localStorage.clear();
          sessionStorage.clear();
          //Reload back to the login screen.
          location.reload();

          $log.log("done")
        },
        data: {
          requiresLogin: false
        }
      });
  });

/**
 * Created by DanGar on 2/13/2017.
 */
'use strict';
angular.module('app.auth').service('Authorization', function($rootScope, $http, $cookies){
    var authToken;

    // function authorizationException(message) {
    //     this.message = message;
    //     this.name = "AuthorizationException";
    // }

    this.login = function (username, password) {

        //******************************************************************************************************
        // Resetting the Authorization in the header if it exists and you are trying to login
        //******************************************************************************************************
        $http.defaults.headers.common.Authorization = undefined;

        var params = "grant_type=password&username=" + username + "&password=" + password;
        return $http({
            url    : appConfig.apiURL + '/Authorization/GetAuthorizeToken',
            method : "POST",
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data   : params
        })
            .success(function (data, status, headers, config) {
                $http.defaults.headers.common.Authorization = "Bearer " + data.access_token;
                $http.defaults.headers.common['Accept-Language'] = $cookies.get('_locale');
              $cookies.put("_Token", data.access_token);
              $cookies.put("expDate", data[".expires"]);
                authToken = data.access_token;

                //******************************************************************************************************
                // userIsAuthorized field is added to avoid throwing error messages if user is unauthorized.
                //******************************************************************************************************
                $rootScope.userIsAuthorized = true;
            })
            .error(function (data, status, headers, config) {
            });
    };
});

/**
 * Created by DanGar on 2/14/2017.
 */
angular.module('app.auth').directive('logoutForm', function ($rootScope, notificationMessages, $state) {
  return {
    restrict: 'EA',
    replace: false,
    templateUrl: 'app/auth/partials/logout-modal.tpl.html',
    link: function (scope, elements, attributes) {

      scope.confirmText = $rootScope.getWord('LogOut');
      scope.cancelText = $rootScope.getWord('Cancel');


      scope.logoutConfirmation = function () {
        angular.element('#logOutModal').removeClass('fade');
        $state.go('logout');
        location.reload();
      };

      scope.confirmLogOut = function (itemName) {
        scope.logoutNotificationTitle = notificationMessages.logOutTitle();
        scope.logoutNotificationMessage = notificationMessages.logOutMessage() + " " + itemName + "?";
      };

    }
  }
});

"use strict";

angular.module('app.auth').directive('loginInfo', function (userRolesService) {

    return {
        restrict: 'A',
        // templateUrl: 'app/auth/directives/login-info.tpl.html',
        controller: function ($rootScope, $scope) {

            if (!$scope.user) {
                var user = userRolesService.getSystemUser();

                if (user) {
                    $rootScope.user = user;
                    $scope.user = $rootScope.user;
                }
            }
        }
    }
});

"use strict";

//angular.module('app.auth').controller('LoginCtrl', function ($scope, $state, GooglePlus, User, ezfb) {
angular.module('app.auth').controller('LoginCtrl', function ($rootScope, $scope, $state, Authorization, $location, $cookies, $http,userInfo, userRolesService,$log) {


  $log.log(appConfig.apiURL);

    $scope.userInfo = {
        username: '',
        password: ''
    };

    // Displays logo based on the env config
    // if (appConfig.images.loginLogo) {
    //     $scope.loginLogo = $rootScope.setBuildInfo(appConfig.images.loginLogo);
    // } else {
    //     $scope.loginLogo = $rootScope.setBuildInfo('styles/img/staples-title-below.png');
    // }

    if ($cookies.get('userInfo') != null) {
        var uInfo = $cookies.getObject('userInfo');
        $scope.userInfo.username = uInfo.username;
        $scope.userInfo.rememberMe = uInfo.rememberMe;
    }

    if (sessionStorage.getItem('storeId')) {
        $scope.userInfo.username = 'CC' + sessionStorage.getItem('storeId');
        $scope.usernameDisabled = true;
    }

    var currentDate = new Date();
    if ($cookies.get('_Token'))
        var tokenDate = new Date($cookies.get('expDate'));

    if ($cookies.get('_Token') && (tokenDate >= currentDate)) {
        $location.path('/');
    }

    $scope.setFocus = function () {
        var password = angular.element('#password')[0];
        if ($scope.usernameDisabled) {
            password.focus();
        }
    };

    $scope.setFocus();

    var loadGoogleMapsScript = function(apiKey) {
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places';
        script.async = true;
        script.defer = true;
        script.onload = function() {
            console.log('Google Maps script loaded successfully.');
            // You can now initialize Maps or Places here
        };
        script.onerror = function() {
            console.error('Failed to load the Google Maps script.');
        };

        document.head.appendChild(script);
    }

    var onLoginSuccess = function () {
        $rootScope.stopSpinner();
        if ($rootScope.previousUrl) {
            $location.path($rootScope.previousUrl);
        } else {
          //TODO: Temporary fix asked by Buisness : JSS
          $state.go('app.quote.list');
          // $location.path('/');
        }
    };

    $scope.loginUser = function () {

        var loginInfo = {
            username: $scope.userInfo.username,
            rememberMe: $scope.userInfo.rememberMe
        };

        if ($scope.userInfo.rememberMe && $scope.userInfo.username) {
          $cookies.putObject("userInfo", loginInfo);
        } else {
          $cookies.remove("userInfo");
        }

        $rootScope.startSpinner();
        Authorization.login(
            $scope.userInfo.username,
            $scope.userInfo.password)

            .success(function () {
              $log.log(userInfo);
                if (userInfo && userInfo.isNotRetrieved) {
                    userInfo
                        .getCurrentUser()
                        .then(function successCallback(response) {
                            userRolesService.initSystemUser(response);
                            onLoginSuccess();
                            $http
                            .get('google.settings.json?' + Math.random())
                            .then(function (response) {
                                if (response.data && response.data.Settings) {
                                    var Urls = response.data.Settings.Urls;
                                    loadGoogleMapsScript(Urls.EnvGoogleApiKey);
                                }
                            });
                        }, function errorCallback(response) {
                          $log.log(response);
                            $rootScope.stopSpinner();
                        });
                } else {
                    onLoginSuccess();
                }
            })
            .error(function () {
                $rootScope.stopSpinner();
            });
    };
});

/**
 * Created by Srikanth Reddy Anugu on 12/11/2017.
 * Path: D:\PNIEstimation.UI\FlightDeck.Estimating.UI\src\app\settings\module.js
 */

"use strict";

angular.module('app.settings', ['settings.products', 'settings.product-codes', 'settings.sources', 'settings.system-roles', 'settings.system-users', 'settings.system-settings']).config(function ($stateProvider) {

  $stateProvider.state('app.settings', {
    abstract: true,
    template: '<ui-view/>',
    data: {
      title: 'Settings',
      requiresLogin: true,
      needAdmin: true
    }
  })
});

(function(){
  "use strict";

  angular.module('Shared', [
    "Shared.Datatables",
    "Shared.Forms",
    "Shared.Filters",
    "Shared.Generic"
  ]);
})();

"use strict";

(function () {
  'use strict';
  angular.module('app.admin',
    [
       'admin.pricing'
    ]);

  angular.module('app.admin').config(function ($stateProvider) {

    $stateProvider.state('app.admin', {
      abstract: true,
      template: '<ui-view/>',
      data: {
        title: 'Admin',
        requiresLogin: true
      }
      // resolve: {
      //   data: function ($rootScope, $state) {
      //     $rootScope.curState = $state.current.name
      //   }
      // }
    })
  });

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('app')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock)
    .config(function ($provide, $httpProvider) {
      // Intercept http calls.
      $provide.factory('ErrorHttpInterceptor', function ($rootScope, $q, $cookies, errorNotificationService) {

        return {
          //On request failure
          requestError: function (rejection) {
            $rootScope.stopSpinner();
            // show notification
            errorNotificationService.notifyError(rejection);

            // Return the promise rejection.
            return $q.reject(rejection);
          },

          // On response failure
          responseError: function (rejection) {
            if ($rootScope.stopSpinner) {
              $rootScope.stopSpinner();
            }

            // To avoid showing multiple error messages
            if ($rootScope.userIsAuthorized) {
              // show notification.
              errorNotificationService.notifyError(rejection);
            } else if (rejection.data) {
              errorNotificationService.notifyError(rejection);
            }

            // This case to support invalid login
            // if (rejection.data && rejection.data.error == 'Login') {
            //   errorNotificationService.notifyError(rejection);
            // }

            //******************************************************************************************************
            // userIsAuthorized field is added to avoid throwing error messages if user is unauthorized.
            //******************************************************************************************************
            if (rejection.status == 401 && $rootScope.$state.current.name != 'login') {
              event.preventDefault();
              $rootScope.userIsAuthorized = false;
              $cookies.remove("_Token");
              $rootScope.$state.go('login');
            }

            // Return the promise rejection.
            return $q.reject(rejection);
          }
        };
      });

      // Add the interceptor to the $httpProvider.
      $httpProvider.interceptors.push('ErrorHttpInterceptor');
    });

  /** @ngInject */
  function runBlock($log, $rootScope, $state, $cookies, userRolesService, $location, $http, languageService, formValidationKeyService, toaster, notificationMessages) {

    /****************************************************************************************************
     * The localised key is set here for all the form validations so that when the app loads
     * we can use the localised value for all the forms.
     ***************************************************************************************************/
    formValidationKeyService.initializeKey();


    $log.debug('runBlock end');
    $rootScope.$state = $state;

    $rootScope.$on('$stateChangeStart', function (event, toState) {
      window.scrollTo(0, 0);
      var requiresLogin = toState.data.requiresLogin;
      var currentDate = new Date();

      if ($cookies.get("_Token"))
        var tokenDate = new Date($cookies.get("expDate"));
      else
        requiresLogin = true;


      if ((requiresLogin || 'undefined') && ($cookies.get("_Token") && (tokenDate >= currentDate))) {
        $http.defaults.headers.common.Authorization = "Bearer " + $cookies.get("_Token");
        $http.defaults.headers.common['Accept-Language'] = $cookies.get("_locale");

        // If user is not initialised load user.
        if (!$rootScope.user) {
          userRolesService.getSystemUser();
        }

        // If logged in and trying to go to login screen
        var isNotAuthorized = $rootScope.userIsAuthorized ? 0 : 1;

        if (toState.name == 'login' && isNotAuthorized) {

          $rootScope.$evalAsync(function () {
            // If on dashboard need to reload the page
            if ($location.path() == '/') {
              location.reload();
            } else {
              // Redirect to dashboard
              $location.path('/');
            }
          });

          event.preventDefault();
          return;
        }
        //Set the authorization for user.
        $rootScope.userIsAuthorized = true;
        if (toState.data.needAdmin && ($rootScope.user.userRole == 1 || $rootScope.user.userRole == 3)) {
          event.preventDefault();
          $state.go('app.quote.list');
          toaster.error({
            title: notificationMessages.notAuthorizedErrorTitle(),
            body: notificationMessages.notAuthorizedErrorMessage()
          });
        }
      } else {
        if (toState.name != 'login') {
          // Reset the authorization header if not logged in.
          $http.defaults.headers.common.Authorization = undefined;

          if (toState.name != 'logout') {
            // Get the previous url for redirect after login
            $rootScope.previousUrl = window.location.href.split('#')[1];
          }

          $state.go('login');
          $rootScope.$evalAsync(function () {
            $location.path('/login');
          });

          event.preventDefault();
          return;
        }
        return;
      }
    });

    $rootScope.$on('$stateChangeSuccess', function (ev, toState, toParams, from) {
      if ($rootScope.userIsAuthorized && toState.name == 'login') {
        // $state.go('app.main');
      }
      Pace.restart();
      if (toState.name != 'login' && from.name == 'login') {
        $rootScope.stopSpinner();
      }
    });
    languageService.initializeLanguage();

  }

})();

'use strict';
var appConfig = {};
// appConfig.apiURL ='https://splus-qa-estimator-api.azurewebsites.net';
//TODO: Update below endpoint once url caching issue is resolved
appConfig.apiURL = 'https://splus-estimator-api.pnimedia.com/';


appConfig.default_language = {
  "key"              : "en-US",
  "class" 		     : "en-us",
  "alt"              : "United States",
  "title"            : "US English",
  "dataTableKey"     : "english",
  "formValidationKey": "en_US"
};

appConfig.apiRootUrl = 'api';
appConfig.useGoogleAutoComplete = true;
appConfig.googleApiKey = '';


window.appConfig = appConfig;

(function () {

  angular
    .module('app')
    .constant('APP_CONFIG', window.appConfig);
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {
  fetchAppConstants().then(bootstrapApplication);

  function fetchAppConstants() {
    var initInjector = angular.injector(["ng"]);
    var $http = initInjector.get("$http");
    var $q = initInjector.get("$q");
    var $log = initInjector.get("$log");
    var $cookies;
    angular.injector(['ngCookies']).invoke(['$cookies', '$q', '$log', function (_$cookies, _$q, _$log) {
      $cookies = _$cookies;
      $q = _$q;
      $log = _$log;
    }]);

    try {
      // Check if token exists using $cookies
      $cookies.get('_Token');
    } catch (error) {
      // This is to remove all the old cookies if any in the application using $cookies methods
      var cookieList = $cookies.getAll();
      for (var cook in cookieList) {
        $cookies.remove(cook);
      }
    }

    return fetchEnvApi($http, $q, $cookies, $log);
  }

  function fetchEnvApi($http, $q, $cookies, $log) {
    return $http
      .get('app.settings.json?' + Math.random())
      .then(function successCallback(response) {

        $log.log(appConfig.apiURL);
        if (response.data && response.data.Settings) {
          var Urls = response.data.Settings.Urls;
          appConfig.apiURL = Urls.EnvApi;
        }
        $log.log(appConfig.apiURL);
        $log.log(appConfig.googleApiKey);

        if (!$cookies.get('_Token')) {
          return $q.resolve();
        }

        $http.defaults.headers.common.Authorization = "Bearer " + $cookies.get("_Token");

        return getCurrentUser($http);
      }, function errorCallback(response) {
        $log.log(response);

        if (!$cookies.get('_Token')) {
          return $q.resolve();
        }

        $http.defaults.headers.common.Authorization = "Bearer " + $cookies.get("_Token");
        return getCurrentUser($http);
      });
  }

  function loadGoogleMapsScript(apiKey) {
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places';
    script.async = true;
    script.defer = true;
    script.onload = function() {
        console.log('Google Maps script loaded successfully.');
        // You can now initialize Maps or Places here
    };
    script.onerror = function() {
        console.error('Failed to load the Google Maps script.');
    };

    document.head.appendChild(script);
  }

  function getCurrentUser($http) {
    $http
    .get('google.settings.json?' + Math.random())
    .then(function (response) {
        if (response.data && response.data.Settings) {
          var Urls = response.data.Settings.Urls;
          appConfig.googleApiKey = Urls.EnvGoogleApiKey;
          loadGoogleMapsScript(appConfig.googleApiKey);
        }
    });

    return $http
      .get(appConfig.apiURL + "/api/CurrentUser")
      .then(function successCallback(response) {
        angular.module("app").constant('userInfo', response.data);
      }, function errorCallback(response) {
        angular.module("app").constant('userInfo', null);
      });
  }

  function bootstrapApplication() {
    // moment.js default language
    // moment.locale('en');

    try {
      angular.bootstrap(document, ['app']);
    } catch (e) {
      console.log(!!e.message.indexOf('btstrpd'))
    }
  }

  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if (navbarHeight > wrapperHeight) {
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if (navbarHeight < wrapperHeight) {
      angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function () {
    //changed by $ingh
    // height was not working on minimizing and then maximizing the window
    // if(!angular.element("body").hasClass('body-small')) {
    fix_height();
    // }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function () {
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function () {
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function () {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  });

});

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/views/login.html","<div class=\"wrapper wrapper-content animated fadeIn login-background\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"middle-box text-center loginscreen\"><div><section class=\"text-center\"><img src=\"assets/images/flightdeck-estimator-logo.png\" alt=\"FlightDeck Estimator logo\" class=\"logo-align\"></section><form class=\"m-t p-sm\" role=\"form\" ng-submit=\"loginUser(userInfo)\"><section><div class=\"form-group\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"control-label pull-left\" for=\"txtUserName\">{{getWord(\'Username\')}}</label> <input id=\"txtUserName\" name=\"txtUserName\" type=\"text\" class=\"form-control\" ng-model=\"userInfo.username\" required=\"\"></div></div></div></section><section><div class=\"form-group\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"control-label pull-left\" for=\"txtPassword\">{{getWord(\'Password\')}}</label> <input id=\"txtPassword\" name=\"txtPassword\" type=\"password\" class=\"form-control\" ng-model=\"userInfo.password\" required=\"\"></div></div></div></section><div class=\"form-group m-t-md\"><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5\"><label class=\"checkbox-wrap p-l-none\" for=\"chkRememberMe\"><input id=\"chkRememberMe\" name=\"chkRememberMe\" type=\"checkbox\" ng-model=\"userInfo.rememberMe\"> {{getWord(\'RememberMe\')}} <span class=\"checkbox-mark\"></span></label></div></div></div><footer><button type=\"submit\" class=\"btn btn-success\">{{getWord(\'LogIn\')}}</button></footer></form></div></div><div id=\"pageOverlay\" class=\"overlay hidden\"></div><custom-spinner id=\"spCustomSpinner\"></custom-spinner></div></div></div>");
$templateCache.put("app/auth/partials/logout-modal.tpl.html","<div class=\"modal fade\" role=\"dialog\" id=\"logOutModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{logoutNotificationTitle}}</b></h3></div><div class=\"modal-body\"><p ng-bind-html=\"logoutNotificationMessage\"></p></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-success pull-right m-l-sm\" data-dismiss=\"modal\" ng-click=\"logoutConfirmation()\" ng-bind=\"confirmText\"></button> <button id=\"cancelBtn\" type=\"button\" class=\"btn btn-default pull-right no-borders\" data-dismiss=\"modal\" ng-bind=\"cancelText\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\" class=\"top-navigation\"><div id=\"pageOverlay\" class=\"overlay hidden\"></div><custom-spinner id=\"spCustomSpinner\"></custom-spinner><logout-form></logout-form><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div><strong>Copyright</strong> © <span id=\"footerYear\">2018</span>, PNI Digital Media ULC. All Rights Reserved.</div></div><script>\r\n  document.getElementById(\"footerYear\").innerHTML = new Date().getFullYear();\r\n</script>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<div class=\"row border-bottom white-bg\"><nav class=\"navbar navbar-static-top\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button></div><div class=\"navbar-collapse collapse\" id=\"navbar\"><div class=\"col-md-3\"><a class=\"navbar-brand\"><img src=\"assets/images/flightdeck-estimator-logo.png\" alt=\"FlightDeck Estimator logo\"></a></div><div class=\"col-md-6\"><ul class=\"nav navbar-nav\"><li ng-class=\"{active: $state.current.name.includes(\'app.quote\')}\"><a ui-sref=\"app.quote.list\">{{getWord(\'Quotes\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.customer\')}\"><a ui-sref=\"app.customer.list\">{{getWord(\'Customers\')}}</a></li><li uib-dropdown=\"\" ng-class=\"{active: $state.current.name.includes(\'app.settings\')}\" ng-show=\"user.userRole!=1 && user.userRole!=3\"><a href=\"#\" uib-dropdown-toggle=\"\"><span>{{getWord(\'Setup\')}}</span><i class=\"m-l-xs fa fa-angle-down\"></i></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-class=\"{active: $state.current.name.includes(\'app.settings.products\')}\"><a ui-sref=\"app.settings.products.list\">{{getWord(\'Products\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.settings.product-codes\')}\"><a ui-sref=\"app.settings.product-codes.list\">{{getWord(\'ProductCodes\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.settings.sources\')}\"><a ui-sref=\"app.settings.sources.list\">{{getWord(\'Sources\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.settings.system-roles\')}\"><a ui-sref=\"app.settings.system-roles.list\">{{getWord(\'SystemRoles\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.settings.system-users\')}\"><a ui-sref=\"app.settings.system-users.list\">{{getWord(\'SystemUsers\')}}</a></li><li ng-class=\"{active: $state.current.name.includes(\'app.settings.system-settings\')}\"><a ui-sref=\"app.settings.system-settings.list\">{{getWord(\'SystemSettings\')}}</a></li></ul></li></ul></div><div class=\"col-md-3\"><ul class=\"nav navbar-top-links navbar-right\"><li><a id=\"username\"><i class=\"fa fa-user\"></i>{{user.login}}</a></li><li><a id=\"logoutLink\" data-toggle=\"modal\" data-target=\"#logOutModal\" ng-click=\"confirmLogOut(user.login)\"><i class=\"fa fa-sign-out\"></i>{{getWord(\'LogOut\')}}</a></li></ul></div></div></nav></div>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header hide\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li><a id=\"logoutLink\" data-toggle=\"modal\" data-target=\"#logOutModal\" ng-click=\"confirmLogOut(user.login)\"><i class=\"fa fa-sign-out\"></i>{{getWord(\'LogOut\')}}</a></li></ul></nav></div>");
$templateCache.put("app/common/language/language-selector.tpl.html","<ul class=\"header-dropdown-list hidden-xs ng-cloak\" ng-controller=\"languageCtrl\"><li class=\"dropdown hide\" dropdown=\"\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"\"><img src=\"{{setBuildInfo(\'styles/img/blank.gif\')}}\" class=\"flag flag-{{currentLanguage.key}}\" alt=\"{{currentLanguage.alt}}\"> <span>{{currentLanguage.title}}</span> <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu pull-right\"><li ng-class=\"{active: language==currentLanguage}\" ng-repeat=\"language in languages\"><a ng-click=\"selectLanguage(language)\"><img src=\"{{setBuildInfo(\'styles/img/blank.gif\')}}\" class=\"flag flag-{{language.key}}\" alt=\"{{language.alt}}\"> {{language.title}}</a></li></ul></li></ul>");
$templateCache.put("app/dashboard/views/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1><b>{{helloText}}</b></h1></div></div></div></div>");
$templateCache.put("app/quote/partials/quoteCreateErrorBadge.html","<div id=\"quantity-error-badge\" class=\"hide m-t-n\" ng-show=\"errorArr.length>0\"><div id=\"quantityAlert\" class=\"alert alert-warning alert-dismissable m-b-sm\"><button aria-hidden=\"true\" class=\"close\" type=\"button\" ng-click=\"closeAlert()\">×</button> <i class=\"fa-fw fa-lg fa fa-times-circle m-r-sm text-danger\"></i><div class=\"m-l-lg\" style=\"margin-top: -17px\"><div ng-repeat=\"error in errorArr\"><span><span class=\"font-weight-bold\" ng-show=\"error.itemNumber\">{{error.itemNumber}}&nbsp;&#45;&nbsp;</span> <span class=\"font-weight-bold\" ng-show=\"error.itemName\">{{error.itemName}}&nbsp;&#45;&nbsp;</span> <span class=\"font-weight-bold\" ng-show=\"error.name\">{{error.name}}&nbsp;&#45;&nbsp;</span> <span class=\"secondary-bold-text\" ng-show=\"error.message\">{{error.message}}</span></span></div></div></div></div>");
$templateCache.put("app/quote/partials/quoteWarningBanner.html","<div id=\"warning-banner\" class=\"hide m-t-n\" ng-show=\"warningArray.length>0\"><div id=\"warningBannerAlert\" class=\"alert alert-warning alert-dismissable m-b-sm\"><button aria-hidden=\"true\" class=\"close\" type=\"button\" ng-click=\"closeWarningAlert()\">×</button> <i class=\"fa-fw fa-lg fa fa-warning m-r-sm text-warning\"></i><div class=\"m-l-lg\" style=\"margin-top: -17px\"><div ng-repeat=\"warning in warningArray\"><span><span class=\"font-weight-bold\" ng-show=\"warning.itemName\">{{warning.itemName}}&nbsp;&#45;&nbsp;</span> <span class=\"font-weight-bold\" ng-show=\"warning.name\">{{warning.name}}&nbsp;&#45;&nbsp;</span> <span class=\"secondary-bold-text\" ng-show=\"warning.message\">{{warning.message}}</span></span></div></div></div></div>");
$templateCache.put("app/quote/partials/quotesHeader.tpl.html","<div class=\"wrapper quote-info-padding fadeIn\"><div class=\"row\"><div class=\"col-lg-12 custom-panel\"><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"ibox-tools\"><a class=\"collapse-link collapsed\" id=\"quoteHeaderLink\" data-toggle=\"collapse\" data-target=\"#quoteHeader\"><i></i><h5><span ng-bind=\"quoteNumberLabel\"></span><span ng-bind-html=\"quoteStatus\"></span></h5></a></div><a ng-show=\"quoteHistoryId && (!readOnly || quotehistoryFlag) && user.userRole!= users.Coa\" ng-click=\"quoteHistoryList(quoteHistoryId)\" class=\"version-align\">{{getWord(\'QuoteHistory\')}}</a></div><div class=\"ibox-content collapse\" id=\"quoteHeader\"><div class=\"row\"><div class=\"col-md-3\"><h4>{{getWord(\'Customer\')}} <a style=\"margin-top: 2px;\" class=\"pull-right f-s-12\" ng-show=\"convertQuoteFlag && convertReviewFlag && !readOnly\" ng-click=\"editCustomerForConvert(customerId,quoteId)\" ng-bind=\"getWord(\'EditCustomer\')\"></a></h4><div class=\"row\" ng-show=\"quoteData.fullName && quoteData.fullName.length <= 100\"><div class=\"col-md-4\">{{getWord(\'Name\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.fullName\"></div></div><div class=\"row\" ng-show=\"quoteData.companyName && quoteData.companyName.length <= 100\"><div class=\"col-md-4\">{{getWord(\'Company\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.companyName\"></div></div><div class=\"row\" ng-show=\"quoteData.accountNumber && quoteData.accountNumber.length <=100\"><div class=\"col-md-4\">{{getWord(\'AccountNo\')}}&#46;</div><div class=\"col-md-8\" ng-bind=\"quoteData.accountNumber\"></div></div><div class=\"row\" ng-show=\"quoteData.hasAddressDetails\"><div class=\"col-md-4\">{{getWord(\'Address\')}}</div><div class=\"col-md-8\"><p class=\"address add-margin\"><span ng-show=\"quoteData.street1\" ng-bind=\"quoteData.street1\"></span> <span ng-show=\"quoteData.street2\" ng-bind=\"quoteData.street2\"></span> <span ng-show=\"quoteData.street3\" ng-bind=\"quoteData.street3\"></span> <b><span ng-show=\"quoteData.city\" ng-bind=\"quoteData.city\"></span> <span ng-show=\"quoteData.state\" ng-bind=\"\',\' + quoteData.state\"></span> <span ng-show=\"quoteData.postalCode\" ng-bind=\"\'-\' + quoteData.postalCode\"></span> <span ng-show=\"quoteData.country && (quoteData.postalCode || quoteData.city || quoteData.street1)\" ng-bind=\"\', \' + quoteData.country.toUpperCase()\"></span></b></p></div></div><div class=\"row\" ng-show=\"quoteData.email || quoteData.quoteData.header.customerInfo.quoteBillTo.email\"><div class=\"col-md-4\">{{getWord(\'E-mail\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.email || quoteData.quoteData.header.customerInfo.quoteBillTo.email\"></div></div><div class=\"row\" ng-show=\"quoteData.phoneNumber\"><div class=\"col-md-4\">{{getWord(\'Phone\')}}</div><div class=\"col-md-8\"><span>{{quoteData.countryCode || \'+1\'}}</span> <span ng-show=\"quoteData.phoneNumber\">{{quoteData.phoneNumber | phoneFilter}}</span> <span ng-show=\"quoteData.phoneExt\">&nbsp;{{getWord(\'Ext\')}}&nbsp;{{quoteData.phoneExt}}</span></div></div><div class=\"row\"><div class=\"col-md-4\" ng-bind=\"getWord(\'Subtotal\')\"></div><div class=\"col-md-8\"><span id=\"quoteSubtotalSummary\">{{partialQuoteData.quoteSubTotal}}</span></div></div><div class=\"row\"><div class=\"col-md-4\" ng-bind=\"getWord(\'VendorTotal\')\"></div><div class=\"col-md-8\"><span id=\"quoteVendorTotalSummary\">{{partialQuoteData.vendorTotal}}</span></div></div><div class=\"row\" ng-show=\"!quoteData.fullName && !quoteData.companyName && !quoteData.accountNumber\"><div class=\"col-md-12\">{{getWord(\'NoCustomerInformation\')}}</div></div></div><div class=\"col-md-3\"><h4>{{getWord(\'Source\')}}</h4><div class=\"row\" ng-show=\"quoteData.sourceName\"><div class=\"col-md-4\">{{getWord(\'Name\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.sourceName\"></div></div><div class=\"row\" ng-show=\"quoteData.sourceName\"><div class=\"col-md-4\">{{getWord(\'PriceType\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.priceType\"></div></div><div class=\"row\" ng-show=\"quoteData.referenceNumber && quoteData.referenceNumber.length <= 50\"><div class=\"col-md-4\">{{getWord(\'ReferenceNo\')}}&#46;</div><div class=\"col-md-8\" ng-bind=\"quoteData.referenceNumber\"></div></div><div class=\"row\" ng-show=\"!quoteData.sourceName && !quoteData.referenceNumber\"><div class=\"col-md-12\">{{getWord(\'NoSourceInformation\')}}</div></div><h4 class=\"m-t-medium\">{{getWord(\'Requester\')}}</h4><div class=\"row\" ng-show=\"quoteData.requesterFullName && quoteData.requesterFullName.length <= 100\"><div class=\"col-md-4\">{{getWord(\'Name\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.requesterFullName\"></div></div><div class=\"row\" ng-show=\"quoteData.requesterPhoneNumber && quoteData.requesterPhoneNumber.length <=20\"><div class=\"col-md-4\">{{getWord(\'Phone\')}}</div><div class=\"col-md-8\"><span ng-bind=\"quoteData.requesterCountryCode || \'+1\'\"></span> <span ng-bind=\"quoteData.requesterPhoneNumber | phoneFilter\"></span></div></div><div class=\"row\" ng-show=\"quoteData.requesterPhExtension && quoteData.requesterPhExtension.length <=10\"><div class=\"col-md-4\">{{getWord(\'Extension\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.requesterPhExtension\"></div></div><div class=\"row\" ng-show=\"!quoteData.requesterFullName && !quoteData.requesterPhoneNumber && !quoteData.requesterPhExtension\"><div class=\"col-md-12\">{{getWord(\'NoRequesterInformation\')}}</div></div></div><div class=\"col-md-3\"><h4>{{getWord(\'Additional Info\')}}</h4><div class=\"row\" ng-show=\"quoteData.projectDescription && quoteData.projectDescription.length <= 100\"><div class=\"col-md-4\" style=\"word-break: normal\">{{getWord(\'ProjectDescription\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.projectDescription\"></div></div><div class=\"row\" ng-show=\"convertQuoteFlag && quoteData.term\"><div class=\"col-md-4\">{{getWord(\'Terms\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteData.term.name\"></div></div><div class=\"row\" ng-show=\"!convertQuoteFlag\"><div class=\"col-md-4\">{{getWord(\'Terms\')}}</div><div class=\"col-md-8\"><select class=\"form-control select-width\" ng-model=\"quoteTerm\" ng-disabled=\"readOnly || termDisable\" ng-change=\"changeTerm()\"><option ng-repeat=\"quote in quoteTerms\" value=\"{{quote.value}}\">{{quote.name}}</option></select></div></div></div><div class=\"col-md-3\"><h4>{{getWord(\'Dates\')}}</h4><div class=\"row\" ng-show=\"createdDate\"><div class=\"col-md-4\">{{getWord(\'created\')}}</div><div class=\"col-md-8\" ng-bind=\"createdDate\"></div></div><div class=\"row\" ng-show=\"modifiedDate\"><div class=\"col-md-4\">{{getWord(\'Modified\')}}</div><div class=\"col-md-8\" ng-bind=\"modifiedDate\"></div></div><h4 class=\"m-t-medium\">{{getWord(\'LastModifiedBy\')}}</h4><div class=\"row\" ng-show=\"user.login\"><div class=\"col-md-4\">{{getWord(\'Username\')}}</div><div class=\"col-md-8\" ng-bind=\"quoteUser.login\"></div></div><div class=\"row\" ng-show=\"versionNumber\"><div class=\"col-md-4\">{{getWord(\'Version\')}}</div><div class=\"col-md-8\" ng-bind=\"versionNumber\"></div></div><h4 class=\"m-t-medium\" ng-show=\"orderNumber || facilityName\">{{getWord(\'FlightDeck\')}}</h4><div class=\"row\" ng-show=\"orderNumber\"><div class=\"col-md-4\">{{getWord(\'OrderNo.\')}}</div><div class=\"col-md-8\" ng-bind=\"orderNumber\"></div></div><div class=\"row\" ng-show=\"facilityName\"><div class=\"col-md-4\">{{getWord(\'Facility\')}}</div><div class=\"col-md-8\" ng-bind=\"facilityName\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/quote/views/edit.html","<add-user-notes-modal></add-user-notes-modal><view-user-notes-modal></view-user-notes-modal><div class=\"wrapper wrapper-content p-t-sm\"><div class=\"row custom-layout p-l-sm\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : createBreadcrumb},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'active\':true,\'label\':createBreadcrumb}]\"></big-breadcrumbs><div class=\"custom-wizard-wrap\"><div class=\"row\"><div class=\"wizard stepwizard\"><div class=\"steps clearfix stepwizard-row setup-panel\"><div a-disabled=\"!navProperties.quoteInformation.isQuoteInformationEnabled\" class=\"stepwizard-step\" ng-class=\"{\'current\': $state.current.name.indexOf(\'.step_one\') >=0}\"><a a-disabled=\"!navProperties.quoteInformation.isQuoteInformationEnabled\" ui-sref=\".step_one\" class=\"btn btn-primary btn-circle\" ng-click=\"clickDataStep(1)\"><span>1</span><i>&#10003;</i></a> <span>{{getWord(\'QuoteInfo\')}}</span></div><div a-disabled=\"!navProperties.addItems.isItemShippingEnabled\" class=\"stepwizard-step\" ng-class=\"{\'current\': $state.current.name.indexOf(\'.step_two\') >=0}\"><a a-disabled=\"!navProperties.addItems.isItemShippingEnabled\" ui-sref=\".step_two\" class=\"btn btn-primary btn-circle\" ng-click=\"clickDataStep(2)\"><span>2</span><i>&#10003;</i></a> <span>{{getWord(\'Items\')}}</span></div><div a-disabled=\"!navProperties.quoteReview.isQuoteReviewEnabled\" class=\"stepwizard-step\" ng-class=\"{\'current\': $state.current.name.indexOf(\'.step_three\') >=0}\"><a a-disabled=\"!navProperties.quoteReview.isQuoteReviewEnabled\" ui-sref=\".step_three\" class=\"btn btn-primary btn-circle\" ng-click=\"clickDataStep(3)\"><span>3</span><i>&#10003;</i></a> <span>{{getWord(\'Summary\')}}</span></div></div></div></div></div></div><generic-modal header-tittle=\"RestoreVersion\" label-submit=\"RestoreVersion\" modal-body=\"RestoreQuoteBody\"></generic-modal><warning-badge class=\"m-t-imp\"></warning-badge><quotes-header></quotes-header><div class=\"wrapper quote-info-padding fadeIn\" ng-if=\"navProperties.quoteReview.isQuoteReviewEnabled\"><div class=\"row\"><div class=\"col-lg-12 custom-panel\"><div class=\"ibox\"><div class=\"ibox-title\" style=\"padding: 5px 15px 7px !important;\"><div class=\"ibox-tools\" style=\"margin-top: 0px !important;\"><a class=\"collapse-link collapsed\" id=\"quoteNotesLink\" data-toggle=\"collapse\" data-target=\"#quoteNotes\"><i></i><h5><span class=\"ng-binding\">Notes</span><span class=\"label label-success status-label\">{{userNoteCount}}</span></h5></a></div><div class=\"btn-group pull-right m-l-sm\"><button class=\"btn btn-success\" data-toggle=\"modal\" data-target=\"#addUserNotesModal\" ng-click=\"resetNoteForm()\"><b>+</b> Add a note</button></div></div><div class=\"ibox-content collapse\" id=\"quoteNotes\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"userNotesTable\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" dt-instance=\"dtInstance\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Time\')\"></th><th ng-bind=\"getWord(\'Note Author\')\"></th><th ng-bind=\"getWord(\'Notes\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div></div></div></div><quote-create-error-badge></quote-create-error-badge><quote-warning-banner></quote-warning-banner><div class=\"wrapper quote-form-padding fadeInRight\"><cancel-confirmation-modal></cancel-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content no-padding\"><div class=\"wizard\"><div class=\"content\"><div id=\"form-views\" ui-view=\"\"></div></div></div></div></div><div class=\"ibox\" id=\"summaryFooter\" ng-show=\"navProperties.quoteReview.isQuoteReviewCurrent\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"goPrevious(2)\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"Previous\")}}</span></button><div id=\"createGrpBtn\" class=\"btn-group pull-right m-l-sm\" ng-hide=\"readOnly\" uib-dropdown=\"\"><button id=\"createBtn\" class=\"btn\" ng-click=\"finishQuoteCreate(false)\" ng-class=\"((user.userRole == users.CoaManager) || (user.isSysAdmin)) ? \'btn-success\' : \'btn-primary rightBorderRadius\'\">{{getWord(\'FinishQuote\')}}</button> <button id=\"btn2\" class=\"btn btn-success dropdown-toggle\" ng-show=\"((user.userRole == users.CoaManager) || (user.isSysAdmin))\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"font-weight-bold\" ng-click=\"finishQuoteCreate(true)\">{{getWord(\'FinishAndConvert\')}}</a></li></ul></div><button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"cancelForm()\" ng-hide=\"readOnly\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div></div></div><script type=\"text/javascript\">\r\n  window.addEventListener(\"beforeunload\", function (e) {\r\n    var confirmationMessage = \"Are you sure you want to leave this page ?\";\r\n    (e || window.event).returnValue = confirmationMessage;\r\n    return confirmationMessage;\r\n  });\r\n</script>");
$templateCache.put("app/quote/views/index.html","<div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-sm-12 col-md-3 col-lg-3 m-b-xs\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Quotes\'},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'active\':true,\'label\':\'Quotes\'}]\"></big-breadcrumbs></div><div class=\"col-sm-12 col-md-6 col-lg-6 m-b-xs inner-addon right-addon\" id=\"searchOption\"><i ng-if=\"!searchText\" class=\"glyphicon glyphicon-search\"></i> <i ng-if=\"searchText\" ng-click=\"resetSearch()\" class=\"glyphicon glyphicon-remove\"></i> <input id=\"search-by-string\" type=\"text\" class=\"input-md form-control\" maxlength=\"500\" ng-change=\"searchByString()\" ng-model-options=\"{ debounce: 600 }\" ng-model=\"searchText\" placeholder=\"Search by Quote Number, Reference Number or Customer Info\" autofocus=\"\" autocomplete=\"off\"></div><i class=\"fa fa-info-circle quote-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{searchTooltipText}}\" aria-hidden=\"true\"></i></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins m-b-xs\"><quote-filters></quote-filters><div class=\"ibox-content p-b\"><tag-builder tags=\"tags\"></tag-builder><page-dropdown-length class=\"m-t-n-xs\" ng-hide=\"searchText == \'\'\"></page-dropdown-length></div><div class=\"ibox-content\" ng-cloak=\"quoteListData\"><table id=\"quoteListDatatable\" quote-server-side-table=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Quote\')\"></th><th ng-bind=\"getWord(\'Source\')\"></th><th ng-bind=\"getWord(\'Status\')\"></th><th ng-bind=\"getWord(\'Customer\')\"></th><th ng-bind=\"getWord(\'LastModifiedBy\')\"></th><th ng-bind=\"getWord(\'DateModified\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/quote/views/quoteHistory.html","<div class=\"wrapper wrapper-content padding-top\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Quote History\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'active\':true,\'label\':\'Quote History\'}]\"></big-breadcrumbs><generic-modal header-tittle=\"RestoreVersion\" label-submit=\"RestoreVersion\" modal-body=\"RestoreQuoteBody\"></generic-modal><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"quoteHistoryDatatable\" datatable-basic=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Version\')\"></th><th ng-bind=\"getWord(\'LastModified\')\"></th><th ng-bind=\"getWord(\'LastModifiedBy\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div><button class=\"btn btn-default m-b-sm\" type=\"button\" ng-click=\"goToCurrentVersion()\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"BackToCurrentVersion\")}}</span></button></div></div></div>");
$templateCache.put("app/customer/partials/backToCustomerList.html","<button class=\"btn btn-default\" type=\"button\" ng-click=\"backToList()\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"Back\")}}</span></button>");
$templateCache.put("app/customer/partials/customerDetailPanel.tpl.html","<div class=\"ibox\"><div class=\"ibox-title\"><div><h2 ng-show=\"customer.fullName\"><b ng-bind=\"customer.fullName\"></b></h2><h2 ng-show=\"!customer.fullName && !customer.companyName\"><b ng-bind=\"customer.accountNumber\"></b></h2><h2 ng-show=\"((!customer.fullName && !customer.accountNumber) || (!customer.fullName && customer.accountNumber && customer.companyName))\"><b ng-bind=\"customer.companyName\"></b></h2></div><div><h4 ng-show=\"customer.accountNumber\" ng-bind=\"customer.accountNumber\"></h4><h4 ng-show=\"customer.companyName\" ng-bind=\"customer.companyName\"></h4></div><div class=\"m-t-md m-b-md\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"goToEditPage()\"><span class=\"font-weight-bold\">{{getWord(\"EditCustomer\")}}</span></button> <b ng-show=\"((user.userRole == users.CoaManager) || (user.isSysAdmin) || (user.userRole == users.EstimatorManager))\"><a class=\"pull-right customer-delete-btn\" ng-click=\"deleteCustomerInDetailsPage(\'customer\')\"><i class=\"fa fa-trash-o m-r-sm f-w-600\"></i>{{getWord(\'Delete\')}}</a></b></div></div><div class=\"ibox-content\" ng-hide=\"!customer.hasAddressDetails && !customer.hasContactDetails\"><div ng-show=\"customer.hasAddressDetails\"><label>{{getWord(\'Address\')}}</label><div ng-show=\"customer.street1\" ng-bind=\"customer.street1\"></div><div ng-show=\"customer.street2\" ng-bind=\"customer.street2\"></div><div><span ng-show=\"customer.city\" ng-bind=\"customer.city\"></span> <span style=\"margin-left: -2px\" ng-show=\"customer.city && customer.state\">&#44;</span><br ng-show=\"customer.city && !customer.state\"><span ng-show=\"customer.state\" ng-bind=\"customer.state\"></span></div><div ng-show=\"customer.postalCode||customer.country\"><span ng-show=\"customer.postalCode\" ng-bind=\"customer.postalCode + \', \'\"></span> <span ng-bind=\"customer.country.toUpperCase()\"></span></div></div><div ng-show=\"customer.hasContactDetails\" class=\"m-t-md\"><label>{{getWord(\'Contact\')}}</label><div class=\"p-b-sm\"><span class=\"m-r-sm\"><i class=\"fa fa-phone\"></i></span> <span ng-show=\"customer.countryCode\" ng-bind=\"customer.countryCode\"></span> <span ng-show=\"customer.phoneNumber\" id=\"formattedPhone\" class=\"m-r-lg\" ng-bind=\"customer.phoneNumber\"></span> <span ng-show=\"customer.phoneExt\" ng-bind=\"getWord(\'Ext\')\"></span> <span ng-show=\"customer.phoneExt\" ng-bind=\"customer.phoneExt\"></span></div><div ng-show=\"customer.email\" class=\"p-b-sm\"><span class=\"m-r-sm\"><i class=\"fa fa-envelope-o\"></i></span><span ng-bind=\"customer.email\"></span></div><div ng-show=\"customer.website\"><span class=\"m-r-sm\"><i class=\"fa fa-globe\"></i></span> <span ng-bind=\"customer.website\"></span></div></div></div></div>");
$templateCache.put("app/customer/partials/customerForm.tpl.html","<form id=\"customerForm\" autocomplete=\"off\" customer-address=\"\" class=\"form-horizontal p-sm\"><div class=\"row\"><h3>{{getWord(\'CustomerDetails\')}} <small>{{getWord(\'OneFieldRequired\')}}</small></h3></div><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=\"control-label\" for=\"txtFullName\">{{getWord(\'FullName\')}}</label> <input id=\"txtFullName\" name=\"txtFullName\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"customer.fullName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3\"><label class=\"control-label\" for=\"txtAccountNumber\">{{getWord(\'AccountNumber\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <input id=\"txtAccountNumber\" name=\"txtAccountNumber\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"customer.accountNumber\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=\"control-label\" for=\"txtCompanyName\">{{getWord(\'CompanyName\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <input id=\"txtCompanyName\" name=\"txtCompanyName\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"customer.companyName\"></div></div></div></fieldset><fieldset class=\"m-t-md row\"><div class=\"panel-group no-padding\" id=\"customerAccodion\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"pull-left m-r-sm m-t-sm\" ng-click=\"expandAddress()\" ng-class=\"{\'fa fa-angle-down fa-2x\': !customer.hasAddressDetails, \'fa fa-angle-up fa-2x\': customer.hasAddressDetails}\"></i><h2 class=\"panel-title p-sm\"><a data-toggle=\"collapse\" data-target=\"#collapse1\" ng-click=\"expandAddress()\" aria-expanded=\"true\">{{getWord(\'AddressDetails\')}}<span ng-show=\"!convertState\" class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></a></h2></div><div id=\"collapse1\" class=\"panel-collapse collapse\" ng-class=\"{\'in\' : customer.hasAddressDetails}\"><div class=\"panel-body m-t-sm m-b-md\"><address-recommendation></address-recommendation><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=\"control-label\">{{getWord(\'AddressLine1\')}}</label> <input id=\"txtStreet1\" name=\"txtStreet1\" type=\"text\" class=\"form-control satoriAddressField\" placeholder=\"Street Name\" gm-places-autocomplete=\"\" ng-show=\"disableAutoFill(\'txtStreet1\')\" ng-model=\"customer.street1\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=\"control-label\" for=\"txtStreet2\">{{getWord(\'AddressLine2\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <input id=\"txtStreet2\" name=\"txtStreet2\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"customer.street2\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-4\"><label class=\"control-label\" for=\"txtCity\">{{getWord(\'City\')}}</label> <input id=\"txtCity\" name=\"txtCity\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"customer.city\"></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\"><label class=\"control-label\" for=\"txtZipCode\">{{getWord(\'Zipcode\')}}</label> <input id=\"txtZipCode\" name=\"txtZipCode\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"customer.postalCode\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-4\"><label class=\"control-label\" for=\"cboCountry\">{{getWord(\'Country\')}}</label><select id=\"cboCountry\" name=\"cboCountry\" type=\"text\" class=\"form-control satoriAddressField\" ng-model=\"customer.country\" ng-change=\"getStates()\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option><option value=\"{{value.code}}\" ng-repeat=\"value in countries\">{{value.name}}</option></select></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\" ng-show=\"customer.country==\'US\'\"><label class=\"control-label\" for=\"cboState\">{{getWord(\'State\')}}</label><select id=\"cboState\" name=\"cboState\" class=\"form-control satoriAddressField satoriAddressField\" ng-model=\"customer.state\" data-ng-options=\"v.stateCode as v.name for v in states\"><option value=\"\" disabled=\"\" selected=\"selected\">Select</option></select></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\" ng-show=\"customer.country!=\'US\'\"><label class=\"control-label\" for=\"txtState\">{{getWord(\'State\')}}</label> <input id=\"txtState\" name=\"txtState\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"customer.state\"></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"pull-left m-r-sm m-t-sm\" ng-click=\"expandContact()\" ng-class=\"{\'fa fa-angle-down fa-2x\': !customer.hasContactDetails, \'fa fa-angle-up fa-2x\': customer.hasContactDetails}\"></i><h2 class=\"panel-title p-sm\"><a data-toggle=\"collapse\" data-target=\"#collapse2\" ng-click=\"expandContact()\" aria-expanded=\"true\">{{getWord(\'ContactDetails\')}}<span ng-show=\"!convertState\" class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></a></h2></div><div id=\"collapse2\" class=\"panel-collapse collapse\" ng-class=\"{\'in\' : customer.hasContactDetails}\"><div class=\"panel-body m-b-md\"><div class=\"row p-w-sm\"><div class=\"form-group col-xs-12 col-sm-3 col-md-3 col-lg-3\" style=\"margin-right: 15px\"><label class=\"control-label\">{{getWord(\'Phone\')}}</label><div class=\"input-group\"><span class=\"input-group-addon\" ng-bind=\"customer.countryCode\"></span> <input id=\"txtPhone\" name=\"txtPhone\" type=\"tel\" ng-show=\"disableAutoFill(\'txtPhone\')\" class=\"form-control\" data-intl-tel=\"\" ng-model=\"customer.phoneNumber\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtExtension\">{{getWord(\'Extension\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <input id=\"txtExtension\" name=\"txtExtension\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"customer.phoneExt\"></div></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4\"><label class=\"control-label\" for=\"txtEmail\">{{getWord(\'Email\')}}</label> <input id=\"txtEmail\" name=\"txtEmail\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"customer.email\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4\"><label class=\"control-label\" for=\"txtWebsite\">{{getWord(\'Website\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <input id=\"txtWebsite\" name=\"txtWebsite\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"customer.website\"></div></div></div></div><hr class=\"dashedLine m-t-none\"></div></div></fieldset><fieldset class=\"customer-update-chkbx\" ng-show=\"convertState || quoteInfoWithQuoteId || quoteInfoWithoutQuoteId\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"checkbox-wrap\" for=\"updateExistingRecord\"><input id=\"updateExistingRecord\" name=\"updateExistingRecord\" type=\"checkbox\" ng-model=\"customer.updateCustomer\">{{getWord(\'UpdateExistingRecord\')}} <span class=\"checkbox-mark\" style=\"z-index: 1\"></span></label></div></div></div></fieldset><form-actions showcheck=\"true\" create-text=\"SaveAndCreateQuote\" create-another-text=\"SaveOnly\" save-changes-text=\"{{saveText}}\"></form-actions></form>");
$templateCache.put("app/customer/partials/tabsHandler.tpl.html","<div class=\"tabs-container\"><div><ul class=\"nav nav-tabs\"><li class=\"nav-item\" ng-click=\"changeTab(1)\" ng-class=\"{\'active\' : activeQuotesTab}\" id=\"quotesTab\"><a href=\"\" data-toggle=\"tab\">{{getWord(\"QuotesCreated\")}}</a></li><li ng-click=\"changeTab(2)\" id=\"recipientsTab\" ng-class=\"{\'active\' : activeRecipientsTab}\"><a href=\"\" data-toggle=\"tab\">{{getWord(\"Recipients\")}}</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane\" id=\"quotesBody\" ng-class=\"{\'active\' : activeQuotesTab}\"><div class=\"panel-body\" style=\"overflow-x: auto;\"><table id=\"customerDetailsDatatable\" data-table-options=\"options\" datatable-basic=\"\" table-dropdown-actions=\"\" class=\"table table-hover\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Quote\')\"></th><th ng-bind=\"getWord(\'Source\')\"></th><th ng-bind=\"getWord(\'Status\')\"></th><th ng-bind=\"getWord(\'DateModified\')\"></th><th ng-bind=\"getWord(\'LastModifiedBy\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div><div class=\"tab-pane\" id=\"recipientsBody\" ng-class=\"{\'active\' : activeRecipientsTab}\" ng-controller=\"recipientCtrl\"><recipient-list></recipient-list></div></div></div></div>");
$templateCache.put("app/customer/views/details.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'label\' :\'Customers\'},{\'active\':true,\'label\':\'CustomerInfo\'}]\"></big-breadcrumbs><div class=\"col-lg-3 p-l-none\"><customer-detail-panel></customer-detail-panel><back-to-customer-list></back-to-customer-list></div><div class=\"col-lg-9\"><tabs-handler></tabs-handler></div></div></div></div>");
$templateCache.put("app/customer/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : customerEditBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' : editCustomerLabel}, {\'active\':true,\'label\':customerBreadcrumb}]\"></big-breadcrumbs><address-error-badge></address-error-badge><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><customer-form customer-accordion=\"\"></customer-form></div></div></div></div></div>");
$templateCache.put("app/customer/views/index.html","<div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Customers\'},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'active\':true,\'label\':\'Customers\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"overflow-x: auto;\"><div class=\"row\"><div class=\"col-sm-12 col-md-4 col-lg-3 m-b-xs\"><button id=\"createCustomer\" class=\"btn btn-success\" ng-click=\"createNewItem()\" ng-show=\"user.userRole!= users.Coa\"><i class=\"fa fa-plus p-r-sm\"></i> <span>Add New Customer</span></button></div><div class=\"col-sm-12 col-md-8 col-lg-6 inner-addon right-addon\"><i ng-if=\"!searchText\" class=\"glyphicon glyphicon-search\"></i> <i ng-if=\"searchText\" ng-click=\"resetSearch()\" class=\"glyphicon glyphicon-remove\"></i> <input id=\"search-by-string\" type=\"text\" class=\"input-md form-control\" maxlength=\"500\" ng-change=\"searchByString()\" ng-model-options=\"{ debounce: 600 }\" ng-model=\"searchText\" placeholder=\"Search by Name, Company or Account Number\" autofocus=\"\" autocomplete=\"off\"></div></div><table id=\"customerDatatable\" customer-server-side-table=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Name\')\"></th><th ng-bind=\"getWord(\'Company\')\"></th><th ng-bind=\"getWord(\'Address\')\"></th><th ng-bind=\"getWord(\'Contact\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/admin/systemUser/views/edit.html","<big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Basic Form\'},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'label\' :\'Forms\'},{\'active\':true,\'label\':\'Basic Form\'}]\"></big-breadcrumbs><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Basic form <small>Simple form example</small></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><pricing-rates-form></pricing-rates-form></div></div></div></div></div>");
$templateCache.put("app/admin/systemUser/views/index.html","<big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Data Tables\'},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'label\' :\'Tables\'},{\'active\':true,\'label\':\'Data Tables\'}]\"></big-breadcrumbs><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div id=\"ibox1\" class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Basic Data Tables Example <small>Sort, search</small></h5><div ibox-tools=\"\"></div></div><widget-data-toolbar class=\"widget-body-toolbar\" label=\"AddNewItem\"></widget-data-toolbar><div class=\"ibox-content\"><table datatable-basic=\"\" data-table-options=\"options\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr role=\"row\"><th>FirstName</th><th>LastName</th></tr></thead><tbody></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Table with data from $scope - <strong>(The angular way)</strong></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table id=\"testDatatable\" responsive-angular-datatable=\"\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\" dt-columns=\"dtColumnDefs\"><thead><tr><th>ID</th><th>FirstName</th><th>LastName</th></tr></thead><tbody><tr ng-repeat=\"person in persons\"><td>{{ person.id }}</td><td>{{ person.firstName }}</td><td>{{ person.lastName }}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/admin/systemUser/partials/pricing-rates-form.tpl.html","<form class=\"form-horizontal p-sm\"><fieldset><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label class=\"control-label\"><code>clear button example</code></label><div class=\"inner-addon right-addon\"><i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"clearText()\" ng-show=\"price.test\" style=\"color: #d77675; font-size: 20px;\"></i> <input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"price.test\"></div></div></div></div></fieldset><fieldset><div class=\"row\"><div class=\"col-lg-6\"><div class=\"padded-row form-group\"><div angucomplete-alt=\"\" id=\"ex1\" placeholder=\"Search countries\" maxlength=\"50\" pause=\"100\" selected-object=\"selectedCountry\" local-data=\"countries\" search-fields=\"name,code\" title-field=\"name\" minlength=\"0\" input-class=\"form-control form-control-small\" match-class=\"highlight\" template-url=\"/my-custom-template.html\"></div><script type=\"text/ng-template\" id=\"/my-custom-template.html\"><div class=\"angucomplete-holder\" ng-class=\"{\'angucomplete-dropdown-visible\': showDropdown}\"> <p>This is custom</p> <input ng-model=\"searchStr\" ng-disabled=\"disableInput\" type=\"text\" placeholder=\"{{placeholder}}\" ng-focus=\"onFocusHandler()\" class=\"{{inputClass}}\" ng-focus=\"resetHideResults()\" ng-blur=\"hideResults($event)\" autocapitalize=\"off\" autocorrect=\"off\" autocomplete=\"off\" ng-change=\"inputChangeHandler(searchStr)\"/> <div class=\"angucomplete-dropdown\" ng-show=\"showDropdown\" style=\"overflow: auto; max-height: 400px; width: 100%;\"> <div class=\"angucomplete-searching\" ng-show=\"searching\" ng-bind=\"textSearching\"> </div> <div class=\"angucomplete-searching\" ng-show=\"!searching && (!results || results.length == 0)\" ng-bind=\"textNoResults\"></div> <div class=\"angucomplete-row \" ng-show=\"results.length > 0\"> <span class=\"text-muted\">Top results</span> </div> <div class=\"angucomplete-row\" ng-repeat=\"result in results\" ng-click=\"selectResult(result)\" ng-mouseenter=\"hoverRow($index)\" ng-class=\"{\'angucomplete-selected-row\': $index == currentIndex}\"> <div ng-if=\"imageField\" class=\"angucomplete-image-holder\"> <img ng-if=\"result.image && result.image != \'\'\" ng-src=\"{{result.image}}\" class=\"angucomplete-image\"/> <div ng-if=\"!result.image && result.image != \'\'\" class=\"angucomplete-image-default\"></div> </div> <div class=\"angucomplete-title\" ng-if=\"matchClass\"> <div class=\"angucomplete-row \"> <table width=\"100%\"> <tr> <td style=\"text-align: left\" width=\"10%\" class=\"fa fa-address-book\"> <!--</td>--> <td style=\"text-align: left\" width=\"45%\"> <span ng-bind-html=\"result.title\"></span> <br> <span class=\"text-muted\">william</span> </td> <td width=\"45%\" style=\"text-align: right\" ng-bind-html=\"result.originalObject.code\"> </td> </tr> </table> </div> </div> <div ng-if=\"matchClass && result.description && result.description != \'\'\" class=\"angucomplete-description\" ng-bind-html=\"result.description\"></div> <div ng-if=\"!matchClass && result.description && result.description != \'\'\" class=\"angucomplete-description\">{{result.description}} </div> </div> <div class=\"angucomplete-row\" ng-click=\"selectResult({title: searchStr, originalObject: { name: searchStr, custom: true }})\" ng-mouseenter=\"hoverRow(results.length)\" ng-class=\"{\'angucomplete-selected-row\': results.length == currentIndex}\"> <div class=\"angucomplete-title\">Select a customer or company <span ng-show=\"searchStr\">\'{{ searchStr }}\'</span></div> </div> </div> </div></script></div></div></div></fieldset></form>");
$templateCache.put("app/admin/systemUser/partials/step_one.html","<form id=\"hey\" name=\"hey\" step-one=\"\" autocomplete=\"off\"><fieldset><h2>Account Information</h2><div class=\"row\"><div class=\"col-lg-8\"><div class=\"form-group\"><label class=\"control-label\">Username *</label> <input id=\"txtName\" ng-model=\"formData.username\" name=\"txtName\" type=\"text\" class=\"form-control\"></div><div class=\"form-group\"><label class=\"control-label\">Password *</label> <input id=\"password\" ng-model=\"formData.password\" name=\"password\" type=\"text\" class=\"form-control\"></div><div class=\"form-group\"><label class=\"control-label\">Confirm Password *</label> <input id=\"confirm\" name=\"confirm\" type=\"text\" class=\"form-control required\"></div></div></div><div><button type=\"submit\" class=\"btn btn-primary\">Next</button></div></fieldset></form>");
$templateCache.put("app/admin/systemUser/partials/step_three.html","<fieldset><h2>Terms and Conditions</h2><input id=\"acceptTerms\" name=\"acceptTerms\" type=\"checkbox\" ng-model=\"formData.terms\" class=\"required\"> <label for=\"acceptTerms\">I agree with the Terms and Conditions.</label></fieldset><fieldset class=\"m-t-md\"><a ui-sref=\"app.admin.pricing.edit.step_two\" class=\"btn btn-default\">Previous</a> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></fieldset>");
$templateCache.put("app/admin/systemUser/partials/step_two.html","<fieldset><h2>Profile Information</h2><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>First name *</label> <input id=\"name\" name=\"name\" ng-model=\"formData.name\" type=\"text\" class=\"form-control required\"></div><div class=\"form-group\"><label>Last name *</label> <input id=\"surname\" name=\"surname\" ng-model=\"formData.lastName\" type=\"text\" class=\"form-control required\"></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Email *</label> <input id=\"email\" name=\"email\" type=\"text\" ng-model=\"formData.email\" class=\"form-control required email\"></div><div class=\"form-group\"><label>Address *</label> <input id=\"address\" name=\"address\" type=\"text\" ng-model=\"formData.address\" class=\"form-control\"></div></div></div><a ui-sref=\"app.admin.pricing.edit.step_one\" class=\"btn btn-default\">Previous</a> <a ui-sref=\"app.admin.pricing.edit.step_three\" class=\"btn btn-primary\">Next</a></fieldset>");
$templateCache.put("app/common/datatables/partials/assign-actions.tpl.html","<div class=\"form-actions m-t\"><div class=\"row\"><div class=\"col-md-12\"><button ng-show=\"id\" ng-disabled=\"assignRemoveButton\" ng-click=\"assignRemove()\" class=\"btn btn-success pull-right m-l-sm\" type=\"button\" ng-bind=\"getWord(\'Save\')\"></button> <button class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"cancelForm()\" ng-bind=\"getWord(\'Cancel\')\"></button></div></div></div>");
$templateCache.put("app/common/datatables/partials/bigBreadcrumbs.html","<div class=\"row wrapper page-heading p-h-xs p-l-sm\"><div class=\"col-lg-10\"><ol class=\"breadcrumb\"><li ng-repeat=\"item in breadItems\" ng-class=\"\'active\' ? item.active:\'\'\"><a ui-sref=\"{{item.href || currentState}}\" ng-bind=\"item.label\" class=\"font-weight-bold\" ng-hide=\"item.active\"></a> <strong ng-show=\"item.active\" ng-bind=\"item.label\"></strong></li></ol><h2 ng-bind=\"header\" ng-show=\"header\" class=\"m-t-sm m-b-xs font-weight-bold\"></h2></div></div>");
$templateCache.put("app/common/datatables/partials/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/common/datatables/partials/page-dropdown-length.tpl.html","<div id=\"dtGlobalList_length\" class=\"page-dropdown-inline pull-right m-r-md\"><label><select name=\"dtGlobalList_length\" ng-model=\"dataTablePageLength\" ng-change=\"changePageLength()\" aria-controls=\"dtGlobalList\" class=\"form-control input-sm select-cus-dd\"><option value=\"10\">10</option><option value=\"25\">25</option><option value=\"50\">50</option><option value=\"100\">100</option></select></label></div>");
$templateCache.put("app/common/datatables/partials/widget-data-toolbar.tpl.html","<div class=\"widget-body-toolbar\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 text-right\"><button class=\"btn btn-primary\" ng-click=\"createNewItem()\"><span ng-bind=\"label\">Add Row</span></button></div></div></div>");
$templateCache.put("app/common/datatables/templates/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/common/datatables/templates/widget-data-toolbar.tpl.html","<div class=\"widget-body-toolbar\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 text-right\"><button class=\"btn btn-primary\" ng-click=\"createNewItem()\"><span ng-bind=\"label\">Add Row</span></button></div></div></div>");
$templateCache.put("app/common/forms/partials/form-actions.tpl.html","<div class=\"form-actions\"><div class=\"row\" ng-show=\"!activeView\"><div class=\"col-md-12\"><div id=\"createGrpBtn\" ng-show=\"!id\" class=\"btn-group pull-right m-l-sm\" uib-dropdown=\"\"><button id=\"createBtn\" class=\"btn btn-success\" ng-click=\"addAnother=false\" type=\"submit\" ng-bind=\"createText\">CreateText</button> <button id=\"btn3\" class=\"btn btn-success\" ng-show=\"showArrow\" type=\"submit\"><span class=\"fa fa-angle-right\"></span></button> <button id=\"btn2\" ng-show=\"showCheck && !id\" type=\"submit\" class=\"btn btn-success dropdown-toggle\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a id=\"submitAnother\" class=\"font-weight-bold\" ng-click=\"addAnother=true\" type=\"submit\" ng-bind=\"createAnotherText\">CreateAndAddAnother</a></li></ul></div><button id=\"saveBtn\" ng-show=\"id\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\" ng-bind=\"saveChangesText\">{{getWord(\'SaveChanges\')}}</button> <button id=\"cancelBtn\" ng-show=\"!activeView\" class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"cancelForm()\">{{getWord(\'Cancel\')}}</button> <button id=\"closeBtn\" ng-show=\"activeView\" class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"cancelForm()\">{{getWord(\'Close\')}}</button></div></div><div class=\"row\" ng-show=\"activeView\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"cancelForm()\" ng-bind=\"Close\"></button></div></div>");
$templateCache.put("app/common/generic/partials/address-error-badge.tpl.html","<div id=\"address-error-badge\" ng-show=\"invalidAddress || modifiedAddress\"><div id=\"addressAlert\" class=\"alert alert-warning alert-dismissable m-b-sm\" style=\"border-color: #f5a90c;\"><button aria-hidden=\"true\" data-dismiss=\"alert\" class=\"close\" type=\"button\">×</button> <i class=\"fa-fw fa-lg fa fa-warning m-r-sm\" style=\"color: #f5a90c;\"></i> {{getWord(\'InvalidAddressMessageAlert\')}}</div></div>");
$templateCache.put("app/common/generic/partials/addressRecommendation.tpl.html","<div><div class=\"row\" ng-show=\"modifiedAddress\"><div id=\"address-error-badge\" class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><div id=\"addressAlert\" class=\"alert alert-warning no-padding\" style=\"border-color: #f5a90c;\"><div class=\"table-responsive\"><table class=\"table\"><thead></thead><tbody><tr><td class=\"no-borders\"><span class=\"textIntent\"><label><input type=\"radio\" ng-model=\"updatedFullValue\" name=\"optionsRadiosFull\" ng-change=\"showRecommendedAddress()\" id=\"optionsRadiosFull1\" value=\"optionFull1\" checked=\"\"> <strong>Suggested address:</strong></label> <span class=\"textIntent\" ng-if=\"updatedModifiedAddress.street2\">{{updatedModifiedAddress.street1 + \' \' + updatedModifiedAddress.street2}}</span> <span class=\"textIntent\" ng-if=\"!updatedModifiedAddress.street2\">{{updatedModifiedAddress.street1}}</span> <span class=\"textIntent\">{{updatedModifiedAddress.city + \' \' + updatedModifiedAddress.state + \' \' + updatedModifiedAddress.postalCode}}</span></span></td><td class=\"no-borders\"><input type=\"button\" ng-show=\"showRecommended == true\" ng-click=\"recommendedAddress()\" class=\"btn btn-default pull-right\" value=\"Select address\"></td></tr><tr><td><span class=\"textIntent\"><label><input type=\"radio\" ng-model=\"updatedFullValue\" name=\"optionsRadiosFull\" ng-change=\"showKeepOriginalAddress()\" id=\"optionsRadiosFull2\" value=\"optionFull2\"> <strong>Use the address you provided:</strong></label> <span class=\"textIntent\" ng-if=\"unmodifiedAddress.street2\">{{unmodifiedAddress.street1 + \' \' + unmodifiedAddress.street2}}</span> <span class=\"textIntent\" ng-if=\"!unmodifiedAddress.street2\">{{unmodifiedAddress.street1}}</span> <span class=\"textIntent\">{{unmodifiedAddress.city + \' \' + unmodifiedAddress.state + \' \' + unmodifiedAddress.postalCode}}</span></span></td><td><input id=\"btnRecommendedAddress\" type=\"button\" ng-show=\"keepOriginal == true\" ng-click=\"originalAddress()\" class=\"btn btn-default pull-right\" value=\"Select address\"></td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-show=\"invalidAddress\"><div id=\"invalid-address-table-widget\" class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><div class=\"alert alert-warning no-padding\" style=\"border-color: #f5a90c;\"><div class=\"table-responsive\"><table class=\"table m-b-sm\"><thead></thead><tbody><tr><td><span class=\"textIntent\"><strong>Use the address you provided:</strong></span><div class=\"textIntent\" ng-if=\"unmodifiedAddress.street2\">{{unmodifiedAddress.street1 + \' \' + unmodifiedAddress.street2}}</div><div class=\"textIntent\" ng-if=\"!unmodifiedAddress.street2\">{{unmodifiedAddress.street1}}</div><div class=\"textIntent\">{{unmodifiedAddress.city + \' \' + unmodifiedAddress.state + \' \' + unmodifiedAddress.postalCode}}</div></td><td><input id=\"btnOriginalAddress\" type=\"button\" ng-show=\"true\" ng-click=\"originalAddress()\" class=\"btn btn-default pull-right\" value=\"Select address\"></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/common/generic/partials/cancel-confirmation-modal.tpl.html","<div class=\"modal fade\" role=\"dialog\" id=\"cancelModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{cancelNotificationTitle}}</b></h3></div><div class=\"modal-body\"><p ng-bind-html=\"cancelNotificationMessage\" style=\"word-break: break-word;\"></p></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-success pull-right m-l-sm\" data-dismiss=\"modal\" ng-click=\"cancelConfirmation()\" ng-bind=\"confirmCancelText\"></button> <button id=\"cancelBtn\" type=\"button\" class=\"btn btn-default pull-right no-borders\" data-dismiss=\"modal\" ng-bind=\"closeText\"></button></div></div></div></div></div></div>");
$templateCache.put("app/common/generic/partials/delete-confirmation-modal.tpl.html","<div class=\"modal fade\" role=\"dialog\" id=\"deleteModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{deleteNotificationTitle}}</b></h3></div><div class=\"modal-body\"><p ng-bind-html=\"deleteNotificationMessage\" style=\"word-break: break-word;\"></p></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-success pull-right m-l-sm\" data-dismiss=\"modal\" ng-click=\"deleteConfirmation()\" ng-bind=\"confirmText\"></button> <button id=\"cancelBtn\" type=\"button\" class=\"btn btn-default pull-right no-borders\" data-dismiss=\"modal\" ng-bind=\"cancelText\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div>");
$templateCache.put("app/common/generic/partials/genericModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"genericModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{headerTittle}}</b></h3></div><div class=\"modal-body\"><p ng-bind-html=\"modalBody\" style=\"word-break: break-word;\"></p></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"restoreBtn\" class=\"btn btn-success pull-right m-l-sm\" ng-click=\"submitModal()\">{{labelSubmit}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancelModal()\">{{labelCancel}}</button></div></div></div></div></div></form>");
$templateCache.put("app/common/generic/partials/warningBadge.tpl.html","<div id=\"warning-badge\" class=\"hide m-t-n\"><div id=\"warningAlert\" class=\"alert alert-warning alert-dismissable m-b-sm\" style=\"border-color: #f5a90c;\"><button ng-hide=\"true\" aria-hidden=\"true\" data-dismiss=\"alert\" class=\"close\" type=\"button\">×</button> <i class=\"fa-fw fa-lg fa fa-warning m-r-sm\" style=\"color: #f5a90c;\"></i> <span class=\"font-weight-bold\" ng-show=\"versionNumber\">{{warningTitleText}}&nbsp;{{versionNumber}}</span> <span ng-show=\"warningTitleText && warningMsgText\">&nbsp;&#45;&nbsp;</span> <span ng-show=\"warningMsgText\" ng-bind=\"warningMsgText\"></span> <span class=\"m-l-lg f-w-600\"><a ng-click=\"primaryLinkFn()\" ng-show=\"primaryLinkText\" ng-bind=\"primaryLinkText\"></a> <a class=\"m-l-lg\" ng-click=\"secondaryLinkFn()\" ng-show=\"secondaryLinkText\" ng-bind=\"secondaryLinkText\"></a></span></div></div>");
$templateCache.put("app/quote/partials/convertQuote/addNotesModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"addNotesModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddNotes\')}}</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><textarea class=\"form-control\" id=\"txtItemNotes\" name=\"txtItemNotes\" rows=\"6\" maxlength=\"250\" ng-trim=\"false\" style=\"resize: vertical;\" ng-model=\"newNotes\"></textarea> <span class=\"form-help optional-bold-text pull-right\">{{250-newNotes.length}}&nbsp;{{getWord(\'CharactersRemaining\')}}</span></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-success pull-right m-l-sm m-r\" type=\"submit\">{{getWord(\'AddNotes\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/convertQuote/addUserNotesModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"addUserNotesModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddNotes\')}}</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>Name of Author</label> <input class=\"form-control\" id=\"userName\" name=\"userName\" disabled=\"\" value=\"{{username}}\"><br></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>Add Note Contents</label> <textarea class=\"form-control\" id=\"txtNotes\" name=\"txtNotes\" rows=\"6\" maxlength=\"300\" minlength=\"1\" ng-trim=\"false\" style=\"resize: vertical;\" ng-model=\"newNotes\"></textarea> <span class=\"form-help optional-bold-text pull-right\">{{300-newNotes.length}}&nbsp;{{getWord(\'CharactersRemaining\')}}</span></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-success pull-right m-l-sm m-r\" type=\"submit\"><b>+</b> Add a note</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/convertQuote/convertQuoteReview.tpl.html","<form class=\"panel-body form-horizontal\" id=\"reviewQuoteForm\" autocomplete=\"off\"><h3><b>{{getWord(\'ReviewQuote\')}}</b></h3><fieldset ng-disabled=\"readOnly\"><div class=\"form-group\"><div class=\"col-xs-12 col-sm-5 col-md-3 col-lg-3\"><label class=\"control-label\" for=\"txtOrderNumber\">{{getWord(\'OrderNumber\')}}</label> <input id=\"txtOrderNumber\" name=\"txtOrderNumber\" type=\"text\" class=\"form-control\" ng-model=\"orderNumber\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-5 col-md-3 col-lg-3\"><label class=\"control-label\" for=\"dpDueDate\">{{getWord(\'DueDate\')}}<i class=\"fa fa-info-circle primary-color m-l-xs\" tooltip-placement=\"right\" uib-tooltip=\"{{dueDateTooltipText}}\"></i></label><div class=\"input-group\"><label class=\"input-group-addon\" for=\"dpDueDate\"><i class=\"fa fa-calendar\"></i></label> <input class=\"form-control\" id=\"dpDueDate\" name=\"dpDueDate\" date-picker=\"\" ng-model=\"dueDate\" data-date-start-date=\"+0d\" placeholder=\"{{getWord(\'SelectDate\')}}\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-5 col-md-3 col-lg-3\"><label class=\"control-label\" for=\"tpDueTime\">{{getWord(\'DueTime\')}}</label><div class=\"input-group\"><label class=\"input-group-addon\" for=\"tpDueTime\"><i class=\"fa fa-clock-o\"></i></label> <input class=\"form-control\" id=\"tpDueTime\" name=\"tpDueTime\" time-picker=\"\" ng-model=\"dueTime\" placeholder=\"{{getWord(\'SelectTime\')}}\" type=\"text\" ng-trim=\"true\"></div></div></div></fieldset><div class=\"form-group\" id=\"convertItemDetails\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-md\" ng-repeat=\"item in reviewQuoteResponse\" ng-show=\"item.selectedIndex!=null\"><div class=\"panel panel-default m-b-none\"><div class=\"panel-heading font-weight-bold\"><a class=\"inline-flex\" ng-click=\"routeToItem(item)\"><span ng-show=\"item.itemName\">&nbsp;{{getWord(\'Item\')}}&nbsp;{{item.itemIdx + 1}}&nbsp;&#45;&nbsp;{{item.itemName}}</span></a> <a class=\"pull-right f-s-12\" ng-click=\"removeReviewItem(item)\" ng-show=\"(selectedVariationData.length > 1) && !readOnly\" ng-bind=\"getWord(\'RemoveItem\')\"></a></div><div class=\"panel-body\"><div class=\"row\" ng-show=\"item.files.length > 0\"><div class=\"secondary-bold-text col-xs-12 col-sm-5 col-md-2 col-lg-2\" ng-bind=\"getWord(\'Files\')\"></div><div class=\"pull-right col-xs-12 col-sm-7 col-md-10 col-lg-10\" ng-repeat=\"file in item.files\"><b><i class=\"fa fa-paperclip m-r-xs\"></i> {{file.fileName}}</b></div></div><div class=\"row\" ng-show=\"item.itemNotes\"><div class=\"secondary-bold-text col-xs-12 col-sm-5 col-md-2 col-lg-2\" ng-bind=\"getWord(\'Notes\')\"></div><div class=\"col-xs-12 col-sm-7 col-md-10 col-lg-10\"><b>{{item.itemNotes}}</b></div></div><div class=\"row\" ng-show=\"item.deliveryInfo.length > 0\"><div class=\"secondary-bold-text col-xs-12 col-sm-5 col-md-2 col-lg-2\" ng-bind=\"getWord(\'Delivery\')\"></div><div class=\"col-xs-12 col-sm-7 col-md-10 col-lg-10\" ng-repeat=\"delivery in item.deliveryInfo track by $index\"><b>{{delivery}}</b></div></div><div class=\"row\" ng-show=\"item.deliveryMethodEnum.name\"><div class=\"secondary-bold-text col-xs-12 col-sm-5 col-md-2 col-lg-2\" ng-bind=\"getWord(\'DeliveryMethod\')\"></div><div class=\"col-xs-12 col-sm-7 col-md-10 col-lg-10 font-weight-bold\"><span ng-show=\"item.deliveryMethodEnum.name\" ng-bind=\"item.deliveryMethodEnum.name\"></span> <span ng-show=\"item.shippingServiceLevel\">&nbsp;&#45;&nbsp;{{item.shippingServiceLevel}}</span></div></div><div class=\"row\"><div class=\"secondary-bold-text col-xs-12 col-sm-5 col-md-2 col-lg-2\" ng-bind=\"getWord(\'Variation\')\"></div><div class=\"col-xs-12 col-sm-7 col-md-10 col-lg-10\"><b>{{getWord(\'Var\')}}&nbsp;{{item.selectedIndex + 1}}&#58;&nbsp; <a class=\"f-w-600\" ng-click=\"routeToVariationDetails(item)\">{{item.variatonDetails.variationShortName}}</a></b></div></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/convertQuote/editDeliveryInfo.tpl.html","<div class=\"panel-body\"><edit-recipient-modal></edit-recipient-modal><div class=\"m-b-xs\"><h2><b>{{item.itemName}} - {{item.productTypeEnum.name}} - {{getWord(\'Delivery\')}}</b></h2><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\"SelectAnOption\")}}</label><div class=\"custom-toggle-btn\"><div class=\"btn-group\" aria-invalid=\"false\"><span class=\"btn\" ng-click=\"changeConvertDeliveryType(1)\" ng-class=\"{\'active\' : item.shippingMethodName==\'20\',\'btn-primary\' : item.shippingMethodName==\'20\',\'btn-default\' : item.shippingMethodName!=\'20\'}\" id=\"shipping\">{{getWord(\"Shipping\")}}</span> <span class=\"btn\" ng-click=\"changeConvertDeliveryType(2)\" ng-class=\"{\'active\' : item.shippingMethodName==\'10\',\'btn-primary\' : item.shippingMethodName==\'10\',\'btn-default\' : item.shippingMethodName!=\'10\'}\" id=\"pickup\">{{getWord(\"PickUp\")}}</span></div></div></div></div></div><edit-shipping-method></edit-shipping-method><pickup-method></pickup-method></div></div>");
$templateCache.put("app/quote/partials/convertQuote/editShippingMethod.tpl.html","<div id=\"shippingPanel\" ng-show=\"item.shippingMethodName==\'20\'\"><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\"DeliveryMethod\")}}</label><select id=\"deliveryMethod\" name=\"deliveryMethod\" class=\"form-control\" ng-model=\"serviceLevel\" ng-change=\"changeDeliveryMethod(serviceLevel)\"><option ng-repeat=\"delivery in serviceLevels\" value=\"{{delivery.code}}\" ng-selected=\"delivery.code === serviceLevel\">{{delivery.name}}</option></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\"><label class=\"m-r\">{{getWord(\"ShippingAddress\")}}</label><table class=\"table custom-table-border\" id=\"shippingRecipientTable\"><thead><tr><th>{{getWord(\"ItemQuantity\")}}</th><th>{{getWord(\"Recipient\")}}</th><th class=\"text-center\">{{getWord(\"Action\")}}</th></tr></thead><tbody><tr><td><span ng-show=\"item.quantityVariations.length<1\">{{item.quantity}}</span> <span ng-show=\"item.quantityVariations.length>=1\">{{getWord(\'Multiple\')}}</span></td><td><fieldset><recipient-search></recipient-search></fieldset></td><td class=\"text-center\"><button id=\"primaryDeliveryButton{{$index}}\" tabindex=\"-1\" class=\"btn btn-white leftBorderRadius font-bold\" ng-disabled=\"disableEditBtn\" ng-click=\"editRecipient($index)\" type=\"button\">{{getWord(\"Edit\")}}</button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/quote/partials/convertQuote/viewUserNotesModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"viewUserNotesModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\" style=\"word-break: break-word;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h2 class=\"modal-title\"><b>View Note</b></h2></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><h3><strong style=\"margin-right: 50px;\">Name of Author:</strong> {{ noteData.createdByUserName }}</h3><br><h3><strong style=\"margin-right: 74px;\">Date Created:</strong> {{ noteData.createdDate | date:\'MM/dd/yyyy hh:mm a\' }}</h3><br><h3>Note:</h3>{{ noteData.userNote }}</div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/quotesList/quoteFilters.tpl.html","<div class=\"row m-b-l\"><div class=\"col-sm-6 col-md-2 col-lg-2\"><button class=\"btn btn-success m-l-n\" ng-click=\"createNewItem()\" ng-show=\"user.userRole!=users.Coa\"><i class=\"fa fa-plus p-r-sm\"></i> <span>{{getWord(\'CreateQuote\')}}</span></button></div><div class=\"col-sm-4 col-md-2 col-lg-2\"><div class=\"form-group\"><div class=\"row\" id=\"sourceBtn\"><label class=\"control-label\"><strong>{{getWord(\'Source\')}}</strong></label> <button type=\"button\" class=\"btn btn-default btn-sm custom-dropdown dropdown-toggle text-left\" ng-click=\"toggleDropdown(\'source_var\');\"><span ng-show=\"source_array.length!=0\" ng-repeat=\"source_arr in source_array track by $index\"><span ng-if=\"$index!=0\">&#44;&nbsp;</span>{{source_arr.value}}</span> <span ng-show=\"source_array.length==0\" class=\"p-l-md\">{{getWord(\'SelectOption\')}}</span> <span class=\"caret\"></span></button><ul class=\"form-control dropdown-menu-toggle dropdown-menu no-animation\" id=\"sourceDrpDwn\" ng-show=\"source_var\"><li ng-repeat=\"source in source_select track by $index\"><div class=\"checkbox\" ng-click=\"multiSelectFn(source,\'source\')\"><label><span ng-if=\"source.check==true\" class=\"m-l-n\"><i class=\"fa fa-check\"></i></span>&nbsp; <span>{{source.value}}</span></label></div></li></ul></div></div></div><div class=\"col-sm-4 col-md-2 col-lg-2\"><div class=\"form-group\"><div class=\"row\" id=\"statusBtn\"><label class=\"control-label\"><strong>{{getWord(\'Status\')}}</strong></label> <button type=\"button\" class=\"btn btn-default btn-sm custom-dropdown dropdown-toggle text-left\" ng-click=\"toggleDropdown(\'status_var\');\"><span ng-show=\"status_array.length!=0\" ng-repeat=\"status_arr in status_array\"><span ng-if=\"$index!=0\">&#44;&nbsp;</span>{{status_arr.value}}</span> <span ng-show=\"status_array.length==0\" class=\"p-l-md\">{{getWord(\'SelectOption\')}}</span> <span class=\"caret\"></span></button><ul class=\"form-control dropdown-menu-toggle dropdown-menu no-animation\" id=\"statusDrpDwn\" ng-show=\"status_var\"><li ng-repeat=\"status in status_select track by $index\"><div class=\"checkbox\" ng-click=\"multiSelectFn(status,\'status\')\"><label><span ng-if=\"status.check==true\" class=\"m-l-n\"><i class=\"fa fa-check\"></i></span>&nbsp; <span>{{status.value}}</span></label></div></li></ul></div></div></div><div class=\"col-sm-4 col-md-2 col-lg-2\"><div class=\"form-group\"><div class=\"row\" id=\"lastByBtn\"><label class=\"control-label\"><strong>{{getWord(\'LastModifiedBy\')}}</strong></label> <button type=\"button\" class=\"btn btn-default btn-sm custom-dropdown dropdown-toggle text-left\" ng-click=\"toggleDropdown(\'lastBy_var\');\"><span ng-show=\"lastModify_array.length!=0\" ng-repeat=\"lastBy_arr in lastModify_array\"><span ng-if=\"$index!=0\">&#44;&nbsp;</span>{{lastBy_arr.value}}</span> <span ng-show=\"lastModify_array.length==0\" class=\"p-l-md\">{{getWord(\'SelectOption\')}}</span> <span class=\"caret\"></span></button><ul class=\"form-control dropdown-menu-toggle dropdown-menu no-animation\" id=\"lastByDrpDwn\" ng-show=\"lastBy_var\"><li ng-repeat=\"lastBy in lastModify_select track by $index\"><div class=\"checkbox\" ng-click=\"multiSelectFn(lastBy,\'modifiedBy\')\"><label><span ng-if=\"lastBy.check==true\" class=\"m-l-n\"><i class=\"fa fa-check\"></i></span>&nbsp; <span>{{lastBy.value}}</span></label></div></li></ul></div></div></div><div class=\"col-sm-4 col-md-2 col-lg-2\"><div class=\"form-group\"><div class=\"row\" id=\"dateBtn\"><label class=\"control-label\"><strong>{{getWord(\'DateModified\')}}</strong></label> <button type=\"button\" class=\"btn btn-default btn-sm custom-dropdown dropdown-toggle text-left\" ng-click=\"toggleDropdown(\'date_var\');\"><span ng-show=\"dateModified_array.length!=0\" ng-repeat=\"date_arr in dateModified_array\"><span ng-if=\"$index!=0\">&#44;&nbsp;</span>{{date_arr.value}}</span> <span ng-show=\"dateModified_array.length==0\" class=\"p-l-md\">{{getWord(\'SelectOption\')}}</span> <span class=\"caret\"></span></button><ul class=\"form-control dropdown-menu-toggle dropdown-menu no-animation\" id=\"dateDrpDwn\" ng-show=\"date_var\"><li ng-repeat=\"dateModify in dateModified_select track by $index\"><div class=\"checkbox\" ng-click=\"singleSelectFn(dateModify,$index)\"><label><span ng-if=\"dateModify.check==true\" class=\"m-l-n\"><i class=\"fa fa-check\"></i></span>&nbsp; <span>{{dateModify.value}}</span></label></div></li><li><div class=\"checkbox\" ng-click=\"customCalenderValid()\"><label><span ng-show=\"custom.check == true\" class=\"m-l-n\"><i class=\"fa fa-check\"></i></span>&nbsp; <span>{{custom.value}}</span></label></div></li><li><div class=\"checkbox\" ng-show=\"customCalenderValue\"><div class=\"input-daterange input-group\" id=\"datepicker\" date-picker=\"\" data-date-end-date=\"+0d\"><input type=\"text\" class=\"input-sm form-control\" id=\"fromDate\" name=\"start\" ng-model=\"fromDate\" ng-change=\"customCalender()\"> <span class=\"input-group-addon\">to</span> <input type=\"text\" class=\"input-sm form-control\" id=\"toDate\" name=\"end\" ng-model=\"toDate\" ng-change=\"customCalender()\"></div></div></li></ul></div></div></div></div>");
$templateCache.put("app/quote/partials/stepOne/customerSearch.tpl.html","<div class=\"row\" id=\"customerSearchDrpDwn\"><span class=\"pull-right requiredField p-w-lg optional-bold-text\">{{getWord(\'IndicatesRequiredField\')}}</span><div class=\"col-lg-6\"><div class=\"padded-row form-group\"><div angucomplete-alt=\"\" id=\"ex1\" ng-show=\"disableCustomerSearch(\'inputField\')\" placeholder=\"Search by Name, Company or Account Number\" maxlength=\"50\" pause=\"1000\" selected-object=\"selectedCustomer\" local-data=\"customers\" search-fields=\"name,accountNumber,companyName\" title-field=\"name\" minlength=\"0\" input-changed=\"inputChanged\" input-class=\"form-control form-control-small\" match-class=\"highlight\" template-url=\"/my-custom-template.html\" initial-value=\"initialCustomer\"></div><script type=\"text/ng-template\" id=\"/my-custom-template.html\"><div class=\"angucomplete-holder\" ng-class=\"{\'angucomplete-dropdown-visible\': showDropdown}\"> <p class=\"requiredField secondary-bold-text\" ng-bind=\"selectCustomer\"></p> <div class=\"inner-addon right-addon\"> <i ng-if=\"!searchStr\" class=\"glyphicon glyphicon-search m-r-n\"></i> <i ng-if=\"searchStr\" ng-click=\"clearInput(\'ex1\')\" class=\"glyphicon glyphicon-remove m-r-n\"></i> <input ng-model=\"searchStr\" ng-disabled=\"disableInput\" type=\"text\" id=\"inputField\" placeholder=\"{{placeholder}}\" ng-focus=\"onFocusHandler();\" class=\"{{inputClass}}\" ng-focus=\"resetHideResults()\" ng-blur=\"testThisFunction();hideResults($event)\" autocapitalize=\"off\" autocorrect=\"off\" autocomplete=\"off\" ng-class=\"{\'-error\': !validateCustomerDrpDwn}\" ng-change=\"inputChangeHandler(searchStr)\"/> </div> <span id=\"requiredCustomer\" class=\"hide text-danger small\">Customer is Required</span> <div class=\"angucomplete-dropdown\" ng-show=\"showDropdown\" style=\"overflow: hidden; max-height: 500px; width: 100%;\"> <div class=\"angucomplete-searching\" ng-show=\"searching\"> <strong ng-bind=\"textSearching\"></strong> </div> <div class=\"angucomplete-row\" dropdown-handler> <a ng-click=\"performAddAction()\"> <span> <i class=\"fa fa-plus p-r-sm\"></i> <span class=\"font-bold\" ng-bind=\"addNewCustomerLabel\"></span> </span> </a> </div> <hr ng-show=\"searchStr\" class=\"m-n\"/> <div class=\"angucomplete-row\" ng-if=\"searchStr\" ng-repeat=\"result in results | limitTo:5\" ng-click=\"selectResult(result)\" ng-mouseenter=\"hoverRow($index)\" ng-class=\"{\'angucomplete-selected-row\': $index == currentIndex}\"> <div class=\"angucomplete-title\" ng-if=\"matchClass\"> <div class=\"angucomplete-row secondary-bold-text\"> <table width=\"100%\"> <tr> <td class=\"pull-left col-md-6 col-lg-6\"> <span ng-bind-html=\"result.title\"></span> <br> <span class=\"text-muted\" ng-bind-html=\"result.originalObject.companyName\"></span> </td> <td class=\"pull-right col-md-6 col-lg-6\" ng-bind-html=\"result.originalObject.accountNumber\"> </td> </tr> </table> </div> </div> </div> <div class=\"angucomplete-searching p-xs\" ng-show=\"!searching && (!results || results.length == 0) && searchStr\" ng-bind=\"textNoResults\"></div> <div class=\"angucomplete-row \" ng-show=\"results.length>5 && searchStr\"> <a> <span ng-click=\"viewCustomerList()\"> <span><b> View all {{results.length}} results </b></span> </span> </a> </div> </div> </div></script></div></div></div>");
$templateCache.put("app/quote/partials/stepOne/wizardStepOne.tpl.html","<form wizard-step-one=\"\" autocomplete=\"off\" id=\"stepOneForm\" class=\"p-sm\" save-progress=\"\"><fieldset ng-disabled=\"readOnly\"><customer-search></customer-search></fieldset><fieldset id=\"customerBlock\" class=\"hide\"><div><div class=\"col-lg-6 m-l-n\"><div class=\"ibox m-b-xs add-ibox-border\"><div class=\"ibox-content ibox-content-style\"><div><h3 class=\"requiredField\">{{getWord(\'CustomerDetails\')}} <small>{{getWord(\'OneFieldRequired\')}}</small></h3></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"control-label\" for=\"txtFullName\">{{getWord(\'FullName\')}}</label> <input id=\"txtFullName\" name=\"txtFullName\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"quote.fullName\" ng-change=\"changeHeaderData()\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><label class=\"control-label\" for=\"txtAccountNumber\">{{getWord(\'AccountNumber\')}}</label> <input id=\"txtAccountNumber\" name=\"txtAccountNumber\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"quote.accountNumber\" ng-change=\"changeHeaderData()\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"control-label\" for=\"txtCompanyName\">{{getWord(\'CompanyName\')}}</label> <input id=\"txtCompanyName\" name=\"txtCompanyName\" type=\"text\" class=\"form-control commonField\" autocomplete=\"nope\" ng-model=\"quote.companyName\" ng-change=\"changeHeaderData()\"></div></div></div><div class=\"form-group\" ng-hide=\"true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><label class=\"checkbox-wrap\"><input type=\"checkbox\" ng-checked=\"true\" ng-disabled=\"true\" ng-model=\"quote.saveAsCustomer\">{{getWord(\'SaveAsCustomer\')}} <span class=\"checkbox-mark\"></span></label></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><label class=\"pull-right\"><a ng-click=\"goToCustomerEdit()\">{{getWord(\'AddMoreInfo\')}}</a></label></div></div></div></div></div></div></div></fieldset><fieldset id=\"customerDetailsBlock\" class=\"hide\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox m-b-xs add-ibox-border\"><div class=\"ibox-content ibox-content-style\"><a class=\"pull-right\" ng-hide=\"readOnly\" ng-click=\"editCustomer(customerInfoData.id)\"><b>{{getWord(\'Edit\')}}</b></a><div class=\"form-group\" ng-show=\"customerInfoData.fullName\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'Name\')}}</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-4\"><b ng-bind=\"customerInfoData.fullName\"></b></label></div></div><div class=\"form-group\" ng-show=\"customerInfoData.companyName\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'Company\')}}</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-4\"><b ng-bind=\"customerInfoData.companyName\"></b></label></div></div><div class=\"form-group\" ng-show=\"customerInfoData.accountNumber\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'AccountNo\')}}&#46;</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-4\"><b ng-bind=\"customerInfoData.accountNumber\"></b></label></div></div><div class=\"form-group\" ng-show=\"customerInfoData.street1 || customerInfoData.street2 || customerInfoData.city || customerInfoData.state || customerInfoData.postalCode\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'Address\')}}</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-6\"><b><span ng-show=\"customerInfoData.street1\" ng-bind=\"customerInfoData.street1\"></span> <span ng-show=\"customerInfoData.street2\" ng-bind=\"\' \' + customerInfoData.street2\"></span></b><br><b><span ng-show=\"customerInfoData.city\" ng-bind=\"customerInfoData.city\"></span> <span ng-show=\"customerInfoData.state\" ng-bind=\"\',\' + customerInfoData.state\"></span> <span ng-show=\"customerInfoData.postalCode\" ng-bind=\"\'-\' + customerInfoData.postalCode\"></span> <span ng-show=\"customerInfoData.country && (customerInfoData.postalCode || customerInfoData.city || customerInfoData.street1)\" ng-bind=\"\', \' + customerInfoData.country.toUpperCase()\"></span></b></label></div></div><div class=\"form-group\" ng-show=\"customerInfoData.email\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'Email\')}}</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-4\"><b ng-bind=\"customerInfoData.email\"></b></label></div></div><div class=\"form-group\" ng-show=\"customerInfoData.phoneNumber\"><div class=\"row\"><label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-3\">{{getWord(\'Phone\')}}</label> <label class=\"control-label col-xs-12 col-sm-12 col-md-4 col-lg-4\"><b><span>{{customerInfoData.countryCode || \'+1\'}}</span> <span ng-show=\"customerInfoData.phoneNumber\">{{customerInfoData.phoneNumber | phoneFilter}}</span> <span ng-show=\"customerInfoData.phoneExt\">&nbsp;{{getWord(\'Ext\')}}&nbsp;{{customerInfoData.phoneExt}}</span></b></label></div></div></div></div></div></div></fieldset><hr><fieldset ng-disabled=\"readOnly\"><div class=\"row\"><div class=\"col-lg-6\"><div><h3>{{getWord(\'Source\')}}</h3></div><div class=\"row\"><div class=\"form-group col-lg-6\"><label class=\"control-label requiredField\" for=\"cboSourceName\">{{getWord(\'Name\')}}</label><select id=\"cboSourceName\" name=\"cboSourceName\" class=\"form-control\" ng-model=\"quote.sourceName\" ng-change=\"changeHeaderData()\" data-ng-options=\"source.value as source.name for source in quoteSources\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"form-group col-lg-4 col-lg-offset-1\"><label class=\"control-label\" for=\"txtReferenceNumber\">{{getWord(\'ReferenceNumber\')}}</label> <input id=\"txtReferenceNumber\" name=\"txtReferenceNumber\" type=\"text\" class=\"form-control\" ng-model=\"quote.referenceNumber\" ng-change=\"changeHeaderData()\"></div></div></div></div></fieldset><hr><fieldset ng-disabled=\"readOnly\"><div class=\"row\"><div class=\"col-lg-6\"><div><h3>{{getWord(\'Requester\')}} <i class=\"fa fa-info-circle primary-color\" tooltip-placement=\"right\" uib-tooltip=\"{{requesterTooltipText}}\" aria-hidden=\"true\"></i></h3></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"control-label\" for=\"txtRequesterFullName\">{{getWord(\'FullName\')}}</label> <input id=\"txtRequesterFullName\" name=\"txtRequesterFullName\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"quote.requesterFullName\" ng-change=\"changeHeaderData()\"></div></div></div><div class=\"form-group col-lg-6\"><div class=\"row\"><label class=\"control-label\" for=\"txtPhone\">{{getWord(\'Phone\')}}</label><div class=\"input-group\"><span class=\"input-group-addon\">+1</span> <input id=\"txtPhone\" name=\"txtPhone\" type=\"tel\" class=\"form-control\" data-intl-tel=\"\" ng-show=\"disableAutoFill(\'txtPhone\')\" ng-model=\"quote.requesterPhoneNumber\" ng-change=\"changeHeaderData()\"></div></div></div><div class=\"form-group col-lg-4 col-lg-offset-1\"><div class=\"row\"><label class=\"control-label\" for=\"txtExtension\">{{getWord(\'Extension\')}}</label> <input id=\"txtExtension\" name=\"txtExtension\" type=\"text\" class=\"form-control\" ng-model=\"quote.requesterPhExtension\" ng-change=\"changeHeaderData()\"></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"control-label\" for=\"txtEmail\">{{getWord(\'Email\')}}</label> <input id=\"txtEmail\" name=\"txtEmail\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"quote.requesterEmail\" ng-change=\"changeHeaderData()\"></div></div></div></div></div></fieldset><hr><fieldset ng-disabled=\"readOnly\"><div class=\"row\"><div class=\"col-lg-6\"><div><h3>{{getWord(\'ProjectDescription\')}}</h3></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><textarea id=\"txtProjectDescription\" name=\"txtProjectDescription\" type=\"text\" class=\"form-control\" ng-model=\"quote.projectDescription\" ng-change=\"changeHeaderData()\"></textarea></div></div></div></div></div></fieldset><div class=\"row m-r\"><button id=\"createBtn\" class=\"btn btn-success pull-right m-l\" type=\"submit\">&nbsp;<span class=\"font-bold\">{{getWord(\"NextItems\")}}</span> <span class=\"fa fa-angle-right m-l-xs\"></span></button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"cancelForm()\">{{getWord(\'Cancel\')}}</button></div></form>");
$templateCache.put("app/quote/partials/stepThree/wizardStepThree.tpl.html","<div quote-summary-view=\"\"><add-notes-modal></add-notes-modal><div class=\"row\" id=\"summaryBlock\"><div class=\"col-lg-12\"><div class=\"tabs-container tab-inactive-bg\" ng-show=\"itemSummary\"><div class=\"tabs-left\"><nav class=\"navbar-default navbar-static-side\"><ul class=\"nav metismenu inner-nav-tabs\"><li class=\"nav-item\" ng-class=\"{\'active\' : itemTab.active}\" a-disabled=\"tab.disabled\" ng-repeat=\"itemTab in summaryItemData track by $index\"><a a-disabled=\"tab.disabled\" ng-click=\"expandItem($index)\"><span class=\"collapsed p-r-sm\"><span ng-show=\"itemTab.itemName\">&nbsp;{{getWord(\'Item\')}}&nbsp;{{$index + 1}}&nbsp;&#45;&nbsp;{{itemTab.itemName}}</span></span></a></li></ul></nav><div id=\"itemSummary\" class=\"tab-content\"><div id=\"tab-6\" class=\"tab-pane active\"><div class=\"panel-body\"><div class=\"summary-header col-md-8 col-lg-8\"><h2 ng-show=\"summaryCurrentItem.itemName\" ng-bind=\"summaryCurrentItem.itemName\"></h2><h2 ng-show=\"summaryCurrentItem.productTypeEnum.name\">&nbsp;&#45;&nbsp;{{summaryCurrentItem.productTypeEnum.name}}</h2></div><div id=\"createGrpBtn\" ng-show=\"showActionButtons()\" class=\"btn-group pull-right m-l-sm\" uib-dropdown=\"\"><button id=\"createBtn\" class=\"btn btn-success\" ng-click=\"summaryEditItem(summaryCurrentItem.id)\">{{getWord(\'EditItem\')}}</button> <button id=\"btn2\" class=\"btn btn-success dropdown-toggle\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a id=\"submitAnother\" class=\"font-weight-bold\" ng-click=\"summaryCreateNewItem()\">{{getWord(\'CreateNewItem\')}}</a></li><li><a id=\"duplicateItem\" class=\"font-weight-bold\" ng-click=\"summaryDuplicateItem()\">{{getWord(\'DuplicateItem\')}}</a></li></ul></div><div class=\"ibox add-ibox-border m-t-xs\"><div class=\"ibox-content ibox-content-style\"><div class=\"row\" ng-hide=\"itemFiles.length == 0 && (!convertQuoteFlag || readOnly)\"><div class=\"control-label col-xs-12 col-sm-12 col-md-3 col-lg-3 secondary-bold-text\" ng-bind=\"getWord(\'Files\')\"></div><div class=\"pull-right col-xs-12 col-sm-12 col-md-9 col-lg-9\" ng-show=\"convertQuoteFlag && !readOnly\"><input type=\"file\" class=\"hide\" id=\"txtConvertItemFile\" name=\"txtConvertItemFile\" ng-model=\"item.files\" onchange=\"angular.element(this).scope().fileChangeForConvert(this)\" multiple=\"\"><div class=\"form-group\"><a class=\"btn btn-default\" id=\"convertFileSelect\" ng-click=\"browseFilesForConvert()\"><b><i class=\"fa fa-paperclip m-r-xs\"></i>{{getWord(\'BrowseFiles\')}}</b></a></div></div><div class=\"pull-right col-xs-12 col-sm-12 col-md-9 col-lg-9\" ng-repeat=\"file in itemFiles\"><a><span class=\"font-weight-bold\" ng-bind=\"file.fileName\" ng-click=\"downloadFile(file)\" a-disabled=\"readOnly\"></span></a> <i class=\"fa fa-times p-w-sm\" ng-click=\"fileRemoveForConvert(file)\" ng-show=\"convertQuoteFlag && !readOnly\"></i></div></div><div class=\"row\" ng-hide=\"!summaryCurrentItem.itemNotes && (!convertQuoteFlag || readOnly)\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 secondary-bold-text\" ng-bind=\"getWord(\'Notes\')\"></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9\"><b ng-show=\"summaryCurrentItem.itemNotes\" class=\"m-r\" ng-bind=\"summaryCurrentItem.itemNotes\"></b> <a class=\"font-weight-bold\" ng-show=\"convertQuoteFlag && !readOnly\" ng-click=\"openModalForAddNotes()\">{{getWord(\'AddNotes\')}}</a></div></div><div class=\"row\" ng-hide=\"itemDeliveryInfo.length <= 0 && (!convertQuoteFlag || readOnly)\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 secondary-bold-text\" ng-bind=\"getWord(\'Delivery\')\"></div><div class=\"pull-right col-xs-12 col-sm-12 col-md-9 col-lg-9\" ng-repeat=\"delivery in itemDeliveryInfo track by $index\"><b class=\"m-r\" ng-bind=\"delivery\"></b> <a class=\"font-weight-bold\" ng-show=\"convertQuoteFlag && !readOnly\" ng-click=\"editDeliveryInfo(quoteId,summaryCurrentItem.id)\">{{getWord(\'EditDeliveryInfo\')}}</a></div></div><div class=\"row\" ng-show=\"summaryCurrentItem.deliveryMethodEnum.name\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 secondary-bold-text\" ng-bind=\"getWord(\'DeliveryMethod\')\"></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 font-weight-bold\"><span ng-show=\"summaryCurrentItem.deliveryMethodEnum.name\" ng-bind=\"summaryCurrentItem.deliveryMethodEnum.name\"></span> <span ng-show=\"summaryCurrentItem.shippingServiceLevel\">&nbsp;&#45;&nbsp;{{summaryCurrentItem.shippingServiceLevel}}</span></div></div><div class=\"row\" ng-show=\"summaryCurrentItem.CostingFacility\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 secondary-bold-text\">{{getWord(\'CostingFacility\')}} <i class=\"fa fa-info-circle quantity-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{costingFacilityTooltipText}}\"></i></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 font-weight-bold\"><span ng-show=\"summaryCurrentItem.CostingFacility\">{{summaryCurrentItem.CostingFacility}}</span></div></div></div></div><div class=\"row\" ng-show=\"summaryCurrentItem.itemVariationCosts.length > 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table custom-table-border\"><thead><tr><th colspan=\"{{variationColSpan}}\" ng-bind=\"getWord(\'Variations\')\"></th><th colspan=\"{{tokenColSpan}}\" ng-show=\"tokenColumn\" ng-bind=\"getWord(\'TokenID\')\"></th><th ng-bind=\"getWord(\'Cost\')\"></th><th ng-bind=\"getWord(\'Price\')\"></th><th class=\"text-center\" ng-show=\"(readOnly || enableConvert) && convertActionsFlag\"><span ng-show=\"convertQuoteFlag && !readOnly\">{{getWord(\'Actions\')}}</span></th></tr></thead><tbody><tr ng-repeat=\"variation in summaryCurrentItem.itemVariationCosts\"><td class=\"col-md-1\"><span class=\"secondary-bold-text\">{{getWord(\'Var\')}}&nbsp;{{$index+1}}</span></td><td class=\"col-md-2\" ng-show=\"variation.jdfTokenId || variation.jdfShortId\"><span class=\"secondary-bold-text\">{{variation.jdfTokenId || variation.jdfShortId}}</span></td><td class=\"col-md-7\"><a ng-click=\"variationDetails($index)\"><b ng-bind=\"variation.variationShortName\"></b></a></td><td class=\"col-md-2 secondary-bold-text\">{{variation.itemCost.totalPrice | currency:\'$ \'}}</td><td class=\"col-md-2 secondary-bold-text\">{{variation.itemCost.totalVendorCost | currency:\'$ \'}}</td><td class=\"text-center\" ng-show=\"convertQuoteFlag && !readOnly\"><div id=\"variationSelectBtn{{$index}}\" ng-click=\"selectVariation($index,\'variationSelectBtn\')\" class=\"var-select-toggle\"><span class=\"variationSelectBtn btn btn-default font-weight-bold\">{{getWord(\'Select\')}}</span></div></td><td class=\"text-center\" ng-show=\"readOnly && convertActionsFlag\"><span class=\"font-weight-bold selected-var\" ng-show=\"readOnly && (summaryCurrentItem.selectedVariationViewIndex == $index)\">{{getWord(\'Selected\')}}</span></td></tr></tbody></table></div></div></div></div></div></div></div><div ng-show=\"!itemSummary\" id=\"variationDetails\"><div class=\"panel-body\"><div class=\"summary-header col-md-8 col-lg-8\"><a ng-click=\"backToSummary()\"><i class=\"fa fa-chevron-left m-r-sm\"></i> <span ng-show=\"summaryCurrentItem.itemName\">{{getWord(\'BackTo\')}}&nbsp;{{getWord(\'Item\')}}&nbsp;{{tabIndex + 1}}&nbsp;&#45;&nbsp;{{summaryCurrentItem.itemName}}</span></a><div class=\"m-t m-b-lg\"><div class=\"summary-details-header\"><h3 ng-show=\"summaryCurrentItem.itemName\" ng-bind=\"summaryCurrentItem.itemName\"></h3><h3 ng-show=\"summaryCurrentItem.productTypeEnum.name\">&nbsp;&#45;&nbsp;{{summaryCurrentItem.productTypeEnum.name}}</h3><h3 ng-show=\"currentVariation\">&nbsp;&#45;&nbsp;{{getWord(\'Variation\')}}&nbsp;{{currentVariation}}</h3><h3 ng-show=\"selectedVariation.jdfTokenId || selectedVariation.jdfShortId\">&nbsp;&#45;&nbsp;{{getWord(\'TokenID\')}}&nbsp;{{selectedVariation.jdfTokenId || selectedVariation.jdfShortId}}</h3></div><h3 ng-show=\"selectedVariation.variationShortName\" ng-bind=\"selectedVariation.variationShortName\"></h3></div></div><div class=\"summary-header col-md-4 col-lg-4\"><div class=\"pull-right\"><div class=\"dataTables_info m-l-lg inline-block\" ng-bind=\"variationPaginationInfo(currentVariation,totalVariations)\"></div><div class=\"btn-group m-l\"><button type=\"button\" ng-disabled=\"disablePrev\" class=\"btn btn-white\" ng-click=\"previous()\"><i class=\"fa fa-chevron-left\"></i></button> <button type=\"button\" ng-disabled=\"disableNext\" class=\"btn btn-white\" ng-click=\"next()\"><i class=\"fa fa-chevron-right\"></i></button></div></div><div ng-show=\"convertQuoteFlag && !readOnly\" id=\"variationDetailsSelectBtn{{currentVariation-1}}\" ng-click=\"selectVariation(currentVariation-1,\'variationDetailsSelectBtn\')\" class=\"var-select-toggle\"><span style=\"margin-top: 3px\" class=\"variationSelectBtn btn btn-default pull-right font-weight-bold\">{{getWord(\'Select\')}}</span></div><div><span class=\"font-weight-bold selected-var pull-right\" ng-show=\"readOnly && ((summaryCurrentItem.selectedVariationViewIndex!= null) && (summaryCurrentItem.selectedVariationViewIndex+1 == currentVariation))\" id=\"itemSel{{currentVariation}}\">{{getWord(\'Selected\')}}</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8 m-l-n\"><div class=\"ibox add-ibox-border\"><div class=\"ibox-content ibox-content-style\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 secondary-bold-text\" ng-bind=\"summaryCurrentItem.quantityLabelText\"></div><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9\" ng-show=\"selectedVariationQuantity\"><b ng-bind=\"selectedVariationQuantity\"></b></div></div></div></div></div><div ng-repeat=\"variationComponent in selectedVariationComponents\"><div class=\"panel panel-default\" id=\"componentDetails\"><div class=\"panel-heading p-l-35\">{{variationComponent.jobPartId}}</div><div class=\"panel-body p-l-md\" ng-show=\"summaryCurrentItem.productTypeEnum.value != productEnums.finishingOnly\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"row\" ng-show=\"variationComponent.frontColor || variationComponent.frontBlack\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.selectedColor\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-show=\"variationComponent.frontColor\" ng-bind=\"getWord(\'Color\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6 font-weight-bold\" ng-show=\"variationComponent.frontBlack\" ng-bind=\"getWord(\'Black\')\"></div></div><div class=\"row m-t-n-sm\" ng-show=\"variationComponent.backColor || variationComponent.backBlack\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'BackColor\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-show=\"variationComponent.backColor\" ng-bind=\"getWord(\'Color\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6 font-weight-bold\" ng-show=\"variationComponent.backBlack\" ng-bind=\"getWord(\'Black\')\"></div></div><div class=\"row\" ng-show=\"variationComponent.size.finalWidth && variationComponent.size.finalHeight\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'FinishedSize\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\">{{variationComponent.size.finalWidth}}&Prime;&nbsp;x&nbsp;{{variationComponent.size.finalHeight}}&Prime;</div></div><div class=\"row\" ng-show=\"variationComponent.sideEnumName\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'PrintedSides\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.sideEnumName\"></div></div><div class=\"row\" ng-show=\"variationComponent.orientation\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'Orientation\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.orientation\"></div></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"row\" ng-show=\"variationComponent.collateEnumName != \'None\'\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'Collation\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.collateEnumName\"></div></div><div class=\"row\" ng-show=\"variationComponent.componentPrintSheetWidth && variationComponent.componentPrintSheetHeight\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'PressSheetSize\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\">{{variationComponent.componentPrintSheetWidth}}&Prime;&nbsp;x&nbsp;{{variationComponent.componentPrintSheetHeight}}&Prime;</div></div><div class=\"row\" ng-show=\"variationComponent.numberOut\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'NumberOut\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.numberOut\"></div></div><div class=\"row m-t-n-sm\" ng-show=\"variationComponent.numberUp\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'NumberUp\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.numberUp\"></div></div><div class=\"row\" ng-show=\"variationComponent.stockCount\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'SheetCount\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.stockCount\"></div></div><div class=\"row\" ng-show=\"variationComponent.finishSizeCuts && variationComponent.finishSizeCuts > 0\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'NumberOfCuts\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.finishSizeCuts\"></div></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div ng-show=\"variationComponent.bleed && variationComponent.bleed.hasBleeds\" style=\"line-height: 11px\"><div class=\"row\" ng-show=\"variationComponent.bleed && variationComponent.bleed.bleedTop\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'BleedTop\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.bleed.bleedTop\"></div></div><div class=\"row\" ng-show=\"variationComponent.bleed && variationComponent.bleed.bleedRight\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'BleedRight\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.bleed.bleedRight\"></div></div><div class=\"row\" ng-show=\"variationComponent.bleed && variationComponent.bleed.bleedBottom\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'BleedBottom\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.bleed.bleedBottom\"></div></div><div class=\"row\" ng-show=\"variationComponent.bleed && variationComponent.bleed.bleedLeft\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'BleedLeft\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.bleed.bleedLeft\"></div></div></div><div class=\"row\" ng-show=\"variationComponent.bleed && !variationComponent.bleed.hasBleeds\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'Bleed\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'No\')\"></div></div><div class=\"row\" ng-show=\"variationComponent.pages\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.tabCountLabelText\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.pages\"></div></div><div class=\"row\" ng-show=\"variationComponent.sheetsPerPad\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'SheetsPerPad\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.sheetsPerPad\"></div></div><div class=\"row\" ng-show=\"variationComponent.formattedPageRange\"><div class=\"col-sm-6 col-md-6 col-lg-6\">{{getWord(\'PageNumbers\')}}</div><div class=\"col-sm-6 col-md-6 col-lg-6\" style=\"word-break: break-word\" ng-bind=\"variationComponent.formattedPageRange\"></div></div><div class=\"row\" ng-show=\"variationComponent.colorClicks\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'ColorClicks\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.colorClicks\"></div></div><div class=\"row\" ng-show=\"variationComponent.totalClicks\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'TotalClicks\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"variationComponent.totalClicks\"></div></div><div class=\"row\" ng-show=\"selectedVariation.itemCost.estimatedRunTime\"><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"getWord(\'EstimatedRunTime\')\"></div><div class=\"col-sm-6 col-md-6 col-lg-6\" ng-bind=\"selectedVariation.itemCost.estimatedRunTime\"></div></div></div></div></div><table id=\"operationCostBreakDown\" class=\"table custom-table-border\" ng-class=\"{\'border-top-none\': summaryCurrentItem.productTypeEnum.value == productEnums.finishingOnly}\"><thead><tr><th class=\"col-md-6 col-lg-6 p-l-35\" colspan=\"2\" ng-bind=\"getWord(\'ConfigurationCostBreakdown\')\"></th><th class=\"col-md-1-2 text-right\" style=\"min-width: 88px!important;\" ng-bind=\"getWord(\'Production\')\"></th><th class=\"col-md-1-2 text-right\" ng-bind=\"getWord(\'Material\')\"></th><th class=\"col-md-1-2 text-right\" ng-bind=\"getWord(\'Labor\')\"></th><th class=\"col-md-1-2 text-right\" ng-bind=\"getWord(\'Buyout\')\"></th><th class=\"col-md-1-2 text-right\" ng-bind=\"getWord(\'CostSubtotal\')\"></th><th class=\"col-md-1-2 text-right\" ng-bind=\"getWord(\'Price\')\"></th></tr></thead><tbody><tr ng-repeat=\"material in variationComponent.materialCost\" ng-show=\"variationComponent.materialCost.length > 0\"><td class=\"col-md-2-4\"><span class=\"p-l-27\" ng-bind=\"getWord(\'Material\')\"></span></td><td class=\"col-md-3-6 font-weight-bold\">{{material.name}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.productionCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.materialCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.laborCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.buyOutCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.totalCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{material.vendorCost | currency:\'$ \'}}</td></tr><tr ng-repeat=\"press in variationComponent.pressCost\" ng-show=\"variationComponent.pressCost.length > 0\"><td class=\"col-md-2-4\"><span class=\"p-l-27\" ng-bind=\"getWord(\'Press\')\"></span></td><td class=\"col-md-3-6 font-weight-bold\">{{press.name}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.productionCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.materialCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.laborCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.buyOutCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.totalCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{press.vendorCost | currency:\'$ \'}}</td></tr><tr ng-repeat=\"binding in variationComponent.bindingCost\" ng-show=\"variationComponent.bindingCost.length > 0\"><td class=\"col-md-2-4\"><span class=\"p-l-27\" ng-bind=\"getWord(\'Binding\')\"></span></td><td class=\"col-md-3-6 font-weight-bold\">{{binding.name}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.productionCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.materialCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.laborCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.buyOutCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.totalCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{binding.vendorCost | currency:\'$ \'}}</td></tr><tr ng-repeat=\"finishing in variationComponent.finishingCost\" ng-show=\"variationComponent.finishingCost.length > 0\"><td class=\"col-md-2-4 secondary-bold-text\"><div class=\"p-l-27\" ng-bind=\"getWord(\'Finishing\')\"></div><div class=\"p-l-27\" ng-if=\"finishing.quantityLabel\" ng-bind=\"finishing.quantityLabel\"></div></td><td class=\"col-md-3-6 font-weight-bold\"><div>{{finishing.name}}</div><div ng-if=\"finishing.quantityLabel\">{{finishing.quantity}}</div></td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.productionCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.materialCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.laborCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.buyOutCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.totalCost | currency:\'$ \'}}</td><td class=\"col-md-1-2 secondary-bold-text text-right\">{{finishing.vendorCost | currency:\'$ \'}}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\" id=\"detailTotals\"><div class=\"panel panel-primary\"><div class=\"panel-heading\" ng-bind=\"getWord(\'Totals\')\"></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\" ng-bind=\"getWord(\'TotalMachineCost\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{selectedVariation.itemCost.productionCost | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\" ng-bind=\"getWord(\'TotalMaterialCost\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{selectedVariation.itemCost.materialCost | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\" ng-bind=\"getWord(\'TotalLaborCost\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{selectedVariation.itemCost.laborCost | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\" ng-bind=\"getWord(\'TotalBuyOutCost\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{selectedVariation.itemCost.buyoutCost | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\">{{getWord(\'MarkUp\')}}&nbsp;&#40;&#37;&#41;</div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b ng-bind=\"markup\"></b></div><div class=\"col-sm-2 col-md-2 col-lg-2\" ng-hide=\"convertQuoteFlag || readOnly\"><a data-toggle=\"collapse\" id=\"editMarkUpBtn\" class=\"editAccordionBtn collapse-link collapsed\" data-target=\"#editMarkUp\"><b ng-bind=\"getWord(\'Edit\')\"></b> <i class=\"m-l-xs\"></i></a></div><form id=\"markupForm\" autocomplete=\"off\"><div id=\"editMarkUp\" class=\"collapse\"><div class=\"row\"><div class=\"col-md-6 col-lg-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtMarkUp\">{{getWord(\'OverrideMarkUp\')}}&nbsp;&#40;&#37;&#41;</label><div class=\"form-inline\"><input id=\"txtMarkUp\" name=\"txtMarkUp\" ng-model=\"newMarkUp\" type=\"text\" class=\"form-control\"></div></div></div><div class=\"col-md-4 col-lg-4\"><div class=\"form-group\"><button class=\"btn btn-default m-l\" type=\"submit\"><b>{{getWord(\'Save\')}}</b></button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group\"><label class=\"checkbox-wrap\" for=\"applyMarkUpToAllVariation\"><input id=\"applyMarkUpToAllVariation\" name=\"applyMarkUpToAllVariation\" ng-model=\"markupCheckBox\" type=\"checkbox\">{{getWord(\'ApplyToAllVariations\')}} <span class=\"checkbox-mark\"></span></label></div></div></div></div></form></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\" ng-bind=\"getWord(\'Subtotal\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{selectedVariationSubTotal | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5\">{{getWord(\'TotalShippingCost\')}}<i class=\"fa fa-info-circle quantity-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{shippingCostTooltipText}}\"></i></div><div class=\"col-sm-5 col-md-5 col-lg-5\"><b>{{defaultShippingCost | currency:\'$ \'}}</b></div><div class=\"col-sm-2 col-md-2 col-lg-2\" ng-hide=\"convertQuoteFlag || readOnly\"><a data-toggle=\"collapse\" id=\"editShippingBtn\" class=\"editAccordionBtn collapse-link collapsed\" data-target=\"#editShippingCost\"><b ng-bind=\"getWord(\'Edit\')\"></b> <i class=\"m-l-xs\"></i></a></div><form id=\"shippingCostForm\" autocomplete=\"off\"><div id=\"editShippingCost\" class=\"collapse\"><div class=\"row\"><div class=\"col-md-6 col-lg-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtShippingCost\">{{getWord(\'OverrideTotalShippingCost\')}}&nbsp;&#40;&#36;&#41;</label><div class=\"form-inline\"><input id=\"txtShippingCost\" name=\"txtShippingCost\" ng-model=\"newShippingCost\" type=\"text\" class=\"form-control\"></div></div></div><div class=\"col-md-4 col-lg-4\"><div class=\"form-group\"><button class=\"btn btn-default m-l\" type=\"submit\"><b>{{getWord(\'Save\')}}</b></button> <a ng-click=\"resetShippingCost()\"><i class=\"fa fa-undo\" tooltip-placement=\"bottom\" uib-tooltip=\"{{resetTooltipText}}\"></i></a></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group\"><label class=\"checkbox-wrap\" for=\"applyShippingCostToAllVariation\"><input id=\"applyShippingCostToAllVariation\" name=\"applyShippingCostToAllVariation\" ng-model=\"shippingCheckBox\" type=\"checkbox\">{{getWord(\'ApplyToAllVariations\')}} <span class=\"checkbox-mark\"></span></label></div></div></div></div></form></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5 font-bold m-l-n\" ng-bind=\"getWord(\'TotalCost\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5 m-l\"><b>{{selectedVariation.itemCost.totalPrice | currency:\'$ \'}}</b></div></div><div class=\"row\"><div class=\"col-sm-5 col-md-5 col-lg-5 font-bold m-l-n\" ng-bind=\"getWord(\'TotalPrice\')\"></div><div class=\"col-sm-5 col-md-5 col-lg-5 m-l\"><b>{{selectedVariation.itemCost.totalVendorCost | currency:\'$ \'}}</b></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/quote/partials/stepTwo/adhocCustomServiceModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"adHocCustomServiceModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddCustomServices\')}}&nbsp;&#40;{{getWord(\'AdHoc\')}}&#41;</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10\"><label for=\"txtCustomServicesName\">{{getWord(\'CustomServicesName\')}}</label> <input id=\"txtCustomServicesName\" name=\"txtCustomServicesName\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.customServiceName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><label for=\"costTypeForAhoc\">{{getWord(\'CostType\')}}</label><select id=\"costTypeForAhoc\" name=\"costTypeForAhoc\" class=\"form-control\" ng-model=\"adHocService.costType\" data-ng-options=\"costType.value as costType.name for costType in localisedCostTypes\" ng-change=\"clearCostTypeFields();\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label class=\"checkbox-wrap\" for=\"chkMarkAsBuyOutForCostType\"><input id=\"chkMarkAsBuyOutForCostType\" name=\"chkMarkAsBuyOutForCostType\" type=\"checkbox\" ng-model=\"adHocService.markAsBuyOut\" ng-disabled=\"!adHocService.costType\">{{getWord(\'MarkAsBuyOut\')}} <span class=\"checkbox-mark\"></span></label></div></div></div><hr ng-show=\"adHocService.costType\"><div class=\"form-group\" ng-show=\"adHocService.costType\"><h4>{{getWord(adHocService.costType)}}</h4><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label for=\"cboQuantityByForCostType\">{{getWord(\'QuantityBy\')}}</label><select id=\"cboQuantityByForCostType\" name=\"cboQuantityByForCostType\" class=\"form-control\" ng-model=\"adHocService.quantityBy\" convert-to-number=\"\" data-ng-options=\"quantityByForCostType.value as quantityByForCostType.name for quantityByForCostType in availableQuantityBy\" ng-change=\"clearQuantityField(adHocService.quantityBy,adHocService.costType);\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.quantityBy == quanityByEnums.Ask)\"><label for=\"txtQuantityForCostType\">{{getWord(\'Quantity\')}}</label> <input id=\"txtQuantityForCostType\" name=\"txtQuantityForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.quantity\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && adHocService.costType==\'adHocMachineCost\') || (adHocService.quantityBy && adHocService.costType ==\'adHocLaborCost\')\"><label for=\"txtSpeedForCostType\">{{getWord(\'Speed\')}}</label> <input id=\"txtSpeedForCostType\" name=\"txtSpeedForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.speed\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && (adHocService.costType==\'adHocMachineCost\')) || (adHocService.quantityBy && (adHocService.costType ==\'adHocLaborCost\'))\"><label for=\"txtRateForCostType\">{{getWord(\'Rate\')}}&nbsp;&#40;&#36;&#47;{{getWord(\'Hr\')}}&#41;</label> <input id=\"txtRateForCostType\" name=\"txtRateForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.hourlyCost\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.costType == \'adHocMaterialCost\')\"><label for=\"txtUnitMeasureForMaterialCost\">{{getWord(\'UnitCost\')}}&nbsp;&#40;&#36;&#41;</label> <input id=\"txtUnitMeasureForMaterialCost\" name=\"txtUnitMeasureForMaterialCost\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.unitCost\"></div></div></div><hr class=\"m-b-none\"></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"saveBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'AddServices\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancelAddHoc()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/askOperationModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"askOperationModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddFinishingOption\')}}</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-lg-4\"><label>{{getWord(\'FinishingOption\')}}</label></div><div class=\"col-lg-6\"><label class=\"control-label\" ng-bind=\"askObj.name\"></label></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-lg-4\"><label for=\"txtInputQuantity\" ng-bind=\"askObj.askLabel\"></label></div><div class=\"col-lg-5\"><input id=\"txtInputQuantity\" name=\"txtInputQuantity\" type=\"text\" class=\"form-control\" ng-model=\"askObj.inputQuantity\"></div></div></div><hr class=\"m-b-none\"></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"saveBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'AddFinishingOption\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancelAddHoc()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/componentTabs.tpl.html","<div class=\"col-lg-12 col-md-12 m-t-md no-padding\" multi-component=\"\" id=\"componentSection\"><adhoc-custom-service-modal></adhoc-custom-service-modal><edit-adhoc-custom-service-modal></edit-adhoc-custom-service-modal><edit-variation-adhoc-custom-service-modal></edit-variation-adhoc-custom-service-modal><ask-operation-modal></ask-operation-modal><custom-intent-modal></custom-intent-modal><div class=\"tab-heading\"><ul class=\"nav nav-tabs\"><li id=\"componentTab{{compTab.id}}\" ng-class=\"{\'active\' : compTab.active}\" a-disabled=\"compTab.disabled\" ng-repeat=\"compTab in componentTabs track by $index\"><a a-disabled=\"compTab.disabled\" ng-click=\"componentTabClick($index)\"><span class=\"p-r-sm\" title=\"{{compTab.name}}\" ng-class=\"compTab.tabClassName\">{{compTab.name}}</span></a> <i ng-show=\"multiComponents.length>1 && !readOnly\" class=\"fa fa-trash-o fa-lg\" ng-click=\"removeComponent($index)\" data-toggle=\"modal\" data-target=\"#deleteModal\"></i></li></ul><div class=\"add-component-align\"><a ng-click=\"addComponent()\" class=\"font-weight-bold\" a-disabled=\"item.productType == productEnums.flatSheet || item.productType == productEnums.envelope || item.productType == productEnums.wideFormat || item.productType == productEnums.finishingOnly\" ng-hide=\"readOnly\"><i class=\"fa fa-plus\"></i> {{getWord(\'AddNewComponent\')}}</a></div></div><div><div class=\"row p-l-sm\"><div class=\"p-sm p-l-sm\"><label class=\"control-label text-danger\" ng-show=\"validComponent\">{{getWord(\'ValidateComponents\')}}</label></div></div><div class=\"row p-l-sm\"><div class=\"p-sm p-l-sm\"><label class=\"control-label text-danger\" ng-show=\"validateHighLightedComponents\">{{getWord(\'ValidateHighlightedComponents\')}}</label></div></div><div class=\"row\" ng-hide=\"(item.productType == productEnums.finishingOnly) || (item.productType == productEnums.wideFormat) || (item.productType == productEnums.ncr) || (item.productType == productEnums.pads)\"><div class=\"col-lg-6 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'ComponentType\')}}</label><div><div class=\"btn-group component-type-align\"><span id=\"standardComponent\" class=\"btn btn-success active\" ng-click=\"changeColor(\'standardComponent\',\'tabComponent\',\'standard\', undefined, \'exceptionComponent\')\" a-disabled=\"readOnly\" style=\"width: 140px;\">{{getWord(\'Standard\')}}</span> <span id=\"tabComponent\" class=\"btn btn-default\" ng-hide=\"item.productType == productEnums.books\" ng-click=\"changeColor(\'tabComponent\',\'standardComponent\',\'tab\', undefined, \'exceptionComponent\')\" a-disabled=\"readOnly\" style=\"width: 140px;\">{{getWord(\'Tab\')}}</span> <span id=\"exceptionComponent\" class=\"btn btn-default\" ng-show=\"(item.productType == productEnums.books) || (item.productType == productEnums.multiFlatSheet)\" ng-click=\"changeColor(\'exceptionComponent\', \'standardComponent\', \'exception\', undefined, \'tabComponent\')\" a-disabled=\"readOnly\" style=\"width: 140px;\">Exception Page(s)</span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'ComponentName\')}}</label> <input id=\"txtComponentName\" name=\"txtComponentName\" class=\"form-control\" ng-change=\"updateComponentTabName()\" ng-model=\"component.itemComponentName\" ng-disabled=\"isExceptionPageEnabled\"></div></div></div><div class=\"row\" ng-show=\"((isTabEnabled) && (item.productType != productEnums.flatSheet))\"><div class=\"col-lg-2 col-md-4\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'TabCount\')}}</label> <input id=\"txtTabCount\" name=\"txtTabCount\" class=\"form-control\" ng-model=\"component.material.pageCount\" ng-change=\"tabCountChange(component.material.pageCount)\"></div></div></div><div class=\"row\" ng-hide=\"((item.productType == productEnums.finishingOnly) || isTabEnabled)\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-2\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Width\')}}&nbsp;&#40;in&#41;</label> <input id=\"txtWidth\" name=\"txtWidth\" type=\"text\" ng-model=\"component.size.finalWidth\" class=\"form-control\" list=\"listWidth\"><datalist id=\"listWidth\"><option value=\"2.00\">2.00</option><option value=\"3.50\">3.50</option><option value=\"4.00\">4.00</option><option value=\"5.00\">5.00</option><option value=\"7.00\">7.00</option><option value=\"8.50\">8.50</option><option value=\"11.00\">11.00</option></datalist></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-2\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Height\')}}&nbsp;&#40;in&#41;</label> <input id=\"txtHeight\" name=\"txtHeight\" type=\"text\" ng-model=\"component.size.finalHeight\" class=\"form-control\" list=\"listHeight\"><datalist id=\"listHeight\"><option value=\"2.00\">2.00</option><option value=\"3.50\">3.50</option><option value=\"4.00\">4.00</option><option value=\"5.00\">5.00</option><option value=\"7.00\">7.00</option><option value=\"8.50\">8.50</option><option value=\"11.00\">11.00</option></datalist></div></div></div><div class=\"row\" ng-hide=\"item.productType == productEnums.finishingOnly\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'NumberOfSides\')}}</label><select id=\"cboNumberOfSides\" name=\"cboNumberOfSides\" class=\"form-control\" ng-model=\"component.side\" convert-to-number=\"\" ng-disabled=\"isTabEnabled\"><option ng-repeat=\"numberOfSide in sides\" value=\"{{numberOfSide.value}}\">{{numberOfSide.name}}</option></select></div></div></div><div class=\"row\" ng-hide=\"item.productType == productEnums.flatSheet || item.productType == productEnums.envelope || item.productType == productEnums.wideFormat || item.productType == productEnums.finishingOnly || isTabEnabled\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtNumberOfPages\">{{numberOfPagesLabelText}}</label> <input id=\"txtNumberOfPages\" name=\"txtNumberOfPages\" class=\"form-control\" ng-model=\"component.pages\" ng-change=\"isExceptionPageEnabled && numberOfPagesChange(component.pages)\"></div></div></div><div class=\"row\" ng-hide=\"item.productType == productEnums.finishingOnly\"><div class=\"col-lg-5\"><div class=\"color-type-align\"><div class=\"form-group\"><label class=\"control-label\" ng-show=\"component.side>2\">{{getWord(\'FrontColor\')}}</label> <label class=\"control-label\" ng-show=\"component.side<=2\">{{getWord(\'Color\')}}</label><div><div class=\"btn-group\" ng-model=\"component.frontColor\"><span id=\"frontBlack\" class=\"btn btn-success active\" ng-click=\"changeColor(\'frontBlack\',\'frontColor\')\" a-disabled=\"readOnly\">{{getWord(\'Black\')}}</span> <span id=\"frontColor\" class=\"btn btn-default\" ng-click=\"changeColor(\'frontColor\',\'frontBlack\')\" a-disabled=\"readOnly\">{{getWord(\'Color\')}}</span></div></div></div></div><div class=\"color-type-align\" ng-show=\"component.side>2\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'BackColor\')}}</label><div><div class=\"btn-group\" ng-model=\"component.backColor\"><span id=\"backBlack\" class=\"btn btn-success active\" ng-click=\"changeColor(\'backBlack\',\'backColor\')\" a-disabled=\"readOnly\">{{getWord(\'Black\')}}</span> <span id=\"backColor\" class=\"btn btn-default\" ng-click=\"changeColor(\'backColor\',\'backBlack\')\" a-disabled=\"readOnly\">{{getWord(\'Color\')}}</span></div></div></div></div></div></div><div class=\"row\" ng-hide=\"((item.productType == productEnums.ncr) || (item.productType == productEnums.finishingOnly) || (item.productType == productEnums.copies) || isTabEnabled)\"><div class=\"col-md-2 col-lg-1 p-r-none\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Bleed\')}}</label><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" class=\"onoffswitch-checkbox\" id=\"example\" ng-model=\"component.itemComponentBleed.hasBleeds\" ng-change=\"resetBleed()\"> <label class=\"onoffswitch-label\" for=\"example\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div></div><div class=\"col-md-3 col-lg-2\" ng-show=\"component.itemComponentBleed.hasBleeds\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'BleedOffset\')}}</label><select id=\"cboBleedOffset\" name=\"cboBleedOffset\" type=\"text\" class=\"form-control\" ng-change=\"changeBleed()\" ng-model=\"component.bleedOffset\"><option value=\"\" disabled=\"disabled\">{{getWord(\'SelectOption\')}}</option><option value=\"0.0625\">0.0625</option><option value=\"0.125\">0.125</option><option value=\"0.25\">0.25</option><option value=\"custom\">Custom</option></select></div></div><div class=\"col-md-2 col-lg-2\" ng-show=\"component.itemComponentBleed.hasBleeds && component.bleedOffset==\'custom\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Top\')}}</label> <input id=\"cboBleedTop\" name=\"cboBleedTop\" type=\"text\" class=\"form-control\" ng-model=\"component.itemComponentBleed.bleedTop\"></div></div><div class=\"col-md-2 col-lg-2\" ng-show=\"component.itemComponentBleed.hasBleeds && component.bleedOffset==\'custom\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Right\')}}</label> <input id=\"cboBleedRight\" name=\"cboBleedRight\" type=\"text\" class=\"form-control\" ng-model=\"component.itemComponentBleed.bleedRight\"></div></div><div class=\"col-md-2 col-lg-2\" ng-show=\"component.itemComponentBleed.hasBleeds && component.bleedOffset==\'custom\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Bottom\')}}</label> <input id=\"cboBleedBottom\" name=\"cboBleedBottom\" type=\"text\" class=\"form-control\" ng-model=\"component.itemComponentBleed.bleedBottom\"></div></div><div class=\"col-md-2 col-lg-2\" ng-show=\"component.itemComponentBleed.hasBleeds && component.bleedOffset==\'custom\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Left\')}}</label> <input id=\"cboBleedLeft\" name=\"cboBleedLeft\" type=\"text\" class=\"form-control\" ng-model=\"component.itemComponentBleed.bleedLeft\"></div></div></div><div class=\"row\" ng-hide=\"item.productType == productEnums.finishingOnly || !item.productType\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\" ng-show=\"item.productType!=productEnums.wideFormat && !isExceptionPageEnabled\">{{getWord(\'Material\')}}</label> <label class=\"control-label\" ng-show=\"item.productType==productEnums.wideFormat\">{{getWord(\'Substrate\')}}</label> <label class=\"control-label\" ng-show=\"isExceptionPageEnabled\">Media Type</label><select id=\"cboMaterial\" name=\"cboMaterial\" placeholder=\"-Select-\"></select></div></div></div><div class=\"row\" ng-show=\"((isTabEnabled) && (item.productType != productEnums.flatSheet))\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'PageNumbers\')}}<i class=\"fa fa-info-circle quantity-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{pageNumbersTooltipText}}\"></i></label> <input id=\"txtPageNumbers\" name=\"txtPageNumbers\" class=\"form-control\" ng-model=\"component.material.pageNumbers\" ng-change=\"pageNumbersChange(component.material.pageNumbers)\"></div></div></div><div class=\"row\" ng-show=\"((isExceptionPageEnabled) && (item.productType != productEnums.flatSheet))\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'PageNumbers\')}} and/or range<i class=\"fa fa-info-circle quantity-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{pageNumbersTooltipText}}\"></i></label> <input id=\"txtPageNumbers\" name=\"txtPageNumbers\" class=\"form-control\" ng-model=\"component.material.pageNumbers\" ng-change=\"pageNumbersChange(component.material.pageNumbers)\"></div></div></div><div class=\"row\" ng-hide=\"((item.productType == productEnums.flatSheet) || (item.productType == productEnums.envelope) || (item.productType == productEnums.wideFormat) || (!item.productType) || isTabEnabled || isExceptionPageEnabled)\"><div class=\"col-lg-4 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Binding\')}}</label><select id=\"cboPrimaryBind\" name=\"cboPrimaryBind\" placeholder=\"-Select-\"></select></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6\" ng-show=\"item.productType\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Finishing\')}}</label><select id=\"cboFinishingOptions\" name=\"cboFinishingOptions\" placeholder=\"-Select Multiple-\" multiple=\"\"></select></div></div><div class=\"col-lg-4\" id=\"adHocTags\" ng-show=\"showFinishingTags()\"><div class=\"form-group\"><label class=\"control-label\">Finishing Notes & {{getWord(\'CustomAdHocs\')}}</label><div class=\"read-only-field\"><span class=\"custom-badge-style\" ng-repeat=\"tag in finishingTags track by $index\"><span>{{tag.name ? tag.name : tag.finishingOptionName }}<i class=\"fa fa-edit custom-clear-badge-style\" ng-click=\"editTags(tag.value, tag)\"></i><i class=\"fa fa-close custom-clear-badge-style\" ng-click=\"closeTags(tag.value, tag)\"></i></span></span></div></div></div></div><div class=\"row\" ng-hide=\"item.productType == productEnums.finishingOnly\"><div class=\"col-sm-12 col-md-8 col-lg-5 m-t-sm\"><div class=\"form-group\"><label class=\"col-sm-3 col-md-3 col-lg-3 m-l-n control-label secondary-bold-text\">{{getWord(\'Press\')}}</label><div class=\"col-sm-6 col-md-6 col-lg-6\"><label class=\"control-label\" for=\"cboPressName\" ng-hide=\"editPress\">{{pressLabel}}</label><select id=\"cboPressName\" name=\"cboPressName\" ng-show=\"editPress\" class=\"form-control m-t-n-xs\" ng-model=\"component.overridePressCode\" ng-change=\"changePress()\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'Default\')\"></option><option ng-repeat=\"press in presses\" value=\"{{press.code}}\">{{press.name}}</option></select></div><div class=\"col-sm-3 col-md-3 col-lg-3\" ng-show=\"enablePressOverride\"><label class=\"control-label\" ng-click=\"showPressDropDown()\"><a>{{pressBtnName}}</a></label></div></div></div></div></div><hr><div ng-hide=\"isTabEnabled\"><div><b class=\"large-text\">{{getWord(\'ComponentVariations\')}}</b><span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></div></div><variation-type></variation-type></div>");
$templateCache.put("app/quote/partials/stepTwo/customIntentModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"customIntentModal\" autocomplete=\"off\" ng-submit=\"submitDescription($event)\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"onModalClose()\">×</button><h3 class=\"modal-title\"><b>Add description</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><label>Description</label> <textarea id=\"txtDescription\" name=\"txtDescription\" class=\"form-control\" ng-model=\"description\"></textarea></div><hr class=\"m-b-none\"></div><div class=\"modal-footer\"><button class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">Add description</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"onModalClose()\">{{getWord(\'Cancel\')}}</button></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/deliveryMethods.tpl.html","<div class=\"tab-content\"><edit-recipient-modal></edit-recipient-modal><div id=\"tab-7\" class=\"tab-pane active\"><div class=\"panel-body\"><label class=\"control-label text-danger\" ng-show=\"invalidItemInfoInfo\">{{getWord(\"ValidateItems\")}}</label> <label class=\"control-label text-danger\" ng-show=\"invalidDeliveryInfo\">{{getWord(\"ValidateItems\")}}</label><div class=\"m-b-xs\"><h2><b>{{getWord(\'Item\') + \' \' + item.itemNumber}}&nbsp;&#45;&nbsp;{{getWord(\'Delivery\')}}</b></h2><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\"SelectAnOption\")}}</label><div class=\"custom-toggle-btn\"><div class=\"btn-group\" aria-invalid=\"false\"><span class=\"btn\" ng-click=\"changeDeliveryType(1)\" ng-class=\"{\'active\' : item.shippingMethodName==\'20\',\'btn-primary\' : item.shippingMethodName==\'20\',\'btn-default\' : item.shippingMethodName!=\'20\'}\" id=\"shipping\" a-disabled=\"readOnly\">{{getWord(\"Shipping\")}}</span> <span class=\"btn\" ng-click=\"changeDeliveryType(2)\" ng-class=\"{\'active\' : item.shippingMethodName==\'10\',\'btn-primary\' : item.shippingMethodName==\'10\',\'btn-default\' : item.shippingMethodName!=\'10\'}\" id=\"pickup\" a-disabled=\"readOnly\">{{getWord(\"PickUp\")}}</span></div></div><label class=\"text-danger\" ng-show=\"makeSelection\" id=\"canAddLabel\">{{getWord(\'PleaseMakeASelection\')}}</label></div></div></div><shipping-method></shipping-method><pickup-method></pickup-method><label class=\"text-danger\" ng-show=\"costingInProgress && getCostingStatus()\" id=\"costingInProgress\">{{getWord(\'CostingInProgress\')}}</label></div><hr><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"goToConfiguration()\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"PreviousConfiguration\")}}</span></button><div id=\"createGrpBtn\" ng-show=\"!id\" class=\"btn-group pull-right m-l-sm\" uib-dropdown=\"\"><button id=\"createBtn\" class=\"btn btn-success\" ng-click=\"submitStepTwo(true, false, true)\" ng-class=\"{\'rightBorderRadius\': readOnly}\">{{getWord(\'NextSummary\')}}</button> <button id=\"btn2\" ng-hide=\"readOnly\" class=\"btn btn-success dropdown-toggle\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li a-disabled=\"!item.productType\"><a id=\"saveProgress\" class=\"font-weight-bold\" ng-click=\"saveProgress()\" a-disabled=\"!item.productType\">{{getWord(\'SaveProgress\')}}</a></li><li><a id=\"submitAnother\" class=\"font-weight-bold\" ng-click=\"createNewItem()\">{{getWord(\'CreateNewItem\')}}</a></li><li><a id=\"duplicateItem\" class=\"font-weight-bold\" ng-click=\"duplicateItem()\">{{getWord(\'DuplicateItem\')}}</a></li></ul></div><button id=\"saveBtn\" ng-show=\"\" class=\"btn btn-success pull-right m-l-sm\">{{getWord(\'Save\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"cancelForm()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div>");
$templateCache.put("app/quote/partials/stepTwo/editAdhocCustomServiceModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"editAdHocCustomServiceModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddCustomServices\')}}&nbsp;&#40;{{getWord(\'AdHoc\')}}&#41;</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10\"><label for=\"txtCustomServicesName\">{{getWord(\'CustomServicesName\')}}</label> <input id=\"txtCustomServicesName\" name=\"txtCustomServicesName\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.customServiceName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><label for=\"costTypeForAhoc\">{{getWord(\'CostType\')}}</label><select id=\"costTypeForAhoc\" name=\"costTypeForAhoc\" class=\"form-control\" ng-model=\"adHocService.costType\" data-ng-options=\"costType.value as costType.name for costType in localisedCostTypes\" ng-change=\"clearCostTypeFields();\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label class=\"checkbox-wrap\" for=\"chkMarkAsBuyOutForCostType\"><input id=\"chkMarkAsBuyOutForCostType\" name=\"chkMarkAsBuyOutForCostType\" type=\"checkbox\" ng-model=\"adHocService.markAsBuyOut\" ng-disabled=\"!adHocService.costType\">{{getWord(\'MarkAsBuyOut\')}} <span class=\"checkbox-mark\"></span></label></div></div></div><hr ng-show=\"adHocService.costType\"><div class=\"form-group\" ng-show=\"adHocService.costType\"><h4>{{getWord(adHocService.costType)}}</h4><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label for=\"cboQuantityByForCostType\">{{getWord(\'QuantityBy\')}}</label><select id=\"cboQuantityByForCostType\" name=\"cboQuantityByForCostType\" class=\"form-control\" ng-model=\"adHocService.quantityBy\" convert-to-number=\"\" data-ng-options=\"quantityByForCostType.value as quantityByForCostType.name for quantityByForCostType in availableQuantityBy\" ng-change=\"clearQuantityField(adHocService.quantityBy,adHocService.costType);\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.quantityBy == quanityByEnums.Ask)\"><label for=\"txtQuantityForCostType\">{{getWord(\'Quantity\')}}</label> <input id=\"txtQuantityForCostType\" name=\"txtQuantityForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.quantity\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && adHocService.costType==\'adHocMachineCost\') || (adHocService.quantityBy && adHocService.costType ==\'adHocLaborCost\')\"><label for=\"txtSpeedForCostType\">{{getWord(\'Speed\')}}</label> <input id=\"txtSpeedForCostType\" name=\"txtSpeedForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.speed\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && (adHocService.costType==\'adHocMachineCost\')) || (adHocService.quantityBy && (adHocService.costType ==\'adHocLaborCost\'))\"><label for=\"txtRateForCostType\">{{getWord(\'Rate\')}}&nbsp;&#40;&#36;&#47;{{getWord(\'Hr\')}}&#41;</label> <input id=\"txtRateForCostType\" name=\"txtRateForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.hourlyCost\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.costType == \'adHocMaterialCost\')\"><label for=\"txtUnitMeasureForMaterialCost\">{{getWord(\'UnitCost\')}}&nbsp;&#40;&#36;&#41;</label> <input id=\"txtUnitMeasureForMaterialCost\" name=\"txtUnitMeasureForMaterialCost\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.unitCost\"></div></div></div><hr class=\"m-b-none\"></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"saveBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'Save\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancelAddHoc()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/editRecipientModal.tpl.html","<form class=\"modal fade\" id=\"recipientModal\" role=\"form\" autocomplete=\"off\" edit-recipient-address=\"\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div id=\"recipientModalForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">{{recipientModalHeaderLabel}}</h3></div><div class=\"modal-body\"><address-error-badge></address-error-badge><span ng-hide=\"convertState\" class=\"pull-right requiredField p-l-lg\">{{getWord(\'IndicatesRequiredField\')}}</span><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>{{getWord(\'RecipientName\')}}</label> <input id=\"txtFullName\" name=\"txtFullName\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.fullName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>{{getWord(\'CompanyName\')}}</label> <input id=\"txtCompanyName\" name=\"txtCompanyName\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.companyName\"></div></div></div><address-recommendation></address-recommendation><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>{{getWord(\'AddressLine1\')}}</label> <input id=\"txtStreet1\" name=\"txtStreet1\" type=\"text\" class=\"form-control satoriAddressField\" placeholder=\"Street Name\" gm-places-autocomplete=\"\" ng-show=\"disableAutoFill(\'txtStreet1\')\" ng-keyup=\"resetRecipientAddress()\" ng-model=\"recipient.street1\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label>{{getWord(\'AddressLine2\')}}</label><span class=\"optional-bold-text\" ng-show=\"convertState\">&nbsp-&nbsp{{getWord(\'Optional\')}}</span> <input id=\"txtStreet2\" name=\"txtStreet2\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.street2\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><label>{{getWord(\'City\')}}</label> <input id=\"txtCity\" name=\"txtCity\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.city\"></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label ng-class=\"{\'requiredField\' : !convertState}\">{{getWord(\'Zipcode\')}}</label> <input id=\"txtZipCode\" name=\"txtZipCode\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.postalCode\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><label>{{getWord(\'Country\')}}</label><select id=\"cboCountry\" name=\"cboCountry\" type=\"text\" class=\"form-control satoriAddressField\" ng-model=\"recipient.country\" ng-change=\"getStates()\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option><option value=\"{{value.code}}\" ng-repeat=\"value in countries\" ng-selected=\"recipient.country == value.code\">{{value.name}}</option></select></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\" ng-show=\"recipient.country==\'US\'\"><label>{{getWord(\'State\')}}</label><select id=\"cboState\" name=\"cboState\" class=\"form-control satoriAddressField\" ng-model=\"recipient.state\" ng-selected=\"recipient.state\" data-ng-options=\"v.stateCode as v.name for v in states\"><option value=\"\" disabled=\"\" selected=\"selected\">Select</option></select></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\" ng-show=\"recipient.country!=\'US\'\"><label>{{getWord(\'State\')}}</label> <input id=\"txtState\" name=\"txtState\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.state\"></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-8 col-md-8 col-lg-8\"><label class=\"control-label\">{{getWord(\'Phone\')}}</label><div class=\"input-group\"><span class=\"input-group-addon\" ng-bind=\"recipient.countryCode\"></span> <input id=\"txtPhone\" name=\"txtPhone\" type=\"tel\" class=\"form-control\" ng-show=\"disableAutoFill(\'txtPhone\')\" data-intl-tel=\"\" ng-model=\"recipient.phoneNumber\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtExtension\">{{getWord(\'Extension\')}}</label><span class=\"optional-bold-text\" ng-show=\"quoteId\">&nbsp-&nbsp{{getWord(\'Optional\')}}</span> <input id=\"txtExtension\" name=\"txtExtension\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.phoneExt\"></div></div></div></div><div class=\"modal-footer m-t-lg\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"createBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{recipientModalSubmitBtnLabel}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"resetModalValidations()\" data-dismiss=\"modal\">{{getWord(\'Cancel\')}}</button> <label class=\"checkbox-wrap pull-right m-t-xs\" ng-show=\"isCustomerExists\" for=\"applyAddress\"><input id=\"applyAddress\" name=\"applyAddress\" type=\"checkbox\" ng-model=\"recipient.updateRecipient\">{{getWord(\'UpdateExistingRecord\')}} <span class=\"checkbox-mark\"></span></label></div></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/editVariationAdhocCustomServiceModal.tpl.html","<form class=\"modal fade\" role=\"dialog\" id=\"editVariationAdHocCustomServiceModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'AddCustomServices\')}}&nbsp;&#40;{{getWord(\'AdHoc\')}}&#41;</b></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10\"><label for=\"txtCustomServicesName\">{{getWord(\'CustomServicesName\')}}</label> <input id=\"txtCustomServicesName\" name=\"txtCustomServicesName\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.customServiceName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><label for=\"costTypeForAhoc\">{{getWord(\'CostType\')}}</label><select id=\"costTypeForAhoc\" name=\"costTypeForAhoc\" class=\"form-control\" ng-model=\"adHocService.costType\" data-ng-options=\"costType.value as costType.name for costType in localisedCostTypes\" ng-change=\"clearCostTypeFields();\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label class=\"checkbox-wrap\" for=\"chkMarkAsBuyOutForCostType\"><input id=\"chkMarkAsBuyOutForCostType\" name=\"chkMarkAsBuyOutForCostType\" type=\"checkbox\" ng-model=\"adHocService.markAsBuyOut\" ng-disabled=\"!adHocService.costType\">{{getWord(\'MarkAsBuyOut\')}} <span class=\"checkbox-mark\"></span></label></div></div></div><hr ng-show=\"adHocService.costType\"><div class=\"form-group\" ng-show=\"adHocService.costType\"><h4>{{getWord(adHocService.costType)}}</h4><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><label for=\"cboQuantityByForCostType\">{{getWord(\'QuantityBy\')}}</label><select id=\"cboQuantityByForCostType\" name=\"cboQuantityByForCostType\" class=\"form-control\" ng-model=\"adHocService.quantityBy\" convert-to-number=\"\" data-ng-options=\"quantityByForCostType.value as quantityByForCostType.name for quantityByForCostType in availableQuantityBy\" ng-change=\"clearQuantityField(adHocService.quantityBy,adHocService.costType);\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.quantityBy == quanityByEnums.Ask)\"><label for=\"txtQuantityForCostType\">{{getWord(\'Quantity\')}}</label> <input id=\"txtQuantityForCostType\" name=\"txtQuantityForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.quantity\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && adHocService.costType==\'adHocMachineCost\') || (adHocService.quantityBy && adHocService.costType ==\'adHocLaborCost\')\"><label for=\"txtSpeedForCostType\">{{getWord(\'Speed\')}}</label> <input id=\"txtSpeedForCostType\" name=\"txtSpeedForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.speed\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"(adHocService.quantityBy && (adHocService.costType==\'adHocMachineCost\')) || (adHocService.quantityBy && (adHocService.costType ==\'adHocLaborCost\'))\"><label for=\"txtRateForCostType\">{{getWord(\'Rate\')}}&nbsp;&#40;&#36;&#47;{{getWord(\'Hr\')}}&#41;</label> <input id=\"txtRateForCostType\" name=\"txtRateForCostType\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.hourlyCost\"></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\" ng-show=\"adHocService.quantityBy && (adHocService.costType == \'adHocMaterialCost\')\"><label for=\"txtUnitMeasureForMaterialCost\">{{getWord(\'UnitCost\')}}&nbsp;&#40;&#36;&#41;</label> <input id=\"txtUnitMeasureForMaterialCost\" name=\"txtUnitMeasureForMaterialCost\" type=\"text\" class=\"form-control\" ng-model=\"adHocService.unitCost\"></div></div></div><hr class=\"m-b-none\"></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"saveBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'Save\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\" ng-click=\"cancelAddHoc()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/itemTemplate.html","<form class=\"modal fade\" role=\"dialog\" id=\"saveAsTemplateModal\" autocomplete=\"off\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><h3 class=\"modal-title\"><b>{{getWord(\'SaveAsTemplate\')}}</b></h3></div><div class=\"modal-body\"><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"txtTemplateName\">{{getWord(\'TemplateName\')}}</label> <input id=\"txtTemplateName\" name=\"txtTemplateName\" type=\"text\" class=\"form-control\" ng-model=\"template.templateName\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"txtDescription\">{{getWord(\'Description\')}}</label><span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span> <textarea id=\"txtDescription\" name=\"txtDescription\" type=\"text\" class=\"form-control\" style=\"resize: vertical;\" ng-model=\"template.templateDescription\" rows=\"5\"></textarea></div></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button id=\"saveBtn\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'SaveChanges\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" data-dismiss=\"modal\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></form>");
$templateCache.put("app/quote/partials/stepTwo/pickupMethod.tpl.html","<div id=\"pickupPanel\" ng-show=\"item.shippingMethodName==\'10\'\"><div class=\"row\"><div class=\"col-lg-10\"><div class=\"form-group\"><div class=\"col-lg-6 m-l-n\"><label class=\"control-label\">{{getWord(\"Location\")}}</label><span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'SelectLocationLabel\')}}</span><div class=\"input-group\"><input id=\"searchByStore\" type=\"text\" class=\"input-md form-control\" name=\"searchByStore\" maxlength=\"500\" ng-model=\"pickUpSearchText\" input-enter=\"searchByString(pickUpSearchText)\" placeholder=\"Store Number or City\" autofocus=\"\" autocomplete=\"off\" ng-disabled=\"readOnly\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!pickUpSearchText\" ng-click=\"searchByString(pickUpSearchText)\"><i class=\"fa fa-fw fa-search fa-lg\"></i></button></div></div></div><div class=\"col-lg-6 m-t-lg\" ng-hide=\"true\"><span class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 secondary-bold-text\">{{getWord(\'SelectedStore\')}}&nbsp;&#58;</span> <span class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><b>{{selectedStore}}</b></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 m-t\"><div ng-show=\"searchedData.length==0 && pickUpSearchText\" class=\"secondary-bold-text\" ng-bind=\"getWord(\'NoResultsFound\')\"></div></div></div><div ng-show=\"false\" id=\"txtPickupPhone\"></div><div class=\"col-lg-6 pick-card-wrap\" ng-repeat=\"storeDetails in searchedData track by $index\"><div class=\"ibox add-ibox-border\"><div class=\"ibox-content ibox-content-style\"><div class=\"row\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 secondary-bold-text\">{{getWord(\'StoreNumber\')}}</div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><b ng-show=\"storeDetails.externalId\" ng-bind=\"storeDetails.externalId\"></b></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 secondary-bold-text\">{{getWord(\'Address\')}}</div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><p class=\"pickup-address add-margin\"><span ng-show=\"storeDetails.address1\">{{storeDetails.address1}}</span> <span ng-show=\"storeDetails.address2\">{{storeDetails.address2}}</span> <span>{{storeDetails.city}}, {{storeDetails.state}} {{storeDetails.postalCode}}</span></p></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 secondary-bold-text\">{{getWord(\'Phone\')}}</div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><b ng-show=\"storeDetails.phone1CountryCode\" ng-bind=\"storeDetails.phone1CountryCode\"></b> <b ng-show=\"storeDetails.phone1Number\" class=\"m-r\">{{storeDetails.phone1Number}}</b> <b ng-show=\"storeDetails.phone1Ext\" ng-bind=\"getWord(\'Ext\')\"></b> <b ng-show=\"storeDetails.phone1Ext\" ng-bind=\"storeDetails.phone1Ext\"></b></div></div></div><div id=\"selectButton{{$index}}\" ng-click=\"selectStore($index)\" class=\"select-btn-toggle col-xs-3 col-sm-3 col-md-3 col-lg-3\"><span class=\"selectButton btn btn-default pull-right\">{{getWord(\'Select\')}}</span></div></div></div></div></div><label class=\"control-label text-danger\" ng-show=\"noPickupSelected && !item.customerSelectedStoreId\">{{getWord(\"SelectPickupLocation\")}}</label></div>");
$templateCache.put("app/quote/partials/stepTwo/recipientSearch.tpl.html","<div class=\"row\"><div class=\"col-lg-12\"><div class=\"padded-row form-group\"><div angucomplete-alt=\"\" id=\"ex2\" placeholder=\"- Select or Add New Recipient -\" maxlength=\"50\" pause=\"1000\" selected-object=\"selectedRecipient\" local-data=\"recipients\" search-fields=\"fullName,street1,street2,city,state,postalCode\" title-field=\"name\" minlength=\"0\" input-changed=\"inputChanged\" input-class=\"form-control form-control-small\" match-class=\"highlight\" template-url=\"/my-custom-template.html\" initial-value=\"initialRecipient\"></div><script type=\"text/ng-template\" id=\"/my-custom-template.html\"><div class=\"angucomplete-holder\" ng-class=\"{\'angucomplete-dropdown-visible\': showDropdown}\"> <div class=\"inner-addon right-addon\"> <i ng-if=\"!searchStr && !hasRecipientObject\" class=\"glyphicon glyphicon-search m-r-n\"></i> <i ng-if=\"searchStr || hasRecipientObject\" ng-click=\"clearInput()\" class=\"glyphicon glyphicon-remove m-r-n\"></i> <input ng-model=\"searchStr\" ng-disabled=\"disableInput\" type=\"text\" shipping-input-handler id=\"inputField{{newIndex}}\" placeholder=\"{{placeholder}}\" ng-focus=\"onFocusHandler();\" class=\"{{inputClass}} recipientInputField\" ng-focus=\"resetHideResults()\" ng-blur=\"hideResults($event)\" autocapitalize=\"off\" autocorrect=\"off\" autocomplete=\"off\" ng-change=\"inputChangeHandler(searchStr)\"/> </div> <div class=\"angucomplete-dropdown\" ng-show=\"showDropdown\" style=\"overflow: hidden; max-height: 500px; width: 100%;\"> <div class=\"angucomplete-searching\" ng-show=\"searching\"> <strong ng-bind=\"textSearching\"></strong> </div> <div class=\"angucomplete-row\" recipient-dropdown-handler> <a id=\"performAddActionId{{newIndex}}\" ng-click=\"performAddAction(newIndex,$event)\"> <span> <i class=\"fa fa-plus p-r-sm\"></i> <span class=\"font-bold\" ng-bind=\"addNewRecipientLabel\"></span> </span> </a> </div> <hr class=\"m-n\" ng-show=\"searchStr\"/> <div class=\"angucomplete-row\" ng-if=\"searchStr\" ng-repeat=\"result in results | limitTo:5\" ng-click=\"selectResult(result)\" ng-mouseenter=\"hoverRow($index)\" ng-class=\"{\'angucomplete-selected-row\': $index == currentIndex}\"> <div class=\"angucomplete-title\" ng-if=\"matchClass\"> <div class=\"angucomplete-row secondary-bold-text\"> <table width=\"100%\"> <tr> <td class=\"pull-left\"> <span ng-bind-html=\"result.title\"></span> </td> </tr> </table> </div> </div> </div> <div class=\"angucomplete-searching p-xs\" ng-show=\"!searching && (!results || results.length == 0) && searchStr\" ng-bind=\"textNoResults\"> </div> </div> </div></script></div></div></div>");
$templateCache.put("app/quote/partials/stepTwo/shippingMethod.tpl.html","<div id=\"shippingPanel\" ng-show=\"item.shippingMethodName==\'20\'\"><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\"DeliveryMethod\")}}</label><select id=\"deliveryMethod\" name=\"deliveryMethod\" class=\"form-control\" ng-model=\"serviceLevel\" ng-change=\"changeDeliveryMethod(serviceLevel)\" ng-disabled=\"readOnly\"><option ng-repeat=\"delivery in serviceLevels\" value=\"{{delivery.code}}\" ng-selected=\"delivery.code === serviceLevel\">{{delivery.name}}</option></select></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\"><label class=\"m-r\">{{getWord(\"ShippingAddress\")}}</label> <label class=\"control-label\" ng-show=\"shipToRecipients.length>1\"><b>{{allocatedQuantity}}</b>&nbsp;{{getWord(\"Allocated\")}} of <b>{{item.quantity}}</b></label> <label class=\"control-label text-danger\" ng-show=\"invalidQuantity && shipToRecipients.length>1\">&#40;{{getWord(\"InvalidQuantityMessage\")}}&#41;</label><table class=\"table custom-table-border\" id=\"shippingRecipientTable\"><thead><tr><th>{{getWord(\"ItemQuantity\")}}</th><th>{{getWord(\"Recipient\")}}</th><th class=\"text-center\">{{getWord(\"Action\")}}</th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat=\"data in shipToRecipients\"><td><span class=\"form-group\" ng-class=\"{\'has-error\' : invalidQuantity && shipToRecipients.length>1}\" ng-show=\"shipToRecipients.length>1\"><input id=\"txtItemQuantity\" name=\"option[]\" type=\"text\" class=\"form-control\" ng-model=\"data.quantity\" ng-change=\"recipientQuantity(data.quantity,$index)\"> &nbsp;&nbsp;of</span> <span ng-show=\"item.quantityVariations.length<1\">{{item.quantity}}</span> <span ng-show=\"item.quantityVariations.length>=1\">{{getWord(\'Multiple\')}}</span><div ng-show=\"invalidQuantity && shipToRecipients.length>1\"><label class=\"text-danger\">{{getWord(\'InvalidQuantity\')}}</label></div><div ng-show=\"notANumber\"><label class=\"text-danger\">{{getWord(\'OnlyPositiveNumbersAllowed\')}}</label></div></td><td><fieldset ng-disabled=\"readOnly\"><recipient-search></recipient-search></fieldset></td><td class=\"text-center\"><div id=\"actionDropDown\" class=\"input-group m-b\"><div class=\"input-group-btn\" uib-dropdown=\"\"><button id=\"primaryDeliveryButton{{$index}}\" tabindex=\"-1\" class=\"btn btn-white leftBorderRadius font-bold\" ng-disabled=\"disableEditBtn || readOnly\" ng-click=\"editRecipient($index)\" type=\"button\">{{getWord(\"Edit\")}}</button> <button id=\"toggleDeliveryAction{{$index}}\" class=\"btn btn-white rightBorderRadius\" uib-dropdown-toggle=\"\" ng-show=\"!disableEditBtn && shipToRecipients.length>1\" ng-disabled=\"disableEditBtn\" type=\"button\"><span class=\"caret\"></span></button><ul id=\"secondaryButton\" uib-dropdown-menu=\"\"><li><a href-void=\"\" ng-click=\"removeItem($index)\"><b>{{getWord(\"RemoveAddress\")}}</b></a></li></ul></div></div></td></tr></tbody></table><label class=\"text-danger\" ng-show=\"canNotAddRecipient\" id=\"canAddLabel\">{{getWord(\'CanNotAddRecipient\')}}</label></div></div></div></div>");
$templateCache.put("app/quote/partials/stepTwo/variationType.html","<fieldset ng-hide=\"isTabEnabled\"><div class=\"row\" ng-repeat=\"type in variationRows\"><div class=\"p-t-sm m-r-sm\"><div class=\"form-group col-lg-3 col-md-6 col-sm-10 col-xs-10\"><label class=\"control-label\">{{getWord(\'VariationType\')}}</label><select name=\"variationOption[]\" id=\"variationOption{{$index}}\" class=\"form-control\" ng-change=\"changeVariationType($index)\" ng-model=\"variationType\"><option value=\"\">{{getWord(\'SelectOption\')}}</option><option ng-repeat=\"item in variationTypes\" value=\"{{item==\'Substrate\'?\'Material\':item}}\">{{getWord(item)}}</option></select></div><div class=\"col-lg-3 col-md-3 col-sm-9 col-xs-9\" id=\"variationTypeMaterial\" ng-show=\"type.value==\'Material\'\"><div class=\"form-group\"><label class=\"control-label\" ng-show=\"item.productType!=productEnums.wideFormat\">{{getWord(\'Material\')}}</label> <label class=\"control-label\" ng-show=\"item.productType==productEnums.wideFormat\">{{getWord(\'Substrate\')}}</label><select id=\"cboVariationMaterial{{$index}}\" name=\"cboVariationMaterial\" placeholder=\"-Select-\"></select></div></div><div class=\"col-md-3 col-lg-1 col-sm-9 col-xs-9 p-r-none\" ng-show=\"type.value==\'Bleed\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Bleed\')}}</label><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" class=\"onoffswitch-checkbox\" id=\"example{{$index}}\" ng-model=\"hasBleeds\" ng-change=\"changeBleedVariation(type.id,$index)\"> <label class=\"onoffswitch-label\" for=\"example{{$index}}\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div></div><div id=\"bleedOffsetRow{{$index}}\" ng-show=\"hasBleeds && type.value==\'Bleed\'\"><div class=\"form-group col-md-3 col-lg-3 col-sm-9 col-xs-9\"><label class=\"control-label\">{{getWord(\'BleedOffset\')}}</label><select id=\"cboVariationBleedOffset{{$index}}\" name=\"variationFields[]\" class=\"form-control\" ng-model=\"bleedOffset\" ng-change=\"changeBleedOffsetVariation(type.id,$index)\"><option value=\"\" disabled=\"disabled\">{{getWord(\'Select\')}}</option><option value=\"0.0625\">0.0625</option><option value=\"0.125\">0.125</option><option value=\"0.25\">0.25</option><option value=\"custom\">Custom</option></select></div><div class=\"col-md-10 col-lg-10 form-group m-l-n m-r customFields{{$index}}\" ng-show=\"hasBleeds && bleedOffset==\'custom\' && type.value==\'Bleed\'\"><div class=\"col-md-2 col-lg-2 col-sm-9 col-xs-9 customFields{{$index}}\" ng-show=\"hasBleeds && bleedOffset==\'custom\' && type.value==\'Bleed\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Top\')}}</label> <input id=\"cboVariationBleedTop{{$index}}\" name=\"cboVariationBleed[]\" type=\"text\" class=\"form-control\" ng-model=\"bleedTop\" ng-change=\"changeBleedVariation(type.id , $index)\"></div></div><div class=\"col-md-2 col-lg-2 col-sm-9 col-xs-9 customFields{{$index}}\" ng-show=\"hasBleeds && bleedOffset==\'custom\' && type.value==\'Bleed\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Right\')}}</label> <input id=\"cboVariationBleedRight{{$index}}\" name=\"cboVariationBleed[]\" type=\"text\" class=\"form-control\" ng-model=\"bleedRight\" ng-change=\"changeBleedVariation(type.id, $index)\"></div></div><div class=\"col-md-2 col-lg-2 col-sm-9 col-xs-9 customFields{{$index}}\" ng-show=\"hasBleeds && bleedOffset==\'custom\' && type.value==\'Bleed\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Bottom\')}}</label> <input id=\"cboVariationBleedBottom{{$index}}\" name=\"cboVariationBleed[]\" type=\"text\" class=\"form-control\" ng-model=\"bleedBottom\" ng-change=\"changeBleedVariation(type.id, $index)\"></div></div><div class=\"col-md-2 col-lg-2 col-sm-9 col-xs-9 customFields{{$index}}\" ng-show=\"hasBleeds && bleedOffset==\'custom\' && type.value==\'Bleed\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Left\')}}</label> <input id=\"cboVariationBleedLeft{{$index}}\" name=\"cboVariationBleed[]\" type=\"text\" class=\"form-control\" ng-model=\"bleedLeft\" ng-change=\"changeBleedVariation(type.id , $index)\"></div></div><div class=\"col-lg-1 col-md-1 col-sm-2 col-xs-2\" ng-show=\"isCustomBleed(type.id, type.value)\"><i class=\"fa fa-lg fa-times removeVariationButton m-l-sm m-t-lg\" ng-show=\"(variationRows.length>1 &amp;&amp; type.value!=\'Finishing\') && !readOnly\" ng-click=\"removeVariationType(type.id,type.value)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\"></i></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-9 col-xs-9\" ng-show=\"type.value==\'NumberOfSides\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'NumberOfSides\')}}</label><select id=\"cboVariationNumberOfSides{{$index}}\" name=\"variationFields[]\" class=\"form-control\" ng-options=\"item.value as item.name for item in sides track by item.value\" ng-model=\"side\" convert-to-number=\"\" ng-change=\"changeSidesVariation(type.id)\"></select></div></div><div class=\"col-lg-3 col-md-3 col-sm-9 col-xs-9\" ng-show=\"type.value==\'Binding\'\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Binding\')}}</label><select id=\"cboVariationPrimaryBind{{$index}}\" name=\"cboVariationPrimaryBind\" placeholder=\"-Select-\"></select></div></div><div class=\"col-lg-5 col-md-9 col-sm-9 col-xs-9\" ng-show=\"type.value==\'Color\'\"><div class=\"color-type-align\"><div class=\"form-group\"><label class=\"control-label\" ng-show=\"component.side>2\">{{getWord(\'FrontColor\')}}</label> <label class=\"control-label\" ng-show=\"component.side<=2\">{{getWord(\'Color\')}}</label><div><div class=\"btn-group\" ng-model=\"frontColor\"><span id=\"variationFrontBlack{{$index}}\" class=\"btn btn-success active\" ng-click=\"changeVariationColor(\'variationFrontBlack\'+$index,\'variationFrontColor\'+$index,type.id,\'frontBlack\')\" a-disabled=\"readOnly\">{{getWord(\'Black\')}}</span> <span id=\"variationFrontColor{{$index}}\" class=\"btn btn-default\" ng-click=\"changeVariationColor(\'variationFrontColor\'+$index,\'variationFrontBlack\'+$index,type.id,\'frontColor\')\" a-disabled=\"readOnly\">{{getWord(\'Color\')}}</span></div></div></div></div><div class=\"color-type-align\" ng-show=\"component.side>2\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'BackColor\')}}</label><div><div class=\"btn-group\" ng-model=\"backColor\"><span id=\"variationBackBlack{{$index}}\" class=\"btn btn-success active\" ng-click=\"changeVariationColor(\'variationBackBlack\'+$index,\'variationBackColor\'+$index,type.id,\'backBlack\')\" a-disabled=\"readOnly\">{{getWord(\'Black\')}}</span> <span id=\"variationBackColor{{$index}}\" class=\"btn btn-default\" ng-click=\"changeVariationColor(\'variationBackColor\'+$index,\'variationBackBlack\'+$index,type.id,\'backColor\')\" a-disabled=\"readOnly\">{{getWord(\'Color\')}}</span></div></div></div></div></div><div class=\"row\" ng-show=\"type.value==\'Finishing\'\"><div class=\"col-lg-3 col-md-6 col-sm-10 col-xs-10\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'Finishing\')}}</label><select id=\"cboVariationFinishingOptions{{$index}}\" name=\"cboVariationFinishingOptions\" placeholder=\"-Select Multiple-\" multiple=\"\"></select></div></div><div class=\"col-lg-3 col-md-6 col-sm-10 col-xs-10 m-l-sm\" id=\"variationAdHocTags\" ng-show=\"setAdHockTags($index,type.id).length>=1\"><div class=\"form-group\"><label class=\"control-label\">Finishing Notes & {{getWord(\'CustomAdHocs\')}}</label><div class=\"read-only-field\"><span class=\"custom-badge-style\" ng-repeat=\"tag in setAdHockTags($index,type.id)\"><span>{{ tag.name ? tag.name : tag.finishingOptionName }}<i class=\"fa fa-edit custom-clear-badge-style\" ng-click=\"editVariationTags(tag.name,type.id,$parent.$index,tag.finishingId,tag.description)\"></i><i class=\"fa fa-close custom-clear-badge-style\" ng-click=\"closeVariationTags(tag.name,type.id,$parent.$index,tag.finishingId)\"></i></span></span></div></div></div><i class=\"fa fa-lg fa-times removeVariationButton m-l-sm m-t-lg col-sm-1 col-xs-1\" ng-show=\"(variationRows.length>1 && type.value==\'Finishing\') && !readOnly\" ng-click=\"removeVariationType(type.id,type.value)\"></i></div></div><i class=\"fa fa-lg fa-times removeVariationButton m-l-sm m-t-lg col-lg-1 col-sm-1 col-xs-1\" ng-class=\"{\'col-lg-pull-3 col-md-pull-4\': bleedOffset==\'custom\' && type.value==\'Bleed\',\'col-lg-pull-3 col-md-pull-4\':component.side<=1 && type.value==\'Color\'}\" ng-show=\"(variationRows.length>1 && type.value!=\'Finishing\') && !isCustomBleed(type.id, type.value) && !readOnly\" ng-click=\"removeVariationType(type.id,type.value)\"></i></div><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div><a class=\"font-bold addVariationButton\" ng-hide=\"readOnly\" ng-click=\"addVariationType($index)\"><i class=\"fa fa-plus m-r-sm\"></i> {{getWord(\'AddAnotherVariation\')}}</a></div></div></fieldset>");
$templateCache.put("app/quote/partials/stepTwo/wizardStepTwo.tpl.html","<div wizard-step-two=\"\" multi-items=\"\" save-progress=\"\"><delete-confirmation-modal></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container tab-inactive-bg\"><div class=\"tabs-left\"><nav class=\"navbar-default navbar-static-side\"><ul class=\"nav metismenu inner-nav-tabs\"><li class=\"nav-item\" id=\"itemTab{{itemTab.id}}\" ng-class=\"{\'active\' : itemTab.active,\'tab-error\' : itemTab.tabClassName}\" a-disabled=\"itemTab.disabled || itemTab.isItemCosting\" ng-repeat=\"itemTab in itemTabs track by $index\"><a a-disabled=\"itemTab.disabled || itemTab.isItemCosting\" ng-class=\"{\'tab-error\':itemTab.tabClassName, \'greyColorDisabled\': itemTab.isItemCosting}\" ng-click=\"tabClick($index,true)\"><div class=\"item-accordion-toggle collapsed p-r-sm\" ng-click=\"expandItem($index)\" data-target=\"#collapse{{itemTab.id}}\" ng-class=\"{\'greyColorDisabled\': itemTab.isItemCosting}\"><span>{{getWord(\'Item\') + \' \' + ($index + 1)}}</span> <span ng-show=\"itemTab.name\">&#45;&nbsp;{{itemTab.name}}</span><br><span ng-show=\"itemTab.isItemCosting\" class=\"text-warning p-l-sm\">{{\'Updating \'}} <span class=\"fa fa-refresh\" aria-hidden=\"true\"></span></span></div></a><div id=\"collapse{{itemTab.id}}\" class=\"collapse\" ng-class=\"{\'in\' : itemTab.active}\"><ul class=\"nav nav-second-level\"><li class=\"active\" id=\"configTab{{itemTab.id}}\" ng-click=\"goToConfiguration(itemTab.id)\"><a>Configuration</a></li><li id=\"deliveryTab{{itemTab.id}}\" ng-click=\"goToDelivery(itemTab.id)\"><a><span ng-class=\"itemTab.tabDeliveryClassName\">Delivery</span></a></li></ul></div></li></ul></nav><form ng-show=\"activeTabOne\" class=\"tab-content\" id=\"stepTwoForm\" autocomplete=\"off\"><div id=\"tab-6\" class=\"tab-pane active\"><div class=\"panel-body\"><fieldset class=\"m-b-xs\" ng-disabled=\"readOnly\"><div><b class=\"large-text\">Item Configuration</b> <b><a class=\"pull-right\" a-disabled=\"multiItems.length<=1 || getCostingStatus()\" ng-disabled=\"multiItems.length<=1 || getCostingStatus()\" ng-click=\"deleteItem()\" ng-hide=\"readOnly\"><i class=\"fa fa-trash-o m-r-xs\"></i>{{getWord(\'DeleteItem\')}}<br><span ng-show=\"getCostingStatus()\" class=\"text-warning p-l-sm\">{{\'Updating \'}} <span class=\"fa fa-refresh\" aria-hidden=\"true\"></span></span></a></b></div><div class=\"row\"><div class=\"col-lg-5 col-md-6\"><div class=\"form-group\"><label class=\"control-label\">{{getWord(\'SelectProduct\')}}</label><select id=\"cboProductTypeName\" name=\"cboProductTypeName\" placeholder=\"Select a product type...\"></select></div></div><div class=\"col-lg-5 col-md-6\" ng-show=\"showFields\"><label class=\"control-label\" for=\"txtItemTemplate\">{{getWord(\'CopyFromTemplate\')}}<span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></label><select id=\"txtItemTemplate\" name=\"txtItemTemplate\" class=\"form-control\" ng-model=\"item.itemTemplateGuid\" ng-change=\"templateChange()\" ng-options=\"template.itemTemplateId as template.name for template in itemTemplates track by template.itemTemplateId\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div></div><div class=\"row\" ng-show=\"showFields\"><div class=\"col-lg-5 col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtItemName\">{{getWord(\'ItemName\')}}</label> <input id=\"txtItemName\" name=\"txtItemName\" type=\"text\" class=\"form-control\" ng-change=\"updateItemName()\" ng-model=\"item.itemName\"></div></div></div><div class=\"row\" ng-hide=\"!showFields || item.productType == productEnums.flatSheet || item.productType == productEnums.envelope || item.productType == productEnums.wideFormat || item.productType == productEnums.finishingOnly\"><div class=\"col-lg-3 col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"cboCollateMethod\">{{getWord(\'Collate\')}}<span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></label><select id=\"cboCollateMethod\" name=\"cboCollateMethod\" type=\"text\" class=\"form-control\" ng-model=\"item.collateMethod\" convert-to-number=\"\"><option ng-repeat=\"collate in collateMethods\" value=\"{{collate.value}}\">{{collate.name}}</option></select></div></div></div><div class=\"row\" ng-hide=\"!showFields\"><div class=\"p-t-sm m-r-sm quantity-var-wrap\"><div class=\"form-group col-lg-2 col-md-3 quantity-field-align\"><label class=\"control-label\">{{quantityLabelText}}<i class=\"fa fa-info-circle quantity-info-icon\" tooltip-placement=\"right\" uib-tooltip=\"{{quantityTooltipText}}\"></i></label> <input name=\"option[]\" id=\"staticQuantity\" type=\"text\" class=\"form-control\" ng-model=\"item.quantity\" ng-change=\"changeStaticQuantity()\"></div><div class=\"col-md-3 col-lg-2 hide form-group quantity-field-align\" id=\"optionTemplate\"><label class=\"control-label\" id=\"quanLabel\">{{quantityLabelText}}</label> <input name=\"option[]\" type=\"text\" class=\"form-control inline\"><i ng-hide=\"readOnly\" class=\"fa fa-times removeButton inline m-l-sm\"></i></div><div class=\"col-lg-3 p-t-sm\"><div class=\"form-group\"><label class=\"control-label\">&nbsp;</label><div><a class=\"font-bold addButton\" ng-click=\"addQuantity($index)\" ng-hide=\"readOnly\"><i class=\"fa fa-plus m-r-sm\"></i> {{addQuantityVariationLabelText}}</a></div></div></div></div></div><div class=\"row\" ng-show=\"showFields\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtItemFile\">{{getWord(\'SupportingFiles\')}}<span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></label> <input type=\"file\" class=\"hide\" id=\"txtItemFile\" name=\"txtItemFile\" ng-model=\"item.files\" multiple=\"\"><div class=\"form-group\"><a class=\"btn btn-default\" id=\"fileSelect\"><b><i class=\"fa fa-paperclip m-r-xs\"></i>{{getWord(\'BrowseFiles\')}}</b></a></div><span id=\"fileList\" ng-hide=\"item.files.length\"><span class=\"optional-bold-text\">{{getWord(\'NoFilesSelected\')}}</span></span><div><ul class=\"list-unstyled files-align\"><li class=\"control-label\" ng-repeat=\"file in item.files\"><a data-toggle=\"tooltip\" data-placement=\"top\" href=\"\" a-disabled=\"readOnly\" title=\"{{file.fileName}}\">{{file.fileName}}</a><i class=\"fa fa-times p-w-sm\" ng-click=\"removeFile(file)\" ng-hide=\"readOnly\"></i></li></ul></div></div></div></div></fieldset><fieldset ng-show=\"showFields\" ng-disabled=\"readOnly\"><div class=\"row\"><div class=\"col-lg-5\"><div class=\"form-group\"><label class=\"control-label\" for=\"txtItemNotes\">{{getWord(\'ItemNotes\')}}<span class=\"optional-bold-text\">&nbsp;&#45;&nbsp;{{getWord(\'Optional\')}}</span></label> <textarea id=\"txtItemNotes\" name=\"txtItemNotes\" type=\"text\" class=\"form-control\" ng-model=\"item.itemNotes\"></textarea></div></div></div></fieldset><fieldset class=\"component-tab-align\" ng-show=\"showFields\" ng-disabled=\"readOnly\"><component-tabs initialize-item-components=\"\"></component-tabs></fieldset><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"goPrevious(1)\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"PreviousQuoteInfo\")}}</span></button><div id=\"createGrpBtn\" ng-show=\"!id\" class=\"btn-group pull-right m-l-sm\" uib-dropdown=\"\"><button id=\"createBtn\" class=\"btn btn-success\" ng-click=\"validateStepTwo()\" ng-class=\"{\'rightBorderRadius\': readOnly}\">{{getWord(\'NextDelivery\')}}</button> <button id=\"btn2\" ng-hide=\"readOnly\" class=\"btn btn-success dropdown-toggle\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li a-disabled=\"!item.productType\"><a id=\"saveProgress\" class=\"font-weight-bold\" ng-click=\"saveProgress()\" a-disabled=\"!item.productType\">{{getWord(\'SaveProgress\')}}</a></li><li><a id=\"submitAnother\" class=\"font-weight-bold\" ng-click=\"openTemplateModel()\">{{getWord(\'SaveAsTemplate\')}}</a></li></ul></div><button id=\"saveBtn\" ng-show=\"id\" class=\"btn btn-success pull-right m-l-sm\" type=\"submit\">{{getWord(\'Save\')}}</button> <button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"cancelForm()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></form><delivery-methods id=\"delivery-form\" ng-show=\"activeTabTwo\"></delivery-methods><item-template></item-template></div></div></div></div></div>");
$templateCache.put("app/quote/views/convertQuote/convertQuote.html","<div class=\"wrapper wrapper-content p-t-sm\"><div class=\"row custom-layout padding-left\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : convertBreadcrumb},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'active\':true,\'label\':convertBreadcrumb}]\"></big-breadcrumbs><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><add-user-notes-modal></add-user-notes-modal><view-user-notes-modal></view-user-notes-modal><div quote-action-buttons=\"\"></div><div id=\"dropDownContainer\" class=\"input-group m-b m-t-lg m-r-lg\" ng-show=\"defaultButtonLabel && readOnly\"><div class=\"input-group-btn dropdown\" uib-dropdown=\"\"><button id=\"toggleAction\" ng-show=\"showActionButton(\'Convert\') || showActionButton(\'Requote\') || showActionButton(\'Delete\') || showActionButton(\'CostedReportOnly\') || showActionButton(\'ConvertedReportOnly\')\" class=\"btn btn-success rightBorderRadius dropdown-toggle pull-right\" uib-dropdown-toggle=\"\" type=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span></button><div quote-action-buttons=\"\"></div><button id=\"primaryButton\" tabindex=\"-1\" class=\"btn btn-success leftBorderRadius pull-right m-b-xs\" ng-class=\"{\'rightBorderRadius\': !showActionButton(\'Convert\') && !showActionButton(\'Requote\') && !showActionButton(\'Delete\') && !showActionButton(\'CostedReportOnly\') && !showActionButton(\'ConvertedReportOnly\')}\" ng-click=\"defaultButtonAction(defaultButtonLabel)\" type=\"button\"><b ng-bind=\"getWord(defaultButtonLabel)\"></b></button><ul id=\"secondaryButton\" uib-dropdown-menu=\"\" class=\"dropdown-menu\"><li><a href-void=\"\" ng-click=\"convertQuote()\" ng-show=\"showActionButton(\'Convert\')\"><b>{{getWord(\'Convert\')}}</b></a></li><li><a href-void=\"\" ng-click=\"requote()\" ng-show=\"showActionButton(\'Requote\')\"><b>{{getWord(\'Requote\')}}</b></a></li><li><a ng-click=\"deleteItem()\" ng-show=\"showActionButton(\'Delete\')\" data-toggle=\"modal\" data-target=\"#deleteModal\"><b>{{getWord(\'Delete\')}}</b></a></li><li><a href-void=\"\" ng-click=\"downloadCostedSummaryReport()\" ng-show=\"showActionButton(\'CostedReportOnly\') || showActionButton(\'ConvertedReportOnly\')\"><b>{{getWord(\'DownloadCostedSummaryReport\')}}</b></a></li><li><a href-void=\"\" ng-click=\"downloadCostedDetailedReport()\" ng-show=\"showActionButton(\'CostedReportOnly\') || showActionButton(\'ConvertedReportOnly\')\"><b>{{getWord(\'DownloadCostedDetailedReport\')}}</b></a></li><li><a href-void=\"\" ng-click=\"downloadConvertedSummaryReport()\" ng-show=\"showActionButton(\'ConvertedReportOnly\')\"><b>{{getWord(\'DownloadConvertedSummaryReport\')}}</b></a></li><li><a href-void=\"\" ng-click=\"downloadConvertedDetailedReport()\" ng-show=\"showActionButton(\'ConvertedReportOnly\')\"><b>{{getWord(\'DownloadConvertedDetailedReport\')}}</b></a></li></ul></div></div></div><warning-badge class=\"m-t-imp\"></warning-badge><quote-create-error-badge class=\"m-t-imp\"></quote-create-error-badge><quotes-header></quotes-header><div class=\"wrapper quote-info-padding fadeIn\"><div class=\"row\"><div class=\"col-lg-12 custom-panel\"><div class=\"ibox\"><div class=\"ibox-title\" style=\"padding: 5px 15px 7px !important;\"><div class=\"ibox-tools\" style=\"margin-top: 0px !important;\"><a class=\"collapse-link collapsed\" id=\"quoteNotesLink\" data-toggle=\"collapse\" data-target=\"#quoteNotes\"><i></i><h5><span class=\"ng-binding\">Notes</span><span class=\"label label-success status-label\">{{userNoteCount}}</span></h5></a></div><div class=\"btn-group pull-right m-l-sm\"><button class=\"btn btn-success\" data-toggle=\"modal\" data-target=\"#addUserNotesModal\" ng-click=\"resetNoteForm()\"><b>+</b> Add a note</button></div></div><div class=\"ibox-content collapse\" id=\"quoteNotes\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"userNotesTable\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" dt-instance=\"dtInstance\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Time\')\"></th><th ng-bind=\"getWord(\'Note Author\')\"></th><th ng-bind=\"getWord(\'Notes\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div></div></div></div><div class=\"wrapper quote-form-padding fadeInRight\"><cancel-confirmation-modal></cancel-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content no-padding\"><div class=\"wizard\"><div class=\"content\"><ng-include ng-show=\"showJobCost\" src=\"\'app/quote/partials/stepThree/wizardStepThree.tpl.html\'\"></ng-include><div ng-show=\"!showJobCost\" class=\"no-items-text\"><center class=\"secondary-bold-text\" ng-bind=\"getWord(\'NoItemsConfigured\')\"></center></div></div></div></div></div><div class=\"ibox\" ng-show=\"(readOnly || enableConvert) && convertActionsFlag\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"pull-right m-l-sm\" ng-show=\"reviewQuoteBtn\"><button class=\"btn btn-success\" ng-click=\"reviewQuoteForConvert(quoteId)\"><span class=\"font-bold\">{{getWord(\'ReviewQuote\')}}</span><i class=\"fa fa-chevron-right m-l-sm\"></i></button></div><div id=\"createGrpBtn\" class=\"btn-group pull-right m-l-sm\" uib-dropdown=\"\" ng-show=\"nextItemBtn\"><button class=\"btn btn-success\" ng-click=\"nextItemCall();\" ng-bind=\"getWord(\'NextItem\')\"></button> <button id=\"btn2\" class=\"btn btn-success dropdown-toggle\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul id=\"form-secondary-dropdown\" class=\"dropdown-menu pull-right\" style=\"margin-top: 5px !important;\" uib-dropdown-menu=\"\"><li><a class=\"font-weight-bold\" ng-click=\"reviewQuoteForConvert(quoteId)\" ng-bind=\"getWord(\'ReviewQuote\')\"></a></li></ul></div><button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"goToQuoteList()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/quote/views/convertQuote/editDelivery.html","<div class=\"wrapper wrapper-content p-t-sm\"><div class=\"row custom-layout padding-left\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'EditDeliveryInfo\'},{\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'CovertQuote\'},{\'active\':true,\'label\':\'EditDeliveryInfo\'}]\"></big-breadcrumbs></div><quote-create-error-badge class=\"m-t-imp\"></quote-create-error-badge><quotes-header></quotes-header><div class=\"wrapper quote-form-padding fadeInRight\"><cancel-confirmation-modal></cancel-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content no-padding\"><div class=\"wizard\"><div class=\"content min-height-auto\"><edit-delivery-info></edit-delivery-info></div></div></div></div><div class=\"ibox m-t-n-25\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div id=\"createGrpBtn\" class=\"btn-group pull-right m-l-sm\"><button id=\"createBtn\" class=\"btn btn-success\" ng-click=\"updateDelivery()\"><span class=\"font-bold\">{{getWord(\'SaveAndContinue\')}}</span></button></div><button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-click=\"goToConvertQuote(quoteId)\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/quote/views/convertQuote/reviewQuote.html","<div class=\"wrapper wrapper-content p-t-sm\"><div class=\"row custom-layout padding-left\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'ConvertQuote\'},{\'label\' : \'Home\',\'href\' : \'app.main\' },{\'active\':true,\'label\':\'ConvertQuote\'}]\"></big-breadcrumbs></div><warning-badge class=\"m-t-imp\"></warning-badge><quote-create-error-badge class=\"m-t-imp\"></quote-create-error-badge><quotes-header></quotes-header><div class=\"wrapper quote-form-padding fadeInRight\"><cancel-confirmation-modal></cancel-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content no-padding\"><div class=\"wizard\"><div class=\"content min-height-auto\"><convert-quote-review></convert-quote-review></div></div></div></div><div class=\"ibox m-t-n-25\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"goToConvertQuote(quoteId)\"><i class=\"fa fa-chevron-left\"></i> &nbsp;<span class=\"font-bold\">{{getWord(\"Previous\")}}</span></button><div id=\"createGrpBtn\" class=\"btn-group pull-right m-l-sm\" ng-show=\"!readOnly\"><button id=\"createBtn\" class=\"btn btn-primary\" ng-click=\"validateReviewQuote()\"><span class=\"font-bold\">{{getWord(\'ConvertToOrder\')}}</span></button></div><button id=\"cancelBtn\" class=\"btn btn-default pull-right no-borders\" type=\"button\" ng-show=\"!readOnly\" ng-click=\"goToQuoteList()\">{{getWord(\'Cancel\')}}</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/customer/recipient/views/editRecipient.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><address-error-badge></address-error-badge><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : recipientBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Customers\'}, {\'active\':true,\'label\':recipientBreadcrumb}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><recipient-form></recipient-form></div></div></div></div></div>");
$templateCache.put("app/customer/recipient/partials/recipientForm.tpl.html","<form id=\"recipientForm\" recipient-address=\"\" class=\"form-horizontal padding-10\" autocomplete=\"off\"><fieldset><span class=\"pull-right requiredField p-w-lg\">{{getWord(\'IndicatesRequiredField\')}}</span><div class=\"form-group\"><div class=\"\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label>{{getWord(\'RecipientName\')}}</label> <input id=\"txtFullName\" name=\"txtFullName\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.fullName\"></div></div></div><div class=\"form-group\"><div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label>{{getWord(\'CompanyName\')}}</label> <input id=\"txtCompanyName\" name=\"txtCompanyName\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.companyName\"></div></div></div><address-recommendation></address-recommendation><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label>{{getWord(\'AddressLine1\')}}</label> <input id=\"txtStreet1\" name=\"txtStreet1\" type=\"text\" class=\"form-control satoriAddressField\" placeholder=\"Street name\" gm-places-autocomplete=\"\" ng-show=\"disableAutoFill(\'txtStreet1\')\" ng-keyup=\"resetRecipientAddress()\" ng-model=\"recipient.street1\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label>{{getWord(\'AddressLine2\')}}</label> <input id=\"txtStreet2\" name=\"txtStreet2\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.street2\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-4\"><label>{{getWord(\'City\')}}</label> <input id=\"txtCity\" name=\"txtCity\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.city\"></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\"><label class=\"requiredField\">{{getWord(\'Zipcode\')}}</label> <input id=\"txtZipCode\" name=\"txtZipCode\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.postalCode\"></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-4\"><label>{{getWord(\'Country\')}}</label><select id=\"cboCountry\" name=\"cboCountry\" type=\"text\" class=\"form-control satoriAddressField\" ng-model=\"recipient.country\" ng-change=\"getStates()\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option><option value=\"{{value.code}}\" ng-repeat=\"value in countries\">{{value.name}}</option></select></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\" ng-show=\"recipient.country==\'US\'\"><label>{{getWord(\'State\')}}</label><select id=\"cboState\" name=\"cboState\" class=\"form-control satoriAddressField\" ng-model=\"recipient.state\" data-ng-options=\"v.stateCode as v.name for v in states\"><option value=\"\" disabled=\"\" selected=\"selected\">Select</option></select></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\" ng-show=\"recipient.country!=\'US\'\"><label>{{getWord(\'State\')}}</label> <input id=\"txtState\" name=\"txtState\" type=\"text\" class=\"form-control satoriAddressField\" autocomplete=\"nope\" ng-model=\"recipient.state\"></div></div><div class=\"form-group\"><div class=\"row p-w-sm\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-4\"><label class=\"control-label\">{{getWord(\'Phone\')}}</label><div class=\"input-group\"><span class=\"input-group-addon\" ng-bind=\"recipient.countryCode\"></span> <input id=\"txtPhone\" name=\"txtPhone\" type=\"tel\" class=\"form-control\" ng-show=\"disableAutoFill(\'txtPhone\')\" data-intl-tel=\"\" ng-model=\"recipient.phoneNumber\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\"><label class=\"control-label\" for=\"txtExtension\">{{getWord(\'Extension\')}}</label> <input id=\"txtExtension\" name=\"txtExtension\" type=\"text\" class=\"form-control\" autocomplete=\"nope\" ng-model=\"recipient.phoneExt\"></div></div></div></fieldset><form-actions showcheck=\"true\" create-text=\"SaveRecipient\" create-another-text=\"SaveAndCreateRecipient\"></form-actions></form>");
$templateCache.put("app/customer/recipient/partials/recipientList.tpl.html","<div class=\"panel-body\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><table id=\"recipientDatatable\" data-table-options=\"recipientOptions\" datatable-basic=\"\" table-dropdown-actions=\"\" class=\"table table-hover\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Recipient\')\"></th><th ng-bind=\"getWord(\'Company\')\"></th><th ng-bind=\"getWord(\'Address\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div>");
$templateCache.put("app/settings/product-codes/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : productBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'Product Bleed Codes\'}, {\'active\':true,\'label\':productBreadcrumb} ]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{getWord(\'ProductNames\')}}</h5></div><div class=\"ibox-content\"><product-codes-form></product-codes-form></div></div></div></div></div>");
$templateCache.put("app/settings/product-codes/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Product Bleed Codes\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'Product Bleed Codes\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"productCodesDatatable\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'ProductNames\')\"></th><th ng-bind=\"getWord(\'Code\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/settings/product-codes/partials/productCodesForm.tpl.html","<form id=\"product-codes-type-form\" name=\"product-type-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"productTypeValue\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'ProductType\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"productTypeValue\" name=\"productTypeValue\" class=\"form-control\" product-type-categories=\"\" ng-model=\"productTypeValue\" data-ng-options=\"productType as productType.name for productType in productTypes | orderBy:\'name\'\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectProductType\')\"></option></select></div></div><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Code\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtName\" name=\"txtName\" type=\"text\" class=\"form-control\" ng-model=\"productType.code\"></div></div><form-actions showcheck=\"true\" create-text=\"CreateProduct\" create-another-text=\"CreateAndAddAnotherProduct\"></form-actions></form>");
$templateCache.put("app/settings/products/partials/productForm.tpl.html","<form id=\"product-type-form\" name=\"product-type-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Name\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtName\" name=\"txtName\" type=\"text\" class=\"form-control\" ng-model=\"productType.name\"></div></div><div class=\"form-group\"><label for=\"productTypeValue\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'ProductType\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"productTypeValue\" name=\"productTypeValue\" class=\"form-control\" product-type-categories=\"\" ng-model=\"productTypeValue\" data-ng-options=\"productType as productType.name for productType in productTypes | orderBy:\'name\'\"><option value=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectProductType\')\"></option></select></div></div><div class=\"form-group\"><label for=\"txtMarkup\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Markup(%)\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtMarkup\" name=\"txtMarkup\" type=\"text\" class=\"form-control\" ng-model=\"productType.markup\"></div></div><form-actions showcheck=\"true\" create-text=\"CreateProduct\" create-another-text=\"CreateAndAddAnotherProduct\"></form-actions></form>");
$templateCache.put("app/settings/products/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : productBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'Products\'}, {\'active\':true,\'label\':productBreadcrumb} ]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{getWord(\'ProductNames\')}}</h5></div><div class=\"ibox-content\"><product-form></product-form></div></div></div></div></div>");
$templateCache.put("app/settings/products/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Product Names\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'Product Names\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"productDatatable\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'ProductNames\')\"></th><th ng-bind=\"getWord(\'ProductType\')\"></th><th ng-bind=\"getWord(\'Markup(%)\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/settings/sources/partials/sourceForm.tpl.html","<form id=\"source-type-form\" name=\"source-type-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Name\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtName\" name=\"txtName\" type=\"text\" class=\"form-control\" ng-model=\"source.name\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-8\"><label class=\"checkbox-wrap\" for=\"chkSourceActive\"><input id=\"chkSourceActive\" name=\"chkSourceActive\" type=\"checkbox\" ng-model=\"source.isActive\">{{getWord(\'Active\')}} <span class=\"checkbox-mark\"></span></label></div></div><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'PriceType\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"priceType\" name=\"priceType\" class=\"form-control\" ng-model=\"source.priceType\" ng-options=\"priceType.id as priceType.value for priceType in victorPriceTypes track by priceType.id\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div></div><div ng-show=\"source.priceType === \'Victor\'\" class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'VictorPriceType\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"victorPriceType\" name=\"victorPriceType\" class=\"form-control\" ng-model=\"source.victorPriceType\" ng-options=\"orderType.id as orderType.value for orderType in setting.value track by orderType.id\"><option value=\"\" disabled=\"\" selected=\"selected\" ng-bind=\"getWord(\'SelectOption\')\"></option></select></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-8\"><label class=\"checkbox-wrap\" for=\"chkIsJdfTokenSaved\"><input id=\"chkIsJdfTokenSaved\" name=\"IsJdfTokenSaved\" type=\"checkbox\" ng-model=\"source.isJdfTokenSaved\">{{getWord(\'JDFToken\')}} <span class=\"checkbox-mark\"></span></label></div></div><form-actions showcheck=\"true\" create-text=\"CreateSource\" create-another-text=\"CreateAndAddAnotherSource\"></form-actions></form>");
$templateCache.put("app/settings/sources/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : sourceBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'Sources\'}, {\'active\':true,\'label\':sourceBreadcrumb} ]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{getWord(\'Sources\')}}</h5></div><div class=\"ibox-content\"><source-form></source-form></div></div></div></div></div>");
$templateCache.put("app/settings/sources/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Sources\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'Sources\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"sourceDatatable\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Name\')\"></th><th ng-bind=\"getWord(\'Active\')\"></th><th ng-bind=\"getWord(\'PriceType\')\"></th><th ng-bind=\"getWord(\'VictorPriceType\')\"></th><th ng-bind=\"getWord(\'Actions\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/settings/system-roles/partials/system-roles-assign-commands.tpl.html","<form id=\"system-role-assign-commands-form\" name=\"system-role-assign-commands-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><fieldset><legend>{{getWord(\'AssignCommandsFor\') + \" \" + systemRole.name}}</legend><div class=\"form-group\"><label for=\"cboSystemRoleCategories\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'FilterByCategory\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"cboSystemRoleCategories\" name=\"cboSystemRoleCategories\" class=\"form-control\" ng-options=\"category as category for category in systemRoleCategories\" ng-model=\"systemRoleObj.systemRoleCategory\" ng-change=\"filterCategory(systemRoleObj.systemRoleCategory)\"><option value=\"\">{{ getWord(\'SelectOption\') }}</option></select></div></div></fieldset><fieldset><select id=\"cboSystemRoleCommandsList\" name=\"cboSystemRoleCommandsList\" multiple=\"multiple\" size=\"10\" dual-list-box=\"\" non-selected-list-label=\"Commands\" selected-list-label=\"Assigned Commands\" selectorminimalheight=\"500\" ng-options=\"availableCommand.fullName as availableCommand.formattedName for availableCommand in availableCommandsFiltered\" ng-model=\"systemRoleObj.assignedCommandIds\"></select></fieldset><assign-actions></assign-actions></form>");
$templateCache.put("app/settings/system-roles/partials/system-roles-form.tpl.html","<form id=\"system-roles-form\" name=\"system-roles-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Name\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtName\" name=\"txtName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"systemRole.name\"></div></div><form-actions create-text=\"createText\" create-another-text=\"createAnotherText\" showcheck=\"true\"></form-actions></form>");
$templateCache.put("app/settings/system-roles/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs ng-show=\"!id\" items=\"[ {\'header\' : true,\'label\' : \'Add System Roles\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Roles\'}, {\'active\':true,\'label\': \'Add System Roles\'} ]\"></big-breadcrumbs><big-breadcrumbs ng-hide=\"breadCrumbs || checkBreadCrumbs\" items=\"[ {\'header\' : true,\'label\' : \'Edit System Roles\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Roles\'}, {\'active\':true,\'label\': \'Edit System Roles\'} ]\"></big-breadcrumbs><big-breadcrumbs ng-show=\"breadCrumbs\" items=\"[ {\'header\' : true,\'label\' : \'Commands\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Roles\'}, {\'active\':true,\'label\': \'Commands\'} ]\"></big-breadcrumbs><div class=\"tabs-container\"><ul class=\"nav nav-tabs pull-right\" ng-show=\"id\"><li class=\"nav-item\" ng-click=\"changeTab(1)\" ng-class=\"{\'active\' : activeDetailsTab}\" id=\"detailsTab\"><a href=\"\" data-toggle=\"tab\" ng-click=\"breadCrumbs=false\">{{getWord(\'Details\')}}</a></li><li ng-click=\"changeTab(2)\" id=\"commandTab\" ng-class=\"{\'active\' : activeCommandTab}\"><a href=\"\" style=\"margin-right: auto;border-right: none;\" data-toggle=\"tab\" ng-click=\"breadCrumbs=true\">{{getWord(\'Commands\')}}</a></li></ul><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" style=\"border-width: inherit\"><h5>{{getWord(\'SystemRoles\')}}</h5></div><div class=\"ibox-content\"><div class=\"tab-content\"><div class=\"tab-pane\" id=\"detailsBody\" ng-class=\"{\'active\' : activeDetailsTab}\"><system-roles-form></system-roles-form></div><div class=\"tab-pane\" id=\"commandBody\" ng-class=\"{\'active\' : activeCommandTab}\"><system-roles-assign-commands></system-roles-assign-commands></div></div></div></div></div></div></div></div>");
$templateCache.put("app/settings/system-roles/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'System Roles\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'System Roles\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"dtSystemRoles\" datatable-basic=\"\" table-dropdown-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Name\')\"></th><th ng-bind=\"getWord(\'Action\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/settings/system-settings/partials/system-settings-form.tpl.html","<form id=\"systems-settings-form\" class=\"form-horizontal\" role=\"form\" autocomplete=\"off\"><div class=\"form-group\"><label for=\"cboCulture\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Culture\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><label ng-show=\"id\" for=\"txtName\" class=\"form-control\">{{systemSettings.culture}}</label><select ng-show=\"!id\" id=\"cboCulture\" name=\"cboCulture\" class=\"form-control\" ng-model=\"systemSettings.culture\"><option value=\"\" selected=\"\">{{getWord(\'SelectOption\')}}</option><option value=\"en-US\">United States - us</option><option value=\"fr-FR\">France Canadian - fr-ca</option><option value=\"en-CA\">English Canadian - en-ca</option></select></div></div><div class=\"form-group\"><label for=\"txtName\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Name\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input ng-show=\"!id\" id=\"txtName\" name=\"txtName\" type=\"text\" class=\"form-control\" ng-model=\"systemSettings.name\"> <label ng-show=\"id\" for=\"txtName\" class=\"form-control\">{{systemSettings.name}}</label></div></div><div class=\"form-group\"><label for=\"cboVariableType\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'VariableType\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><select id=\"cboVariableType\" name=\"cboVariableType\" class=\"form-control\" data-ng-model=\"systemSettings.variableType\" convert-to-number=\"\"><option value=\"\">{{getWord(\'SelectOption\')}}</option><option value=\"0\">{{getWord(\'NotDefined\')}}</option><option value=\"1\">{{getWord(\'String\')}}</option><option value=\"2\">{{getWord(\'Int\')}}</option><option value=\"3\">{{getWord(\'Decimal\')}}</option><option value=\"4\">{{getWord(\'Bool\')}}</option><option value=\"5\">{{getWord(\'Html\')}}</option><option value=\"6\">{{getWord(\'HttpHandler\')}}</option></select></div></div><div class=\"form-group\" ng-show=\"systemSettings.variableType == \'0\' || systemSettings.variableType == \'1\' || systemSettings.variableType == \'6\'\"><label for=\"txtVariableTypeString\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Value\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtVariableTypeString\" name=\"txtVariableTypeString\" type=\"text\" class=\"form-control\" ng-model=\"systemSettings.value\" value=\"String\"></div></div><div class=\"form-group\" ng-show=\"systemSettings.variableType == \'2\'\"><label for=\"txtVariableTypeInt\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Value\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtVariableTypeInt\" name=\"txtVariableTypeInt\" type=\"text\" class=\"form-control\" ng-model=\"systemSettings.value\"></div></div><div class=\"form-group\" ng-show=\"systemSettings.variableType == \'3\'\"><label for=\"txtVariableTypeDecimal\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Value\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><input id=\"txtVariableTypeDecimal\" name=\"txtVariableTypeDecimal\" type=\"text\" class=\"form-control\" ng-model=\"systemSettings.value\"></div></div><div class=\"form-group\" ng-show=\"systemSettings.variableType == \'4\'\"><label class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Value\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><label class=\"radio radio-inline\"><input id=\"valueSimpleText\" name=\"valueType\" type=\"radio\" class=\"radiobox\" ng-model=\"systemSettings.value\" value=\"true\"> <span>{{getWord(\'True\')}}</span></label> <label class=\"radio radio-inline\"><input id=\"valueTypeHTML\" name=\"valueType\" type=\"radio\" class=\"radiobox\" ng-model=\"systemSettings.value\" value=\"false\"> <span>{{getWord(\'False\')}}</span></label></div></div><div id=\"form-group-html\" class=\"form-group\" ng-show=\"systemSettings.variableType == \'5\'\"><label class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Value\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><textarea name=\"ckeditor\" data-smart-ck-editor=\"\" ng-model=\"htmlValue\"></textarea></div></div><div class=\"form-group\"><label for=\"txtNotes\" class=\"col-sm-3 col-md-3 col-lg-3 control-label\">{{getWord(\'Notes\')}}</label><div class=\"col-sm-8 col-md-8 col-lg-8\"><textarea id=\"txtNotes\" name=\"txtNotes\" type=\"text\" class=\"form-control\" data-ng-model=\"systemSettings.notes\"></textarea></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-8\"><label class=\"checkbox-wrap\" for=\"chkCoreSetting\"><input id=\"chkCoreSetting\" name=\"chkCoreSetting\" type=\"checkbox\" ng-model=\"systemSettings.coreSetting\">{{getWord(\'CoreSetting\')}} <span class=\"checkbox-mark\"></span></label></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-8\"><label class=\"checkbox-wrap\" for=\"chkManageAsBaseSetting\"><input id=\"chkManageAsBaseSetting\" name=\"chkManageAsBaseSetting\" type=\"checkbox\" ng-model=\"systemSettings.manageAsBaseSetting\">{{getWord(\'ManageasBaseSetting\')}} <span class=\"checkbox-mark\"></span></label></div></div><form-actions showcheck=\"true\" create-text=\"Create\" create-another-text=\"createAnotherText\"></form-actions></form>");
$templateCache.put("app/settings/system-settings/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[ {\'header\' : true,\'label\' : settingBreadcrumb}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'SystemSettings\'}, {\'active\':true,\'label\':settingBreadcrumb} ]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{getWord(\'SystemSettings\')}}</h5></div><div class=\"ibox-content\"><system-settings-form></system-settings-form></div></div></div></div></div>");
$templateCache.put("app/settings/system-settings/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'SystemSettings\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'SystemSettings\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><table id=\"dtSystemSettings\" datatable-basic=\"\" mis-row-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" table-dropdown-actions=\"\" width=\"100%\"><thead><tr><th ng-bind=\"getWord(\'Name\')\"></th><th ng-bind=\"getWord(\'Actions\')\" class=\"col-action\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/settings/system-users/partials/system-user-assign-roles-form.tpl.html","<form id=\"system-user-assign-roles-form\" class=\"form-horizontal p-sm\" autocomplete=\"off\"><legend>{{getWord(\'AssignRolesFor\') + \" \" + systemUser.login}}</legend><fieldset><select id=\"cboSystemUserRolesList\" name=\"cboSystemUserRolesList\" multiple=\"multiple\" size=\"10\" dual-list-box=\"\" non-selected-list-label=\"Roles\" selected-list-label=\"Assigned Roles\" ng-options=\"availableRole.id as availableRole.name for availableRole in availableRoles\" ng-model=\"systemUserObj.assignedSystemRoleIds\"></select></fieldset><assign-actions></assign-actions></form>");
$templateCache.put("app/settings/system-users/partials/system-user-password-change-form.tpl.html","<form id=\"system-user-password-change-form\" name=\"system-user-password-change-form\" autocomplete=\"off\"><fieldset><legend>{{getWord(\'ChangePasswordFor\') + \" \" + systemUser.login}}</legend><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label for=\"txtNewPassword\" class=\"control-label\">{{getWord(\'NewPassword\')}}</label> <input id=\"txtNewPassword\" name=\"txtNewPassword\" type=\"password\" class=\"form-control\" placeholder=\"\" ng-model=\"userPassword.password\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label for=\"txtNewPasswordConfirm\" class=\"control-label\">{{getWord(\'NewPasswordConfirm\')}}</label> <input id=\"txtNewPasswordConfirm\" name=\"txtNewPasswordConfirm\" type=\"password\" class=\"form-control\" placeholder=\"\"></div></div></div></fieldset><form-actions></form-actions></form>");
$templateCache.put("app/settings/system-users/partials/system-users-form.tpl.html","<form id=\"system-users-form\" name=\"system-users-form\" autocomplete=\"off\"><fieldset><legend>{{getWord(\'UserInformation\')}}</legend><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label for=\"txtLogin\" class=\"control-label\">{{getWord(\'Login\')}}</label> <input id=\"txtLogin\" name=\"txtLogin\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"systemUser.login\" autocomplete=\"off\"></div></div></div></fieldset><fieldset><div class=\"form-group\" ng-hide=\"id\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label for=\"txtPassword\" class=\"control-label\">{{getWord(\'Password\')}}</label> <input id=\"txtPassword\" name=\"txtPassword\" type=\"password\" class=\"form-control\" ng-model=\"systemUser.password\" autocomplete=\"off\"></div></div></div></fieldset><fieldset><div class=\"form-group\" ng-hide=\"id\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label for=\"txtConfirmPassword\" class=\"control-label\">{{getWord(\'ConfirmPassword\')}}</label> <input id=\"txtConfirmPassword\" name=\"txtConfirmPassword\" type=\"password\" class=\"form-control\" placeholder=\"\" autocomplete=\"off\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label for=\"txtFirstName\" class=\"control-label\">{{getWord(\'FirstName\')}}&nbsp{{getWord(\'(Optional)\')}}</label> <input id=\"txtFirstName\" name=\"txtFirstName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"systemUser.firstName\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label for=\"txtLastName\" class=\"control-label\">{{getWord(\'LastName\')}}&nbsp{{getWord(\'(Optional)\')}}</label> <input id=\"txtLastName\" name=\"txtLastName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"systemUser.lastName\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label for=\"txtTitle\" class=\"control-label\">{{getWord(\'Title\')}}&nbsp{{getWord(\'(Optional)\')}}</label> <input id=\"txtTitle\" name=\"txtTitle\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"systemUser.title\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label for=\"txtEmailAddress\" class=\"control-label\" ng-bind=\"getWord(\'EmailAddress\')\"></label> <input id=\"txtEmailAddress\" name=\"txtEmailAddress\" type=\"text\" class=\"form-control\" ng-model=\"systemUser.email\"></div></div></div></fieldset><form-actions create-text=\"createText\" create-another-text=\"createAnotherText\" showcheck=\"true\"></form-actions></form>");
$templateCache.put("app/settings/system-users/views/change-password.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'Change Password\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Users\'}, {\'active\':true,\'label\':\'Change Password\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{getWord(\'ChangePassword\')}}</h5></div><div class=\"ibox-content\"><system-user-password-change-form></system-user-password-change-form></div></div></div></div></div>");
$templateCache.put("app/settings/system-users/views/edit.html","<div class=\"wrapper wrapper-content fadeIn p-t-sm\"><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs ng-show=\"!id\" items=\"[ {\'header\' : true,\'label\' : \'Add System User\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System User\'}, {\'active\':true,\'label\': \'Add System User\'} ]\"></big-breadcrumbs><big-breadcrumbs ng-hide=\"breadCrumbs || checkBreadCrumbs\" items=\"[ {\'header\' : true,\'label\' : \'Edit System User\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Users\'}, {\'active\':true,\'label\': \'Edit System User\'} ]\"></big-breadcrumbs><big-breadcrumbs ng-show=\"breadCrumbs\" items=\"[ {\'header\' : true,\'label\' : \'Roles\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'label\' :\'System Users\'}, {\'active\':true,\'label\': \'Roles\'} ]\"></big-breadcrumbs><div class=\"tabs-container\"><ul class=\"nav nav-tabs pull-right\" ng-show=\"id\"><li class=\"nav-item\" ng-click=\"changeTab(1)\" ng-class=\"{\'active\' : activeDetailsTab}\" id=\"detailsTab\"><a href=\"\" data-toggle=\"tab\" ng-click=\"breadCrumbs=false\">{{getWord(\'UserDetails\')}}</a></li><li ng-click=\"changeTab(2)\" id=\"commandTab\" ng-class=\"{\'active\' : activeRolesTab}\"><a href=\"\" style=\"margin-right: auto;border-right: none;\" data-toggle=\"tab\" ng-click=\"breadCrumbs=true\">{{getWord(\'Roles\')}}</a></li></ul><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" style=\"border-width: inherit\"><h5>{{getWord(\'SystemUsers\')}}</h5></div><div class=\"ibox-content\"><div class=\"tab-content\"><div class=\"tab-pane\" id=\"detailsBody\" ng-class=\"{\'active\' : activeDetailsTab}\"><system-users-form></system-users-form></div><div class=\"tab-pane\" id=\"commandBody\" ng-class=\"{\'active\' : activeRolesTab}\"><system-user-assign-roles-form></system-user-assign-roles-form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/settings/system-users/views/index.html","<div id=\"content\"><div class=\"wrapper wrapper-content p-t-sm\"><delete-confirmation-modal id=\"deleteModal\"></delete-confirmation-modal><div class=\"row\"><div class=\"col-lg-12\"><big-breadcrumbs items=\"[{\'header\' : true,\'label\' : \'System Users\'}, {\'label\' : \'Home\',\'href\' : \'app.main\' }, {\'label\' :\'Setup\'}, {\'active\':true,\'label\':\'System Users\'}]\"></big-breadcrumbs><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"overflow-x: auto;\"><table id=\"dtSystemUsers\" datatable-basic=\"\" mis-row-actions=\"\" table-dropdown-actions=\"\" data-table-options=\"options\" class=\"table table-hover\" width=\"100%\"><thead><tr role=\"row\"><th ng-bind=\"getWord(\'Login\')\"></th><th ng-bind=\"getWord(\'FirstName\')\"></th><th ng-bind=\"getWord(\'LastName\')\"></th><th ng-bind=\"getWord(\'Title\')\"></th><th class=\"col-checkbox\" ng-bind=\"getWord(\'UserIs\')\"></th><th class=\"col-action\" ng-bind=\"getWord(\'Action\')\"></th></tr></thead><tbody></tbody></table></div></div></div></div></div></div>");}]);